'use strict';

//polyfill array.includes
if(!Array.prototype.includes){Object.defineProperty(Array.prototype,"includes",{value:function(searchElement,fromIndex){if(this==null){throw new TypeError('"this" is null or not defined')}var o=Object(this);var len=o.length>>>0;if(len===0){return false}var n=fromIndex|0;var k=Math.max(n>=0?n:len-Math.abs(n),0);function sameValueZero(x,y){return x===y||typeof x==="number"&&typeof y==="number"&&isNaN(x)&&isNaN(y)}while(k<len){if(sameValueZero(o[k],searchElement)){return true}k++}return false}})}

angular.module('frontendAppCache', []).run(); // Needs to be defined for dev!!!
var modules =
    [
        'ui.router',
        'ui.router.state.events',
        'permission',
        'permission.ui',
        'ngCookies',
        'satellizer',
        'pascalprecht.translate',
        'ui.select',
        'LocalStorageModule',
        'ngSanitize',
        'ngDialog',
        'ui.select',
        'ui.grid',
        'ui.grid.pagination',
        'ui.grid.selection',
        'ui.grid.grouping',
        'ui.grid.expandable',
        'ui.grid.autoResize',
        'ui.grid.edit',
        'ui.grid.exporter',
        'ui.grid.moveColumns',
        'angularjs-dropdown-multiselect',
        'ncy-angular-breadcrumb',
        'angularMoment',
        'ui.tinymce'
    ];

angular.module('frontendApp', modules);

angular.module('frontendApp').value('frontend', {

    header: {
        inverse: false,
        gray: false,
        diag: false,
        diagpulled: false
    },
    footer: {
        inverse: false,
        gray: false,
        diag: false,
        diagpulled: false
    }
});

angular.module('frontendApp').run(['$rootScope', 'frontend', function ($rootScope) {
    $rootScope.isInMaintenance = false; //activates maintenance modus (causes redirect if cookie not set to maintenance page)
    $rootScope.authenticated = false;
    $rootScope.xsrfTokenValid = false;
    $rootScope.currentUser = null;
    if ($rootScope.itemsPerPage == null)
        $rootScope.itemsPerPage = 25;
}]);

//Override for Select Search Template
angular.module("ui.select").run(["$templateCache", function ($templateCache) {
   $templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-controll ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
    $templateCache.put("bootstrap/match.tpl.html", "<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focuss\':$select.focus}\">\n\
                                                     <span tabindex=\"-1\" class=\"form-controll ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\">\n\
                                                        <span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span>\n\
                                                        <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span>\n\
                                                        <i class=\"carett pull-right\" ng-click=\"$select.toggle($event)\"></i> \n\
                                                        <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\">\n\
                                                          <i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i>\n\
                                                        </a>\n\
                                                    </span>\n\
                                                   </div>");
}]);

angular.module('frontendApp').config(function (localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('SSC');
    localStorageServiceProvider.setStorageType('localStorage');
});
angular.module("frontendApp")
.constant("api", {"root":"https://sp.stromspar-check.de/api/public/api/","cdn":"https://sp.stromspar-check.de/api/public/"})
.constant("APP_FLAGS", ["DEV"]);
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:useremployment
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('useremployment', function ($filter, usercreateService, $stateParams, userService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "userEmploymentController",
        link: function (scope, element, attrs) {
            
            usercreateService.readUser($stateParams.id).then(function (data) {
                scope.title = $filter('translate')('USER_EMPLOYMENTTYP_TITEL', {name: data.name});

                var roleInfo = userService.extractRoleInfo(data, $stateParams.roleMapId);
                if(roleInfo) {
                    scope.subheading = roleInfo.roleShort + " ";
                    if(roleInfo.location) {
                        scope.subheading += "Standort: " + roleInfo.location;
                    }
                    if(roleInfo.organisation) {
                        scope.subheading += "Organisation: " + roleInfo.organisation;
                    }
                    if(roleInfo.state) {
                        scope.subheading += "Bundesländer: ";
                        scope.subheading += roleInfo.state.join(", ");
                    }
                }
            }, function (error) {
                console.log(error);
            });

        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:userSubstituteController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('userEmploymentController', function ($scope, $stateParams, uiGridConstants, gridService, $rootScope, moment) {

    $scope.data = [];
    $scope.api = {
        route: "employmentmap/read",
        data: {
            user_role_map_id: $stateParams.roleMapId,
            items: $rootScope.itemsPerPage
        }
    };

    // UI GRID: updates data
    $scope.getTableData = function () {
        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {

            for(var i in data) { //format dates
                data[i].date_begin = moment(data[i].date_begin).format("D.M.YYYY");
                data[i].date_end = moment(data[i].date_end).format("D.M.YYYY");
            }

            $scope.data = data;
            $scope.gridOptions.totalItems = data.total;
        }, function (error) {
            console.log(error);
        });
    };


    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            width: 50,
            headerCellFilter: 'translate'
        },       
        {
            field: 'get_user_employment_type.name',
            displayName: 'Art',
            headerCellFilter: 'translate'
        },
        {
            field: 'date_begin',
            displayName: 'Von',
            headerCellFilter: 'translate'
        },
        {
            field: 'date_end',
            displayName: 'Bis',
            headerCellFilter: 'translate'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'USER_FUNCTION',
            enableSorting: false,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update.employmenttyp.update({userEmplyomentId: row.entity.id})" permission permission-only="[\'LOKO\', \'ADMIN\']" ><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
        
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        enableSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableExpandAll: false,
        expandableRowTemplate    : '<div ui-grid="row.entity.subGridOptions" ui-grid-auto-resize ui-grid-selection></div>',
        rowHeight: 35,
        
        // Selection
        enableRowHeaderSelection: true,  
        selectionRowHeaderWidth: 0,
        enableFullRowSelection: false,
        enableRowSelection: true,
        enableSelectAll: false,       
        multiSelect: true,
        
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSize: $rootScope.itemsPerPage,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                    $rootScope.$broadcast("gridLoaded");
                }
            });
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenuuseremplyomenttyp', function (tabmenuService, $stateParams, $filter, $compile, userService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            isNotFound: "="
        },
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {
            scope.isNotFound = false;
            if(!userService.loggedInHasRole(['LOKO', 'REKO', 'ADMIN'])) {
                scope.isNotFound = true;
                return;
            }
            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (scope.pageIndex == 0)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("employmentmap/count",$stateParams.roleMapId).then(function (data) {
                    scope.bSearch = bSearch;
                    scope.searchCounts = data["ALL"];
                    scope.tabCounts = data;
                    console.log(data);
                    scope.grids = [
                        {
                            name: "useremployment",//usersubstitute
                            title: $filter('translate')('TAB_EMPLOYMENTTYPE'),
                            permissionOnly: ['ADMIN','SSH','SSHPLUS','LOKO','EFB'],
                            data: scope.tabCounts
                        }
                    ];

                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.empty();
                    myEl.append(template);
                    $compile(template)(scope);
                }, function (error) {
                    scope.isNotFound = true;
                    console.log(error);
                });
            };

            scope.$on("substituteUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:usersubstitute
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('usersubstitute', function ($filter, usercreateService, $stateParams, userService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "userSubstituteController",
        link: function (scope, element, attrs) {
            
            usercreateService.readUser($stateParams.id).then(function (data) {
                scope.title = $filter('translate')('USER_SUBSTITUTES_TITEL', {name: data.name});

                var roleInfo = userService.extractRoleInfo(data, $stateParams.roleMapId);
                if(roleInfo) {
                    scope.subheading = roleInfo.roleShort + " ";
                    if(roleInfo.location) {
                        scope.subheading += "Standort: " + roleInfo.location;
                    }
                    if(roleInfo.organisation) {
                        scope.subheading += "Organisation: " + roleInfo.organisation;
                    }
                    if(roleInfo.state) {
                        scope.subheading += "Bundesländer: ";
                        scope.subheading += roleInfo.state.join(", ");
                    }
                }

            }, function (error) {
                console.log(error);
            });
            
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:userSubstituteController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('userSubstituteController', function ($scope, $stateParams, uiGridConstants, gridService, $rootScope, moment, ngDialog, $filter) {

    $scope.data = [];
    $scope.api = {
        route: "user/substitute/read",
        data: {
            role_map_id: $stateParams.roleMapId,
            items: $rootScope.itemsPerPage
        }
    };

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            for(var i in data.data) { //format dates
                data.data[i].date_begin = moment(data.data[i].date_begin).format("D.M.YYYY");
                data.data[i].date_end = moment(data.data[i].date_end).format("D.M.YYYY");
            }
            $scope.data = data.data;

            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };


    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            width: 50,
            headerCellFilter: 'translate'
        },
        {
            field: 'user.lastname',
            displayName: 'USER_SUBSTITUTE',
            headerCellFilter: 'translate',
            width:350,
            cellTemplate: '<a href="" ui-sref="location.regionDetail({id: row.entity.user_role_area_map.region[0].id})" data-ng-bind="row.entity.user.name"></a>'
        },
        {
            field: 'date_begin',
            displayName: 'USER_SUBSTITUTE_FROM',
            headerCellFilter: 'translate'
        },
        {
            field: 'date_end',
            displayName: 'USER_SUBSTITUTE_TILL',
            headerCellFilter: 'translate'
        },
        {
            field: 'status',
            displayName: 'USER_SUBSTITUTE_STATUS',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><span data-ng-if="row.entity.status == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span><span data-ng-if="row.entity.status == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div>',
            width: 120
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'USER_FUNCTION',
            enableSorting: false,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update.substitute.update({substituteId: row.entity.id})" title="Bearbeiten"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
                        + '<a href="" ng-click="grid.appScope.deleteDialog(row.entity.id)" title="Löschen"><i class="fa fa-trash" aria-hidden="true"></i></a>'
        }
        
    ];

    function deleteSubstitute(id){
        gridService.readData("user/substitute/delete", {
            id: id
        }).then(function (data) {
            if(data && data === "success"){
                $scope.getTableData();
            }
        }, function (error) {
            var errorDescription = "Fehler";
            ngDialog.open({
                template: 'templates/landingpage/ok_dialog.html' + "?v=" + window.version.tag,
                data: {
                    diagTitle: $filter('translate')('LANDINGPAGE_DELETE_ROLE_ERROR_TITLE'),
                    diagDescription: errorDescription
                }
            });
        });
    }

    $scope.deleteDialog = function (id) {

        ngDialog.openConfirm({
            template: 'templates/landingpage/confirm_dialog.html' + "?v=" + window.version.tag,
            data: {
                diagTitle: $filter('translate')('BTN_DELETE'),
                diagDescription: $filter('translate')('LANDINGPAGE_DELETE_DESCRIPTION'),
                diagCancel: $filter('translate')('BTN_CANCEL'),
                diagConfirm: $filter('translate')('BTN_DELETE')
            }
        }).then(function(data) {
            //confirm
            deleteSubstitute(id);
        }, function(data) {
            //cancelled
        });
    };

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        enableSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableExpandAll: false,
        expandableRowTemplate    : '<div ui-grid="row.entity.subGridOptions" ui-grid-auto-resize ui-grid-selection></div>',
        rowHeight: 35,
        
        // Selection
        enableRowHeaderSelection: true,  
        selectionRowHeaderWidth: 0,
        enableFullRowSelection: false,
        enableRowSelection: true,
        enableSelectAll: false,       
        multiSelect: true,
        
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSize: $rootScope.itemsPerPage,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.user_role_map;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.status, \'ssc-grid-row-highlight\': row.entity.is_active}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenuusersubstitute', function (tabmenuService, $stateParams, $filter, $compile) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            isNotFound: "="
        },
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (scope.pageIndex == 0)
                    scope.pageIndex++;
            };
            
            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("user/substitute/count", $stateParams.roleMapId).then(function (data) {
                    scope.bSearch = bSearch;
                    scope.searchCounts = data["ALL"];
                    scope.tabCounts = data;
                    scope.grids = [
                        {
                            name: "usersubstitute",
                            title: $filter('translate')('USER_SUBSTITUTES'),
                            permissionOnly: ['LOKO', 'EFB', 'REKO', 'BUKO', 'ADMIN'],
                            data: scope.tabCounts
                        }
                    ];

                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.empty();
                    myEl.append(template);
                    $compile(template)(scope);

                },function (error) {
                    scope.isNotFound = true;
                    console.log(error);
                });
            };

            scope.$on("substituteUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenuuserrolelocation', function (tabmenuService, $stateParams, $filter, $compile) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            tabmenuService.getTabCounts("user/countuserrole", $stateParams.id).then(function (data) {
                scope.tabCounts = data.count;
                scope.grids = [
                    {
                        name: "userrolelocation",
                        title: $filter('translate')('TAB_USER_ROLE_LOCATION'),
                        permissionOnly: ['SSH', 'SSHPLUS', 'TRAINER', 'LOKO', 'EFB', 'REKO', 'BUKO', 'ADMIN'],
                        data: scope.tabCounts
                    }];

                var html = tabmenuService.setTabs(scope.grids);
                var template = angular.element(html);
                var myEl = angular.element(document.querySelector('.tab-content'));
                myEl.append(template);
                $compile(template)(scope);
            },
                    function (error) {
                        console.log(error);
                    });
        }
    };
}); 
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('userrolelocation', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "userRoleLocationController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_USER_ROLE_LOCATION');
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:userRoleLocationController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('userRoleLocationController', function ($scope, $stateParams, uiGridConstants, ngDialog, gridService, $rootScope, $filter) {

    $scope.data = [];
    $scope.api = {
        route: "user/read",
        data: {
            id: $stateParams.id,
            items: $rootScope.itemsPerPage
        }
    };

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.user_role_map;
            $scope.gridOptions.totalItems = data.user_role_map.length;
        },
                function (error) {
                    console.log(error);
                });
    };


    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            width: 40,
            headerCellFilter: 'translate'
        },
        {
            field: 'user_role_area_map[0]',
            displayName: 'USER_AREA',
            headerCellFilter: 'translate',
            cellTemplate: '<span ng-if="row.entity.user_role_area_map.state.length == 16">Bundesweit</span>'
                + '<span ng-if="row.entity.user_role_area_map.state.length != 16" data-ng-bind="row.entity.user_role_area_map.state[0].name"></span>'
                + '<a href="" ui-sref="location.regionDetail({id: row.entity.user_role_area_map.region[0].id})" data-ng-bind="row.entity.user_role_area_map.region[0].name"></a>'
                + '<a href="" ui-sref="location.detail({id: row.entity.user_role_area_map.location[0].id})" data-ng-bind="row.entity.user_role_area_map.location[0].name"></a>'
                + '<span ng-repeat="region in row.entity.user_role_area_map.regionoverorganisation">{{region.name}}<span ng-if="!$last">, </span></span>'
        },
        {
            field: 'street',
            displayName: 'USER_STREET',
            headerCellFilter: 'translate'
        },
        {
            field: 'postalcode',
            displayName: 'USER_PLZ',
            headerCellFilter: 'translate'
        },
        {
            field: 'city',
            displayName: 'USER_PLACE',
            headerCellFilter: 'translate'
        },
        {
            field: 'role.role',
            displayName: 'USER_ROLE',
            headerCellFilter: 'translate'
        },
        {
            field: 'user_substitute[0].user.lastname',
            displayName: 'USER_SUBSTITUTE',
            headerCellFilter: 'translate',
            cellTemplate:
                '<span ng-if="row.entity.user_substitute.length > 0 && row.entity.isSubstitute">vertritt <a data-ng-bind="row.entity.user.lastname" ui-sref="user.update({id: row.entity.user_id})" ></a></span>'
                + '<span ng-if="row.entity.user_substitute.length > 0 && !row.entity.isSubstitute">vertreten durch <a data-ng-bind="row.entity.user_substitute[0].user.lastname" ui-sref="user.update({id: row.entity.user_substitute[0].user_id})"></a></span>'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'USER_FUNCTION',
            enableSorting: false,
            headerCellFilter: 'translate',
            width: 80,
            cellTemplate: '<a href="" ng-show="row.entity.CAN_WRITE" ui-sref="user.update.rolelocationUpdate({roleId: row.entity.user_role_id, roleMapId: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true" title="{{\'USER_EDIT_ROLE\' | translate}}"></i></a> '
                        + '<a href="" ng-show="row.entity.CAN_WRITE" ng-click="grid.appScope.deleteRoleDialog(row.entity.id)" title="{{\'USER_ROLE_DELETE\' | translate}}"><i class="fa fa-trash" aria-hidden="true"></i></a> '
                        + '<a href="" ng-show="row.entity.CAN_WRITE" ng-if="![\'admin\', \'buko\', \'efb\'].includes(row.entity.role.slug.toLowerCase())" ui-sref="user.update.substitute({roleMapId: row.entity.id})" title="{{\'USER_CREATE_SUBSTITUTE_TITEL\' | translate}}"><i class="fa fa-user-plus" aria-hidden="true"></i></a> '
                        + '<a href="" permission permission-except="[\'ADMIN\']" ng-if="row.entity.role.slug==\'SSH\' && row.entity.CAN_WRITE" ui-sref="user.update.employmenttyp({roleMapId: row.entity.id})" title="{{\'USER_EDIT_EMPLOYMENT_TYPE\' | translate}}"><i class="fa fa-briefcase" aria-hidden="true"></i></a>'
        }
    ];

    $scope.deleteRole = function(id){
        gridService.readData("user/deleteuserrole", {
            id: id
        }).then(function (data) {
            if(data && data === "success"){
                $scope.getTableData();
            }
        }, function (error) {
            var errorDescription = "Fehler";
            if(error.error === 'client_error.user_roles_delete_ssh') {
                errorDescription = $filter('translate')('USER_ROLES_DELETE_SSH');
            } else if (error.error === 'client_error.user_roles_delete_last') {
                errorDescription = $filter('translate')('USER_ROLES_DELETE_LAST');
            }
            ngDialog.open({
                template: 'templates/landingpage/ok_dialog.html' + "?v=" + window.version.tag,
                data: {
                    diagTitle: $filter('translate')('LANDINGPAGE_DELETE_ROLE_ERROR_TITLE'),
                    diagDescription: errorDescription
                }
            });
        });
    };
    
    $scope.deleteRoleDialog = function (id) {

        ngDialog.openConfirm({
            template: 'templates/landingpage/confirm_dialog.html' + "?v=" + window.version.tag,
            data: {
                diagTitle: $filter('translate')('BTN_DELETE'),
                diagDescription: $filter('translate')('LANDINGPAGE_USER_ROLE_DELETE_TEXT'),
                diagCancel: $filter('translate')('BTN_CANCEL'),
                diagConfirm: $filter('translate')('BTN_DELETE')
            }
        }).then(function(data) {
            //confirm
            $scope.deleteRole(id);
        }, function(data) {
            //cancelled
        });
    };
    
    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        enableSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableExpandAll: false,
        expandableRowTemplate    : '<div ui-grid="row.entity.subGridOptions" ui-grid-auto-resize ui-grid-selection></div>',
        rowHeight: 35,
        
        // Selection
        enableRowHeaderSelection: true,  
        selectionRowHeaderWidth: 0,
        enableFullRowSelection: false,
        enableRowSelection: true,
        enableSelectAll: false,       
        multiSelect: true,
        
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: false,        
        paginationCurrentPage: 1,
        paginationPageSize: 25,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: 'data.user_role_map.length',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.user_role_map;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:employmenttypeCreateService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('employmentCreateService', function (apiService) {

    var service = {};

    service.readEmployment = function (id) {
        return apiService.post("employmentmap/read", {id: id});
    };

    service.createEmployment = function (data) {
        return apiService.post("employmentmap/create", data);
    };

    service.updateEmployment = function (data) {
        return apiService.post("employmentmap/update", data);
    };

    /*service.deleteEmployment = function (data) {
        return apiService.post("employment/delete", data);
    };*/

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:userSubstituteCreate
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('userEmplyomenttypCreate', function () {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/user/userCreate/employmenttypCreate/userEmplyomenttypCreate/userEmplyomenttypCreate.view.html' + "?v=" + window.version.tag,
        controller: 'userEmplyomenttypCreateController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:userEmplyomenttypCreateController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('userEmplyomenttypCreateController', function ($scope, $stateParams, ngDialog, employmenttypeCreateService, employmentCreateService, formService, $window, $filter, $state, searchService, usercreateService, userService) {
    $scope.isNotFound = false;
    if(!userService.loggedInHasRole(['LOKO', 'ADMIN'])) {
        $scope.isNotFound = true;
        return;
    }
    $scope.init = function() {
        if ($state.current.name.indexOf('user.update.employmenttyp.create') !== -1) {
            $scope.edit = false;
        } else {
            $scope.edit = true;
        }
        
        employmenttypeCreateService.readEmploymenttype().then(function (data) {
            $scope.employmentTypeList=data;
            
            if($scope.edit){
                employmentCreateService.readEmployment($stateParams.userEmplyomentId).then(function (data) {
                    $scope.model = data;
                }, function (error) {
                    $scope.isNotFound = true;
                    console.log(error);
                });
            }else{
                 $scope.model={};
            }
           
        }, function (error) {
            console.log(error);
        });

        usercreateService.readUser($stateParams.id).then(function (data) {
            if($scope.edit) {
                $scope.actionTitle = $filter('translate')('EMPLOYMENTTYPE_UPDATE', {name: data.name});
            } else {
                $scope.actionTitle = $filter('translate')('EMPLOYMENTTYPE_CREATE', {name: data.name});
            }

            var roleInfo = userService.extractRoleInfo(data, $stateParams.roleMapId);
            if(roleInfo) {
                $scope.subheading = roleInfo.roleShort + " ";
                if(roleInfo.location) {
                    $scope.subheading += "Standort: " + roleInfo.location;
                }
                if(roleInfo.organisation) {
                    $scope.subheading += "Organisation: " + roleInfo.organisation;
                }
                if(roleInfo.state) {
                    $scope.subheading += "Bundesländer: ";
                    $scope.subheading += roleInfo.state.join(", ");
                }
            }
        }, function (error) {
            $scope.isNotFound = true;
            console.log(error);
        });

        $scope.required = {
            user_employment_type_id: true,
            date_begin: true,
            date_end: true
        };
    };
    
    $scope.check = function () {
        if(!formService.check($scope.required, $scope.model)) {
            return false;
        }
        return true;
    };

    $scope.save = function() {
        $scope.errorAlert = undefined;
        $scope.saved = true;
        if($scope.isSaving) {
            return;
        }
        
        if(!$scope.check()){
            $scope.requiredModal();
            return;
        }
        $scope.isSaving = true;

        if($scope.edit) {
            employmentCreateService.updateEmployment($scope.model).then(function () {
                $scope.isSaving = false;
                $window.history.back();
            }, function (error) {
                $scope.errorModal();
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        } else {
            $scope.model.user_role_map_id=$stateParams.roleMapId;
            employmentCreateService.createEmployment($scope.model).then(function () {
                $scope.isSaving = false;
                $window.history.back();
            }, function (error) {
                $scope.errorModal();
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        }
    };

    $scope.errorModal = function () {
        ngDialog.open({
            template: 'templates/landingpage/employmentdate_in_use.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false
        });
    };
    $scope.requiredModal = function () {
        ngDialog.open({
            template: 'templates/landingpage/ready_failed.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false
        });
    };
                
    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenulocationSsh', function (tabmenuService, PermPermissionStrategies, $stateParams, $filter, $compile, $rootScope) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {
            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("location/count").then(function (data) {
                    scope.bSearch = bSearch;
                    scope.searchCounts = data["ALL"];
                    if(bSearch) {
                        scope.tabCounts = 0;
                        angular.forEach(data, function (value) {
                            scope.tabCounts += value;
                        });
                    }
                    scope.grids = [
                        {
                            name: "locationsshoverview",
                            title: $filter('translate')('TAB_LOCATION_SSH'),
                            permissionOnly: ['ADMIN'],
                            data: data.location
                        }
                    ];
                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.empty();
                    myEl.append(template);
                    $compile(template)(scope);
                },
                        function (error) {
                            console.log(error);
                        });
            };

            scope.$on("locationUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
}); 

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:locationOverviewlocation
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('locationsshoverview', function ($filter, $stateParams, locationService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "locationSshController",
        link: function (scope, element, attrs) {

            locationService.getLocationByID($stateParams.id).then(function (data) {
                scope.title = $filter('translate')('TAB_LOCATION_SSH_TITLE', {name: data.name});
            }, function (error) {
                console.log(error);
            });
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:locationSshController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('locationSshController', function ($scope, $stateParams, uiGridConstants, $rootScope, ngDialog, locationService, gridService, $translate) {

    $scope.data = [];
    $scope.api = {
        route: "location/readssh",
        data: {
            id: $stateParams.id,
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };

    // UI GRID: updates data
    $scope.getTableData = function () {
        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:0});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
    $scope.gridName='location';

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            enableFiltering: false,
            width: 80,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'firstname',
            displayName: 'Vorname',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'lastname',
            displayName: 'Name',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'username',
            displayName: 'Benutzername',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'email',
            displayName: 'E-Mail',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            headerCellFilter: 'translate',
            enableSorting: false,
            visible: gridService.checkVisible('function',$scope.gridName),
            cellTemplate: '<a href="" ui-sref="user.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.deactivateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/deactivate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function() {
                $scope.getTableData();
            }
        });
    };

    $scope.activateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/activate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function() {
                $scope.getTableData();
            }
        });
    };

    $scope.activate = function (id) {

        locationService.activateLocation(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.deactivate = function (id) {

        locationService.deactivateLocation(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 34,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSize: $rootScope.itemsPerPage,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
                 
                if(sort[0] && sort[0].field){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].field;
                $scope.api.data.sort.order =sort[0].sort.direction;
                
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenuemploymenttype', function (tabmenuService, $stateParams, $filter, $compile, $rootScope) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (scope.pageIndex == 0)
                    scope.pageIndex++;
            };
            
            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("employmenttype/count").then(function (data) {
                    scope.bSearch = bSearch;
                    scope.searchCounts = data["ALL"];
                    scope.tabCounts = data.employmenttype;
                    scope.grids = [
                        {
                            name: "employmenttype",
                            title: $filter('translate')('TAB_EMPLOYMENTTYPE'),
                            permissionOnly: ['ADMIN', 'LOKO'],
                            data: scope.tabCounts
                        }
                    ];

                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.empty();
                    myEl.append(template);
                    $compile(template)(scope);
                },
                        function (error) {
                            console.log(error);
                        });
            };

            scope.$on("employmenttypeUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
}); 

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:employmenttype
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('employmenttype', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "employmenttypeController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_EMPLOYMENTTYPE');
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:bukoController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('employmenttypeController', function ($scope, ngDialog, employmenttypeService,uiGridConstants, gridService, $rootScope) {

    $scope.data = [];
    $scope.api = {
        route: "employmenttype/read",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    
    $scope.gridName = 'employmenttype';

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            //Update TabCount
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:0});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
      

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            width: 100, 
            enableFiltering: false
        },
        {
            field: 'name',
            displayName: 'Name',
            headerCellFilter: 'translate'
        },
        {
            field: 'status',
            displayName: 'Status',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><span data-ng-if="row.entity.status == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span><span data-ng-if="row.entity.status == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div>',
            headerCellFilter: 'translate'

        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            visible: gridService.checkVisible('function',$scope.gridName),
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.employmenttype.update({id: row.entity.id})" permission permission-only=\'["REKO", "BUKO", "EFB", "ADMIN"]\'><i class="fa fa-pencil" aria-hidden="true"></i></a> <a title="{{\'BTN_ACTIVATE\' | translate}}" href="" ng-click="grid.appScope.activateDialog(row.entity.id, row.entity.description)" ng-if="(row.entity.status != 1)"><i class="fa fa-eye-slash" aria-hidden="true" permission permission-only=\'["REKO", "BUKO", "EFB", "ADMIN"]\'></i></a> <a title="{{\'BTN_DEACTIVATE\' | translate}}" href="" ng-if="(row.entity.status != 0)" ng-click="grid.appScope.deactivateDialog(row.entity.id, row.entity.description)" permission permission-only=\'["REKO", "BUKO", "EFB", "ADMIN"]\'><i class="fa fa-eye" aria-hidden="true"></i></a>'
        }
    ];

    $scope.deactivateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/deactivate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function() {
                $scope.getTableData();
            }
        });
    };

    $scope.activateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/activate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function() {
                $scope.getTableData();
            }
        });
    };

    $scope.activate = function (id) {

        employmenttypeService.activateDeploymenttype(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.deactivate = function (id) {

        employmenttypeService.deactivateDeploymenttype(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        enableSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSize: $rootScope.itemsPerPage,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                    $rootScope.$broadcast("gridLoaded");
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.user_role_map;
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenulog', function (tabmenuService, $stateParams, $filter, $compile, $rootScope) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("checks/ssc/log/count", $stateParams.id).then(function (data) {
                    scope.bSearch = bSearch;
                    scope.searchCounts = data["ALL"];
                    scope.tabCounts = data;
                    scope.grids = [
                        {
                            name: "log",
                            title: $filter('translate')('TAB_LOG'),
                            permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'TRAINER'],
                            data: scope.tabCounts

                        }
                    ];

                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.append(template);
                    $compile(template)(scope);
                },
                        function (error) {
                            console.log(error);
                        });
            };

            scope.$on("logUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
}); 

"use strict";
/**
* @ngdoc directive
* @name global.directive:log
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('log', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'logController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('TAB_LOG');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:appointmentSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('logController', function ($scope, gridService, $stateParams, $filter, $rootScope, moment) {

    $scope.data = [];
    $scope.api = {
        route: "checks/ssc/log/read",
        data: {
            id: $stateParams.id,
            items: $rootScope.itemsPerPage,
            sort: {
                column: "created_at",
                order: "desc"
            },
        }
    };

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            for(var i in data.data) {
                data.data[i].created_at = moment.utc(data.data[i].created_at).local().format("D.M.YYYY HH:mm:ss");
            }
            $scope.data = data.data;
            $scope.gridOptions.totalItems = data.total;
        },
        function (error) {
            console.log(error);
        });
    };

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            width: "80",
            enableFiltering: false,
            cellTooltip: true
        },
        {
            field: 'created_at',
            displayName: $filter('translate')('SSC_COL_CREATED'),
            headerCellFilter: 'translate',
            //cellFilter: 'date:"yyyy-MM-dd"',
            enableFiltering: true,
            cellTooltip: true
        },
        {
            field: 'user.name',
            displayName: $filter('translate')('USER_USER'),
            headerCellFilter: 'translate',
            enableFiltering: false,
            cellTooltip: true
        },
        {
            field: 'user.user_role[0].role',
            displayName: $filter('translate')('USER_ROLE'),
            headerCellFilter: 'translate',
            enableFiltering: true,
            cellTooltip: true
        },
        {
            field: 'field',
            displayName: $filter('translate')('SSC_COL_FIELD'),
            headerCellFilter: 'translate',
            enableFiltering: true,
            cellTooltip: true
        },
        {
            field: 'old_value',
            displayName: $filter('translate')('SSC_COL_VALUE_OLD'),
            headerCellFilter: 'translate',
            enableFiltering: true,
            cellTooltip: true
        },
        {
            field: 'new_value',
            displayName: $filter('translate')('SSC_COL_VALUE_NEW'),
            headerCellFilter: 'translate',
            enableFiltering: false,
            cellTooltip: true
        }
        
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        enableSorting: false,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSize: $rootScope.itemsPerPage,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    for(var i in data.data) {
                        data.data[i].created_at = moment.utc(data.data[i].created_at).local().format("D.M.YYYY HH:mm:ss");
                    }
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('freitagsauswertung', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/othersReview/freitagsauswertung/freitagsauswertung.view.html' + "?v=" + window.version.tag,
        controller: "freitagsauswertungController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('freitagsauswertungController', function ($scope, reviewService, $rootScope) {


    
        delete $rootScope.from;
        delete $rootScope.to;


    $scope.$on("createReview", function () {
        console.log($scope.from);
        console.log($scope.to);
        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to}
        ];

    });

});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('statuschecks', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/locationReview/statuschecks/statuschecks.view.html' + "?v=" + window.version.tag,
        controller: "statuschecksController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('statuschecksController', function ($scope, reviewService, $rootScope, apiService, sscTreeSelectService) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;

        apiService.post("user/readareas", {
            doIncludeInactive: true,
            filterRoleSlugs: ['BUKO', 'ADMIN']
        }).then(function (data) {
            $scope.areaTreeArr = sscTreeSelectService.userAreasToTree(data);

            var areaTitle = [];
            if (data.regions.length > 0) {
                areaTitle.push("Region");
            }
            if (data.states.length > 0) {
                areaTitle.push("Bundesland");
            }
            if (data.locations.length > 0) {
                areaTitle.push("Standort");
            }
            $scope.areaTitle = areaTitle.join(" / ");


        }, function (error) {
        });
    };

    $scope.init();

    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'location_id', value: $scope.location_id},
            {column: 'state_id', value: $scope.state_id},
            {column: 'region_id', value: $scope.region_id}
        ];

        var areaSelection = sscTreeSelectService.extractSelection($scope.areaTreeArr);

        if(areaSelection.region_id && areaSelection.region_id.length > 0) {
            $rootScope.filter.push({column: 'region_id', value: areaSelection.region_id});
        }
        if(areaSelection.state_id && areaSelection.state_id.length > 0) {
            $rootScope.filter.push({column: 'state_id', value: areaSelection.state_id});
        }
        if(areaSelection.location_id && areaSelection.location_id.length > 0) {
            $rootScope.filter.push({column: 'location_id', value: areaSelection.location_id});
        }
    });

});


"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('standortvergleich', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/locationReview/standortvergleich/standortvergleich.view.html' + "?v=" + window.version.tag,
        controller: "standortvergleichController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('standortvergleichController', function ($scope, reviewService, $rootScope, sscTreeSelectService, apiService) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        $scope.showertime_id = 1;
        $scope.from = "2008-01-01";
        $scope.bund = true;
        $scope.areaTreeArr = [];
        $scope.consultation_type = "visit";
        $scope.extra_filter = null;
        $scope.showertime = [
            {id: 1, name: 'Statistischer Wert Gfk (2005)'},
            {id: 2, name: 'Angaben des Haushalts'}
        ];
        $scope.consultation_types = [
            {id: "all", name: "alle Beratungsformate"},
            {id: "visit", name: "Hausbesuch"},
            {id: "online", name: "Online"}
        ];
        $scope.extra_filters = [
            {id: "heat_checks", name: "nur Wärmechecks"},
            {id: "monitoring_in_period", name: "Monitoring abgeschlossen und gewertet in Zeitraum"},
            {id: "quarter_checks", name: "nur Quartierchecks"},
            {id: "checks_with_kia", name: "nur KiA-Checks"},
            {id: "fridge_exchange_state", name: "nur KGT Landesprogramm"}
        ];
        $scope.showertime_id = 1;
        // $scope.dropdown = multiselectService.loadRegionStateLocationList();
        apiService.post("user/readareas", {doIncludeInactive: true})
        .then(function (data) {
            $scope.areaTreeArr = sscTreeSelectService.userAreasToTree(data);

            var areaTitle = [];
            if (data.regions.length > 0) {
                areaTitle.push("Region");
            }
            if (data.states.length > 0) {
                areaTitle.push("Bundesland");
            }
            if (data.locations.length > 0) {
                areaTitle.push("Standort");
            }
            $scope.areaTitle = areaTitle.join(" / ");


        }, function (error) {
        });
    };

    $scope.init();

    $scope.$on("createReview", function () {
        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'bund', value: $scope.bund},
            {column: 'showertime_id', value: $scope.showertime_id},
            {column: 'consultation_type', value: $scope.consultation_type},
            {column: 'extra_filter', value: $scope.extra_filter},
        ];
        var areaSelection = sscTreeSelectService.extractSelection($scope.areaTreeArr);
        if (areaSelection.region_id && areaSelection.region_id.length > 0) {
            $rootScope.filter.push({column: 'region_id', value: areaSelection.region_id});
        }
        if (areaSelection.state_id && areaSelection.state_id.length > 0) {
            $rootScope.filter.push({column: 'state_id', value: areaSelection.state_id});
        }
        if (areaSelection.location_id && areaSelection.location_id.length > 0) {
            $rootScope.filter.push({column: 'location_id', value: areaSelection.location_id});
        }
    });
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('standortberichtmonitoring', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/locationReview/standortberichtmonitoring/standortberichtmonitoring.view.html' + "?v=" + window.version.tag,
        controller: "standortberichtmonitoringController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('standortberichtmonitoringController', function ($scope, reviewService, multiselectService, $rootScope) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.showertime_id = null;
        $scope.showertime = [
            {id: 1, name: 'Statistischer Wert Gfk (2005)'},
            {id: 2, name: 'Angaben des Haushalts'}
        ];
        $scope.location_id = [];
        $scope.state_id = [];
        $scope.region_id = [];
        $scope.model = {region: [], state: [], location: []};
        $scope.dropdown = multiselectService.loadRegionStateLocationList();
    };

    $scope.OnClickSelect = function (column, item) {
        var data = multiselectService.OnClickSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.OnRemoveSelect = function (column, item) {
        var data = multiselectService.OnRemoveSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.selectAllLocation = function () {
        var data = multiselectService.selectAllLocation($scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.groupByRegion = function (item) {
        return multiselectService.groupByRegion(item);
    };

    $scope.readIds = function (data) {
        $scope.state_id = multiselectService.readIdsFromList(data.model.state);
        $scope.region_id = multiselectService.readIdsFromList(data.model.region);
        $scope.location_id = multiselectService.readIdsFromList(data.model.location);
    };

    $scope.init();

    


    $scope.$on("createReview", function () {


        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'showertime', value: $scope.showertime},
            {column: 'showertime_id', value: $scope.showertime_id},
            {column: 'location_id', value: $scope.location_id},
            {column: 'state_id', value: $scope.state_id},
            {column: 'region_id', value: $scope.region_id}
        ];

    });
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('quatieransatz', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/locationReview/quatieransatz/quatieransatz.view.html' + "?v=" + window.version.tag,
        controller: "quatieransatzController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('quatieransatzController', function ($scope,reviewService,multiselectService,$rootScope,localStorageService) {
//INIT
    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.showertime_id = null;
        $scope.add = 0;
        $scope.showertime = [
            {id: 1, name: 'Statistischer Wert Gfk (2005)'},
            {id: 2, name: 'Angaben des Haushalts'}
        ];
        $scope.quarter_id = [];
        $scope.plz_id = [];
        $scope.plzArea_id = [];
        $scope.plzArea = {
            name: null,
            zip: []};
        $scope.model = {region: [], state: [], location: []};
        $scope.dropdown = multiselectService.loadRegionStateLocationList();
        $scope.groupFilterPLZ = multiselectService.groupFilterPLZ;
        reviewService.loadPlzAreaList().then(function (data) {
            $scope.dropdownPLZArea = data;
            $scope.dropdownPLZ = data;
        }, function (error) {
            console.log(error);
        });

        $scope.checkShowPlz = false;
        var user = localStorageService.get('user');
        angular.forEach(user.user_role, function (role) {
            if(['TRAINER', 'LOKO', 'ADMIN'].includes(role.slug)) {
                $scope.checkShowPlz = true;
            }
        });
    };

//MULTISELECT
    $scope.OnClickSelect = function (column, item) {
        $rootScope.$broadcast('refreshReportBtn');
        var data = multiselectService.OnClickSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.data = data;
        $scope.quarter_id = data.quarter_id;
        reviewService.loadPlzList({quarter_id: data.quarter_id}).then(function (data) {
            $scope.dropdownPLZ = angular.copy($scope.dropdownPLZArea);
            angular.forEach(data, function (plz) {
                $scope.dropdownPLZ.push(plz);
            });
        }, function (error) {
            console.log(error);
        });
    };
    $scope.OnRemoveSelect = function (column, item) {
        var data = multiselectService.OnRemoveSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.data = data;
        $scope.quarter_id = data.quarter_id;
        $scope.dropdownPLZ = angular.copy($scope.dropdownPLZArea);
        if (data.quarter_id.length > 0) {
            reviewService.loadPlzList({quarter_id: data.quarter_id}).then(function (data) {
                angular.forEach(data, function (plz) {
                    $scope.dropdownPLZ.push(plz);
                });
            }, function (error) {
                console.log(error);
            });
        }
    };
    $scope.groupByRegion = function (item) {
        return multiselectService.quarterGroupByRegion(item);
    };
//PLZ
    $scope.groupByPlzNumberOne = function (item) {
        return multiselectService.groupByPlzNumberOne(item);
    };
    $scope.OnClickSelectPLZ = function (item) {
        $rootScope.$broadcast('refreshReportBtn');
        if (item.id) {
            angular.forEach(item.report_preset_zip, function (zip) {

                var doublezip = false;
                angular.forEach($scope.model.plz, function (plz) {
                    if (plz.name === zip.zip) {

                        doublezip = true;
                    }
                });
                if (!doublezip)
                    $scope.model.plz.push({name: zip.zip});

                var doubleplzid = false;
                angular.forEach($scope.plz_id, function (id) {
                    if (id === zip.zip) {
                        doubleplzid = true;
                    }
                });
                if (!doubleplzid)
                    $scope.plz_id.push(zip.zip);

            });
            angular.forEach($scope.model.plz, function (zip, index) {
                if (zip.id === item.id)
                {
                    $scope.model.plz.splice(index, 1);
                }
            });

        } else {
            $scope.plzArea.zip.push(item.name);
            $scope.plz_id.push(item.name);
        }
    };
    $scope.OnRemoveSelectPLZ = function (item) {
        angular.forEach($scope.plzArea.zip, function (zip, index) {
            if (zip === item.name)
            {
                $scope.plzArea.zip.splice(index, 1);
            }
        });

        angular.forEach($scope.plz_id, function (zip, index) {
            if (zip === item.name)
            {
                $scope.plz_id.splice(index, 1);
            }
        });
    };
    $scope.savePLZ = function () {
        reviewService.createPLZArea($scope.plzArea).then(function () {
            $scope.plzArea = {
                name: null,
                zip: []};
            reviewService.loadPlzAreaList().then(function (data) {
                $scope.dropdownPLZArea = data;
                $scope.dropdownPLZ = data;
                reviewService.loadPlzList($scope.data).then(function (data) {
                    $scope.dropdownPLZ = angular.copy($scope.dropdownPLZArea);
                    angular.forEach(data, function (plz) {
                        $scope.dropdownPLZ.push(plz);
                    });
                }, function (error) {
                    console.log(error);
                });
            }, function (error) {
                console.log(error);
            });
        }, function (error) {
            console.log(error);
        });
    };
//PLZAREA
    $scope.OnClickSelectPLZArea = function (item) {
        $rootScope.$broadcast('refreshReportBtn');
        $scope.plzArea_id.push(item.id);
    };
    $scope.OnRemoveSelectPLZArea = function (item) {
        angular.forEach($scope.plzArea_id, function (id, index) {
            if (id === item.id)
            {
                $scope.plzArea_id.splice(index, 1);
            }
        });
    };
    $scope.deletePLZArea = function () {
        reviewService.deletePLZArea($scope.plzArea_id).then(function () {
            $scope.plzArea_id.splice(0);
            $scope.model.plzarea.splice(0);
            reviewService.loadPlzAreaList().then(function (data) {
                $scope.dropdownPLZArea = data;
                $scope.dropdownPLZ = data;
                reviewService.loadPlzList($scope.data).then(function (data) {
                    $scope.dropdownPLZ = angular.copy($scope.dropdownPLZArea);
                    angular.forEach(data, function (plz) {
                        $scope.dropdownPLZ.push(plz);
                    });
                }, function (error) {
                    console.log(error);
                });
            }, function (error) {
                console.log(error);
            });

        }, function (error) {
            console.log(error);
        });
    };

//CREATEREVIEWs
    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'showertime', value: $scope.showertime},
            {column: 'showertime_id', value: $scope.showertime_id},
            {column: 'location_quarter_id', value: $scope.quarter_id},
            {column: 'additionalInformation', value: $scope.add},
            {column: 'plz', value: $scope.plz_id},
            {column: 'location', value: $scope.extralocation},
            {column: 'is_quartier', value: 1}
        ];
    });

    $scope.init();
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('evalmonitoring', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/locationReview/evalmonitoring/evalmonitoring.view.html' + "?v=" + window.version.tag,
        controller: "evalmonitoringController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('evalmonitoringController', function ($scope, reviewService, multiselectService, $rootScope, apiService, sscTreeSelectService, APP_FLAGS) {

    if(APP_FLAGS.includes("DEV")) {
        $scope.isDev = true;
    }

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.showertime_id = 2;
        $scope.showertime = [
            {id: 1, name: 'Statistischer Wert Gfk (2005)'},
            {id: 2, name: 'Angaben des Haushalts'}
        ];
        $scope.location_id = [];
        $scope.state_id = [];
        $scope.region_id = [];
        $scope.model = {region: [], state: [], location: []};
        $scope.devVars = {
            checkIds: "",
            isDebug: false
        };

        apiService.post("user/readareas", {doIncludeInactive: true, filterRoleSlugs: ['TRAINER', 'EFB', 'BUKO', 'ADMIN']}).then(function(data) {
            $scope.areaTreeArr = sscTreeSelectService.userAreasToTree(data);

            var areaTitle = [];
            if(data.regions.length > 0) {
                areaTitle.push("Region");
            }
            if(data.states.length > 0) {
                areaTitle.push("Bundesland");
            }
            if(data.locations.length > 0) {
                areaTitle.push("Standort");
            }
            $scope.areaTitle = areaTitle.join(" / ");


        }, function(error) {});
    };

    $scope.init();

    $scope.$on("createReview", function () {
        $rootScope.filter = [
            {column: 'showerIsGfk', value: !!($scope.showertime_id && parseInt($scope.showertime_id) === 1)}
        ];

        var areaSelection = sscTreeSelectService.extractSelection($scope.areaTreeArr);

        if(areaSelection.region_id && areaSelection.region_id.length > 0) {
            $rootScope.filter.push({column: 'region_id', value: areaSelection.region_id});
        }
        if(areaSelection.state_id && areaSelection.state_id.length > 0) {
            $rootScope.filter.push({column: 'state_id', value: areaSelection.state_id});
        }
        if(areaSelection.location_id && areaSelection.location_id.length > 0) {
            $rootScope.filter.push({column: 'location_id', value: areaSelection.location_id});
        }
        if($scope.from) {
            $rootScope.filter.push({column: 'valid_from', value: $scope.from});
        }
        if($scope.to) {
            $rootScope.filter.push({column: 'valid_until', value: $scope.to});
        }
        if($scope.devVars.checkIds) {
            $rootScope.filter.push({column: 'ssc_id', value: $scope.devVars.checkIds.split(",")});
        }
        if($scope.devVars.isDebug) {
            $rootScope.filter.push({column: 'isDebug', value: $scope.devVars.isDebug});
        }
    });

});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('beschaeftigungsfoerderung', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/locationReview/beschaeftigungsfoerderung/beschaeftigungsfoerderung.view.html' + "?v=" + window.version.tag,
        controller: "beschaeftigungsfoerderungController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('beschäftigungsförderungController', function ($scope, multiselectService, reviewService, $rootScope, apiService, sscTreeSelectService) {

    $scope.init = function () {
        delete $rootScope.to;
        multiselectService.init();
        $scope.location_id = [];
        $scope.employment_id = [];
        $scope.model = {region: [], state: [], location: [], employment: []};
        $scope.bund = true;
        $scope.allChecked = false;
        
        reviewService.loadEmploymentTypeList().then(function (data) {    
            $scope.dropdownEmployment = data;
        },
                function (error) {
                    console.log(error);
                });
        apiService.post("user/readareas", {
            doIncludeInactive: true,
            filterRoleSlugs: ['BUKO', 'ADMIN']
        }).then(function (data) {
            $scope.areaTreeArr = sscTreeSelectService.userAreasToTree(data);

            var areaTitle = [];
            if (data.regions.length > 0) {
                areaTitle.push("Region");
            }
            if (data.states.length > 0) {
                areaTitle.push("Bundesland");
            }
            if (data.locations.length > 0) {
                areaTitle.push("Standort");
            }
            $scope.areaTitle = areaTitle.join(" / ");


        }, function (error) {
        });
    };

    $scope.selectAll = function() {
        var data = multiselectService.selectAll($scope.dropdownEmployment, $scope.model.employment);
        $scope.model.employment = data.rows;
        $scope.employment_id = data.ids;
    }

    $scope.OnClickSelectEmployment = function (item) {
        $scope.employment_id.push(item.id);
    };
    $scope.OnRemoveSelectEmployment = function (item) {
        angular.forEach($scope.employment_id, function (id, index) {
            if (id === item.id)
            {
                $scope.employment_id.splice(index, 1);
            }
        });
    };

    $scope.init();

    
    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_to', operator: '<=', value: $scope.to},
            {column: 'bund', value: $scope.bund},
            {column: 'location_id', value: $scope.location_id},
            {column: 'state_id', value: $scope.state_id},
            {column: 'region_id', value: $scope.region_id},     
            {column: 'employment_id', value: $scope.model.employment}
        ];

        var areaSelection = sscTreeSelectService.extractSelection($scope.areaTreeArr);

        if(areaSelection.region_id && areaSelection.region_id.length > 0) {
            $rootScope.filter.push({column: 'region_id', value: areaSelection.region_id});
        }
        if(areaSelection.state_id && areaSelection.state_id.length > 0) {
            $rootScope.filter.push({column: 'state_id', value: areaSelection.state_id});
        }
        if(areaSelection.location_id && areaSelection.location_id.length > 0) {
            $rootScope.filter.push({column: 'location_id', value: areaSelection.location_id});
        }
    });




});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('auswertungssh', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/locationReview/auswertungssh/auswertungssh.view.html' + "?v=" + window.version.tag,
        controller: "auswertungsshController",
        link: function (scope, element, attrs) {
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('auswertungsshController', function ($scope, reviewService, multiselectService,$rootScope) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.location_id = [];
        $scope.model = {region: [], state: [], location: []};
        $scope.dropdown = multiselectService.loadRegionStateLocationList();
    };

    $scope.groupByRegion = function (item) {
        if (item.id !== 'all')
            return multiselectService.groupByRegion(item);
    };

    
    
    $scope.OnClickSelect = function (item) {
        $rootScope.$broadcast('refreshReportBtn');
        $scope.location_id.push(item.id);        
        if ($scope.model.location.length > 1) {
            $scope.model.location.splice(0, 1);
            $scope.location_id.splice(0, 1);
        }
        
        
    };

    $scope.OnRemoveSelect = function (item) {
         $scope.location_id.splice(0, 1);
    };

    $scope.init();

    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'location_id', value: $scope.location_id}
        ];
    });
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('auswertungsberichtssc', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/locationReview/auswertungsberichtssc/auswertungsberichtssc.view.html' + "?v=" + window.version.tag,
        controller: "auswertungsberichtsscController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('auswertungsberichtsscController', function ($scope, reviewService, multiselectService, localStorageService, $rootScope, sscTreeSelectService, apiService) {
    //INIT
    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.bund = true;
        $scope.showertime_id = 1;
        $scope.add = 0;
        $scope.showertime = [
            { id: 1, name: 'Statistischer Wert Gfk (2005)' },
            { id: 2, name: 'Angaben des Haushalts' }
        ];
        $scope.ssc_types = [
            {id:"all", name:"alle Checks"},
            {id:"model_warm", name:"nur Checks Wärme"},
            {id:"quartier_approach", name:"nur Checks Quartier"},
            {id: "fridge_exchange_state", name: "nur KGT Landesprogramm"}
        ];
        $scope.consultation_types = [
            {id: "all", name: "alle Beratungsformate"},
            {id: "visit", name: "Hausbesuch"},
            {id: "online", name: "Online"}
        ];
        $scope.showertime_id = 1;
        $scope.consultation_type = "visit";
        $scope.ssc_type = "all";
        $scope.location_id = [];
        $scope.plz_id = [];
        $scope.plzArea_id = [];
        $scope.plzArea = {
            name: null,
            zip: []
        };
        $scope.locationSelectChanged = true;
        $scope.areaTreeArr = [];
        $scope.model = { region: [], state: [], location: [] ,plz:[]};
        apiService.post("user/readareas", {doIncludeInactive: true})
        .then(function (data) {
            $scope.areaTreeArr = sscTreeSelectService.userAreasToTree(data);

            var areaTitle = [];
            if (data.regions.length > 0) {
                areaTitle.push("Region");
            }
            if (data.states.length > 0) {
                areaTitle.push("Bundesland");
            }
            if (data.locations.length > 0) {
                areaTitle.push("Standort");
            }
            $scope.areaTitle = areaTitle.join(" / ");


        }, function (error) {
        });

        reviewService.loadPlzAreaList().then(function (data) {
            $scope.dropdownPLZArea = data;
            $scope.dropdownPLZ = data;
        }, function (error) {
            console.log(error);
        });
        $scope.groupFilterPLZ = multiselectService.groupFilterPLZ;

        $scope.checkShowPlz = false;
        var user = localStorageService.get('user');
        angular.forEach(user.user_role, function (role) {
            if(['TRAINER', 'LOKO', 'ADMIN', 'BUKO', 'REKO', 'EFB'].includes(role.slug)) {
                $scope.checkShowPlz = true;
            }
        });
    };
    $scope.$watch("areaTreeArr", function () {
        $scope.locationSelectChanged = true;
    }, true);
    $scope.refreshPlzDropdown = function () {
        if ($scope.locationSelectChanged) {
            $scope.locationSelectChanged = false;
            var locations = sscTreeSelectService.extractSelectedLocations($scope.areaTreeArr);
            if (locations.length > 0) {
                reviewService.loadPlzList({"location_id": locations}).then(function (data) {
                    $scope.dropdownPLZ = angular.copy($scope.dropdownPLZArea);
                    angular.forEach(data, function (plz) {
                        $scope.dropdownPLZ.push(plz);
                    });
                }, function (error) {
                    console.log(error);
                });
            }
            else {
                $scope.dropdownPLZ.length = 0;
            }
        }
    };
    //PLZ
    $scope.groupByPlzNumberOne = function (item) {
        return multiselectService.groupByPlzNumberOne(item);
    };
    $scope.OnClickSelectPLZ = function (item) {
        $rootScope.$broadcast('refreshReportBtn');
        if (item.id) {
            $scope.extralocation = item.name;
            angular.forEach(item.report_preset_zip, function (zip) {

                var doublezip = false;
                angular.forEach($scope.model.plz, function (plz) {
                    if (plz.name === zip.zip) {

                        doublezip = true;
                    }
                });
                if (!doublezip)
                    $scope.model.plz.push({ name: zip.zip });

                var doubleplzid = false;
                angular.forEach($scope.plz_id, function (id) {
                    if (id === zip.zip) {
                        doubleplzid = true;
                    }
                });
                if (!doubleplzid)
                    $scope.plz_id.push(zip.zip);

            });
            angular.forEach($scope.model.plz, function (zip, index) {
                if (zip.id === item.id) {
                    $scope.model.plz.splice(index, 1);
                }
            });

        } else {
            $scope.plzArea.zip.push(item.name);
            $scope.plz_id.push(item.name);
        }
    };
    $scope.OnRemoveSelectPLZ = function (item) {        
        angular.forEach($scope.plzArea.zip, function (zip, index) {
            if (zip === item.name) {
                $scope.plzArea.zip.splice(index, 1);
            }
        });

        angular.forEach($scope.plz_id, function (zip, index) {
            if (zip === item.name) {
                $scope.plz_id.splice(index, 1);
            }
        });
    };
    $scope.savePLZ = function () {
        reviewService.createPLZArea($scope.plzArea).then(function () {
            $scope.plzArea = {
                name: null,
                zip: []
            };
            reviewService.loadPlzAreaList().then(function (data) {
                $scope.dropdownPLZArea = data;
                $scope.dropdownPLZ = data;
                var locations = sscTreeSelectService.extractSelectedLocations($scope.areaTreeArr);
                reviewService.loadPlzList({location_id: locations}).then(function (data) {
                    $scope.dropdownPLZ = angular.copy($scope.dropdownPLZArea);
                    angular.forEach(data, function (plz) {
                        $scope.dropdownPLZ.push(plz);
                    });
                }, function (error) {
                    console.log(error);
                });
            }, function (error) {
                console.log(error);
            });
        }, function (error) {
            console.log(error);
        });
    };
    //PLZAREA
    $scope.OnClickSelectPLZArea = function (item) {
        $scope.plzArea_id.push(item.id);
    };
    $scope.OnRemoveSelectPLZArea = function (item) {
        angular.forEach($scope.plzArea_id, function (id, index) {
            if (id === item.id) {
                $scope.plzArea_id.splice(index, 1);
            }
        });
    };
    $scope.deletePLZArea = function () {
        reviewService.deletePLZArea($scope.plzArea_id).then(function () {
            $scope.plzArea_id.splice(0);
            $scope.model.plzarea.splice(0);
            reviewService.loadPlzAreaList().then(function (data) {
                $scope.dropdownPLZArea = data;
                $scope.dropdownPLZ = data;
                var locations = sscTreeSelectService.extractSelectedLocations($scope.areaTreeArr);
                reviewService.loadPlzList({location_id: locations}).then(function (data) {
                    $scope.dropdownPLZ = angular.copy($scope.dropdownPLZArea);
                    angular.forEach(data, function (plz) {
                        $scope.dropdownPLZ.push(plz);
                    });
                }, function (error) {
                    console.log(error);
                });
            }, function (error) {
                console.log(error);
            });

        }, function (error) {
            console.log(error);
        });
    };

    //CREATEREVIEWs
    $scope.$on("createReview", function () {

        $rootScope.filter = [
            { column: 'valid_from', value: $scope.from },
            { column: 'valid_until', value: $scope.to },
            { column: 'showertime_id', value: $scope.showertime_id },
            { column: 'additionalInformation', value: $scope.add },
            { column: 'plz', value: $scope.plz_id },
            { column: 'location', value: $scope.extralocation },
            { column: 'bund', value: $scope.bund },
            { column: 'ssc_type', value: $scope.ssc_type },
            { column: 'consultation_type', value: $scope.consultation_type }
        ];
        var areaSelection = sscTreeSelectService.extractSelection($scope.areaTreeArr);
        if (areaSelection.region_id && areaSelection.region_id.length > 0) {
            $rootScope.filter.push({column: 'region_id', value: areaSelection.region_id});
        }
        if (areaSelection.state_id && areaSelection.state_id.length > 0) {
            $rootScope.filter.push({column: 'state_id', value: areaSelection.state_id});
        }
        if (areaSelection.location_id && areaSelection.location_id.length > 0) {
            $rootScope.filter.push({column: 'location_id', value: areaSelection.location_id});
        }
    });

    $scope.init();
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('akquiseliste', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/locationReview/akquiseliste/akquiseliste.view.html' + "?v=" + window.version.tag,
        controller: "akquiselisteController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('akquiselisteController', function ($scope, reviewService, multiselectService, $rootScope, apiService, sscTreeSelectService) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.location_id = [];
        $scope.akquise_id = [];
        $scope.model = {akquise: []};
        $scope.bund = true;
        $scope.allChecked = false;
        reviewService.loadAkquiseList().then(function (data) {
                $scope.dropdownAkquise = data;
                console.log(data);
            },
            function (error) {
                console.log(error);
            });

        apiService.post("user/readareas", {
            doIncludeInactive: true,
            includeLocationStates: true,
        }).then(function (data) {
            $scope.areaTreeArr = sscTreeSelectService.userAreasToTree(data);

            var areaTitle = [];
            if (data.regions.length > 0) {
                areaTitle.push("Region");
            }
            if (data.states.length > 0) {
                areaTitle.push("Bundesland");
            }
            if (data.locations.length > 0) {
                areaTitle.push("Standort");
            }
            $scope.areaTitle = areaTitle.join(" / ");


        }, function (error) {
        });

    };


    $scope.selectAll = function () {
        var data = multiselectService.selectAll($scope.dropdownAkquise, $scope.model.akquise);
        $scope.model.akquise = data.rows;
        $scope.akquise_id = data.ids;
    };

    $scope.OnClickSelectAkquise = function (item) {
        $scope.akquise_id.push(item.id);
    };

    $scope.OnRemoveSelectAkquise = function (item) {
        angular.forEach($scope.akquise_id, function (id, index) {
            if (id === item.id) {
                $scope.akquise_id.splice(index, 1);
            }
        });
    };

    $scope.init();


    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'bund', value: $scope.bund},
            {column: 'location_id', value: $scope.location_id},
            {column: 'state_id', value: $scope.state_id},
            {column: 'region_id', value: $scope.region_id},
            {column: 'akquise_id', value: $scope.akquise_id}
        ];

        var areaSelection = sscTreeSelectService.extractSelection($scope.areaTreeArr);

        if(areaSelection.region_id && areaSelection.region_id.length > 0) {
            $rootScope.filter.push({column: 'region_id', value: areaSelection.region_id});
        }
        if(areaSelection.state_id && areaSelection.state_id.length > 0) {
            $rootScope.filter.push({column: 'state_id', value: areaSelection.state_id});
        }
        if(areaSelection.location_id && areaSelection.location_id.length > 0) {
            $rootScope.filter.push({column: 'location_id', value: areaSelection.location_id});
        }

    });

});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('abgeschlossenehh', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/locationReview/abgeschlossenehh/abgeschlossenehh.view.html' + "?v=" + window.version.tag,
        controller: "abgeschlossenehhController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('abgeschlossenehhController', function ($scope, reviewService, multiselectService, $rootScope, apiService, sscTreeSelectService, userService) {
    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        var currentYear = (new Date()).getFullYear();
        $scope.location_id = [];
        $scope.state_id = [];
        $scope.region_id = [];
        $scope.bund = true;
        $scope.from = currentYear + "-01-01";
        $scope.to = currentYear + "-12-31";
        $scope.model = {region: [], state: [], location: []};
        $scope.allChecked = false;

        apiService.post("user/readareas", {
            doIncludeInactive: true,
            filterRoleSlugs: ['BUKO', 'ADMIN', 'REKO', 'EFB', 'LOKO']
        }).then(function (data) {
            $scope.areaTreeArr = sscTreeSelectService.userAreasToTree(data);

            var areaTitle = [];
            if (data.regions.length > 0) {
                areaTitle.push("Region");
            }
            if (data.states.length > 0) {
                areaTitle.push("Bundesland");
            }
            if (data.locations.length > 0) {
                areaTitle.push("Standort");
            }
            $scope.areaTitle = areaTitle.join(" / ");


        }, function (error) {
        });
    };



    $scope.init();


    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'bund', value: $scope.bund},
            {column: 'location_id', value: $scope.location_id},
            {column: 'state_id', value: $scope.state_id},
            {column: 'region_id', value: $scope.region_id}
        ];

        var areaSelection = sscTreeSelectService.extractSelection($scope.areaTreeArr);

        if(areaSelection.region_id && areaSelection.region_id.length > 0) {
            $rootScope.filter.push({column: 'region_id', value: areaSelection.region_id});
        }
        if(areaSelection.state_id && areaSelection.state_id.length > 0) {
            $rootScope.filter.push({column: 'state_id', value: areaSelection.state_id});
        }
        if(areaSelection.location_id && areaSelection.location_id.length > 0) {
            $rootScope.filter.push({column: 'location_id', value: areaSelection.location_id});
        }
    });

    $scope.treeSelectDisableBund = function () {
        return !userService.loggedInHasRole(["ADMIN", "BUKO", "REKO", "EFB"]);
    }
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('kleinerstandortvergleich', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/directhelpReview/kleinerstandortvergleich/kleinerstandortvergleich.view.html' + "?v=" + window.version.tag,
        controller: "kleinerstandortvergleichController",
        link: function (scope, element, attrs) {
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('kleinerstandortvergleichController', function ($scope, reviewService, multiselectService,$rootScope) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.location_id = [];
        $scope.model = {region: [], state: [], location: []};
        $scope.from = "2009-01-01";
        $scope.dropdown = multiselectService.loadRegionStateLocationList();
    };

    $scope.groupByRegion = function (item) {
        if (item.id !== 'all')
            return multiselectService.groupByRegion(item);
    };

    
    
    $scope.OnClickSelect = function (item) {
        $scope.location_id.push(item.id);
        
        
    };

    $scope.OnRemoveSelect = function (item) {
         $scope.location_id.splice(0, 1);
    };

    $scope.init();

    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'location_id', value: $scope.location_id}
        ];
    });
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('givenDirecthelps', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/directhelpReview/givenDirecthelps/givenDirecthelps.view.html' + "?v=" + window.version.tag,
        controller: "givenDirecthelpsController",
        link: function (scope, element, attrs) {
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('givenDirecthelpsController', function ($scope, reviewService, $timeout, multiselectService, $rootScope, sscTreeSelectService, apiService) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.bund = true;
        $scope.from = "2008-01-01";
        $scope.model = {location: []};
        $scope.areaTreeArr = [];
        apiService.post("user/readareas", { doIncludeInactive: true })
        .then(function (data) {
            $scope.areaTreeArr = sscTreeSelectService.userAreasToTree(data);

            var areaTitle = [];
            if (data.regions.length > 0) {
                areaTitle.push("Region");
            }
            if (data.states.length > 0) {
                areaTitle.push("Bundesland");
            }
            if (data.locations.length > 0) {
                areaTitle.push("Standort");
            }
            $scope.areaTitle = areaTitle.join(" / ");


        }, function (error) {
        });
    };
    $scope.init();

    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'bund', operator: '<=', value: $scope.bund},
        ];
        var areaSelection = sscTreeSelectService.extractSelection($scope.areaTreeArr);
        if (areaSelection.region_id && areaSelection.region_id.length > 0) {
            $rootScope.filter.push({column: 'region_id', value: areaSelection.region_id});
        }
        if (areaSelection.state_id && areaSelection.state_id.length > 0) {
            $rootScope.filter.push({column: 'state_id', value: areaSelection.state_id});
        }
        if (areaSelection.location_id && areaSelection.location_id.length > 0) {
            $rootScope.filter.push({column: 'location_id', value: areaSelection.location_id});
        }
    });

});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('bericht', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/directhelpReview/bericht/bericht.view.html' + "?v=" + window.version.tag,
        controller: "berichtController",
        link: function (scope, element, attrs) {
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('berichtController', function ($scope, reviewService, $timeout, multiselectService, $rootScope, sscTreeSelectService, apiService) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.bund = true;
        $scope.from = "2008-01-01";
        $scope.model = {location: []};
        $scope.areaTreeArr = [];
        apiService.post("user/readareas", { doIncludeInactive: true })
        .then(function (data) {
            $scope.areaTreeArr = sscTreeSelectService.userAreasToTree(data);

            var areaTitle = [];
            if (data.regions.length > 0) {
                areaTitle.push("Region");
            }
            if (data.states.length > 0) {
                areaTitle.push("Bundesland");
            }
            if (data.locations.length > 0) {
                areaTitle.push("Standort");
            }
            $scope.areaTitle = areaTitle.join(" / ");


        }, function (error) {
        });
    };
    $scope.init();

    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'bund', operator: '<=', value: $scope.bund},
        ];
        var areaSelection = sscTreeSelectService.extractSelection($scope.areaTreeArr);
        if (areaSelection.region_id && areaSelection.region_id.length > 0) {
            $rootScope.filter.push({column: 'region_id', value: areaSelection.region_id});
        }
        if (areaSelection.state_id && areaSelection.state_id.length > 0) {
            $rootScope.filter.push({column: 'state_id', value: areaSelection.state_id});
        }
        if (areaSelection.location_id && areaSelection.location_id.length > 0) {
            $rootScope.filter.push({column: 'location_id', value: areaSelection.location_id});
        }
    });

});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('zielerreichnungmonitoring', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/controllingReview/zielerreichnungmonitoring/zielerreichnungmonitoring.view.html' + "?v=" + window.version.tag,
        controller: "zielerreichnungmonitoringController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('zielerreichnungmonitoringController', function ($scope, reviewService,multiselectService,$rootScope) {
    
    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.location_id = [];
        $scope.model = {region: [], state: [], location: []};
        $scope.dropdown = multiselectService.loadRegionStateLocationList();
    };

    $scope.OnClickSelect = function (column, item) {
        var data = multiselectService.OnClickSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.OnRemoveSelect = function (column, item) {
        var data = multiselectService.OnRemoveSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.selectAllLocation = function () {
        var data = multiselectService.selectAllLocation($scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.groupByRegion = function (item) {
        return multiselectService.groupByRegion(item);
    };
    $scope.readIds = function(data) {
        $scope.state_id = multiselectService.readIdsFromList(data.model.state);        
        $scope.region_id = multiselectService.readIdsFromList(data.model.region);
    };
        
    $scope.init();

    
    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'checks_from', operator: '>=', value: $scope.fromtwo},
            {column: 'checks_until', operator: '<=', value: $scope.totwo},
            {column: 'monitoring_from', operator: '>=', value: $scope.from},
            {column: 'monitoring_until', operator: '<=', value: $scope.to},
            {column: 'location_id', value: $scope.location_id},
            {column: 'state_id', value: $scope.state_id},
            {column: 'region_id', value: $scope.region_id} 
        ];
    });

});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('monitoringeinsparungen', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/controllingReview/monitoringeinsparungen/monitoringeinsparungen.view.html' + "?v=" + window.version.tag,
        controller: "monitoringeinsparungenController"
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('monitoringeinsparungenController', function ($scope, reviewService, $rootScope, apiService, sscTreeSelectService) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;

        apiService.post("user/readareas", {
            doIncludeInactive: true,
            filterRoleSlugs: ['BUKO', 'ADMIN']
        }).then(function (data) {
            $scope.areaTreeArr = sscTreeSelectService.userAreasToTree(data);

            var areaTitle = [];
            if (data.regions.length > 0) {
                areaTitle.push("Region");
            }
            if (data.states.length > 0) {
                areaTitle.push("Bundesland");
            }
            if (data.locations.length > 0) {
                areaTitle.push("Standort");
            }
            $scope.areaTitle = areaTitle.join(" / ");


        }, function (error) {
        });
    };

    $scope.init();



    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'location_id', value: $scope.location_id},
            {column: 'state_id', value: $scope.state_id},
            {column: 'region_id', value: $scope.region_id}
        ];

        var areaSelection = sscTreeSelectService.extractSelection($scope.areaTreeArr);

        if(areaSelection.region_id && areaSelection.region_id.length > 0) {
            $rootScope.filter.push({column: 'region_id', value: areaSelection.region_id});
        }
        if(areaSelection.state_id && areaSelection.state_id.length > 0) {
            $rootScope.filter.push({column: 'state_id', value: areaSelection.state_id});
        }
        if(areaSelection.location_id && areaSelection.location_id.length > 0) {
            $rootScope.filter.push({column: 'location_id', value: areaSelection.location_id});
        }

    });
});
"use strict";

angular.module('frontendApp').directive('controllingreport', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/controllingReview/controllingreport/controllingreport.view.html' + "?v=" + window.version.tag,
        controller: "controllingreportController"
    };
});
"use strict";
/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
angular.module('frontendApp').controller('controllingreportController', function ($scope, reviewService, multiselectService, $rootScope, apiService) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.location_id = [];
        $scope.model = {region: [], state: [], location: []};
        $scope.export_type = "excel-tabs";
        $scope.export_tabs = {selected: null, options: []};
        $scope.dropdown = multiselectService.loadRegionStateLocationList();
        apiService.get("report/controlling/controllingreport/tabs")
            .then(function (data) {
                $scope.export_tabs.options = data;
                $scope.export_tabs.selected = data;
            });
    };

    $scope.OnClickSelect = function (column, item) {
        $rootScope.$broadcast('refreshReportBtn');
        var data = multiselectService.OnClickSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.OnRemoveSelect = function (column, item) {
        var data = multiselectService.OnRemoveSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.selectAllLocation = function () {
        $rootScope.$broadcast('refreshReportBtn');
        var data = multiselectService.selectAllLocation($scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.groupByRegion = function (item) {
        return multiselectService.groupByRegion(item);
    };
    $scope.readIds = function (data) {
        $scope.state_id = multiselectService.readIdsFromList(data.model.state);
        $scope.region_id = multiselectService.readIdsFromList(data.model.region);
    };
    $scope.readTabIds = function () {
        var ids = [];
        angular.forEach($scope.export_tabs.selected, function (tab) {
            ids.push(tab.id);
        });
        return ids;
    }

    $scope.init();

    $scope.$on("createReview", function () {
        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'location_id', value: $scope.location_id},
            {column: 'state_id', value: $scope.state_id},
            {column: 'region_id', value: $scope.region_id},
            {column: 'export_type', value: $scope.export_type},
            {column: 'export_tabs', value: $scope.readTabIds()}
        ];

    });
});
"use strict";

angular.module('frontendApp').directive('controllingmonitoring', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/controllingReview/controllingmonitoring/controllingmonitoring.view.html' + "?v=" + window.version.tag,
        controller: "controllingmonitoringController"
    };
});
"use strict";
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
angular.module('frontendApp').controller('controllingmonitoringController', function ($scope, reviewService, multiselectService, $rootScope) {
    
    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.location_id = [];
        $scope.model = {region: [], state: [], location: []};
        $scope.dropdown = multiselectService.loadRegionStateLocationList();
    };

    $scope.OnClickSelect = function (column, item) {
        $rootScope.$broadcast('refreshReportBtn');
        var data = multiselectService.OnClickSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.OnRemoveSelect = function (column, item) {
        var data = multiselectService.OnRemoveSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.selectAllLocation = function () {
        $rootScope.$broadcast('refreshReportBtn');
        var data = multiselectService.selectAllLocation($scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.groupByRegion = function (item) {
        return multiselectService.groupByRegion(item);
    };
    $scope.readIds = function (data) {
        $scope.state_id = multiselectService.readIdsFromList(data.model.state);
        $scope.region_id = multiselectService.readIdsFromList(data.model.region);
    };

    $scope.init();



    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'location_id', value: $scope.location_id},
            {column: 'state_id', value: $scope.state_id},
            {column: 'region_id', value: $scope.region_id}
        ];

    });
});
"use strict";

angular.module('frontendApp').directive('controllingenergy', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/overview/controllingReview/controllingenergy/controllingenergy.view.html' + "?v=" + window.version.tag,
        controller: "controllingenergyController"
    };
});
"use strict";
/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
angular.module('frontendApp').controller('controllingenergyController', function ($scope, reviewService, multiselectService, $rootScope) {

    $scope.init = function () {
        delete $rootScope.from;
        delete $rootScope.to;
        multiselectService.init();
        $scope.location_id = [];
        $scope.model = {region: [], state: [], location: []};
        $scope.dropdown = multiselectService.loadRegionStateLocationList($scope.$parent.review.roles);
    };

    $scope.OnClickSelect = function (column, item) {
        $rootScope.$broadcast('refreshReportBtn');
        var data = multiselectService.OnClickSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.OnRemoveSelect = function (column, item) {
        var data = multiselectService.OnRemoveSelect(column, item, $scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.selectAllLocation = function () {
        $rootScope.$broadcast('refreshReportBtn');
        var data = multiselectService.selectAllLocation($scope.model);
        $scope.model = data.model;
        $scope.readIds(data);
        $scope.location_id = data.location_id;
    };
    $scope.groupByRegion = function (item) {
        return multiselectService.groupByRegion(item);
    };
    $scope.readIds = function (data) {
        $scope.state_id = multiselectService.readIdsFromList(data.model.state);
        $scope.region_id = multiselectService.readIdsFromList(data.model.region);
    };

    $scope.init();



    $scope.$on("createReview", function () {

        $rootScope.filter = [
            {column: 'valid_from', operator: '>=', value: $scope.from},
            {column: 'valid_until', operator: '<=', value: $scope.to},
            {column: 'location_id', value: $scope.location_id},
            {column: 'state_id', value: $scope.state_id},
            {column: 'region_id', value: $scope.region_id}
        ];

    });
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenuarchive
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenuarchiv', function (tabmenuService, $stateParams, $filter, $compile, $rootScope) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("exchange/archive/count").then(function (data) {
                    scope.bSearch = bSearch;
                    scope.tabCounts = data;
                    scope.searchCounts = scope.tabCounts;
                    scope.grids = [{
                            name: "archiv",
                            title: $filter('translate')('TAB_ARCHIV'),
                            permissionOnly: ['ADMIN', 'LOKO'],
                            data: scope.tabCounts
                        }];
                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.empty();
                    myEl.append(template);
                    $compile(template)(scope);
                },
                        function (error) {
                            console.log(error);
                        });
            };

            scope.$on("exchangeUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
}); 

"use strict";
angular.module('frontendApp').factory('exchangeArchiveService', function(apiService, api){
   var exchange = {};
   
   exchange.exportBilling = function(data){
       return apiService.post("exchange/archive/export", data);
   };
   
   exchange.downloadExport = function(data){
       return apiService.get(data);
   };   
   
   return exchange;
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:exchange
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('archiv', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "archivController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_ARCHIV');
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:archivController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('archivController', function ($scope, ngDialog, $rootScope, newsService, uiGridConstants, gridService, $http, api, exchangeArchiveService, $translate, formService) {

    $scope.data = [];

    $scope.api = {
        route: "exchange/archive/read",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            search: $rootScope.search,
            filter: $rootScope.filter,
            archive: true
        }
    };
    $scope.route = api.root + 'exchange/download/export';
    $scope.user = {token: $rootScope.currentUser.token};
//    var dataMock = [{
//            id: 1,
//            billnumber: 2322342343232,
//            time_start: '1.8.2018',
//            time_end: '8.8.2018',
//            created_at: '9.8.2018',
//            status: 0,
//            document: 'abrechnung.xls'
//        }];

    var cols = ['created_at', 'valid_until', ];

    // UI GRID: updates data
    $scope.getTableData = function () {
        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = formService.formatGrid(data.data, cols);
            $scope.data = data.data;
            //Update TabCount
            if ($scope.api.data.search || $scope.api.data.filter)
                $rootScope.$broadcast('updateTabcount', {count: data.total});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            width: 100,
            sort: {direction: uiGridConstants.ASC, priority: 1},
            enableFiltering: false,

        },
        {
            field: 'billing_nr',
            displayName: 'Abrechnungsnummer',
            headerCellFilter: 'translate',
        },
        {
            field: 'from',
            displayName: 'Zeitraum Beginn',
            headerCellFilter: 'translate',
        },
        {
            field: 'to',
            displayName: 'Zeitraum Ende',
            headerCellFilter: 'translate',
        },
        {
            field: 'created_at',
            displayName: 'Erstellungsdatum',
            headerCellFilter: 'translate',
        },
        {
            field: 'fileName',
            displayName: 'Dokument',
            headerCellFilter: 'translate',
        }, {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 100,
            headerCellClass: 'center',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="center"><a title="Download" ng-href="{{grid.appScope.route}}?ids={{row.entity.id}}&token={{grid.appScope.user.token}}" download ng-if="!grid.appScope.itemsSelected" class="ui-grid-nav"><i class="fa fa-download" aria-hidden="true"></i></a></div>'
        }
    ];


    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        enableColumnMenus: false,
        enableFiltering: false,
        useExternalSorting: true,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 60,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSizes: [1, 5, 10, 25, 50],
        paginationPageSize: $rootScope.itemsPerPage,
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.core.on.sortChanged($scope, function (grid, sort) {


                if (sort[0] && sort[0].field) {
                    //1. Sorting setzen nach Feld und ORder
                    $scope.api.data.sort.column = sort[0].field;
                    $scope.api.data.sort.order = sort[0].sort.direction;

                    //2. 
                    gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                        $scope.data = formService.formatGrid(data.data, cols);
                        $scope.data = data.data;
                        //  $scope.data = dataMock;
                    }, function (error) {
                        console.log(error);
                    });
                }
                ;
            });

            gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                var msg = 'row selected ' + row.isSelected;
                $scope.itemsSelected = gridApi.selection.getSelectedRows().length > 1;
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = formService.formatGrid(data.data, cols);
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                    //$scope.data = dataMock;
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };

    $scope.downloadExport = function (id) {
        var data = {id: id};
        exchangeArchiveService.downloadExport(data).then(function (data) {
            console.log(data);
        }, function (error) {
            console.log(error);
        });

    };




});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:exampleService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('userSubstituteCreateService', function (apiService) {

    var service = {};

    service.readSubstitute = function (id) {
        return apiService.post("user/substitute/read", {id: id});
    };

    service.createSubstitute = function (data) {
        return apiService.post("user/substitute/create", data);
    };

    service.updateSubstitute = function (data) {
        return apiService.post("user/substitute/update", data);
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:userSubstituteCreate
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('userSubstituteCreate', function () {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/user/userSubstitute/userSubstituteCreate/userSubstituteCreate.view.html' + "?v=" + window.version.tag,
        controller: 'userSubstituteCreateController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:userSubstituteCreateController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('userSubstituteCreateController', function ($scope, $stateParams, usercreateService, userSubstituteCreateService, formService, $window, $filter, $state, searchService, apiService, userService) {

    $scope.showSshOption = false;
    $scope.selector = {role: 'SSH'};


    $scope.formVars = {
        canCreateSubstitute: true
    };
    $scope.isNotFound = false;

    $scope.init = function() {
        
        $scope.searchRes = [];
        
        usercreateService.readUser($stateParams.id).then(function (data) {
            $scope.name = data.name;
            $scope.data = data;
            var roleSlug, locationId;
            angular.forEach($scope.data.user_role_map, function(value, key) {
                if($stateParams.roleMapId == $scope.data.user_role_map[key].id) {
                    roleSlug = $scope.data.user_role_map[key].role.slug;
                    if(roleSlug == "LOKO") {
                        $scope.showSshOption = true;
                        // Check if SSH+ has been selected
                        if($scope.selector.role == "SSH+") {
                            roleSlug = "SSHPLUS";
                        }
                    }

                    //TODO, currently nonsense

                    if($scope.data.user_role_map[key].user_role_area_map.location) {
                        locationId = $scope.data.user_role_map[key].user_role_area_map.location[0].id;
                    }
                }
            });

            if(["admin", "buko", "efb"].includes(roleSlug.toLowerCase())) {
                $scope.formVars.canCreateSubstitute = false;
                return;
            }

            var roleInfo = userService.extractRoleInfo(data, $stateParams.roleMapId);
            if(roleInfo) {
                $scope.subheading = roleInfo.roleShort + " ";
                if(roleInfo.location) {
                    $scope.subheading += "Standort: " + roleInfo.location;
                }
                if(roleInfo.organisation) {
                    $scope.subheading += "Organisation: " + roleInfo.organisation;
                }
                if(roleInfo.state) {
                    $scope.subheading += "Bundesländer: ";
                    $scope.subheading += roleInfo.state.join(", ");
                }
            }

            //TODO, currently nonsense
            if(locationId){
                apiService.post("user/readviaroleslug", {//get users for dropdown
                    slug: roleSlug,
                    filter: [{
                        column: "location.id", location: locationId
                    }]
                }).then(function(data) {

                    //add name
                    for(var i = 0 ; i < data.length; i++) {
                        data[i].fullname = data[i].lastname;
                        if(data[i].firstname) {
                            data[i].fullname += ", " + data[i].firstname;
                        }
                    }
                    //remove self from it, and inactive
                    for(var i = 0 ; i < data.length; i++) {
                        if(parseInt(data[i].id) === parseInt($stateParams.id) || !data[i].aktiv) {
                            data.splice(i, 1);
                        }
                    }

                    $scope.searchRes = data;

                }, function(error) {
                    $scope.isNotFound = true;
                });
            }

        }, function (error) {
            $scope.isNotFound = true;
            console.log(error);
        });


        $scope.edit = $state.current.name.indexOf('user.update.substitute.update') !== -1;

        if($scope.edit) {
            //read the user
            userSubstituteCreateService.readSubstitute($stateParams.substituteId).then(function (data) {
                $scope.model = data;console.log(data);
                $scope.user = data.user;
                $scope.user.fullname = $scope.user.lastname;
                if($scope.user.firstname) {
                    $scope.user.fullname += ", " + $scope.user.firstname;
                }

                $scope.model.date_begin = moment($scope.model.date_begin, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
                $scope.model.date_end = moment($scope.model.date_end, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");

            }, function (error) {
                console.log(error);
            });

        } else { //creating new
            $scope.model = {};
        }

        $scope.required = {
            user_id: true,
            date_begin: true,
            date_end: true
        };
    };

    $scope.check = function () {
        if(!formService.check($scope.required, $scope.model)) {
            return false;
        }
        return true;
    };

    $scope.save = function() {
        $scope.errorAlert = undefined;
        $scope.saved = true;
        if($scope.isSaving || !$scope.check()) {
            return;
        }
        $scope.isSaving = true;

        $scope.model.role_map_id = $stateParams.roleMapId;

        function onSuccess() {
            $scope.isSaving = false;
            $window.history.back();
        }

        function onError(error) {
            $scope.isSaving = false;

            if(error.error === "client_error.date_overlap") {
                $scope.errorAlert = {message: $filter('translate')('Datum überlagert sich mit anderer Vertretung.')};
            } else {
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
            }
        }

        if($scope.edit) {
            userSubstituteCreateService.updateSubstitute($scope.model).then(onSuccess, onError);
        } else {
            userSubstituteCreateService.createSubstitute($scope.model).then(onSuccess, onError);
        }
    };

    // SSCR-1121: Substitution for SSH can also be SSH+
    $scope.reloadUsers = function() {
        $scope.init();
    };

        
    $scope.OnClickSelect = function (item) {
        $scope.model.user_id = item.id;
    };

    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:exampleService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('userrolelocationService', function (apiService) {

    var service = {};

    service.readRole = function (id, role_id, role_map_id) {
        var data = {
            id: id,
            role_id: role_id,
            role_map_id: role_map_id
        };
        return apiService.post("user/readuserrole", data);
    };

    service.createRole = function (data) {
        return apiService.post("user/createuserrole", data);
    };

    service.updateRole = function (data) {
        return apiService.post("user/updateuserrole", data);
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:userCreate
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('userCreateRoleLocation', function () {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/user/userCreate/roleLocationCreate/roleLocationCreate.view.html' + "?v=" + window.version.tag,
        controller: 'usercreaterolelocationController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:usercreaterolelocationController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('usercreaterolelocationController', function ($scope, $state, formService, $stateParams, userService, userrolelocationService, usercreateService, $filter, apiService) {

    var areasArr;
    var userObj;
    $scope.hasAccess = true;
    var sshArr = [];
    var sshPlusArr = [];
    $scope.states = {
        locked: [],
        dropSelected: []
    };

    function updateAreaDropdowns() {
        if(!areasArr) {
            return;
        }

        //figure out slug
        var roleSlug, i, tempArr;
        if(!$scope.dropRole) {
            return;
        }
        for (i = 0; i < $scope.dropRole.length; i++) {
            if(parseInt($scope.dropRole[i].id) === parseInt($scope.model.role_id)) {
                roleSlug = $scope.dropRole[i].slug;
                break;
            }
        }

        var dropdownArr = userService.getAreaDropdowns(areasArr, roleSlug);

        $scope.dropLocation = dropdownArr.dropLocation;
        $scope.dropOrganisation = dropdownArr.dropOrganisation;
        $scope.dropState = dropdownArr.dropState;
        //making drop and selection the same.
        for(i = 0; i < $scope.dropState.length; i++) {
            delete $scope.dropState[i].short;
        }

        //filter dropLocation for SSH and SSH+
        if(roleSlug === "SSH" && userObj) {
            //only keep locations where no SSH
            tempArr = $scope.dropLocation;
            $scope.dropLocation = [];
            for(i = 0; i < tempArr.length; i++) {
                if(parseInt($scope.model.location) === parseInt(tempArr[i].id) ) {
                    $scope.dropLocation.push(tempArr[i]);
                    continue;
                }
                if(!sshArr.includes(tempArr[i].id)) {
                    $scope.dropLocation.push(tempArr[i]);
                }
            }
        }
        if(roleSlug === "SSHPLUS" && userObj) {
            //only keep locations where an SSH, but no SSH+
            tempArr = $scope.dropLocation;
            $scope.dropLocation = [];
            for(i = 0; i < tempArr.length; i++) {
                if(parseInt($scope.model.location) === parseInt(tempArr[i].id) ) {
                    $scope.dropLocation.push(tempArr[i]);
                    continue;
                }
                if(sshArr.includes(tempArr[i].id) && !sshPlusArr.includes(tempArr[i].id)) {
                    $scope.dropLocation.push(tempArr[i]);
                }
            }
        }


        //initializing states

        //what is accessible needs to have been loaded and dropdowns initialized
        //model needs to have been loaded and initialized
        if(!$scope.dropState || !$scope.model.states) {
            return;
        }

        $scope.states = {
            locked: [],
            dropSelected: []
        };

        var accessible;
        for(i = 0 ; i < $scope.model.states.length; i++) {
            accessible = false;
            for(var e = 0; e < $scope.dropState.length; e++) {
                if(parseInt($scope.dropState[e].id) === parseInt($scope.model.states[i].id)) {
                    accessible = true;
                    break;
                }
            }
            if(accessible) {
                $scope.states.dropSelected.push($scope.model.states[i]);
            } else {
                $scope.states.locked.push($scope.model.states[i]);
            }
        }
    }

    function onRoleChange(newValue, oldValue) {
        if(parseInt(newValue) === parseInt(oldValue)) {
            return;
        }
        $scope.model.location = undefined;
        $scope.model.organisation = undefined;
        $scope.model.states = [].concat($scope.states.locked);
        updateAreaDropdowns();
    }

    $scope.init = function () {
        $scope.isSaving = false;
        $scope.saved = false;

        $scope.model = {};
        $scope.initialModel = {};

        $scope.isCreate = false;

        $scope.hasSSH = false;

        $scope.isSshPlusSelected = false;


        if ($state.current.name.indexOf('user.update.rolelocationCreate') !== -1) {
            $scope.edit = false;

            $scope.model.user_id = parseInt($stateParams.id); //user id
            $scope.model.role_id = parseInt($stateParams.roleId);
            $scope.isCreate = true;

            $scope.$watch('model.role_id', onRoleChange);

        } else {
            $scope.edit = true;
            userrolelocationService.readRole($stateParams.id, $stateParams.roleId, $stateParams.roleMapId).then(function (data) {
                var model = data;
                var initialModel = {};

                model.role_id = model.user_role_id;

                if(parseInt(model.role_id) === 2 || parseInt(model.role_id) === 8) {
                    initialModel.states = model.states = [];
                    for(var i = 0; i < model.area.length; i++) {
                        model.states.push({
                            id: model.area[i].state_id,
                            name: model.area[i].name
                        });
                    }
                } else if(model.area.length > 0) {
                    initialModel.location = model.location = model.area[0].location_id ? parseInt(model.area[0].location_id, 10) : undefined;
                    initialModel.organisation = model.organisation = model.area[0].organisation_id ? parseInt(model.area[0].organisation_id, 10) : undefined;
                }


                initialModel.comment = model.comment;

                delete model.area;

                $scope.model = model;
                $scope.initialModel = initialModel;
                $scope.updateRequired();
                updateAreaDropdowns();

                $scope.$watch('model.role_id', onRoleChange);

            }, function (error) {
                console.log(error);
            });
        }

        usercreateService.readUser($stateParams.id).then(function (data) {
            userObj = data;
            if($scope.edit) {
                $scope.name = $filter('translate')('USER_UPDATE_ROLE_LOCATION', {name: data.name});
            } else {
                $scope.name = $filter('translate')('USER_CREATE_ROLE_LOCATION', {name: data.name});
            }

            for(var i = 0; i < userObj.user_role_map.length; i++) {
                if(userObj.user_role_map[i].role.slug === "SSH") {
                    sshArr.push(userObj.user_role_map[i].user_role_area_map.location[0].id);
                }
                if(userObj.user_role_map[i].role.slug === "SSHPLUS") {
                    sshPlusArr.push(userObj.user_role_map[i].user_role_area_map.location[0].id);
                }
            }

            updateAreaDropdowns();
        }, function (error) {
            $scope.hasAccess = false;
            console.log(error);
        });

        userService.getRoles().then(function (data) {
            $scope.dropRole = data;
            for(var i = 0; i < $scope.dropRole.length; i++) {
                $scope.dropRole[i].dropName = $scope.dropRole[i].role + " (" + $scope.dropRole[i].short + ")";
                $scope.dropRole[i].dropSlug = $scope.dropRole[i].slug;
            }
            updateAreaDropdowns();
        }, function (error) {
            $scope.hasAccess = false;
            console.log(error);
        });

        apiService.post("user/readaccessibleareas", {mode: 'write'}).then(function (data) {
            areasArr = data;
            updateAreaDropdowns();
        }, function (error) {
            console.log(error);
        });

        $scope.$watch('states.dropSelected', function(newValue, oldValue) {
            $scope.model.states = [].concat(newValue).concat($scope.states.locked);
        });
    };

    $scope.setLocationAdress = function () {
        for (var i = 0; i < $scope.dropLocation.length; i++) {
            if($scope.dropLocation[i].id == $scope.model.location) {
                $scope.model.street = $scope.dropLocation[i].street;
                $scope.model.telephone = $scope.dropLocation[i].telephone;
                $scope.model.postalcode = $scope.dropLocation[i].postalcode;
                $scope.model.city = $scope.dropLocation[i].city;
            }
        }
    };

    $scope.clearAdress = function () {

        $scope.model.street = "";
        $scope.model.telephone = "";
        $scope.model.postalcode = "";
        $scope.model.city = "";
        $scope.model.location = "";
    };

    $scope.updateRequired = function() {
        var model = $scope.model;


        model.location = $scope.initialModel.location;
        model.organisation = $scope.initialModel.organisation;
        model.states = $scope.initialModel.states;
        model.comment = $scope.initialModel.comment;

        var required = {};
        required.role_id = true;
        required.location = model.role_id == 6 || model.role_id == 5 || model.role_id == 4 || model.role_id == 9;
        required.organisation = model.role_id == 3;
        required.states = model.role_id == 2 || model.role_id == 8;
        required.street = true;
        required.postalcode = true;
        required.city = true;
        required.mobilephone = false;
        required.comment = false;

        $scope.required = required;
    };


    $scope.check = function () {

        if(!formService.check($scope.required, $scope.model)) {
            return false;
        }

        $scope.model.area = [];

        if($scope.model.location) {
            $scope.model.area.push({
                location_id: $scope.model.location
            });
        }

        if($scope.model.organisation) {
            $scope.model.area.push({
                organisation_id: $scope.model.organisation
            });
        }

        if($scope.model.states) {
            for(var i = 0; i < $scope.model.states.length; i++) {
                $scope.model.area.push({
                    state_id: $scope.model.states[i].id
                });
            }
        }
        return true;
    };

    function getSelectedRole() {
        if (!$scope.dropRole || !$scope.dropRole.find || !$scope.model || !$scope.model.role_id) {
            return null;
        }
        var roleId = parseInt($scope.model.role_id);
        var role = $scope.dropRole.find((item) => item.id === roleId);
        if (role === undefined) {
            return null;
        }
        return role;
    }

    $scope.showStates = function () {
        var role = getSelectedRole();
        if (role === null) {
            return false;
        }
        return role.slug === 'BUKO' || role.slug === 'REKO' || role.slug === 'KGA';
    }

    $scope.save = function() {
        $scope.errorAlert = undefined;
        $scope.saved = true;
        if($scope.isSaving) {
            return;
        }
        if(!$scope.check()) {//check needs to be run
            return;
        }
        $scope.isSaving = true;

        function onSuccess() {
            $scope.isSaving = false;
            $state.go("user.update", {"id": $stateParams.id});
        }
        function onError(error) {
            $scope.isSaving = false;

            if(error){
                if(error.i18n){
                    $scope.errorAlert = [{message: $filter('translate')(error.i18n)}];
                }else
                if(error.message){
                    if(typeof error.message === "string") {
                        $scope.errorAlert = [];
                        $scope.errorAlert.push({message: "Fehler"});
                    } else {
                        for (var property in error.message) {
                            if (error.message.hasOwnProperty(property)) {
                                for (var index in error.message[property]) {
                                    if (!$scope.errorAlert) {
                                        $scope.errorAlert = [];
                                    }
                                    $scope.errorAlert.push({message: error.message[property][index]});
                                }
                            }
                        }
                    }
                }
            }else{
                $scope.errorAlert = [{message: $filter('translate')('FORM_ERROR_SAVING')}];
            }
        }

        if($scope.edit) {
            userrolelocationService.updateRole($scope.model).then(onSuccess, onError);
        } else {
            userrolelocationService.createRole($scope.model).then(onSuccess, onError);
        }
    };
    $scope.init();
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:example
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('searchlocationSsh', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/user/userByRole/search/search.view.html' + "?v=" + window.version.tag,
        controller: 'searchLocationSshController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:searchLocationSshController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('searchLocationSshController', function ($scope,$rootScope, searchService) {
    
    $scope.init = function () {
        $scope.searchfield = null;
        delete $rootScope.search;
        delete $rootScope.filter;
    };

    $scope.clearFilter = function () {
        $scope.searchfield = null;
        $scope.showDetails = false;
        $scope.bSearch = false;
        $rootScope.search = {
            search: $scope.searchfield
        };
        $rootScope.filter = {};

        delete $rootScope.search;
        delete $rootScope.filter;
        searchService.closeCollapse('filter-collapse');
        $rootScope.$broadcast("locationUpdate", {bSearch: $scope.bSearch});
    };
    $scope.$on("sscClearFilter", function () {
        $scope.clearFilter();
    });

    $scope.search = function () {
        if ($scope.searchfield !== null || $scope.location_id !== null || $scope.region_id !== null) {
            $scope.bSearch = true;
            var search = {
                search: $scope.searchfield
            };

            var filter = [];

            $rootScope.search = search;
            $rootScope.filter = filter;
            $rootScope.$broadcast("locationUpdate", {bSearch: $scope.bSearch});
        }
    };
    
    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:newsbox
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('roleBox', function (userDetailService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/user/userByRole/roleBox/roleBox.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            userDetailService.rolesForUser().then(function (data) {
                    scope.roles = data.user_role_map;
                },
                function (error) {
                    console.log(error);
                });
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:trainer
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('trainer', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "trainerController",
        link: function (scope, element, attrs) {
            
            scope.title = $filter('translate')('TAB_TRAINER');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:trainerController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('trainerController', function ($scope, uiGridConstants, $rootScope, gridService, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "user/readviaroleslug?slug=TRAINER",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
            }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:2});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
    
     $scope.gridName = 'trainer';

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            name: 'id',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'lastname',
            displayName: 'Name',
            name: 'lastname',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" title="{{COL_FIELD}}" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'firstname',
            displayName: 'Vorname',
            name: 'firstname',
            visible: gridService.checkVisible('name',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'location',
            displayName: 'Standorte',
            name: 'location',
            visible: gridService.checkVisible('location',$scope.gridName),
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><span ng-repeat="location in row.entity.locations"><a ng-href="#" ui-sref="location.detail({id: location.id})">{{location.name}}</a><span ng-if="!$last">, </span></span></div>',
            enableSorting: false
        },
        {
            field: 'ssc_count',
            name: 'sscs',
            displayName: 'Stromspar-Checks',
            enableSorting: false,
            headerCellFilter: 'translate'
        },
        {
            field: 'ssc_count_nodate',
            name: 'withoutdata',
            visible: gridService.checkVisible('withoutdata',$scope.gridName),
            displayName: 'Davon ohne Termin',
            enableSorting: false,
            headerCellFilter: 'translate'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            visible: gridService.checkVisible('function',$scope.gridName),
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
                  if(sort[0] && sort[0].name){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].name;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
                
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.aktiv}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenuuser', function (tabmenuService, $stateParams, $filter, $compile, $timeout, userDetailService, $rootScope, searchCacheService) {

    var pageIndex = 0;
    var childScope;

    function updateGrids(data, scope) {

        scope.grids = [
            {
                name: "ssh",
                title: $filter('translate')('TAB_SSH'),
                permissionOnly: ['SSH', 'SSHPLUS', 'TRAINER', 'LOKO', 'EFB', 'REKO', 'BUKO', 'ADMIN'],
                data: data ? parseInt(data["SSH"]) : "?"
            },
            {
                name: "sshplus",
                title: $filter('translate')('TAB_SSH_PLUS'),
                permissionOnly: ['SSH', 'SSHPLUS', 'TRAINER', 'LOKO', 'EFB', 'REKO', 'BUKO', 'ADMIN'],
                data: data ? parseInt(data["SSHPLUS"]) : "?"
            },
            {
                name: "trainer",
                title: $filter('translate')('TAB_TRAINER'),
                permissionOnly: ['SSH', 'SSHPLUS', 'TRAINER', 'LOKO', 'EFB', 'REKO', 'BUKO', 'ADMIN'],
                data: data ? parseInt(data["TRAINER"]) : "?"
            },
            {
                name: "loko",
                title: $filter('translate')('TAB_LOKO'),
                permissionOnly: ['SSH', 'SSHPLUS', 'TRAINER', 'LOKO', 'EFB', 'REKO', 'BUKO', 'ADMIN'],
                data: data ? parseInt(data["LOKO"]) : "?"
            },
            {
                name: "efb",
                title: $filter('translate')('TAB_EFB'),
                permissionOnly: ['TRAINER', 'LOKO', 'EFB', 'REKO', 'BUKO', 'ADMIN'],
                data: data ? parseInt(data["EFB"]) : "?"
            },
            {
                name: "reko",
                title: $filter('translate')('TAB_REKO'),
                permissionOnly: ['TRAINER', 'LOKO', 'EFB', 'REKO', 'BUKO', 'ADMIN'],
                data: data ? parseInt(data["REKO"]) : "?"
            },
            {
                name: "buko",
                title: $filter('translate')('TAB_BUKO'),
                permissionOnly: ['EFB', 'REKO', 'BUKO', 'ADMIN'],
                data: data ? parseInt(data["BUKO"]) : "?"
            },
            {
                name: "kga",
                title: $filter('translate')('TAB_KGA'),
                permissionOnly: ['ADMIN'],
                data: data ? parseInt(data["KGA"]) : "?"
            },
            {
                name: "admin",
                title: $filter('translate')('TAB_ADMIN'),
                permissionOnly: ['ADMIN'],
                data: data ? parseInt(data["ADMIN"]) : "?"
            }
        ];
    }

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {
            var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "tabIndex");
            if ($stateParams.status) {
                scope.pageIndex = $stateParams.status;
            } else if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
                scope.pageIndex = cacheData;
            } else {
                scope.pageIndex = 0;
            }
            searchCacheService.setCacheData(searchCacheService.type.user, "tabIndex", scope.pageIndex, false);

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
                searchCacheService.unsetData(searchCacheService.type.user);
                searchCacheService.setCacheData(searchCacheService.type.user, "tabIndex", scope.pageIndex);
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                updateGrids(null, scope);

                /*
                 *
                 * @type .global.navigator.userAgent|String|window.navigator.userAgent
                 * Fix for setting default tab - different from state - on IE
                 */
                var ua = navigator.userAgent;
                /* @is_ie|boolean - check if IE is current browser
                 * MSIE used to detect old browsers and Trident used to newer ones
                 */
                var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
                if (is_ie && userDetailService.getHighestRole().slug === 'EFB') {
                    //if heighest Role, set default tab
                    scope.pageIndex = 2;
                }


                var html = tabmenuService.setTabs(scope.grids);
                var template = angular.element(html);
                var myEl = angular.element(document.querySelector('.tab-content'));
                if(childScope) {
                    childScope.$destroy();
                }
                myEl.empty();
                myEl.append(template);
                childScope = scope.$new();
                $compile(template)(childScope);


                $timeout(function () {
                    scope.bSearch = bSearch;
                    scope.searchCounts = "?";
                    tabmenuService.getTabCounts("user/count").then(function (data) {
                            scope.bSearch = bSearch;
                            if (bSearch) {
                                scope.tabCounts = 0;
                                angular.forEach(data, function (value) {
                                    scope.tabCounts += value;
                                });
                            }
                            scope.searchCounts = scope.tabCounts;
                            updateGrids(data, scope);
                        },
                        function (error) {
                            console.log(error);
                        });
                });
            };

            scope.$on("userUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function () {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
}); 

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:sshplus
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('sshplus', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "sshPlusController",
        link: function (scope, element, attrs) {
            
            scope.title = $filter('translate')('TAB_SSH_PLUS');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:sshplusController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('sshPlusController', function ($scope, uiGridConstants, $rootScope, gridService, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "user/readviaroleslug?slug=SSHPLUS",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:1});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
    
    $scope.gridName = 'sshplus';

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            name: 'id',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'lastname',
            displayName: 'Name',
            name: 'lastname',
            visible: gridService.checkVisible('name',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" title="{{COL_FIELD}}" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'firstname',
            displayName: 'Vorname',
            name: 'firstname',
            visible: gridService.checkVisible('name',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'email',
            displayName: 'E-Mail',
            name: 'email',
            headerCellFilter: 'translate',
            cellTooltip: true
        },
        {
            field: 'location',
            displayName: 'Standorte',
            name: 'location',
            visible: gridService.checkVisible('location',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><span ng-repeat="location in row.entity.locations"><a ng-href="#" ui-sref="location.detail({id: location.id})">{{location.name}}</a><span ng-if="!$last">, </span></span></div>',
            enableSorting: false
        },
        {
            field: 'ssc_count',
            name: 'sscs',
            displayName: 'Stromspar-Checks',
            enableSorting: false,
            headerCellFilter: 'translate'
        },
        {
            field: 'ssc_count_nodate',
            name: 'withoutdata',
            displayName: 'Davon ohne Termin',
            enableSorting: false,
            visible: gridService.checkVisible('withoutdata',$scope.gridName),
            headerCellFilter: 'translate'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            visible: gridService.checkVisible('function',$scope.gridName),
            enableSorting: false,
            enableHiding: false,
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
               
                 
                if(sort[0] && sort[0].name){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].name;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.aktiv}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:ssh
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('ssh', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "sshController",
        link: function (scope, element, attrs) {
            
            scope.title = $filter('translate')('TAB_SSH');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:sshController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('sshController', function ($scope, uiGridConstants, $rootScope, gridService, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "user/readviaroleslug?slug=SSH",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:0});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
    
    $scope.gridName = 'ssh';

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            name: 'id',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'lastname',
            displayName: 'Name',
            name: 'lastname',
            visible: gridService.checkVisible('lastname',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" title="{{COL_FIELD}}" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'firstname',
            displayName: 'Vorname',
            name: 'firstname',
            visible: gridService.checkVisible('name',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'email',
            displayName: 'E-Mail',
            name: 'email',
            headerCellFilter: 'translate',
            cellTooltip: true,
        },
        {
            field: 'location',
            displayName: 'Standorte',
            name: 'location',
            visible: gridService.checkVisible('location',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><span ng-repeat="location in row.entity.locations"><a ng-href="#" ui-sref="location.detail({id: location.id})">{{location.name}}</a><span ng-if="!$last">, </span></span></div>',
            enableSorting: false
        },
        {
            field: 'ssc_count',
            name: 'sscs',
            displayName: 'Stromspar-Checks',
            enableSorting: false,
            headerCellFilter: 'translate'
        },
        {
            field: 'ssc_count_nodate',
            name: 'ssc_count_nodate',
            displayName: 'Davon ohne Termin',
            enableSorting: false,
            visible: gridService.checkVisible('withoutdata',$scope.gridName),
            headerCellFilter: 'translate'
        },
        {
            field: 'avg_directhelp_price',
            name: 'ssh',
            displayName: 'SH Ø in €',
            enableSorting: false,
            visible: gridService.checkVisible('ssh',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD | decimal2currency}} €</div>'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            visible: gridService.checkVisible('function',$scope.gridName),
            enableSorting: false,
            enableHiding: false,
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
               
                 
                if(sort[0] && sort[0].name){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].name;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
                
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.aktiv}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:reko
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('reko', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "rekoController",
        link: function (scope, element, attrs) {
            
            scope.title = $filter('translate')('TAB_REKO');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:rekoController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('rekoController', function ($scope, uiGridConstants, $rootScope, gridService, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "user/readviaroleslug?slug=REKO",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:5});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
    
    $scope.gridName = 'reko';

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            name: 'id',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'lastname',
            displayName: 'Name',
            name: 'lastname',
            visible: gridService.checkVisible('name',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" title="{{COL_FIELD}}" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'firstname',
            displayName: 'Vorname',
            name: 'firstname',
            visible: gridService.checkVisible('name',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'email',
            displayName: 'E-Mail',
            name: 'email',
            headerCellFilter: 'translate'
        },
        {
            field: 'state',
            displayName: 'Bundesländer',
            name: 'state',
            visible: gridService.checkVisible('state',$scope.gridName),
            //cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="location.detail({id: row.entity.locationid})">{{COL_FIELD}}</a></div>'
            //cellTemplate: '<span ng-repeat="item in row.entity.user_role_area_map.location"><span ng-if="$index != 0">, </span><a ng-href="#" ui-sref="location.detail({id: item.id})" data-ng-bind="item.name"></a></span>',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><span ng-repeat="state in row.entity.states">{{ state.name}}<span ng-if="!$last">, </span></span></div>',
            enableSorting: false
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            visible: gridService.checkVisible('function',$scope.gridName),
            enableSorting: false,
            enableHiding: false,
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
               
                 
                if(sort[0] && sort[0].name){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].name;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.aktiv}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:loko
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('loko', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "lokoController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_LOKO_LONG');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:lokoController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('lokoController', function ($scope, uiGridConstants, $rootScope, gridService, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "user/readviaroleslug?slug=LOKO",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:3});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
    
    $scope.gridName = 'loko';
     

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            name: 'id',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'lastname',
            displayName: 'Name',
            name: 'lastname',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" title="{{COL_FIELD}}" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'firstname',
            displayName: 'Vorname',
            name: 'firstname',
            visible: gridService.checkVisible('name',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'location',
            displayName: 'Standorte',
            name: 'location',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><span ng-repeat="location in row.entity.locations"><a ng-href="#" ui-sref="location.detail({id: location.id})">{{location.name}}</a><span ng-if="!$last">, </span></span></div>',
            enableSorting: false
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            visible: gridService.checkVisible('function',$scope.gridName),
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
               
                 
                if(sort[0] && sort[0].name){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].name;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.aktiv}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:reko
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('kga', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "kgaController",
        link: function (scope, element, attrs) {
            
            scope.title = $filter('translate')('TAB_KGA');
        }
    };
}); 
"use strict";

angular.module('frontendApp').controller('kgaController', function ($scope, uiGridConstants, $rootScope, gridService, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "user/readviaroleslug?slug=KGA",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                $scope.data = data.data;
                if ($scope.api.data.search || $scope.api.data.filter) $rootScope.$broadcast('updateTabcount', {
                    count: data.total,
                    case: 5
                });
                $scope.gridOptions.totalItems = data.total;
            },
            function (error) {
                console.log(error);
            });
    };

    $scope.gridName = 'kga';

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            name: 'id',
            sort: {direction: uiGridConstants.ASC, priority: 1},
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'lastname',
            displayName: 'Name',
            name: 'lastname',
            visible: gridService.checkVisible('name', $scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" title="{{COL_FIELD}}" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'firstname',
            displayName: 'Vorname',
            name: 'firstname',
            visible: gridService.checkVisible('name', $scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'email',
            displayName: 'E-Mail',
            name: 'email',
            headerCellFilter: 'translate'
        },
        {
            field: 'state',
            displayName: 'Bundesländer',
            name: 'state',
            visible: gridService.checkVisible('state', $scope.gridName),
            //cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="location.detail({id: row.entity.locationid})">{{COL_FIELD}}</a></div>'
            //cellTemplate: '<span ng-repeat="item in row.entity.user_role_area_map.location"><span ng-if="$index != 0">, </span><a ng-href="#" ui-sref="location.detail({id: item.id})" data-ng-bind="item.name"></a></span>',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><span ng-repeat="state in row.entity.states">{{ state.name}}<span ng-if="!$last">, </span></span></div>',
            enableSorting: false
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            visible: gridService.checkVisible('function', $scope.gridName),
            enableSorting: false,
            enableHiding: false,
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            gridApi.core.on.sortChanged($scope, function (grid, sort) {


                if (sort[0] && sort[0].name) {
                    //1. Sorting setzen nach Feld und ORder
                    $scope.api.data.sort.column = sort[0].name;
                    $scope.api.data.sort.order = sort[0].sort.direction;
                    searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
                    //2.
                    gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                        $scope.data = data.data;
                    }, function (error) {
                        console.log(error);
                    });
                }
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.aktiv}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:efb
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('efb', function ( $filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "efbController",
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('TAB_EFB_LONG');
        }
    };
}); 

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:efbController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('efbController', function ($scope, uiGridConstants,$rootScope, gridService, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "user/readviaroleslug?slug=EFB",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:4});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
    
    
    $scope.gridName = 'efb';

    var columnDefs = [
        {
            field: 'id',
            name: 'id',
            displayName: 'ID',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'lastname',
            name: 'lastname',
            displayName: 'Name',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" title="{{COL_FIELD}}" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'firstname',
            displayName: 'Vorname',
            name: 'firstname',
            visible: gridService.checkVisible('name',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'organisation',
            name: 'organisation',
            displayName: 'Organisationen',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><span ng-repeat="organisation in row.entity.organisations"><a ng-href="#" ui-sref="location.organisation({id: organisation.id})">{{ organisation.name}}</a><span ng-if="!$last">, </span></span></div>',
            enableSorting: false
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
               
                 
                if(sort[0] && sort[0].name){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].name;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.aktiv}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('buko', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "bukoController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_BUKO_LONG');
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:bukoController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('bukoController', function ($scope, uiGridConstants, $rootScope, gridService, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "user/readviaroleslug?slug=BUKO",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:6});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
    
    $scope.gridName = 'buko';
      

    var columnDefs = [
        {
            field: 'id',
            name: 'id',
            displayName: 'ID',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            width: 100, 
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'lastname',
            name: 'lastname',
            displayName: 'Name',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" title="{{COL_FIELD}}" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'firstname',
            displayName: 'Vorname',
            name: 'firstname',
            visible: gridService.checkVisible('name',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
               
                 
                if(sort[0] && sort[0].name){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].name;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);

                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.aktiv}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('admin', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "adminController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_ADMIN');
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:adminController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('adminController', function ($scope, uiGridConstants, $rootScope, gridService, searchCacheService) {
    $scope.data = [];
    $scope.api = {
        route: "user/readviaroleslug?slug=ADMIN",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
        $scope.api.data = cacheData;
    }
    else {
        searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
    }
    
    $scope.gridName = 'admin';

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:7});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
      

    var columnDefs = [
        {
            field: 'id',
            name: 'id',
            displayName: 'ID',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            width: 100, 
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'lastname',
            name: 'lastname',
            displayName: 'Name',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" title="{{COL_FIELD}}" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'firstname',
            displayName: 'Vorname',
            name: 'firstname',
            visible: gridService.checkVisible('name',$scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="user.update({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="user.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
               
                 
                if(sort[0] && sort[0].field){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].field;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.user, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.aktiv}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
* @ngdoc directive
* @name global.directive:searchuser
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('searchemploymenttype', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/user/employmenttype/search/search.view.html' + "?v=" + window.version.tag,
        controller: 'searchEmploymenttypeController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:searchEmploymenttypeController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('searchEmploymenttypeController', function ($scope, $rootScope) {

    $scope.init = function () {
        $scope.searchfield = null;
        delete $rootScope.search;
        delete $rootScope.filter;
    };

    $scope.clearFilter = function () {
        $scope.searchfield = null;
        $scope.showDetails = false;
        $scope.bSearch = false;
        $rootScope.search = {
            search: $scope.searchfield
        };
        $rootScope.filter = {};

        delete $rootScope.search;
        delete $rootScope.filter;
        $rootScope.$broadcast("employmenttypeUpdate", {bSearch: $scope.bSearch});
    };
    $scope.$on("sscClearFilter", function () {
        $scope.clearFilter();
    });

    $scope.search = function () {
        if ($scope.searchfield !== null) {
            $scope.bSearch = true;
            var search = {
                search: $scope.searchfield
            };

            var filter = [];

            $rootScope.search = search;
            $rootScope.filter = filter;
            $rootScope.$broadcast("employmenttypeUpdate", {bSearch: $scope.bSearch});
        }
    };

    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:employmenttypeCreateService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('employmenttypeCreateService', function (apiService) {

    var service = {};

    service.readEmploymenttype = function (id) {
        return apiService.post("employmenttype/read", {id: id});
    };

    service.createEmploymenttype = function (data) {
        return apiService.post("employmenttype/create", data);
    };

    service.updateEmploymenttype = function (data) {
        return apiService.post("employmenttype/update", data);
    };

    service.deleteEmploymenttype = function (data) {
        return apiService.post("employmenttype/delete", data);
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:employmenttypeCreate
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('employmenttypeCreate', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/user/employmenttype/employmenttypeCreate/employmenttypeCreate.view.html' + "?v=" + window.version.tag,
        controller: 'employmenttypeCreateController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:employmenttypeCreateController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('employmenttypeCreateController', function ($scope, $state, $filter, $stateParams, formService, employmenttypeCreateService) {

    $scope.init = function () {
        $scope.isSaving = false;
        if($state.current.name.indexOf('user.employmenttype.create') !== -1 ) {
            $scope.edit = false;
        } else {
            $scope.edit = true;
            employmenttypeCreateService.readEmploymenttype($stateParams.id).then(function (data) {
                $scope.model = data;
                $scope.name = data.name;
            }, function (error) {
                console.log(error);
            });
        }
            
        $scope.required = {
            name: true
        };

        $scope.saved = false;
    };
    
    $scope.check = function () {
        return formService.check($scope.required, $scope.model);
    };

    $scope.save = function () {

        $scope.saved = true;
        $scope.errorAlert = undefined;
        if($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            employmenttypeCreateService.createEmploymenttype($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("user.employmenttype");
            }, function (error) {
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        }
    };

    $scope.update = function () {

        $scope.saved = true;
        $scope.errorAlert = undefined;
        if($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            employmenttypeCreateService.updateEmploymenttype($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("user.employmenttype");
            }, function (error) {
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        }
    };

    $scope.delete = function () {

        $scope.saved = true;
        $scope.errorAlert = undefined;
        if($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            employmenttypeCreateService.deleteEmploymenttype($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("user.employmenttype");
            }, function (error) {
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        }
    };

    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:legend
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('legend', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: false,
        templateUrl: 'templates/components/content/stromsparcheck/tile/legend/legend.view.html' + "?v=" + window.version.tag
    };
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenussc', function (tabmenuService, $stateParams, $filter, $compile, $rootScope, searchCacheService) {

    var childScope;

    function updateGrids(data, scope) {
        scope.grids = [
            {
                name: "nodate",
                title: $filter('translate')('TAB_DATENO'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data: data ? parseInt(data["NO_VISIT"]) : "?"

            },
            {
                name: "appointment",
                title: $filter('translate')('SSC_TITLE_APPOINTMENT'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data:  data ? parseInt(data["VISIT_SCHEDULED"]) : "?"
            },
            {
                name: "data",
                title: $filter('translate')('TAB_DATAENTRY'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data:  data ? parseInt(data["DATA_ENTRY"]) : "?"
            },
            {
                name: "proof",
                title: $filter('translate')('TAB_PROOF'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data: data ? parseInt(data["CHECK"]) : "?"
            },
            {
                name: "control",
                title: $filter('translate')('TAB_CONTROL'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data: data ? parseInt(data["FOLLOW_UP"]) : "?"
            },
            {
                name: "secondvisit",
                title: $filter('translate')('SSC_TITLE_SECONDVISIT'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data: data ? parseInt(data["SECOND_VISIT_CLEARANCE"]) : "?"
            },
            {
                name: "monitoring_data",
                title: $filter('translate')('TAB_MONITORING_DATAENTRY'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data:  data ? parseInt(data["MONTIORING_ENTRY"]) : "?"
            },
            {
                name: "monitoring_proof",
                title: $filter('translate')('TAB_MONITORING_PROOF'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data:  data ? parseInt(data["MONTIORING_CHECK"]) : "?"
            },
            {
                name: "monitoring_control",
                title: $filter('translate')('TAB_MONITORING_CONTROL'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data:  data ? + parseInt(data["MONTIORING_FOLLOW_UP"]) : "?"
            },
            {
                name: "closed",
                title: $filter('translate')('TAB_CLOSED'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data:  data ? parseInt(data["COMPLETED"]) : "?"
            },
            {
                name: "monitoring",
                title: $filter('translate')('TAB_MONITORING'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data:  data ? parseInt(data["MONTIORING_COMPLETED"]) : "?"
            },
            {
                name: "none",
                title: $filter('translate')('TAB_NORESULT'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB'],
                data:  data ? parseInt(data["MONTIORING_COMPLETED_CANCELED_EVALUATION"]) : "?"
            },
            {
                name: "all",
                title: $filter('translate')('TAB_ALL'),
                permissionOnly: ['ADMIN', 'LOKO', 'SSH', 'SSHPLUS', 'TRAINER', 'BUKO', 'EFB', 'KGA'],
                data:  data ? parseInt(data["ALL"]) : "?"
            }
        ];
    }


    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {
            var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.ssc, "tabIndex");
            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.ssc))
                scope.pageIndex = cacheData;
            else
                scope.pageIndex = 0;
            searchCacheService.setCacheData(searchCacheService.type.ssc, "tabIndex", scope.pageIndex, false);

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
                searchCacheService.unsetData(searchCacheService.type.ssc);
                searchCacheService.setCacheData(searchCacheService.type.ssc, "tabIndex", scope.pageIndex);
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                updateGrids(null, scope);
                var html = tabmenuService.setTabs(scope.grids);
                var template = angular.element(html);
                var myEl = angular.element(document.querySelector('.tab-content'));
                if(childScope) {
                    childScope.$destroy();
                }
                myEl.empty();
                myEl.append(template);
                childScope = scope.$new();
                $compile(template)(childScope);

                tabmenuService.getTabCounts("checks/ssc/count").then(function (data) {
                        scope.bSearch = bSearch;
                        scope.searchCounts = data["ALL"];
                        updateGrids(data, scope);
                        tabmenuService.setTabs(scope.grids);
                    },
                    function (error) {
                        console.log(error);
                    });
            };

            scope.$on("sscUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
}); 

"use strict";
/**
* @ngdoc directive
* @name global.directive:seceondvisit
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('secondvisit', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'secondVisitSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_SECONDVISIT');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:secondVisitSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('secondVisitSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [9]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:proof
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('proof', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'proofSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_PROOF');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:proofSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('proofSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [3]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:appointment
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('none', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'noneSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('TAB_NORESULT');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:noneSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('noneSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [17]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:nodate
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('nodate', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'nodateSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_NODATE');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:nodateSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('nodateSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [1]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:proof
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('monitoringProof', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'monitoringProofSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_PROOF');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:proofSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('monitoringProofSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [11]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:data
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('monitoringData', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'monitoringDataSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_DATA');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:dataSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('monitoringDataSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [10]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:control
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('monitoringControl', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'monitoringControlSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_CONTROL');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controlSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('monitoringControlSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [12]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:monitoring
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('monitoring', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'monitoringSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_MONITORING');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:monitoringSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('monitoringSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [7]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:data
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('data', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'dataSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_DATA');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:dataSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('dataSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [2]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:control
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('control', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'controlSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_CONTROL');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controlSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('controlSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [4]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:closed
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('closed', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'closedSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_CLOSED');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:closedSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('closedSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [5]);
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:appointment
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('appointment', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'appointmentSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('TAB_APPOINTMENT');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:appointmentSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('appointmentSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, [8]);
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:closed
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('all', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'allSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('TAB_ALL');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:closedSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('allSSCController', function ($scope, sscOverviewService) {
    sscOverviewService.initTabContents($scope, -1);
});
"use strict";

/*
works closely together with check/monitoring page controller
-> uses its save method, and accesses content and properties

<ssc-input
    data-type="input" //input | label | select | toggle
    data-field="monitoring_lighting.{{$index}}.lighting_current_saving"
    data-label="MONITORING_DH_LIGHTING_CURRENT_SAVING"
    data-unit="kWh/a" //optional if unit to be displayed
    data-page="formPageScope" //scope of the page controller (that has the save function, content, properties)
    data-help="TIP_MONITORING_DH_LIGHTING_CURRENT_BULB_COUNT"
>
</ssc-input>


Needs in page:
- dataTimestamp
- save($scope.record, $scope.tableField, $scope.field)


*/

angular.module('frontendApp').directive('sscInput', function () {

    function updateView($scope) {
        var path = $scope.field.split(".");
        var record = $scope.page.content;
        var properties = $scope.page.properties;
        for(var i = 0; i < path.length - 1; i++) {
            if(!record || !properties) {
                $scope.dataError = true;
                return;
            }
            record = record[path[i]];
            properties = properties[path[i]];
        }
        $scope.record = record;
        $scope.properties = properties;

        $scope.isDisabled = !!($scope.disabled);
        $scope.isRequired = false;

        if($scope.type === "toggle" && ($scope.record[$scope.column] === null || $scope.record[$scope.column] === undefined)) {
            $scope.record[$scope.column] = 0;
        }

        if(!properties) {
            return;
        }

        if($scope.properties[$scope.column]) {
            $scope.isDisabled = $scope.properties[$scope.column].disabled || $scope.disabled;
            $scope.isRequired = $scope.properties[$scope.column].required;
        }

        if($scope.displayfield) {
            $scope.displayValue = null;
            var displayPath = $scope.displayfield.split(".");
            if(typeof $scope.record === "object" && $scope.record.hasOwnProperty(displayPath[0]) && $scope.record[displayPath[0]]) {
                $scope.displayValue = $scope.record[displayPath[0]][displayPath[1]];
            }
        }
        $scope.dataError = false;
    }

    return {
        restrict: 'E',
        replace: true,
        scope: {
            page: "=", //scope of page controller
            label: "@", //text left of input
            labelHtml: "@",
            help: "@", //helptext content. an i18n name. e.g. SSC_REFRIGERATOR_PRODUCER
            field: "@", //path to field e.g.: ssc_refrigerator.5.producer_id
            displayfield: "@", //path within row object to what to be displayed. e.g. producer.name
            unit: "@", //unit right of input
            unitHtml: "@",
            disabled: "@", //true -> force disabled
            inverted: "@", //true -> invert value of toggle
            precision: "@",


            type: "@", // input | select | textarea | toggle | date | label

            //for input
            isText: "@", //is input text. by default it's a number

            //for select
            options: "=", //array - options for select; id is the value
            optionfield: "@", //which attribute in option to be displayed

            //for textarea


            //for toggle


            //for date
            datemodeltype: "@", //days | minutes | seconds
            dateformattype: "@" //days | minutes | seconds

            //for Label



            //debug: "@"
        },
        templateUrl: 'templates/components/content/stromsparcheck/form/sscInput/sscInput.view.html' + "?v=" + window.version.tag,
        link: function($scope) {
            $scope.$watch("page.dataTimestamp", function() {
                updateView($scope);
            })
        },
        controller: function($scope) {
            $scope.dataError = false;
            var path = $scope.field.split(".");
            $scope.column = path[path.length - 1];
            $scope.table = path[path.length - 2];
            if(!isNaN($scope.table)) {
                $scope.table = path[path.length - 3];
            }
            $scope.tableField = $scope.table + "." + $scope.column;

            $scope.inputUniqueId = "ssc_input_" + $scope.field;



            //only save if something changed
            var initVal;
            $scope.focus = function() {
                if(!$scope.dataError) {
                    initVal = $scope.record[$scope.column];
                }
            };
            $scope.save = function() {
                if(!$scope.dataError && initVal !== $scope.record[$scope.column]) {
                    $scope.page.save($scope.record, $scope.tableField, $scope.field);
                }
                initVal = undefined;
            };
            $scope.savedate = function(val) {
                if(val !== $scope.record[$scope.column]) {
                    $scope.record[$scope.column] = val;
                    $scope.page.save($scope.record, $scope.tableField, $scope.field);
                }

            };

            $scope.convertModelFormat = function(format) {
                if(format === "days") {
                    return "API_DAY";
                }
                if(format === "minutes") {
                    return "API_MINUTE";
                }
                if(format === "seconds") {
                    return "API_SECOND";
                }
            };
            $scope.convertViewFormat = function(format) {
                if(format === "days") {
                    return "DATEPICKER_DAY";
                }
                if(format === "minutes") {
                    return "DATEPICKER_MINUTE";
                }
            };
        }
    };
});
"use strict";


//TODO
/*
if model oder properties changes -> update

if change from input field -> trigger onchange

*/
angular.module('frontendApp').directive('sscHouselocation', function () {
/*
    function updateView($scope) {
        //break up into pieces
        $scope.boxes = Array.from($scope.houselocationModel);
    }

    function inputChanged($scope, $ngModel) {
        //parse
        $scope.houselocationModel = $scope.boxes.join("");

        //write model
        $ngModel.$setViewValue($scope.houselocationModel);

        //exec onchange
        $scope.houselocationOnchange();
    }

    return {
        restrict: 'E',
        replace: true,
        scope: {
            houselocationModel: "=",
            houselocationOnchange: "&",
            houselocationProperties: "="
        },
        templateUrl: 'templates/components/content/stromsparcheck/form/sscHouselocation/sscHouselocation.view.html' + "?v=" + window.version.tag,
        link: function($scope, $element, $attrs, $ngModel) {
            $scope.$watch("houselocationModel", function() {
                updateView($scope);
            })
        },
        controller: function($scope) {
            $scope.boxes = [];
            updateView($scope);
        }

    };*/
});
"use strict";
angular.module('frontendApp').directive('sscHeatingTool', function () {
	return {
		restrict: 'E',
		replace: true,
		scope: {
			table: "@",
			tileSlug: "@",
			routePrefix: "@",
		},
		templateUrl: 'templates/components/content/stromsparcheck/form/sscHeatingTool/sscHeatingTool.view.html' + "?v=" + window.version.tag,
		controller: 'sscHeatingToolController'
	};
});
"use strict";
angular.module('frontendApp').controller('sscHeatingToolController', function ($scope, stromsparcheckService, $stateParams, formService, $timeout, $rootScope, ngDialog, $q, sscErrorboxService) {
	$scope.content = {};
	$scope.content[$scope.table] = {};
	$scope.properties = {};
	$scope.formscope = $scope;
	$scope.memory;
	$scope.savingRooms = false;

	$scope.calculateFuelPart = function () {
		if ($scope.content[$scope.table].fuel_total_kwh_from_bill) {
			$scope.content[$scope.table].building_hw_fuel_bill = $scope.content[$scope.table].building_hw_fuel_bill_pct * 0.01 * $scope.content[$scope.table].fuel_total_kwh_from_bill;
			$scope.saveWrapper('content.'+$scope.table+'.building_hw_fuel_bill');
		}
	};

	$scope.copyErrors = function (field, target) {
		if (!$scope.properties || !$scope.properties[$scope.table] || field === "bill_heating_begin" || field === "bill_heating_end" || field === "bill_usage_begin" || field === "bill_usage_end") {
			return false;
		}

		var errorflag = false;

		for (var key in $scope.properties[$scope.table]) {
			if ($scope.properties[$scope.table][key] && ($scope.properties[$scope.table][key].error || $scope.properties[$scope.table][key].warning)) {
				if (field !== key) {
					target.properties[$scope.table][key] = $scope.properties[$scope.table][key];
					target.content[$scope.table][key] = $scope.content[$scope.table][key];

					errorflag = true;
				}
			}
		}

		return errorflag;
	};

	$scope.read = function () {
		stromsparcheckService.read($stateParams.id, $scope.tileSlug).then(function (data) {
			$scope.update(data);
			$scope.sign();

		}, function (error) {
			console.log(error);
		});
	};

	function doSave(update) {
		var deferred = $q.defer();
		stromsparcheckService.saveValue(update).then(function (data) {
			//data
			$scope.update(data);
			deferred.resolve();
		}, function (error) {
			console.log('Speichern fehlgeschlagen: ' + error);
			$scope.update(error.data);
			deferred.reject(error);
		});
		return deferred.promise;
	}

	$scope.update = function (data) {
		$scope.content = data.content;
		$scope.memory = {
			content: JSON.parse(JSON.stringify(data.content))
		};

		// required fields
		$scope.properties = data.properties;
		$scope.tableProperties = data.tableProperties;
		updateErrors();
		$rootScope.$broadcast("errorUpdate", data.properties);
	}

	function updateErrors() {
		var structure = {
			heating_tool: {
				path: $scope.table
			},
			rooms: {
				path: "ssc_heating_tool_room[]"
			}
		};
		$scope.errors = sscErrorboxService.createErrorObject(structure, $scope.properties);
	}

	$scope.roomsAvailable = () => $scope.table === 'ssc_heating_tool';

	$scope.addRoom = function () {
		$scope.savingRooms = true;
		var update = {
			route: $scope.routePrefix + '/' + $scope.table.replaceAll('_', '') + 'room/update',
			ssc_heating_tool_id: $scope.content[$scope.table].id,
			ssc_id: $stateParams.id,
			ssc_tile_page: $scope.tileSlug
		};
		doSave(update).finally(() => $scope.savingRooms = false);
	};

	$scope.delete = function (route, index, id) {
		$scope.savingRooms = true;
		stromsparcheckService.delete(route, index, id, $scope.tileSlug).then(function(data) {
			if(!data) {
				return; //cancelled
			}
			$scope.update(data);
		}, function(error) {
			$scope.update(error.data);
		}).finally(() => $scope.savingRooms = false);
	};

	$scope.save = function (data, tableField) {
		var fieldParts = tableField.split('.');

		var update = {
			route: $scope.routePrefix + '/' + fieldParts[0].replaceAll('_', '') + '/update',
			ssc_id: $stateParams.id,
			ssc_tile_page: $scope.tileSlug,
			id: data.id
		};
		update[fieldParts[1]] = data[fieldParts[1]];
		doSave(update);
	};

	$scope.saveWrapper = function (modelStr) {
		$scope.saveEvent({
			target: {
				attributes: [
					{name: 'ng-model', nodeValue: modelStr}]
			}
		});
	};
	$scope.saveEvent = function (event, forcePath) {
		forcePath = forcePath || false;
		var datafield,
			split,
			value,
			oldValue,
			keyname,
			update = {
				route: $scope.routePrefix + '/' + $scope.table.replaceAll('_', '') + '/update',
				id: $scope.content[$scope.table].id,
				ssc_id: $stateParams.id,
				ssc_tile_page: $scope.tileSlug
			};

		if (!forcePath) {
			if (!event || !event.target || !event.target.attributes) {
				console.log("error: ng-model not found.");
				return;
			}

			for (var i = 0; i < event.target.attributes.length; i++) {
				if (event.target.attributes[i].name === 'ng-model') {
					datafield = event.target.attributes[i].nodeValue.replace("[table]", "."+$scope.table);
					break;
				}
			}
			if (!datafield) {
				console.log("error: attr ng-model not found.");
				return;
			}

			split = datafield.split('.');
			keyname = split[split.length - 1];

			/*not ECMAScript syntax, will not work in IE*/
//            value=split.reduce((o,i)=>o[i], $scope);

			if ($scope.memory) {
				oldValue = split.reduce(function (o, i) {
					if (o) {
						return o[i];
					}
				}, $scope.memory);
			}

			value = split.reduce(function (o, i) {
				if (o) {
					return o[i];
				}
			}, $scope);
			update[keyname] = value;
		} else {
			split = forcePath.split('.');
			keyname = split[split.length - 1];
			value = split.reduce(function (o, i) {
				if (o) {
					return o[i];
				}
			}, $scope);

			if ($scope.memory) {
				oldValue = split.reduce(function (o, i) {
					if (o) {
						return o[i];
					}
				}, $scope.memory);
			}

			//forced
			update[keyname] = value;
		}

		//check 4 changes
		if (oldValue !== value || (!oldValue && !value)) {
			stromsparcheckService.saveValue(update).then(function (data) {
				var errorflag = $scope.copyErrors(keyname, data);
				if (errorflag) {
					$(document).ready(function () {
						$rootScope.$broadcast("errorUpdate", data.properties);
					});
				}

				$scope.update(data);

				$scope.drawnTacho($scope.content[$scope.table].stat_building_fuel_index, $scope.content[$scope.table].stat_flat_fuel_index);
			}, function (error) {
				console.log('Speichern fehlgeschlagen: ' + error);

				var errorflag = $scope.copyErrors(keyname, error.data);
				if (errorflag) {
					$(document).ready(function () {
						$rootScope.$broadcast("errorUpdate", error.data.properties);
					});
				}

				// required fields
				$scope.properties = error.data.properties;
				$scope.tableProperties = error.data.tableProperties;

				updateErrors();

				$scope.drawnTacho($scope.content[$scope.table].stat_building_fuel_index, $scope.content[$scope.table].stat_flat_fuel_index);
			});
		}
	};

	$scope.tachoCss = {
		tachotop: {left: "0px", display: 'none'},
		tachobottom: {left: "0px", display: 'none'},
		headlinetop: {left: "-31px"},
		headlinebottom: {left: "-31px"}
	};


	$scope.drawnTacho = function (kennzGeb, kennzWohn) {
		var highestlimit = 0;

		stromsparcheckService.readTachoHeatTool('checks/ssctacho/readheattool', kennzWohn).then(function (data) {
			highestlimit = data.limitHighest;
			$scope.tachoLableCss = [];

			var fontweight, lablePerc;
			angular.forEach(data.limitsBandLable, function (limit) {
				fontweight = "normal";
				if (limit.limit_id === data.limitId) {
					fontweight = "bold";
				}

				if (limit.limit_id !== 9) {
					var perc = limit.to / highestlimit * 100;
					lablePerc = (((limit.to / highestlimit * 100) - (limit.from / highestlimit * 100)) / 2) + (limit.from / highestlimit * 100) - 1;
					$scope.tachoLableCss.push(
						{
							id: limit.limit_id,
							lineCss: {left: perc + "%", 'font-weight': 'bold'},
							lableCss: {left: lablePerc + "%", 'font-weight': fontweight},
							lable: limit.lable
						});
				}
				if (limit.limit_id === 9) {
					lablePerc = ((100 - (limit.from / highestlimit * 100)) / 2) + (limit.from / highestlimit * 100) - 1;
					$scope.tachoLableCss.push(
						{
							id: limit.limit_id,
							lineCss: {left: "0%", display: 'none'},
							lableCss: {left: lablePerc + "%", 'font-weight': fontweight},
							lable: limit.lable
						});
				}
			});
		}, function (error) {
			console.log(error);
		});


		if (kennzGeb === null) {
			kennzGeb = 0;
		}

		if (kennzWohn === null) {
			kennzWohn = 0;
		}


		//get image size
		var img = document.getElementById('tacho_image');

		var imgpath = new Image();
		imgpath.src = img.src;
		imgpath.onload = function () {//fix rendering update #1

			//calc pos
			var gebPosPerc = kennzGeb / 250 * 100;
			var wohnPosPerc = kennzWohn / 250 * 100;
			//text anti overflow
			if (kennzGeb < 14) {
				$scope.tachoCss.headlinetop = {left: 0};
			} else {
				$scope.tachoCss.headlinetop = {left: "-31px"};
			}
			if (kennzWohn < 14) {
				$scope.tachoCss.headlinebottom = {left: 0};
			} else {
				$scope.tachoCss.headlinebottom = {left: "-31px"};
			}

			if (gebPosPerc > 98) {
				gebPosPerc = 98;
			}
			if (wohnPosPerc > 98) {
				wohnPosPerc = 98;
			}


			if (gebPosPerc > 0) {
				$scope.tachoCss.visible = true;
				$scope.tachoCss.visible = true;
			}

			if (gebPosPerc === 0) {
				$scope.tachoCss.visible = false;
			}

			//set pos
			$timeout(function () {//fix rendering update #2
				$scope.tachoCss.tachotop = {left: gebPosPerc + "%", display: 'block'};
				$scope.tachoCss.tachobottom = {left: wohnPosPerc + "%", display: 'block'};
			});
		};
	};

	$scope.sign = function () {
		if ($scope.content) {
			if ($scope.content.stat_heating_avg > 0) {
				$scope.content.stat_heating_avg = '+' + $scope.content.stat_heating_avg;
			}
			if ($scope.content.stat_hw_avg > 0) {
				$scope.content.stat_hw_avg = '+' + $scope.content.stat_hw_avg;
			}
			if ($scope.content.stat_flat_fuel_avg > 0) {
				$scope.content.stat_flat_fuel_avg = '+' + $scope.content.stat_flat_fuel_avg;
			}
		}
	};

	$scope.showHeatingCostCalculation = function () {
		return !($scope.content[$scope.table] && $scope.content[$scope.table].usage_degree_days !== null && $scope.content[$scope.table].usage_degree_days < 500);

	};

	$scope.ready = function (tile) {
		stromsparcheckService.ready($stateParams.id, tile).then(function (data) {
			ngDialog.open({
				template: 'templates/landingpage/ready_success.html' + "?v=" + window.version.tag,
				className: 'dialogLanding',
				showClose: false
			});

		}, function (error) {
			console.log('Speichern fehlgeschlagen: ' + error);
		});

	};
	$scope.read();
});
"use strict";


angular.module('frontendApp').directive('sscDeleteButton', function () {

    return {
        restrict: 'E',
        replace: true,
        scope: {
            deleteEnabled: "=",
            deleteOnclick: "&",
            deleteClass: "@"
        },
        templateUrl: 'templates/components/content/stromsparcheck/form/sscDeleteButton/sscDeleteButton.view.html' + "?v=" + window.version.tag
    };
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service.sscAdviceService
 * @scope
 * @restrict E
 *
 * @description
 * Service to get, edit and delete advices in a check
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('sscAdviceService', function ($http, api, $q, apiService) {
	var service = {};

	var loadedData = null;
	var deferred = null;

	service.getOptions = function () {

		if (loadedData !== null) {
			var d = $q.defer();
			d.resolve(loadedData.data);
			return d.promise;
		}

		if (deferred === null) {
			deferred = $q.defer();

			$http.post(api.root + "advice/read")
				.success(function (data, status) {
					loadedData = data;
					deferred.resolve(loadedData.data);
				})
				.error(function (error) {
					deferred.reject(error);
				});
		}

		return deferred.promise;
	};

	service.addAdvice = function (sscId, tileSlug, type, adviceId, referenceId) {
		var data = {
			ssc_id: sscId,
			advice_id: adviceId,
			ssc_tile_page: tileSlug,
			adviceable_id: referenceId,
			type: type
};
		return apiService.post("checks/advice/create", data);
	};

	service.updateAdvice = function (tileSlug, advice, field) {
		var data = {
			id: advice.id,
			ssc_tile_page: tileSlug,
		};
		if (advice.hasOwnProperty(field)) {
			data[field] = advice[field];
		}
		return apiService.post("checks/advice/update", data);
	};

	service.getAdvices = function (sscId) {
		return apiService.post("checks/advice/create", {ssc_id: sscId});
	};

	return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:sscAdvice
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('sscAdvice', function () {
	return {
		restrict: 'E',
		replace: true,
		scope: {
			type: "@",
			tileSlug: "=",
			advices: "=",
			options: "=?",
			referenceId: "=?",
			tableProperties: "=",
			showTopTips: "@?",
			showSource: "@?",
			freeTextLabel: "@?",
			freeTextDescriptionLabel: "@?",
			freeTextHideTitle: "@?",
			useDefaultTexts: "@?"
		},
		templateUrl: 'templates/components/content/stromsparcheck/form/sscAdvice/sscAdvice.view.html' + "?v=" + window.version.tag,
		controller: 'sscAdviceController'
	};
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:sscAdviceController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('sscAdviceController', function ($scope, $rootScope, sscAdviceService, $stateParams, stromsparcheckService, $filter, apiService) {

    const TYPE_ADVICE = "advice";
    const TYPE_EXPLANATION = "explanation";
    const TYPE_PRAISE = "praise";

    $scope.openCategoryId = null;

    $scope.templatesVisible = false;

    $scope.addButtonEnabled = true;

    $scope.optionsDefault = [];

    $scope.isSaving = false;

    $scope.sscGeneral = null;

    if ([TYPE_ADVICE, TYPE_EXPLANATION, TYPE_PRAISE].indexOf($scope.type) === -1) {
        throw new Error('Wrong type "' + $scope.type + '" in sscAdvice!');
    }

    // init advice options
    sscAdviceService.getOptions().then(function (data) {
        $scope.optionsDefault = data;
    });

    apiService.post('checks/sscgeneral/read', {ssc_id: $stateParams.id}).then(function (data) {
        $scope.sscGeneral = data;
    });

    $scope.getOptions = function () {
        let options = $scope.options ? $scope.options : $scope.optionsDefault;
        console.log('sscAdviceController.sscGeneral', $scope.sscGeneral);
        if (!!$scope.sscGeneral) {
            let allowedAidMoneyTypes = ['rent_aid', 'student_loan', 'childcare'];
            if ($scope.sscGeneral.ssc_aid_money_type === null || allowedAidMoneyTypes.indexOf($scope.sscGeneral.ssc_aid_money_type.slug) === -1) {
                return options.map(function (category) {
                    category.themes = category.themes.map(function (theme) {
                        theme.advices = theme.advices.filter(function (advice) {
                            return advice.shortcut !== 'HuL15';
                        });
                        return theme;
                    });
                    return category;
                });
            }
        }
        return options;
    };

    $scope.addAdvice = function (advice) {
        $scope.hideTemplates();
        $scope.isSaving = true;
        var adviceId = null;
        if (advice && advice.hasOwnProperty("id")) {
            adviceId = advice.id;
        }
        handleResponse(sscAdviceService.addAdvice($stateParams.id, $scope.tileSlug, $scope.type, adviceId, $scope.referenceId));
    };
    $scope.updateAdvice = function (advice, field) {
        $scope.isSaving = true;
        handleResponse(sscAdviceService.updateAdvice($scope.tileSlug, advice, field));
    };
    $scope.deleteAdvice = function (adviceId) {
        $scope.isSaving = true;
        handleResponse(stromsparcheckService.delete("advice", null, adviceId, $scope.tileSlug));
    };

    function handleResponse(referrer) {
        referrer.then(
            function (data) {
                $scope.isSaving = false;
                $rootScope.$broadcast("sscAdviceSave", data.content);
            }, function (error) {
                $scope.isSaving = false;
                if (error.data && error.data.content) {
                    $rootScope.$broadcast("sscAdviceSave", error.data.content);
                }
            }
        );
    }

    $scope.showTemplates = function () {
        $scope.openCategoryId = null;
        $scope.templatesVisible = true;
    };
    $scope.hideTemplates = function () {
        $scope.templatesVisible = false;
    };
    $scope.toggleCategory = function (category) {
        if (category.hasOwnProperty("id")) {
            if ($scope.openCategoryId === category.id) {
                $scope.openCategoryId = null;
            } else {
                $scope.openCategoryId = category.id;
            }
        }
    };
    $scope.isCategoryVisible = function (category) {
        return category.hasOwnProperty("id") && $scope.openCategoryId === category.id;
    };
    $scope.getHeaderText = function (advice) {
        switch ($scope.getType(advice)) {
            case TYPE_EXPLANATION:
                return $filter('translate')("SSC_ADVICE_HEADER_EXPLANATION");
            case TYPE_PRAISE:
                return $filter('translate')("SSC_ADVICE_HEADER_PRAISE");
            default:
                return $filter('translate')("SSC_ADVICE_HEADER")
        }
    };
    $scope.getType = function (advice) {
        var type = $scope.type;
        if (advice && advice.hasOwnProperty("type")) {
            type = advice.type
        }
        return type;
    };
    $scope.isExplanation = function (advice) {
        return $scope.getType(advice) === TYPE_EXPLANATION;
    };
    $scope.isAdvice = function (advice) {
        return $scope.getType(advice) === TYPE_ADVICE;
    }
    $scope.isPraise = function (advice) {
        return $scope.getType(advice) === TYPE_PRAISE;
    }
    $scope.showDefaultTextFields = function (advice) {
        return $scope.useDefaultTexts && advice.advice_id !== null;
    }
    $scope.showTitle = function (advice) {
        return (!$scope.freeTextHideTitle || advice.advice_id !== null) && ($scope.isAdvice(advice) || $scope.isPraise(advice));
    }
});
"use strict";


angular.module('frontendApp').directive('sscAddButton', function () {

    return {
        restrict: 'E',
        replace: true,
        scope: {
            addIsSaving: "=",
            addOnclick: "&",
            addLabel: "@",
            addEnabled: "="
        },
        templateUrl: 'templates/components/content/stromsparcheck/form/sscAddButton/sscAddButton.view.html' + "?v=" + window.version.tag
    };
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenudeletionrequests', function (tabmenuService, $stateParams, $filter, $compile) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {                
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                tabmenuService.getTabCounts("checks/countDeletionRequests").then(function (data) {
                    scope.bSearch = bSearch;
                    scope.tabCounts = data;
                    
                    scope.grids = [
                        {
                            name: "deletionrequests",
                            title: $filter('translate')('TAB_ALL'),
                            permissionOnly: ['ADMIN'],
                            data: scope.tabCounts ? scope.tabCounts : 0
                        }
                    ];
                    
                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.empty();
                    myEl.append(template);                    
                    $compile(template)(scope);
                },
                function (error) {
                    console.log(error);
                });
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
}); 

"use strict";
/**
* @ngdoc directive
* @name global.directive:closed
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('deletionrequests', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'DeletionRequestsSSCController',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('TAB_ALL');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:closedSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('DeletionRequestsSSCController', function ($scope, gridService, $filter, $rootScope, ngDialog, stromsparcheckService, localStorageService, formService, moment) {


    $scope.data = [];
    $scope.api = {
        route: "checks/readDeletionRequests",
        data: {
            status: -1,
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            //filter: $rootScope.filter,
            //search: $rootScope.search
        }
    };

    var cols = ['first_visit_at', 'second_visit_at', 'created_at'];
    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {

            for(var i in data.data) { //convert to local timezone
                data.data[i].created_at = moment.utc(data.data[i].created_at).local().format("YYYY-MM-DD HH:mm:ss");
            }

            $scope.data = formService.formatGrid(data.data, cols);
            if ($scope.api.data.search || $scope.api.data.filter)
                $rootScope.$broadcast('updateTabcount');
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };

    $scope.isAdmin = function () {
        var user = localStorageService.get('user');
        for (var i = 0; i < user.user_role.length; i++) {
            if (user.user_role[i].slug === 'ADMIN') {
                return true;
            }
        }
        return false;
    };

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            width: "80",
            enableFiltering: false
        },
        {
            field: 'name',
            displayName: $filter('translate')('SSC_COL_NAME'),
            headerCellFilter: 'translate',
            enableFiltering: true,
            cellTooltip: true
        },
        {
            field: 'city',
            displayName: $filter('translate')('SSC_COL_ADDRESS'),
            headerCellFilter: 'translate',
            enableFiltering: false
        },
        {
            field: 'created_at',
            width: "100",
            displayName: $filter('translate')('SSC_COL_CREATED'),
            headerCellFilter: 'translate',
            enableFiltering: true
        },
        /*{
            field: 'first_visit_at',
            displayName: $filter('translate')('SSC_COL_FIRSTDATE'),
            headerCellFilter: 'translate',
            enableFiltering: true
        },
        {
            field: 'second_visit_at',
            displayName: $filter('translate')('SSC_COL_SECONDDATE'),
            headerCellFilter: 'translate',
            enableFiltering: true
        },*/
        
        {
            field: 'ssc_delete_reason_type_name',
            displayName: $filter('translate')('SSC_COL_DELETION_REQUESTS_REASON'),
            headerCellFilter: 'translate',
            enableFiltering: true
        },
        {
            field: 'ssc_delete_reason',
            width: "300",
            displayName: $filter('translate')('SSC_COL_DELETION_REQUESTS_COMMENT'),
            headerCellFilter: 'translate',
            enableFiltering: true
        },

        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            width: "80",
            displayName: $filter('translate')('SSC_COL_FUNCTION'),
            headerCellFilter: 'translate',
            enableFiltering: false,
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<a title="{{\'BTN_EDIT\' | translate}}" href="" ui-sref="ssc.check({id: row.entity.id, name: row.entity.name})"><i class="fa fa-pencil" aria-hidden="true"></i></a> '
                    + '<a permission permission-only="[\'ADMIN\']" title="{{\'BTN_DELETE\' | translate}}" ng-click="grid.appScope.deleteDialog(row.entity.id,grid.appScope.isAdmin())"><i class="fa fa-trash" aria-hidden="true"></i></a>'
                    + '<a title="{{\'BTN_LOG_HISTORY\' | translate}}" href="" class="ui-grid-nav" ui-sref="ssc.log({id: row.entity.id})"><i class="fa fa-history" aria-hidden="true"></i></a>'
                    + '<a title="{{\'BTN_LOG_CANCEL_DELETE\' | translate}}" href="" class="ui-grid-nav" ng-click="grid.appScope.cancelDeleteDialog(row.entity.id)""><i class="fa fa-ban" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        //enableSorting: false,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSize: $rootScope.itemsPerPage,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.core.on.sortChanged($scope, function (grid, sort) {
                if (sort[0] && sort[0].field) {
                    //1. Sorting setzen nach Feld und ORder 
                    $scope.api.data.sort.column = sort[0].field;
                    $scope.api.data.sort.order = sort[0].sort.direction;
                    console.log($scope.api.data.sort);

                    //2. 
                    gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                        $scope.data = formService.formatGrid(data.data, cols);
                    }, function (error) {
                        console.log(error);
                    });
                }
                ;
            });
            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = formService.formatGrid(data.data, cols);
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };

    $scope.deleteDialog = function (id, isAdmin) {
        var handleDialog = function (data) {
            ngDialog.open({
                template: 'templates/landingpage/check_delete.html' + "?v=" + window.version.tag,
                className: 'dialogLanding',
                showClose: false,
                scope: $scope,
                data: data,
                preCloseCallback: function () {
                    $scope.getTableData();
                }
            });
        };

        var handleReson = function (needReason) {
            if (needReason) {
                stromsparcheckService.getDeleteReasons().then(function (data) {
                    handleDialog({
                        dropDeleteReason: data,
                        needReason: needReason,
                        id: id
                    });
                }, function (error) {
                    console.log(error);
                });
            } else {
                handleDialog({
                    needReason: needReason,
                    id: id
                });
            }
        };
        
        if (!isAdmin) {
            //no admin - check required filled - if yes, ask for reason
            stromsparcheckService.getRequiredFilled(id).then(function (data) {
                handleReson(data);
            }, function (error) {
                console.log(error);
            });
        } else {
            handleReson(false);
        }
    };
    
    $scope.cancelDeleteDialog = function (id) {    
        var handleDialog = function (data) {
            ngDialog.open({
                template: 'templates/landingpage/check_delete_cancel.html' + "?v=" + window.version.tag,
                className: 'dialogLanding',
                showClose: false,
                scope: $scope,
                data: data,
                preCloseCallback: function () {
                    $scope.getTableData();
                }
            });
        };
        
        handleDialog({
            id: id
        });
    };
    
    $scope.cancelDelete = function (id) {
        stromsparcheckService.cancelDeleteCheck(id).then(function (data) {
            $scope.getTableData();
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };
    $scope.delete = function (id, comment, reason) {
        stromsparcheckService.deleteCheck(id, comment, reason).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:closed
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('commentOverview', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/stromsparcheck/comment/commentOverview/commentOverview.view.html' + "?v=" + window.version.tag,
        controller: 'commentOverview',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_CLOSED');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:closedSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('commentOverview', function ($scope, gridService, $rootScope, commentService, $stateParams, formService, moment) {

    function escapeHtml(text) {
        return text.replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    var data = {
        ssc_id: $stateParams.id
    };

    function read() {
        // Load existing comments at site start
        commentService.readComments(data).then(function(data) {
            for(var i in data) {
                data[i].created_at = moment.utc(data[i].created_at).local().format("D.M.YYYY HH:mm");
                data[i].message = escapeHtml(data[i].message).replace(/\n/g, "<br />");
            }
            $scope.comments = data.reverse();
        });
    }
    read();

    $rootScope.$on('addCommentEmit', function(event, data) {
        read();
    });

});
"use strict";
/**
* @ngdoc directive
* @name global.directive:closed
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('commentCreate', function ($filter) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/stromsparcheck/comment/commentCreate/commentCreate.view.html' + "?v=" + window.version.tag,
        controller: 'commentCreate',
        link: function (scope, element, attrs) {

            scope.title = $filter('translate')('SSC_TITLE_CLOSED');
        } 
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:closedSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('commentCreate', function ($scope, commentService, localStorageService, $stateParams) {
    $scope.comment = "";
    $scope.addcomment = function () {
        if ($scope.isSaving !== true && $scope.comment !== "") {
            $scope.isSaving = true;
            commentService.addComment($stateParams.id, $scope.comment).then(function (data) {
                $scope.isSaving = false;
                var user = localStorageService.get('user');
                var today = new Date();
                var addZero = function (i) {
                    if (i < 10) {
                        i = "0" + i;
                    }
                    return i;
                };

                var dataSend = {
                    message: $scope.comment,
                    user: user,
                    created_at: today.getFullYear() + "-" + addZero(today.getMonth() + 1) + "-" + addZero(today.getDate()) + " " + addZero(today.getUTCHours()) + ":" + addZero(today.getUTCMinutes()) + ":" + addZero(today.getUTCSeconds())
                };

                $scope.$emit('addCommentEmit', dataSend);
                $scope.comment = "";
            }, function (error) {
                $scope.isSaving = false;
            });
        }
    };

    $scope.$on('disable-comments', function(event, args) {
        $scope.disableComments = true;
    });
    $scope.$on('save-comment', function (event, args) {
        $scope.addcomment();
    });

});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:toiletflushController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('toiletflushController', function ($scope, stromsparcheckService, $stateParams, ngDialog, $rootScope, sscErrorboxService) {

    var tileSlug = 'TOILET_FLUSH';
    $scope.saveData = {
        'ssc_id': $stateParams.id
    };
    var formreadStructure = {
        ssc_toilet_flush: {
            parent: "ssc_id",
            many: true
        }
    };
    var errorStructure = {
        toilet: {
            path: "ssc_toilet_flush[n]"
        }
    };
    $scope.btnIsSaving = [];

    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors(
                {
                    content: $scope.content,
                    properties: $scope.properties,
                    tableProperties: $scope.tableProperties
                },
                newData,
                formreadStructure,
                indexPathStr,
                noWarningConfirm
            );
        }

        stromsparcheckService.appendOldDirecthelpList(newData.content.toilet_flush_directhelp, newData.content.ssc_toilet_flush);

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;
        updateAccordions();

        $scope.errors = sscErrorboxService.createErrorObject(errorStructure, $scope.properties);
        $rootScope.$broadcast("onSscLoadComplete", data.properties);
        $rootScope.$broadcast("errorUpdate", data.properties);
    }

    function read(withErrors) {
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);//don't remember errors, if all errors and warnings from backend
        }, function (error) {
            console.log(error);
        });
    }
    read();

    $scope.save = function (controller, field, value, itemId) {
        var saveParams = stromsparcheckService.resolveSaveParamsFromOldInterface({
            controller: controller,
            field: field,
            value: value,
            itemId: itemId,
            structureObj: formreadStructure,
            contentObj: $scope.content,
            tileSlug: tileSlug
        });
        stromsparcheckService.saveValueNew(saveParams.data, saveParams.route).then(function (data) {
            update(data, true, saveParams.indexPathStr);
        }, function (error) {
            update(error.data, true, saveParams.indexPathStr);
        });
    };

    $scope.addRow = function (tableName, parentId, buttonId) {
        if(!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;

        var route = 'checks/' + tableName.split("_").join("") + '/update';//checks/sscinstalledbrush/update
        var data = {};
        data.ssc_tile_page = tileSlug;
        data[formreadStructure[tableName]['parent']] = parentId;

        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        }, function (error) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        });
    };

    $scope.delete = function(tableName, index, id) {
        stromsparcheckService.delete(tableName, index, id, tileSlug).then(function(data) {
            if(!data) {
                return; //cancelled
            }
            update(data, true);
        }, function(error) {
        });
    };

    $scope.broadcastErrorUpdate = function () {
        $rootScope.$broadcast("errorUpdate", $scope.properties);
    };
    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };

    // Intercept collapse events in order to keep collapse status on update
    $scope.initjquery = function() {
        var a = $(".accordion");

        a.on('shown.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = true;
        });

        a.on('hidden.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = false;
        });
    };

    function updateAccordions() {
        var i;
        if($scope.accordions === undefined) {
            $scope.accordions = [];
            for(i in $scope.content.ssc_toilet_flush) {
                $scope.accordions[i] = [false, $scope.content.ssc_toilet_flush[i].id];
            }
            if($scope.accordions[0]) {
                $scope.accordions[0][0] = true;
            }
        } else {
            var newAccordions = [];
            for(i in $scope.content.ssc_toilet_flush) {
                newAccordions[i] = [false, $scope.content.ssc_toilet_flush[i].id];
            }
            $scope.accordions = stromsparcheckService.copyAccordionStates($scope.accordions, newAccordions);
        }
    }

});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:tipsController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('tipsController', function ($scope, stromsparcheckService, $stateParams, sscErrorboxService, $rootScope) {

    var tileSlug = 'TIPS';
    $scope.tileSlug = tileSlug;
    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    $scope.editorConfig = {
        max_chars: 1500
    };

    $scope.data = {
        ssc_tips:{
            internal_comment:"",
            budget_report_2:"",
            budget_report_3:""
        }
    };
    $scope.properties = {};
    $scope.tableProperties = {};

    $scope.readData = function(data) {
        if (data.content) {
            $scope.data = data.content
        }
        if (data.properties) {
            $scope.properties = data.properties;
            $rootScope.$broadcast("errorUpdate", data.properties);
        }
        if (data.tableProperties) {
            $scope.tableProperties = data.tableProperties;
        }
    };
    stromsparcheckService.read($stateParams.id, tileSlug).then(function (data) {
        $scope.readData(data);
        updateErrors();
    }, function (error) {
        console.log(error);
    });

    $scope.$on("sscAdviceSave", function (event, data) {
        $scope.readData({content: data});
    });

    /* Saves one field after change or defocus (blur) of an input field */
    $scope.save = function (controller, field, value) {
        var data = {
            'ssc_id': $stateParams.id,
            'route': 'checks/' + controller + '/update',
            'ssc_tile_page': 'TIPS'
        };
        if($scope.data.ssc_tips.id){
            data.id=$scope.data.ssc_tips.id;
        }
        
        data[field] = value;

        stromsparcheckService.saveValue(data).then(function (dataIn) {
            $scope.readData(dataIn.content);
            updateErrors();
        }, function (error) {
            if (error.data.properties) {
                $scope.properties = error.data.properties;
            }
            if (error.data.tableProperties) {
                $scope.tableProperties = error.data.tableProperties;
            }
            updateErrors();
            console.log('Speichern fehlgeschlagen: ', error);
        });
    };

    function read(withErrors) {
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            $scope.readData(data);
            updateErrors();
        }, function (error) {
            console.log(error);
        });
    }

    function updateErrors() {
        var structure = {
            tips: {
                path: "ssc_tips"
            }
        };
        $scope.messages = sscErrorboxService.createErrorObject(structure, $scope.properties)
    }

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service.textmodulService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('textmodulService', function ($http, api, $q) {

    var service = {};

    var loadedData = null;
    var deferred = null;

    service.getTextmodulOptions = function () {

        if(loadedData !== null) {
            var d = $q.defer();
            d.resolve(loadedData.data);
            return d.promise;
        }

        if(deferred === null) {
            deferred = $q.defer();

            $http.post(api.root + 'checks/ssc/textmodule/read')
                .success(function (data, status) {
                    loadedData = data;
                    deferred.resolve(loadedData.data);
                })
                .error(function (error) {
                    deferred.reject(error);
                });
        }

        return deferred.promise;
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:textmodul
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('textmodul', function () {
    return { 
        restrict: 'E',
        replace: true,
        scope: {
            model: "=",
            id: "=",
            delimiter: "@"
        },
        templateUrl: 'templates/components/content/stromsparcheck/check/textmodul/textmodul.view.html' + "?v=" + window.version.tag,
        controller: 'textmodulController',
        link: function(scope, element, attributes){

        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:textmodulController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('textmodulController', function ($scope, $stateParams, $rootScope, textmodulService) {

    textmodulService.getTextmodulOptions($stateParams.id).then(function (data) {
        $scope.data = data;
    }, function (error) {
        console.log(error);
    });

    $scope.setText = function(text, id) {
        var pre="";
        if($scope.model){
            var delimiter = "\n\n";
            if (typeof $scope.delimiter === "string") {
                delimiter = $scope.delimiter;
            }
            pre=$scope.model + delimiter;
        }
        $scope.model = pre + text;
        $rootScope.$broadcast("textmodulUpdated", {text: $scope.model, id: $scope.id});
    };

});

"use strict";

/**
 * @ngdoc controller
 * @name dashboard.controller:telephoneInfoController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('telephoneInfoController', function ($scope, api, stromsparcheckService, $stateParams, $rootScope, formService, localStorageService, sscErrorboxService, $filter, apiService, ngDialog) {


	var tileSlug = 'TELEPHONE_CONSULTATION_INFO';
	$scope.$on("$destroy", function () {
		stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
		}, function (error) {
			console.log(error);
		});
	});
	$scope.formPageScope = $scope;
	$scope.dataTimestamp = 0;

	function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
		var newData = data;
		if (doRememberErrors) {
			var structure = {
				ssc_telephone_consultation_info: {
					parent: "ssc_id"
				}
			}
			newData = stromsparcheckService.rememberInputErrors({content: $scope.content, properties: $scope.properties, tableProperties: $scope.tableProperties}, data, structure, indexPathStr, noWarningConfirm);
		}
		$scope.errors = [];
		angular.forEach(newData.properties, function (tabledata) {
			angular.forEach(tabledata, function (field) {
				$scope.errors = $scope.errors.concat(sscErrorboxService.toMessage(field));
			});
		});
		$scope.content = newData.content;
		$scope.properties = newData.properties;
		$scope.tableProperties = newData.tableProperties;
		$scope.dataTimestamp++;
	}

	function read(withErrors) {
		//INIT
		stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
			update(data, !withErrors, undefined, withErrors);
		}, function (error) {
			console.log(error);
		});
	}

	read();

	$scope.save = function (obj, tableColumn, path) {
		var tableName = tableColumn.split(".")[0];
		var controller = tableName.split("_").join("");
		var field = tableColumn.split(".")[1];
		var value = obj[field];
		var itemId = obj["id"];

		var dataSend = {};
		dataSend.ssc_tile_page = tileSlug;
		dataSend.id = itemId;
		dataSend[field] = value;

		stromsparcheckService.saveValueNew(dataSend, 'checks/' + controller + '/update').then(function (data) {
			update(data, true, path);
		}, function (error) {
			update(error.data, true, path);
		});
	};

	$scope.continue = function () {
		stromsparcheckService.continue($stateParams.id, tileSlug);
	};
	$scope.ready = function () {
		read(true);
		stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
	};
});
"use strict";

/**
 * @ngdoc controller
 * @name dashboard.controller:telephoneController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('telephoneController', function ($scope, api, stromsparcheckService, $stateParams, $rootScope, formService, localStorageService, sscErrorboxService, $filter, apiService, ngDialog) {


    var tileSlug = 'TELEPHONE_CONSULTATION';
    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });
    $scope.formPageScope = $scope;
    $scope.dataTimestamp = 0;

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            var structure = {
                ssc_telephone_consultation: {
                    parent: "ssc_id"
                }
            }
            newData = stromsparcheckService.rememberInputErrors({content:$scope.content, properties: $scope.properties, tableProperties: $scope.tableProperties}, data, structure, indexPathStr, noWarningConfirm);
        }
        $scope.errors = [];
        angular.forEach(newData.properties, function (tabledata) {
            angular.forEach(tabledata, function (field) {
                $scope.errors = $scope.errors.concat(sscErrorboxService.toMessage(field));
            });
        });
        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;
        $scope.dataTimestamp++;
    }

    function read(withErrors) {
        //INIT
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);
        }, function (error) {
            console.log(error);
        });
    }

    read();

    $scope.save = function (obj, tableColumn, path) {
        var tableName = tableColumn.split(".")[0];
        var controller = tableName.split("_").join("");
        var field = tableColumn.split(".")[1];
        var value = obj[field];
        var itemId = obj["id"];

        var dataSend = {};
        dataSend.ssc_tile_page = tileSlug;
        dataSend.id = itemId;
        dataSend[field] = value;

        stromsparcheckService.saveValueNew(dataSend, 'checks/' + controller + '/update').then(function (data) {
            update(data, true, path);
        }, function (error) {
            update(error.data, true, path);
        });
    };

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:tapController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('tapController', function ($scope, $stateParams, stromsparcheckService, ngDialog, $rootScope, sscErrorboxService) {

    var tileSlug = 'TAP';
    $scope.saveData = {
        'ssc_id': $stateParams.id
    };
    var formreadStructure = {
        ssc_tap: {
            parent: "ssc_id",
            many: true
        }
    };
    var errorStructure = {
        tap: {
            path: "ssc_tap[n]"
        }
    };
    $scope.btnIsSaving = [];

    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors(
                {
                    content: $scope.content,
                    properties: $scope.properties,
                    tableProperties: $scope.tableProperties
                },
                newData,
                formreadStructure,
                indexPathStr,
                noWarningConfirm
            );
        }

        stromsparcheckService.appendOldDirecthelpList(newData.content.tap_directhelp, newData.content.ssc_tap);

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;
        updateAccordions();

        $scope.errors = sscErrorboxService.createErrorObject(errorStructure, $scope.properties);
        $rootScope.$broadcast("onSscLoadComplete", data.properties);
        $rootScope.$broadcast("errorUpdate", data.properties);
    }

    function read(withErrors) {
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);//don't remember errors, if all errors and warnings from backend
        }, function (error) {
            console.log(error);
        });
    }
    read();

    $scope.save = function (controller, field, value, itemId) {
        var saveParams = stromsparcheckService.resolveSaveParamsFromOldInterface({
            controller: controller,
            field: field,
            value: value,
            itemId: itemId,
            structureObj: formreadStructure,
            contentObj: $scope.content,
            tileSlug: tileSlug
        });
        stromsparcheckService.saveValueNew(saveParams.data, saveParams.route).then(function (data) {
            update(data, true, saveParams.indexPathStr);
        }, function (error) {
            update(error.data, true, saveParams.indexPathStr);
        });
    };

    $scope.addRow = function (tableName, parentId, buttonId) {
        if(!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;

        var route = 'checks/' + tableName.split("_").join("") + '/update';//checks/sscinstalledbrush/update
        var data = {};
        data.ssc_tile_page = tileSlug;
        data[formreadStructure[tableName]['parent']] = parentId;

        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        }, function (error) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        });
    };

    $scope.delete = function(tableName, index, id) {
        stromsparcheckService.delete(tableName, index, id, tileSlug).then(function(data) {
            if(!data) {
                return; //cancelled
            }
            update(data, true);
        }, function(error) {
        });
    };

    $scope.broadcastErrorUpdate = function () {
        $rootScope.$broadcast("errorUpdate", $scope.properties);
    };
    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };

    // Intercept collapse events in order to keep collapse status on update
    $scope.initjquery = function() {
        var a = $(".accordion");

        a.on('shown.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = true;
        });

        a.on('hidden.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = false;
        });
    };

    function updateAccordions() {
        var i;
        if($scope.accordions === undefined) {
            $scope.accordions = [];
            for(i in $scope.content.ssc_tap) {
                $scope.accordions[i] = [false, $scope.content.ssc_tap[i].id];
            }
            if($scope.accordions[0]) {
                $scope.accordions[0][0] = true;
            }
        } else {
            var newAccordions = [];
            for(i in $scope.content.ssc_tap) {
                newAccordions[i] = [false, $scope.content.ssc_tap[i].id];
            }
            $scope.accordions = stromsparcheckService.copyAccordionStates($scope.accordions, newAccordions);
        }
    }
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:standbyController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('standbyController', function ($scope, $stateParams, stromsparcheckService, ngDialog, $rootScope, sscErrorboxService) {
    var tileSlug = 'STANDBY';
    $scope.saveData = {
        'ssc_id': $stateParams.id
    };
    var formreadStructure = {
        ssc_standby: {
            parent: "ssc_id",
            many: true
        },
        ssc_standby_device: {
            parent: "ssc_standby_id",
            parentEl: "ssc_standby",
            many: true
        }
    };
    var errorStructure = {
        standby: [
            {
                path: "ssc_standby[n]"
            },
            {
                path: "ssc_standby[n].ssc_standby_device[]"
            }
        ]
    };
    $scope.btnIsSaving = [];

    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors(
                {
                    content: $scope.content,
                    properties: $scope.properties,
                    tableProperties: $scope.tableProperties
                },
                newData,
                formreadStructure,
                indexPathStr,
                noWarningConfirm
            );
        }

        stromsparcheckService.appendOldDirecthelpList(newData.content.standby_directhelp, newData.content.standby_directhelp);

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;
        updateAccordions();

        $scope.errors = sscErrorboxService.createErrorObject(errorStructure, $scope.properties);
        $rootScope.$broadcast("onSscLoadComplete", data.properties);
        $rootScope.$broadcast("errorUpdate", data.properties);
    }

    function read(withErrors) {
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);//don't remember errors, if all errors and warnings from backend
        }, function (error) {
            console.log(error);
        });
    }
    read();

    $scope.save = function (controller, field, value, itemId) {
        var saveParams = stromsparcheckService.resolveSaveParamsFromOldInterface({
            controller: controller,
            field: field,
            value: value,
            itemId: itemId,
            structureObj: formreadStructure,
            contentObj: $scope.content,
            tileSlug: tileSlug
        });
        stromsparcheckService.saveValueNew(saveParams.data, saveParams.route).then(function (data) {
            update(data, true, saveParams.indexPathStr);
        }, function (error) {
            update(error.data, true, saveParams.indexPathStr);
        });
    };

    $scope.addRow = function (tableName, parentId, buttonId) {
        if(!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;

        var route = 'checks/' + tableName.split("_").join("") + '/update';//checks/sscinstalledbrush/update
        var data = {};
        data.ssc_tile_page = tileSlug;
        data[formreadStructure[tableName]['parent']] = parentId;

        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        }, function (error) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        });
    };

    $scope.delete = function(tableName, index, id, parentIndex) {
        stromsparcheckService.delete(tableName, index, id, tileSlug).then(function(data) {
            if(!data) {
                return; //cancelled
            }
            update(data, true);
        }, function(error) {
        });
    };

    $scope.broadcastErrorUpdate = function () {
        $rootScope.$broadcast("errorUpdate", $scope.properties);
    };
    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };

    // Intercept collapse events in order to keep collapse status on update
    $scope.initjquery = function() {
        var a = $(".accordion");

        a.on('shown.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = true;
        });

        a.on('hidden.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = false;
        });
    };

    function updateAccordions() {
        var i;
        if($scope.accordions === undefined) {
            $scope.accordions = [];
            for(i in $scope.content.ssc_standby) {
                $scope.accordions[i] = [false, $scope.content.ssc_standby[i].id];
            }
            if($scope.accordions[0]) {
                $scope.accordions[0][0] = true;
            }
        } else {
            var newAccordions = [];
            for(i in $scope.content.ssc_standby) {
                newAccordions[i] = [false, $scope.content.ssc_standby[i].id];
            }
            $scope.accordions = stromsparcheckService.copyAccordionStates($scope.accordions, newAccordions);
        }
    }
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:showerController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('showerController', function ($scope, $stateParams, stromsparcheckService, ngDialog, $rootScope, apiService, sscErrorboxService) {
    $scope.confirmWarnings = {
        current: undefined,
        listConfirmed: []
    };

    $scope.tileSlug = 'SHOWER';
    $scope.saveData = {
        'ssc_id': $stateParams.id
    };
    var formreadStructure = { //structure of data coming with formread
        ssc_shower: {
            parent: "ssc_id",
            many: true
        },
        ssc_shower_person: {
            many: true,
            parent: "ssc_shower_id",
            parentEl: "ssc_shower"
        },
        ssc_bathtub: {
            parent: "ssc_id",
            many: true
        }
    };
    var errorStructure = {
        shower: [
            {path: "ssc_shower[n]"},
            {path: "ssc_shower[n].ssc_shower_person[]"}
        ],
        bathtub: [
            {path: "ssc_bathtub[n]"}
        ]
    };
    $scope.btnIsSaving = [];

    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, $scope.tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    $scope.$on("sscAdviceSave", function (event, data) {
        update(
            {content: data, properties: $scope.properties, tableProperties: $scope.tableProperties},
            false, undefined, false
        );
    });

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors({content: $scope.content, properties: $scope.properties, tableProperties: $scope.tableProperties}, newData, formreadStructure, indexPathStr, noWarningConfirm);
        }

        stromsparcheckService.appendOldDirecthelpList(newData.content.shower_directhelp,newData.content.ssc_shower);

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;
        updateAccordions();

        updateErrors();
        setTimeout(function() {//needs to be delayed or the changes are not visible
            $rootScope.$broadcast("onSscLoadComplete", data.properties);
            $rootScope.$broadcast("errorUpdate", data.properties);
        }, 10);
    }

    //INIT
    function read(withErrors) {
        stromsparcheckService.read($stateParams.id, $scope.tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);//don't remember errors, if all errors and warnings from backend
        }, function (error) {
            console.log(error);
        });
    }

    read();

    $scope.addRow = function (tableName, parentId, buttonId) {
        if(!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;

        var route = 'checks/' + tableName.split("_").join("") + '/update';//checks/sscinstalledbrush/update
        var data = {};
        data.ssc_tile_page = $scope.tileSlug;
        data[formreadStructure[tableName]['parent']] = parentId;

        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        }, function (error) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        });
    };

    $scope.broadcastErrorUpdate = function () {
        $rootScope.$broadcast("errorUpdate", $scope.properties);
    };


    $scope.save = function (controller, field, value, itemId) {
        var saveParams = stromsparcheckService.resolveSaveParamsFromOldInterface({
            controller: controller,
            field: field,
            value: value,
            itemId: itemId,
            structureObj: formreadStructure,
            contentObj: $scope.content,
            tileSlug: $scope.tileSlug
        });
        stromsparcheckService.saveValueNew(saveParams.data, saveParams.route).then(function (data) {
            update(data, true, saveParams.indexPathStr);
        }, function (error) {
            update(error.data, true, saveParams.indexPathStr);
        });
    };
    
    //------------------ warning confirm ----------------------------------------------------------

    $scope.hasConfirmWarnings = function (controller,field) {
        for (var key in $scope.properties.ssc_shower) {
            if(controller==='sscshower'){
                for (var relid in $scope.properties.ssc_shower[key]) {
                    if(field===relid){
                        if ($scope.properties.ssc_shower[key][relid] && $scope.properties.ssc_shower[key][relid].warning_confirm) {
                            if(stromsparcheckService.hasWarningConfirmed(controller,field, $scope.confirmWarnings)){
                                return false;
                            }
                            $scope.confirmWarnings.current={controller:controller,field:field};
                            return true;
                        }else{
                            stromsparcheckService.removeWarningConfirmed(controller,field, $scope.confirmWarnings);
                        }
                    }    
                }
            }
            
            if(controller==='sscshowerperson'){
                if($scope.properties.ssc_shower[key].ssc_shower_person){
                    for (var pIndex in $scope.properties.ssc_shower[key].ssc_shower_person) {
                        for (var pColumn in $scope.properties.ssc_shower[key].ssc_shower_person[pIndex]) {
                            if(field===pColumn){
                                if ($scope.properties.ssc_shower[key].ssc_shower_person && $scope.properties.ssc_shower[key].ssc_shower_person[pIndex][pColumn] && $scope.properties.ssc_shower[key].ssc_shower_person[pIndex][pColumn].warning_confirm) {
                                    if(stromsparcheckService.hasWarningConfirmed(controller,field, $scope.confirmWarnings)){
                                        return false;
                                    }
                                    $scope.confirmWarnings.current={controller:controller,field:field};
                                    return true;
                                }else{
                                    stromsparcheckService.removeWarningConfirmed(controller,field, $scope.confirmWarnings);
                                }
                            }
                        }
                    }
                }
            }
        }
        return false;
    };


    //------------------ warning confirm END ----------------------------------------------------------

    function updateErrors() {
        $scope.errors = sscErrorboxService.createErrorObject(errorStructure, $scope.properties);
    }

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, $scope.tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, $scope.tileSlug);
    };

    $scope.delete = function(tableName, index, id, parentIndex) {
        stromsparcheckService.delete(tableName, index, id, $scope.tileSlug).then(function(data) {
            if(!data) {
                return; //cancelled
            }
            update(data, true);
        }, function(error) {
        });
    };

    function updateAccordions() {
        let i, newAccordions;
        if($scope.accordions === undefined) {
            $scope.accordions = [];
            for(i in $scope.content.ssc_shower) {
                $scope.accordions[i] = [false, $scope.content.ssc_shower[i].id];
            }
            if($scope.accordions[0]) {
                $scope.accordions[0][0] = true;
            }
        } else {
            newAccordions = [];
            for(i in $scope.content.ssc_shower) {
                newAccordions[i] = [false, $scope.content.ssc_shower[i].id];
            }
            $scope.accordions = stromsparcheckService.copyAccordionStates($scope.accordions, newAccordions);
        }
        if($scope.accordionsBathtub === undefined) {
            $scope.accordionsBathtub = [];
            for(i in $scope.content.ssc_bathtub) {
                $scope.accordionsBathtub[i] = [false, $scope.content.ssc_bathtub[i].id];
            }
        } else {
            newAccordions = [];
            for(i in $scope.content.ssc_bathtub) {
                newAccordions[i] = [false, $scope.content.ssc_bathtub[i].id];
            }
            $scope.accordionsBathtub = stromsparcheckService.copyAccordionStates($scope.accordionsBathtub, newAccordions);
        }
    }
});

"use strict";

/**
 * @ngdoc controller
 * @name dashboard.controller:refrigeratorController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('refrigeratorController', function ($scope, api, stromsparcheckService, $stateParams, $rootScope, sscErrorboxService, $filter, apiService, ngDialog, APP_FLAGS) {


    var tileSlug = 'REFRIGERATOR_EXCHANGE';
    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });
    $scope.formPageScope = $scope;
    $scope.dataTimestamp = 0;
    $scope.showAllVersions = false;
     for (let role of $rootScope.currentUser.user_role) {
        if (role.slug === "ADMIN" && APP_FLAGS.includes("DEV")) {
            $scope.showAllVersions = true;
            break;
        }
    }

    (function() { //init Form Vars
        var i;
        var formVars = {};
        formVars.isOwnerOptions = [
            {id: 1, name: $filter('translate')('SSC_REFRIGERATOR_YES')},
            {id: 0, name: $filter('translate')('SSC_REFRIGERATOR_NO_HH_IS_OWNER')}
        ];

        formVars.coolingStepsOptions = [];
        for (i = 1; i < 11; i++) {
            formVars.coolingStepsOptions.push({id: i});
        }

        formVars.info_dl_route = api.root + "checks/pdf/refrigeratorinfonote/read";
        formVars.voucher_dl_route = api.root + "checks/pdf/voucher/read";

        formVars.voucherExpiredBy = new Date();
        formVars.voucherExpiredBy.setDate(formVars.voucherExpiredBy.getDate() + 30 + 31);

        formVars.newVoucherValue = null;

        formVars.voucherAccordeon = [];
        formVars.fridgeAccordeon = [];

        $scope.formVars = formVars;
    })();

    var formreadStructure = {
        ssc_refrigerator_exchange: {
            parent: "ssc_id"
        },
        ssc_refrigerator: {
            many: true,
            parent: "ssc_refrigerator_exchange_id"
        },
        ssc_local_subsidy: {
            many: true,
            parent: "ssc_refrigerator_exchange_id"},
        ssc_refrigerator_voucher: {
            many: true,
            parent: "ssc_refrigerator_exchange_id"
        }
    };
    $scope.btnIsSaving = [];

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors({content:$scope.content, properties: $scope.properties, tableProperties: $scope.tableProperties}, data, formreadStructure, indexPathStr, noWarningConfirm);
        }

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;

        $scope.formVars.isCorrupted = !$scope.content.ssc_refrigerator_exchange;

        updateErrors();
        updateAccordeon();
        $scope.dataTimestamp++;
    }

    function read(withErrors) {
        //INIT
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            if (data.content && data.content.ssc_refrigerator_exchange) {
                if (data.content.ssc_refrigerator_exchange.voucher_ends_at) {
                    $scope.formVars.voucherExpiredBy = moment(data.content.ssc_refrigerator_exchange.voucher_ends_at, "YYYY-MM-DD HH:mm:ss").toDate();
                }
                if (data.content.ssc_refrigerator_exchange.voucher_new_value) {
                    $scope.formVars.newVoucherValue = data.content.ssc_refrigerator_exchange.voucher_new_value;
                }
            }
            update(data, !withErrors, undefined, withErrors);
        }, function (error) {
            console.log(error);
        });
    }

    read();

    $scope.save = function (obj, tableColumn, path) {
        var tableName = tableColumn.split(".")[0];
        var controller = tableName.split("_").join("");
        var field = tableColumn.split(".")[1];
        var value = obj[field];
        var itemId = obj["id"];

        var dataSend = {};
        dataSend.ssc_tile_page = tileSlug;
        dataSend.id = itemId;
        dataSend[field] = value;

        stromsparcheckService.saveValueNew(dataSend, 'checks/' + controller + '/update').then(function (data) {
            update(data, true, path);
        }, function (error) {
            update(error.data, true, path);
        });
    };


    function updateErrors() {
        var structure = {
            exchange: {
                path: "ssc_refrigerator_exchange",
                fields: ["ssc_refrigerator_partner_id"]
            },
            fridge: {
                path: "ssc_refrigerator[n]"
            },
            newFridge: {
                path: "ssc_refrigerator_exchange",
                fields: ["new_*"]
            },
            localSubsidy: [
                {
                    path: "ssc_refrigerator_exchange",
                    fields: ["is_local_subsidy"]
                },
                {
                    path: "ssc_local_subsidy[]"
                }
            ]
        };
        $scope.errors = sscErrorboxService.createErrorObject(structure, $scope.properties);

        $scope.voucherErrors = [];
        if($scope.content.ssc_refrigerator_exchange) {
            if(!$scope.content.ssc_refrigerator_exchange.has_sealnumber) {
                $scope.voucherErrors.push({type:'error',text: $filter('translate')('SSC_REFRIGERATOR_EXCHANGE_DOWNLOAD_ERROR_MSG')});
            }
            if(!$scope.content.ssc_refrigerator_exchange.LOCATION_HAS_BUNDESPROGRAMM) {
                // $scope.voucherErrors.push({type:'error',text: $filter('translate')('SSC_REFRIGERATOR_EXCHANGE_NO_BUNDESPROGRAMM_ERROR')});
            }
        }
    }

    function updateAccordeon() {
        var formVars = $scope.formVars;
        var structure = [
            {
                table: "ssc_refrigerator_voucher",
                accordeon: "voucherAccordeon"
            },
            {
                table: "ssc_refrigerator",
                accordeon: "fridgeAccordeon"
            }
        ];
        for(var e in structure) {
            if($scope.content && $scope.content[structure[e].table]) {
                var toAdd = $scope.content[structure[e].table].length - formVars[structure[e].accordeon].length;
                if(toAdd > 0) {
                    for(var i = 0; i < toAdd; i++) {
                        formVars[structure[e].accordeon].push(false);
                    }
                }
                if(toAdd < 0) {
                    formVars[structure[e].accordeon] = formVars[structure[e].accordeon].slice(0, $scope.content[structure[e].table].length);
                }
            } else {
                formVars[structure[e].accordeon] = [];
            }
        }
    }

    $scope.domChangedAccordeon = function() {
        setTimeout(function() {
            var formVars = $scope.formVars;
            var i;
            var $el;
            for(i in formVars.voucherAccordeon) {
                $el = $("#voucherAccordeon" + i);
                formVars.voucherAccordeon[i] = $el[0].className.split(" ").includes("in");
            }
            for(i in formVars.fridgeAccordeon) {
                $el = $("#fridgeAccordeon" + i);
                formVars.fridgeAccordeon[i] = $el[0].className.split(" ").includes("in");
            }
        }, 500);
    };
    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };

    $scope.extendVoucher = function() {
        $scope.content.ssc_refrigerator_exchange.voucher_is_extendable = 1;
        var obj = $scope.content.ssc_refrigerator_exchange;
        var tableColumn = "ssc_refrigerator_exchange.voucher_is_extendable";
        var path = "ssc_refrigerator_exchange.voucher_is_extendable";
        $scope.save(obj, tableColumn, path);
    };

    $scope.toDate = function(dateStr) {
        return moment(dateStr, "YYYY-MM-DD HH:mm:ss").toDate();
    };

    $scope.addRow = function (tableName, parentId, buttonId) {
        if(!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;

        var route = 'checks/' + tableName.split("_").join("") + '/update';
        var data = {};
        data.ssc_tile_page = tileSlug;
        data[formreadStructure[tableName]['parent']] = parentId;

        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        }, function (error) {
            $scope.btnIsSaving[buttonId]--;
            update(error.data, true);
        });
    };

    $scope.delete = function(tableName, index, id) {
        stromsparcheckService.delete(tableName, index, id, tileSlug).then(function(data) {
            if(!data) {
                return; //cancelled
            }
            update(data, true);
        }, function(error) {
        });
    };

    $scope.refreshAge = function (buttonId) {
        if(!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;

        ngDialog.openConfirm({
            template: 'templates/landingpage/confirm_dialog.html' + "?v=" + window.version.tag,
            data: {
                diagTitle: $filter('translate')('SSC_REFRIGERATOR_REFRESH_AGE_TITLE'),
                diagDescription: $filter('translate')('SSC_REFRIGERATOR_REFRESH_AGE_DESCRIPTION'),
                diagCancel: $filter('translate')('BTN_CANCEL'),
                diagConfirm: $filter('translate')('BTN_CONFIRM')
            }
        }).then(function () {
            //confirm
            var data = {
                ssc_id: $scope.content.ssc_refrigerator_exchange.ssc_id,
                ssc_tile_page: tileSlug
            };
            apiService.post('monitoring/sscrefrigeratorexchange/refreshage', data).then(function (data) {
                $scope.btnIsSaving[buttonId]--;
                update(data, true);
            }, function (error) {
                $scope.btnIsSaving[buttonId]--;
            });
        }, function () {
            $scope.btnIsSaving[buttonId]--;
        });
    };
});
"use strict";
angular.module('frontendApp').controller('photovoltaicController', function ($scope, api, stromsparcheckService, $stateParams, $rootScope, formService, localStorageService, sscErrorboxService, $filter, apiService, ngDialog) {
    var tileSlug = 'PHOTOVOLTAIC';
    $scope.tileSLug = tileSlug;
    $scope.formPageScope = $scope;
    $scope.dataTimestamp = 0;
    $scope.btnIsSaving = {};
    $scope.moduleCountOptions = [];
    for (var option = 1; option <= 10; option++) {
        $scope.moduleCountOptions.push({
            id: option,
            description: option
        });
    }

    $scope.addPvModule = function (parentId, buttonId) {
        if (!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;
        var requestData = {
            ssc_photovoltaic_id: parentId,
            ssc_tile_page: tileSlug
        };
        stromsparcheckService.saveValueNew(requestData, "checks/sscpvmodule/update").then(
            function (responseData) {
                $scope.btnIsSaving[buttonId]--;
                update(responseData, true);
            }, function (error) {
                $scope.btnIsSaving[buttonId]--;
                update(error.data, true);
            });
    };

    $scope.delete = function (route, index, id) {
        stromsparcheckService.delete(route, index, id, tileSlug).then(
            function (data) {
                if (!data) {
                    return;
                }
                update(data, true);
            }, function (error) {
            });
    };

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };
    $scope.save = function (obj, tableColumn, path) {
        var tableName = tableColumn.split(".")[0];
        var controller = tableName.split("_").join("");
        var field = tableColumn.split(".")[1];
        var value = obj[field];
        var itemId = obj["id"];

        var dataSend = {
            ssc_tile_page: tileSlug,
            id: itemId
        };
        if (field !== "") {
            dataSend[field] = value;
        }

        stromsparcheckService.saveValueNew(dataSend, 'checks/' + controller + '/update').then(function (data) {
            update(data, true, path);
        }, function (error) {
            update(error.data, true, path);
        });
    };

    function read(withErrors) {
        //INIT
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);
        }, function (error) {
            console.log(error);
        });
    }

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if (doRememberErrors) {
            var structure = {
                ssc_photovoltaic: {
                    parent: "ssc_id"
                },
                ssc_pv_module: {
                    many: true,
                    parent: "ssc_photovoltaic_id"
                },
            };
            newData = stromsparcheckService.rememberInputErrors({
                content: $scope.content,
                properties: $scope.properties,
                tableProperties: $scope.tableProperties
            }, data, structure, indexPathStr, noWarningConfirm);
        }
        $scope.errors = {
            ssc_photovoltaic: [],
            ssc_pv_module: []
        };
        angular.forEach($scope.errors, function (errors, table) {
            if (newData.properties[table]) {
                if ("ssc_pv_module" === table) {
                    angular.forEach(newData.properties[table], function (tabledata, index) {
                        $scope.errors[table][index] = [];
                        angular.forEach(tabledata, function (field) {
                            $scope.errors[table][index] = $scope.errors[table][index].concat(sscErrorboxService.toMessage(field));
                        });
                    });
                } else {
                    $scope.errors[table] = [];
                    angular.forEach(newData.properties[table], function (field) {
                        $scope.errors[table] = $scope.errors[table].concat(sscErrorboxService.toMessage(field));
                    });
                }
            }
        });
        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;
        $scope.dataTimestamp++;
    }
    read(false);
});
"use strict";
/**
 * @ngdoc directive
 * @name overview.directive:errorlabel
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('errorlabel', function ($rootScope) {
    return {
        restrict: 'A',
        scope: {
            dataobj: "=dataobj",
            datafield: "@datafield"
        },
        link: function (scope, element, attrs) {
            //$scope;
            Object.resolve = function (path, obj) {
                return path.split('.').reduce(function (prev, curr) {
                    return prev ? prev[curr] : false
                }, obj || self);
            };

            var hadError = false;
            var hadWarning = false;

            scope.$on("errorUpdate", function (event, data) {

                var errors = Object.resolve(attrs.errorlabel, data);
                var $element = $(element);

                var error = errors && errors.error;
                var warning = errors && errors.warning && !error;
                if(!warning){
                    warning = errors && errors.warning_confirm && !error;
                }
                if(hadWarning !== warning) {
                    hadWarning = warning;
                    if(warning) {
                        $element.addClass("warning");
                    } else {
                        $element.removeClass("warning");
                    }
                }

                if(hadError !== error) {
                    hadError = error;
                    if(error) {
                        $element.addClass("error");
                    } else {
                        $element.removeClass("error");
                    }
                }

            });

        }
    };
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:overviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('overviewController', function ($scope, stromsparcheckService, ngDialog, searchService, $stateParams, formService, $rootScope, $state, $anchorScroll) {
    var tileSlug = 'OVERVIEW';

    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    $scope.loadOverview = function () {
        stromsparcheckService.read($stateParams.id, tileSlug, false).then(function (data) {

            $scope.showerrorbox = 0;
            $scope.data = data.content;

            $scope.loadUserList(data.content.ssc.location_id);

            // required fields
            $scope.required = data.properties;
            $rootScope.$broadcast("errorUpdate", data.properties);
            //update - "Ohne Wertung"
            $scope.isSlugSet('MONTIORING_COMPLETED');
            $scope.isSlugSet('MONTIORING_COMPLETED_CANCELED_EVALUATION');
            $scope.tableProperties = data.tableProperties;
            $scope.origStatus = null;
            if($scope.data.ssc) {
                $scope.origStatus = $scope.data.ssc.status;
            }
        }, function (error) {
            console.log(error);
        });
    };

    $scope.unsetAkquiseId = function () {
        $scope.data.ssc.ssc_akquise_id = null;
    };

    $scope.loadUserList = function(loc_id) {

        var dataSSH = {
            role: 'SSH',
            loc_id: loc_id
        };

        var dataTrainer = {
            role: 'TRAINER',
            loc_id: loc_id
        };

        stromsparcheckService.getAllUsersByRole(dataSSH).then(function (data) {
            $scope.dropUsersSSH = data;
        }, function (error) {
            console.log(error);
        });

        stromsparcheckService.getAllUsersByRole(dataTrainer).then(function (data) {
            $scope.dropUsersTrainer = data;
        }, function (error) {
            console.log(error);
        });
    }

    $scope.getDropUserSsh = function () {
        if (!$scope.dropUsersSSH || typeof $scope.dropUsersSSH.filter !== "function") {
            return [];
        }
        return $scope.dropUsersSSH.filter(user => user.id !== $scope.data.ssc.ssc_user_1_id && user.id !== $scope.data.ssc.ssc_user_2_id);
    };

    $scope.getDropUserSshMonitoring = function () {
        if (!$scope.dropUsersSSH || typeof $scope.dropUsersSSH.filter !== "function") {
            return [];
        }
        return $scope.dropUsersSSH.filter(user => user.id !== $scope.data.ssc.ssc_user_mon_1_id && user.id !== $scope.data.ssc.ssc_user_mon_2_id);
    };

    $scope.statusDialog = function () {
        ngDialog.open({
            template: 'templates/landingpage/status.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'success': true
            }
        });
    };

    /**
     * Resets the status to the original status
     */
    $scope.resetStatus = function () {
        $scope.data.ssc.status = $scope.origStatus;
    };

    $scope.anonymizeDialog = function () {
        ngDialog.open({
            template: 'templates/landingpage/anonymize.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'success': true
            }
        });
    };

    $scope.anonymize = function () {
        stromsparcheckService.anonymize($stateParams.id).then(function (data) {
            ngDialog.close();
            $scope.loadOverview();
            $rootScope.$broadcast('reload-household-name');
            $rootScope.$broadcast('disable-comments');
        }, function (error) {
            console.log('Anonymisierung fehlgeschlagen: ' + error);
        });
    };
    
    $scope.showCanceledEvaluation=false;
    $scope.isSlugSet = function (slug) {
        if($scope.data && $scope.data.ssc_status &&
           $scope.data.ssc && $scope.data.ssc.status ){
                for(var i=0;i<$scope.data.ssc_status.length;i++){
                    if( ($scope.data.ssc_status[i].id == $scope.data.ssc.status) &&
                        ($scope.data.ssc_status[i].slug == slug) ){
                        $scope.showCanceledEvaluation=true;
                        break;
                    }
                }
        }
    };

    /* Saves one field after change or defocus (blur) of an input field */
    $scope.save = function (controller, field, value) {
        var data = {
            'id': $stateParams.id,
            'route': 'checks/' + controller + '/update',
            'ssc_tile_page': tileSlug
        };
        data[field] = value;
        var field = field;

        var userKeyArr = [
            ['trainer_user_id', 'trainer_user'],
            ['ssc_user_1_id', 'user_1'],
            ['ssc_user_2_id', 'user_2'],
            ['ssc_user_mon_1_id', 'user_mon_1'],
            ['ssc_user_mon_2_id', 'user_mon_2']
        ];
        for(var i = 0; i < userKeyArr.length; i++) {
            if(field === userKeyArr[i][0]) {
                $scope.data.ssc[userKeyArr[i][0]] = value;
            }
        }

        var changedStatus = controller === "ssc" && field === "status";
        var changedName = controller === "ssc" && (field === "firstname" || field === "lastname");
        var changedClimateProtection = controller === "ssc" && field === "has_climate_protection";
        var changedPhotovoltaic = controller === "ssc" && field === "has_photovoltaic";
        var reloadTiles = changedClimateProtection || changedPhotovoltaic;

        stromsparcheckService.saveValue(data).then(function (data) {

            if(changedStatus || reloadTiles) {
                //status change might make monitoring tiles visible/hidden, climate protection tile
                $rootScope.$broadcast("reload-tile-status");
                if (changedStatus) {
                    $rootScope.$broadcast("save-comment");
                }
            }
            if(changedName) {
                $rootScope.$broadcast('reload-household-name');
            }

            //update - "Ohne Wertung"
            $scope.isSlugSet('MONTIORING_COMPLETED');
            $scope.isSlugSet('MONTIORING_COMPLETED_CANCELED_EVALUATION');
            // Check if there is an existing error in another field.

            var errorflag = false;
            $scope.showerrorbox = 0;
            for (var key in $scope.required.ssc) {
                if ($scope.required.ssc[key] && ($scope.required.ssc[key].error || $scope.required.ssc[key].warning)) {
                    if (field != key) {
                        data.properties.ssc[key] = $scope.required.ssc[key];
                        data.content.ssc[key] = $scope.data.ssc[key];
                        errorflag = true;
                    }
                }
            }

            //to properly remember wrong inputs for users
            var newUserId, newUser;
            for(var i = 0; i < userKeyArr.length; i++) {
                newUserId = data.content.ssc[userKeyArr[i][0]];
                newUser = data.content.ssc[userKeyArr[i][1]];
                if((newUserId === null && newUser !== null)
                    || (newUserId !== null && newUser === null)
                    || (newUser !== null && parseInt(newUser.id) !== parseInt(newUserId))) {
                    data.content.ssc[userKeyArr[i][1]] = $scope.data.ssc[userKeyArr[i][1]];
                }
            }

            if (errorflag) {
                $rootScope.$broadcast("errorUpdate", data.properties);
            }
            $scope.data = data.content;
            // required fields

            $scope.required = data.properties;
            $scope.searchRes = [];
            $scope.tableProperties = data.tableProperties;
            $scope.origStatus = null;
            if($scope.data.ssc) {
                $scope.origStatus = $scope.data.ssc.status;
            }
        }, function (error) {
            console.log('Speichern fehlgeschlagen: ' + error);
            console.log(field);

            // required fields
            var errorflag = false;
            $scope.showerrorbox = 0;
            for (var key in $scope.required.ssc) {
                if ($scope.required.ssc[key] && ($scope.required.ssc[key].error || $scope.required.ssc[key].warning)) {
                    if (field != key) {
                        error.data.properties.ssc[key] = $scope.required.ssc[key];
                        error.data.content.ssc[key] = $scope.data.ssc[key];
                        errorflag = true;
                    }
                }
            }
            if (errorflag) {
                $rootScope.$broadcast("errorUpdate", error.data.properties);
            }
            $scope.required = error.data.properties;
            $scope.tableProperties = error.data.tableProperties;
        });
    };

    $scope.search = function ($select) {
        if ($select.search !== "") {
            searchService.searchUser($select.search).then(function (data) {
                $scope.searchRes = data;
            }, function (error) {
                console.log(error);
            });
        }
    };
    
    $scope.search = function ($select, $role, targetId) {
        if (1 || $select.search !== "") {
            if($role==='EFB'){
                searchService.searchEfbUser($select.search, targetId).then(function (data) {
                    $scope.searchRes = data;
                }, function (error) {
                    console.log(error);
                });
            }else{
                searchService.searchUser($select.search, $role, targetId).then(function (data) {
                    $scope.searchRes = data;
                }, function (error) {
                    console.log(error);
                });
            }
        }
    };
    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {

        stromsparcheckService.read($stateParams.id, tileSlug, true).then(function (data) {

            $scope.showerrorbox = 0;
            $scope.data = data.content;

            $scope.loadUserList(data.content.ssc.location_id);

            // required fields
            $scope.required = data.properties;
            $rootScope.$broadcast("errorUpdate", data.properties);
            //update - "Ohne Wertung"
            $scope.isSlugSet('MONTIORING_COMPLETED');
            $scope.isSlugSet('MONTIORING_COMPLETED_CANCELED_EVALUATION');
            $scope.tableProperties = data.tableProperties;

            $scope.origStatus = null;
            if($scope.data.ssc) {
                $scope.origStatus = $scope.data.ssc.status;
            }
        }, function (error) {
            console.log(error);
        });

        stromsparcheckService.ready($stateParams.id, tileSlug).then(function (data) {

            // Alle Pflichtfelder sind gesetzt
            if (data) {
                ngDialog.open({
                    template: 'templates/landingpage/ready_success.html' + "?v=" + window.version.tag,
                    className: 'dialogLanding',
                    showClose: false
                });
            }
            //es sind nicht alle Felder ausgefüllt
            else {
                ngDialog.open({
                    template: 'templates/landingpage/ready_failed.html' + "?v=" + window.version.tag,
                    className: 'dialogLanding',
                    showClose: false
                });
            }

        }, function (error) {
            console.log('Speichern fehlgeschlagen: ' + error);
        });
    };
    
    $scope.canceledEvaluationDialog = function () {
        ngDialog.open({
            template: 'templates/landingpage/canceled_evaluation.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'success': true
            }
        });
    };

    $scope.canceledEvaluation = function () {
        var data = {
            ssc_id: $stateParams.id,
            route: 'checks/ssc/canceledevaluation'
        };

        stromsparcheckService.saveValue(data).then(function (data) {
            ngDialog.close();
        }, function (error) {
            ngDialog.close();
            ngDialog.open({
                    template: 'templates/landingpage/canceled_evaluation_error.html' + "?v=" + window.version.tag,
                    className: 'dialogLanding',
                    showClose: false
            });
            console.log('Anfrage Ohne Wertung fehlgeschlagen: ' + error);
        });
    };

    $scope.getStatusName = function(id) {
        if(!id || !$scope.data) {
            return "";
        }
        for(var i = 0; i < $scope.data.ssc_status.length; i++) {
            if(parseInt($scope.data.ssc_status[i].id) === parseInt(id)) {
                return $scope.data.ssc_status[i].name;
            }
        }
        return "";
    };
    
    $scope.loadOverview();
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:householdcreateController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('householdcreateController', function ($scope, stromsparcheckService, ngDialog, searchService, $stateParams, formService, $state, $rootScope) {


    $scope.locationlist = null;

    var tileSlug = 'OVERVIEW';

    stromsparcheckService.read($stateParams.id, tileSlug).then(function (data) {

        $scope.showerrorbox = 0;
        $scope.data = data.content;
        $scope.data.ssc = {};
        if ($scope.data.ssc_previous_consultation_type && $scope.data.ssc_previous_consultation_type.length > 0) {
            var defaultType = $scope.data.ssc_previous_consultation_type.find(t => t.is_default === true);
            if (defaultType) {
                $scope.data.ssc.ssc_previous_consultation_type_id = defaultType.id;
            }
        }
        $scope.locationlist = null;

        stromsparcheckService.readLocation($stateParams.id, 'hhcreate').then(function (data) {

            $scope.locationlist = data;
            if($scope.locationlist.length == 1) {
                $scope.data.ssc.location_id = parseInt($scope.locationlist[0].id);
                $scope.loadUserList($scope.data.ssc.location_id);
            }

        }, function (error) {
            console.log(error);
        });

        $scope.required = data.properties;

    }, function (error) {
        console.log(error);
    });

    $scope.unsetAkquiseId = function () {
        $scope.data.ssc.ssc_akquise_id = null;
    };

    $scope.loadUserList = function(loc_id) {

        $scope.data.ssc.user_1 = null;
        $scope.data.ssc.user_2 = null;
        $scope.data.ssc.trainer_user = null;

        var dataSSH = {
            role: 'SSH',
            loc_id: loc_id
        };

        var dataTrainer = {
            role: 'TRAINER',
            loc_id: loc_id
        };

        stromsparcheckService.getAllUsersByRole(dataSSH).then(function (data) {
            $scope.dropUsersSSH = data;
        }, function (error) {
            console.log(error);
        });

        stromsparcheckService.getAllUsersByRole(dataTrainer).then(function (data) {
            $scope.dropUsersTrainer = data;
            if($scope.dropUsersTrainer.length === 1) {
                $scope.data.ssc.trainer_user = $scope.dropUsersTrainer[0];
            }
        }, function (error) {
            console.log(error);
        });
    };

    $scope.statusDialog = function () {
        ngDialog.open({
            template: 'templates/landingpage/status.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'success': true
            }
        });
    };


    $scope.status = function () {
        console.log($scope.data.ssc.status);
        var data = {
            'id': $stateParams.id,
            'route': 'checks/ssc/update',
            'input': "status",
            'value': $scope.data.ssc.status
        };

        stromsparcheckService.saveValue(data).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log('Speichern fehlgeschlagen: ' + error);
        });
    };


    $scope.anonymizeDialog = function () {
        ngDialog.open({
            template: 'templates/landingpage/anonymize.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'success': true
            }
        });
    };


    $scope.anonymize = function () {
        stromsparcheckService.anonymize($stateParams.id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log('Anonymisierung fehlgeschlagen: ' + error);
        });
    };


    /* Saves one field after change or defocus (blur) of an input field */
    $scope.save = function () {
        $scope.responseHasServerError = false;

        $scope.data.ssc.route = 'checks/ssc/createhousehold';
        $scope.data.ssc.ssc_tile_page = tileSlug;

        if ($scope.data.ssc.location_id instanceof Object) {
            $scope.data.ssc.location_id = $scope.data.ssc.location_id.id;
        }
        delete $scope.data.ssc.ssc_user_1_id;
        delete $scope.data.ssc.ssc_user_2_id;
        delete $scope.data.ssc.trainer_user_id;
        if ($scope.data.ssc.user_1 instanceof Object) {
            $scope.data.ssc.ssc_user_1_id = $scope.data.ssc.user_1.id;
        }
        if ($scope.data.ssc.user_2 instanceof Object) {
            $scope.data.ssc.ssc_user_2_id = $scope.data.ssc.user_2.id;
        }
        if ($scope.data.ssc.trainer_user instanceof Object) {
            $scope.data.ssc.trainer_user_id = $scope.data.ssc.trainer_user.id;
        }
        stromsparcheckService.checkDuplicate($scope.data.ssc).then(
            function (data) {
                if (data.has_duplicate && data.has_duplicate === true) {
                    ngDialog.open({
                        template: 'templates/landingpage/check_duplicate.html' + "?v=" + window.version.tag,
                        className: 'dialogLanding',
                        showClose: true,
                        scope: $scope,
                    });
                }
                else {
                    $scope.saveCheck();
                }
            }, function (error) {
                console.log('Duplikatpruefung fehlgeschlagen: ', error);
            }
        );
    };

    $scope.saveCheck = function () {
        ngDialog.close();
        stromsparcheckService.addCheck($scope.data.ssc).then(function (data) {
            $state.go('ssc.overview');
        }, function (error) {
            console.log('Speichern fehlgeschlagen: ', error);
            if ((typeof error.error === 'string' || error.error instanceof String) && error.error.split(".")[0] === "client_error") {//is a client error
                $scope.required = error.data.properties;
            } else {
                $scope.responseHasServerError = true;
            }
        });
    };

    $scope.search = function ($select) {
        if ($select.search !== "") {
            searchService.searchUser($select.search).then(function (data) {
                $scope.searchRes = data;
            }, function (error) {
                console.log(error);
            });
        }
    };


    $scope.search = function ($select, $role, $loc_id) {

        if ($select.search !== "") {
            if ($scope.data.ssc.location_id instanceof Object) {
                $scope.data.ssc.location_id = $scope.data.ssc.location_id.id;
            }
            searchService.searchUser($select.search, $role, $loc_id).then(function (data) {
                $scope.searchRes = data;
            }, function (error) {
                console.log(error);
            });
        }
        $scope.searchRes = [];
    };


});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:lightingController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('lightingController', function ($scope, stromsparcheckService, $stateParams, $rootScope, ngDialog, sscErrorboxService) {


    var tileSlug = 'LIGHTING';
    $scope.saveData = {
        'ssc_id': $stateParams.id
    };
    var formreadStructure = {
        ssc_lighting: {
            parent: "ssc_id",
            many: true
        }
    };
    var errorStructure = {
        light: {
            path: "ssc_lighting[n]"
        }
    };
    $scope.btnIsSaving = [];

    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors(
                {
                    content: $scope.content,
                    properties: $scope.properties,
                    tableProperties: $scope.tableProperties
                },
                newData,
                formreadStructure,
                indexPathStr,
                noWarningConfirm
            );
        }

        stromsparcheckService.appendOldDirecthelpList(newData.content.lighting_directhelp, newData.content.ssc_lighting);

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;
        updateAccordions();

        $scope.errors = sscErrorboxService.createErrorObject(errorStructure, $scope.properties);
        $rootScope.$broadcast("onSscLoadComplete", data.properties);
        $rootScope.$broadcast("errorUpdate", data.properties);
    }

    function read(withErrors) {
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);//don't remember errors, if all errors and warnings from backend
        }, function (error) {
            console.log(error);
        });
    }
    read();

    $scope.save = function (controller, field, value, itemId) {
        var saveParams = stromsparcheckService.resolveSaveParamsFromOldInterface({
            controller: controller,
            field: field,
            value: value,
            itemId: itemId,
            structureObj: formreadStructure,
            contentObj: $scope.content,
            tileSlug: tileSlug
        });
        stromsparcheckService.saveValueNew(saveParams.data, saveParams.route).then(function (data) {
            update(data, true, saveParams.indexPathStr);
        }, function (error) {
            update(error.data, true, saveParams.indexPathStr);
        });
    };


    $scope.addRow = function (tableName, parentId, buttonId) {
        if(!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;

        var route = 'checks/' + tableName.split("_").join("") + '/update';//checks/sscinstalledbrush/update
        var data = {};
        data.ssc_tile_page = tileSlug;
        data[formreadStructure[tableName]['parent']] = parentId;

        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        }, function (error) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        });
    };

    $scope.delete = function(tableName, index, id) {
        stromsparcheckService.delete(tableName, index, id, tileSlug).then(function(data) {
            if(!data) {
                return; //cancelled
            }
            update(data, true);
        }, function(error) {
        });
    };

    $scope.broadcastErrorUpdate = function () {
        $rootScope.$broadcast("errorUpdate", $scope.properties);
    };
    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };

    // Intercept collapse events in order to keep collapse status on update
    $scope.initjquery = function() {
        var a = $(".accordion");

        a.on('shown.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = true;
        });

        a.on('hidden.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = false;
        });
    };

    function updateAccordions() {
        var i;
        if($scope.accordions === undefined) {
            $scope.accordions = [];
            for(i in $scope.content.ssc_lighting) {
                $scope.accordions[i] = [false, $scope.content.ssc_lighting[i].id];
            }
            if($scope.accordions[0]) {
                $scope.accordions[0][0] = true;
            }
        } else {
            var newAccordions = [];
            for(i in $scope.content.ssc_lighting) {
                newAccordions[i] = [false, $scope.content.ssc_lighting[i].id];
            }
            $scope.accordions = stromsparcheckService.copyAccordionStates($scope.accordions, newAccordions);
        }
    }
});
"use strict";

/**
 * @ngdoc controller
 * @name dashboard.controller:kiaController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('kiaController', function ($scope, api, stromsparcheckService, $stateParams, $rootScope, formService, localStorageService, sscErrorboxService, $filter, apiService, ngDialog) {


    var tileSlug = 'KIA';
    $scope.isSaving = false;
    $scope.tileSlug = tileSlug;
    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });
    $scope.formPageScope = $scope;
    $scope.dataTimestamp = 0;

    $scope.$on("sscAdviceSave", function (event, data) {
        update({content: data, properties: $scope.properties, tableProperties: $scope.tableProperties}, false, undefined, false);
    });

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            var structure = {
                ssc_kia: {
                    parent: "ssc_id"
                },
                ssc_kia_directhelp: {
                    many: true,
                    parent: "ssc_kia_id",
                },
                ssc_kia_infomaterial: {
                    many: true,
                    parent: "ssc_kia_id",
                },
                ssc_advice: {
                    many: true,
                    parent: "adviceable_id",
                }
            };
            newData = stromsparcheckService.rememberInputErrors({content:$scope.content, properties: $scope.properties, tableProperties: $scope.tableProperties}, data, structure, indexPathStr, noWarningConfirm);
        }
        $scope.errors = {
            ssc_kia_directhelp: [],
            ssc_kia_infomaterial: []
        };
        angular.forEach($scope.errors, function (errors, table) {
            if (newData.properties[table]) {
                angular.forEach(newData.properties[table], function (tabledata, index) {
                    $scope.errors[table][index] = [];
                    angular.forEach(tabledata, function (field) {
                        $scope.errors[table][index] = $scope.errors[table][index].concat(sscErrorboxService.toMessage(field));
                    });
                });
            }
        });
        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;
        $scope.dataTimestamp++;
    }

    function read(withErrors) {
        //INIT
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);
        }, function (error) {
            console.log(error);
        });
    }

    read();

    $scope.save = function (obj, tableColumn, path) {
        var tableName = tableColumn.split(".")[0];
        var controller = tableName.split("_").join("");
        var field = tableColumn.split(".")[1];
        var value = obj[field];
        var itemId = obj["id"];

        var dataSend = {};
        dataSend.ssc_tile_page = tileSlug;
        dataSend.id = itemId;
        if (field !== "") {
            dataSend[field] = value;
        }

        stromsparcheckService.saveValueNew(dataSend, 'checks/' + controller + '/update').then(function (data) {
            update(data, true, path);
        }, function (error) {
            update(error.data, true, path);
        });
    };

    $scope.delete = function (table, id) {
        $scope.isSaving = true;
        stromsparcheckService.delete(table, null, id, tileSlug).then(
            function (data) {
                $scope.isSaving = false;
                update(data, true);
            },
            function (error) {
                $scope.isSaving = false;
                update(error.data, true);
            }
        );
    }

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };

    $scope.addDirecthelp = function () {
        $scope.addRow("directhelp");
    }

    $scope.addInfomaterial = function () {
        $scope.addRow("infomaterial");
    }

    $scope.addRow = function (section) {
        if ($scope.content.ssc_kia) {
            $scope.isSaving = true;
            var data = {
                ssc_kia_id: $scope.content.ssc_kia.id,
                ssc_id: $stateParams.id,
                ssc_tile_page: tileSlug
            };
            var route = "checks/ssckia" + section + "/create"
            stromsparcheckService.saveValueNew(data, route).then(
                function (data) {
                    $scope.isSaving = false;
                    update(data, true, undefined)
                },
                function (error) {
                    $scope.isSaving = false;
                    update(error.data, true, undefined)
                }
            );
        }
    };
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:heatController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('heatController', function ($scope, stromsparcheckService, $stateParams, $rootScope, ngDialog, sscErrorboxService, $filter) {

    var tileSlug = 'HEAT';
    $scope.tileSlug = tileSlug;
    $scope.$on("$destroy", function () {
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });
    
    var formreadStructure = {//structure of data coming with formread
        ssc_heat: {
            parent: "ssc_id"
        },
        ssc_installed_clip: {
            many: true,
            parent: "ssc_heat_id",
            parentEl: "ssc_heat"
        },
        ssc_installed_shutter_strap_seal: {
            many: true,
            parent: "ssc_heat_id",
            parentEl: "ssc_heat"
        },
        ssc_thermohygrometer: {
            many: true,
            parent: "ssc_heat_id",
            parentEl: "ssc_heat"
        },
        ssc_installed_door_brush: {
            many: true,
            parent: "ssc_heat_id",
            parentEl: "ssc_heat"
        },
        ssc_heat_room_prediction: {
            many: true,
            parent: "ssc_heat_id"
        },
        ssc_heat_infomaterial: {
            many: true,
            parent: "ssc_heat_id"
        }
    };
    $scope.btnIsSaving = [];

    $scope.$on("sscAdviceSave", function (event, data) {
        update({content: data, properties: $scope.properties, tableProperties: $scope.tableProperties}, false, undefined, false);
    });

    function update(data, doRememberErrors, indexPathStr) {
        var newData = data;
        if (doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors({content: $scope.content, properties: $scope.properties, tableProperties: $scope.tableProperties}, newData, formreadStructure, indexPathStr);
        }

        //waermesoforthilfen - HEAT_CLIP - clip_directhelp - ssc_installed_clip
        stromsparcheckService.appendOldDirecthelpList(newData.content.clip_directhelp, newData.content.ssc_heat.ssc_installed_clip);

        //gurtoeffnung von rolllaeden - HEAT_SHUTTER_STRAP_SEAL - strap_seal_directhelp - ssc_installed_shutter_strap_seal
        stromsparcheckService.appendOldDirecthelpList(newData.content.strap_seal_directhelp, newData.content.ssc_heat.ssc_installed_shutter_strap_seal);

        //dichtungsband
        //HEAT_SEALING_TAPE - sealing_tape_directhelp - ssc_seal_tape_install_type_directhelp
        stromsparcheckService.appendOldDirecthelp(newData.content.sealing_tape_directhelp, newData.content.ssc_heat.ssc_seal_tape_install_type_directhelp);

        //tuerbesen - HEAT_DOOR_BRUSH - door_brush_directhelp - ssc_installed_door_brush
        stromsparcheckService.appendOldDirecthelpList(newData.content.door_brush_directhelp, newData.content.ssc_heat.ssc_installed_door_brush);

        //thermometer
        //HEAT_THERMOMETER - thermo_digital_directhelp -  thermohygro_digital_directhelp
        stromsparcheckService.appendOldDirecthelp(newData.content.thermo_digital_directhelp, newData.content.ssc_heat.thermohygro_digital_directhelp);
        //HEAT_THERMOMETER_ANALOG - thermo_analog_directhelp -  thermohygro_analog_directhelp
        stromsparcheckService.appendOldDirecthelp(newData.content.thermo_analog_directhelp, newData.content.ssc_heat.thermohygro_analog_directhelp);

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        // $scope.required = $scope.properties;
        $scope.tableProperties = newData.tableProperties;

        //warm check location
        $scope.modelWarmCheck = true;
        $scope.hasHeatCheck = true;

        updateErrors();
        $rootScope.$broadcast("onSscLoadComplete", data.properties);
        $rootScope.$broadcast("errorUpdate", data.properties);
    }

    function read(withErrors) {
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors);//don't remember errors, if all errors and warnings from backend
        }, function (error) {
            console.log(error);
        });
    }

    read();

    $scope.addRow = function (tableName, parentId, buttonId) {
        if(!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;

        var route = 'checks/' + tableName.split("_").join("") + '/update';//checks/sscinstalledbrush/update
        var data = {};
        data.ssc_tile_page = tileSlug;
        data[formreadStructure[tableName]['parent']] = parentId;

        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        }, function (error) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        });
    };

    $scope.broadcastErrorUpdate = function () {
        $rootScope.$broadcast("errorUpdate", $scope.properties);
    };

    $scope.saveInfomaterial = function () {};


    $scope.save = function (controller, field, value, itemId, ssc_heat_id) {
        var tableName = stromsparcheckService.getTablenameFromController(controller, formreadStructure);
        var indexPathStr = stromsparcheckService.resolveIndexPathStr(tableName, itemId, formreadStructure, $scope.content) + "." + field;
        var route = 'checks/' + controller + '/update';

        var data = {};
        data.ssc_tile_page = tileSlug;
        data[field] = value;
        data.id = itemId;
        if(ssc_heat_id){
            data.ssc_heat_id=ssc_heat_id;
        }
        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            update(data, true, indexPathStr);
        }, function (error) {
            update(error.data, true, indexPathStr);
        });
    };


    function updateErrors() {
        var structure = {
            clip: {
                path: "ssc_heat.ssc_installed_clip[]"
            },
            shutterStrapSeal: {
                path: "ssc_heat.ssc_installed_shutter_strap_seal[]"
            },
            sealTape: {
                path: "ssc_heat",
                fields: ["seal_tape_packages", "seal_tape_install_type_id", "seal_tape_room_type_id", "seal_tape_length", "seal_tape_directhelp_id", "seal_tape_gap_type_id"]
            },
            thermo: [
                {
                    path: "ssc_heat",
                    fields: ["thermohygro_analog_directhelp_id", "thermohygro_digital_directhelp_id"]
                },
                {
                    path: "ssc_heat.ssc_thermohygrometer[]"
                }
            ],
            doorBrush: {
                path: "ssc_heat.ssc_installed_door_brush[]"
            },
            advice: {
                path: "ssc_heat",
                fields: ["advice_*", "tip_*", "information_for_household", "internal_comment", "ssc_advice_count"]
            },
            prediction: {
                path: "ssc_heat_room_prediction[]",
            },
            prediction_total: {
                path: "ssc_heat",
                fields: ["room_savings_percent"]
            },
            infomaterial: {
                path: "ssc_heat_infomaterial[]"
            }
        };
        $scope.errors = sscErrorboxService.createErrorObject(structure, $scope.properties);
    }

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, 'HEAT');
    };

    $scope.delete = function (tableName, index, id) {
        stromsparcheckService.delete(tableName, index, id, tileSlug).then(function (data) {
            if (!data) {
                return; //cancelled
            }
            update(data, true);
        }, function (error) {
        });
    };

});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:generalInformationController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('generalInformationController', function ($scope, stromsparcheckService, $stateParams, $state, $rootScope, ngDialog, sscErrorboxService, $anchorScroll) {

    var tileSlug = 'GENERAL_INFO';

    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    $scope.read = function(withErrors) {
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            $scope.data = data.content;
            $scope.required = data.properties;
            $scope.showerrorbox1 = 0;
            $scope.showerrorbox2 = 0;
            $scope.showerrorbox3 = 0;
            $scope.showerrorbox4 = 0;
            $scope.showerrorbox5 = 0;
            $scope.showerrorbox6 = 0;
            $scope.showerrorbox7 = 0;
            $scope.showerrorbox8 = 0;
            if (data.content.ssc_general.position_flat_house_matrix != undefined) {
                $scope.fw_lwh_h1 = parseInt(data.content.ssc_general.position_flat_house_matrix[0]);
                $scope.fw_lwh_h2 = parseInt(data.content.ssc_general.position_flat_house_matrix[1]);
                $scope.fw_lwh_h3 = parseInt(data.content.ssc_general.position_flat_house_matrix[2]);
                $scope.fw_lwh_h4 = parseInt(data.content.ssc_general.position_flat_house_matrix[3]);
                $scope.fw_lwh_h5 = parseInt(data.content.ssc_general.position_flat_house_matrix[4]);
                $scope.fw_lwh_h6 = parseInt(data.content.ssc_general.position_flat_house_matrix[5]);
                $scope.fw_lwh_h7 = parseInt(data.content.ssc_general.position_flat_house_matrix[6]);
                $scope.fw_lwh_h8 = parseInt(data.content.ssc_general.position_flat_house_matrix[7]);
                $scope.fw_lwh_h9 = parseInt(data.content.ssc_general.position_flat_house_matrix[8]);
                $scope.fw_lwh_h10 = parseInt(data.content.ssc_general.position_flat_house_matrix[9]);
                $scope.fw_lwh_h11 = parseInt(data.content.ssc_general.position_flat_house_matrix[10]);
            }
            else {
                $scope.fw_lwh_h1 = 0;
                $scope.fw_lwh_h2 = 0;
                $scope.fw_lwh_h3 = 0;
                $scope.fw_lwh_h4 = 0;
                $scope.fw_lwh_h5 = 0;
                $scope.fw_lwh_h6 = 0;
                $scope.fw_lwh_h7 = 0;
                $scope.fw_lwh_h8 = 0;
                $scope.fw_lwh_h9 = 0;
                $scope.fw_lwh_h10 = 0;
                $scope.fw_lwh_h11 = 0;
            }
            $scope.position_flat_house_matrix = {
                "fw_lwh_h1": $scope.fw_lwh_h1,
                "fw_lwh_h2": $scope.fw_lwh_h2,
                "fw_lwh_h3": $scope.fw_lwh_h3,
                "fw_lwh_h4": $scope.fw_lwh_h4,
                "fw_lwh_h5": $scope.fw_lwh_h5,
                "fw_lwh_h6": $scope.fw_lwh_h6,
                "fw_lwh_h7": $scope.fw_lwh_h7,
                "fw_lwh_h8": $scope.fw_lwh_h8,
                "fw_lwh_h9": $scope.fw_lwh_h9,
                "fw_lwh_h10": $scope.fw_lwh_h10,
                "fw_lwh_h11": $scope.fw_lwh_h11
            };

            updateErrors();
            $rootScope.$broadcast("errorUpdate", data.properties);
            $scope.tableProperties = data.tableProperties;

        }, function (error) {
            console.log(error);
        });
    };

    $scope.read(false);

    /* Updates the flat index string after a checbbox has been changed */
    $scope.update_flat_position = function () {
        $scope.data.ssc_general.position_flat_house_matrix = "";
        angular.forEach($scope.position_flat_house_matrix, function (value, key) {
            $scope.data.ssc_general.position_flat_house_matrix += value;
        });
        $scope.save('sscgeneral', 'position_flat_house_matrix', $scope.data.ssc_general.position_flat_house_matrix);
    };

    /* Saves one field after change or defocus (blur) of an input field */
    $scope.save = function (controller, field, value) {
        var data = {
            'id': $scope.data.ssc_general.id,
            'route': 'checks/' + controller + '/update',
            'ssc_tile_page': tileSlug
        };
        data[field] = value;

        stromsparcheckService.saveValue(data).then(function (data) {
            // Check if there is an existing error in another field.

            var errorflag = false;
            $scope.showerrorbox1 = 0;
            $scope.showerrorbox2 = 0;
            $scope.showerrorbox3 = 0;
            $scope.showerrorbox4 = 0;
            $scope.showerrorbox5 = 0;
            $scope.showerrorbox6 = 0;
            $scope.showerrorbox7 = 0;
            $scope.showerrorbox8 = 0;
            for (var key in $scope.required.ssc_general) {
                if ($scope.required.ssc_general[key] && $scope.required.ssc_general[key].error) {
                    if (field != key) {
                        data.properties.ssc_general[key] = $scope.required.ssc_general[key];
                        data.content.ssc_general[key] = $scope.data.ssc_general[key];
                        errorflag = true;
                    }
                }
            }
            if (errorflag) {
                $rootScope.$broadcast("errorUpdate", data.properties);
            }

            $scope.data = data.content;
            // required fields

            $scope.required = data.properties;
            $scope.tableProperties = data.tableProperties;
            updateErrors();
        }, function (error) {
            console.log('Speichern fehlgeschlagen: ' + error);
            console.log(field);

            // required fields
            var errorflag = false;
            $scope.showerrorbox1 = 0;
            $scope.showerrorbox2 = 0;
            $scope.showerrorbox3 = 0;
            $scope.showerrorbox4 = 0;
            $scope.showerrorbox5 = 0;
            $scope.showerrorbox6 = 0;
            $scope.showerrorbox7 = 0;
            $scope.showerrorbox8 = 0;
            for (var key in $scope.required.ssc_general) {
                if ($scope.required.ssc_general[key] && ($scope.required.ssc_general[key].error || $scope.required.ssc_general[key].warning)) {
                    if (field != key) {
                        error.data.properties.ssc_general[key] = $scope.required.ssc_general[key];
                        error.data.content.ssc_general[key] = $scope.data.ssc_general[key];
                        errorflag = true;
                    }
                }
            }
            if (errorflag) {
                $rootScope.$broadcast("errorUpdate", error.data.properties);
            }

            $scope.required = error.data.properties;
            $scope.tableProperties = error.data.tableProperties;
            updateErrors();
        });
    };


    function updateErrors() {
        var i;
        $scope.errorsGeneral = []; //Allgemeine Angaben

        if($scope.required) {
            var generalFields = [
                "privacy_is_signed",
                "grants_later_contact",
                "has_received_voucher"
            ];
            $scope.errorsGeneral = sscErrorboxService.messagesFromRow($scope.required.ssc_general, generalFields);
        }
    }


    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };

    $scope.ready = function () {
        $scope.read(1);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };
});

"use strict";

angular.module('frontendApp').controller('heattoolController', function ($scope, stromsparcheckService, $stateParams, formService, $timeout, $rootScope, ngDialog) {
    $scope.showerrorbox0 = 0;
    $scope.data = {
        ssc_heating_tool: {}
    };
    $scope.memory;

    var tileSlug = 'HEATING_TOOL';
    $scope.calculateFuelPart = function () {
        if ($scope.data.ssc_heating_tool.fuel_total_kwh_from_bill) {
            $scope.data.ssc_heating_tool.building_hw_fuel_bill = $scope.data.ssc_heating_tool.building_hw_fuel_bill_pct * 0.01 * $scope.data.ssc_heating_tool.fuel_total_kwh_from_bill;
            $scope.saveWrapper('data.ssc_heating_tool.building_hw_fuel_bill');
        }
    };

    $scope.copyErrors = function (field, target) {
        if (!$scope.required || !$scope.required.ssc_heating_tool || field == "bill_heating_begin" || field == "bill_heating_end" || field == "bill_usage_begin" || field == "bill_usage_end") {
            return false;
        }

        var errorflag = false;

        for (var key in $scope.required.ssc_heating_tool) {
            if ($scope.required.ssc_heating_tool[key] && ($scope.required.ssc_heating_tool[key].error || $scope.required.ssc_heating_tool[key].warning)) {
                if (field !== key) {
                    target.properties.ssc_heating_tool[key] = $scope.required.ssc_heating_tool[key];
                    target.content.ssc_heating_tool[key] = $scope.data.ssc_heating_tool[key];

                    errorflag = true;
                }
            }
        }

        return errorflag;
    };

    $scope.read = function () {
        stromsparcheckService.read($stateParams.id, tileSlug).then(function (data) {
            $scope.data = data.content;
            if ($scope.data.ssc_heating_tool) {
                $scope.memory = {
                    data: JSON.parse(JSON.stringify(data.content))
                };//deep copy
                $scope.drawnTacho($scope.data.ssc_heating_tool.stat_building_fuel_index, $scope.data.ssc_heating_tool.stat_flat_fuel_index);
            }

            $scope.required = data.properties;
            $scope.tableProperties = data.tableProperties;

            $scope.sign();

        }, function (error) {
            console.log(error);
        });
    };

    $scope.saveWrapper = function(modelStr) {
        $scope.save({
            target: {
                attributes: [
                    {name: 'ng-model', nodeValue: modelStr}]
            }
        });
    };
    $scope.save = function (event, forcePath) {
        forcePath = forcePath || false;

        var datafield,
                split,
                value,
                oldValue,
                keyname,
                update = {
                    route: 'checks/sscheatingtool/update',
                    id: $scope.data.ssc_heating_tool.id,
                    ssc_id: $stateParams.id,
                    ssc_tile_page: tileSlug
                };

        if (!forcePath) {
            if (!event || !event.target || !event.target.attributes) {
                console.log("error: ng-model not found.");
                return;
            }

            for (var i = 0; i < event.target.attributes.length; i++) {
                if (event.target.attributes[i].name == 'ng-model') {
                    datafield = event.target.attributes[i].nodeValue;
                    break;
                }
            }
            if (!datafield) {
                console.log("error: attr ng-model not found.");
                return;
            }

            split = datafield.split('.');
            keyname = split[split.length - 1];

            /*not ECMAScript syntax, will not work in IE*/
//            value=split.reduce((o,i)=>o[i], $scope);

            if ($scope.memory) {
                oldValue = split.reduce(function (o, i) {
                    if (o) {
                        return o[i];
                    }
                }, $scope.memory);
            }

            value = split.reduce(function (o, i) {
                if (o) {
                    return o[i];
                }
            }, $scope);
            update[keyname] = value;
        } else {
            split = forcePath.split('.');
            keyname = split[split.length - 1];
            value = split.reduce(function (o, i) {
                if (o) {
                    return o[i];
                }
            }, $scope);

            if ($scope.memory) {
                oldValue = split.reduce(function (o, i) {
                    if (o) {
                        return o[i];
                    }
                }, $scope.memory);
            }

            //forced
            update[keyname] = value;
        }

        //check 4 changes
        if (oldValue != value || (!oldValue && !value)) {
            stromsparcheckService.saveValue(update).then(function (data) {
                var errorflag = $scope.copyErrors(keyname, data);
                if (errorflag) {
                    $(document).ready(function () {
                        $rootScope.$broadcast("errorUpdate", data.properties);
                    });
                }

                //data
                $scope.data = data.content;
                $scope.memory = {
                    data: JSON.parse(JSON.stringify(data.content))
                };//deep copy

                // required fields
                $scope.showerrorbox0 = 0;
                $scope.required = data.properties;
                $scope.tableProperties = data.tableProperties;

                $scope.drawnTacho($scope.data.ssc_heating_tool.stat_building_fuel_index, $scope.data.ssc_heating_tool.stat_flat_fuel_index);
            }, function (error) {
                console.log('Speichern fehlgeschlagen: ' + error);

                var errorflag = $scope.copyErrors(keyname, error.data);
                if (errorflag) {
                    $(document).ready(function () {
                        $rootScope.$broadcast("errorUpdate", error.data.properties);
                    });
                }

                // required fields
                $scope.required = error.data.properties;
                $scope.tableProperties = error.data.tableProperties;

                $scope.drawnTacho($scope.data.ssc_heating_tool.stat_building_fuel_index, $scope.data.ssc_heating_tool.stat_flat_fuel_index);
            });
        }
    };

    $scope.tachoCss = {
        tachotop: {left: "0px", display: 'none'},
        tachobottom: {left: "0px", display: 'none'},
        headlinetop: {left: "-31px"},
        headlinebottom: {left: "-31px"}
    };


    $scope.drawnTacho = function (kennzGeb, kennzWohn) {
        var highestlimit = 0;

        stromsparcheckService.readTachoHeatTool('checks/ssctacho/readheattool', kennzWohn).then(function (data) {
            highestlimit = data.limitHighest;
            $scope.tachoLableCss = [];


            angular.forEach(data.limitsBandLable, function (limit) {
                var fontweight = "normal";
                if (limit.limit_id === data.limitId) {
                    var fontweight = "bold";
                }

                if (limit.limit_id !== 9) {
                    var perc = limit.to / highestlimit * 100;
                    var lablePerc = (((limit.to / highestlimit * 100) - (limit.from / highestlimit * 100)) / 2) + (limit.from / highestlimit * 100) - 1;
                    $scope.tachoLableCss.push(
                            {id: limit.limit_id,
                                lineCss: {left: perc + "%", 'font-weight': 'bold'},
                                lableCss: {left: lablePerc + "%", 'font-weight': fontweight},
                                lable: limit.lable
                            });
                }
                ;
                if (limit.limit_id === 9) {
                    var lablePerc = ((100 - (limit.from / highestlimit * 100)) / 2) + (limit.from / highestlimit * 100) - 1;
                    $scope.tachoLableCss.push(
                            {id: limit.limit_id,
                                lineCss: {left: "0%", display: 'none'},
                                lableCss: {left: lablePerc + "%", 'font-weight': fontweight},
                                lable: limit.lable
                            });
                }
                ;
            });
        }, function (error) {
            console.log(error);
        });


        if (kennzGeb === null)
        {
            kennzGeb = 0;
        }

        if (kennzWohn === null)
        {
            kennzWohn = 0;
        }


        //get image size
        var img = document.getElementById('tacho_image');

        var imgpath = new Image();
        imgpath.src = img.src;
        imgpath.onload = function () {//fix rendering update #1

            //calc pos
            var gebPosPerc = kennzGeb / 250 * 100;
            var wohnPosPerc = kennzWohn / 250 * 100;
            //text anti overflow
            if (kennzGeb < 14) {
                $scope.tachoCss.headlinetop = {left: 0};
            } else {
                $scope.tachoCss.headlinetop = {left: "-31px"};
            }
            if (kennzWohn < 14) {
                $scope.tachoCss.headlinebottom = {left: 0};
            } else {
                $scope.tachoCss.headlinebottom = {left: "-31px"};
            }

            if (gebPosPerc > 98)
            {
                gebPosPerc = 98;
            }
            if (wohnPosPerc > 98)
            {
                wohnPosPerc = 98;
            }


            if (gebPosPerc > 0)
            {
                $scope.tachoCss.visible = true;
            }

            if (gebPosPerc === 0)
            {
                $scope.tachoCss.visible = false;
            }

            //set pos
            $timeout(function () {//fix rendering update #2
                $scope.tachoCss.tachotop = {left: gebPosPerc + "%", display: 'block'};
                $scope.tachoCss.tachobottom = {left: wohnPosPerc + "%", display: 'block'};
            });
        };
    };

    $scope.sign = function () {
        if ($scope.data) {
            if ($scope.data.stat_heating_avg > 0) {
                $scope.data.stat_heating_avg = '+' + $scope.data.stat_heating_avg;
            }
            if ($scope.data.stat_hw_avg > 0) {
                $scope.data.stat_hw_avg = '+' + $scope.data.stat_hw_avg;
            }
            if ($scope.data.stat_flat_fuel_avg > 0) {
                $scope.data.stat_flat_fuel_avg = '+' + $scope.data.stat_flat_fuel_avg;
            }
        }
    };


    $scope.ready = function (tile) {

        stromsparcheckService.ready($stateParams.id, tile).then(function (data) {

            // Alle Pflichtfelder sind gesetzt
            if (true) {  // if(false) {
                ngDialog.open({
                    template: 'templates/landingpage/ready_success.html' + "?v=" + window.version.tag,
                    className: 'dialogLanding',
                    showClose: false
                });
            }
            //es sind nicht alle Felder ausgefüllt
            else {
                ngDialog.open({
                    template: 'templates/landingpage/ready_failed.html' + "?v=" + window.version.tag,
                    className: 'dialogLanding',
                    showClose: false,
                    preCloseCallback: function () {
                        $scope.required = data.data.properties;
                        $rootScope.$broadcast("errorUpdate", data.data.properties);
                    }
                });
            }

        }, function (error) {
            console.log('Speichern fehlgeschlagen: ' + error);
        });

    };

    $scope.read();
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:energyController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('energyController', function ($scope, stromsparcheckService, $stateParams, formService, ngDialog, $rootScope, sscErrorboxService) {

    var tileSlug = 'ENERGY_HEAT_WATER';
    $scope.$on("$destroy", function () {
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    $scope.tachoData = [];

    var formreadStructure = {//structure of data coming with formread
        ssc_energy: {
            parent: 'ssc_id'
        }
    };
    $scope.btnIsSaving = [];

    function update(data, doRememberErrors, indexPathStr) {
        var newData = data;
        if (doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors({content: $scope.content, properties: $scope.properties, tableProperties: $scope.tableProperties}, newData, formreadStructure, indexPathStr);
        }

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;

        //update Tacho
        $scope.drawnTacho($scope.content.ssc_energy.power_index, 1);
        $scope.drawnTacho($scope.content.ssc_energy.water_index, 3);
        $scope.drawnTacho($scope.content.ssc_energy.warmwater_index, 4);
        $scope.drawnTacho($scope.content.ssc_energy.heating_index, 2);

        updateErrors();
        $rootScope.$broadcast("onSscLoadComplete", data.properties);
        $rootScope.$broadcast("errorUpdate", data.properties);
    }

    function read(withErrors) {
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors);//don't remember errors, if all errors and warnings from backend
        }, function (error) {
            console.log(error);
        });
    }

    read();

    /*$scope.broadcastErrorUpdate = function () {
        $rootScope.$broadcast("errorUpdate", $scope.properties);
    };*/

    $scope.save = function (controller, field, value) {
        var itemId = $scope.content.ssc_energy.id;
        var tableName = stromsparcheckService.getTablenameFromController(controller, formreadStructure);//ssc_installed_brush
        var indexPathStr = stromsparcheckService.resolveIndexPathStr(tableName, itemId, formreadStructure, $scope.content) + "." + field;//ssc_heat.ssc_installed_brush.1.directhelp_id
        var route = 'checks/' + controller + '/update';//checks/sscinstalledbrush/update

        var data = {};
        data.ssc_tile_page = tileSlug;
        data[field] = value;
        data.id = itemId;
        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            update(data, true, indexPathStr);
        }, function (error) {
            update(error.data, true, indexPathStr);
        });
    };


    function updateErrors() {
        var structure = {
            bills: {
                path: 'ssc_energy',
                fields: ['power_bill_type_id', 'water_bill_type_id', 'warmwater_bill_type_id', 'heating_bill_type_id']
            },
            power: {
                path: 'ssc_energy',
                fields: ['power_bill_period_from', 'power_bill_period_to', 'power_price', 'power_heating_was_deducted',
                    'power_consumption', 'power_consumption_year', 'power_has_gas_stove', 'power_is_pump_included',
                    'power_index']
            },
            electric_meter: {
                path: 'ssc_energy',
                fields: ['electric_meter_date', 'electric_meter_number', 'electric_meter_count']
            },
            water: {
                path: 'ssc_energy',
                fields: ['water_bill_period_from', 'water_bill_period_to', 'water_price', 'water_total_counter_available_yn_id',
                    'water_total_water_count', 'water_total_water_count_year', 'water_cold_counter_available_yn_id',
                    'water_cold_water_count', 'water_cold_water_count_year', 'water_warm_counter_available_yn_id',
                    'water_warm_water_count', 'water_warm_water_count_year', 'water_has_dishwasher', 'water_index']
            },
            warmwater: {
                path: 'ssc_energy',
                fields: ['warmwater_bill_period_from', 'warmwater_bill_period_to', 'warmwater_preparation_type_id',
                    'warmwater_other_heating', 'warmwater_fuel_price', 'warmwater_consumption_count',
                    'warmwater_additional_system', 'warmwater_index']
            },
            heating: {
                path: 'ssc_energy',
                fields: ['heating_bill_period_from', 'heating_bill_period_to', 'ssc_heating_system_type_id',
                    'ssc_fuel_type_id', 'heating_total_heating_count', 'heating_price', 'heating_additional_system',
                    'heating_water_heating_included_yn_id', 'has_heat_cost_allocator', 'heating_index']
            }
        };
        $scope.errors = sscErrorboxService.createErrorObject(structure, $scope.properties);
    }

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };

    $scope.drawnTacho = function (kennzGeb, tachoId) {
        kennzGeb = kennzGeb === null ? 0 : kennzGeb;
        stromsparcheckService.readTacho('checks/ssctacho/read', $stateParams.id, kennzGeb, tachoId).then(function (data) {
            $scope.tachoData[tachoId] = {
                kennzGeb: kennzGeb,
                top: data.val,
                label: data.limitBandLable
            };
        }, function (error) {
            delete $scope.tachoData[tachoId];
            console.log(error);
        });
    };

});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:electricBoilerController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('electricBoilerController', function ($scope, stromsparcheckService, $stateParams, ngDialog, $rootScope, sscErrorboxService) {

    var tileSlug = 'ELECTRIC_BOILER';
    $scope.saveData = {
        'ssc_id': $stateParams.id
    };
    var formreadStructure = {
        ssc_electric_boiler: {
            parent: "ssc_id",
            many: true
        }
    };
    var errorStructure = {
        boiler: {
            path: "ssc_electric_boiler[n]"
        }
    };
    $scope.btnIsSaving = [];

    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors(
                {
                    content: $scope.content,
                    properties: $scope.properties,
                    tableProperties: $scope.tableProperties
                },
                newData,
                formreadStructure,
                indexPathStr,
                noWarningConfirm
            );
        }

        stromsparcheckService.appendOldDirecthelpList(newData.content.electric_boiler_directhelp, newData.content.ssc_electric_boiler);

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;
        updateAccordions();

        $scope.errors = sscErrorboxService.createErrorObject(errorStructure, $scope.properties);
        $rootScope.$broadcast("onSscLoadComplete", data.properties);
        $rootScope.$broadcast("errorUpdate", data.properties);
    }

    function read(withErrors) {
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);//don't remember errors, if all errors and warnings from backend
        }, function (error) {
            console.log(error);
        });
    }
    read();

    $scope.save = function (controller, field, value, itemId) {
        var saveParams = stromsparcheckService.resolveSaveParamsFromOldInterface({
            controller: controller,
            field: field,
            value: value,
            itemId: itemId,
            structureObj: formreadStructure,
            contentObj: $scope.content,
            tileSlug: tileSlug
        });
        stromsparcheckService.saveValueNew(saveParams.data, saveParams.route).then(function (data) {
            update(data, true, saveParams.indexPathStr);
        }, function (error) {
            update(error.data, true, saveParams.indexPathStr);
        });
    };

    $scope.addRow = function (tableName, parentId, buttonId) {
        if(!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;

        var route = 'checks/' + tableName.split("_").join("") + '/update';//checks/sscinstalledbrush/update
        var data = {};
        data.ssc_tile_page = tileSlug;
        data[formreadStructure[tableName]['parent']] = parentId;

        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        }, function (error) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        });
    };

    $scope.delete = function(tableName, index, id) {
        stromsparcheckService.delete(tableName, index, id, tileSlug).then(function(data) {
            if(!data) {
                return; //cancelled
            }
            update(data, true);
        }, function(error) {
        });
    };

    $scope.broadcastErrorUpdate = function () {
        $rootScope.$broadcast("errorUpdate", $scope.properties);
    };

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };

    // Intercept collapse events in order to keep collapse status on update
    $scope.initjquery = function() {
        var a = $(".accordion");

        a.on('shown.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = true;
        });

        a.on('hidden.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = false;
        });
    };

    function updateAccordions() {
        var i;
        if($scope.accordions === undefined) {
            $scope.accordions = [];
            for(i in $scope.content.ssc_electric_boiler) {
                $scope.accordions[i] = [false, $scope.content.ssc_electric_boiler[i].id];
            }
            if($scope.accordions[0]) {
                $scope.accordions[0][0] = true;
            }
        } else {
            var newAccordions = [];
            for(i in $scope.content.ssc_electric_boiler) {
                newAccordions[i] = [false, $scope.content.ssc_electric_boiler[i].id];
            }
            $scope.accordions = stromsparcheckService.copyAccordionStates($scope.accordions, newAccordions);
        }
    }
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:download
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('download', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/stromsparcheck/check/download/download.view.html' + "?v=" + window.version.tag,
        controller: 'downloadController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:downloadController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('downloadController', function ($scope, $rootScope, localStorageService, $stateParams, apiService) {

    $scope.updateSetting = function (download, setting) {
        var data = {
            ssc_id: $stateParams.id,
            ssc_download_setting_id: setting.id,
            value: setting.value
        }
        download.is_disabled = true;
        apiService.post('checks/sscdownloadsetting/update', data).then(
            function (data) {
                download.is_disabled = false;
                setting.value = data.value;
            },
            function (error) {
                download.is_disabled = false;
            }
        )
    };

    apiService.post('checks/sscdownload/read', {ssc_id: $stateParams.id}).then(function (data) {
        if (data) {
            $rootScope.$broadcast("onSscLoadComplete", data);
        }
        $scope.ssc_id = $stateParams.id;
       
        $scope.downloads = data;
    }, function (error) {
        console.log(error);
    });
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:energyController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('deviceController', function ($scope, stromsparcheckService, $stateParams, formService, ngDialog, $rootScope, sscErrorboxService) {

    var tileSlug = 'ADDITIONAL_DEVICES';
    $scope.tileSlug = tileSlug;
    $scope.saveData = {
        'ssc_id': $stateParams.id
    };
    var formreadStructure = {
        ssc: {
        },
        ssc_device: {
            parent: "ssc_id",
            many: true
        }
    };
    var errorStructure = {
        device: {
            path: "ssc_device[n]"
        }
    };
    $scope.btnIsSaving = [];

    $scope.deviceSettingsConfig = [];

    $scope.isDeviceSettingsOpen = function (device) {
        var isOpen = false;
        if (device.hasOwnProperty('id')) {
            isOpen = $scope.deviceSettingsConfig[device.id] === true;
        }
        return isOpen;
    };

    $scope.toggleDeviceSettings = function (device) {
        $scope.deviceSettingsConfig[device.id] = $scope.deviceSettingsConfig[device.id] !== true;
        console.log(device.id, $scope.deviceSettingsConfig)
    };

    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    $scope.$on("sscAdviceSave", function (event, data) {
        update({content: data, properties: $scope.properties, tableProperties: $scope.tableProperties}, false, undefined, false);
    });

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors(
                {
                    content: $scope.content,
                    properties: $scope.properties,
                    tableProperties: $scope.tableProperties
                },
                newData,
                formreadStructure,
                indexPathStr,
                noWarningConfirm
            );
        }

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;
        updateAccordions();

        $scope.errors = sscErrorboxService.createErrorObject(errorStructure, $scope.properties);
        $rootScope.$broadcast("onSscLoadComplete", data.properties);
        $rootScope.$broadcast("errorUpdate", data.properties);
    }

    function read(withErrors) {
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);//don't remember errors, if all errors and warnings from backend
        }, function (error) {
            console.log(error);
        });
    }
    read();

    $scope.save = function (controller, field, value, itemId) {
        var saveParams = stromsparcheckService.resolveSaveParamsFromOldInterface({
            controller: controller,
            field: field,
            value: value,
            itemId: itemId,
            structureObj: formreadStructure,
            contentObj: $scope.content,
            tileSlug: tileSlug
        });
        stromsparcheckService.saveValueNew(saveParams.data, saveParams.route).then(function (data) {
            update(data, true, saveParams.indexPathStr);
        }, function (error) {
            update(error.data, true, saveParams.indexPathStr);
        });
    };

    $scope.addRow = function (tableName, parentId, buttonId) {
        if(!$scope.btnIsSaving[buttonId]) {
            $scope.btnIsSaving[buttonId] = 0;
        }
        $scope.btnIsSaving[buttonId]++;

        var route = 'checks/' + tableName.split("_").join("") + '/update';//checks/sscinstalledbrush/update
        var data = {};
        data.ssc_tile_page = tileSlug;
        data[formreadStructure[tableName]['parent']] = parentId;

        stromsparcheckService.saveValueNew(data, route).then(function (data) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        }, function (error) {
            $scope.btnIsSaving[buttonId]--;
            update(data, true);
        });
    };

    $scope.delete = function(tableName, index, id) {
        stromsparcheckService.delete(tableName, index, id, tileSlug).then(function(data) {
            if(!data) {
                return; //cancelled
            }
            update(data, true);
        }, function(error) {
        });
    };

    $scope.broadcastErrorUpdate = function () {
        $rootScope.$broadcast("errorUpdate", $scope.properties);
    };

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };

    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };

    // Intercept collapse events in order to keep collapse status on update
    $scope.initjquery = function() {
        var a = $(".accordion");

        a.on('shown.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = true;
        });

        a.on('hidden.bs.collapse', function(event){
            var id = event.currentTarget.id.replace("accordion","");
            $scope.accordions[id][0] = false;
        });
    };

    $scope.$on("textmodulUpdated", function (event, data) {
        if(data.text){
            $scope.save('sscdevice', 'comment', data.text, data.id);
        }
    });

    function updateAccordions() {
        var i;
        if($scope.accordions === undefined) {
            $scope.accordions = [];
            for(i in $scope.content.ssc_device) {
                $scope.accordions[i] = [false, $scope.content.ssc_device[i].id];
            }
            if($scope.accordions[0]) {
                $scope.accordions[0][0] = true;
            }
        } else {
            var newAccordions = [];
            for(i in $scope.content.ssc_device) {
                newAccordions[i] = [false, $scope.content.ssc_device[i].id];
            }
            $scope.accordions = stromsparcheckService.copyAccordionStates($scope.accordions, newAccordions);
        }
    }

});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:abstractControllers
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('abstractController', function ($scope, stromsparcheckService, $stateParams, sscErrorboxService) {

    var tileSlug = 'SUMMARY';

    var errorStructure = {
        summary: {
            path: "ssc_summary"
        }
    };

    stromsparcheckService.read($stateParams.id, tileSlug).then(function (data) {
        $scope.data = data.content;
        $scope.required = data.properties;

        $scope.errors = sscErrorboxService.createErrorObject(errorStructure, {ssc_summary: data.properties});

        // Calculate number of lamps
        var lightCount = 0;
        angular.forEach($scope.data.lighting, function(value, key) {
            lightCount += $scope.data.lighting[key].count;
        });
        $scope.data.light_count = lightCount;
        var toilet_cost = 0;
        angular.forEach($scope.data.toilet_flush, function(value, key) {
            toilet_cost += parseFloat($scope.data.toilet_flush[key].cost);
        });
        $scope.data.toilet_cost = toilet_cost;
        var boiler_cost = 0;
        angular.forEach($scope.data.hot_water, function(value, key) {
            boiler_cost += parseFloat($scope.data.hot_water[key].cost);
        });
        $scope.data.boiler_cost = boiler_cost;
        var tap_cost = 0;
        angular.forEach($scope.data.tap, function(value, key) {
            tap_cost += parseFloat($scope.data.tap[key].cost);
        });
        //$scope.data.tap_cost = tap_cost;

        //TODO properties
    }, function (error) {
        console.log(error);
    });

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenureview', function (tabmenuReviewService, $stateParams, $filter, $compile, reviewService) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenuReview/tabmenuReview.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (scope.pageIndex == 0)
                    scope.pageIndex++;
            };

            var updateView = function () {
                scope.tabs = [];

                if(reviewService.hasTab("directhelpreview")) {
                    scope.tabs.push({
                        name: "directhelpreview",
                        title: $filter('translate')('TAB_DIRECTHELP'),
                        permissionOnly: ['ADMIN','TRAINER', 'LOKO', 'EFB', 'BUKO']
                    });
                }
                if(reviewService.hasTab("locationreview")) {
                    scope.tabs.push({
                        name: "locationreview",
                        title: $filter('translate')('TAB_LOCATION'),
                        permissionOnly: ['ADMIN','TRAINER', 'LOKO', 'EFB', 'REKO', 'BUKO', 'KGA']
                    });
                }
                if(reviewService.hasTab("controllingreview")) {
                    scope.tabs.push({
                        name: "controllingreview",
                        title: $filter('translate')('TAB_CONTROLLING'),
                        permissionOnly: ['ADMIN','TRAINER', 'LOKO', 'EFB', 'BUKO', 'REKO']
                    });
                }
                if(reviewService.hasTab("othersreview")) {
                    scope.tabs.push({
                        name: "othersreview",
                        title: $filter('translate')('TAB_OTHERS'),
                        permissionOnly: ['ADMIN','EFB','BUKO']
                    });
                }
                if(reviewService.hasTab("photovoltaicreview")) {
                    scope.tabs.push({
                        name: "photovoltaicreview",
                        title: $filter('translate')('TAB_PHOTOVOLTAIC'),
                        permissionOnly: ['ADMIN','TRAINER', 'LOKO', 'EFB', 'BUKO', 'REKO']
                    });
                }

                var html = tabmenuReviewService.setTabs(scope.tabs);
                var template = angular.element(html);
                var myEl = angular.element(document.querySelector('.tab-content'));
                myEl.empty();
                myEl.append(template);
                $compile(template)(scope);
            };


            updateView();

        }
    };
}); 
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('photovoltaicreview', function ($filter, $compile, tabmenuReviewService, localStorageService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/review/review.view.html' + "?v=" + window.version.tag,
        controller: "photovoltaicReviewController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_PHOTOVOLTAIC');
            scope.userEmail = localStorageService.get('user').email;

            var updateView = function (site) {
                var html = tabmenuReviewService.buildSite(site);
                var template = angular.element(html);
                var myEl = angular.element(document.querySelector('.filter-content'));
                myEl.empty();
                if (template.length === 1) {
                    myEl.append(template);
                    $compile(template)(scope);
                }


            };

            scope.$on("photovoltaicreview", function (event, data) {
                updateView(data);
            });
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:abgeschlossenehhController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('photovoltaicReviewController', function ($scope, $rootScope, reviewService) {

    $scope.reviews = reviewService.checkRightForReviewFunction('photovoltaicreview');
    $scope.submitEnabled = false;

    $scope.$on("refreshReportBtn", function () {
        $scope.submitEnabled = true;
    });

    $scope.showtemplate = function (id) {
        $scope.submitEnabled = false;
        angular.forEach($scope.reviews, function (review) {
            if (review.id === parseInt(id)) {
                $rootScope.$broadcast('photovoltaicreview', review.short);
            }
        });

    };

    $scope.createReview = function (id, doSendEmail)
    {
        var api = {
            filter: []
        };        
        $rootScope.$broadcast('createReview');
        
        angular.forEach($scope.reviews, function (review) {
            if (review.id === parseInt(id)) {
                api.route = review.route;                
                if(review.short === ' '){ 
                    $rootScope.filter =[];
                }
            }
        });

        for (var i = 0; i < $rootScope.filter.length; i++) {
            if ($rootScope.filter[i].value && $rootScope.filter[i].value.length !== 0)
                api.filter.push($rootScope.filter[i]);
        }
        reviewService.createReview(api, doSendEmail);
    };

});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('othersreview', function ($filter,tabmenuReviewService,$compile, localStorageService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/review/review.view.html' + "?v=" + window.version.tag,
        controller: "othersReviewController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_OTHERS');
            scope.userEmail = localStorageService.get('user').email;
            
              var updateView = function (site) {
                var html = tabmenuReviewService.buildSite(site);
                var template = angular.element(html);
                var myEl = angular.element(document.querySelector('.filter-content'));
                    myEl.empty();
                if (template.length === 1) {                    
                    myEl.append(template);
                    $compile(template)(scope);
                }


            };

            scope.$on("othersreview", function (event, data) {
                updateView(data);
            });
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:auswertungsberichtController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('othersReviewController', function ($scope, $rootScope, reviewService) {

    $scope.reviews = reviewService.checkRightForReviewFunction('othersreview');

    $scope.showtemplate = function (id) {
        angular.forEach($scope.reviews, function (review) {
            if (review.id === parseInt(id)) {
                $rootScope.$broadcast('othersreview', review.short);
            }
        });

    };

    $scope.createReview = function (id, doSendEmail)
    {
        var api = {
            filter: []
        };
        $rootScope.$broadcast('createReview');

        angular.forEach($scope.reviews, function (review) {
            if (review.id === parseInt(id)) {
                api.route = review.route;
                if (review.short === ' ') {
                    $rootScope.filter = [];
                }
            }
        });

        for (var i = 0; i < $rootScope.filter.length; i++) {
            if ($rootScope.filter[i].value && $rootScope.filter[i].value.length !== 0)
                api.filter.push($rootScope.filter[i]);
        }

        reviewService.createReview(api, doSendEmail);
    };
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('locationreview', function ($filter, tabmenuReviewService, $compile, localStorageService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/review/review.view.html' + "?v=" + window.version.tag,
        controller: "locationReviewController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_LOCATION');
            scope.userEmail = localStorageService.get('user').email;

            var updateView = function (site) {
                var html = tabmenuReviewService.buildSite(site);
                var template = angular.element(html);
                var myEl = angular.element(document.querySelector('.filter-content'));
                    myEl.empty();
                if (template.length === 1) {
                    myEl.append(template);
                    $compile(template)(scope);
                }
            };

            scope.$on("locationreview", function (event, data) {
                updateView(data);
            });
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:locationreviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('locationReviewController', function ($scope, $rootScope, reviewService) {

    $scope.reviews = reviewService.checkRightForReviewFunction('locationreview');

    $scope.submitEnabled = false;

    $scope.$on("refreshReportBtn", function () {
        $scope.submitEnabled = true;
    });
    
    $scope.showtemplate = function (id) {
        $scope.submitEnabled = false;
        angular.forEach($scope.reviews, function (review) {
            if (review.id === parseInt(id)) {
                $rootScope.$broadcast('locationreview', review.short);
            }
        });

    };

    $scope.createReview = function (id, doSendEmail)
    {

        var dataArr = {
            filter: []
        };
        //so the controller for that report puts their filter into the root scope
        $rootScope.$broadcast('createReview');

        angular.forEach($scope.reviews, function (review) {
            if (review.id === parseInt(id)) {
                dataArr.route = review.route;
                if (review.short === ' ') {
                    $rootScope.filter = [];
                }
            }
        });

        if(id !== 41) {//location monitoring doesn't need this
            for (var i = 0; i < $rootScope.filter.length; i++) {
                if ($rootScope.filter[i].value && $rootScope.filter[i].value.length !== 0)
                    dataArr.filter.push($rootScope.filter[i]);
            }
        } else {
            dataArr.filter = JSON.parse(JSON.stringify($rootScope.filter));
        }

        reviewService.createReview(dataArr, doSendEmail);


    };
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('directhelpreview', function ($filter, $compile, tabmenuReviewService, localStorageService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/review/review.view.html' + "?v=" + window.version.tag,
        controller: "directhelpReviewController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_DIRECTHELP');
            scope.userEmail = localStorageService.get('user').email;

            var updateView = function (site) {
                var html = tabmenuReviewService.buildSite(site);
                var template = angular.element(html);
                var myEl = angular.element(document.querySelector('.filter-content'));
                myEl.empty();
                if (template.length === 1) {
                    myEl.append(template);
                    $compile(template)(scope);
                }


            };

            scope.$on("directhelpreview", function (event, data) {
                updateView(data);
            });
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:abgeschlossenehhController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('directhelpReviewController', function ($scope, $rootScope, reviewService) {

    $scope.reviews = reviewService.checkRightForReviewFunction('directhelpreview');
    $scope.submitEnabled = false;

    $scope.$on("refreshReportBtn", function () {
        $scope.submitEnabled = true;
    });

    $scope.showtemplate = function (id) {
        $scope.submitEnabled = false;
        angular.forEach($scope.reviews, function (review) {
            if (review.id === parseInt(id)) {
                $rootScope.$broadcast('directhelpreview', review.short);
            }
        });

    };

    $scope.createReview = function (id, doSendEmail)
    {
        var api = {
            filter: []
        };        
        $rootScope.$broadcast('createReview');
        
        angular.forEach($scope.reviews, function (review) {
            if (review.id === parseInt(id)) {
                api.route = review.route;                
                if(review.short === ' '){ 
                    $rootScope.filter =[];
                }
            }
        });

        for (var i = 0; i < $rootScope.filter.length; i++) {
            if ($rootScope.filter[i].value && $rootScope.filter[i].value.length !== 0)
                api.filter.push($rootScope.filter[i]);
        }
        reviewService.createReview(api, doSendEmail);
    };

});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('controllingreview', function ($filter,$compile,tabmenuReviewService, localStorageService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/review/review.view.html' + "?v=" + window.version.tag,
        controller: "controllingReviewController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_CONTROLLING');
            scope.userEmail = localStorageService.get('user').email;
            
            var updateView = function (site) {
                var html = tabmenuReviewService.buildSite(site);
                var template = angular.element(html);
                var myEl = angular.element(document.querySelector('.filter-content'));
                    myEl.empty();
                if (template.length === 1) {                    
                    myEl.append(template);
                    $compile(template)(scope);
                }


            };

            scope.$on("controllingreview", function (event, data) {
                updateView(data);
            });
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:controllingReviewController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('controllingReviewController', function ($scope,$rootScope,reviewService) {


    $scope.reviews = reviewService.checkRightForReviewFunction('controllingreview');
    $scope.submitEnabled = false;

    $scope.$on("refreshReportBtn", function () {
        $scope.submitEnabled = true;
    });

    $scope.showtemplate = function (id) {
        $scope.submitEnabled = false;
        angular.forEach($scope.reviews, function (review) {
            if (review.id === parseInt(id)) {
                $rootScope.$broadcast('controllingreview', review.short);
            }
        });

    };

    $scope.createReview = function (id, doSendEmail)
    {
        var api = {
            filter: []
        };
        $rootScope.$broadcast('createReview');

        angular.forEach($scope.reviews, function (review) {
            if (review.id === parseInt(id)) {
                api.route = review.route;
                if(review.short === ' '){
                    $rootScope.filter =[];
                }
            }
        });

        for (var i = 0; i < $rootScope.filter.length; i++) {
            if ($rootScope.filter[i].value && $rootScope.filter[i].value.length !== 0)
                api.filter.push($rootScope.filter[i]);
        }
        reviewService.createReview(api, doSendEmail);
    };

});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenunews
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenunews', function (tabmenuService, $stateParams, $filter, $compile, $rootScope, searchCacheService) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.ssc, "tabIndex");
            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.news))
                scope.pageIndex = cacheData;
            else
                scope.pageIndex = 0;
            searchCacheService.setCacheData(searchCacheService.type.ssc, "tabIndex", scope.pageIndex, false);

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
                searchCacheService.unsetData(searchCacheService.type.news);
                searchCacheService.setCacheData(searchCacheService.type.news, "tabIndex", scope.pageIndex);
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("news/count").then(function (data) {
                    scope.bSearch = bSearch;
                    scope.searchCounts = data.news;
                    scope.tabCounts = data.news;
                    scope.grids = [{
                            name: "news",
                            title: $filter('translate')('TAB_NEWS'),
                            permissionOnly: ['ADMIN'],
                            data: scope.tabCounts
                        }];
                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.empty();
                    myEl.append(template);
                    $compile(template)(scope);
                },
                        function (error) {
                            console.log(error);
                        });
            };

            scope.$on("newsUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
}); 

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:news
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('news', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "newsController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_NEWS');
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:newsController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('newsController', function ($scope, ngDialog, $rootScope, newsService, uiGridConstants, gridService, $translate, formService, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "news/read",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "desc"
            },
            search: $rootScope.search,
            filter: $rootScope.filter
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.news, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.news)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.news, "data", $scope.api.data);
    }

    var cols = ['valid_from', 'valid_until'];

    // UI GRID: updates data
    $scope.getTableData = function () {
        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = formService.formatGrid(data.data, cols,'news');
            //Update TabCount
            if ($scope.api.data.search || $scope.api.data.filter)
                $rootScope.$broadcast('updateTabcount', {count: data.total});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            width: 100,
            sort: {direction: uiGridConstants.DESC, priority: 1},
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ui-sref="news.detail({id: row.entity.id})">{{COL_FIELD}}</div>'
        },
        {
            field: 'headline',
            displayName: 'Überschrift',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ui-sref="news.detail({id: row.entity.id})">{{COL_FIELD}}</div>'
        },
        {
            field: 'status',
            displayName: 'Status',
            headerCellFilter: 'translate',
            width: 50,
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><span data-ng-if="row.entity.status == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span><span data-ng-if="row.entity.status == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div>'
        },
        {
            field: 'valid_from',
            displayName: 'von',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'valid_until',
            displayName: 'bis',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'role',
            displayName: 'Rollen',
            headerCellFilter: 'translate',
            enableSorting: false,
            cellTemplate: '<span ng-repeat="item in row.entity.role"><span ng-if="$index != 0">, </span><span data-ng-bind="item.short"></span></span>'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="news.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a title="{{\'BTN_ACTIVATE\' | translate}}" href="" ng-click="grid.appScope.activateDialog(row.entity.id, row.entity.description)" ng-if="(row.entity.status != 1)"><i class="fa fa-eye-slash" aria-hidden="true"></i></a> <a title="{{\'BTN_DEACTIVATE\' | translate}}" href="" ng-if="(row.entity.status != 0)" ng-click="grid.appScope.deactivateDialog(row.entity.id, row.entity.description)"><i class="fa fa-eye" aria-hidden="true"></i></a>'
        }
    ];

    $scope.deactivateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/deactivate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function () {
                $scope.getTableData();
            }
        });
    };

    $scope.activateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/activate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function () {
                $scope.getTableData();
            }
        });
    };

    $scope.activate = function (id) {

        newsService.activateNews(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.deactivate = function (id) {

        newsService.deactivateNews(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        enableColumnMenus: false,
        enableFiltering: false,
        useExternalSorting: true,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 60,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.core.on.sortChanged($scope, function (grid, sort) {


                if (sort[0] && sort[0].field) {
                    //1. Sorting setzen nach Feld und ORder
                    $scope.api.data.sort.column = sort[0].field;
                    $scope.api.data.sort.order = sort[0].sort.direction;
                    searchCacheService.setCacheData(searchCacheService.type.news, "data", $scope.api.data);

                    //2. 
                    gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                        $scope.data = formService.formatGrid(data.data, cols,'news');
                    }, function (error) {
                        console.log(error);
                    });
                }
                ;
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.news, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = formService.formatGrid(data.data, cols,'news');
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenussc
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenulocation', function (tabmenuService, PermPermissionStrategies, $stateParams, $filter, $compile, $rootScope, searchCacheService) {
    var childScope;

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.location, "tabIndex");
            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.location))
                scope.pageIndex = cacheData;
            else
                scope.pageIndex = 0;
            searchCacheService.setCacheData(searchCacheService.type.location, "tabIndex", scope.pageIndex, false);

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
                searchCacheService.unsetData(searchCacheService.type.location);
                searchCacheService.setCacheData(searchCacheService.type.location, "tabIndex", scope.pageIndex);
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("location/count").then(function (data) {
                    scope.bSearch = bSearch;
                    if(bSearch) {
                        scope.tabCounts = 0;
                        angular.forEach(data, function (value) {
                            scope.tabCounts += value;
                        });
                    }
                    scope.searchCounts = scope.tabCounts;

                    scope.grids = [
                        {
                            name: "locationoverview",
                            title: $filter('translate')('TAB_LOCATION'),
                            permissionOnly: ['ADMIN', 'REKO', 'EFB', 'LOKO'],
                            data: data.location
                        },
                        {
                            name: "locationoverviewregion",
                            title: $filter('translate')('TAB_REGION'),
                            permissionOnly: ['ADMIN', 'BUKO'],
                            data: data.region
                        },
                        {
                            name: "locationovervieworganisation",
                            title: $filter('translate')('TAB_ORGANISATION'),
                            permissionOnly: ['ADMIN', 'BUKO'],
                            data: data.organisation
                        }
                    ];
                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    if(childScope) {
                        childScope.$destroy();
                    }
                    myEl.empty();
                    myEl.append(template);
                    childScope = scope.$new();
                    $compile(template)(childScope);
                },
                        function (error) {
                            console.log(error);
                        });
            };

            scope.$on("locationUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
}); 

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:locationOverviewRegion
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('locationoverviewregion', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "locationRegionController",
        link: function (scope, element, attrs) {
            
            scope.title = $filter('translate')('TAB_REGION');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:locationRegionController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('locationRegionController', function ($scope,uiGridConstants, regionService, ngDialog, gridService, $rootScope, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "region/read",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.location, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.location)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.location, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:1});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            enableFiltering: false,
            cellClass: 'p-left-10',
            maxWidth: 50,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="location.regionDetail({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'name',
            displayName: 'Region',
            headerCellFilter: 'translate',
            width: '30%',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="location.regionDetail({id: row.entity.id})">{{COL_FIELD}}</a></div>'  
        },
        {
            field: 'efb',
            displayName: 'efB',
            headerCellFilter: 'translate',
            enableSorting: false,
            width: '40%',
            cellTemplate: '<span ng-repeat="item in row.entity.efb"><a ng-href="#" ui-sref="user.update({id: item.id})" data-ng-bind="item.name" class="label label-default"></a>&nbsp;</span>'
        },
        {
            field: 'location_count',
            displayName: 'Standorte',
            enableSorting: false,
            headerCellFilter: 'translate',
            maxWidth: 100
        },
        {
            field: 'ssh_count',
            displayName: 'Stromsparhelfer',
            enableSorting: false,
            headerCellFilter: 'translate',
            maxWidth: 100
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            headerCellFilter: 'translate',
            enableSorting: false,
            cellTemplate: '<a href="" ui-sref="location.regionUpdate({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a title="{{\'BTN_ACTIVATE\' | translate}}" href="" ng-click="grid.appScope.activateDialog(row.entity.id, row.entity.description)" ng-if="(row.entity.status != 1)"><i class="fa fa-eye-slash" aria-hidden="true"></i></a> <a title="{{\'BTN_DEACTIVATE\' | translate}}" href="" ng-if="(row.entity.status != 0)" ng-click="grid.appScope.deactivateDialog(row.entity.id, row.entity.description)"><i class="fa fa-eye" aria-hidden="true"></i></a>'
        }
    ];

    $scope.deactivateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/deactivate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function() {
                $scope.getTableData();
            }
        });
    };

    $scope.activateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/activate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function() {
                $scope.getTableData();
            }
        });
    };

    $scope.activate = function (id) {

        regionService.activateRegion(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.deactivate = function (id) {

        regionService.deactivateRegion(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
         useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
               
                 
                if(sort[0] && sort[0].field){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].field;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.location, "data", $scope.api.data);
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.location, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.status}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:locationovervieworganisation
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('locationovervieworganisation', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "locationOrganisationController",
        link: function (scope, element, attrs) {
            
            scope.title = $filter('translate')('TAB_ORGANISATION');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:locationOrganisationController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('locationOrganisationController', function ($scope,uiGridConstants, gridService, organisationService, ngDialog, $rootScope, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "organisation/read",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.location, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.location)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.location, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:2});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            enableFiltering: false,
            cellClass: 'p-left-10',
            width: 60,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="location.organisation({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'name',
            displayName: 'Name',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="location.organisation({id: row.entity.id})">{{COL_FIELD}}</a></div>'  
        },
        {
            field: 'street',
            displayName: 'Straße',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'postalcode',
            displayName: 'PLZ',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'city',
            displayName: 'Stadt',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'region',
            displayName: 'Regionen',
            headerCellFilter: 'translate',
            minWidth: 100,
            width: '30%',
            maxWidth: 300,
            cellTemplate: '<span ng-repeat="item in row.entity.region"><a ng-href="#" ui-sref="location.regionDetail({id: item.id})" data-ng-bind="item.name" class="label label-default"></a>&nbsp;</span>',
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="location.organisationUpdate({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a title="{{\'BTN_ACTIVATE\' | translate}}" href="" ng-click="grid.appScope.activateDialog(row.entity.id, row.entity.description)" ng-if="(row.entity.status != 1)"><i class="fa fa-eye-slash" aria-hidden="true"></i></a> <a title="{{\'BTN_DEACTIVATE\' | translate}}" href="" ng-if="(row.entity.status != 0)" ng-click="grid.appScope.deactivateDialog(row.entity.id, row.entity.description)"><i class="fa fa-eye" aria-hidden="true"></i></a>'
        }
    ];

    $scope.deactivateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/deactivate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function() {
                $scope.getTableData();
            }
        });
    };

    $scope.activateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/activate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function() {
                $scope.getTableData();
            }
        });
    };

    $scope.activate = function (id) {

        organisationService.activateOrganisation(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.deactivate = function (id) {

        organisationService.deactivateOrganisation(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        enableSorting: true,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
               
                 
                if(sort[0] && sort[0].field){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].field;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.location, "data", $scope.api.data);
                
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.location, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.status}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:locationOverviewlocation
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('locationoverview', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "locationLocationController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_LOCATION');
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:locationLocationController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('locationLocationController', function ($scope, uiGridConstants, $rootScope, ngDialog, locationService, gridService, $translate, searchCacheService) {

    $scope.data = [];
    $scope.api = {
        route: "location/read",
        data: {
            items: $rootScope.itemsPerPage, // $rootScope.bla
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };
    var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.location, "data");
    if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.location)) {
        $scope.api.data = cacheData;
    } else {
        searchCacheService.setCacheData(searchCacheService.type.location, "data", $scope.api.data);
    }

    // UI GRID: updates data
    $scope.getTableData = function () {
        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:0});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };
    //$scope.gridName='location';

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            enableFiltering: false,
            cellClass: 'p-left-10',
            maxWidth: 50,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="location.detail({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'name',
            displayName: 'Standort',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="location.detail({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'loko',
            displayName: 'LoKo',
            headerCellFilter: 'translate',
            enableSorting: false,
            cellTemplate: '<span ng-repeat="item in row.entity.loko"><a ng-href="#" ui-sref="user.update({id: item.user_id})" data-ng-bind="item.name" class="label label-default"></a>&nbsp;</span>'
        },
        {
            field: 'trainer',
            displayName: 'Trainer',
            headerCellFilter: 'translate',
            enableSorting: false,
            cellTemplate: '<span ng-repeat="item in row.entity.trainer"><a ng-href="#" ui-sref="user.update({id: item.user_id})" data-ng-bind="item.name" class="label label-default"></a>&nbsp;</span>'
        },
        {
            field: 'ssh_count',
            displayName: 'SSH',
            enableSorting: false,
            visible: gridService.checkVisible('ssh',$scope.gridName),
            headerCellFilter: 'translate',
            maxWidth: 50,
            cellClass: 'text-center',
            cellTemplate: '<span data-ng-if="row.entity.ssh_count > 0"><a href="" ui-sref="user.overview.ssh({id: row.entity.id})"><span data-ng-bind="row.entity.ssh_count"></span></a></span><span data-ng-if="row.entity.ssh_count == 0">0</span>'
        },
        {
            field: 'telephone',
            displayName: 'Telefon',
            visible: gridService.checkVisible('telephone',$scope.gridName),
            headerCellFilter: 'translate'
        },
        {
            field: 'region',
            displayName: 'Region',
            headerCellFilter: 'translate',
            cellTemplate: '<span data-ng-bind="row.entity.region"></span>'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            headerCellFilter: 'translate',
            enableSorting: false,
            visible: gridService.checkVisible('function',$scope.gridName),
            cellTemplate: '<a href="" ui-sref="location.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a permission permission-only="[\'EFB\', \'ADMIN\', \'REKO\']" title="{{\'BTN_ACTIVATE\' | translate}}" href="" ng-click="grid.appScope.activateDialog(row.entity.id, row.entity.description)" ng-if="(row.entity.status != 1)"><i class="fa fa-eye-slash" aria-hidden="true"></i></a> <a permission permission-only="[\'EFB\', \'ADMIN\', \'REKO\']" title="{{\'BTN_DEACTIVATE\' | translate}}" href="" ng-if="(row.entity.status != 0)" ng-click="grid.appScope.deactivateDialog(row.entity.id, row.entity.description)"><i class="fa fa-eye" aria-hidden="true"></i>{{row.status}}</a>'
        }
    ];

    $scope.deactivateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/deactivate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function() {
                $scope.getTableData();
            }
        });
    };

    $scope.activateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/activate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function() {
                $scope.getTableData();
            }
        });
    };

    $scope.activate = function (id) {

        locationService.activateLocation(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.deactivate = function (id) {

        locationService.deactivateLocation(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 34,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
        paginationPageSize: $scope.api.data.items,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.core.on.sortChanged($scope, function (grid, sort) {

                if(sort[0] && sort[0].field){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].field;
                $scope.api.data.sort.order =sort[0].sort.direction;
                searchCacheService.setCacheData(searchCacheService.type.location, "data", $scope.api.data);

                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }
                searchCacheService.setCacheData(searchCacheService.type.location, "data", $scope.api.data);

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };

    $scope.gridOptions.rowTemplate = '<div ng-class="{\'ssc-grid-row-inactive\': !row.entity.status}" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenunews
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenuexchange', function (tabmenuService, $stateParams, $filter, $compile, $rootScope) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("exchange/count").then(function (data) {
                    scope.bSearch = bSearch;
                    scope.searchCounts = data.hhexchange + data.closedexchange + data.billedexchange;
                    scope.grids = [{
                            name: "hhexchange",
                            title: $filter('translate')('TAB_HHEXCHANGE'),
                            permissionOnly: ['ADMIN', 'LOKO'],
                            data: data.hhexchange
                        },
                        {
                            name: "closedexchange",
                            title: $filter('translate')('TAB_EXCHANGE'),
                            permissionOnly: ['ADMIN'],
                            data: data.closedexchange
                        },
                        {
                            name: "billedexchange",
                            title: $filter('translate')('TAB_BILLEDEXCHANGE'),
                            permissionOnly: ['ADMIN', 'LOKO'],
                            data: data.billedexchange
                        }];
                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.empty();
                    myEl.append(template);
                    $compile(template)(scope);
                },
                        function (error) {
                            console.log(error);
                        });
            };

            scope.$on("exchangeUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
}); 

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:exchange
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('hhexchange', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "hhexchangeController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_HHEXCHANGE');
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:exchangeController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('hhexchangeController', function ($scope, ngDialog, $rootScope, gridService, uiGridConstants, $translate, api, $window, exchangeArchiveService, formService, moment) {

    $scope.data = [];
    $scope.toBeBilled = [];
    var newColDefs;
    $scope.api = {
        route: "exchange/read",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            search: $rootScope.search,
            filter: $rootScope.filter
        }
    };
    $scope.createBillIds = [];

    var cols = ['created_at', 'expires_after', 'new_voucher_used_date'];

    // UI GRID: updates data
    $scope.getTableData = function () {
        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {

            for(var i in data.data) { //convert to local timezone
                data.data[i].created_at = moment.utc(data.data[i].created_at).local().format("YYYY-MM-DD HH:mm:ss");
            }

            $scope.data = formService.formatGrid(data.data, cols);
            //Update TabCount
            if ($scope.api.data.search || $scope.api.data.filter)
                $rootScope.$broadcast('updateTabcount', {count: data.total});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };

    //check user roles to set columnDefs and tabs
    $scope.checkForRole = function () {
        var user = $rootScope.currentUser;
        var loko = false;
        var admin = false;
        for (var i in user.user_role) {
            if (user.user_role[i].slug === "ADMIN") {
                admin = true;
            }
        }
        for (var i in user.user_role) {
            if (user.user_role[i].slug === "LOKO") {
                loko = true;
            }
        }
        if (!loko && admin) {
            return true;
        }
        return false;
    };

    var columnDefs = [
//        {
//            field: 'id',
//            displayName: 'ID',
//            width: 60,
//            sort: {direction: uiGridConstants.ASC, priority: 1},
//            enableFiltering: false,
//            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a href="" ui-sref="ssc.check.overview.refrigerator({id: row.entity.id})">{{COL_FIELD}}</div>'
//        },
        {
            field: 'for_billing',
            displayName: '',
            visible: gridService.checkVisible('cash_up', 'hhexchange'),
            headerCellFilter: 'translate',
            width: 60,
            cellTemplate: '<input type="checkbox" ng-click="grid.appScope.pushToBilled(row)" ' +
                    'id="checkboxExchange{{row.entity.id}}"  ng-disabled="grid.appScope.isBillable(row.entity)"' +
                    ' ng-checked="{{grid.appScope.toBeBilled.indexOf(row.entity.id) != -1}}"/><label class=" checklabelgrid checklabelgrid{{row.entity.id.indexOf(grid.appScope.toBeBilled)}}" ' +
                    ' ng-class="{ \'checkbox-disabled\': grid.appScope.isBillable(row.entity) }"' +
                    ' for="checkboxExchange{{row.entity.id}}"><i ng-if="grid.appScope.toBeBilled.indexOf(row.entity.id) != -1" class="fa fa-check fa-2x" aria-hidden="true"></i>' +
                    ' </label>',
        },
        {
            field: 'ssc_id',
            displayName: 'Haushalt ID',
            width: 100,
            cellClass: 'center',
            enableFiltering: false,
        },
        {
            field: 'location',
            displayName: 'Ort',
            //width: 100,
            headerCellFilter: 'translate',
        },
        {
            field: 'created_at',
            displayName: 'Erstellt am',
            headerCellFilter: 'translate',
        },
        {
            field: 'expires_after',
            displayName: 'Gültig bis',
            headerCellFilter: 'translate',
        },
        {
            field: 'new_voucher_used_date',
            /*[5]*/     displayName: 'Abgerechnet am',
            //width: 100,
            headerCellFilter: 'translate',
        },
        {
            field: 'producer',
            displayName: 'Hersteller',
            headerCellFilter: 'translate',
        },
        {
            field: 'new_model',
            displayName: 'Model',
            width: 130,
            cellClass: 'center',
            headerCellFilter: 'translate',
        },
        {
            field: 'voucher_binding_max_consumption',
            displayName: 'Gutschein kWh',
            headerCellFilter: 'translate',
        },
        {
            field: 'new_consumption',
            displayName: 'Neues KG kWh',
            headerCellFilter: 'translate',
        },
        {
            field: 'billing_status_type_id',
            displayName: 'Zustand',
            /*[10]*/   headerCellFilter: 'translate',
            width: 110,
            cellTemplate: '<select class="selectgrid" ng-disabled="true" ng-model="row.entity.billing_status_type_id" ng-change="grid.appScope.updateState(row.entity.id,row.entity.billing_status_type_id)"><option ng-value="1">Offen</option><option ng-value="2">abgerechnet</option><option ng-value="3">zur Prüfung</option><option ng-value="4">abgelehnt</option></select>'
        },
//        {
//            field: 'cash_up',
//            displayName: 'abrechnen',
//            visible: gridService.checkVisible('cash_up', 'hhexchange'),
//            headerCellFilter: 'translate',
//            cellTemplate: '<div><input type="checkbox" ng-change="grid.appScope.checkAndPushBill(row.entity.id,row.entity.billing_status_type_id)" id="checkboxExchange{{row.entity.id}}" ng-disabled="row.entity.billing_status_type_id != null && row.entity.billing_status_type_id != 1 " ng-model="row.entity.billing_status_type_id" ng-true-value="1" ng-false-value="null" ng-chid="checkboxNews{{row.entity.id}}"  ng-checked="row.entity.billing_status_type_id == 2"/><label class=" checklabelgrid checklabelgrid{{row.entity.billing_status_type_id}}" for="checkboxExchange{{row.entity.id}}"><i ng-if="row.entity.billing_status_type_id == 2" class="fa fa-check fa-2x" aria-hidden="true"></i><i ng-if="row.entity.billing_status_type_id == 1 || row.entity.billing_status_type_id == 3" class="fa fa-times fa-2x" aria-hidden="true"></i><i ng-if="row.entity.billing_status_type_id == 4" class="fa fa-exclamation fa-1x" aria-hidden="true"></i></label></span></div>',
//        },
        {
            field: 'function',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 100,
            cellClass: 'ui-grid-func-cell',
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" title="KG Tausch öffnen" ui-sref="ssc.check.overview.refrigerator({id: row.entity.ssc_id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
                    + '<a title="Download" ng-if="row.entity.voucher > 0" ng-click="grid.appScope.downloadVoucher(row.entity.id)" class="ui-grid-nav" ui-sref=""><i class="fa fa-download" aria-hidden="true"></i></a>'
                    + '<a title="Abrechnen" href="" class="ui-grid-nav" ng-if="row.entity.billing_status_type_id == null && !grid.appScope.isNoLoko && grid.appScope.toBeBilled.length < 2 && row.entity.saving == 1" ng-click="grid.appScope.pushToBillPerIcon(row.entity.id)"><i class="fa fa-usd" aria-hidden="true"></i></a>'
        }
    ];

    //set columnDefs depending on role
    if ($scope.checkForRole()) {
        newColDefs = columnDefs;
    } else {
        newColDefs = [columnDefs[0], columnDefs[1], columnDefs[2], columnDefs[3], columnDefs[4], columnDefs[5], columnDefs[10], columnDefs[11]];        
    }


    $scope.gridOptions = {
        data: 'data',
        columnDefs: newColDefs,
        enableColumnMenus: false,
        enableFiltering: false,
        useExternalSorting: true,
        fastWatch: true,
        enableRowSelection: false,
        enableSelectAll: false,
        enableRowHeaderSelection: false,
        selectionRowHeaderWidth: 30,
        rowHeight: 40,
        rowSelection: true,
        enableFullRowSelection: true,
        enableCellEdit: true,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSizes: [1, 5, 10, 25, 50],
        paginationPageSize: $rootScope.itemsPerPage,
        totalItems: '$scope.data.total',
        isRowSelectable: function (row) {
            if (row.entity.billing_status_type_id !== null || !row.entity.saving) {
                return false; //not selectable
            }
            return true;
        },
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            $scope.isNoLoko = $scope.checkForRole();
            gridApi.core.on.sortChanged($scope, function (grid, sort) {

                if (sort[0] && sort[0].field) {
                    //1. Sorting setzen nach Feld und ORder
                    $scope.api.data.sort.column = sort[0].field;
                    $scope.api.data.sort.order = sort[0].sort.direction;

                    //2. 
                    gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                        $scope.data = formService.formatGrid(data.data, cols);
                    }, function (error) {
                        console.log(error);
                    });
                }
                ;
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                    //tmp not firing - ToDo
                });

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = formService.formatGrid(data.data, cols);
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };

    $scope.checkAndPushBill = function (id, status) {
        if (status == 1)
        {
            $scope.createBillIds.push(id);
        }
        if (status === null)
        {
            angular.forEach($scope.createBillIds, function (checkId, index) {
                if (id == checkId) {
                    $scope.createBillIds.splice(index, 1);
                }
            });
        }
    };

    $scope.updateState = function (id, status) {
        $scope.api.data.id = [id];
        $scope.api.data.state = angular.copy(status);
        gridService.readData('exchange/update', $scope.api.data).then(function (data) {
            $scope.data = formService.formatGrid(data.data, cols);
        }, function (error) {
            console.log(error);
        });

    };

    $scope.pushToBillPerIcon = function (id) {
        var ids = [];
        ids[0] = id;
        $scope.api.data.id = angular.copy(ids);
        $scope.api.data.state = 1;
        gridService.readData('exchange/update', $scope.api.data).then(function (data) {
            $rootScope.$broadcast('exchangeUpdate', data);

            $scope.export(ids);
        }, function (error) {
            console.log(error);
        });
    };
    $scope.pushToBillPerButton = function (id) {
//        var ids = [];
//
//        for (var i = 0; i < $scope.gridApi.selection.getSelectedRows().length; i++) {
//            ids.push($scope.gridApi.selection.getSelectedRows()[i].id);
//        }

        $scope.api.data.state = 1;
        $scope.api.data.id = angular.copy($scope.toBeBilled);
        gridService.readData('exchange/update', $scope.api.data).then(function (data) {
            $rootScope.$broadcast('exchangeUpdate', data);
            $scope.createBillIds.splice(0);
            $scope.export($scope.toBeBilled);
        }, function (error) {
            console.log(error);
        });
    };

    $scope.export = function (id) {
        var data = {items: id};
        exchangeArchiveService.exportBilling(data).then(function (data) {
            $scope.downloadExport(data);
        }, function (error) {
            console.log(error);
        });
    };

    $scope.downloadExport = function (data) {
        var ids = [];
        for (var i = 0; i < data.length; i++) {
            ids.push(data[i].id);
        }
        //call/open dowonload url per GET method to force the browser to donwload the file (file response)
        var route = api.root + 'exchange/download/export?ids=' + ids;
        $window.location.href = route;
    };
    $scope.downloadVoucher = function (id) {
        var route = api.root + 'checks/pdf/voucher/read?id=' + id;
        //need to use window.open() to open in new tab
        window.open(route, '_blank');
    };

    //push selected item to scope
    $scope.pushToBilled = function (row) {
        var index = $scope.toBeBilled.indexOf(row.entity.id);
        //if item already exists, remove it from array (unselect)
        if (index !== -1) {
            $scope.toBeBilled.splice(index, 1);
            return;
        }
        //if item not in array, push it to array (select)
        $scope.toBeBilled.push(row.entity.id);
    };

    $scope.isBillable = function (value) {
        //billing allowed?
        if (value.billing_status_type_id !== null || $scope.isNoLoko || value.saving != 1 || value.voucher < 1 || value.is_billed == 1)
        {
            return true;
        }
        
        return false;
    };

});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:exchange
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('closedexchange', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "closedexchangeController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_EXCHANGE');
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:archivController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('closedexchangeController', function ($scope, ngDialog, $rootScope, newsService, api, uiGridConstants, gridService, $translate, formService, moment) {

    $scope.data = [];
    var newColDefs;
    $scope.api = {
        route: "exchange/read",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            search: $rootScope.search,
            filter: $rootScope.filter,
            billing_status_type_id: [2, 3, 4]
        }
    };



    var cols = ['created_at', 'expires_after', 'new_voucher_used_date'];

    // UI GRID: updates data
    $scope.getTableData = function () {
        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {

            for(var i in data.data) { //convert to local timezone
                data.data[i].created_at = moment.utc(data.data[i].created_at).local().format("YYYY-MM-DD HH:mm:ss");
            }

            $scope.data = formService.formatGrid(data.data, cols);
            //Update TabCount
            if ($scope.api.data.search || $scope.api.data.filter)
                $rootScope.$broadcast('updateTabcount', {count: data.total});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };

    $scope.checkForRole = function () {
        var user = $rootScope.currentUser;
        var loko = false;
        var admin = false;
        for (var i in user.user_role) {
            if (user.user_role[i].slug === "ADMIN") {
                admin = true;
            }
        }
        for (var i in user.user_role) {
            if (user.user_role[i].slug === "LOKO") {
                loko = true;
            }
        }
        if (!loko && admin) {
            return true;
        }
        return false;
    };

    var columnDefs = [
//        {
//            field: 'id',
//            displayName: 'ID',
//            width: 100,
//            sort: {direction: uiGridConstants.ASC, priority: 1},
//            enableFiltering: false
////            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="" ui-sref="news.detail({id: row.entity.id})">{{COL_FIELD}}</div>'
//        },
        {
            field: 'ssc_id',
            displayName: 'Haushalt ID',
            width: 100,
            enableFiltering: false,
        },
        {
            field: 'location',
            displayName: 'Ort',
            headerCellFilter: 'translate',
        },
        {
            field: 'created_at',
            displayName: 'Erstellt am',
            headerCellFilter: 'translate',
        },
        {
            field: 'expires_after',
            displayName: 'Gültig bis',
            headerCellFilter: 'translate',
        },
        {
            field: 'new_voucher_used_date',
 /*[5]*/    displayName: 'Abgerechnet am',
            headerCellFilter: 'translate',
        },
        {
            field: 'producer',
            displayName: 'Hersteller',
            headerCellFilter: 'translate',
        },
        {
            field: 'new_model',
            displayName: 'Model',
            headerCellFilter: 'translate',
        },
        {
            field: 'voucher_binding_max_consumption',
            displayName: 'Gutschein kWh',
            headerCellFilter: 'translate',
        },
        {
            field: 'new_consumption',
            displayName: 'Neues KG kWh',
            headerCellFilter: 'translate',
        },
        {
            field: 'billing_status_type_id',
 /*[10]*/   displayName: 'Zustand',
            headerCellFilter: 'translate',
            width: 110,
            cellTemplate: '<select class="selectgrid" ng-disabled="grid.appScope.isNoLoko" ng-model="row.entity.billing_status_type_id" ng-change="grid.appScope.updateState(row.entity.id,row.entity.billing_status_type_id)"><option ng-value="1">Offen</option><option ng-value="2">abgerechnet</option><option ng-value="3">zur Prüfung</option><option ng-value="4">abgelehnt</option></select>'
        },
        {
            field: 'function',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 100,
            cellClass: 'ui-grid-func-cell',
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" title="neues Kühlgerät hinzufügen" ui-sref="ssc.check.overview.refrigerator({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
                    + '<a title="Download" ng-if="row.entity.voucher > 0" href="" ng-click="grid.appScope.downloadVoucher(row.entity.id)" class="ui-grid-nav" ui-sref=""><i class="fa fa-download" aria-hidden="true"></i></a>'
                    + '<a title="Abrechnen" href="" class="ui-grid-nav" ui-sref=""ng-if="row.entity.billing_status_type_id != 1 && !grid.appScope.isNoLoko" ng-click="grid.appScope.pushToBillPerIcon(row.entity.id)"><i class="fa fa-usd" aria-hidden="true"></i></a>'
        }
    ];
    
    if ($scope.checkForRole()) {
        newColDefs = columnDefs;
    } else {
        newColDefs = [columnDefs[0], columnDefs[1], columnDefs[2], columnDefs[3], columnDefs[4], columnDefs[10], columnDefs[11]];;
    }
    
    $scope.gridOptions = {
        data: 'data',
        columnDefs: newColDefs,
        enableColumnMenus: false,
        enableFiltering: false,
        useExternalSorting: true,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 60,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSizes: [1, 5, 10, 25, 50],
        paginationPageSize: $rootScope.itemsPerPage,
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            $scope.isNoLoko = $scope.checkForRole();
            gridApi.core.on.sortChanged($scope, function (grid, sort) {


                if (sort[0] && sort[0].field) {
                    //1. Sorting setzen nach Feld und ORder
                    $scope.api.data.sort.column = sort[0].field;
                    $scope.api.data.sort.order = sort[0].sort.direction;

                    //2. 
                    gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                        $scope.data = formService.formatGrid(data.data, cols);
                    }, function (error) {
                        console.log(error);
                    });
                }
                ;
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = formService.formatGrid(data.data, cols);
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };

    $scope.checkForRole = function () {
        var user = $rootScope.currentUser;
        var loko = false;
        var admin = false;
        for (var i in user.user_role) {
            if (user.user_role[i].slug === "ADMIN") {
                admin = true;
            }
        }
        for (var i in user.user_role) {
            if (user.user_role[i].slug === "LOKO") {
                loko = true;
            }
        }
        if (!loko && admin) {
            return true;
        }
        return false;
    };

    $scope.updateState = function (id, status) {
        $scope.api.data.id = [id];
        $scope.api.data.state = angular.copy(status);
        gridService.readData('exchange/update', $scope.api.data).then(function (data) {
            $scope.data = formService.formatGrid(data.data, cols);
        }, function (error) {
            console.log(error);
        });

    };
    $scope.downloadVoucher = function (id) {
        var route = api.root + 'checks/pdf/voucher/read?id=' + id;
        //need to use window.open() to open in new tab
        window.open(route, '_blank');
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:exchange
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('billedexchange', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "billedexchangeController",
        link: function (scope, element, attrs) {
            scope.title = $filter('translate')('TAB_BILLEDEXCHANGE');
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:billedexchangeController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('billedexchangeController', function ($scope, ngDialog, $rootScope, newsService, uiGridConstants, api, gridService, $translate, formService, moment) {

    $scope.data = [];
    var newColDefs;
    $scope.api = {
        route: "exchange/read",
        data: {
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            search: $rootScope.search,
            filter: $rootScope.filter,
            billing_status_type_id: [1,3]
        }
    };

    var cols = ['created_at', 'expires_after', 'new_voucher_used_date'];

    // UI GRID: updates data
    $scope.getTableData = function () {
        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {

            for(var i in data.data) { //convert to local timezone
                data.data[i].created_at = moment.utc(data.data[i].created_at).local().format("YYYY-MM-DD HH:mm:ss");
            }

            $scope.data = formService.formatGrid(data.data, cols);

            //Update TabCount
            if ($scope.api.data.search || $scope.api.data.filter)
                $rootScope.$broadcast('updateTabcount', {count: data.total});
            $scope.gridOptions.totalItems = data.total;
        },
                function (error) {
                    console.log(error);
                });
    };

    $scope.checkForRole = function () {
        var user = $rootScope.currentUser;
        var loko = false;
        var admin = false;
        for (var i in user.user_role) {
            if (user.user_role[i].slug === "ADMIN") {
                admin = true;
            }
        }
        for (var i in user.user_role) {
            if (user.user_role[i].slug === "LOKO") {
                loko = true;
            }
        }
        if (!loko && admin) {
            return true;
        }
        return false;
    };


    var columnDefs = [
//        {
//            field: 'id',
//            displayName: 'ID',
//            width: 100,
//            sort: {direction: uiGridConstants.ASC, priority: 1},
//            enableFiltering: false
////            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="" ui-sref="news.detail({id: row.entity.id})">{{COL_FIELD}}</div>'
//        },
        {
            field: 'ssc_id',
            displayName: 'Haushalt ID',
            width: 100,
            enableFiltering: false,
        },
        {
            field: 'location',
            displayName: 'Ort',
            headerCellFilter: 'translate',
        },
        {
            field: 'created_at',
            displayName: 'Erstellt am',
            headerCellFilter: 'translate',
        },
        {
            field: 'expires_after',
            displayName: 'Gültig bis',
            headerCellFilter: 'translate',
        },
        {
            field: 'new_voucher_used_date',
             displayName: 'Abgerechnet am',
            headerCellFilter: 'translate',
        },
        {
            field: 'producer',
            /*[5]*/ displayName: 'Hersteller',
            headerCellFilter: 'translate',
        },
        {
            field: 'new_model',
            displayName: 'Model',
            headerCellFilter: 'translate',
        },
        {
            field: 'voucher_binding_max_consumption',
            displayName: 'Gutschein kWh',
            headerCellFilter: 'translate',
        },
        {
            field: 'new_consumption',
            displayName: 'Neues KG kWh',
            headerCellFilter: 'translate',
        },
        {
            field: 'billing_status_type_id',
            displayName: 'Zustand',
            headerCellFilter: 'translate',
            width: 110,
            cellTemplate: '<select class="selectgrid" ng-disabled="!grid.appScope.isNoLoko" ng-model="row.entity.billing_status_type_id" ng-change="grid.appScope.updateState(row.entity.id,row.entity.billing_status_type_id)"><option ng-value="1">Offen</option><option ng-value="2">abgerechnet</option><option ng-value="3">zur Prüfung</option><option ng-value="4">abgelehnt</option></select>'
        },
        {
            field: 'function',
            displayName: 'Funktionen',
            enableSorting: false,
            /*[10]*/ enableHiding: false,
            cellClass: 'ui-grid-func-cell',
            width: 100,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" title="neues Kühlgerät hinzufügen" ui-sref="ssc.check.overview.refrigerator({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
                    + '<a title="Download" ng-if="row.entity.voucher > 0" href="" ng-click="grid.appScope.downloadVoucher(row.entity.id)" class="ui-grid-nav" ui-sref=""><i class="fa fa-download" aria-hidden="true"></i></a>'
                    + '<a title="Abrechnen" href="" class="ui-grid-nav" ui-sref=""ng-if="row.entity.billing_status_type_id != 1 && !grid.appScope.isNoLoko" ng-click="grid.appScope.pushToBillPerIcon(row.entity.id)"><i class="fa fa-usd" aria-hidden="true"></i></a>'
        }
    ];

    if ($scope.checkForRole()) {
        newColDefs = columnDefs;
    } else {
        newColDefs = [columnDefs[0], columnDefs[1], columnDefs[2], columnDefs[3], columnDefs[4], columnDefs[9], columnDefs[10]];;
    }

    $scope.gridOptions = {
        data: 'data',
        columnDefs: newColDefs,
        enableColumnMenus: false,
        enableFiltering: false,
        useExternalSorting: true,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 60,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSizes: [1, 5, 10, 25, 50],
        paginationPageSize: $rootScope.itemsPerPage,
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            $scope.isNoLoko = $scope.checkForRole();
            gridApi.core.on.sortChanged($scope, function (grid, sort) {


                if (sort[0] && sort[0].field) {
                    //1. Sorting setzen nach Feld und ORder
                    $scope.api.data.sort.column = sort[0].field;
                    $scope.api.data.sort.order = sort[0].sort.direction;

                    //2. 
                    gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                        $scope.data = formService.formatGrid(data.data, cols);
                    }, function (error) {
                        console.log(error);
                    });
                }
                ;
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = formService.formatGrid(data.data, cols);
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            });
        }
    };


    $scope.updateState = function (id, status) {
        $scope.api.data.id = [id];
        $scope.api.data.state = angular.copy(status);
        gridService.readData('exchange/update', $scope.api.data).then(function (data) {
            $scope.data = formService.formatGrid(data.data, cols);
            $rootScope.$broadcast('exchangeUpdate');
            $scope.getTableData();
            $rootScope.$broadcast('updateTabcount', {count: data.total});
        }, function (error) {
            console.log(error);
        });

    };
    $scope.downloadVoucher = function (id) {
        var route = api.root + 'checks/pdf/voucher/read?id=' + id;
        //need to use window.open() to open in new tab
        window.open(route, '_blank');
    };



});

"use strict";
/**
* @ngdoc directive
* @name global.directive:searchnews
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('searcharchiv', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/exchange/archiv/search/search.view.html' + "?v=" + window.version.tag,
        controller: 'searchArchivController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:searchExchangeController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('searchArchivController', function ($scope, $rootScope, stromsparchecksearchservice, searchService) {

    $scope.init = function () {
        $scope.time = null;
        $scope.status = null;
        $scope.location = null;
        $scope.from = null;
        $scope.to = null;
        $scope.searchfield = null;
        delete $rootScope.from;
        delete $rootScope.to;
        delete $rootScope.search;
        delete $rootScope.filter;
        stromsparchecksearchservice.loadLocationList().then(function (data) {
            $scope.dropLocation = data;
        });
        $scope.dropStatus = [{id: 0,
                name: 'Offen'}, {id: 1,
                name: 'abgerechnet'}, {id: 2,
                name: 'Prüfung'}, {id: 3,
                name: 'abgelehnt'}];
    };

    $scope.clearFilter = function () {
        $scope.time = null;
        $scope.status = null;
        $scope.location = null;
        $scope.from = null;
        $scope.to = null;
        $scope.searchfield = null;
        $scope.showDetails = false;
        $scope.bSearch = false;
        $rootScope.search = {
            search: $scope.searchfield
        };
        $rootScope.filter = {};

        delete $rootScope.search;
        delete $rootScope.filter;
        searchService.closeCollapse('filter-collapse');
        $rootScope.$broadcast("exchangeUpdate", {bSearch: $scope.bSearch});
    };
    $scope.$on("sscClearFilter", function () {
        $scope.clearFilter();
    });

    $scope.search = function () {
        if ($scope.searchfield !== null || $scope.time !== null || $scope.status !== null || $scope.location !== null || $scope.from !== null || $scope.to !== null) {
            $scope.bSearch = true;
            var search = {
                search: $scope.searchfield
            };


            var filter = [
                {column: 'status', operator: '>=', value: $scope.status},
                {location: $scope.location},
                {from: 'from', operator: '>=', value: $scope.from},
                {to: 'to', operator: '<=', value: $scope.to},
                {column: 'valid_from', columntwo: 'valid_until', value: $scope.time}
            ];

            $rootScope.search = search;
            $rootScope.filter = filter;
            $rootScope.$broadcast("exchangeUpdate", {bSearch: $scope.bSearch});
        }
    };


    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenudirecthelptyp
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenudirecthelptyp', function (tabmenuService, directhelpService, $stateParams, $filter, $compile, $rootScope) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status)
                scope.pageIndex = $stateParams.status;
            else
                scope.pageIndex = 0;

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("directhelptype/count").then(function (data) {
                    scope.bSearch = bSearch;
                    scope.searchCounts = data.directhelptype;
                    scope.tabCounts = data.directhelptype;
                    scope.grids = [
                        {
                            name: "directhelp-typen",
                            title: $filter('translate')('TAB_DIRECTHELP_TYPS'),
                            permissionOnly: ['ADMIN'],
                            data: scope.tabCounts

                        }
                    ];

                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.empty();
                    myEl.append(template);
                    $compile(template)(scope);
                },
                        function (error) {
                            console.log(error);
                        });
            };

            scope.$on("directhelptypeUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:directhelpTypen
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('directhelpTypen', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            id: '@'
        },
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "directhelpTypenController"
    };
}); 

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:directhelpTypenController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('directhelpTypenController', function ($scope,uiGridConstants, gridService, $rootScope) {
    
    $scope.data = [];
    $scope.api = {
        route: "directhelptype/readonly",
        data: {
            type_id: $scope.id,
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            search: $rootScope.search
        }
    };

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            if($scope.api.data.search ||$scope.api.data.filter )$rootScope.$broadcast('updateTabcount',{count:data.total,case:0});
            $scope.gridOptions.totalItems = data.total;
        },
        function (error) {
            console.log(error);
        });
    };

    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            sort: { direction: uiGridConstants.ASC, priority: 1 },
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'name',
            displayName: 'Name',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 150,
            headerCellFilter: 'translate',
            cellTemplate: '<a href="" ui-sref="directhelp.typ.update({id: row.entity.id})" ng-if="row.entity.not_editable==0"><i class="fa fa-pencil" aria-hidden="true"></i></a>'
        }
    ];

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSize: $rootScope.itemsPerPage,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;
            
            gridApi.core.on.sortChanged($scope, function (grid, sort) {
               
                 
                if(sort[0] && sort[0].field){
                //1. Sorting setzen nach Feld und ORder
                $scope.api.data.sort.column =sort[0].field;
                $scope.api.data.sort.order =sort[0].sort.direction;
                
                //2. 
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                }, function (error) {
                    console.log(error);
                });};
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.data;
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenudirecthelpprices
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenudirecthelpprices', function (tabmenuService, $stateParams, $filter, $compile) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            edit: "@"
        },
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status) {
                scope.pageIndex = $stateParams.status;
            } else {
                scope.pageIndex = 0;
            }

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            scope.onUnauthorized = function (element) {
                element.remove();
                if (element.val() == scope.pageIndex)
                    scope.pageIndex++;
            };

            tabmenuService.getTabCounts("directhelpprice/count", $stateParams.id).then(
                function (data) {
                    scope.tabCounts = data.count;
                    scope.grids = [
                        {
                            name: "directhelp-prices",
                            parameter: {
                                key: "edit",
                                value: scope.edit
                            },
                            title: $filter('translate')('TAB_DIRECTHELP_PRICES'),
                            permissionOnly: ['ADMIN', 'TRAINER', 'LOKO', 'EFB', 'REKO', 'BUKO'],
                            data: scope.tabCounts

                        }];

                    var html = tabmenuService.setTabs(scope.grids);
                    var template = angular.element(html);
                    var myEl = angular.element(document.querySelector('.tab-content'));
                    myEl.append(template);
                    $compile(template)(scope);
                },
                function (error) {
                    console.log(error);
                }
            );
        }
    };
}); 
"use strict";
/**
* @ngdoc directive
* @name global.directive:directhelpPrices
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('directhelpPrices', function ($stateParams, $filter, directhelpCreateService) {
    return { 
        restrict: 'E',
        replace: true,
        scope: {
            edit: "@"
        },
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: 'directhelpPricesController',
        link: function (scope, element, attrs) {
            directhelpCreateService.readDirecthelp($stateParams.id).then(function (data) {
                scope.title = $filter('translate')('TAB_DIRECTHELP_PRICES_TITLE', {name: data.description});
            }, function (error) {
                console.log(error);
            });
        }
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:directhelpPricesController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('directhelpPricesController', function ($scope, uiGridConstants, $stateParams, gridService, $rootScope) {

    $scope.data = [];
    $scope.api = {
        route: "directhelp/read",
        data: {
            id: $stateParams.id,
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            }
        }
    };

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = data.data;
            
            $scope.gridOptions.totalItems = data.total;
            
            for (var i = 0; i < $scope.data.length; i++) {
                $scope.data[i].directhelp_id = data.id;
            }
        },
        function (error) {
            console.log(error);
        });
    };

    var columnDefs = [
        {
            field: 'directhelp_price_id',
            displayName: 'ID',
            sort: {direction: uiGridConstants.ASC, priority: 1},
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'price_ek',
            displayName: 'EK Preis',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD | decimal2currency}}€</div>'
        },
        {
            field: 'price_vk',
            displayName: 'VK Preis',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD | decimal2currency}}€</div>'
        },
        {
            field: 'valid_from',
            displayName: 'Gültig ab',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        },
        {
            field: 'valid_until',
            displayName: 'Gültig bis',
            headerCellFilter: 'translate',
            cellTemplate: '<div data-ng-if="row.entity.valid_until" class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>' +
                    '<div data-ng-if="!row.entity.valid_until" class="ngCellText" ng-class="col.colIndex()">∞</div>'
        },
        {
            field: 'function',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 150,
            //visible: $scope.edit == 1,
            headerCellFilter: 'translate',
            cellTemplate: '<a ng-if="row.entity.newest" href="" permission permission-only="[\'ADMIN\']" ui-sref="directhelp.prices.update({id: row.entity.id, idPrice: row.entity.directhelp_price_id})"><i class="fa fa-pencil"></i></a>'
        }
    ];


    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSize: $rootScope.itemsPerPage,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.core.on.sortChanged($scope, function (grid, sort) {


                if (sort[0] && sort[0].field) {
                    //1. Sorting setzen nach Feld und ORder
                    $scope.api.data.sort.column = sort[0].field;
                    $scope.api.data.sort.order = sort[0].sort.direction;

                    //2. 
                    gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                        $scope.data = data.data;
                    }, function (error) {
                        console.log(error);
                    });
                }
                ;
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = data.directhelp_price;
                    for (var i = 0; i < $scope.data.length; i++) {
                        $scope.data[i].directhelp_id = data.id;
                    }
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tabmenudirecthelp
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tabmenudirecthelp', function (tabmenuService, directhelpService, $stateParams, $filter, $compile, $rootScope) {
    var childScope;

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/tabmenu/tabmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            if ($stateParams.status) {
                scope.pageIndex = $stateParams.status;
            } else {
                scope.pageIndex = 0;
            }

            scope.changeIndex = function (indexToChange) {
                scope.pageIndex = indexToChange;
            };

            var updateView = function (bSearch) {
                scope.bSearch = bSearch;
                scope.searchCounts = "?";
                tabmenuService.getTabCounts("directhelp/count").then(function (data) {
                    scope.bSearch = bSearch;
                    scope.searchCounts = data["ALL"];
                    if(bSearch) {
                        scope.searchCounts = 0;
                        angular.forEach(data.directhelpbytype, function (value) {
                            scope.searchCounts += value;
                        });
                    }
                    directhelpService.readDirecthelptyp().then(function (dataDt) {
                        scope.directhelptyp = dataDt;
                        scope.grids = [];
                        angular.forEach(scope.directhelptyp, function (directhelptyp, key) {

                            scope.grids.push({
                                name: "directhelp-typ",
                                parameter: [
                                    {
                                        key: "id",
                                        value: directhelptyp.id
                                    },
                                    {
                                        key: "slug",
                                        value: directhelptyp.slug
                                    }],
                                title: directhelptyp.name,
                                permissionOnly: ['ADMIN', 'TRAINER','LOKO','SSH', 'REKO', 'BUKO', 'EFB'],
                                data: data.directhelpbytype[directhelptyp.name]
                            });
                        });
                        var html = tabmenuService.setTabs(scope.grids);
                        var template = angular.element(html);
                        var myEl = angular.element(document.querySelector('.tab-content'));
                        if(childScope) {
                            childScope.$destroy();
                        }
                        myEl.empty();
                        myEl.append(template);
                        childScope = scope.$new();
                        $compile(template)(childScope);

                    },
                        function (error) {
                            console.log(error);
                        });
                }, function (error) {
                    console.log(error);
                });
            };

            scope.$on("directhelpUpdate", function (event, data) {
                updateView(data.bSearch);
            });

            scope.clearFilterByBroadcast = function() {
                $rootScope.$broadcast("sscClearFilter");
            };

            setTimeout(function() {//so $rootScope.search and $rootScope.filter are cleared
                updateView(false);
            }, 1);
        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:directhelpTyp
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('directhelpTyp', function (directhelpService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            id: '@',
            //title: '@',
            slug: '@'
        },
        templateUrl: 'templates/components/shared/grid/grid.view.html' + "?v=" + window.version.tag,
        controller: "directhelpTypController",
        link: function (scope, element, attrs) {
            directhelpService.readDirecthelptyp().then(function (dataDt) {
                angular.forEach(dataDt, function (directhelptyp, key) {
                    if(directhelptyp.slug==attrs.slug){
                        scope.title = directhelptyp.name;
                    }
                 });
            });     
        }
    };
}); 

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:directhelpTypController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('directhelpTypController', function ($scope, uiGridConstants, $rootScope, formService, ngDialog, directhelpService, gridService, $translate) {

    $scope.data = [];
    $scope.api = {
        route: "directhelp/read",
        data: {
            directhelp_type_id: $scope.id,
            items: $rootScope.itemsPerPage,
            sort: {
                column: "id",
                order: "asc"
            },
            filter: $rootScope.filter,
            search: $rootScope.search
        }
    };

    var cols = ['valid_from'];
    $scope.gridName = 'directhelptyp';

    // UI GRID: updates data
    $scope.getTableData = function () {

        return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
            $scope.data = formService.formatGrid(data.data, cols, 'directhelp_price');
            $scope.gridOptions.totalItems = data.total;
            // suche Tab
            directhelpService.readDirecthelptyp().then(function (data) {
                $scope.directhelptyp = data;
                var i = 0;

                angular.forEach($scope.directhelptyp, function (directhelptyp) {
                    if (directhelptyp.id == parseInt($scope.id)) {
                        if ($scope.api.data.search || $scope.api.data.filter)
                            $rootScope.$broadcast('updateTabcount', {count: $scope.gridOptions.totalItems, case: i});
                    } else {
                        i++;
                    }
                });
            }, function (error) {
                console.log(error);
            });
        },
                function (error) {
                    console.log(error);
                });
    };


    var columnDefs = [
        {
            field: 'id',
            displayName: 'ID',
            sort: {direction: uiGridConstants.ASC, priority: 1},
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a ng-href="#" ui-sref="directhelp.prices({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'description',
            displayName: 'Bezeichnung',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()"><a ng-href="#" ui-sref="directhelp.prices({id: row.entity.id})">{{COL_FIELD}}</a></div>'
        },
        {
            field: 'price_ek',
            displayName: 'Aktueller EK Preis',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD | decimal2currency}}€</div>'
        },
        {
            field: 'price_vk',
            displayName: 'Aktueller VK Preis',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD | decimal2currency}}€</div>'
        },
        {
            field: 'valid_from',
            displayName: 'Gültig seit',
            headerCellFilter: 'translate',
            cellTemplate: '<div class="ngCellText" ng-class="col.colIndex()">{{COL_FIELD}}</div>'
        }
    ];

    if ($scope.slug !== 'ARCHIVE') {
        columnDefs.push({
            field: 'actions',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 150,
            visible: gridService.checkVisible('actions', $scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<a title="Bearbeiten" href="" ui-sref="directhelp.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true" ng-if="(row.entity.directhelp_type_id !== 2)" ></i></a> '
                    + '<a title="{{\'BTN_DIRECTHELP_PRICE_CREATE\' | translate}}" href="" ui-sref="directhelp.prices.create({id: row.entity.id})" ng-if="(row.entity.directhelp_type_id !== 2)" ><i class="fa fa-euro" aria-hidden="true"></i></a>'
                    + '<a title="{{\'BTN_ARCHIVE\' | translate}}" href="" class="ui-grid-nav" ng-hide="(row.entity.slug === \'ARCHIVE\')" ng-click="grid.appScope.archive(row.entity.id, row.entity.description)"><i class="fa fa-archive" aria-hidden="true"></i></a> <a title="{{\'BTN_ACTIVATE\' | translate}}" href="" ng-click="grid.appScope.activateDialog(row.entity.id)" ng-if="(row.entity.status != 1) && (row.entity.slug !== \'ARCHIVE\')"><i class="fa fa-eye-slash" aria-hidden="true"></i></a> <a title="{{\'BTN_DEACTIVATE\' | translate}}" href="" ng-if="(row.entity.status != 0) && (row.entity.slug !== \'ARCHIVE\')" ng-click="grid.appScope.deactivateDialog(row.entity.id)"><i class="fa fa-eye" aria-hidden="true"></i></a>'
        });
    }
    else {
        columnDefs.push({
            field: 'actions',
            cellClass: 'ui-grid-func-cell',
            displayName: 'Funktionen',
            enableSorting: false,
            enableHiding: false,
            width: 150,
            visible: gridService.checkVisible('actions', $scope.gridName),
            headerCellFilter: 'translate',
            cellTemplate: '<a title="Bearbeiten" href="" ui-sref="directhelp.update({id: row.entity.id})"><i class="fa fa-pencil" aria-hidden="true" ng-if="(row.entity.directhelp_type_id !== 2)" ></i></a> '
        });
    }

    $scope.deactivateDialog = function (id) {
        ngDialog.open({
            template: 'templates/landingpage/deactivate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function () {
                $scope.getTableData();
            }
        });
    };

    $scope.activateDialog = function (id, description) {
        ngDialog.open({
            template: 'templates/landingpage/activate.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            scope: $scope,
            data: {
                'id': id
            },
            preCloseCallback: function () {
                $scope.getTableData();
            }
        });
    };

    $scope.archive = function (id, description) {
        ngDialog.open({
            template: 'templates/landingpage/directhelp_archive.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false,
            data: {
                'id': id,
                description: description
            },
            preCloseCallback: function () {
                $scope.getTableData();
                $rootScope.$broadcast("directhelpUpdate"); // HAS TO STAY!
            }
        });
    };

    $scope.activate = function (id) {

        directhelpService.activateDirecthelp(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            ngDialog.close();
            console.log(error);
        });
    };

    $scope.deactivate = function (id) {

        directhelpService.deactivateDirecthelp(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            ngDialog.close();
            console.log(error);
        });
    };

    $scope.archiveDirecthelp = function (id) {

        directhelpService.archiveDirecthelp(id).then(function (data) {
            ngDialog.close();
        }, function (error) {
            ngDialog.close();
            console.log(error);
        });
    };

    $scope.gridOptions = {
        data: 'data',
        columnDefs: columnDefs,
        useExternalSorting: true,
        enableColumnMenus: false,
        enableFiltering: false,
        fastWatch: true,
        enableRowSelection: true,
        enableSelectAll: false,
        selectionRowHeaderWidth: 0,
        rowHeight: 35,
        // Pagination
        enablePagination: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        paginationCurrentPage: 1,
        paginationPageSize: $rootScope.itemsPerPage,
        paginationPageSizes: [1, 5, 10, 25, 50],
        totalItems: '$scope.data.total',
        onRegisterApi: function (gridApi) {

            $scope.gridApi = gridApi;

            gridApi.core.on.sortChanged($scope, function (grid, sort) {


                if (sort[0] && sort[0].field) {
                    //1. Sorting setzen nach Feld und ORder
                    $scope.api.data.sort.column = sort[0].field;
                    $scope.api.data.sort.order = sort[0].sort.direction;

                    //2. 
                    gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                        $scope.data = formService.formatGrid(data.data, cols, 'directhelp_price');
                    }, function (error) {
                        console.log(error);
                    });
                }
                ;
            });

            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                if ($scope.api) {
                    $scope.api.data.page = newPage;
                    $scope.api.data.items = pageSize;
                }

                // Daten abholen
                gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                    $scope.data = formService.formatGrid(data.data, cols, 'directhelp_price');
                    $rootScope.$broadcast("gridLoaded");
                }, function (error) {
                    console.log(error);
                });
            })
        }
    };
});

"use strict";


angular.module('frontendApp').directive("sscSearch", function (formService, $rootScope, moment) {

    return{
        priority: 1,
        require: 'ngModel',
        scope: {
            sscSearchPlaceholder: "@",
            sscSearchOnsubmit: "&",
            sscSearchOnclear: "&",
            sscSearchModel: "=",
            sscSearchFiltered: "="
        },
        transclude: true,
        templateUrl: 'templates/components/shared/search/sscSearch/sscSearch.view.html' + "?v=" + window.version.tag
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:exampleService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('tabmenuReviewService', function ($http, $q, api, $rootScope, localStorageService) {

    var service = {};

    service.setTabs = function (tabs) {

        var html = "";
        var i = 0;
        var user = localStorageService.get('user');

        angular.forEach(tabs, function (value, key) {

            var ret = false;
            angular.forEach(value.permissionOnly, function (v_role, k_role) {
                angular.forEach(user.user_role_map, function (v_user, k_user) {
                    if (v_role == v_user.role.slug) {
                        ret = true;
                    }
                });
            });

            if (ret) {
                var directive = '<' + value.name + '></' + value.name + '>';
                if (value.parameter) {
                    var parameters = "";
                    angular.forEach(value.parameter, function (v_parameter, k_parameter) {
                        parameters += v_parameter.key + '="' + v_parameter.value + "\" ";
                    });
                    directive = '<' + value.name + ' ' + parameters + '"></' + value.name + '>';
                }

                html = html + '<div ng-if="pageIndex == ' + i + '"><div class="tab-pane">' + directive + '</div></div>';
            } else {
                //TODO fehlermeldung
                console.log('insufficent_rights@tabmenuReview.factory');
            }
            i = i + 1;
        });

        return html;
    };

    service.buildSite = function (site) {
        
        var directive = '<' + site + '></' + site + '>';

        return directive;
    };


    return service;

});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:exampleService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('tabmenuService', function (apiService, $rootScope, localStorageService) {

    var service = {};

    service.setTabs = function (tabs) {

        var html = "";
        var i = 0;
        var user = localStorageService.get('user');        
         
        angular.forEach(tabs, function (value, key) {
            
            var ret = false;
            angular.forEach(value.permissionOnly, function (v_role, k_role) {
                angular.forEach(user.user_role_map, function (v_user, k_user) {
                    if(v_role == v_user.role.slug) {
                        ret = true;
                    }
                });
            });
            
            if(ret) {
                var directive = '<' + value.name + '></' + value.name + '>';
                if(value.parameter) {
                    var parameters = "";
                    angular.forEach(value.parameter, function (v_parameter, k_parameter) {
                        parameters += v_parameter.key + '="'+ v_parameter.value + "\" ";
                    });
                    directive = '<' + value.name + ' ' + parameters + '"></' + value.name + '>';
                }

                html = html + '<div ng-if="pageIndex == ' + i + '"><div class="tab-pane">' + directive + '</div></div>';
            }
            i = i + 1;
        });
        
        return html;
    };

    service.getTabCounts = function (route, id) {
        var data = {
            id: id,
            search: $rootScope.search,
            filter: $rootScope.filter,
            consultation_type: $rootScope.consultationType
        };
        return apiService.post(route, data);
    };

    return service;

});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:submenuController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('submenuController', function ($scope, $stateParams, localStorageService) {

    $scope.id = $stateParams.id;
    $scope.idPrice = $stateParams.idPrice;
    $scope.roleId = $stateParams.roleId;
    $scope.roleMapId = $stateParams.roleMapId;
    $scope.substituteId = $stateParams.substituteId;

    var user = localStorageService.get('user');
    if (user) {
        $scope.userId = user.id;
    }
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('profilmenu', function ($rootScope, localStorageService) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/profilmenu/profilmenu.view.html' + "?v=" + window.version.tag,
        controller: 'profilmenuController',
        link: function (scope, element, attrs) {
        }
    };
}); 

"use strict";
/**
 * @ngdoc controller
 * @name :profilmenuController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('profilmenuController', function ($scope, $rootScope, localStorageService) {
    $scope.authenticated = $rootScope.authenticated;

    if ($rootScope.authenticated) {
        var user = localStorageService.get("user");
        if(user) {
            $scope.user = user;
            $scope.name = user.name;
            $rootScope.rootScopeName = user.name;
        }
    }
});


"use strict";
/**
 * @ngdoc directive
 * @name global.directive:mainmenu
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('mainmenu', function ($filter, $state, reviewService) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/shared/menu/mainmenu/mainmenu.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            scope.stateIncludes = function (search)
            {

                //console.log(search);
                //console.log($state.current.name);

                if ($state.current.name.indexOf(search) !== -1)
                {
                    return true;
                }
                return false;
            };

            scope.menu = [
                {
                    route: "home",
                    class: "icon home",
                    title: $filter('translate')('NAV_HOME'),
                    permissionOnly: ["ADMIN", "BUKO", "EFB", "LOKO", "TRAINER", "REKO", "SSH", "SSHPLUS", "KGA"]
                },
                {
                    route: "ssc",
                    routeParams: "({ status: 0})",
                    class: "icon ssc",
                    title: $filter('translate')('NAV_CHECKS'),
                    permissionOnly: ["ADMIN", "BUKO", "REKO", "EFB", "LOKO", "TRAINER", "SSH", "SSHPLUS", "KGA"]
                },
                {
                    route: "user",
                    class: "icon user",
                    title: $filter('translate')('NAV_USER'),
                    permissionOnly: ["SSH", "SSHPLUS", "TRAINER", "LOKO", "EFB", "REKO", "BUKO", "ADMIN"]
                },
                {
                    route: "directhelp",
                    class: "icon directhelp",
                    title: $filter('translate')('NAV_INSTAHELP'),
                    permissionOnly: ["TRAINER", "LOKO", "EFB", "REKO", "BUKO", "ADMIN"]
                },
                {
                    route: "location",
                    //routeParams: "({ status: 0})",
                    class: "icon location",
                    title: $filter('translate')('NAV_PLACES'),
                    permissionOnly: ["ADMIN", "BUKO", "EFB", "LOKO"]
                },
                {
                    route: "exchange", //({ status: 0})
                    class: "icon exchange",
                    title: $filter('translate')('NAV_FRIDGE'),
                    permissionOnly: ["ADMIN", "LOKO"]
                }
            ];
            if(reviewService.hasTabs()) {
                scope.menu.push({
                    route: "review", //({ status: 0})
                    class: "icon review",
                    title: $filter('translate')('NAV_RATING'),
                    permissionOnly: ['TRAINER', 'LOKO', 'EFB', 'REKO', 'BUKO', 'ADMIN', 'KGA']
                });
            }
            scope.menu.push({
                    route: "news", //({ status: 0})
                    class: "icon news",
                    title: $filter('translate')('NAV_NEWS'),
                    permissionOnly: ["ADMIN"]
                });
        }
    };
}); 

"use strict";
/**
* @ngdoc directive
* @name global.service:verifyService
* @scope
* @restrict E
*
* @description
* A description of the service
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').factory('verifyService', function($http, $q, $stateParams, ngDialog, api) {
	
    var service = {};

    service.setVerifyUser = function() {
        
        var deferred = $q.defer();
        $http.post(api.root + 'public/verify/user/' + $stateParams.id)
        
            .success(function(data, status) {
                deferred.resolve(data);
            })
            
            .error(function(error, status) {
                deferred.reject(error);
                console.log('Verifizierung konnte nicht abgeschlossen werden')
            });
            return deferred.promise;
    };

    service.setVerifyEmail   = function() {
        
        var deferred = $q.defer();
        $http.post(api.root + 'public/verify/email/' + $stateParams.id)
        
            .success(function(data, status) {
                deferred.resolve(data);
            })
            
            .error(function(error, status) {
                deferred.reject(error);
                console.log('Verifizierung konnte nicht abgeschlossen werden')
            });
            return deferred.promise;
    };

    service.setRejectUser = function() {
        
        var deferred = $q.defer();
        $http.post(api.root + 'public/reject/user/' + $stateParams.id)
        
            .success(function(data, status) {
                deferred.resolve(data);
            })
            
            .error(function(error, status) {
                deferred.reject(error);
                console.log('Verifizierung konnte nicht abgeschlossen werden')
            });
            return deferred.promise;
    };


    return service;
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:verifyController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('verifyController', function (ngDialog, verifyService, $state) 
{       
    if( $state.current.name.indexOf('User') !== -1 )
    {
        // reject or verify
        if( $state.current.name.indexOf('verify') !== -1 )
        {
            verifyService.setVerifyUser().then(function(data) 
            {                  
                ngDialog.open({
                    template: 'templates/landingpage/verfiySendUser.html' + "?v=" + window.version.tag,                    
                    className: '',
                    showClose: false,
                    closeByDocument: false                 
                });
            },function(error){
                $state.go('404');
                console.log(error);
                return;
            }); 
        }
        else if($state.current.name.indexOf('reject') !== -1 )
        {
            verifyService.setRejectUser().then(function(data) 
            {                  
                ngDialog.open({
                    template: 'templates/landingpage/verfiyRejectUser.html' + "?v=" + window.version.tag,                    
                    className: '',
                    showClose: false,
                    closeByDocument: false                 
                });
            },function(error){
                $state.go('404');
                console.log(error);
                return;
            }); 
        }
        else
        {
            $state.go('404');
        }
    }
    else
    {
        verifyService.setVerifyEmail().then(function(data) 
        { 
            ngDialog.open({
                template: 'templates/landingpage/verfiySendEmail.html' + "?v=" + window.version.tag,                    
                className: '',
                showClose: false,
                closeByDocument: false            
            });
        },function(error){
            $state.go('404');
            console.log(error);
            return;
        });
    }
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:passwordForgotten
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('resetPasswordService', function (apiService) {

    var service = {};

    service.resetPassword = function (data) {
        return apiService.post("public/resetPassword", data);
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:resetPassword
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('resetPassword', function (userChangePasswordService) {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/core/auth/resetPassword/resetPassword.view.html' + "?v=" + window.version.tag,
        controller: 'resetPasswordController',
        link: function (scope, element, attrs) {
        }
    };
});
"use strict";
/**
 * @ngdoc controller
 * @name resetPasswordController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('resetPasswordController', function ($scope, formService, resetPasswordService, $filter, $stateParams, $state) {



    $scope.required = {
        newPassword: true,
        newPasswordRepeat: true,
        username: true
    };

    $scope.pwInvalid = false;
    
    $scope.check = function () {
        if ($scope.model.newPassword != $scope.model.newPasswordRepeat) {
            return false;
        }
        return formService.check($scope.required, $scope.model);
    };

    $scope.checkPw = function() {
        if(/*($scope.model.newPassword.length < 8 && $scope.model.newPassword.length > 0) || */
            $scope.model.newPassword.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{8,})$/) == null) {
            $scope.pwInvalid = true;
        }
        else {
            $scope.pwInvalid = false;
        }
    }

    $scope.save = function (params) {
        $scope.saved = true;
        $scope.errorAlert = undefined;
        
        if (!$scope.check() || $scope.isSaving) {
            return;
        }
        $scope.isSaving = true;

        var data = {
            username: $scope.model.username,
            password: $scope.model.newPassword,
            password_confirmation: $scope.model.newPasswordRepeat,
            token: $stateParams.token
        };
        
        resetPasswordService.resetPassword(data).then(function (data) {            
            $scope.isSaving = false;
            $scope.reset_successfull = true;            
        }, function (error) {
            $scope.isSaving = false;
            $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_PASSWORD_RESET')};
            console.log(error);
        });

    };
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:passwordForgotten
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('passwordForgotten', function (apiService) {

    var service = {};

    service.reset = function (username) {
        return apiService.post("public/sendResetMail", {username: username});
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:example
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('passwordForgotten', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/core/auth/passwordForgotten/passwordForgotten.view.html' + "?v=" + window.version.tag,
        controller: 'passwordForgottenController'
    };
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:passwordForgottenController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('passwordForgottenController', function (api, $http, $state, $rootScope, $auth, $scope, $stateParams, passwordForgotten) {

    $scope.passform_locked = false;
    $scope.reset_successfull = false;
    $scope.reset_failure = false;

    $scope.reset = function() {
        $scope.passform_locked = true;
        passwordForgotten.reset($scope.email).then(function (data) {
            // Lock Form to prevent follow up generations of new password. Only unlock in case of error
            $scope.reset_successfull = true;
            $scope.reset_failure = false;
        }, function (error) {
            console.log(error);
            $scope.passform_locked = false;
            $scope.reset_failure = true;
        });
    };

});
"use strict";
/**
* @ngdoc directive
* @name global.service:logoutService
* @scope
* @restrict E
*
* @description
* A description of the service
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').factory('logoutService', function(ngDialog, $auth, PermRoleStore, localStorageService, $rootScope, $state) {
	
    var service = {};
    var logoutDialog;

    service.logoutOpenDialog = function () {

        logoutDialog = ngDialog.open({
            template: 'templates/components/core/auth/logout/logout.view.html' + "?v=" + window.version.tag,
            className: 'ngdialog-theme-plain'
        });
        
    };

    service.logoutCloseDialog = function () {
         
        logoutDialog.close();
    };

    service.logout = function(params) {
        $auth.logout().then(function() {

            // Remove the authenticated user from local storage
            localStorageService.remove('user');
            localStorageService.remove('lastActive');

            // Flip authenticated to false so that we no longer
            // show UI elements dependant on the user being logged in
            $rootScope.authenticated = false;

            // Remove the current user info from rootscope
            $rootScope.currentUser = null;

            PermRoleStore.clearStore();

            $state.go("login", params);
        });
    };

    return service;
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:logoutController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('logoutController', function ($scope, localStorageService, logoutService, api, $http) {
    $scope.logout = function () {
        //logout on server - blacklist token
        var user = localStorageService.get('user');
        if (user) {
            $http.post(api.root + "public/logout");
            logoutService.logout();
        }
    };
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:example
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('login', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/core/auth/login/login.view.html' + "?v=" + window.version.tag,
        controller: 'loginController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:loginController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('loginController', function (apiService, PermRoleStore, $state, $rootScope, $auth, localStorageService, $scope, $stateParams, $filter, xsrfTokenService) {

    $scope.verified = $stateParams.verified;
    $scope.modus_credentials = true;
    $scope.error_message = null;
    $scope.email = "";
    $scope.password = "";
    $scope.two_factor_pin = "";
    $scope.send = function () {
        var user = {
            username: $scope.email,
            password: $scope.password
        };
        if ($scope.modus_credentials === false) {
            user.two_factor_pin = $scope.two_factor_pin
        }
        xsrfTokenService.getToken().then(() =>
            $auth.login(user).then(function (response) {
                if (response.data) {
                    $rootScope.currentUser = response.data.data;
                    $scope.usernameAvailable = true;
                    $rootScope.authenticated = true;
                    localStorageService.set('user', $rootScope.currentUser);
                } else {
                    $scope.usernameAvailable = false;
                    $rootScope.authenticated = false;
                }

                apiService.post('public/permissions').then(function (permissions) {
                    var user = localStorageService.get('user');
                    angular.forEach(permissions, function (role, key) {
                        PermRoleStore.defineRole(role.slug, function () {

                            var result = false;

                            if (user) {
                                angular.forEach(user.user_role_map, function (roles_user, key_user) {
                                    if (role.slug == roles_user.role.slug) {
                                        result = true;
                                    }
                                });
                            }

                            return result;
                        });
                    });
                }).then(function () {
                    $state.go("home");
                });
            }).catch(function (response) {
                var error = null;
                if (response.data.error) {
                    error = response.data.error;
                }
                switch (error) {
                    case "client_error.login_fail_user_not_aktiv":
                        //user is not active thrown only if password is correct
                        $scope.access_active = false;
                        $scope.access = true;
                        $scope.error_message = $filter('translate')('FORM_ERRORLOGIN_USER_NOT_AKTIV');
                        $scope.modus_credentials = true;
                        break;
                    case "client_error.two_factor_pin_required":
                        $scope.modus_credentials = false;
                        break;
                    case "client_error.two_factor_pin_invalid":
                        $scope.error_message = $filter('translate')('FORM_ERRORLOGIN_USER_TWO_FACTOR_PIN');
                        break;
                    case 'too_many_attempts':
                        $scope.error_message = $filter('translate')('FORM_ERRORLOGIN_TOO_MANY_ATTEMPTS', {"retry_in": response.data.available_in});
                        break;
                    default:
                        //user not found with given credentials..
                        $scope.access = false;
                        $scope.access_active = true;
                        $scope.error_message = $filter('translate')('FORM_ERRORLOGIN_TEXT');
                        $scope.modus_credentials = true;
                }
            })
        )
    };

    $scope.showTwoFactorAuth = function () {
        return $scope.modus_credentials === false;
    };

    $scope.showLoginCredentials = function () {
        return $scope.modus_credentials === true;
    };

    $scope.showErrorBox = function () {
      return $scope.error_message !== null;
    };
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:deniedController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('deniedController', function ($scope, ngDialog) {

    $scope.openDeniedDialog = function() {
        
        ngDialog.open({
            template: 'templates/landingpage/denied.html' + "?v=" + window.version.tag,   
            className: '',
            showClose: false,
            closeByDocument: false
        });
    };
});
"use strict";
/**
* @ngdoc directive
* @name global.service:deleteService
* @scope
* @restrict E
*
* @description
* A description of the service
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').factory('deleteService', function($http, $q, localStorageService, api) {
	
    var service = {};

    service.deleteProfil = function() {
        
        var deferred = $q.defer();
        var user = localStorageService.get('user'); 
        var data = {
            user_id: user.id
        };
        $http.post(api.root + 'auth/profil/delete', data)
        
            .success(function(data, status) {
                deferred.resolve(data);
            })
            
            .error(function(error, status) {
                deferred.reject(error);
                console.log('Profil konnten nicht gelöscht werden')
            });
            return deferred.promise;
    };
    
    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:userDetailService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('userDetailService', function (apiService, $rootScope) {

    var service = {};

    service.rolesForUser = function () {
        return apiService.post("user/read", {readUser: 1});
    };

    service.detail = function (id) {
        return apiService.post("user/read", {id: id});
    };
    
    service.getHighestRole = function () {
        //return highest role of current user
        var user_role = $rootScope.currentUser.user_role;
        user_role.sort(function (x, y) {
            return x.level - y.level
        });
        return user_role[0];
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:userDetail
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('userDetail', function ($stateParams, userDetailService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/user/userDetail/userDetail.view.html' + "?v=" + window.version.tag,
        link: function ($scope, element, attrs) {
            $scope.notFound = false;
            userDetailService.detail($stateParams.id).then(function (data) {
                $scope.model = data;
            }, function (error) {
                $scope.notFound = true;
                console.log(error);
            });

        }
    };
}); 
"use strict";
/**
 * @ngdoc directive
 * @name global.service:exampleService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('usercreateService', function (apiService) {

    var service = {};

    service.readUser = function (id) {
        return apiService.post("user/read", {id: id});
    };

    service.createUser = function (data) {
        return apiService.post("user/create", data);
    };

    service.updateUser = function (data) {
        return apiService.post("user/update", data);
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:userCreate
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('userCreate', function () {
    return { 
        restrict: 'E',
        replace: true,
        scope: {
            isNotFound: "="
        },
        templateUrl: 'templates/components/content/user/userCreate/userCreate.view.html' + "?v=" + window.version.tag,
        controller: 'usercreateController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:userCreateController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('usercreateController', function ($scope, $rootScope, $state, $stateParams, userService, formService, organisationService, locationService, usercreateService, localStorageService, $filter, apiService, twoFactorAuthService, ngDialog) {

    $scope.EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[-]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    $scope.failedUsername = false;
    $scope.isNotFound = false;
    $scope.logged_in_user_id = $rootScope.currentUser.id;

    var areasArr;

    function updateAreaDropdowns() {
        if(!$scope.model || !areasArr) {
            return;
        }

        $scope.dropLocation = [];
        $scope.dropOrganisation = [];
        $scope.dropState = [];

        //figure out slug
        var roleSlug, i;
        if(!$scope.dropRole) {
            return;
        }
        for (i = 0; i < $scope.dropRole.length; i++) {
            if(parseInt($scope.dropRole[i].id) === parseInt($scope.model.role_id)) {
                roleSlug = $scope.dropRole[i].slug;
                break;
            }
        }

        var dropdownArr = userService.getAreaDropdowns(areasArr, roleSlug);

        $scope.dropLocation = dropdownArr.dropLocation;
        $scope.dropOrganisation = dropdownArr.dropOrganisation;
        $scope.dropState = dropdownArr.dropState;
    }

    $scope.init = function () {
        $scope.isSaving = false;
        $scope.changeRequired = {};
        if ($state.current.name.indexOf('user.create') !== -1) {
            $scope.edit = false;

            $scope.model = {
                role_id: $stateParams.roleId,
                area: [{}] //okay...
            };
        } else {
            $scope.edit = true;
            usercreateService.readUser($stateParams.id).then(function (data) {
                $scope.model = data;
                $scope.name = $scope.model.name;
                $scope.updateRequired();
                updateAreaDropdowns();
            }, function (error) {
                $scope.isNotFound = true;
                console.log(error);
            });
        }

        $scope.saved = false;

        userService.getRoles().then(function (data) {
            $scope.dropRole = data;
            for (var i = 0; i < $scope.dropRole.length; i++) {
                $scope.dropRole[i].dropName = $scope.dropRole[i].role + " (" + $scope.dropRole[i].short + ")";
                $scope.dropRole[i].dropSlug = $scope.dropRole[i].slug;
            }
        }, function (error) {
            console.log(error);
        });

        userService.getEmploymentType().then(function (data) {
            $scope.dropEmploymentType = data;
        }, function (error) {
            console.log(error);
        });

        apiService.post("user/readaccessibleareas", {mode: 'write'}).then(function (data) {
            areasArr = data;
            updateAreaDropdowns();
        }, function (error) {
            console.log(error);
        });

        $scope.$watch('model.role_id', function(newValue, oldValue) {
            updateAreaDropdowns();
        });

        $scope.updateRequired();
    };

    $scope.resetTwoFactorAuth = function () {
        ngDialog.openConfirm({
            template: 'templates/landingpage/confirm_dialog.html' + "?v=" + window.version.tag,
            data: {
                diagTitle: $filter('translate')('LANDINGPAGE_TWO_FACTOR_RESET_TITLE'),
                diagDescription: $filter('translate')('LANDINGPAGE_TWO_FACTOR_RESET_CONFIRM_TEXT'),
                diagCancel: $filter('translate')('BTN_CANCEL'),
                diagConfirm: $filter('translate')('BTN_RESET')
            }
        }).then(function (data) {
            //confirm
            twoFactorAuthService.reset($scope.model.id)
                .then(function (data) {
                    $scope.model = data;
                    ngDialog.open({
                        template: 'templates/landingpage/ok_dialog.html' + "?v=" + window.version.tag,
                        data: {
                            diagTitle: $filter('translate')('LANDINGPAGE_TWO_FACTOR_RESET_TITLE'),
                            diagDescription: $filter('translate')('LANDINGPAGE_TWO_FACTOR_RESET_SUCCESS_TEXT')
                        }
                    });
                })
                .catch(function (error) {
                    ngDialog.open({
                        template: 'templates/landingpage/ok_dialog.html' + "?v=" + window.version.tag,
                        data: {
                            diagTitle: $filter('translate')('LANDINGPAGE_TWO_FACTOR_RESET_TITLE'),
                            diagDescription: $filter('translate')('LANDINGPAGE_TWO_FACTOR_RESET_FAILED_TEXT')
                        }
                    });
                });
        });
    };

    $scope.setLocationAdress = function () {
        for (var i = 0; i < $scope.dropLocation.length; i++) {
            if ($scope.dropLocation[i].id == $scope.model.location) {
                $scope.model.street = $scope.dropLocation[i].street;
                $scope.model.telephone = $scope.dropLocation[i].telephone;
                $scope.model.postalcode = $scope.dropLocation[i].postalcode;
                $scope.model.city = $scope.dropLocation[i].city;
            }
        }
    };

    $scope.clearAdress = function () {

        $scope.model.street = "";
        $scope.model.telephone = "";
        $scope.model.postalcode = "";
        $scope.model.city = "";
        $scope.model.location = "";
    };

    $scope.updateRequired = function () {
        var model = $scope.model;        
        var required = {};
        required.salutation = true;
        required.firstname = true;
        required.lastname = true;
        required.email = true;
        required.username = false;
        required.role_id = true;


        if (!$scope.edit) {
            model.location = undefined;
            model.organisation = undefined;
            model.state = undefined;
            model.states = undefined;
            model.comment = undefined;
            model.date_begin = undefined;
            model.date_end = undefined;
            model.employment_id = undefined;
            model.mobilephone = undefined;

            var role = getSelectedRole();
            required.username = true;
            required.role_id = true;
            required.location = $scope.showLocation();
            required.organisation = $scope.showOrganisation();
            required.states = $scope.showStates();
            required.street = true;
            required.postalcode = true;
            required.city = true;
            required.telephone = true;
            required.comment = false;

            if (role !== null && role.slug === 'SSH') {
                required.date_begin = true;
                required.date_end = true;
                required.employment_id = true;
            }
        }

        $scope.required = required;
    };

    $scope.update = function () {
        $scope.errorAlert = undefined;
        $scope.saved = true;        
        if ($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            usercreateService.updateUser($scope.model).then(function (params) {
                $scope.isSaving = false;
                var user = localStorageService.get('user');
                if (user.id == params.id) {
                    user.firstname = params.firstname;
                    user.lastname = params.lastname;
                    user.name = params.name;

                    $rootScope.rootScopeName = params.name;

                    localStorageService.set('user', user);
                }

                $state.go("user.overview");
            }, function (error) {
                $scope.isSaving = false;
                
                if(error && error.message){
                    for (var property in error.message) {
                        if (error.message.hasOwnProperty(property)) {
                            for (var index in error.message[property]) {
                                if (!$scope.errorAlert) {
                                    $scope.errorAlert = [];
                                }
                                $scope.errorAlert.push({message: error.message[property][index]});
                            }
                        }
                    }
                }else{
                    $scope.errorAlert = [{
                        message: $filter('translate')('FORM_ERROR_SAVING')
                    }];
                }
                    
                console.log(error);
            });
        }
    };

    $scope.check = function () {
        // Auskommentiert
//        if(!$scope.validEmail($scope.model.email) || !formService.check($scope.required, $scope.model)) {
//            console.log($scope.model.email);
//            console.log("mail");
//            return false;
//        }

        if (!$scope.edit) {
            $scope.model.area = [{
                    location_id: $scope.model.location,
                    organisation_id: $scope.model.organisation, //todo sicherstellen dass mit backend funktioniert wenn implementiert
                    //state_id: $scope.model.state
                }];
            if ($scope.model.states) {
                $scope.model.area = [];
                for (var i = 0; i < $scope.model.states.length; i++) {
                    $scope.model.area.push({
                        state_id: $scope.model.states[i].id
                    });
                }
            }
        }
        //add role_id for required
        if ($scope.model.user_role_map) {
            $scope.model.role_id = $scope.model.user_role_map[0].role.id;
        }

        if(!$scope.edit && !$scope.testUsername($scope.model.username)) {
            return false;
        }

        return formService.check($scope.required, $scope.model);
    };

    $scope.validEmail = function (emailString) {
        return $scope.EMAIL_REGEXP.test(emailString);
    };

    $scope.save = function () {
        $scope.errorAlert = undefined;
        $scope.saved = true;

        if ($scope.model.date_end && $scope.model.date_begin) {
            if ($scope.model.date_end < $scope.model.date_begin) {
                $scope.model.date_begin = undefined;
                $scope.model.date_end = undefined;
                $scope.errorAlert = [{
                    message: $filter('translate')('FORM_ERROR_DATE')
                }];
            }
        }
        
        if ($scope.check() && !$scope.isSaving && !$scope.errorAlert) {
            $scope.isSaving = true;
            usercreateService.createUser($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("user.overview");
            }, function (error) {
                $scope.isSaving = false;

                if (error.error == "client_error.username_taken") {
                    $scope.errorAlert = [{
                        message: $filter('translate')('FORM_ERROR_USERNAME_TAKEN')
                    }];
                    $scope.changeRequired.username = $scope.model.username;
                } else {
                    
                    if(error && error.message){
                        for (var property in error.message) {
                            if (error.message.hasOwnProperty(property)) {
                                for (var index in error.message[property]) {
                                    if(!$scope.errorAlert){
                                        $scope.errorAlert=[];
                                    }
                                    $scope.errorAlert.push({message:error.message[property][index]});
                                }
                            }
                        }
                    }else{
                        $scope.errorAlert = [{
                            message: $filter('translate')('FORM_ERROR_SAVING')
                        }];
                    }
                }

                console.log(error);
            });
        }
    };

    $scope.testUsername = function(str) {
        $scope.failedUsername = true;
        str = "" + str;
        str = str.toLowerCase();
        if(str.length < 3 || str.length > 30) {
            return false;
        }
        if(!str.match(/^[a-z0-9_\-\.äüöß]*$/)) {
            return false;
        }
        $scope.failedUsername = false;
        return true;
    };

    $scope.showStates = function () {
        var role = getSelectedRole();
        if (role === null) {
            return false;
        }
        return role.slug === 'BUKO' || role.slug === 'REKO' || role.slug === 'KGA';
    }

    $scope.showOrganisation = function () {
        var role = getSelectedRole();
        if (role === null) {
            return false;
        }
        return role.slug === 'EFB';
    }

    $scope.showLocation = function () {
        var role = getSelectedRole();
        if (role === null) {
            return false;
        }
        return role.slug === 'SSH' || role.slug === 'TRAINER' || role.slug === 'LOKO';
    }

    $scope.showComment = function () {
        return isRoleSsh();
    }

    $scope.showEmployment = function () {
        return isRoleSsh() && !$scope.edit;
    }

    function isRoleSsh() {
        var role = getSelectedRole();
        if (role === null) {
            return false;
        }
        return role.slug === 'SSH';
    }

    function getSelectedRole() {
        if (!$scope.dropRole || !$scope.dropRole.find || !$scope.model || !$scope.model.role_id) {
            return null;
        }
        var roleId = parseInt($scope.model.role_id);
        var role = $scope.dropRole.find((item) => item.id === roleId);
        if (role === undefined) {
            return null;
        }
        return role;
    }

    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:exampleService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('userChangePasswordService', function (apiService) {

    var service = {};

    service.changePassword = function (data) {
        var method = "user/changepassword";
        if(data.user_id === undefined) {
            method = "user/changemypassword";
        }
        return apiService.post(method, data);
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:userChangePassword
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('userChangePassword', function (userChangePasswordService) {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/user/userChangePassword/userChangePassword.view.html' + "?v=" + window.version.tag,
        controller: 'userChangePasswordController',
        link: function (scope, element, attrs) {
        }
    };
});
"use strict";
/**
 * @ngdoc controller
 * @name userChangePassword
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('userChangePasswordController', function ($scope, $state, $stateParams, usercreateService, userChangePasswordService, logoutService, $filter, formService, $window){

    $scope.MODE_MY_PW = 0;
    $scope.MODE_OTHER_PW = 1;

    $scope.mode = -1;

    $scope.errorMsg = "";

    $scope.pwInvalid = true;

    $scope.isNotFound = false;

    $scope.checkPw = function() {
        $scope.pwInvalid = !($scope.model.newPassword.length >= 8 && $scope.model.newPassword.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/));
    };

    $scope.init = function() {
        $scope.isSaving = false;

        $scope.model = {};

        if ($state.current.name == "user.changeMyPassword" || $state.current.name == "requireNewPw") {
            $scope.mode = $scope.MODE_MY_PW;
        } else {
            $scope.mode = $scope.MODE_OTHER_PW;

            usercreateService.readUser($stateParams.id).then(function (data) {
                $scope.model = data;
                $scope.model.newPassword = "";
                if(!$scope.model.CAN_WRITE) {
                    $scope.isNotFound = true;
                }
            }, function (error) {
                $scope.isNotFound = true;
                console.log(error);
            });
        }

        $scope.required = {
            newPassword: true,
            newPasswordRepeat: true
        };
    };

    $scope.check = function () {
        if($scope.model.newPassword != $scope.model.newPasswordRepeat) {
            return false;
        }
        if(!$scope.testPw($scope.model.newPassword)) {
            return false;
        }
        return formService.check($scope.required, $scope.model);
    };

    $scope.save = function(params) {

        $scope.saved = true;
        $scope.errorAlert = undefined;

        if(!$scope.check() || $scope.pwInvalid || $scope.isSaving) {
            return;
        }
        $scope.isSaving = true;
        var data = {
            password: $scope.model.newPassword,
            password_compare: $scope.model.newPasswordRepeat,
            user_id: ($scope.mode == $scope.MODE_OTHER_PW) ? $scope.model.id : undefined
        };
        userChangePasswordService.changePassword(data).then(function (data) {
            $scope.isSaving = false;
            if(data.logged_out === true) {
                logoutService.logout({verified: true});
            } else {
                $window.history.back();
            }
        }, function (error) {
            $scope.isSaving = false;
            $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
            console.log(error);
        });

    };

    $scope.testPw = function(str) {
        return true;
    };


    $scope.init();
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:twoFactorAuthService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('twoFactorAuthService', function (apiService) {

    var service = {};

    service.reset = function (userId) {
        return apiService.post("user/2fa/reset", {user_id: userId});
    };

    service.getSecret = function () {
        return apiService.get("user/2fa/secret");
    };

    service.confirmSecret = function (oneTimePassword) {
        return apiService.post("user/2fa/confirm", {one_time_password: oneTimePassword});
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:twoFactorAuth
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/

angular.module('frontendApp').directive('twoFactorAuth', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/user/twoFactorAuth/twoFactorAuth.view.html' + "?v=" + window.version.tag,
        controller: 'twoFactorAuthController'
    };
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:twoFactorAuthController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('twoFactorAuthController', function ($scope, twoFactorAuthService, $state, $filter, logoutService, ngDialog, userService) {

	$scope.isSaving = false;
	$scope.isLoading = true;
	$scope.noData = false;
	$scope.error = "";

	$scope.model = {
		secret: "",
		one_time_password: ""
	};

	twoFactorAuthService.getSecret()
		.then(function (data) {
			$scope.model.secret = data.secret;
			$scope.isLoading = false;
		})
		.catch(function () {
			$scope.isLoading = false;
			$scope.noData = true;
		})

	$scope.save = function () {
		$scope.isSaving = true;
		twoFactorAuthService.confirmSecret($scope.model.one_time_password)
			.then(function (data) {
				unsetError();
				$scope.isSaving = false;
				if (data.success === true) {
					ngDialog.open({
						template: 'templates/landingpage/ok_dialog.html' + "?v=" + window.version.tag,
						data: {
							// diagTitle: $filter('translate')('LANDINGPAGE_TWO_FACTOR_RESET_TITLE'),
							diagTitle: "Konfiguration erfolgreich",
							// diagDescription: $filter('translate')('LANDINGPAGE_TWO_FACTOR_RESET_SUCCESS_TEXT'),
							diagDescription: "Die Zwei Faktor Autorisierung wurde erfolgreich angelegt. Sie werden nun ausgeloggt und müssen sich mithilfe Ihrer Authentifizierungs-App erneut einloggen.",
						}
					});
					logoutService.logout();
				}
				else {
					handleError("no_success");
				}
			})
			.catch(function (data) {
				$scope.isSaving = false;
				var error = null;
				if (data.error) {
					error = data.error;
				}
				handleError(error);
			});
	}

	$scope.showErrorBox = function () {
		return $scope.error !== "";
	}

	function handleError(error) {
		switch (error) {
			case "client_error":
				$scope.error = $filter("translate")("USER_CREATE_TWO_FACTOR_AUTH_NO_PIN");
				break;
			case "error.one_time_password_invalid":
				$scope.error = $filter("translate")("USER_CREATE_TWO_FACTOR_AUTH_WRONG_PIN");
				break;
			default:
				$scope.error = $filter("translate")("FORM_ERROR_SAVING");
		}
	}

	function unsetError() {
		$scope.error = "";
	}
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:usersearchService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('usersearchService', function (apiService) {

    var service = {};

    service.search = function (data) {
        return apiService.post("user/search", {data: data});
    };

    service.loadLocationList = function () {
        return apiService.post("location/readviauser", {plain: true});
    };

    service.loadUserList = function () {
        return apiService.post("location/read", {plain: true});
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:searchuser
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('searchuser', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/user/search/search.view.html' + "?v=" + window.version.tag,
        controller: 'searchUserController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:searchLocationController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('searchUserController', function ($scope, $rootScope, usersearchService, searchService, searchCacheService) {

    var lastFilter = {};
    function genFilter() {
        return [$scope.location_id, $scope.isOnlyActive, $scope.searchfield, $scope.user_right];
    }
    function hasFilterChanged(newFilter) {
        return JSON.stringify(newFilter) !== JSON.stringify(lastFilter);
    }

    $scope.init = function () {
        $scope.location_id = null;
        $scope.user_right = null;
        $scope.isOnlyActive = 1;
        $scope.searchfield = null;
        $scope.user_right = null;
        $scope.bSearch = true;
        $scope.dropRights = [
            {name: null, label: ""},
            {name: "report_controlling_list", label: "SEARCH_RIGHT_REPORT_CONTROLLING_LIST"}
        ];
        $scope.user_right = $scope.dropRights[0].name;
        lastFilter = genFilter();

        delete $rootScope.search;
        delete $rootScope.filter;
        var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "data");
        if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.user)) {
            $scope.bSearch = searchCacheService.getCacheDataByKey(searchCacheService.type.user, "bSearch") === true;
            if (cacheData.hasOwnProperty("search") && typeof cacheData.search === "object")
                $scope.searchfield = cacheData.search.search;
            if (typeof cacheData.filter === "object" && cacheData.filter.hasOwnProperty("length")) {
                for (var n = 0; n < cacheData.filter.length; n++) {
                    var filter = cacheData.filter[n];
                    if (filter.hasOwnProperty("location")) {
                        $scope.location_id = parseInt(filter.location);
                    }
                    if (filter.hasOwnProperty("isOnlyActive"))
                       $scope.isOnlyActive = filter.isOnlyActive;
                    if (filter.hasOwnProperty("user_right"))
                        $scope.user_right = filter.user_right;
                }
            }
            $scope.setFilterInRoot();
        }
        else {
            searchCacheService.unsetData(searchCacheService.type.user);
        }
        usersearchService.loadLocationList().then(function (data) {
            $scope.dropLocation = data;
        });
    };

    $scope.clearFilter = function () {
        $scope.location_id = null;
        $scope.isOnlyActive = 0;
        $scope.user_right = null;
        $scope.searchfield = null;
        lastFilter = genFilter();

        $scope.showDetails = false;
        $scope.bSearch = false;
        $rootScope.search = {
            search: $scope.searchfield
        };
        $rootScope.filter = {};
        
        delete $rootScope.search;
        delete $rootScope.filter;
        searchCacheService.unsetData(searchCacheService.type.user);
        searchService.closeCollapse('filter-collapse');
        $rootScope.$broadcast("userUpdate", {bSearch: $scope.bSearch});
    };
    $scope.$on("sscClearFilter", function () {
        $scope.clearFilter();
    });

    $scope.search = function () {
        var newFilter = genFilter();
        if (hasFilterChanged(newFilter)) {
            lastFilter = newFilter;
            $scope.bSearch = true;
            searchCacheService.setCacheData(searchCacheService.type.user, "bSearch", $scope.bSearch);
            searchCacheService.setCacheData(searchCacheService.type.user, "data", null);
            $scope.setFilterInRoot();
            $rootScope.$broadcast("userUpdate", {bSearch: $scope.bSearch});
        }
    };

    $scope.setFilterInRoot = function () {
        var search = {
            search: $scope.searchfield
        };

        var filter = [
            {column: 'location.id', location: $scope.location_id},
            {user_right: $scope.user_right},
            {isOnlyActive: $scope.isOnlyActive}
        ];

        $rootScope.search = search;
        $rootScope.filter = filter;
    };

    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:directhelpTyp
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tileSmall', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            id: '@',
            title: '@'
        },
        templateUrl: 'templates/components/content/stromsparcheck/tile/tile_small.view.html' + "?v=" + window.version.tag,
        controller: "tileController"
    };
}); 

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:tileLarge
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('tileLarge', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: false,
        templateUrl: 'templates/components/content/stromsparcheck/tile/tile_large.view.html' + "?v=" + window.version.tag,
        controller: "tileController"
    };
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:tileService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('tileService', function (apiService) {

    var service = {};

    var tileStatusData = false;

    service.getTileStatus = function (id) {
        var temp =  apiService.post("checks/tileStatus", {ssc_id: id});
        temp.then(function(val) {
            tileStatusData = val;
        });
        return temp;
    };

    service.getMonitoringState = function() {
        return tileStatusData.is_monitoring_state;
    };

    service.isHeatLocation = function() {
        return tileStatusData.model_warm;
    };

    service.hasClimateProtection = function () {
        return tileStatusData.has_climate_protection;
    };

    service.isTelephoneCheck = function () {
        return tileStatusData.is_telephone_check;
    };

    service.isFridgeCheck = function () {
        return tileStatusData.is_fridge_exchange_check;
    }

    return service;
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:tileLargeController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('tileController', function ($rootScope, $scope, $state, $stateParams, tileService, apiService) {

    $scope.isAnonymised = false;
    $scope.id = $stateParams.id;

    apiService.post("checks/ssc/read", {id: $stateParams.id, status: -1}).then(function (data) {
        $scope.name = data.name;
        $scope.consultation_type = data.ssc_consultation_type;
        $scope.isAnonymised = data.is_anonymised;
        if($scope.isAnonymised) {
            $rootScope.$broadcast('disable-comments');
        }

    }, function (error) {
        console.log(error);
    });

    // Bind variables to scope which need to be accessed in the template
    $scope.$state = $state;
    $scope.$stateParams = $stateParams;

    $scope.$on('reload-tile-status', function(event, args) {
        tileService.getTileStatus($stateParams.id).then(function (data) {
                $scope.data = data;
            }, function (error) {
                console.log(error);
            });
    });

    $scope.$on('reload-household-name', function(event, args) {
        apiService.post("checks/ssc/read", {id: $stateParams.id, status: -1}).then(function (data) {
            $scope.name = data.name;
            $scope.isAnonymised = data.is_anonymised;
        }, function (error) {
            console.log(error);
        });
    });

    tileService.getTileStatus($stateParams.id).then(function (data) {
            $scope.data = data;
        },
        function (error) {
            console.log(error);
    });

    $scope.overview = function () {
        $state.go("ssc.check.overview.household");
    };

    $scope.generalInformation = function () {
        $state.go("ssc.check.overview.generalInformation");
    };

    $scope.energy = function () {
        $state.go("ssc.check.overview.energy");
    };

    $scope.heat = function () {
        $state.go("ssc.check.overview.heat");
    };

    $scope.lighting = function () {
        $state.go("ssc.check.overview.lighting");
    };

    $scope.toiletFlush = function () {
        $state.go("ssc.check.overview.toiletFlush");
    };

    $scope.shower = function () {
        $state.go("ssc.check.overview.shower");
    };

    $scope.tap = function () {
        $state.go("ssc.check.overview.tap");
    };

    $scope.tips = function () {
        $state.go("ssc.check.overview.tips");
    };

    $scope.telephone = function () {
        $state.go("ssc.check.overview.telephone");
    };

    $scope.telephoneInfo = function () {
        $state.go("ssc.check.overview.telephoneInfo");
    };

    $scope.device = function () {
        $state.go("ssc.check.overview.device");
    };

    $scope.refrigerator = function () {
        $state.go("ssc.check.overview.refrigerator");
    };

    $scope.standby = function () {
        $state.go("ssc.check.overview.standby");
    };

    $scope.electricBoiler = function () {
        $state.go("ssc.check.overview.electricBoiler");
    };

    $scope.kia = function () {
      $state.go("ssc.check.overview.kia");
    };

    $scope.photovoltaic = function () {
        $state.go("ssc.check.overview.photovoltaic");
    };
    
    $scope.monitoring = function () {
        $state.go("ssc.check.overview.monitoring");
    };
    
    $scope.monitoringdirecthelp = function () {
        $state.go("ssc.check.overview.monitoringdirecthelp");
    };
    
    $scope.monitoringmoredevices = function () {
        $state.go("ssc.check.overview.monitoringmoredevices");
    };
    
    $scope.monitoringquestion = function () {
        $state.go("ssc.check.overview.monitoringquestion");
    };
    
    $scope.monitoringsuccess = function () {
        $state.go("ssc.check.overview.monitoringsuccess");
    };
    
});
"use strict";

angular.module('frontendApp').directive('sscLogButton', function ($stateParams) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/stromsparcheck/sscLogButton/sscLogButton.view.html' + "?v=" + window.version.tag,
        link: function($scope) {
            $scope.state = $stateParams;
        },
        controller: function($scope) {
        }
    };
});
"use strict";

angular.module('frontendApp').directive('sscCopyButton', function ($stateParams) {
	return {
		restrict: 'E',
		replace: true,
		scope: {
			disabled: "=?"
		},
		templateUrl: 'templates/components/content/stromsparcheck/sscCopyButton/sscCopyButton.view.html' + "?v=" + window.version.tag,
		link: function ($scope) {
			$scope.state = $stateParams;
		},
		controller: function ($scope, stromsparcheckService, $state, ngDialog, $filter) {

			$scope.isRunning = false;

			$scope.copySsc = function () {
				$scope.isRunning = true;
				ngDialog.openConfirm({
					template: 'templates/landingpage/confirm_dialog.html' + "?v=" + window.version.tag,
					data: {
						diagTitle: $filter('translate')('LANDINGPAGE_CHECK_COPY_CONFIRM_TITLE'),
						diagDescription: $filter('translate')('LANDINGPAGE_CHECK_COPY_CONFIRM_TEXT'),
						diagCancel: $filter('translate')('BTN_CANCEL'),
						diagConfirm: $filter('translate')('BTN_SSC_COPY')
					}
				}).then(function (data) {
					//confirm
					stromsparcheckService.copySsc($stateParams.id).then(
						function (data) {
							$scope.isRunning = false;
							if (data.ssc_id) {
								$state.go("ssc.check.overview.household", {id: data.ssc_id});
							}
						},
						function (error) {
							$scope.isRunning = false;
							ngDialog.open({
								template: 'templates/landingpage/ok_dialog.html' + "?v=" + window.version.tag,
								data: {
									diagTitle: $filter('translate')('LANDINGPAGE_CHECK_COPY_FAILED_TITLE'),
									diagDescription: $filter('translate')('LANDINGPAGE_CHECK_COPY_FAILED_TEXT')
								}
							});
						}
					);
				}, function (data) {
					$scope.isRunning = false;
				});
			};
		}
	};
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:stromsparchecksearchservice
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('stromsparchecksearchservice', function (apiService) {

    var service = {};

    service.search = function (data) {
        return apiService.post("user/search", {data: data});
    };

    service.loadRoleList = function () {
        return apiService.post("role/readownrole", {plain: false});
    };

    service.loadConsultationList = function () {
        return apiService.post("checks/consultation/read");
    };

    service.loadLocationList = function (roleSlug) {
        var data = {
            plain: true,
            role_slug: roleSlug
        };
        return apiService.post("location/readviauser", data);
    };

    service.loadUserList = function () {
        return apiService.post("location/read", {plain: true});
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:example
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('searchssc', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/stromsparcheck/search/search.view.html' + "?v=" + window.version.tag,
        controller: 'searchSSCController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:searchSSCController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('searchSSCController', function ($scope, $rootScope, stromsparchecksearchservice, formService, searchService, searchCacheService) {


    $scope.init = function () {
        $scope.householdfilter = null;
        $scope.roleSlug = null;
        $scope.timeframe = null;
        $scope.timeframe_setting = null;
        $scope.householdfilter = null;
        $scope.from = null;
        $scope.to = null;
        $scope.location = null;
        if (typeof $rootScope.consultationType !== "string")
            $rootScope.consultationType = "visit";
        $scope.consultationType = $rootScope.consultationType;
        $scope.searchfield = null;
        delete $rootScope.from;
        delete $rootScope.to;
        delete $rootScope.search;
        delete $rootScope.filter;
        var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.ssc, "data");
        if (searchCacheService.isBackButton(searchCacheService.type.ssc) && cacheData !== null) {
            $scope.bSearch = searchCacheService.getCacheDataByKey(searchCacheService.type.ssc, "bSearch") === true;
            if (cacheData.hasOwnProperty("search") && typeof cacheData.search === "object")
                $scope.searchfield = cacheData.search.search;
            if (typeof cacheData.filter === "object" && cacheData.filter.hasOwnProperty("length")) {
                for (var n = 0; n < cacheData.filter.length; n++) {
                    var item = cacheData.filter[n];
                    if (item.hasOwnProperty('householdfilter'))
                        $scope.householdfilter = item.householdfilter;
                    if (item.hasOwnProperty('role_slug'))
                        $scope.roleSlug = item.role_slug;
                    if (item.hasOwnProperty('location'))
                        $scope.location = parseInt(item.location);
                    if (item.hasOwnProperty('time')) {
                        $scope.timeframe_setting = item.column;
                        $scope.timeframe = item.time;
                    }
                    if (item.hasOwnProperty('from'))
                        $scope.from = item.value;
                    if (item.hasOwnProperty('to'))
                        $scope.to = item.value;
                }
            }
            $scope.setFilterInRoot();
        }
        else {
            searchCacheService.unsetData(searchCacheService.type.ssc);
        }
        stromsparchecksearchservice.loadConsultationList().then(function (data) {
            $scope.dropConsultation = data;
        });
        stromsparchecksearchservice.loadRoleList().then(function (data) {
            var temp = {};
            var i;
            for(i = 0; i < data.length; i++) {
                temp[data[i].slug] = data[i].role;
            }
            $scope.dropRole = [];
            for(i in temp) {
                if(!temp.hasOwnProperty(i)) {
                    continue;
                }
                $scope.dropRole.push({
                    slug: i,
                    role: temp[i]
                });
            }
            $scope.dropRole.sort(function(a, b) {
                if(a.role < b.role) { return -1; }
                if(a.role > b.role) { return 1; }
                return 0;
            })
        });
        stromsparchecksearchservice.loadLocationList().then(function (data) {
            $scope.dropLocation = data;
        });
    };
    $scope.updateLocation = function () {
        stromsparchecksearchservice.loadLocationList($scope.roleSlug).then(function (data) {
            $scope.dropLocation = data;
            $scope.location = null;
        });
    };
    $scope.clearFilter = function () {
        $scope.householdfilter = null;
        $scope.roleSlug = null;
        $scope.timeframe = null;
        $scope.timeframe_setting = null;
        $scope.householdfilter = null;
        $scope.from = null;
        $scope.to = null;
        $scope.location = null;
        $scope.searchfield = null;
        $scope.showDetails = false;
        $scope.bSearch = false;
        searchCacheService.unsetData(searchCacheService.type.ssc);
        $rootScope.search = {
            search: $scope.searchfield
        };
        $rootScope.filter = {};
        delete $rootScope.search;
        delete $rootScope.filter;
        searchService.closeCollapse('filter-collapse');
        $rootScope.$broadcast("sscUpdate", {bSearch: $scope.bSearch});
    };
    $scope.$on("sscClearFilter", function () {
        $scope.clearFilter();
    });
    $scope.search = function () {
        if ($scope.searchfield !== null || $scope.householdfilter !== null || $scope.roleSlug !== null || $scope.location !== null || $scope.timeframe !== null || $scope.from !== null || $scope.to !== null) {
            $scope.bSearch = true;
            searchCacheService.setCacheData(searchCacheService.type.ssc, "data", null);
            searchCacheService.setCacheData(searchCacheService.type.ssc, "bSearch", $scope.bSearch);
            $scope.setFilterInRoot();
            $rootScope.$broadcast("sscUpdate", {bSearch: $scope.bSearch});
        }
    };

    $scope.setFilterInRoot = function () {
            var search = {
                search: $scope.searchfield
            };
            var filter = [
                {householdfilter: $scope.householdfilter},
                {role_slug: $scope.roleSlug},
                {location: $scope.location},
                
                {column: $scope.timeframe_setting, time: $scope.timeframe},
                
                {from: 'from', operator: '>=', value: $scope.from},
                {to: 'to', operator: '<=', value: $scope.to}
            ];
            $rootScope.search = search;
            $rootScope.filter = filter;
    };

    $scope.consultationTypeChanged = function () {
        $rootScope.consultationType = $scope.consultationType;
        searchCacheService.setCacheData(searchCacheService.type.ssc, "data", null);
        searchCacheService.setCacheData(searchCacheService.type.ssc, "bSearch", $scope.bSearch);
        $scope.setFilterInRoot();
        $rootScope.$broadcast("sscUpdate", {bSearch: $scope.bSearch});
    };

    $scope.$watch('timeframe_setting', function(newValue, oldValue) {
        if(!newValue) {
            $scope.timeframe = null;
            $scope.from = null;
            $scope.to = null;
            delete $rootScope.from;
            delete $rootScope.to;
        }
    });

    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:directhelpTyp
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('plausiSmall', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
        },
        templateUrl: 'templates/components/content/stromsparcheck/plausi/plausi_small.view.html' + "?v=" + window.version.tag,
        controller: "plausiController"
    };
}); 

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:plausiLarge
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('plausiLarge', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {

        },
        templateUrl: 'templates/components/content/stromsparcheck/plausi/plausi_large.view.html' + "?v=" + window.version.tag,
        controller: "plausiController"
    };
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:plausilargeService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('plausiService', function (apiService) {

    var service = {};

    service.getPlausi = function (id) {
        return apiService.post("checks/ssc/plausi", {ssc_id: id});
    };

    return service;
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:plausiController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('plausiController', function ($scope, $stateParams, plausiService, $filter) {
    var propertyUnitMap = [
        {name: "consumption_invoice", unit: "kWh/a"},
        {name: "consumption_analytics", unit: "kWh/a"},
        {name: "consumption_directhelp", unit: "%"},
        {name: "water_total", unit: "m³/a"},
        {name: "water_estimate", unit: "m³/a"},
        {name: "consumption_shower", unit: "m³/a"},
        {name: "water_saving_directhelp", unit: "%"},
        {name: "ek_wert", unit: "€"}
    ];

    $scope.load = function () {
        plausiService.getPlausi($stateParams.id).then(function (data) {
            for (var n = 0; n < propertyUnitMap.length; n++) {
                var name = propertyUnitMap[n].name;
                var isValid = false;
                var value = "";
                if (data.hasOwnProperty(name)) {
                    value = $scope.transformToNumeric(data[name]);
                    isValid = isNaN(value) === false;
                    if (isValid) {
                        value = Math.round(value) + " " + propertyUnitMap[n].unit;
                    }
                }
                if (isValid === false)
                    value = $filter("translate")("SSC_PLAUSI_NO_INFO");
                $scope[name] = value;
            }
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * Replaces the different comma type
     * @param {string} dataString
     * @returns {string}
     */
    $scope.transformToNumeric = function (dataString) {
        return String(dataString).replace(',', '.');
    };

    $scope.$on('reload-plausi', function(event, args) {
        $scope.load();
    });

    $scope.load();

});
"use strict";

//ssc overview grid contents
angular.module('frontendApp').factory('sscOverviewService', function (
    gridService, $filter, $rootScope, ngDialog, stromsparcheckService, localStorageService, formService, moment,
    uiGridConstants, uiGridExporterConstants, $state, searchCacheService
) {

    var service = {};

    const FIELD_DIRECTHELP_EK = 'sh_ek';
    const FIELD_DIRECTHELP_VK = 'sh_vk';
    const FIELD_HAS_FRIDGE_EXCHANGE = 'has_fridge_exchange';
    const FIELD_IS_MONITORED = 'is_monitored';

    service.initTabContents = function ($scope, sscStatus) {

        $scope.downloadCsv = function () {
            $scope.gridApi.exporter.csvExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
        };

        $scope.showExport = true;

        $scope.data = [];
        $scope.api = {
            route: "checks/ssc/read",
            data: {
                status: sscStatus,
                items: $rootScope.itemsPerPage,
                sort: {
                    column: "id",
                    order: "desc"
                },
                filter: $rootScope.filter,
                search: $rootScope.search
            }
        };
        var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.ssc, "data");
        if (cacheData !== null && searchCacheService.isBackButton(searchCacheService.type.ssc)) {
            $scope.api.data = cacheData;
        } else {
            searchCacheService.setCacheData(searchCacheService.type.ssc, "data", $scope.api.data);
        }
        $scope.api.data.consultation_type = $rootScope.consultationType;

        var cols = ['first_visit_at', 'second_visit_at', 'created_at', 'completed_at'];
        // UI GRID: updates data
        $scope.getTableData = function () {

            return gridService.readData($scope.api.route, $scope.api.data).then(function (data) {

                    for (var i in data.data) { //convert to local timezone
                        data.data[i].created_at = moment.utc(data.data[i].created_at).local().format("YYYY-MM-DD HH:mm:ss");
                    }

                    $scope.data = formService.formatGrid(data.data, cols);
                    if ($scope.api.data.search || $scope.api.data.filter)
                        $rootScope.$broadcast('updateTabcount');
                    $scope.gridOptions.totalItems = data.total;
                },
                function (error) {
                    console.log(error);
                });
        };

        $scope.isAdmin = function () {
            var user = localStorageService.get('user');
            for (var i = 0; i < user.user_role.length; i++) {
                if (user.user_role[i].slug === 'ADMIN') {
                    return true;
                }
            }
            return false;
        };
        var columnDefs = [
            {
                field: 'id',
                displayName: 'ID',
                sort: {direction: uiGridConstants.DESC, priority: 1},
                width: 70,
                pinnedLeft: true,
                enableFiltering: false,
                cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a title="{{\'BTN_EDIT\' | translate}}" href="" ui-sref="ssc.check({id: row.entity.id, name: row.entity.name})">{{COL_FIELD}}</a></div>'
            },
            {
                field: 'name',
                displayName: 'SSC_COL_NAME',
                headerCellFilter: 'translate',
                enableFiltering: true,
                pinnedLeft: true,
                cellTooltip: true,
                minWidth: 140
            },
            {
                field: 'street',
                displayName: 'SSC_COL_ADDRESS',
                headerCellFilter: 'translate',
                enableFiltering: false,
                cellTooltip: true,
                minWidth: 140
            },
            {
                field: 'postalcode',
                displayName: 'SSC_COL_POSTALCODE',
                headerCellFilter: 'translate',
                enableFiltering: false,
                cellTooltip: true,
                width: 60
            },
            {
                field: 'city',
                displayName: 'SSC_COL_CITY',
                headerCellFilter: 'translate',
                enableFiltering: false,
                cellTooltip: true,
                minWidth: 140
            },
            {
                field: 'telephone',
                displayName: 'SSC_COL_TELEPHONE',
                headerCellFilter: 'translate',
                enableFiltering: false,
                cellTooltip: true,
                width: 115
            },
            {
                field: 'created_at',
                displayName: 'SSC_COL_CREATED',
                headerCellFilter: 'translate',
                enableFiltering: true,
                width: 90
            },
            {
                field: 'first_visit_at',
                displayName: 'SSC_COL_FIRSTDATE',
                headerCellFilter: 'translate',
                enableFiltering: true,
                width: 90
            },
            {
                field: 'second_visit_at',
                displayName: 'SSC_COL_SECONDDATE',
                headerCellFilter: 'translate',
                enableFiltering: true,
                width: 90
            },
            {
                field: 'completed_at',
                displayName: 'SSC_COL_COMPLETED_AT',
                headerCellFilter: 'translate',
                enableFiltering: true,
                width: 90
            },
            {
                field: 'ssh1_name',
                displayName: 'SSC_COL_ASSIGNED_HELPER_1',
                headerCellFilter: 'translate',
                enableFiltering: false,
                enableSorting: false,
                cellTooltip: true,
                minWidth: 115
            },
            {
                field: 'ssh2_name',
                displayName: 'SSC_COL_ASSIGNED_HELPER_2',
                headerCellFilter: 'translate',
                enableFiltering: false,
                enableSorting: false,
                cellTooltip: true,
                minWidth: 115
            },
            {
                field: 'trainer_name',
                displayName: 'SSC_COL_TRAINER',
                headerCellFilter: 'translate',
                enableFiltering: false,
                enableSorting: false,
                cellTooltip: true,
                minWidth: 115
            },
            {
                field: 'function',
                cellClass: 'ui-grid-func-cell',
                displayName: 'SSC_COL_FUNCTION',
                headerCellFilter: 'translate',
                width: 90,
                pinnedRight: true,
                enableFiltering: false,
                enableSorting: false,
                enableHiding: false,
                cellTemplate: '<a title="{{\'BTN_EDIT\' | translate}}" href="" ui-sref="ssc.check({id: row.entity.id, name: row.entity.name})"><i class="fa fa-pencil" aria-hidden="true"></i></a> '

                    + '<a ng-if="row.entity.ssc_delete_reason==null || grid.appScope.isAdmin()" permission permission-only="[\'LOKO\', \'ADMIN\']" title="{{\'BTN_DELETE_OR_REQUEST\' | translate}}" ng-click="grid.appScope.deleteDialog(row.entity.id,grid.appScope.isAdmin())"><i class="fa fa-trash" aria-hidden="true"></i></a>'

                    + '<a title="{{\'BTN_DOWNLOAD_DOCUMENTS\' | translate}}" href="" class="ui-grid-nav" ui-sref="ssc.check.overview.download({id: row.entity.id})"><i class="fa fa-download" aria-hidden="true"></i></a>'
                    + '<a title="{{\'BTN_LOG_HISTORY\' | translate}}" href="" class="ui-grid-nav" ui-sref="ssc.log({id: row.entity.id})"><i class="fa fa-history" aria-hidden="true"></i></a>'
            },
            {
                field: FIELD_DIRECTHELP_EK,
                displayName: 'SSC_COL_SH_EK',
                headerCellFilter: 'translate',
                enableSorting: false,
                enableFiltering: false,
                width: 60,
                cellTemplate: '<div class="ui-grid-cell-contents"><span data-ng-bind="COL_FIELD | decimal2comma:2"></span> €</div>'
            },
            {
                field: FIELD_DIRECTHELP_VK,
                displayName: 'SSC_COL_SH_VK',
                headerCellFilter: 'translate',
                enableSorting: false,
                enableFiltering: false,
                width: 60,
                cellTemplate: '<div class="ui-grid-cell-contents"><span data-ng-bind="COL_FIELD | decimal2comma:2"></span> €</div>'
            },
            {
                field: 'commentscount',
                displayName: 'SSC_COL_COMMENTS',
                headerTooltip: 'SSC_COL_COMMENTS_INFO',
                headerCellFilter: 'translate',
                enableSorting: false,
                enableFiltering: false,
                width: 60
            },
            {
                field: FIELD_IS_MONITORED,
                displayName: 'SSC_COL_IS_MONITORING',
                headerCellFilter: 'translate',
                enableSorting: false,
                enableFiltering: false,
                width: 90,
                cellTemplate: '<div class="ui-grid-cell-contents text-center"><i class="glyphicon glyphicon-ok" ng-if="COL_FIELD == 1"></i></div>'
            },
            {
                field: FIELD_HAS_FRIDGE_EXCHANGE,
                displayName: 'SSC_COL_KGTP',
                headerCellFilter: 'translate',
                enableSorting: false,
                enableFiltering: false,
                width: 60,
                cellTemplate: '<div class="ui-grid-cell-contents text-center"><i class="glyphicon glyphicon-ok" ng-if="COL_FIELD == 1"></i></div>'
            },
            {
                field: 'id',
                displayName: 'ID',
                width: 70,
                pinnedLeft: true,
                enableFiltering: false,
                enableSorting: false,
                cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a title="{{\'BTN_EDIT\' | translate}}" href="" ui-sref="ssc.check({id: row.entity.id, name: row.entity.name})">{{COL_FIELD}}</a></div>'
            },
            {
                field: 'name',
                displayName: 'SSC_COL_NAME',
                headerCellFilter: 'translate',
                enableFiltering: true,
                enableSorting: false,
                pinnedLeft: true,
                cellTooltip: true,
                minWidth: 140
            },
        ];

        $scope.gridOptions = {
            data: 'data',
            columnDefs: columnDefs,
            enableGridMenu: false,
            enableColumnMoving: true,
            exporterCsvColumnSeparator: ';',
            exporterCsvFilename: $filter('translate')('SEARCH_SSC_EXPORT_FILE') + '.csv',
            exporterOlderExcelCompatibility: true,
            exporterIsExcelCompatible: false,
            exporterFieldCallback: function (grid, row, col, value) {
                switch (col.name) {
                    case FIELD_DIRECTHELP_EK:
                    case FIELD_DIRECTHELP_VK:
                        value = $filter('decimal2comma')(value, 2) + "€";
                        break;
                    case FIELD_HAS_FRIDGE_EXCHANGE:
                    case FIELD_IS_MONITORED:
                        if (Boolean(value) === true) {
                            value = $filter('translate')('YES');
                        } else {
                            value = $filter('translate')('NO');
                        }
                        break;
                }
                if (value === null) {
                    return null
                }
                return value + "\t";
            },
            exporterSuppressColumns: ['function'],
            useExternalSorting: true,
            //enableSorting: false,
            enableColumnMenus: false,
            enableFiltering: false,
            fastWatch: true,
            enableRowSelection: true,
            enableSelectAll: false,
            selectionRowHeaderWidth: 0,
            rowHeight: 35,
            // Pagination
            enablePagination: true,
            enablePaginationControls: false,
            useExternalPagination: true,
            paginationCurrentPage: $scope.api.data.page ? $scope.api.data.page : 1,
            paginationPageSize: $scope.api.data.items,
            paginationPageSizes: [1, 5, 10, 25, 50],
            totalItems: '$scope.data.total',
            onRegisterApi: function (gridApi) {

                $scope.gridApi = gridApi;

                gridApi.core.on.sortChanged($scope, function (grid, sort) {
                    if (sort[0] && sort[0].field) {
                        //1. Sorting setzen nach Feld und ORder
                        $scope.api.data.sort.column = sort[0].field;
                        $scope.api.data.sort.order = sort[0].sort.direction;
                        searchCacheService.setCacheData(searchCacheService.type.ssc, "data", $scope.api.data);
                        //console.log($scope.api.data.sort);

                        //2.
                        gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                            $scope.data = formService.formatGrid(data.data, cols);
                        }, function (error) {
                            console.log(error);
                        });
                    }
                });
                gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    if ($scope.api) {
                        $scope.api.data.page = newPage;
                        $scope.api.data.items = pageSize;
                    }
                    searchCacheService.setCacheData(searchCacheService.type.ssc, "data", $scope.api.data);

                    // Daten abholen
                    gridService.readData($scope.api.route, $scope.api.data).then(function (data) {
                        $scope.data = formService.formatGrid(data.data, cols);
                        $rootScope.$broadcast("gridLoaded");
                    }, function (error) {
                        console.log(error);
                    });
                });
            }
        };

        $scope.deleteDialog = function (id, isAdmin) {
            var handleDialog = function (data) {
                ngDialog.open({
                    template: 'templates/landingpage/check_delete.html' + "?v=" + window.version.tag,
                    className: 'dialogLanding',
                    showClose: false,
                    scope: $scope,
                    data: data,
                    preCloseCallback: function () {
                        $scope.getTableData();
                    }
                });
            };

            var handleReson = function (needReason) {
                if (needReason) {
                    stromsparcheckService.getDeleteReasons().then(function (data) {
                        handleDialog({
                            dropDeleteReason: data,
                            needReason: needReason,
                            id: id
                        });
                    }, function (error) {
                        console.log(error);
                    });
                } else {
                    handleDialog({
                        needReason: needReason,
                        id: id
                    });
                }
            };

            if (!isAdmin) {
                //no admin - check required filled - if yes, ask for reason
                stromsparcheckService.getRequiredFilled(id).then(function (data) {
                    handleReson(data);
                }, function (error) {
                    console.log(error);
                });
            } else {
                handleReson(false);
            }
        };

        $scope.delete = function (id, comment, reason) {
            stromsparcheckService.deleteCheck(id, comment, reason).then(function (data) {
                ngDialog.close();
            }, function (error) {
                console.log(error);
            });
        };
    };

    service.downloadList = function () {
        return apiService.post()
    };

    return service;
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:newscreateService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('commentService', function (apiService) {

    var service = {};

    service.addComment = function(ssc_id, message) {
        var data = {
            ssc_id: ssc_id,
            message: message
        };
        return apiService.post("checks/ssccomment/update", data);
    };

    service.readComments = function(data) {
        return apiService.post("checks/ssccomment/read", data);
    };

    return service;
});
"use strict";

angular.module('frontendApp').directive('reportList', function (apiService, $interval, api, moment) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/review/reportList/reportList.view.html' + "?v=" + window.version.tag,
        controller: function($scope) {
            var energy = 1;

            $scope.apiRoot = api.root;

            $scope.update = function() {
                if($scope.isLoading) {
                    return;
                }

                $scope.isLoading = true;
                //get the data
                apiService.post('report/read', [], {
                    'inBackground': true
                }).then(function(data) {
                    $scope.isLoading = false;
                    for(var i in data) {
                        data[i].created_at = moment.utc(data[i].created_at).local().format("D.M.YYYY HH:mm");
                        if(data[i].finished_at) {
                            data[i].finished_at_short = moment.utc(data[i].finished_at).local().format("HH:mm");
                            data[i].finished_at = moment.utc(data[i].finished_at).local().format("D.M.YYYY HH:mm");
                        }
                    }
                    $scope.data = data.reverse();
                }, function(error) {

                });
            };
            $scope.update();

            $scope.$on("updateReportList", function() {
                $scope.update();
                energy = 1;
            });

            var count = 0;
            var loaderInterval = $interval(function() {
                count++;
                if(count > 60 - energy * 59){
                    $scope.update();
                    count = 0;
                }
                energy *= 0.99;
            }, 1000);

            $scope.$on('$destroy', function() {
                $interval.cancel(loaderInterval);
            });
        }
    };
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:searchnews
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('searchnews', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/news/search/search.view.html' + "?v=" + window.version.tag,
        controller: 'searchNewsController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:searchNewsController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('searchNewsController', function ($scope, $rootScope, searchService, searchCacheService) {
    
    $scope.init = function () {
        $scope.time = null;
        $scope.from = null;
        $scope.to = null;
        $scope.searchfield = null;
        delete $rootScope.from;
        delete $rootScope.to;
        delete $rootScope.search;
        delete $rootScope.filter;
        var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.news, "data");
        if (searchCacheService.isBackButton(searchCacheService.type.news) && cacheData !== null) {
            $scope.bSearch = searchCacheService.getCacheDataByKey(searchCacheService.type.news, "bSearch") === true;
            if (cacheData.hasOwnProperty("search") && typeof cacheData.search === "object")
                $scope.searchfield = cacheData.search.search;
            if (typeof cacheData.filter === "object" && cacheData.filter.hasOwnProperty("length")) {
                for (var n = 0; n < cacheData.filter.length; n++) {
                    var item = cacheData.filter[n];
                    if (item.hasOwnProperty('from'))
                        $scope.from = item.value;
                    if (item.hasOwnProperty('to'))
                        $scope.to = item.value;
                    if (item.hasOwnProperty('column') && item.hasOwnProperty('columntwo') && item.column === "valid_from")
                        $scope.time = item.value;
                }
            }
            $scope.setFilterInRoot();
        } else {
            searchCacheService.unsetData(searchCacheService.type.ssc);
        }
    };

    $scope.clearFilter = function () {
        $scope.time = null;
        $scope.from = null;
        $scope.to = null;
        $scope.searchfield = null;
        $scope.showDetails = false;
        $scope.bSearch = false;
        $rootScope.search = {
            search: $scope.searchfield
        };
        $rootScope.filter = {};
        searchCacheService.unsetData(searchCacheService.type.news);
        delete $rootScope.search;
        delete $rootScope.filter;
        searchService.closeCollapse('filter-collapse');
        $rootScope.$broadcast("newsUpdate", {bSearch: $scope.bSearch});
    };
    $scope.$on("sscClearFilter", function () {
        $scope.clearFilter();
    });

    $scope.search = function () {
        if($scope.searchfield !== null || $scope.time !== null || $scope.from !== null || $scope.to !== null) {
            $scope.bSearch = true;
            searchCacheService.setCacheData(searchCacheService.type.news, "bSearch", $scope.bSearch);
            searchCacheService.setCacheData(searchCacheService.type.news, "data", null);
            $scope.setFilterInRoot();
            $rootScope.$broadcast("newsUpdate", {bSearch: $scope.bSearch});
        }
    };

    $scope.setFilterInRoot = function () {
        var search = {
            search: $scope.searchfield
        };
        var filter = [
            {from: 'from', operator: '>=', value: $scope.from},
            {to: 'to', operator: '<=', value: $scope.to},
            {column: 'valid_from', columntwo: 'valid_until', value: $scope.time}
        ];

        $rootScope.search = search;
        $rootScope.filter = filter;
    };

        
    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:newscreateService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('newsDetailService', function (apiService) {

    var service = {};

    service.detail = function (id) {
        return apiService.post("news/read", {id: id});
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:newsDetail
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('newsDetail', function (newsDetailService,$stateParams, $sce) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/news/newsDetail/newsDetail.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {
            scope.trustAsHtml = function(string) {
                return $sce.trustAsHtml(string);
            };
            newsDetailService.detail($stateParams.id).then(function (data) {
                scope.model = data;
            }, function (error) {
                console.log(error);
            });
        }
    };
     
});



"use strict";
/**
 * @ngdoc directive
 * @name global.service:newscreateService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('newscreateService', function (apiService) {

    var service = {};

    service.readNews = function (id) {
        return apiService.post("news/read", {id: id});
    };

    service.createNews = function (data) {
        return apiService.post("news/create", data);
    };

    service.updateNews = function (data) {
        return apiService.post("news/update", data);
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:newsCreate
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('newsCreate', function ($filter) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/news/newsCreate/newsCreate.view.html' + "?v=" + window.version.tag,
        controller: "newsCreateController"
    };
});

"use strict";
/*
 * @ngdoc controller
 * @name dashboard.controller:newsCreateController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('newsCreateController', function ($scope, $state, $stateParams, formService, $filter, newscreateService, userService) {

    $scope.inputs = {};

	$scope.editorOptions = {
		statusbar: true,
		forced_root_block: 'p',
		element_format: 'html',
		entity_encoding: "raw",
		plugins: "paste lists table link",
		paste_as_text: true,
		toolbar: 'undo redo | styleselect | alignleft aligncentre alignright alignjustify | indent outdent | bullist numlist | link removeformat',
		menubar: 'false',
        setup: function () {
            return true;
        },
	};

    $scope.init = function () {
        $scope.isSaving = false;

        if ($state.current.name.indexOf('news.create') !== -1) {
            $scope.edit = false;
        } else {
            $scope.edit = true;
            newscreateService.readNews($stateParams.id).then(function (data) {
                $scope.model = data;
                $scope.model.rolenews = $scope.model.role;
                $scope.name = $scope.model.headline;

            }, function (error) {
                console.log(error);
            });
        }

        $scope.saved = false;
        userService.getRoles().then(function (data) {
            $scope.dropRole = data;
            var i = 0;
            angular.forEach(data, function (value) {
                var temp = value;

                angular.forEach($scope.model.role, function (val2) {
                    if (val2.id == temp.id) {
                        delete $scope.dropRole[i];
                    }
                });
                i++;
            });
        }, function (error) {
            console.log(error);
        });

        $scope.model = {
            status: 0,
            role: []
        };

        $scope.required = {
            headline: true,
            text: true,
            role: true,
            valid_from: true,
            valid_until: true
        };
    };

    $scope.check = function () {
        return formService.check($scope.required, $scope.model);
    };

    $scope.save = function () {
        $scope.saved = true;
        $scope.errorAlert = undefined;
        if($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            newscreateService.createNews($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("news.overview");
            }, function (error) {
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        }
    };

    $scope.update = function () {
        $scope.saved = true;
        $scope.errorAlert = undefined;
        if($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            newscreateService.updateNews($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("news.overview");
            }, function (error) {
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        }
    };

    $scope.OnClickSelect = function (item) {
        $scope.model.role.push({'id': item.id});
    };

    $scope.OnRemoveSelect = function (item) {
        var index = $scope.model.role.indexOf(item);
        $scope.model.role.splice(index, 1);
    };


    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:newsboxService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('newsboxService', function (apiService) {

    var service = {};

    service.getNews = function () {
        return apiService.post("news/readonline");
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:newsbox
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('newsBox', function (newsboxService, $sce) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/news/newsBox/newsBox.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {
            scope.trustAsHtml = function(string) {
                return $sce.trustAsHtml(string);
            };
            newsboxService.getNews().then(function (data) {
                scope.news = data;
                scope.length = data.length;
            },
            function (error) {
                console.log(error);
            });
        }
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:monitoringSuccessController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('monitoringSuccessController', function ($scope, stromsparcheckService, $stateParams, ngDialog, $rootScope, $state, $anchorScroll) {


    var tileSlug = 'MONITORING_SAVINGS';
    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    stromsparcheckService.read($stateParams.id, tileSlug).then(function (data) {

        $scope.data = data.content;
        $scope.required = data.properties;
        
    }, function (error) {
        console.log(error);
    });


    /* Saves one field after change or defocus (blur) of an input field */
    $scope.save = function (input, value) {

        var data = {
            'id': $stateParams.id,
            'route': 'monitoring/monitoringsuccess/update'
        };
        data[input] = value;

        stromsparcheckService.saveValue(data).then(function (data) {

        }, function (error) {
            console.log('Speichern fehlgeschlagen: ' + error);
        });
    };

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:monitoringQuestionController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('monitoringQuestionController', function ($scope, stromsparcheckService, $stateParams, ngDialog, $rootScope, $state, $anchorScroll) {

    var tileSlug = 'MONITORING_QUESTIONS';
    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    stromsparcheckService.read($stateParams.id, tileSlug).then(function (data) {
        
        $scope.data = data.content;
        $scope.required = data.properties;
        $scope.resetErrorBoxes();
    }, function (error) {
        console.log(error);
    });

    /* reset values of radio area */
    $scope.resetValues = function (id, value) {

        if (value == 1) {
            if (id == 'reduce_energy_costs') {
                $scope.save('monitoringmostimportantreason', 'reduce_energy_costs', 1, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'get_dh', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'preserve_climate', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'get_energy_tips', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.data.monitoring_most_important_reason.get_dh = 0;
                $scope.data.monitoring_most_important_reason.preserve_climate = 0;
                $scope.data.monitoring_most_important_reason.get_energy_tips = 0;
            } else if (id == 'get_dh') {
                $scope.save('monitoringmostimportantreason', 'reduce_energy_costs', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'get_dh', 1, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'preserve_climate', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'get_energy_tips', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.data.monitoring_most_important_reason.reduce_energy_costs = 0;
                $scope.data.monitoring_most_important_reason.preserve_climate = 0;
                $scope.data.monitoring_most_important_reason.get_energy_tips = 0;
            } else if (id == 'preserve_climate') {
                $scope.save('monitoringmostimportantreason', 'reduce_energy_costs', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'get_dh', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'preserve_climate', 1, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'get_energy_tips', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.data.monitoring_most_important_reason.reduce_energy_costs = 0;
                $scope.data.monitoring_most_important_reason.get_dh = 0;
                $scope.data.monitoring_most_important_reason.get_energy_tips = 0;
            } else if (id == 'get_energy_tips') {
                $scope.save('monitoringmostimportantreason', 'reduce_energy_costs', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'get_dh', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'preserve_climate', 0, $scope.data.monitoring_most_important_reason.id);
                $scope.save('monitoringmostimportantreason', 'get_energy_tips', 1, $scope.data.monitoring_most_important_reason.id);
                $scope.data.monitoring_most_important_reason.reduce_energy_costs = 0;
                $scope.data.monitoring_most_important_reason.get_dh = 0;
                $scope.data.monitoring_most_important_reason.preserve_climate = 0;
            }
        } else {
            if (id == 'reduce_energy_costs') {
                $scope.save('monitoringmostimportantreason', 'reduce_energy_costs', 0, $scope.data.monitoring_most_important_reason.id);
            } else if (id == 'get_dh') {
                $scope.save('monitoringmostimportantreason', 'get_dh', 0, $scope.data.monitoring_most_important_reason.id);
            } else if (id == 'preserve_climate') {
                $scope.save('monitoringmostimportantreason', 'preserve_climate', 0, $scope.data.monitoring_most_important_reason.id);
            } else if (id == 'get_energy_tips') {
                $scope.save('monitoringmostimportantreason', 'get_energy_tips', 0, $scope.data.monitoring_most_important_reason.id);
            }
        }
        

    };

    /* Saves one field after change or defocus (blur) of an input field */
    $scope.save = function (controller, field, value, itemId) {
        var data = {
            'id': $stateParams.id,
            'route': 'monitoring/' + controller + '/update',
            'ssc_tile_page': tileSlug
        };
        data[field] = value;
        
        if(itemId){
            data.id=itemId;
            data.ssc_id=$stateParams.id;
        }

        stromsparcheckService.saveValue(data).then(function (data) {
            // Check if there is an existing error in another field.

            data = $scope.copyErrorsToResponseData(data, field);

            $scope.data = data.content;
            // required fields

            $scope.required = data.properties;
        }, function (error) {
            console.log('Speichern fehlgeschlagen: ' + error);
            console.log(field);
            error.data = $scope.copyErrorsToResponseData(error.data, field);

            $scope.required = error.data.properties;
        });
    };

    $scope.copyErrorsToResponseData = function (data, currentField) {
        var errorflag = false;
        $scope.resetErrorBoxes();

        for (var key in $scope.required.monitoring_questions) {
            if (currentField !== key) {
                var fieldData = $scope.required.monitoring_questions[key];
                if (fieldData !== null && (fieldData.hasOwnProperty('error') || fieldData.hasOwnProperty('warning'))) {
                    data.properties.monitoring_questions[key] = fieldData;
                    errorflag = true;
                }
            }
        }
        if (errorflag) {
            $rootScope.$broadcast("errorUpdate", data.properties);
        }
        return data;
    };

    /* Gets device type */
    $scope.getDeviceType = function (id) {

        var str = "";
        if ($scope.data == undefined) {
            return str;
        }
        for (var k in $scope.data.monitoring_device_type) {
            if ($scope.data.monitoring_device_type[k].id == id) {
                str = $scope.data.monitoring_device_type[k].name;
                return str;
            }
        }
        ;
    };

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };

    $scope.resetErrorBoxes = function () {
        $scope.showerrorbox1 = 0;
        $scope.showerrorbox2 = 0;
        $scope.showerrorbox3 = 0;
        $scope.showerrorbox12 = 0;
        $scope.showerrorbox13 = 0;
        $scope.showerrorbox14 = 0;
        $scope.showerrorbox15 = 0;
        $scope.showerrorbox16 = 0;
        $scope.showerrorbox17 = 0;
        $scope.showerrorbox18 = 0;
        $scope.showerrorbox19 = 0;
        $scope.showerrorbox20 = 0;
        $scope.showerrorbox21 = 0;
        $scope.showerrorbox22 = 0;
        $scope.showerrorbox23 = 0;
        $scope.showerrorbox24 = 0;
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:monitoringMoredevicesController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('monitoringMoredevicesController', function ($scope, stromsparcheckService, $stateParams, ngDialog, $rootScope, $state, $anchorScroll) {
    $scope.openCollapse=[];

    var tileSlug = 'MONITORING_DEVICES';
    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    var addCollapseHandler = function(){
        //add listeners
        $( document ).ready(function(){
            var $collapse = $('.collapse');
            $collapse.on('shown.bs.collapse', function () {
                $scope.openCollapse.push(this.id);
            });

            $collapse.on('hidden.bs.collapse', function () {
                var index=$scope.openCollapse.indexOf(this.id);
                $scope.openCollapse.splice(index, 1);
            });
        });
    };
    
    stromsparcheckService.read($stateParams.id, tileSlug).then(function (data) {

        $scope.data = data.content;
        $scope.required = data.properties;
        
        $scope.showerrorboxlistna1=[];
        
        addCollapseHandler();
       
    }, function (error) {
        console.log(error);
    });

    /* Saves one field after change or defocus (blur) of an input field */
    $scope.save = function (controller, field, value, itemId) {
        var data = {
            'id': $stateParams.id,
            'route': 'monitoring/' + controller + '/update',
            'ssc_tile_page': tileSlug
        };
        data[field] = value;
        
        if(itemId){
            data.id=itemId;
            data.ssc_id=$stateParams.id;
        }

        stromsparcheckService.saveValue(data).then(function (data) {
            // Check if there is an existing error in another field.

            var errorflag = false;
            
            $scope.showerrorboxlistna1=[];
            for (var key in $scope.required.monitoring_moredevices) {
                for (var relid in $scope.required.monitoring_moredevices[key]) {
                    for (var relkey in $scope.required.monitoring_moredevices[key][relid]) {
                        if ($scope.required.monitoring_moredevices[key][relid][relkey].error || $scope.required.monitoring_moredevices[key][relid][relkey].warning) {
                            if (field != [relkey]) {
                                data.properties.monitoring_moredevices[key][relid][relkey] = $scope.required.monitoring_moredevices[key][relid][relkey];
                                data.content.monitoring_moredevices[key][relid][relkey] = $scope.data.monitoring_moredevices[key][relid][relkey];
                                errorflag = true;
                            }
                        }
                    }
                }
            }
            
            if (errorflag)
                $rootScope.$broadcast("errorUpdate", data.properties);

            $scope.data = data.content;
            // required fields

            $scope.required = data.properties;
            
            addCollapseHandler();
        }, function (error) {
            console.log('Speichern fehlgeschlagen: ' + error);
            console.log(field);

            // required fields
            var errorflag = false;
            $scope.showerrorboxlistna1=[];
            for (var key in $scope.required.monitoring_moredevices) {
                for (var relid in $scope.required.monitoring_moredevices[key]) {
                    for (var relkey in $scope.required.monitoring_moredevices[key][relid]) {
                        if ($scope.required.monitoring_moredevices[key][relid][relkey].error || $scope.required.monitoring_moredevices[key][relid][relkey].warning) {
                            if (field != [relkey]) {
                                data.properties.monitoring_moredevices[key][relid][relkey] = $scope.required.monitoring_moredevices[key][relid][relkey];
                                data.content.monitoring_moredevices[key][relid][relkey] = $scope.data.monitoring_moredevices[key][relid][relkey];
                                errorflag = true;
                            }
                        }
                    }
                }
            }
            if (errorflag)
                $rootScope.$broadcast("errorUpdate", error.data.properties);

            $scope.required = error.data.properties;
            
            addCollapseHandler();
        });
    };

    /* Gets category */
    $scope.getCategory = function (id) {

        var str = "";
        if ($scope.data == undefined) {
            return str;
        }
        for (var k in $scope.data.monitoring_device_category) {
            if ($scope.data.monitoring_device_category[k].id == id) {
                str = $scope.data.monitoring_device_category[k].name;
                return str;
            }
        }
        ;
    };

    /* Gets Device Type */
    $scope.getType = function (id) {

        var str = "";
        if ($scope.data == undefined) {
            return str;
        }
        for (var k in $scope.data.monitoring_device_type) {
            if ($scope.data.monitoring_device_type[k].id == id) {
                str = $scope.data.monitoring_device_type[k].name;
                return str;
            }
        }
        ;
    };

    /* Gets Room */
    $scope.getRoom = function (id) {

        var str = "";
        if ($scope.data == undefined) {
            return str;
        }
        for (var k in $scope.data.monitoring_room_type) {
            if ($scope.data.monitoring_room_type[k].id == id) {
                str = $scope.data.monitoring_room_type[k].name;
                return str;
            }
        }
        ;
    };

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:monitoringController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('monitoringController', function ($scope, stromsparcheckService, $stateParams, formService, ngDialog, $rootScope, sscErrorboxService) {
    $scope.confirmWarnings = {
        current: undefined,
        listConfirmed: []
    };

    $scope.dataTimestamp = 0;

    $scope.errors = {};

    $scope.formPageScope = $scope;

    var tileSlug = 'MONITORING';
    $scope.$on("$destroy", function () {
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });

    $scope.isHeatingToolVisible = function () {
        return $scope.required && $scope.required.monitoring_heating_tool && $scope.required.monitoring_heating_tool.bill_heating_begin && !$scope.required.monitoring_heating_tool.bill_heating_begin.hidden;
    };

    $scope.isPhotovoltaicVisible = function () {
        if (!$scope.required) {
            return false;
        }
        if (!$scope.required.monitoring_photovoltaic) {
            return false;
        }
        if (!$scope.required.monitoring_photovoltaic.total_production) {
            return true;
        }
        return !$scope.required.monitoring_photovoltaic.total_production.hidden;
    };

    $scope.read = function (with_errors, callback) {
        stromsparcheckService.read($stateParams.id, tileSlug, with_errors).then(function (data) {
            $scope.data = data.content;
            updatePage(data);

            $scope.data.monitoring.second_visit_date = formService.dateModel2Format($scope.data.monitoring.second_visit_date);
            $scope.required = data.properties;

            if (callback) {
                callback();
            }

        }, function (error) {
            console.log(error);
        });
    };
    $scope.read(false);

    /* Saves one field after change or defocus (blur) of an input field */
    $scope.save = function (controller, field, value, itemId) {
        if (typeof controller === "object") {
            var obj = controller;
            var tableName = field.split(".")[0];
            controller = tableName.split("_").join("");
            field = field.split(".")[1];
            value = obj[field];
            itemId = obj.id;
        }
        var data = {
            'id': itemId,
            'ssc_id': $stateParams.id,
            'route': 'monitoring/' + controller + '/update',
            'ssc_tile_page': tileSlug
        };
        data[field] = value;

        stromsparcheckService.saveValue(data).then(function (data) {
            // Check if there is an existing error in another field.
            for (var key in $scope.required.monitoring) {
                if ($scope.required.monitoring[key] && ($scope.required.monitoring[key].error || $scope.required.monitoring[key].warning || $scope.required.monitoring[key].warning_confirm)) {
                    if (field !== key) {
                        data.properties.monitoring[key] = $scope.required.monitoring[key];
                        data.content.monitoring[key] = $scope.data.monitoring[key];
                    }
                }
            }
            $scope.data = data.content;
            // required fields

            $scope.required = data.properties;
            updatePage(data);

            //warning confirm message
            if ($scope.hasConfirmWarnings(controller, field)) {
                ngDialog.open({
                    template: 'templates/landingpage/ready_confirm_warnings.html' + "?v=" + window.version.tag,
                    className: 'dialogLanding',
                    showClose: false,
                    preCloseCallback: $scope.warningsHasConfirmed
                });
            }
        }, function (error) {
            console.log('Speichern fehlgeschlagen: ' + error);
            console.log(field);

            // required fields
            for (var key in $scope.required.monitoring) {
                if ($scope.required.monitoring[key] && ($scope.required.monitoring[key].error || $scope.required.monitoring[key].warning || $scope.required.monitoring[key].warning_confirm)) {
                    if (field !== key) {
                        error.data.properties.monitoring[key] = $scope.required.monitoring[key];
                        error.data.content.monitoring[key] = $scope.data.monitoring[key];
                    }
                }
            }
            $scope.required = error.data.properties;
            updatePage(error.data);

            //warning confirm message
            if ($scope.hasConfirmWarnings(controller, field)) {
                ngDialog.open({
                    template: 'templates/landingpage/ready_confirm_warnings.html' + "?v=" + window.version.tag,
                    className: 'dialogLanding',
                    showClose: false,
                    preCloseCallback: $scope.warningsHasConfirmed
                });
            }
        });
    };

    $scope.warningsHasConfirmed = function () {
        if ($scope.confirmWarnings.current) {
            $scope.confirmWarnings.listConfirmed.push($scope.confirmWarnings.current);
        }
        $scope.confirmWarnings.current = undefined;
    };
    $scope.hasWarningConfirmed = function (controller, field) {
        if ($scope.confirmWarnings.listConfirmed.length > 0) {
            var list = $scope.confirmWarnings.listConfirmed;

            for (var i = 0; i < list.length; i++) {
                if (list[i].controller === controller &&
                    list[i].field === field) {
                    return true;
                }
            }
        }
        return false;
    };
    $scope.removeWarningConfirmed = function (controller, field) {
        if ($scope.confirmWarnings.listConfirmed.length > 0) {
            for (var i = $scope.confirmWarnings.listConfirmed.length - 1; i >= 0; i--) {
                if ($scope.confirmWarnings.listConfirmed[i].controller === controller &&
                    $scope.confirmWarnings.listConfirmed[i].field === field) {
                    $scope.confirmWarnings.listConfirmed.splice(i, 1);
                }
            }
        }
        return false;
    };
    $scope.hasConfirmWarnings = function (controller, field) {
        if (controller === 'monitoring') {
            for (var key in $scope.required.monitoring) {
                if (field === key) {
                    if ($scope.required.monitoring[key] && $scope.required.monitoring[key].warning_confirm) {
                        if ($scope.hasWarningConfirmed(controller, field)) {
                            return false;
                        }
                        $scope.confirmWarnings.current = {controller: controller, field: field};
                        return true;
                    } else {
                        $scope.removeWarningConfirmed(controller, field);
                    }
                }
            }
        }
        return false;
    };

    function updatePage(data) {
        $scope.content = data.content;
        $scope.properties = data.properties;
        $scope.dataTimestamp++;
        updateErrors();
        $rootScope.$broadcast("errorUpdate", data.properties);
    }

    function updateErrors() {
        var structure = {
            photovoltaic: {
                path: "monitoring_photovoltaic",
            },
            general: {
                path: "monitoring",
                fields: ["third_visit_date", "third_visit_person_count", "third_visit_use_duration"]
            },
            electricity: {
                path: "monitoring",
                fields: ["third_visit_energy_consumption_year", "third_visit_energy_price", "explanation_variation_energy_consumption"]
            },
            electricity_meter: {
                path: "monitoring",
                fields: ["second_reading", "first_reading_id", "first_reading_count", "second_reading_id", "second_reading_count", "consumption_year"]
            },
            water: {
                path: "monitoring",
                fields: ["third_visit_water_consumption_year", "third_visit_water_price", "explanation_variation_water_consumption"]
            },
            warmwater: {
                path: "monitoring",
                fields: ["third_visit_water_energy_consumption_year", "third_visit_water_energy_price", "explanation_variation_warmwater_energy_consumption"]
            },
            heating: {
                path: "monitoring",
                fields: ["third_visit_heat_energy_consumption_year", "third_visit_heat_energy_price", "explanation_variation_heat_energy_consumption"]
            },
            tips: {
                path: "monitoring",
                fields: ["further_optimization_tips"]
            },
            notes: {
                path: "monitoring",
                fields: ["internal_notes"]
            },

        };
        $scope.errors = sscErrorboxService.createErrorObject(structure, $scope.properties);
    }

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        $scope.read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };
});

"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:monitoringDirecthelpController
 * @description
 * A description of the controller, service or filter
 */



angular.module('frontendApp').controller('monitoringDirecthelpController', function ($scope, $stateParams, stromsparcheckService, $rootScope, sscErrorboxService) {


    var tileSlug = 'MONITORING_DIRECTHELP';
    $scope.$on("$destroy", function(){
        stromsparcheckService.leaveTile($stateParams.id, tileSlug).then(function (data) {
        }, function (error) {
            console.log(error);
        });
    });
    $scope.formPageScope = $scope;
    $scope.dataTimestamp = 0;
    $scope.formPageScope.yesNoTypeArr = [
        {
            id: 1,
            name: "Ja"
        },
        {
            id: 0,
            name: "Nein"
        }
    ];

    var structure = {
        monitoring_installed_clip: {
            parent: "ssc_id",
            many: true
        },
        monitoring_installed_doorbrush: {
            parent: "ssc_id",
            many: true
        },
        monitoring_installed_shutter_strap_seal: {
            parent: "ssc_id",
            many: true
        },
        monitoring_heat_directhelp_other: {
            parent: "ssc_id",
            many: false
        },
        monitoring_lighting: {
            parent: "ssc_id",
            many: true
        },
        monitoring_no_load_losses: {
            parent: "ssc_id",
            many: true
        },
        monitoring_hot_water: {
            parent: "ssc_id",
            many: true
        },
        monitoring_shower: {
            parent: "ssc_id",
            many: true
        },
        monitoring_toilet_flush: {
            parent: "ssc_id",
            many: true
        },
        monitoring_tap: {
            parent: "ssc_id",
            many: true
        },
        monitoring_kia_directhelp: {
            parent: "ssc_id",
            many: true
        },
        monitoring_kia_infomaterial: {
            parent: "ssc_id",
            many: true
        }
    };
    var isSaving = 0; //0 not saving; >0 is saving

    function update(data, doRememberErrors, indexPathStr, noWarningConfirm) {
        var newData = data;
        if(doRememberErrors) {
            newData = stromsparcheckService.rememberInputErrors({content:$scope.content, properties: $scope.properties, tableProperties: $scope.tableProperties}, data, structure, indexPathStr, noWarningConfirm);
        }

        $scope.content = newData.content;
        $scope.properties = newData.properties;
        $scope.tableProperties = newData.tableProperties;

        updateErrors();
        $scope.dataTimestamp++;
    }

    function read(withErrors) {
        //INIT
        stromsparcheckService.read($stateParams.id, tileSlug, withErrors).then(function (data) {
            update(data, !withErrors, undefined, withErrors);
        }, function (error) {
            console.log(error);
        });
    }

    read();

    $scope.save = function (obj, tableColumn, path) {
        isSaving++;
        var tableName = tableColumn.split(".")[0];
        var controller = tableName.split("_").join("");
        var field = tableColumn.split(".")[1];
        var value = obj[field];
        var itemId = obj["id"];
        if(itemId < 0) {
            itemId = undefined;
        }

        var dataSend = {};
        dataSend.ssc_tile_page = tileSlug;
        if(itemId) {
            dataSend.id = itemId;
        } else { //new entry
            dataSend[structure[tableName].parent] = obj[structure[tableName].parent];
        }
        dataSend[field] = value;

        stromsparcheckService.saveValueNew(dataSend, 'monitoring/' + controller + '/update').then(function (data) {
            isSaving--;
            update(data, true, path);
        }, function (error) {
            isSaving--;
            update(error.data, true, path);
        });
    };


    function updateErrors() {
        var structure = {
            lighting: {
                path: "monitoring_lighting[]"
            },
            standby: {
                path: "monitoring_no_load_losses[]"
            },
            hotWater: {
                path: "monitoring_hot_water[]"
            },
            shower: {
                path: "monitoring_shower[]"
            },
            toiletFlush: {
                path: "monitoring_toilet_flush[]"
            },
            tap: {
                path: "monitoring_tap[]"
            }
        };
        $scope.errors = sscErrorboxService.createErrorObject(structure, $scope.properties);
    }

    $scope.continue = function () {
        stromsparcheckService.continue($stateParams.id, tileSlug);
    };
    $scope.ready = function () {
        read(true);
        stromsparcheckService.readyWithDialog($stateParams.id, tileSlug);
    };
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:locationsearchService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('locationsearchService', function (apiService) {

    var service = {};

    service.search = function (data) {
        return apiService.post("location/search", {data: data});
    };

    service.loadLocationList = function () {
        return apiService.post("location/read", {plain: true});
    };

    service.loadRegionList = function () {
        return apiService.post("region/read", {data: undefined});
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:example
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('searchlocation', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/location/search/search.view.html' + "?v=" + window.version.tag,
        controller: 'searchLocationController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:searchLocationController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('searchLocationController', function ($scope,$rootScope, locationsearchService, searchService, searchCacheService) {

    var lastFilter = {};
    function genFilter() {
        return [$scope.location_id, $scope.region_id, $scope.isOnlyActive, $scope.searchfield];
    }
    function hasFilterChanged(newFilter) {
        return JSON.stringify(newFilter) !== JSON.stringify(lastFilter);
    }

    $scope.init = function () {
        $scope.location_id = null;
        $scope.region_id = null;
        $scope.isOnlyActive = 1;
        $scope.searchfield = null;
        lastFilter = genFilter();

        delete $rootScope.search;
        delete $rootScope.filter;
        var cacheData = searchCacheService.getCacheDataByKey(searchCacheService.type.location, "data");
        if (searchCacheService.isBackButton(searchCacheService.type.location) && cacheData !== null) {
            $scope.bSearch = searchCacheService.getCacheDataByKey(searchCacheService.type.location, "bSearch") === true;
            if (cacheData.hasOwnProperty("search") && typeof cacheData.search === "object")
                $scope.searchfield = cacheData.search.search;
            if (typeof cacheData.filter === "object" && cacheData.filter.hasOwnProperty("length")) {
                for (var n = 0; n < cacheData.filter.length; n++) {
                    var item = cacheData.filter[n];
                    if (item.hasOwnProperty('location'))
                        $scope.location_id = parseInt(item.location);
                    if (item.hasOwnProperty('isOnlyActive'))
                        $scope.isOnlyActive = item.isOnlyActive;
                    if (item.hasOwnProperty('region'))
                        $scope.region_id = parseInt(item.region);
                }
            }
            $scope.setFilterInRoot();
        } else {
            searchCacheService.unsetData(searchCacheService.type.location);
        }
        // Fill the dropdowns for location and region
        locationsearchService.loadLocationList().then(function (data) {
            //$scope.places = "irgdnwas";//data.data;
            $scope.dropLocation = data;
        });

        locationsearchService.loadRegionList().then(function (data) {
            //$scope.places = "irgdnwas";//data.data;
            $scope.dropRegion = data;
        });
    };

    $scope.clearFilter = function () {
        $scope.searchfield = null;
        $scope.location_id = null;
        $scope.region_id = null;
        $scope.isOnlyActive = 0;
        lastFilter = genFilter();

        $scope.showDetails = false;
        $scope.bSearch = false;
        searchCacheService.unsetData(searchCacheService.type.location);
        $rootScope.search = {
            search: $scope.searchfield
        };
        $rootScope.filter = {};

        delete $rootScope.search;
        delete $rootScope.filter;
        searchService.closeCollapse('filter-collapse');
        $rootScope.$broadcast("locationUpdate", {bSearch: $scope.bSearch});
    };
    $scope.$on("sscClearFilter", function () {
        $scope.clearFilter();
    });

    $scope.search = function () {
        var newFilter = genFilter();
        if (hasFilterChanged(newFilter)) {
            lastFilter = newFilter;
            $scope.bSearch = true;
            searchCacheService.setCacheData(searchCacheService.type.location, "bSearch", $scope.bSearch);
            searchCacheService.setCacheData(searchCacheService.type.location, "data", null);
            $scope.setFilterInRoot();
            $rootScope.$broadcast("locationUpdate", {bSearch: $scope.bSearch});
        }
    };
    $scope.setFilterInRoot = function () {
        var search = {
            search: $scope.searchfield
        };
        var filter = [
            {column: 'id', location: $scope.location_id},
            {column: 'id', region: $scope.region_id},
            {isOnlyActive: $scope.isOnlyActive}
        ];
        $rootScope.search = search;
        $rootScope.filter = filter;
    };
    
    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:detailRegionService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('detailRegionService', function (apiService) {

    var service = {};

    service.detail = function (id) {
        return apiService.post("region/read", {id: id});
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:detailRegion
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('detailRegion', function ($stateParams, detailRegionService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/location/detailRegion/detailRegion.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {
            
            detailRegionService.detail($stateParams.id).then(function (data) {
                scope.model = data;
            }, function (error) {
                console.log(error);
            });

        }
    };
}); 
"use strict";
/**
 * @ngdoc directive
 * @name global.service:detailOrganisationService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('detailOrganisationService', function (apiService) {

    var service = {};

    service.detail = function (id) {
        var data = {
            id: id
        };
        return apiService.post("organisation/read", data);
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:detailOrganisation
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('detailOrganisation', function ($stateParams, detailOrganisationService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/location/detailOrganisation/detailOrganisation.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {
            
            detailOrganisationService.detail($stateParams.id).then(function (data) {
                scope.model = data;
            }, function (error) {
                console.log(error);
            });

        }
    };
}); 
"use strict";
/**
 * @ngdoc directive
 * @name global.service:detailLocationService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('detailLocationService', function (apiService) {

    var service = {};

    service.detail = function (id) {
        return apiService.post("location/read", {id: id});
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:createRegion
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('detailLocation', function ($stateParams, detailLocationService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {},
        templateUrl: 'templates/components/content/location/detailLocation/detailLocation.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {
            detailLocationService.detail($stateParams.id).then(function (data) {
                scope.model = data;
                scope.implode = function (items, glue, key) {
                if (typeof key === "string") {
                    items = items.map(value => value[key]);
                }
                return items.join(glue)
            }
            }, function (error) {
                console.log(error);
            });
        }
    };
}); 
"use strict";
/**
 * @ngdoc directive
 * @name global.service:exampleService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('createregionService', function (apiService) {

    var service = {};

    service.readRegion = function (id) {
        return apiService.post("region/read", {id: id});
    };

    service.createRegion = function (data) {
        return apiService.post("region/create", data);
    };

    service.updateRegion = function (data) {
        return apiService.post("region/update", data);
    };

    return service;
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:createRegion
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('createRegion', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/location/createRegion/createRegion.view.html' + "?v=" + window.version.tag,
        controller: 'createregionController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:createregionController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('createregionController', function ($scope, formService, $state, $stateParams, locationService, organisationService, createregionService, $filter) {

    $scope.model = {};
    //$scope.model.states - selected states
    //$scope.dropdownStates - states in dropdown menu

    function initDropdown() {
        locationService.getState($stateParams.id).then(function (data) {
            var states = data;
            $scope.dropdownStates = [];

            for (var i = 0; i < states.length; i++) {
                $scope.dropdownStates.push({
                    id: states[i].id,
                    name: states[i].name
                });
            }
        }, function (error) {
            console.log(error);
        });
    }

    function init() {
        $scope.isSaving = false;
        $scope.dropdownStates = [];

        if ($state.current.name.indexOf('location.regionCreate') !== -1) { //create
            $scope.edit = false;
            $scope.model.status = 0;

            initDropdown();

        } else { // edit
            $scope.edit = true;
            createregionService.readRegion($stateParams.id).then(function (data) {
                $scope.model = data;

                var states = data.states;
                $scope.model.states = [];
                $scope.name = data.name;
                if (states !== undefined) {
                    for (var i = 0; i < states.length; i++) {
                        $scope.model.states.push({
                            id: states[i].id,
                            name: states[i].name
                        });
                    }
                }
                
                console.log("Model States ", $scope.model.states);

                initDropdown();

            }, function (error) {
                console.log(error);
            });
        }

        var payload = {
            'hide_inactive': 1
        }

        organisationService.getOrganisation(payload).then(function (data) {
            $scope.dropOrganisation = data;
        }, function (error) {
            console.log(error);
        });

        $scope.required = {
            name: true,
            states: true,
            organisation: true
        };
    };

    $scope.check = function () {
        return formService.check($scope.required, $scope.model);
    };

    $scope.OnClickSelect = function (item) {
        //not needed
    };

    $scope.OnRemoveSelect = function (item) {
        //not needed
    };

    $scope.save = function () {
        $scope.saved = true;
        $scope.errorAlert = undefined;
        if ($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            createregionService.createRegion($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("location", {"status": 0});
            }, function (error) {
                $scope.isSaving = false;
                if (error.message == "region already exist") {
                    $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_REGION_ALREADY_EXISTS')};
                }
                if(error.error === "client_error.state_taken") {
                    $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_REGION_STATE_TAKEN')};
                }
                else {
                    $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                }
                console.log(error);
            });
        }
    };

    $scope.update = function () {
        $scope.saved = true;
        $scope.errorAlert = undefined;
        if ($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            createregionService.updateRegion($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("location", {"status": 0});
            }, function (error) {
                $scope.isSaving = false;
                if(error.error === "client_error.state_taken") {
                    $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_REGION_STATE_TAKEN')};
                } else {
                    $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                }
                console.log(error);
            });
        }
    };

    init();
});


"use strict";
/**
 * @ngdoc directive
 * @name global.service:createOrganisationService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('createOrganisationService', function (apiService) {

    var service = {};

    service.readOrganisation = function (id) {
        return apiService.post("organisation/read", {id: id});
    };

    service.createOrganisation = function (data) {
        return apiService.post("organisation/create", data);
    };

    service.getOrganisation = function (id) {
        return apiService.post("organisation/read", {id: id});
    };

    service.updateOrganisation = function (data) {
        return apiService.post("organisation/update", data);
    };

    return service;
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:createOrganisation
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('createOrganisation', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/location/createOrganisation/createOrganisation.view.html' + "?v=" + window.version.tag,
        controller: 'createOrganisationController'
    };
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:createOrganisationController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('createOrganisationController', function ($scope, formService, $state, $stateParams, createOrganisationService, $filter) {

    $scope.init = function () {
        $scope.isSaving = false;
        if ($state.current.name.indexOf('location.organisationCreate') !== -1) {
            $scope.edit = false;

            $scope.model = {
                status: false
            };
        } else {
            $scope.edit = true;
            createOrganisationService.readOrganisation($stateParams.id).then(function (data) {
                $scope.model = data;
                $scope.name = data.name;
            }, function (error) {
                console.log(error);
            });
        }

        $scope.saved = false;

        $scope.required = {
            name: true,
            street: true,
            postalcode: true,
            city: true
        };
    };

    $scope.check = function () {
        return formService.check($scope.required, $scope.model);
    };

    $scope.save = function () {

        $scope.saved = true;
        $scope.errorAlert = undefined;

        function onSuccess() {
            $scope.isSaving = false;
            $state.go("location", {"status": 0});
        }
        function onFailure(error) {
            $scope.isSaving = false;
            if (error.message == "organisation already exist") {
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_ORGANISATION_ALREADY_EXISTS')};
            } else if (error.error == 'client_error' && (error.message == "UPLOAD_IMAGE_SIZE_ERROR" || error.message == "UPLOAD_IMAGE_READ_ERROR")) {
                $scope.errorAlert = {message: $filter('translate')(error.message)};
            } else if (error.error == 'client_error' && error.message.postalcode) {
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_PLZ_SAVING')};
                $scope.required.postalcode = true;
            } else {
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
            }
        }

        if ($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            if($scope.edit) {
                createOrganisationService.updateOrganisation($scope.model).then(onSuccess, onFailure);
            } else {
                createOrganisationService.createOrganisation($scope.model).then(onSuccess, onFailure);
            }
        }
    };

    $scope.fileChanged = function ($event, name) {
        //get files
        var files = $event.target.files[0];

        //parse files
        var r = new FileReader();
        r.onloadend = function (e) {
            var data = e.target.result;
            $scope.model[name] = btoa(data);
        };

        r.readAsBinaryString(files);
    };

    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:createLocationService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('createLocationService', function (apiService) {

    var service = {};

    service.readLocation = function (id) {
        return apiService.post("location/read", {id: id});
    };

    service.createLocation = function (data) {
        return apiService.post("location/create", data);
    };

    service.updateLocation = function (data) {
        return apiService.post("location/update", data);
    };

    service.getLocation = function (id) {
        return apiService.post("location/read", {id: id});
    };

    return service;
});

"use strict";
/**
 * @ngdoc directive
 * @name global.directive:createRegion
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('createLocation', function () {
    return {
        restrict: 'E',
        replace: true,
        controller: 'createlocationController',
        templateUrl: 'templates/components/content/location/createLocation/createLocation.view.html' + "?v=" + window.version.tag,
        link: function (scope, element, attrs) {

            

        }
    };
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:createLocationController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('createlocationController', function ($scope, $state, formService, $stateParams, locationService, createLocationService, $filter, localStorageService, ngDialog) {

    $scope.saved = false;

    $scope.init = function () {
        $scope.limitedAccess = true;
        $scope.noAccess = true;
        var user = localStorageService.get('user');
        for (var n = 0; n < user.user_role.length; n++) {
            switch (user.user_role[n].slug) {
                case "ADMIN":
                case "EFB":
                    $scope.limitedAccess = false;
                    $scope.noAccess = false;
                    break;
            }
            if ($scope.limitedAccess === false) {
                break;
            }
        }
        $scope.isSaving = false;
        if ($state.current.name.indexOf('location.create') !== -1) {
            $scope.edit = false;
            $scope.limitedAccess = false;
            $scope.noAccess = false;
        } else {
            $scope.edit = true;
            createLocationService.readLocation($stateParams.id).then(function (data) {
                for (var n = 0; n < user.user_role_map.length; n++) {
                    switch (user.user_role_map[n].role.slug) {
                        case 'LOKO':
                            for (var m = 0; m < user.user_role_map[n].user_role_area_map.length; m++) {
                                var area_map = user.user_role_map[n].user_role_area_map[m];
                                if (data.id === area_map.location_id) {
                                    $scope.noAccess = false;
                                    break;
                                }
                            }
                            break;
                    }
                }
                $scope.model = data;
                if ($scope.model.location_quarters.length === 0) {
                    $scope.addQuarter();
                }
                $scope.model.state_id = parseInt($scope.model.state_id, 10);
                $scope.name = data.name;
            }, function (error) {
                console.log(error);
            });
        }

        $scope.saved = false;
        locationService.getState().then(function (data) {
            $scope.dropState = data;
        }, function (error) {
            console.log(error);
        });

        $scope.model = {
            status: 0,
            fridge_exchange: 0,
            loc_kg_programm: 0,
            quartier_approach: 0,
            model_warm: 0,
            monitoring: 0,
            luminous_color: 0,
            climate_protection: 0,
            fridge_exchange_intervention: 0,
            logo_delete: 0,
            logo_2_delete: 0,
            location_quarters: []
        };
        $scope.addQuarter();

        $scope.required = {
            name: true,
            state_id: true,
            postalcode: true,
            city: true,
            telephone: true,
            street: true
        };
        $scope.error = {};
    };

    $scope.check = function () {
        if(!$scope.model.fridge_exchange && !$scope.model.loc_kg_programm && !$scope.model.fridge_subsidy_complete) {
            return false;
        }
        return formService.check($scope.required, $scope.model);
    };

    $scope.addQuarter = function () {
        if ($scope.model.location_quarters.length < 10) {
            var quarter = {
                id: null,
                name: $filter('translate')('LOCATION_QUARTER_DEFAULT')
            };
            $scope.model.location_quarters.push(quarter);
        }
    };

    $scope.removeQuarter = function (index) {
        ngDialog.openConfirm({
            template: 'templates/landingpage/confirm_dialog.html' + "?v=" + window.version.tag,
            data: {
                diagTitle: $filter('translate')('LANDINGPAGE_DELETE_TITLE'),
                diagDescription: $filter('translate')('LANDINGPAGE_DELETE_DESCRIPTION'),
                diagCancel: $filter('translate')('BTN_CANCEL'),
                diagConfirm: $filter('translate')('BTN_DELETE')
            }
        }).then(function () {
            $scope.model.location_quarters.splice(index, 1);
        });
    };

    $scope.save = function () {
        $scope.saved = true;
        $scope.errorAlert = undefined;
        $scope.error = {};

        function onSuccess() {
            $scope.isSaving = false;
            $state.go("location", {"status": 0});
        }
        function onFailure(error) {
            $scope.isSaving = false;
            if (error.message == "location already exist") {
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_LOCATION_ALREADY_EXISTS')};
            } else if (error.error == 'client_error' && (error.message == "UPLOAD_IMAGE_SIZE_ERROR" || error.message == "UPLOAD_IMAGE_READ_ERROR")) {
                $scope.errorAlert = {message: $filter('translate')(error.message)};
            } else if (error.error == 'client_error' && (error.message.postalcode || error.message.privacy_postalcode || error.message.authority_postalcode)) {
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_PLZ_SAVING')};
                if (error.message.postalcode) {
                    $scope.required.postalcode = true;
                }
            } else if (error.error == 'client_error' && (error.message.telephone || error.message.privacy_telephone || error.message.authority_telephone)) {
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_PHONE')};
                if (error.message.telephone) {
                    $scope.required.telephone = true;
                }
            } else if (error.error == 'client_error' && error.message.ident) {
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_IDENT_SAVING')};
                $scope.required.ident = true;
            } else if (error.error == 'client_error' && (error.message.email || error.message.privacy_email || error.message.authority_email)) {
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_EMAIL')};
            }else {
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
            }
        }

        if ($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            if($scope.edit) {
                createLocationService.updateLocation($scope.model).then(onSuccess, onFailure);
            } else {
                createLocationService.createLocation($scope.model).then(onSuccess, onFailure);
            }
        }
    };

    $scope.fileChanged = function ($event, name) {
        //get files
        var files = $event.target.files[0];

        //parse files
        var r = new FileReader();
        r.onloadend = function (e) {
            var data = e.target.result;
            $scope.model[name] = btoa(data);
        };
        r.readAsBinaryString(files);
    };

    $scope.isFridgeExchangeValid = function () {
        return $scope.model.fridge_exchange || $scope.model.loc_kg_programm || $scope.model.fridge_subsidy_complete || !$scope.saved;
    };

    $scope.init();
});

"use strict";
/**
* @ngdoc directive
* @name global.directive:searchnews
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('searchexchange', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/exchange/search/search.view.html' + "?v=" + window.version.tag,
        controller: 'searchExchangeController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:searchExchangeController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('searchExchangeController', function ($scope, $rootScope, stromsparchecksearchservice, searchService) {

    $scope.init = function () {
        $scope.time = null;
        $scope.status = null;
        $scope.location = null;
        $scope.from = null;
        $scope.to = null;
        $scope.searchfield = null;
        delete $rootScope.from;
        delete $rootScope.to;
        delete $rootScope.search;
        delete $rootScope.filter;
        stromsparchecksearchservice.loadLocationList().then(function (data) {
            $scope.dropLocation = data;
        });
        $scope.dropStatus = [{id: 1,
                name: 'Offen'}, {id: 2,
                name: 'abgerechnet'}, {id: 3,
                name: 'Prüfung'}, {id: 4,
                name: 'abgelehnt'}];
    };

    $scope.clearFilter = function () {
        $scope.time = null;
        $scope.status = null;
        $scope.location = null;
        $scope.from = null;
        $scope.to = null;
        $scope.searchfield = null;
        $scope.showDetails = false;
        $scope.bSearch = false;
        $rootScope.search = {
            search: $scope.searchfield
        };
        $rootScope.filter = {};

        delete $rootScope.search;
        delete $rootScope.filter;
        searchService.closeCollapse('filter-collapse');
        $rootScope.$broadcast("exchangeUpdate", {bSearch: $scope.bSearch});
    };
    $scope.$on("sscClearFilter", function () {
        $scope.clearFilter();
    });

    $scope.search = function () {
        if ($scope.searchfield !== null || $scope.time !== null || $scope.status !== null || $scope.location !== null || $scope.from !== null || $scope.to !== null) {
            $scope.bSearch = true;
            var search = {
                search: $scope.searchfield
            };
            
            var filter = [
                {status: $scope.status},
                {location: $scope.location},
                {time: $scope.time},
                {from: 'from', operator: '>=', value: $scope.from},
                {to: 'to', operator: '<=', value: $scope.to}
            ];

            $rootScope.search = search;
            $rootScope.filter = filter;
            $rootScope.$broadcast("exchangeUpdate", {bSearch: $scope.bSearch});
        }
    };


    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:directhelptypesearchService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('directhelptypesearchService', function (apiService) {

    var service = {};

    service.search = function (data) {
        return apiService.post("directhelptype/search", {data: data});
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:searchdirecthelptyp
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('searchdirecthelptyp', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/directhelptyp/search/search.view.html' + "?v=" + window.version.tag,
        controller: 'searchDirecthelpController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:searchDirecthelptypController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('searchDirecthelptypController', function ($scope, $rootScope) {

    $scope.init = function () {
        $scope.searchfield = null;
        delete $rootScope.search;
        delete $rootScope.filter;
    };

    $scope.clearFilter = function () {
        $scope.searchfield = null;
        $scope.bSearch = false;
        $rootScope.search = {
            search: $scope.searchfield
        };
        $rootScope.filter = {};

        delete $rootScope.search;
        delete $rootScope.filter;
        $rootScope.$broadcast("directhelptypeUpdate", {bSearch: $scope.bSearch});
    };
    $scope.$on("sscClearFilter", function () {
        $scope.clearFilter();
    });

    $scope.search = function () {
        if ($scope.searchfield !== null || $scope.location_id !== null) {
            $scope.bSearch = true;
            var search = {
                search: $scope.searchfield
            };

            $rootScope.search = search;
            $rootScope.$broadcast("directhelptypeUpdate", {bSearch: $scope.bSearch});
        }
    };

    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:directhelpTypCreateService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('directhelpTypCreateService', function (apiService) {

    var service = {};

    service.readDirecthelpTyp = function (id) {
        var data = {
            id: id
        };
        return apiService.post("directhelptype/read", data);
    };

    service.createDirecthelpTyp = function (data) {
        return apiService.post("directhelptype/create", data);
    };

    service.updateDirecthelpTyp = function (data) {
        return apiService.post("directhelptype/update", data);
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:directhelpTypCreate
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('directhelpTypCreate', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/directhelptyp/directhelpTypCreate/directhelpTypCreate.view.html' + "?v=" + window.version.tag,
        controller: 'directhelpTypCreateController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:directhelpTypCreateController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('directhelpTypCreateController', function ($scope, $state, $stateParams, formService, directhelpTypCreateService, $filter) {

    $scope.init = function () {
        $scope.isSaving = false;
        if($state.current.name.indexOf('directhelp.typ.create') !== -1 ) {
            $scope.edit = false;
        }
        else {
            $scope.edit = true;
            directhelpTypCreateService.readDirecthelpTyp($stateParams.id).then(function (data) {
                $scope.model = data;
                $scope.name = data.name;
            }, function (error) {
                console.log(error);
            });
        }

        $scope.saved = false;
        $scope.required = {
            name: true
        };
    };
    
    $scope.check = function () {
        return formService.check($scope.required, $scope.model);
    };

    $scope.save = function () {
        
        $scope.saved = true;
        $scope.errorAlert = undefined;
        if($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            directhelpTypCreateService.createDirecthelpTyp($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("directhelp.typ");
            }, function (error) {
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        }
    };

    $scope.update = function () {

        $scope.saved = true;
        $scope.errorAlert = undefined;
        if($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            directhelpTypCreateService.updateDirecthelpTyp($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("directhelp.typ");
            }, function (error) {
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        }
    };

    $scope.init();
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:directhelpPricesCreateService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('directhelpPricesCreateService', function ($stateParams, apiService) {

    var service = {};

    service.getPrice = function (data) {
        return apiService.post("directhelpprice/read", data);
    };

    service.createDirecthelpPrice = function (model) {
        var data = {
            directhelp_id: $stateParams.id,
            price_ek: model.price_ek,
            price_vk: model.price_vk,
            valid_from: model.valid_from
        };
        return apiService.post("directhelpprice/create", data);
    };

    service.updateDirecthelpPrice = function (model) {
        var data = {
            id: $stateParams.idPrice,
            price_ek: model.price_ek,
            price_vk: model.price_vk,
            valid_from: model.valid_from
        };
        return apiService.post("directhelpprice/update", data);
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:directhelpPricesCreate
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('directhelpPricesCreate', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/directhelpPrices/directhelpPricesCreate/directhelpPricesCreate.view.html' + "?v=" + window.version.tag,
        controller: 'directhelpPricesCreateController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:directhelpPricesCreateController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('directhelpPricesCreateController', function ($scope, $state, directhelpCreateService, $stateParams, formService, directhelpPricesCreateService, $filter) {

    $scope.init = function () {
        $scope.isSaving = false;
        $scope.saved = false;

        $scope.valid = {
            valid_from: ""
        };

        $scope.required = {
            price_ek: true,
            price_vk: true,
            valid_from: true
        };

        directhelpCreateService.readDirecthelp($stateParams.id).then(function (data) {
            if($scope.edit) {
                $scope.actionTitle = $filter('translate')('DIRECTHELP_UPDATE_PRICE', {name: data.description});
            } else {
                $scope.actionTitle = $filter('translate')('DIRECTHELP_NEW_PRICE', {name: data.description});
            }
        }, function (error) {
            console.log(error);
        });


        if ($state.current.name.indexOf('directhelp.prices.create') !== -1) {
            $scope.edit = false;
        } else {
            $scope.edit = true;
            directhelpPricesCreateService.getPrice({directhelp_id: $stateParams.id}).then(function (data) {
                //search price via priceid
                for(var i=0;i<data.length;i++){
                    if(data[i].id==$stateParams.idPrice){
                        $scope.model = data[i];
                        break;
                    }
                }
            }, function (error) {
                console.log(error);
            });
        }

    };

    $scope.check = function () {
        return formService.check($scope.required, $scope.model);
    };

    $scope.save = function () {
        $scope.saved = true;
        $scope.errorAlert = undefined;
        if (!$scope.check()) {
            return;
        }
        $scope.isSaving = true;
        if ($scope.edit) {
            if ($scope.check()) {
                directhelpPricesCreateService.updateDirecthelpPrice($scope.model).then(function () {
                    $scope.isSaving = false;
                    $state.go("directhelp.prices", {"id": $stateParams.id});
                }, function (error) {
                    $scope.isSaving = false;
                    $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                    if (error.message === 'date already in use by other price') {
                        $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING_PRICE_IN_USE')};
                    }
                });
            }
        } else {
            if ($scope.check()) {
                directhelpPricesCreateService.createDirecthelpPrice($scope.model).then(function () {
                    $scope.isSaving = false;
                    $state.go("directhelp.prices", {"id": $stateParams.id});
                }, function (error) {
                    $scope.isSaving = false;
                    $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                    if (error.message === 'date already in use by other price') {
                        $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING_PRICE_IN_USE')};
                    }
                });
            }
        }
    };

    $scope.init();
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:directhelpsearchService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('directhelpsearchService', function (apiService) {

    var service = {};

    service.search = function (data) {
        return apiService.post("directhelp/search", {data: data});
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:searchdirecthelp
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('searchdirecthelp', function () {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/directhelp/search/search.view.html' + "?v=" + window.version.tag,
        controller: 'searchDirecthelpController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:searchDirecthelpController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('searchDirecthelpController', function ($scope, $rootScope, searchService) {

    $scope.init = function () {
        $scope.time = "";
        $scope.from = "";
        $scope.to = "";
        $scope.searchfield = null;
        delete $rootScope.from;
        delete $rootScope.to;
        delete $rootScope.search;
        delete $rootScope.filter;
    };

    $scope.clearFilter = function () {
        $scope.time = "";
        $scope.from = "";
        $scope.to = "";
        $scope.searchfield = null;
        $scope.showDetails = false;
        $scope.bSearch = false;
        $rootScope.search = {
            search: $scope.searchfield
        };
        $rootScope.filter = {};

        delete $rootScope.search;
        delete $rootScope.filter;
        searchService.closeCollapse('filter-collapse');
        $rootScope.$broadcast("directhelpUpdate", {bSearch: $scope.bSearch});
    };
    $scope.$on("sscClearFilter", function () {
        $scope.clearFilter();
    });

    $scope.search = function () {
        if ($scope.searchfield !== null || $scope.location_id !== null) {
            $scope.bSearch = true;
            var search = {
                search: $scope.searchfield
            };
            

            var filter = [
                {from: 'from', operator: '>=', value: $scope.from},
                {to: 'to', operator: '<=', value: $scope.to},
                {column: 'valid_from', columntwo: 'valid_until', value: $scope.time}
            ];

            $rootScope.search = search;
            $rootScope.filter = filter;
            $rootScope.$broadcast("directhelpUpdate", {bSearch: $scope.bSearch});
        }
    };

    
    $scope.init();
});

"use strict";
angular.module('frontendApp').controller('directhelpLocationPriceListController', function ($scope, $state, $filter, $stateParams, formService, directhelpService, createLocationService) {
    $scope.init = function () {
        directhelpService.readViaLocation({location_id:$stateParams.id}, 'directhelp/readViaLocation').then(function (data) {
            $scope.data=data;
        }, function (error) {
            console.log(error);
        });

        createLocationService.readLocation($stateParams.id).then(function (data) {
            $scope.pageTitle = "Soforthilfen für Standort: ID " + data.id + " - " + data.name;
        }, function (error) {
            console.log(error);
        });
    };
    
    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:directhelpCreateService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('directhelpCreateService', function (apiService) {

    var service = {};

    service.readDirecthelp = function (id) {
        var data = {
            id: id
        };
        return apiService.post("directhelp/read", data);
    };

    service.readSockets = function() {
        return apiService.post("checks/ssclightsockettype/read");
    };
    
    service.readLifetime = function() {
        return apiService.post("checks/ssclightlifetimetype/read");
    };

    service.createDirecthelp = function (data) {
        return apiService.post("directhelp/create", data);
    };

    service.updateDirecthelp = function (data) {
        return apiService.post("directhelp/update", data);
    };

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:directhelpCreate
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('directhelpCreate', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/content/directhelp/directhelpCreate/directhelpCreate.view.html' + "?v=" + window.version.tag,
        controller: 'directhelpCreateController'
    };
}); 
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:directhelpCreateController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('directhelpCreateController', function ($scope, $state, $filter, stromsparcheckService, $stateParams, formService, directhelpService, directhelpCreateService) {
    $scope.init = function () {
        $scope.isSaving = false;

        if ($state.current.name.indexOf('directhelp.create') !== -1) {
            $scope.edit = false;

            $scope.model = {
                status: 0,
                tile: []
            };

            $scope.required = {
                description: true,
                directhelp_type_id: true,
                lamp_lifetime_id: false,
                productnumber_old: false,
                productnumber_new: true,
                calculation_value: true,
                tile: true,
                price_ek: true,
                price_vk: true,
                valid_from: true,
                report_categorie: false
            };
            $scope.loadTiles();

            directhelpService.readDirecthelptypWithoutArchiv().then(function (data) { 
                $scope.directhelptyp = data;

                directhelpCreateService.readSockets().then(function (lightsockettype) {
                    $scope.lightsockettype = lightsockettype;
                    $scope.isDirecthelpTypeBulb($scope.model.directhelp_type_id);
                }, function (error) {
                    console.log(error);
                });

                directhelpCreateService.readLifetime().then(function (lightlifetimetype) {
                    $scope.lightlifetimetype = lightlifetimetype;
                }, function (error) {
                    console.log(error);
                });

            }, function (error) {
                console.log(error);
            });

        } else {
            $scope.edit = true;

            directhelpService.readDirecthelptypWithoutArchiv().then(function (dataType) {
                $scope.directhelptyp = dataType;

                directhelpCreateService.readDirecthelp($stateParams.id).then(function (dataModel) {
                    $scope.model = dataModel;
                    $scope.name = dataModel.description;
                    $scope.model.sockel = parseInt($scope.model.sockel);
                    $scope.model.lamp_lifetime_id = parseInt($scope.model.lamp_lifetime_id);

                    if ($scope.model.tile.length === 0)
                        $scope.required.tile = true;

                    directhelpCreateService.readSockets().then(function (lightsockettype) {
                        $scope.lightsockettype = lightsockettype;
                        $scope.isDirecthelpTypeBulb($scope.model.directhelp_type_id);
                    }, function (error) {
                        console.log(error);
                    });

                    directhelpCreateService.readLifetime().then(function (lightlifetimetype) {
                        $scope.lightlifetimetype = lightlifetimetype;
                    }, function (error) {
                        console.log(error);
                    });

                    $scope.loadTiles();
                }, function (error) {
                    console.log(error);
                });
            }, function (error) {
                console.log(error);
            });

            $scope.required = {
                description: true,
                directhelp_type_id: true,
                lamp_lifetime_id: false,
                productnumber_old: false,
                productnumber_new: true,
                calculation_value: true
            };
        }

        $scope.saved = false;
    };

    $scope.loadTiles = function () {
        stromsparcheckService.getTile().then(function (data) {
            $scope.model.tileList = data;

            var i = 0;
            angular.forEach(data, function (value) {
                angular.forEach($scope.model.tile, function (val2) {
                    if (val2.id == value.id) {
                        delete $scope.model.tileList[i];
                    }
                });
                i++;
            });
        }, function (error) {
            console.log(error);
        });
        
        stromsparcheckService.getReportCategories().then(function (data) {
            $scope.model.reportCategorieList = data;
        }, function (error) {
            console.log(error);
        }); 
    };

    $scope.isDirecthelpTypeBulb = function (directhelpTypeId) {
        if (!directhelpTypeId)
            return false;

        if (!$scope.directhelptyp)
            return false;

        $scope.model.slug = '';//init
        for (var i = 0; i < $scope.directhelptyp.length; i++) {
            if (($scope.directhelptyp[i].id == directhelpTypeId)) {//&& ($scope.directhelptyp[i].slug === "BULBS")
                $scope.model.slug = $scope.directhelptyp[i].slug;
                break;
            }
        }
    };

    $scope.check = function () {
        return formService.check($scope.required, $scope.model);
    };

    $scope.save = function () {
         for(var i=0;i<$scope.directhelptyp.length;i++){
            if($scope.directhelptyp[i].slug==='BULBS'){
                if($scope.directhelp_type_id===$scope.directhelptyp[i].id){
                    $scope.required.lamp_lifetime_id=true;
                }
                break;
            }
        }
        $scope.saved = true;
        $scope.errorAlert = undefined;
        if ($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            directhelpCreateService.createDirecthelp($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("directhelp");
            }, function (error) {
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        }
    };

    $scope.update = function () {
        $scope.saved = true;
        $scope.errorAlert = undefined;
        if ($scope.check() && !$scope.isSaving) {
            $scope.isSaving = true;
            directhelpCreateService.updateDirecthelp($scope.model).then(function () {
                $scope.isSaving = false;
                $state.go("directhelp");
            }, function (error) {
                $scope.isSaving = false;
                $scope.errorAlert = {message: $filter('translate')('FORM_ERROR_SAVING')};
                console.log(error);
            });
        }
    };

    $scope.isReportCategorieSet = function (id) {
        if($scope.model && $scope.model.report_categorie){
            for(var i=0;i<$scope.model.report_categorie.length;i++){
                if($scope.model.report_categorie[i].id===id){
                    return true;
                }
            }
        }
        return false;
    };
    
    $scope.init();
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:userService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('userService', function (apiService, localStorageService, $rootScope) {

    var service = {};
    var limiting = 4;    // number of users to show in list

    /**
     * Has logged in user one of the roles in slugArr
     * @param slugArr
     */
    service.loggedInHasRole = function(slugArr) {
        var user = localStorageService.get('user');
        var i, e;
        for(e = 0; e < slugArr.length; e++) {
            for (i = 0; i < user.user_role.length; i++) {
                if (user.user_role[i].slug === slugArr[e]) {
                    return true;
                }
            }
        }
        return false;
    };

    service.forceTwoFactorAuth = function () {
        var user = localStorageService.get("user");
        if (!user) {
            return false;
        }
        return user.mandatory_two_factor_auth && user && user.has_two_factor_auth === false;
    };

    service.getRoles = function () {
        return apiService.post("role/read");
    };

    service.getEFB = function () {
        return apiService.post("user/readusersefb");
    };

    service.getEmploymentType = function () {
        return apiService.post("employmenttype/readactive");
    };

    service.search = function (data) {
        return apiService.post("user/search", data);
    };

    /**
     * fill area dropdowns with available options for role
     *
     * @param areasArr - as user/readaccessibleareas returns it
     * @returns {{dropLocation: Array, dropOrganisation: Array, dropState: Array}}
     */
    service.getAreaDropdowns = function(areasArr, roleSlug) {
        var result = {
            dropLocation: [],
            dropOrganisation: [],
            dropState: []
        };

        var i;

        //collect all
        var locationIdArr = [];
        var organisationIdArr = [];
        var stateIdArr = [];
        var areaName;
        for (areaName in areasArr['access'][roleSlug]) {
            if (!areasArr['access'][roleSlug].hasOwnProperty(areaName)) {
                continue;
            }
            if(areaName === "location_id") {
                locationIdArr = [].concat(areasArr['access'][roleSlug][areaName]);
            }
            if(areaName === "organisation_id") {
                organisationIdArr = [].concat(areasArr['access'][roleSlug][areaName]);
            }
            if(areaName === "state_id") {
                stateIdArr = [].concat(areasArr['access'][roleSlug][areaName]);
            }
        }

        //put into dropdowns
        for(i = 0; i < areasArr['locations'].length; i++) {
            if(locationIdArr.includes(areasArr['locations'][i].id)) {
                result.dropLocation.push(areasArr['locations'][i]);
            }
        }
        for(i = 0; i < areasArr['organisations'].length; i++) {
            if(organisationIdArr.includes(areasArr['organisations'][i].id)) {
                result.dropOrganisation.push(areasArr['organisations'][i]);
            }
        }
        for(i = 0; i < areasArr['states'].length; i++) {
            if(stateIdArr.includes(areasArr['states'][i].id)) {
                result.dropState.push(areasArr['states'][i]);
            }
        }

        return result;
    };

    /**
     * get easy access to userRoleMap information:
     * role name
     * location/organisation/state
     *
     * result looks like this:
     * {roleName: "Stromsparhelfer", roleShort: "SSH", location: "Dresden"}
     *
     * @param userObj
     * @param userRoleMapId
     * @returns object or null
     */
    service.extractRoleInfo = function(userObj, userRoleMapId) {
        var result = {};
        var userRoleMap;
        var i;
        for(i = 0; i < userObj.user_role_map.length; i++) {
            if(parseInt(userObj.user_role_map[i].id) === parseInt(userRoleMapId)) {
                userRoleMap = userObj.user_role_map[i];
                break;
            }
        }
        if(!userRoleMap) {
            return null;
        }
        result.roleName = userRoleMap.role.name;
        result.roleShort = userRoleMap.role.short;

        if(userRoleMap.user_role_area_map.location) {
            result.location = userRoleMap.user_role_area_map.location[0].name;
        }
        if(userRoleMap.user_role_area_map.organisation) {
            result.organisation = userRoleMap.user_role_area_map.organisation[0].name;
        }
        if(userRoleMap.user_role_area_map.state) {
            if(userRoleMap.user_role_area_map.state.length === 16) {//hoffentlich bleibt Bayern Teil von Deutschland
                result.state = ["Bundesweit"];
            } else {
                var stateArr = [];
                for(i = 0; i < userRoleMap.user_role_area_map.state.length; i++) {
                    stateArr.push(userRoleMap.user_role_area_map.state[i].short);
                }
                result.state = stateArr;
            }
        }
        return result;
    };

    return service;
});
"use strict";
/**
 * Binds a TinyMCE widget to <textarea> elements.
 */
angular.module('ui.tinymce', [])
	.value('uiTinymceConfig', {
		statusbar: true,
		forced_root_block: false,
		element_format: 'html',
		entity_encoding: "raw",
		plugins: "paste",
		paste_as_text: true,
		// paste_text_sticky: true,
		toolbar: 'undo redo | styleselect | removeformat customHrButton',
		setup: function (editor) {
			editor.addButton('customHrButton', {
				text: 'Trennlinie',
				onclick: function () {
					editor.insertContent('<span class="tip-delimiter"><br>----------<br></span>');
				}
			});
			 var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
			editor.on('keydown', function (e) {
				if (allowedKeys.indexOf(e.keyCode) !== -1)
					return true;
				if (this.settings.max_chars && tinymce.get(tinymce.activeEditor.id).contentDocument.body.innerText.length + 1 > this.settings.max_chars) {
					e.preventDefault();
					e.stopPropagation();
					return false;
				}
				return true;
			});
		},
		menubar: false,
		style_formats: [
			{title: 'fett', inline: 'b'},
			{title: 'kursiv', inline: 'i'},
			{title: 'unterstrichen', inline: 'span', styles: {'text-decoration': 'underline'}},
			{title: 'rot', inline: 'span', styles: {color: '#e62931'}},
			{title: 'schwarz', inline: 'span', styles: {color: '#000000'}},
		]
	})
	.directive('uiTinymce', ['$rootScope', '$compile', '$timeout', '$window', '$sce', 'uiTinymceConfig', 'uiTinymceService', function ($rootScope, $compile, $timeout, $window, $sce, uiTinymceConfig, uiTinymceService) {
		uiTinymceConfig = uiTinymceConfig || {};

		if (uiTinymceConfig.baseUrl) {
			tinymce.baseURL = uiTinymceConfig.baseUrl;
		}

		return {
			require: ['ngModel', '^?form'],
			priority: 599,
			link: function (scope, element, attrs, ctrls) {
				if (!$window.tinymce) {
					return;
				}

				var ngModel = ctrls[0],
					form = ctrls[1] || null;

				var expression, options = {
						debounce: true
					}, tinyInstance,
					updateView = function (editor) {
						var content = editor.getContent({format: options.format}).trim();
						content = $sce.trustAsHtml(content);

						ngModel.$setViewValue(content);
						if (!$rootScope.$$phase) {
							scope.$digest();
						}
					};

				function toggleDisable(disabled) {
					if (disabled) {
						ensureInstance();

						if (tinyInstance) {
							tinyInstance.getBody().setAttribute('contenteditable', false);
						}
					} else {
						ensureInstance();

						if (tinyInstance && !tinyInstance.settings.readonly && tinyInstance.getDoc()) {
							tinyInstance.getBody().setAttribute('contenteditable', true);
						}
					}
				}

				// fetch a unique ID from the service
				var uniqueId = uiTinymceService.getUniqueId();
				attrs.$set('id', uniqueId);

				expression = {};

				angular.extend(expression, scope.$eval(attrs.uiTinymce));

				//Debounce update and save action
				var debouncedUpdate = (function (debouncedUpdateDelay) {
					var debouncedUpdateTimer;
					return function (ed) {
						$timeout.cancel(debouncedUpdateTimer);
						debouncedUpdateTimer = $timeout(function () {
							return (function (ed) {
								if (ed.isDirty()) {
									ed.save();
									updateView(ed);
								}
							})(ed);
						}, debouncedUpdateDelay);
					};
				})(400);

				var setupOptions = {
					// Update model when calling setContent
					// (such as from the source editor popup)
					setup: function (ed) {
						ed.on('init', function () {
							ngModel.$render();
							ngModel.$setPristine();
							ngModel.$setUntouched();
							if (form) {
								form.$setPristine();
							}
						});

						// Update model when:
						// - a button has been clicked [ExecCommand]
						// - the editor content has been modified [change]
						// - the node has changed [NodeChange]
						// - an object has been resized (table, image) [ObjectResized]
						ed.on('ExecCommand change NodeChange ObjectResized', function () {
							if (!options.debounce) {
								ed.save();
								updateView(ed);
								return;
							}
							debouncedUpdate(ed);
						});

						ed.on('blur', function () {
							element[0].blur();
							element[0].dispatchEvent(new Event("blur"));
							ngModel.$setTouched();
							if (!$rootScope.$$phase) {
								scope.$digest();
							}
						});

						ed.on('remove', function () {
							element.remove();
						});

						if (uiTinymceConfig.setup) {
							uiTinymceConfig.setup(ed, {
								updateView: updateView
							});
						}

						if (expression.setup) {
							expression.setup(ed, {
								updateView: updateView
							});
						}
					},
					format: expression.format || 'html',
					selector: '#' + attrs.id
				};
				// extend options with initial uiTinymceConfig and
				// options from directive attribute value
				angular.extend(options, uiTinymceConfig, expression, setupOptions);
				// Wrapped in $timeout due to $tinymce:refresh implementation, requires
				// element to be present in DOM before instantiating editor when
				// re-rendering directive
				$timeout(function () {
					if (options.baseURL) {
						tinymce.baseURL = options.baseURL;
					}
					var maybeInitPromise = tinymce.init(options);
					if (maybeInitPromise && typeof maybeInitPromise.then === 'function') {
						maybeInitPromise.then(function () {
							toggleDisable(scope.$eval(attrs.ngDisabled));
						});
					} else {
						toggleDisable(scope.$eval(attrs.ngDisabled));
					}
				});

				ngModel.$formatters.unshift(function (modelValue) {
					return modelValue ? $sce.trustAsHtml(modelValue) : '';
				});

				ngModel.$parsers.unshift(function (viewValue) {
					return viewValue ? $sce.getTrustedHtml(viewValue) : '';
				});

				ngModel.$render = function () {
					ensureInstance();

					var viewValue = ngModel.$viewValue ?
						$sce.getTrustedHtml(ngModel.$viewValue) : '';

					// instance.getDoc() check is a guard against null value
					// when destruction & recreation of instances happen
					if (tinyInstance &&
						tinyInstance.getDoc()
					) {
						tinyInstance.setContent(viewValue);
						// Triggering change event due to TinyMCE not firing event &
						// becoming out of sync for change callbacks
						tinyInstance.fire('change');
					}
				};

				attrs.$observe('disabled', toggleDisable);

				// This block is because of TinyMCE not playing well with removal and
				// recreation of instances, requiring instances to have different
				// selectors in order to render new instances properly
				var unbindEventListener = scope.$on('$tinymce:refresh', function (e, id) {
					var eid = attrs.id;
					if (angular.isUndefined(id) || id === eid) {
						var parentElement = element.parent();
						var clonedElement = element.clone();
						clonedElement.removeAttr('id');
						clonedElement.removeAttr('style');
						clonedElement.removeAttr('aria-hidden');
						tinymce.execCommand('mceRemoveEditor', false, eid);
						parentElement.append($compile(clonedElement)(scope));
						unbindEventListener();
					}
				});

				scope.$on('$destroy', function () {
					ensureInstance();

					if (tinyInstance) {
						tinyInstance.remove();
						tinyInstance = null;
					}
				});

				function ensureInstance() {
					if (!tinyInstance) {
						tinyInstance = tinymce.get(attrs.id);
					}
				}
			}
		};
	}])
	.service('uiTinymceService', [
		/**
		 * A service is used to create unique ID's, this prevents duplicate ID's if there are multiple editors on screen.
		 */
		function () {
			var UITinymceService = function () {
				var ID_ATTR = 'ui-tinymce';
				// uniqueId keeps track of the latest assigned ID
				var uniqueId = 0;
				// getUniqueId returns a unique ID
				var getUniqueId = function () {
					uniqueId++;
					return ID_ATTR + '-' + uniqueId;
				};
				// return the function as a public method of the service
				return {
					getUniqueId: getUniqueId
				};
			};
			// return a new instance of the service
			return new UITinymceService();
		}
	]);

"use strict";
/**
 * @ngdoc directive
 * @name stromsparcheckService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('stromsparcheckService', function ($q, $http, api, $rootScope, apiService, tileService, $stateParams, ngDialog, $filter, $state, $anchorScroll) {
    var service = {};

    var currentSlug = "";
    var canceler = $q.defer();
    service.read = function (id, slug, withErrors) {
        var deferred = $q.defer();
        currentSlug = slug;
        var data = {
            ssc_tile_page: slug
        };
        if (id !== undefined) {
            data.ssc_id = id;
        }
        if (withErrors) {
            data.with_errors = 1;
        }

        //cancel all pending formread requests -- toDo: could be stored in route.js on $stateChangeStart
        //fix for successive tab selecting Bug 2389
        $http.pendingRequests.forEach(function (request) {
            if (request.cancel && request.timeout && request.url == api.root + "checks/formread") {
                request.cancel.resolve('already running');
            }
        });
        //timeout & cancel necessary for canceling requests
        $http.post(api.root + "checks/formread", data, {timeout : deferred.promise, cancel : deferred})
                .success(function (data, status) {                    
                    if (data.data)
                        $rootScope.$broadcast("onSscLoadComplete", data.data.properties);
                    deferred.resolve(data.data);
                    $rootScope.$broadcast('reload-tile-status');
                })
                .error(function (error) {
                    if (error.data)
                        $rootScope.$broadcast("onSscLoadComplete", error.data.properties);
                    deferred.reject(error);

                    console.log('Stromsparcheck-Daten konnten nicht geladen werden');
                });
        return deferred.promise;
    };

    service.readTextmodule = function (id, route) {
        var deferred = $q.defer();

        var data = {};
        if (id !== undefined) {
            data.ssc_id = id;
        }

        $http.post(api.root + route, data)
                .success(function (data, status) {
                    if (data.data)
                        $rootScope.$broadcast("onSscLoadComplete", data.data.properties);
                    deferred.resolve(data.data);
                })
                .error(function (error) {
                    if (error.data)
                        $rootScope.$broadcast("onSscLoadComplete", error.data.properties);
                    deferred.reject(error);

                    console.log('Stromsparcheck-Daten konnten nicht geladen werden');
                });

        return deferred.promise;
    };

    service.readTacho = function (route, id, tachoNumber, tachoId) {
        var deferred = $q.defer();

        var data = {
            ssc_id: id,
            tacho_number: tachoNumber,
            tachoId: tachoId
        };

        $http.post(api.root + route, data)
                .success(function (data, status) {

                    deferred.resolve(data.data);
                })
                .error(function (error) {

                    deferred.reject(error);

                    console.log('Tacho-Daten konnten nicht geladen werden');
                });

        return deferred.promise;
    };

    service.readTachoHeatTool = function (route, heatnumber) {
        var deferred = $q.defer();

        var data = {
            number: heatnumber
        };

        $http.post(api.root + route, data)
                .success(function (data, status) {

                    deferred.resolve(data.data);
                })
                .error(function (error) {

                    deferred.reject(error);

                    console.log('Tacho-Daten konnten nicht geladen werden');
                });

        return deferred.promise;
    };

    service.readLocation = function (id, readFor) {
        var data = {};
        if (readFor) {
            data.readFor = readFor;
        }

        var deferred = $q.defer();

        $http.post(api.root + 'location/readviauser','hhcreate', data)
                .success(function (data, status) {
                    deferred.resolve(data.data);
                    if (data.data)
                        $rootScope.$broadcast("onSscLoadComplete", data.data.properties);
                })
                .error(function (error) {
                    deferred.reject(error);
                    if (error.data)
                        $rootScope.$broadcast("onSscLoadComplete", error.data.properties);
                    console.log('Stromsparcheck-Daten konnten nicht geladen werden');
                });

        return deferred.promise;
    };

    service.getAllUsersByRole = function (data) {
        var deferred = $q.defer();

        $http.post(api.root + 'user/searchallbyrole', data)
                .success(function (data, status) {
                    deferred.resolve(data.data);
                    //if(data.data)$rootScope.$broadcast("onSscLoadComplete", data.data.properties);
                })
                .error(function (error) {
                    deferred.reject(error);
                    //if(error.data)$rootScope.$broadcast("onSscLoadComplete", error.data.properties);
                    console.log('Stromsparcheck-Daten konnten nicht geladen werden');
                });

        return deferred.promise;
    };


    service.saveValueNew = function (data, route) {
        return apiService.post(route, data);
    };


    service.saveValue = function (data) {
        var deferred = $q.defer();

        $http.post(api.root + data.route, data)
                .success(function (data, status) {
                    if (data.data)
                        $rootScope.$broadcast("errorUpdate", data.data.properties);
                    deferred.resolve(data.data);
                    if (data.data)
                        $rootScope.$broadcast("onSscLoadComplete", data.data.properties);
                })
                .error(function (error) {
                    console.log(error);
                    if (error.data)
                        $rootScope.$broadcast("errorUpdate", error.data.properties);
                    deferred.reject(error);
                    if (error.data)
                        $rootScope.$broadcast("onSscLoadComplete", error.data.properties);
                });
        return deferred.promise;
    };

    service.addCheck = function (data) {
        var deferred = $q.defer();

        $http.post(api.root + data.route, data)
                .success(function (data, status) {
                    $rootScope.$broadcast("errorUpdate", data.properties);
                    deferred.resolve(data.data);
                })
                .error(function (error) {
                    if (error.data && error.data.properties) {
                        $rootScope.$broadcast("errorUpdate", error.data.properties);
                    }

                    deferred.reject(error);
                    console.log('Ein Fehler ist aufgetreten');
                });
        return deferred.promise;
    };

    /*service.deleteCheck = function (id) {
     return apiService.post("checks/ssc/delete", {id: id});
     };*/

    service.deleteCheck = function (id, ssc_delete_reason, ssc_delete_reason_id) {
        var data = {
            id: id,
            ssc_delete_reason: ssc_delete_reason,
            ssc_delete_reason_id: ssc_delete_reason_id
        };
        return apiService.post("checks/ssc/delete", data);
    };
    service.cancelDeleteCheck = function (id) {
         var data = {
            id: id
        };
        return apiService.post("checks/ssc/cancelDelete", data);
    };

    service.getDeleteReasons = function (id) {
        return apiService.post("checks/sscdeletereason/read", {id: id});
    };
    service.getRequiredFilled = function (id) {
        return apiService.post("checks/ssc/requiredfilled", {id: id});
    };

    service.getTile = function () {
        return apiService.post("checks/ssctile/read");
    };
    service.getReportCategories = function () {
        return apiService.post("directhelp/reportcategories/read");
    };

    service.anonymize = function (id) {
        return apiService.post("checks/ssc/anonymize", {id: id});
    };

    service.checkDuplicate = function (data) {
        return apiService.post("checks/ssc/checkduplicate", data);
    };

    service.ready = function (id, tileSlug) {
        var deferred = $q.defer();

        var data = {
            ssc_id: id,
            tile: tileSlug
        };

        $http.post(api.root + "checks/ssc/status/create", data)
                .success(function (data, status) {
                    deferred.resolve(data.data);
                    if(data.data) {
                        $rootScope.$broadcast("onSscLoadComplete", data.data.properties);
                    }
                })
                .error(function (error) {
                    deferred.reject(error);
                    if (error.data)
                        $rootScope.$broadcast("onSscLoadComplete", error.data.properties);
                    console.log('Stromsparcheck-Daten konnten nicht geladen werden');
                });
        return deferred.promise;
    };

    service.getTarget = function (tileSlug) {
        // Alle Pflichtfelder sind gesetzt
        var target = "";
        var is_monitoring_state = tileService.getMonitoringState();
        var isTelephoneCheck = tileService.isTelephoneCheck();
        var isClimateProtection = tileService.hasClimateProtection();
        var isFridgeCheck = tileService.isFridgeCheck();
        if (tileSlug === "OVERVIEW")
            target = "generalInformation";
        if (tileSlug === "GENERAL_INFO")
            target = "energy";
        if (tileSlug === "ENERGY_HEAT_WATER") {
            if (isTelephoneCheck)
                target = "telephone";
            else if (isFridgeCheck)
                target = "refrigerator";
            else
                target = "heat";
        }
        if (tileSlug === "HEAT")
            target = "lighting";
        if (tileSlug === "LIGHTING")
            target = "standby";
        if (tileSlug === "STANDBY")
            target = "electricBoiler";
        if (tileSlug === "ELECTRIC_BOILER")
            target = "toiletFlush";
        if (tileSlug === "TOILET_FLUSH")
            target = "shower";
        if (tileSlug === "SHOWER")
            target = "tap";
        if (tileSlug === "TAP")
            target = "refrigerator";
        if (tileSlug === "REFRIGERATOR_EXCHANGE")
            if (isClimateProtection)
                target = "kia";
            else if (isFridgeCheck)
                target = "tips";
            else
                target = "device";
        if (tileSlug === "KIA")
            target = "device";
        if (tileSlug === "ADDITIONAL_DEVICES")
            target = "tips";
        if (tileSlug === "TELEPHONE_CONSULTATION")
            target = "tips";
        if (tileSlug === 'TIPS') {
            if (isTelephoneCheck)
                target = "telephoneInfo";
            else if (is_monitoring_state)
                target = "monitoring";
            else
                target = "abstract";
        }
        if (tileSlug === "MONITORING")
            target = "monitoringdirecthelp";
        if (tileSlug === "MONITORING_HEAT")
            target = "monitoringdirecthelp";
        if (tileSlug === "MONITORING_DIRECTHELP")
            target = "monitoringmoredevices";
        if (tileSlug === "MONITORING_DEVICES")
            target = "monitoringquestion";
        if (tileSlug === "MONITORING_QUESTIONS")
            target = "monitoringsuccess";
        if (tileSlug === "MONITORING_SAVINGS")
            target = "abstract";
        return target;
    };

    service.continue = function (sscId, tileSlug) {
        service.ready(sscId, tileSlug).then(
            function (data) {
                var target = service.getTarget(tileSlug);
                if (target !== "") {
                    if (data) {
                        var listener = $rootScope.$on("$locationChangeSuccess", function () {
                            $anchorScroll();
                            listener();
                        });
                    }
                    $state.go("ssc.check.overview." + target);
                }
            },
            function (error) {
                console.log('Speichern fehlgeschlagen: ' + error);
            });
    };

    service.readyWithDialog = function (sscId, tileSlug) {
        service.ready(sscId, tileSlug).then(function (data) {
            if(data) {
                ngDialog.open( {
                    template: 'templates/landingpage/ready_success.html' + "?v=" + window.version.tag,
                    className: 'dialogLanding',
                    showClose: false
                });
            } else {//es sind nicht alle Felder ausgefüllt
                ngDialog.open( {
                    template: 'templates/landingpage/ready_failed.html' + "?v=" + window.version.tag,
                    className: 'dialogLanding',
                    showClose: false
                });
            }

        }, function (error) {
            console.log('Speichern fehlgeschlagen: ' + error);
        });
    };

    service.readData = function(dataRequest, route) {
        var deferred = $q.defer();

        $http.post(api.root + route, dataRequest)
                .success(function (data, status) {
                    deferred.resolve(data.data);
                    if (data.data)
                        $rootScope.$broadcast("onSscLoadComplete", data.data.properties);
                })
                .error(function (error) {
                    deferred.reject(error);
                    if (error.data)
                        $rootScope.$broadcast("onSscLoadComplete", error.data.properties);
                    console.log('Stromsparcheck-Daten konnten nicht geladen werden');
                });
        return deferred.promise;
    };

    service.leaveTile = function (id, tile) {
        var deferred = $q.defer();

        if(!id) {
            deferred.reject();
            return deferred.promise;
        }

        $rootScope.$broadcast('reload-plausi');

        var data = {
            'ssc_id': id,
            'tile': tile
        };

        $http.post(api.root + "checks/leaveTile", data)
                .success(function (data, status) {
                    deferred.resolve(data.data);
                    $rootScope.$broadcast('reload-tile-status');
                })
                .error(function (error) {
                    deferred.reject(error);
                });
        return deferred.promise;
    };

    /**
     * deletes an entry from check. first shows a confirm dialog.
     * calls checks/tablename/delete in api
     * data in promise is undefined when cancel pressed in dialog
     * @param tableName
     * @param index
     * @param id
     * @param tileSlug
     */
    service.delete = function (tableName, index, id, tileSlug) {
        var deferred = $q.defer();
        ngDialog.openConfirm({
            template: 'templates/landingpage/confirm_dialog.html' + "?v=" + window.version.tag,
            data: {
                diagTitle: $filter('translate')('LANDINGPAGE_DELETE_TITLE'),
                diagDescription: $filter('translate')('LANDINGPAGE_DELETE_DESCRIPTION'),
                diagCancel: $filter('translate')('BTN_CANCEL'),
                diagConfirm: $filter('translate')('BTN_DELETE')
            }
        }).then(function (data) {
            //confirm
            apiService.post('checks/' + tableName + '/delete', {id: id, ssc_tile_page: tileSlug}).then(function (data) {
                deferred.resolve(data);
            }, function (error) {
                //error
                deferred.reject(error);
            });
        }, function (data) {
            //cancelled
            deferred.resolve();
        });

        return deferred.promise;
    };

    /**
     * überträgt collapse zustände aus altem accordion array in neues. korreliert die ids
     * @param oldAccordions [[true, 1], [false, 2], [true, 3], ..]
     * @param newAccordions [[false, 1], [false, 2], [false, 3], ..]
     * @returns {Array}
     */
    service.copyAccordionStates = function (oldAccordions, newAccordions) {
        var i;
        var e;
        var result = [];
        var found;
        for (i in newAccordions) {
            result[i] = [newAccordions[i][0], newAccordions[i][1]];
            found = false;
            for (e in oldAccordions) {
                if (parseInt(result[i][1]) === parseInt(oldAccordions[e][1])) {//same id
                    result[i][0] = oldAccordions[e][0];//then copy over collapse state
                    found = true;
                }
            }
            if (!found) {
                result[i][0] = true;
            }
        }
        return result;
    };


    /**
     * Add selected entries to dropdown, if not in the available dropdown options
     * @param directhelpList
     * @param directhelpSelectedList
     */
    service.appendOldDirecthelp = function (directhelpList, directhelpSelectedList) {
        if (!directhelpSelectedList || !directhelpList) {
            return;
        }
        for (var key in directhelpSelectedList) {//set directhelps
            if (directhelpSelectedList[key]) {
                var found = false;
                for (var keyL in directhelpList) { //list directhelps
                    if (directhelpSelectedList[key].id === directhelpList[keyL].id) {
                        found = true;
                        break;
                    }
                }

                if (!found) {
                    var directHelp = directhelpSelectedList[key];
                    directHelp.status = 0;
                    directhelpList.push(directHelp);
                }
            }
        }
    };

    /**
     * Add selected entries to dropdown, if not in the available dropdown options
     * @param directhelpList
     * @param directhelpSelectedList
     */
    service.appendOldDirecthelpList = function (directhelpList, directhelpSelectedList) {
        if (!directhelpSelectedList || !directhelpList) {
            return;
        }
        for (var key in directhelpSelectedList) {//set directhelps
            if (directhelpSelectedList[key].directhelp) {
                var found = false;
                for (var keyL in directhelpList) { //list directhelps
                    if (directhelpSelectedList[key].directhelp.id === directhelpList[keyL].id) {
                        found = true;
                        break;
                    }
                }

                if (!found) {
                    var directHelp = directhelpSelectedList[key].directhelp;
                    directHelp.status = 0;
                    directhelpList.push(directHelp);
                }
            }
        }
    };



    /**
     * converts index path string to id path string
     * @param indexPathStr "a.3.b.c.2.columnName" aka a[3].b.c[2].columnname
     * @param dataObj (content or properties from formread)
     * @returns "a.163.b.c.832.columnName" ->uses id of entries instead of array index
     */
    function indexPathToIdPath(indexPathStr, dataObj) {
        if (!dataObj) {
            return null;
        }
        var result = [];


        var pathSplit = indexPathStr.split(".");
        var current = dataObj;
        var i;
        for (i = 0; i < pathSplit.length; i++) {
            if (typeof current[pathSplit[i]] === "undefined") {
                return null;
            }
            var indexOrKey = pathSplit[i];
            if (/^\d+$/.test(indexOrKey)) {//is number aka array index
                result.push(current[pathSplit[i]].id);
            } else {//is key
                result.push(indexOrKey);
            }
            current = current[pathSplit[i]];
        }
        return result.join(".");
    }

    /**
     * converts id path string to index path string
     * @param indexPathStr "a.163.b.c.832.columnName"
     * @param dataObj (content or properties from formread)
     * @returns "a.3.b.c.2.columnName" aka a[3].b.c[2].columnname
     */
    function idPathToIndexPath(indexPathStr, dataObj) {
        if (!dataObj) {
            return null;
        }
        var result = [];

        var pathSplit = indexPathStr.split(".");
        var current = dataObj;
        var i;
        for (i = 0; i < pathSplit.length; i++) {
            var idOrKey = pathSplit[i];
            if (/^-?\d+$/.test(idOrKey)) {//is number aka row id, can be negative
                var found = false;
                for (var e = 0; e < current.length; e++) {
                    if (parseInt(current[e].id) === parseInt(idOrKey)) {
                        result.push(e);
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    return null;
                }
            } else {//is key
                if (typeof current[idOrKey] === "undefined") {
                    return null;
                }
                result.push(idOrKey);
            }
            current = current[result[result.length - 1]];
        }
        return result.join(".");
    }

    /**
     * return entry from data via index path
     * @param dataObj (something like content or properties from formread)
     * @param indexPathArr e.g. a.2.b.field
     * @param ignore how many indexes in indexPathArr to be ignored, counting backwards. e.g. 1 ignores the last
     * @returns e.g. dataObj["a"][2]["b"]["field"]
     */
    service.getViaIndexPathArr = function (dataObj, indexPathArr, ignore) {
        if (ignore === undefined) {
            ignore = 0;
        }
        var current = dataObj;
        var i;
        for (i = 0; i < indexPathArr.length - ignore; i++) {
            current = current[indexPathArr[i]];
            if (!current) {
                return null;
            }
        }
        return current;
    };

    /**
     * Flattens dataObj to 1d Array. Keys are id paths
     * @param dataObj (content or properties from formread)
     * @param structureObj a formread structure object
     * @param indexPathArr used for recursion. should be undefined initially
     * @param result used for recursion. should be undefined initially
     * @returns flattened data. each row is behind a key. the key is an id path
     *              e.g. {"a.2.b":{...},"a.34.b":{...},...}
     */
    function recursiveFlattenData(dataObj, structureObj, indexPathArr, result) {
        var key;
        var nextIndexPath;
        if (!result) {
            result = {};
        }
        if (!indexPathArr) {//initial state
            indexPathArr = [];
            for (key in structureObj) {
                if (!structureObj.hasOwnProperty(key))
                    continue;
                if (!structureObj[key].parentEl) {
                    recursiveFlattenData(dataObj, structureObj, [key], result);
                }
            }
            return result;
        }
        var dataEl = service.getViaIndexPathArr(dataObj, indexPathArr);
        var idPathStr = indexPathToIdPath(indexPathArr.join("."), dataObj);


        var currentStructureKey = indexPathArr[indexPathArr.length - 1];
        var structureEl = structureObj[currentStructureKey];
        if (!structureEl.many) {
            dataEl = [dataEl];
        }
        if (!dataEl) {
            dataEl = [];
        }
        var children = [];
        for (key in structureObj) {
            if (!structureObj.hasOwnProperty(key))
                continue;
            if (structureObj[key].parentEl === currentStructureKey) {
                children.push(key);
            }
        }
        for (var i = 0; i < dataEl.length; i++) {
            var currentIdPathArr = idPathStr.split(".");
            if (structureEl.many) {
                currentIdPathArr = currentIdPathArr.concat(dataEl[i].id);
            }
            result[currentIdPathArr.join(".")] = dataEl[i];
            for (var e = 0; e < children.length; e++) {
                if (structureEl.many) {
                    nextIndexPath = indexPathArr.concat([i, children[e]]);
                } else {
                    nextIndexPath = indexPathArr.concat([children[e]]);
                }
                recursiveFlattenData(dataObj, structureObj, nextIndexPath, result);
            }
        }
        return result;
    }

    function hasAtLeastOneProperty(obj, propertiesArr) {
        for (var i = 0; i < propertiesArr.length; i++) {
            if (typeof obj[propertiesArr[i]] !== "undefined" && obj[propertiesArr[i]] !== null) {
                return true;
            }
        }
        return false;
    }

    function showWarningConfirm() {
        ngDialog.open({
            template: 'templates/landingpage/ready_confirm_warnings.html' + "?v=" + window.version.tag,
            className: 'dialogLanding',
            showClose: false
        });
    }

    /**
     * For when new data from formread comes in. Keeps errors and warnings + their inputs unless
     * the user explicitly fixed them (requestIndexPathStr)
     * @param dataOldObj(data from controller) containing content, properties, tableProperties
     * @param dataNewObj(data from formread) containing content, properties, tableProperties
     * @param structureObj a formread structure object
     * @param requestIndexPathStr optional: the path that was edited on update
     * @param hideWarningConfirm bool if true: don't show popups for Warning Confirms
     * @returns returns updated dataNewObj
     */
    service.rememberInputErrors = function (dataOldObj, dataNewObj, structureObj, requestIndexPathStr, hideWarningConfirm) {
        if (!dataOldObj || !dataOldObj.properties || !dataOldObj.content || !dataNewObj.properties || !dataNewObj.content) {
            return dataNewObj;
        }

        var key;

        //flatten new and old content + properties. easier to work with
        var flatOldContent = recursiveFlattenData(dataOldObj.content, structureObj);
        var flatOldProperties = recursiveFlattenData(dataOldObj.properties, structureObj);
        var flatNewContent = recursiveFlattenData(dataNewObj.content, structureObj);
        var flatNewContentCopy = JSON.parse(JSON.stringify(flatNewContent));
        var flatNewProperties = recursiveFlattenData(dataNewObj.properties, structureObj);

        var ignorePathStr = undefined;
        if (requestIndexPathStr) {
            //convert request path to id based path
            ignorePathStr = indexPathToIdPath(requestIndexPathStr, dataOldObj.content);
        }

        if (ignorePathStr) { //copy over value from edited field if it had an error, and show warning-confirm popup

            //if request field has an error -> take request value
            var ignorePathA = ignorePathStr.split(".");
            var ignorePathB = ignorePathA.pop();
            ignorePathA = ignorePathA.join(".");
            if (flatNewProperties[ignorePathA]) {
                if (flatNewProperties[ignorePathA][ignorePathB] && hasAtLeastOneProperty(flatNewProperties[ignorePathA][ignorePathB], ["error"])) {
                    flatNewContent[ignorePathA][ignorePathB] = flatOldContent[ignorePathA][ignorePathB];
                }

                if (!hideWarningConfirm && flatNewProperties[ignorePathA][ignorePathB] && flatNewProperties[ignorePathA][ignorePathB].warning_confirm) {
                    showWarningConfirm();
                }
            } else { //something new was created. no explicit way of identifying
                //temp solution, will cause problems
                //backend would need to provide explicit info which entry was created
                var ignorePathNewStr = indexPathToIdPath(requestIndexPathStr, dataNewObj.content);
                //won't map when array structure slightly different
                if (ignorePathNewStr) {
                    //if request field has an error -> take request value
                    var ignorePathNewA = ignorePathNewStr.split(".");
                    var ignorePathNewB = ignorePathNewA.pop();
                    ignorePathNewA = ignorePathNewA.join(".");

                    if (flatNewProperties[ignorePathNewA][ignorePathNewB] && flatNewProperties[ignorePathNewA][ignorePathNewB].error) {
                        flatNewContent[ignorePathNewA][ignorePathNewB] = flatOldContent[ignorePathA][ignorePathB];
                    }

                    if (!hideWarningConfirm && flatNewProperties[ignorePathNewA][ignorePathNewB] && flatNewProperties[ignorePathNewA][ignorePathNewB].warning_confirm) {
                        showWarningConfirm();
                    }
                }
            }


        }

        //copy over errors, warnings, and their values
        for (key in flatOldProperties) {
            if (!flatOldProperties.hasOwnProperty(key))
                continue;
            for (var columnKey in  flatOldProperties[key]) {
                if (!flatOldProperties[key].hasOwnProperty(columnKey))
                    continue;
                if (key + "." + columnKey === ignorePathStr || !flatNewProperties[key]) {
                    continue;
                }
                if (flatOldProperties[key][columnKey] && hasAtLeastOneProperty(flatOldProperties[key][columnKey], ["error", "warning", "warning_confirm"]) && flatNewProperties[key]) {//has error or warning
                    //copy over properties
                    if (!flatNewProperties[key][columnKey]) {
                        flatNewProperties[key][columnKey] = {};
                    }
                    if (!flatNewProperties[key][columnKey].hidden && !flatNewProperties[key][columnKey].disabled) { //no point in showing errors for invisible fields
                        flatNewProperties[key][columnKey].error = flatOldProperties[key][columnKey].error;
                        flatNewProperties[key][columnKey].warning = flatOldProperties[key][columnKey].warning;
                        flatNewProperties[key][columnKey].warning_confirm = flatOldProperties[key][columnKey].warning_confirm;

                        //copy over value
                        flatNewContent[key][columnKey] = flatOldContent[key][columnKey];
                    }
                    // Field is not required, empty in scope and has an error -> gets removed, keeps the old value from DB
                    if(!flatNewProperties[key][columnKey].required && flatNewProperties[key][columnKey].error && flatOldContent[key][columnKey] == "") {
                        flatNewProperties[key][columnKey] = null;
                        flatOldContent[key][columnKey] = flatNewContentCopy[key][columnKey];
                        flatNewContent[key][columnKey] = flatNewContentCopy[key][columnKey];
                    }
                }
            }
        }

        /*//copy over empty ADDED_WHILE_SAVING entries
         for(key in flatOldContent) {
         if (!flatOldContent.hasOwnProperty(key)) continue;
         if(flatOldContent[key].ADDED_WHILE_SAVING) {//copy this entry over
         //get index path of array in new content
         var idPathArr = key.split(".");
         var lastStr = idPathArr.pop();//remove id at the end
         if(/^-?\d+$/.test(lastStr)) { //if it's actually a table with many
         var newIndexPathStr = idPathToIndexPath(idPathArr.join("."), dataNewObj.content);
         //get that array in content new
         var TargetArr = service.getViaIndexPathArr(dataNewObj.content, newIndexPathStr.split("."));
         if(TargetArr !== null) {//if exists, add to it
         delete flatOldContent[key].ADDED_WHILE_SAVING;
         TargetArr.push(flatOldContent[key]);
         }
         }
         }
         }*/
        return dataNewObj;
    };

    /**
     * figures out the index path given the params
     * @param tableName
     * @param itemId
     * @param structureObj a formread structure object
     * @param dataObj (content or properties from formread)
     * @returns {string} index path
     */
    service.resolveIndexPathStr = function (tableName, itemId, structureObj, dataObj) {
        var matchStr = tableName;
        if (structureObj[tableName].many) {
            matchStr += "." + itemId;
        }

        var flatData = recursiveFlattenData(dataObj, structureObj);

        for (var key in flatData) {
            if (!flatData.hasOwnProperty(key))
                continue;
            var indexOfResult = key.indexOf(matchStr);
            if (indexOfResult >= 0 && indexOfResult === key.length - matchStr.length) {
                return idPathToIndexPath(key, dataObj);
            }
        }
    };

    /**
     * e.g. "sscheat" -> "ssc_heat"
     * @param controllerStr e.g. "sscheat"
     * @param structureObj a formread structure object
     * @returns string or null if not found. e.g. "ssc_heat"
     */
    service.getTablenameFromController = function (controllerStr, structureObj) {
        for (var key in structureObj) {
            if (!structureObj.hasOwnProperty(key))
                continue;
            if (controllerStr === key.split("_").join("")) {
                return key;
            }
        }
        return null;
    };


    var emptyContentRowCount = 0;//helps making emptyRow.id unique
    /**
     * adds empty row to your content
     * sets parent field, and sets a negative unique id (timestamp)
     * (if run directly after one another in same execution run, the ids will not be unique
     * will have same id)
     *
     * @param tableName
     * @param parentId
     * @param structureObj a formread structure object
     * @param dataObj content from formread
     * @param isAddedWhileSaving bool if true sets attribute ADDED_WHILE_SAVING = true
     * @returns the created row object
     */
    service.addEmptyContentRow = function (tableName, parentId, structureObj, dataObj, isAddedWhileSaving) {
        var target;
        if (structureObj[tableName].parentEl) {
            var parentTableName = structureObj[tableName].parentEl;
            var indexPathStr = service.resolveIndexPathStr(parentTableName, parentId, structureObj, dataObj);
            var parentEl = service.getViaIndexPathArr(dataObj, indexPathStr.split("."));
            target = parentEl[tableName];
        } else {
            target = dataObj[tableName];
        }

        var emptyRow = {};
        emptyRow.id = (-1 * new Date().getTime()) + "" + emptyContentRowCount++;
        emptyRow[structureObj[tableName].parent] = parentId;
        if (isAddedWhileSaving) {
            emptyRow.ADDED_WHILE_SAVING = true;
        }
        target.push(emptyRow);
        return emptyRow;
    };


    service.warningsHasConfirmed = function (confirmWarnings) {
        if (confirmWarnings.current) {
            confirmWarnings.listConfirmed.push(confirmWarnings.current);
        }
        confirmWarnings.current = undefined;
    };
    service.hasWarningConfirmed = function (controller, field, confirmWarnings) {
        if (confirmWarnings.listConfirmed.length > 0) {
            var list = confirmWarnings.listConfirmed;

            for (var i = 0; i < list.length; i++) {
                if (list[i].controller === controller &&
                        list[i].field === field) {
                    return true;
                }
            }
        }
        return false;
    };
    service.removeWarningConfirmed = function (controller, field, confirmWarnings) {
        if (confirmWarnings.listConfirmed.length > 0) {
            for (var i = confirmWarnings.listConfirmed.length - 1; i >= 0; i--) {
                if (confirmWarnings.listConfirmed[i].controller === controller &&
                        confirmWarnings.listConfirmed[i].field === field) {
                    confirmWarnings.listConfirmed.splice(i, 1);
                }
            }
        }
        return false;
    };

    service.resolveSaveParamsFromOldInterface = function (params) {
        var result = {
            data: {}
        };

        var tableName = service.getTablenameFromController(params.controller, params.structureObj);//ssc_installed_brush
        result.indexPathStr = service.resolveIndexPathStr(tableName, params.itemId, params.structureObj, params.contentObj) + "." + params.field;//ssc_heat.ssc_installed_brush.1.directhelp_id
        result.route = 'checks/' + params.controller + '/update';//checks/sscinstalledbrush/update

        if (params.itemId < 0) {
            params.itemId = undefined;
        }
        result.data.ssc_tile_page = params.tileSlug;
        result.data[params.field] = params.value;
        if (params.itemId === undefined) {
            var parentField = params.structureObj[tableName].parent;
            var row = service.getViaIndexPathArr(params.contentObj, result.indexPathStr.split("."), 1);
            result.data[parentField] = row[parentField];
        } else {
            result.data.id = params.itemId;
        }

        return result;
    };

    service.copySsc = function (sscId) {
        return apiService.post('checks/ssc/copyhousehold', {'ssc_id': sscId});
    }

    return service;
});

"use strict";


angular.module('frontendApp').directive('onFinishRender',['$timeout', '$parse', function ($timeout, $parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last == true) {
                $timeout(function () {
                    scope.$emit('ngRepeatFinished');
                    if(!!attr.onFinishRender){
                        $parse(attr.onFinishRender)(scope);
                    }
                });
            }
        }
    }
}]);
"use strict";
angular.module('frontendApp').directive('convertToNumber', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function(val) {
                return val != null ? parseInt(val, 10) : null;
            });
            ngModel.$formatters.push(function(val) {
                return val != null ? '' + val : null;
            });
        }
    };
});
"use strict";


angular.module('frontendApp').factory('sscTreeSelectService', function() {

    var service = {};
    var idCounter = 0;

    /**
     * gen a "unique" base id for the dom
     * @returns {string}
     */
    service.genUniqueId = function() {
        return "ssc-tree-select-" + idCounter++;
    };

    /**
     * take locations from areaObj and put them in tree format (it's the leaf, so no children though)
     * when a location gets placed into the result,
     *  then it will also be removed from areaObj
     *
     * @param areaObj obj e.g. {locations: [...]}
     * @param id int optional - then it will only take that location
     * @returns array for tree e.g. [{id:5, name: 'Dresden', type:'location_id'}, ...]
     */
    function getLocations(areaObj, id) {
        var result = [];
        for(var i = 0; i < areaObj.locations.length; i++) {
            if(typeof(id) !== "undefined" && id !== null && parseInt(areaObj.locations[i].id) !== parseInt(id)) {
                continue;
            }
            result.push({
                id: areaObj.locations[i].id,
                name: areaObj.locations[i].name,
                type: 'location_id',
                checked: false,
                active: areaObj.locations[i].status === 1
            });
            areaObj.locations.splice(i, 1);
            i--;
        }
        return result;
    }

    /**
     * take states from areaObj and put them in tree format (including their locations)
     * when a state or location gets placed into the result,
     *  then it will also be removed from areaObj
     *
     * @param areaObj obj e.g. {states: [...], locations: [...]}
     * @param id int optional - then it will only take that location
     * @returns array for tree e.g. [{id:5, name: 'Sachsen', type:'state_id', children:[{id:5, name: 'Dresden', type:'location_id'}, ...]}, ...]
     */
    function getStates(areaObj, id) {
        var result = [];
        for(var i = 0; i < areaObj.states.length; i++) {
            var targetObj = areaObj.states[i];
            if (typeof(id) !== "undefined" && id !== null && parseInt(targetObj.id) !== parseInt(id)) {
                continue;
            }
            var newItem = {
                id: targetObj.id,
                name: targetObj.name,
                type: 'state_id',
                checked: false
            };
            result.push(newItem);
            if (targetObj.location_id && targetObj.location_id.length > 0) {
                newItem.children = [];
                for (var e = 0; e < targetObj.location_id.length; e++) {
                    var idItem = targetObj.location_id[e];
                    newItem.children.push(getLocations(areaObj, idItem)[0]);
                }
            }
            areaObj.states.splice(i, 1);
            i--;
        }
        return result;
    }

    /**
     * take regions from areaObj and put them in tree format (including their states, and locations)
     * when a region, state, or location gets placed into the result,
     *  then it will also be removed from areaObj
     *
     * @param areaObj obj e.g. {regions: [...], states: [...], locations: [...]}
     * @returns array for tree e.g. [{id:5, name: 'Sachsen/Thüringen', type:'region_id', children: [{id:5, name: 'Sachsen', type:'state_id', children:[{id:5, name: 'Dresden', type:'location_id'}, ...]}, ...]}]
     */
    function getRegions(areaObj) {
        var result = [];
        for(var i = 0; i < areaObj.regions.length; i++) {
            var targetObj = areaObj.regions[i];
            var newItem = {
                id: targetObj.id,
                name: targetObj.name,
                type: 'region_id',
                checked: false
            };
            result.push(newItem);
            if(targetObj.state_id && targetObj.state_id.length > 0) {
                newItem.children = [];
                for(var e = 0; e < targetObj.state_id.length; e++) {
                    var idItem = targetObj.state_id[e];
                    newItem.children.push(getStates(areaObj, idItem)[0]);
                }
            }
            areaObj.regions.splice(i, 1);
            i--;
        }
        return result;
    }

    service.getBund = function(areaObj) {
        console.log(areaObj);
        return true;
    };

    /**
     * takes userAreaObj and puts it in format readable for ssc-tree-select directive
     * will also consider states and locations that have no parent.
     * they will be listed after regions respectively
     *
     * userAreaObj will stay the same
     *
     * see ssc-tree-select directive for example of how its model looks like
     *
     * @param userAreaObj object e.g. {organisations: [...], regions: [{id:5, name:'Bayern', state_id: [1,5,3], ...}, ...], states: [{id:3, name:'Bayern', location_id: [42,12,4], ...}, ...], locations: [{id:12, name:'München', ...}, ...]}
     * @returns array tree e.g. [{id:5, name: 'Sachsen/Thüringen', type:'region_id', children: [{id:5, name: 'Sachsen', type:'state_id', children:[{id:5, name: 'Dresden', type:'location_id'}, ...]}, ...]}]
     */
    service.userAreasToTree = function(userAreaObj) {
        var result = [];
        var areaObj = JSON.parse(JSON.stringify(userAreaObj));//make a copy, because it will be changed
        var regionsArr = getRegions(areaObj);
        var statesArr = getStates(areaObj);
        var locationsArr = getLocations(areaObj);

        result = result.concat(regionsArr);
        if(regionsArr.length > 0 && (statesArr.length > 0 || locationsArr.length > 0)) {
            result.push({});
        }
        result = result.concat(statesArr);
        if(statesArr.length > 0 && locationsArr.length > 0) {
            result.push({});
        }
        result = result.concat(locationsArr);

        return result;
    };

    /**
     * flattens ssc-tree-select tree
     *
     * @param treeArr array tree e.g. [{name: 'Sachsen/Thüringen', checked: true, children: [{name: 'Sachsen', checked: true, children:[{name: 'Dresden', checked: true}, ...]}, ...]}]
     * @returns array each item on 1d array - e.g. array tree e.g. [{name: 'Sachsen/Thüringen', checked: true, children: [...]}, {name: 'Sachsen', checked: true, children:[...]}, {name: 'Dresden', checked: true}, ...]
     */
    function recursiveFlattenTree(treeArr) {
        var result = [];

        if(!treeArr) {
            return result;
        }

        for(var i = 0; i < treeArr.length; i++) {
            result.push(treeArr[i]);
            if(treeArr[i].children) {
                result = result.concat(recursiveFlattenTree(treeArr[i].children));
            }
        }

        return result;
    }

    /**
     * tells you which ids of which type were selected.
     * assumes tree items all have the attributes: id, type
     *
     * @param treeArr array e.g. [{id: 1, name: 'Dresden', type: 'location_id', checked: true}, ...]
     * @returns object e.g. {location_id: [1, ...], ...}
     */
    service.extractSelection = function(treeArr) {
        var result = {};

        var flatArr = recursiveFlattenTree(treeArr);

        for(var i = 0; i < flatArr.length; i++) {
            if(!flatArr[i].checked) {
                continue;
            }
            if(!result[flatArr[i].type]) {
                result[flatArr[i].type] = [];
            }
            result[flatArr[i].type].push(flatArr[i].id);
        }

        return result;
    };

    /**
     * Returns the selection as location ids.
     * if a region is selected it returns the regions location ids.
     * @param {Array} treeArr
     */
    service.extractSelectedLocations = function (treeArr) {
        var result = [];
        for (var r = 0; r < treeArr.length; r++) {
            var regionChecked = treeArr[r].checked === true;
            if (treeArr[r].hasOwnProperty("children")) {
                for (var s = 0; s < treeArr[r].children.length; s++) {
                    var stateChecked = regionChecked || treeArr[r].children[s].checked === true;
                    if (treeArr[r].children[s].hasOwnProperty("children")) {
                        for (var l = 0; l < treeArr[r].children[s].children.length; l++) {
                            if (stateChecked || treeArr[r].children[s].children[l].checked === true) {
                                result.push(treeArr[r].children[s].children[l].id);
                            }
                        }
                    }
                    else if (treeArr[r].children[s].type === "location_id" && (regionChecked || treeArr[r].children[s].checked === true)) {
                        result.push(treeArr[r].children[s].id);
                    }
                }
            }
            else if (treeArr[r].type === "location_id" && treeArr[r].checked === true) {
                result.push(treeArr[r].id);
            }
        }
        return result;
    };

    return service;
});
"use strict";

/**
 * a tree-like multi select
 * can have max 3 levels
 * each level is optional
 *
 * levels can be expanded and collapsed
 * has a select all
 * can display a separator line
 *
 * expects model to be as such:
    [
        {
            name: "Sachsen/Thüringen",
            children: [
                {
                    name: "Sachsen",
                    children: [
                        {
                            name: "Dresden",
                        },
                        ...
                    ]
                },
                ...
            ]
        },
        ...
    ]
 *
 * it will write "checked" attribute like so (by itself):
 * { name: "Dresden", checked: true }
 *
 * and empty item at root level will create a seperator line
 *
 * it will not touch extra attributes in items e.g. {
                id: 12312, //extra attribute <- will remain
                type: 'region_id', //extra attribute <- will remain
                name: "Sachsen/Thüringen",
                children: [...],
            }
 * so you can put more data in there to read out later again
 *
 */
angular.module('frontendApp').directive('sscTreeSelect', function (sscTreeSelectService) {

    /**
     * gets item from tree structure
     * indexArr uses array index. does not look at id property of an item.
     *
     * @param dataArr array the tree structure
     * @param pathIndexArr array e.g. [1, 4, 3]
     * @returns object tree-item e.g. {name: 'Dresden', checked: true}
     */
    function getViaPath(dataArr, pathIndexArr) {
        var result = {children: dataArr};
        for(var i = 0; i < pathIndexArr.length; i++) {
            result = result.children[parseInt(pathIndexArr[i])];
        }
        return result;
    }

    /**
     * set checked status of all children, and their children
     *
     * @param item object e.g. {name: 'Dresden', checked: true, children: [...]}
     * @param checked boolean
     * @param {boolean} onlyActive
     */
    function setChildren(item, checked, onlyActive) {
        if (onlyActive === undefined) {
            onlyActive = false;
        }
        if(!item.children) {
            return;
        }
        for(var i = 0; i < item.children.length; i++) {
            var setChecked = onlyActive === false || item.children[i].hasOwnProperty('active') === false || item.children[i].active === true;
            item.children[i].checked = checked && setChecked;
            if (setChecked) {
                setChildren(item.children[i], checked, onlyActive);
            }
        }
    }

    return {
        restrict: 'E',
        replace: true,
        scope: {
            sscTreeSelectModel: "=",
            sscTreeSelectBund: "=",
            sscTreeSelectSearch: "=",
            disableBund: "="
        },
        link: function(scope, element, attrs) {
            if (scope.disableBund === true) {
                scope.sscTreeSelectBund = false;
            }
        },
        templateUrl: 'templates/components/shared/sscTreeSelect/sscTreeSelect.view.html' + "?v=" + window.version.tag,
        controller: function($scope) {
            //unique id so you can have multiple tree selects on a page
            $scope.baseId = sscTreeSelectService.genUniqueId();

            /**
             * Checks only active elements, unchecks every element in the scope
             * @param {integer[]} pathIndexArr
             */
            $scope.toggleActive = function (pathIndexArr) {
                var item = getViaPath($scope.sscTreeSelectModel, pathIndexArr);
                if (item.checked === undefined) {
                    item.checked = false;
                }
                setChildren(item, item.checked === false, true);
            };

            /**
             * Checks only active elements, unchecks every element
             */
            $scope.toggleAllActive = function () {
                for (var i = 0; i < $scope.sscTreeSelectModel.length; i++) {
                    $scope.sscTreeSelectModel[i].checked = !$scope.allChecked;
                    setChildren($scope.sscTreeSelectModel[i], !$scope.allChecked, true);
                }
                $scope.allChecked = !$scope.allChecked;
                $scope.sscTreeSelectBund = !$scope.allChecked && !$scope.disableBund;
            };

            //an item was checked/unchecked -> update tree
            $scope.update = function(pathIndexArr) {
                var item = getViaPath($scope.sscTreeSelectModel, pathIndexArr);
                var i, remainderArr, parent, allChecked, current;
                if(item.checked === undefined) item.checked = false;
                //if uncheck -> uncheck parents
                if(!item.checked) {
                    remainderArr = pathIndexArr;
                    while(remainderArr.length > 1) {
                        remainderArr = remainderArr.slice(0, -1);
                        parent = getViaPath($scope.sscTreeSelectModel, remainderArr);
                    }
                }

                //if check, and all current level are checked -> check parent -> same test above
                if(item.checked) {
                    remainderArr = pathIndexArr;
                    while(remainderArr.length > 1) {
                        remainderArr = remainderArr.slice(0, -1);
                        parent = getViaPath($scope.sscTreeSelectModel, remainderArr);
                        allChecked = true;
                        for(i = 0; i < parent.children.length; i++) {
                            if(!parent.children[i].checked) {
                                allChecked = false;
                                break;
                            }
                        }
                        if(allChecked) {

                        } else {
                            break;
                        }
                    }
                }

                setChildren(item, !item.checked);

                //update all-toggle at the top
                allChecked = true;
                for(i = 0; i < $scope.sscTreeSelectModel.length; i++) {
                    if(!$scope.sscTreeSelectModel[i].checked) {
                        allChecked = false;
                        break;
                    }
                }
                //$scope.allChecked = allChecked;
            };

            $scope.updateAll = function() {
                for(var i = 0; i < $scope.sscTreeSelectModel.length; i++) {
                    $scope.sscTreeSelectModel[i].checked = !$scope.allChecked;
                    setChildren($scope.sscTreeSelectModel[i], !$scope.allChecked);
                }
                $scope.allChecked = !$scope.allChecked;
                $scope.sscTreeSelectBund = !$scope.allChecked && !$scope.disableBund;
            };
        }
    };
});
"use strict";

/**
 * a caret shaped toggle. useful for expanding and collapsing.
 * Toggles on click.
 */
angular.module('frontendApp').directive('sscToggleCaret', function() {

    return {
        scope: {
            sscToggleCaretModel: "=",// false >  true v
            sscToggleCaretHidden: "="//still takes up space when hidden
        },
        templateUrl: 'templates/components/shared/sscToggleCaret/sscToggleCaret.view.html' + "?v=" + window.version.tag,
        controller: function($scope) {
            $scope.toggle = function() {
                $scope.sscToggleCaretModel = !$scope.sscToggleCaretModel;
            };
        }
    };
});
"use strict";

angular.module('frontendApp').directive('sscTacho', function ($interval) {

    return {
        restrict: 'E',
        replace: true,
        scope: {
            sscTachoTop: "=",
            sscTachoBottom: "=",
            sscTachoLabel: "="
        },
        templateUrl: 'templates/components/shared/sscTacho/sscTacho.view.html' + "?v=" + window.version.tag,
        link: function($scope) {

        },
        controller: function($scope) {
            function update() {
                var clamped, transform;
                $scope.sscTacho = {};
                if(typeof($scope.sscTachoTop) !== "undefined" && $scope.sscTachoTop !== null) {
                    clamped = Math.min(1, Math.max(0, $scope.sscTachoTop));
                    transform = "";
                    if(clamped > 0.85) {
                        transform = "translate(-58px,0)";
                    }
                    if(clamped < 0.15) {
                        transform = "translate(-8px,0)";
                    }
                    $scope.sscTacho.styleLabelTop = {
                        marginLeft: (clamped * 100) + "%",
                        transform: transform
                    };
                    $scope.sscTacho.styleArrowTop = {
                        marginLeft: (Math.min(1, Math.max(0, $scope.sscTachoTop)) * 100) + "%"
                    };
                }
                if(typeof($scope.sscTachoBottom) !== "undefined" && $scope.sscTachoBottom !== null) {
                    clamped = Math.min(1, Math.max(0, $scope.sscTachoBottom));
                    transform = "";
                    if(clamped > 0.85) {
                        transform = "translate(-58px,0)";
                    }
                    if(clamped < 0.15) {
                        transform = "translate(-8px,0)";
                    }
                    $scope.sscTacho.styleLabelBottom = {
                        marginLeft: (clamped * 100) + "%",
                        transform: transform
                    };
                    $scope.sscTacho.styleArrowBottom = {
                        marginLeft: (Math.min(1, Math.max(0, $scope.sscTachoBottom)) * 100) + "%"
                    };
                }
            }
            $scope.$watch('sscTachoTop', update);
            $scope.$watch('sscTachoBottom', update);
            update();
        }
    };
});
"use strict";

//visually lay out pills (direct children of element) as if they were stacked. there's always something underneath of a pill. no floating pills.
//Like so:
// |   |    |
// |     |     |   |
// |  |     |    |     |
//done purely by looking at width of container and pills, then calculating the break points
angular.module("frontendApp").directive("sscPillStack", function() {

    return {
        restrict: 'A',
        link: function($scope, element, attrs) {

            var containerEl = element[0];
            var containerWidth;
            var pillWidthArr = [];

            var updatePills = function() {
                if(document.hidden) {
                    return;
                }
                //get current width of container and pills
                var wLimit = 1;//pixels - change in width that will be ignored
                var newContainerWidth = containerEl.clientWidth - (wLimit * 4); //subtract wLimit for wiggleroom
                var newPillWidthArr = [];//e.g. [312, 123, 51, 323, 142]
                var i;
                for(i = 0; i < containerEl.children.length; i++) {
                    newPillWidthArr.push(containerEl.children[i].clientWidth);
                }

                //if container and pills have not changed their width -> return
                //it needs to have changed their width by more than wLimit pixels - otherwise it might flicker (not sure why)
                if(Math.abs(newContainerWidth - containerWidth) <= wLimit && pillWidthArr.length === newPillWidthArr.length) {
                    var allSame = true;
                    for(i = 0; i < pillWidthArr.length; i++) {
                        if(Math.abs(pillWidthArr[i] - newPillWidthArr[i]) > wLimit) {
                            allSame = false;
                            break;
                        }
                    }
                    if(allSame) {
                        return;
                    }
                }

                //a width has changed -> recalculate break points

                //determine where pills would break
                //by going backwards. filling from bottom to top
                var breaksArr = [];//which el breaks. e.g.[false, false, false, true, false, false]
                var availableWidth = newContainerWidth;//available width on line
                //either width of container, or of line below
                var lineWidth = 0;//how much width has current line taken up
                for(i = newPillWidthArr.length - 1; i >= 0; i--) {
                    if(lineWidth + newPillWidthArr[i] > availableWidth) {
                        if(lineWidth == 0) {//first element on line, and already going over available width
                            //element i will be the break point
                            breaksArr = [true].concat(breaksArr);
                            availableWidth = newPillWidthArr[i];
                            lineWidth = 0;
                        } else {
                            //element i + 1 will be break point
                            breaksArr[0] = true;
                            breaksArr = [false].concat(breaksArr);
                            availableWidth = lineWidth;
                            lineWidth = newPillWidthArr[i];
                        }
                    } else {
                        lineWidth += newPillWidthArr[i];
                        breaksArr = [false].concat(breaksArr);
                    }
                }

                //apply styling
                for(i = 0; i < breaksArr.length; i++) {
                    if(breaksArr[i]) {
                        $(containerEl.children[i]).addClass('ssc-pill-stack-break');
                    } else {
                        $(containerEl.children[i]).removeClass('ssc-pill-stack-break');
                    }
                }

                containerWidth = newContainerWidth;
                pillWidthArr = newPillWidthArr;
            };

            var interval = setInterval(updatePills, 50);

            $scope.$on('$destroy', function() {
                clearInterval(interval);
            });
        }
    };
});
"use strict";


angular.module("frontendApp").directive("sscExpandAllBtn", function($timeout) {

    return {
        templateUrl: 'templates/components/shared/sscExpandAllBtn/sscExpandAllBtn.view.html' + "?v=" + window.version.tag,
        controller: function($scope) {
            //update button on api load
            $scope.$on("onSscLoadComplete", function (event, propertyData) {
                $timeout(function() {
                    isCollapseOpen();
                    addListeners();
                }, 0);
            });
             
            //check; one collapse open
            var isCollapseOpen=function(){
                //current state
                var allShown = true;
                var $collapse = $('.collapse');
                var numChecked=0;
                $collapse.each(function( index ) {
                    if(!$(this).hasClass("in")){
                        if(!$(this).parent().hasClass("ng-hide")){
                            allShown = false;
                        }
                    };
                    numChecked++;
                });
                $scope.isEnabled = numChecked > 0;
                if(numChecked > 0) {
                    $scope.sscIsExpanded = allShown;
                }
            };
            
            //listeners
            var addListeners = function(){
                var $collapse = $(".collapse");
                $collapse.on('shown.bs.collapse', function(event){
                    $timeout(function() {
                        isCollapseOpen();
                    }, 0);
                });

                $collapse.on('hidden.bs.collapse', function(event){
                    $timeout(function() {
                        isCollapseOpen();
                    }, 0);
                });
            };
            
            isCollapseOpen();
            addListeners();
            
            $scope.toggle = function() {
                var $collapse = $('.collapse');
                $scope.sscIsExpanded = !$scope.sscIsExpanded;

                if($scope.sscIsExpanded){
                    $collapse.collapse('show');
                    if($collapse.hasClass("collapsed")){
                        $collapse.removeClass("collapsed");
                    }
                }else{
                    $collapse.collapse('hide');
                    if(!$collapse.hasClass("collapsed")){
                        $collapse.addClass("collapsed");
                    }
                }
            };
        }
    };
});
"use strict";


angular.module('frontendApp').factory('sscErrorboxService', function ($filter) {
    var service = {};

    //wildcardStringMatch("birdieeee", "bird*") -> true
    function wildcardStringMatch(str, rule) {
        return new RegExp("^" + rule.split("*").join(".*") + "$").test(str);
    }

    /**
     * ssc-errorbox compatible messages from properties field
     * @param field
     * @returns {Array}
     */
    service.toMessage = function(field) {
        var result = [];
        if(field) {
            if (field.error) {
                result.push({
                    type: "error",
                    text: field.error
                });
            }
            if (field.warning) {
                result.push({
                    type: "warning",
                    text: field.warning
                });
            }
            if (field.warning_confirm) {
                result.push({
                    type: "warning",
                    text: field.warning_confirm,
                    confirm: true
                });
            }
        }
        return result;
    };

    /**
     * get array of ssc-errorbox compatible messages from properties row object
     * @param row object
     * @param optional: array with fieldnames. if you only want a few specific field from an object * wildcard possible
     * @returns {Array}
     */
    service.messagesFromRow = function(row, fieldlist) {
        var result = [];
        var i, e;
        if(row) {
            for (i in row) {
                if(fieldlist) {
                    var skip = true;
                    for(e in fieldlist) {
                        if(wildcardStringMatch(i, fieldlist[e])) {
                            skip = false;
                            break;
                        }
                    }
                    if(skip) {
                        continue;
                    }
                }
                result = result.concat(service.toMessage(row[i]));
            }
        }
        return result;
    };

    /**
     * get array of ssc-errorbox compatible messages from properties table array (containing multiple rows)
     * @param tableArr
     * @param fieldList array with fieldnames. if you only want a few specific field from an object. * wildcard possible
     * @param isSeparated boolean - if true, it will be an array of arrays. each
     *              index the errors of a row. [[errors row 1], [errors row 2], ...]
     * @returns {Array}
     */
    service.messagesFromTable = function(tableArr, fieldList, isSeparated) {
        var result = [];
        if(tableArr) {
            for(var i in tableArr) {
                if(isSeparated) {
                    result.push(service.messagesFromRow(tableArr[i], fieldList));
                } else {
                    result = result.concat(service.messagesFromRow(tableArr[i], fieldList));
                }
            }
        }
        return result;
    };


    /**
     *
     * recursively finds all errors and warnings of interest for one filter (aka path)
     * @param subPath "tablename[n].tablename2" -> n causes a seperation (each entry of tablename will have their own
     *                                                                  array of messages
     * @param fieldList ["name", "tip_*", ...]
     *          array with fieldnames. if you only want a few specific field from an object * wildcard possible
     * @param subProperties {tablename:[{id: 1, name: null, tablename2: {...}}, ...], ...}
     * returns {separationLevels:0-n, messages: [...]} - separationLevels tells how often an "[n]" occurred
     */
    function recursiveFilterLevel(subPath, fieldList, subProperties) {
        var splitPath = subPath.split(".");

        if(splitPath.length === 0) {
            return {separationLevels: 0, messages: []};
        }

        var isSeparated = false;
        var isMany = false;
        var key;
        var messages;
        var subFilterResultObj;
        var nextSubPath;


        if(splitPath[0].length > 3 && splitPath[0].indexOf("[n]") === splitPath[0].length - 3) {//tableName[n]
            isSeparated = true;
            isMany = true;
            key = splitPath[0].substring(0, splitPath[0].length - 3);
        } else if(splitPath[0].length > 2 && splitPath[0].indexOf("[]") === splitPath[0].length - 2) {//tableName[]
            isMany = true;
            key = splitPath[0].substring(0, splitPath[0].length - 2);
        } else {//tableName
            key = splitPath[0];
        }

        //in case no data, keep walking deeper anyhow
        if(!subProperties || !subProperties[key]) {//null or undefined
            if(splitPath.length === 1) {//leaf
                return {separationLevels: isSeparated ? 1 : 0, messages: []};
            } else {//branch
                if(isMany) {
                    subFilterResultObj = recursiveFilterLevel(nextSubPath, undefined, undefined);
                    var result = {
                    };
                    if(isSeparated) {
                        result.separationLevels = subFilterResultObj.separationLevels + 1;
                        result.messages = [subFilterResultObj.messages];
                    } else {
                        result.separationLevels = subFilterResultObj.separationLevels;
                        result.messages = subFilterResultObj.messages;
                    }
                    return result;
                } else {
                    nextSubPath = splitPath.slice(1).join(".");
                    return recursiveFilterLevel(nextSubPath, undefined, undefined);
                }
            }
        }


        var propertiesTableArr = subProperties[key];
        if(!isMany) {
            propertiesTableArr = [propertiesTableArr];
        }

        if(splitPath.length === 1) {//leaf
            messages = service.messagesFromTable(propertiesTableArr, fieldList, isSeparated);
            return {separationLevels: isSeparated ? 1 : 0, messages: messages};
        } else {//branch
            nextSubPath = splitPath.slice(1).join(".");
            if(isMany) {
                var subSeparationLevels = undefined;
                var messagesArr = [];

                //bring all sub table entries together, or separate them on current level

                //get all messages from sub levels
                for(var i in propertiesTableArr) {

                    subFilterResultObj = recursiveFilterLevel(nextSubPath, fieldList, subProperties[key][i]);
                    /*something like this in subFilterResultObj.messages
                    0 [{msg}, ...] ssc_heat
                    1 [[{msg}, ...], ...] ssc_shower[n]
                    2 [[[{msg}, ...], ...], ...] ssc_shower[n].ssc_shower_person[n]
                    */
                    subSeparationLevels = subFilterResultObj.separationLevels;

                    if(isSeparated) {//tableName[n]. ...
                        messagesArr.push(subFilterResultObj.messages);
                    } else {//tableName[]. ...
                        messagesArr = messagesArr.concat(subFilterResultObj.messages);
                    }
                }
                if(propertiesTableArr.length === 0) {
                    subFilterResultObj = recursiveFilterLevel(nextSubPath, undefined, undefined);
                    subSeparationLevels = subFilterResultObj.separationLevels;
                }

                return {
                    separationLevels: subSeparationLevels + (isSeparated ? 1 : 0),
                    messages: messagesArr
                }

            } else {//tableName. ...
                return recursiveFilterLevel(nextSubPath, fieldList, subProperties[key]);
            }
        }
    }

    /**
     * returns all errors and warnings of interest in properties
     * will be structured as structureObj specifies. see check controllers for examples
     * @param structureObj an errorbox structure object <- tells which errors and warnings you want,
     *                                                      and how to structure them
     *                      atm only one [n] per path allowed
     * @param properties from formread
     * @returns {{}}
     */
    service.createErrorObject = function(structureObj, properties) {
        var result = {};
        var key;
        var i;
        var e;
        for (key in structureObj) { //lets get the errors and warnings for each filter/key in the structure
            if (!structureObj.hasOwnProperty(key)) continue;
            var filtersArr = structureObj[key];
            if(!Array.isArray(filtersArr)) {
                filtersArr = [filtersArr];
            }
            var messagesArr = [];
            var separationLevels = undefined;

            for (i in filtersArr) {
                var filterResultObj = recursiveFilterLevel(filtersArr[i].path, filtersArr[i].fields, properties);

                //either: separationLevels: 0, [{}, {}, {}, ...]
                //or: separationLevels: 1, [[{}, ...], [{}, ..], ...]

                //exception if: contradictory levels, or levels > 1

                if(filterResultObj.separationLevels > 1) {
                    throw "only one separation level allowed. (aka one \"[n]\" in path)";
                }
                if(filterResultObj.separationLevels === 1) {
                    if(separationLevels === 0) {
                        throw "contradictory paths";
                    }
                    separationLevels = 1;
                    for(e in filterResultObj.messages) {
                        if(!messagesArr[e]) {
                            messagesArr[e] = [];
                        }
                        messagesArr[e] = messagesArr[e].concat(filterResultObj.messages[e]);
                    }
                } else {
                    if(separationLevels === 1) {
                        throw "contradictory paths";
                    }
                    separationLevels = 0;
                    messagesArr = messagesArr.concat(filterResultObj.messages);
                }

            }


            var results = [];


            //look for errors and warnings
            var searchArr = messagesArr;
            if(separationLevels === 0) {
                searchArr = [searchArr];
            }

            for(e in searchArr) { //prepare return

                var resultKey = {
                    hasError: false,
                    hasWarning: false
                };

                //determine hasError and hasWarning
                for(i in searchArr[e]) {
                    if(searchArr[e][i].type === "error") {
                        resultKey.hasError = true;
                        if(resultKey.hasWarning) {
                            break;
                        }
                    }
                    if(searchArr[e][i].type === "warning") {
                        resultKey.hasWarning = true;
                        if(resultKey.hasError) {
                            break;
                        }
                    }
                }

                resultKey.messages = searchArr[e];
                results.push(resultKey);
            }

            if(separationLevels === 0) {
                result[key] = results[0];
            } else {
                result[key] = results;
            }
        }
        return result;
    };

    return service;
});
"use strict";

angular.module('frontendApp').directive('sscErrorbox', function () {

    return {
        restrict: 'E',
        replace: true,
        scope: {
            messages: "=",
            boxtitle: "@",
            sscErrorboxTitle: "="
        },
        templateUrl: 'templates/components/shared/sscErrorbox/sscErrorbox.view.html' + "?v=" + window.version.tag,
        link: function($scope) {
        },
        controller: function($scope) {
        }
    };
});
"use strict";
/**
 * 
 * pathTo( image_relative_path ): returns full cdn-path (URL) for given image or relative path
 * 
 */

angular.module('frontendApp').factory('srcCdnService', function (api)
{
    var service = {};

    service.pathTo = function (ressource)
    {
        // don't add cdn path if ressource is a full URL or base64 encoded
        if(ressource !== undefined && ressource !== null && ressource.length !== 0)
        { 
            if (ressource.indexOf('http') === 0 || ressource.indexOf('data:image/') !== -1)
                return ressource;     

            // TODO cut '/' or '\' from front   
            return api.cdn + ressource;
        } else {
            // insert placeholder image?
            return "";
        }
    }; 
    
    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.directive:srcCdn
* @scope
* @restrict E
*
* @description
* Replaces the "src-cdn"-attribute in an element with a "src"-attribute 
* which is generated out of some predefined cdn-url and some relative path from database
* 
* USAGE: <img src-cdn="{{varWithPath}}">  will be translated to
*        <img src="http://fullyBuildURL/with/valueOf.varWithPath">
*        
* [create-attr]:
*   You can additionally set an attribute 'create-attr="foo"', which will trigger not to create 
*   a "src"-attribute, but a "foo"-attribute which contains the generated CDN-URL.
*   
* [watch]:
*   If this property-attribute exists, directive will $watch the value
*   in "src-cdn" and waits for changes. It will fire its action after every change of "src-cdn".
*
* @param {object}  field   A field object
*/
        
angular.module('frontendApp').directive('srcCdn', function (api, srcCdnService)
{
    return { 
        restrict: 'A',
        replace: true,        
                
        link: function (scope, elem, attrs)
        {   
            // replacing action
            scope.action = function()
            {
                var replace = "href";  
                if( attrs['createAttr'] !== undefined)
                {
                   replace = attrs['createAttr'];
                }
                elem.attr(replace, srcCdnService.pathTo(attrs.srcCdn));
            };
                        
            // switching on $watch/$observe if set
            if( attrs['watch'] !== undefined)
            {
               attrs.$observe('srcCdn',  scope.action);
           }
           elem.on('error', function(event){
               scope.$emit('error404', event);
           });
            
            // initial run
            scope.action();
        }
    };
});



"use strict";
/**
 * @ngdoc directive
 * @name global.service:searchCacheService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('searchCacheService', function ($rootScope) {

	var service = {};

	service.type = {};
	service.type.ssc = "ssc";
	service.type.user = "user";
	service.type.directhelp = "directhelp";
	service.type.location = "location";
	service.type.fridge_exchange = "fridge_exchange";
	service.type.news = "news";

	service.setCacheData = function (type, key, data) {
		if (typeof $rootScope.searchCache !== "object") {
			$rootScope.searchCache = {};
		}
		if ($rootScope.searchCache.hasOwnProperty(type) === false) {
			$rootScope.searchCache[type] = {};
		}
		$rootScope.searchCache[type][key] = data;
	};
	service.getCacheDataComplete = function (type) {
		var data = {};
		if ($rootScope.searchCache && $rootScope.searchCache[type]) {
			data = $rootScope.searchCache[type];
		}
		return data;
	};
	service.getCacheDataByKey = function (type, key) {
		var data = null;
		if ($rootScope.searchCache && $rootScope.searchCache[type] && $rootScope.searchCache[type].hasOwnProperty(key)) {
			data = $rootScope.searchCache[type][key];
		}
		return data;
	};
	service.unsetData = function (type) {
		if ($rootScope.searchCache && $rootScope.searchCache[type]) {
			$rootScope.searchCache[type] = {};
		}
	};
	service.isBackButton = function (type) {
		var isBack = false;
		if (typeof $rootScope.previousState === "object" && $rootScope.previousState.hasOwnProperty("name")) {
			var previousState = $rootScope.previousState.name;
			switch (type) {
				case service.type.ssc:
					isBack = previousState.indexOf("ssc") === 0;
					break;
				case service.type.location:
					isBack = previousState.indexOf("location") === 0;
					break;
				case service.type.news:
					isBack = previousState.indexOf("news") === 0;
					break;
				case service.type.user:
					isBack = previousState.indexOf("user") === 0;
					break;
			}
		}
		return isBack;
	};

	return service;

});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:searchService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('searchService', function (apiService) {

    var service = {};

    service.search = function (route, data) {
        return apiService.post(route, {search: data});
    };

    service.filter = function (route, data) {
        return apiService.post(route, {filter: data});
    };

    service.searchUser = function(searchString, role, loc_id)
    {
        if(!searchString) {
            searchString = "";
        }
        var data = {
            search: searchString,
            role: role,
            loc_id: loc_id
        };
        return apiService.post("user/searchbyrole", data);
    };

    service.searchEfbUser = function(searchString, sscId)
    {
        if(!searchString){
            searchString = "";
        }
        var data = {
            search: searchString,
            role: 'efb',
            ssc_id: sscId
        };
        return apiService.post("user/searchallbyrole", data);
    };

    /**
     * closes a collapse element if it's open
     * @param $id
     */
    service.closeCollapse = function($id) {
        var $collapse = $('#' + $id);
        if($collapse.hasClass("in")) {
            $collapse.collapse('hide');
        }
    };

    return service;
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:adminService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('reviewService', function (apiService, $filter, localStorageService, ngDialog, $rootScope) {

    var service = {};
    var user = localStorageService.get('user');
    //admin can see all
    //[] - all users can see it
    //['BUKO'] - only BUKO can see it
    //['BUKO', 'LOKO'] - only BUKO and LOKO can see it
    //['!REKO'] - everyone except REKO can see it
    var options = {
        directhelpreview: [
            {roles: ['ADMIN'], route: "report/reportsh", id: 13, short: 'bericht', name: $filter('translate')('REVIEW_BERICHTSH')},
            {roles: ['BUKO', 'EFB', 'LOKO'], route: "report/givendirecthelp", id: 14, short: 'given-directhelps', name: $filter('translate')('REVIEW_GIVEN_DIRECTHELP')}
        ],
        locationreview: [
            {roles: ['LOKO', 'TRAINER', 'BUKO', 'EFB', 'KGA'], route: "report/reportssc", id: 21, short: 'auswertungsberichtssc', name: $filter('translate')('REVIEW_AUSWERTUNGSSC')},
            {roles: ['BUKO', 'LOKO', 'TRAINER'], route: "report/akquise", id: 27, short: 'akquiseliste', name: $filter('translate')('REVIEW_AKQUISELISTE')},
            {roles: ['BUKO', 'REKO', 'EFB'], route: "report/closedhh", id: 22, short: 'abgeschlossenehh', name: $filter('translate')('REVIEW_ABGESCHLOSSENEHH')},
            {roles: ['LOKO', 'TRAINER', 'BUKO', 'EFB', 'KGA'], route: "report/location", id: 11, short: 'standortvergleich', name: $filter('translate')('REVIEW_STANDORTVERGLEICH')},
            {roles: ['BUKO', 'REKO', 'EFB', 'LOKO'], route: "report/closedchecks", id: 42, short: 'abgeschlossenehh', name: $filter('translate')('REVIEW_CLOSED_CHECKS')}
        ],
        controllingreview: [
            {roles: ['EFB', 'BUKO', 'REKO', 'LOKO', 'TRAINER'], route: "report/controlling/checkenergy", id: 37, short: 'controllingenergy', name: $filter('translate')('REVIEW_CONTROLLING_CHECKENERGY')},
            {roles: ['EFB', 'BUKO', 'REKO', 'LOKO', 'TRAINER'], route: "report/controlenergy", id: 34, short: 'controllingenergy', name: $filter('translate')('REVIEW_CONTROLLINGENERGIEDATEN')},
            {roles: user.right_report_controlling_list ? [] : ['ADMIN'], route: "report/controlling/controllingreport", id: 38, short: 'controllingreport', name: $filter('translate')('REVIEW_CONTROLLING_REPORT')},
        ],
        photovoltaicreview: [
            {roles: ['EFB', 'BUKO', 'REKO', 'LOKO', 'TRAINER'], route: "report/photovoltaic/check", id: 51, short: 'abgeschlossenehh', name: $filter('translate')('REVIEW_PHOTOVOLTAIC_CHECK')},
            {roles: ['EFB', 'BUKO', 'REKO', 'LOKO', 'TRAINER'], route: "report/photovoltaic/monitoring", id: 52, short: 'abgeschlossenehh', name: $filter('translate')('REVIEW_PHOTOVOLTAIC_MONITORING')},
        ],
        othersreview: []
    };

    /**
     * starts generating the report
     * will quickly show popup informing that it's in progress
     * won't wait until report is finished because some take really long
     *
     * @param data - usually [{column: "bla", value: 123}, ...]
     * @param doSendEmail bool send notification email when finished
     */
    service.createReview = function (data, doSendEmail) {

        var params = [{column: "doSendEmail", value: !!doSendEmail}].concat(data.filter);

        //timeout after 1 second, because reports can take really long to generate
        //client shouldn't listen
        apiService.post(data.route, params, {timeout: 1000, timeoutIsSuccess: true}).then(function () {
            $rootScope.$broadcast('updateReportList');
            ngDialog.open({
                template: 'templates/landingpage/ok_dialog.html' + "?v=" + window.version.tag,
                data: {
                    diagTitle: $filter('translate')('REVIEW_IS_GENERATING_TITLE'),
                    diagDescription: $filter('translate')('REVIEW_IS_GENERATING_TEXT'),
                    diagIcon: "fa-hourglass"
                }
            });
        }, function (error) {
            $rootScope.$broadcast('updateReportList');
            let text = $filter('translate')('REVIEW_ERROR_TEXT');
            if (!!error.error && error.error === 'memory_limit_exceeded') {
                text = $filter('translate')('REVIEW_ERROR_TEXT_MEMORY', {
                    estimate: Math.round(error.estimate / 1000000),
                    allowed: Math.round(error.allowed / 1000000)
                });
            }
            ngDialog.open({
                template: 'templates/landingpage/ok_dialog.html' + "?v=" + window.version.tag,
                data: {
                    diagTitle: $filter('translate')('FORM_ERROR_GENERIC'),
                    diagDescription: text,
                    diagIcon: "fa-exclamation-triangle"
                }
            });
        });
    };
    service.createPLZArea = function (data) {
        return apiService.post("report/preset/create", data);
    };
    service.deletePLZArea = function (ids) {
        return apiService.post("report/preset/delete", {ids: ids});
    };
    service.loadPlzList = function (ids) {
        return apiService.post("report/preset/read", ids);
    };
    service.loadPlzAreaList = function () {
        return apiService.post("report/preset/readPlzArea");
    };
    service.loadRegionStateLocationList = function (roleFilter) {
        var data = {};
        if (roleFilter) {
            roleFilter.push("ADMIN");
            data = {"role_filter": roleFilter};
        }
        return apiService.post("location/readforreport", data);
    };
    service.loadEmploymentTypeList = function () {
        return apiService.post("report/employment/read");
    };
    service.loadAkquiseList = function () {
        return apiService.post("report/akquise/read");
    };


    /**
     * are there reports that can be created. false if none are visible
     * @returns {boolean}
     */
    service.hasTabs = function() {
        var result = false;
        for(var i in options) {
            if(service.hasTab(i)) {
                return true;
            }
        }
        return false;
    };

    /**
     * are there reports that can be created within tab (e.g. "directhelpreview")
     * @param tabName
     * @returns {boolean}
     */
    service.hasTab = function(tabName) {
        return service.checkRightForReviewFunction(tabName).length > 0;
    };

    /**
     * returns reportinfo for a tab
     * @param tabName
     * @returns {any}
     */
    service.checkRightForReviewFunction = function (tabName) {
        var result = [];
        var userRoles = user.user_role;
        var tab, i, e, f;
        var isAdmin = false;
        for(i in userRoles) {
            if(userRoles[i].slug === "ADMIN") {
                isAdmin = true;
                break;
            }
        }

        for(i in options[tabName]) {
            var toAdd = [];
            if(options[tabName][i].roles.length === 0 || isAdmin) {
                toAdd = [true];
            } else {
                for(e in options[tabName][i].roles) {
                    var role = options[tabName][i].roles[e];
                    var negate = false;
                    if(role[0] === "!") {
                        negate = true;
                        role = role.slice(1);
                    }
                    var ruleResult = false;
                    for(f in userRoles) {
                        if(userRoles[f].slug === role) {
                            ruleResult = true;
                            break;
                        }
                    }
                    if(negate) {
                        ruleResult = !ruleResult;
                    }
                    toAdd.push(ruleResult);
                }
            }
            for(e in toAdd) {
                if(toAdd[e]) { //if one role true it will be returned
                    result.push(options[tabName][i]);
                    break;
                }
            }
        }
        return JSON.parse(JSON.stringify(result));
    };


    return service;
});


"use strict";
/**
 * @ngdoc directive
 * @name global.service:adminService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('multiselectService', function (reviewService) {

    var multiselect = {};
    var list = {dropdownRegion: [], dropdownState: [], dropdownLocation: []};
    var dataBundle;
    var groupName;
    var location_id = [];
    var quarter_id = [];
    var model = {region: [], state: [], location: [], quarter: []};


    multiselect.init = function () {
        list = {dropdownRegion: [], dropdownState: [], dropdownLocation: [], dropdownQuarter: []};
        dataBundle;
        groupName;
        location_id = [];
        model = {region: [], state: [], location: [], quarter: []};
    };

    multiselect.loadRegionStateLocationList = function (roleFilter) {
        reviewService.loadRegionStateLocationList(roleFilter).then(function (data) {
            dataBundle = data;
            list.dropdownRegion = multiselect.getDataFromList('region', data);
            list.dropdownState =  multiselect.UniqueArraybyId(multiselect.getDataFromList('state', data),"id");
            list.dropdownLocation = multiselect.getDataFromList('location', data);
            list.dropdownQuarter = multiselect.getDataFromList('quarter', data);
        });
        return list;
    };


    multiselect.UniqueArraybyId = function(collection, keyname) {
        var output = [],
            keys = [];

        angular.forEach(collection, function(item) {
            var key = item[keyname];
            if(keys.indexOf(key) === -1) {
                keys.push(key);
                output.push(item);
            }
        });
        return output;
    };

    multiselect.getDataFromList = function (column, data) {
        var array = [];

        switch (column) {
            case 'region':
                array = data;
                break;
            case 'state':
                angular.forEach(data, function (region) {
                    angular.forEach(region.state, function (state) {
                        array.push(state);
                    });
                });
                break;
            case 'location':
                angular.forEach(data, function (region) {
                    angular.forEach(region.state, function (state) {
                        angular.forEach(state.location, function (location) {
                            array.push(location);
                        });
                    });
                });
                break;
            case 'quarter':
                angular.forEach(data, function (region) {
                    angular.forEach(region.state, function (state) {
                        angular.forEach(state.location, function (location) {
                            angular.forEach(location.location_quarters, function (quarter) {
                                quarter.name = location.name + " - " + quarter.name;
                                quarter.region_id = region.id;
                                array.push(quarter);
                            });
                        });
                    });
                });
                break;
        }
        return array;
    };
    multiselect.checkIfIdIsIn = function (array, item) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].id === item.id)
            {
                return  true;
            }
        }
        return false;
    };
    multiselect.selectAllLocation = function (data) {
        model = data;
        model.state.splice(0);
        location_id.splice(0);
        model.region.splice(0);
        if (model.location.length !== list.dropdownLocation.length)
        {
            model.location.splice(0);
            angular.forEach(list.dropdownLocation, function (location) {
                location_id.push(location.id);
                model.location.push(location);
            });
            multiselect.checkHoleSelectedArray(dataBundle);
        } else {
            model.location.splice(0);
        }

        var select = {model: model, location_id: location_id};

        return select;
    };
    multiselect.checkHoleSelectedArray = function (data) {
        angular.forEach(data, function (region) {
            angular.forEach(region.state, function (state) {
                var count = 0;
                for (var i = 0; i < model.location.length; i++) {
                    if (multiselect.checkIfIdIsIn(state.location, model.location[i]))
                    {
                        count++;
                        if (state.location.length === count && !multiselect.checkIfIdIsIn(model.state, state))
                        {
                            model.state.push(state);
                        }
                    }
                }
            });
            var count = 0;
            for (var i = 0; i < model.state.length; i++) {
                if (multiselect.checkIfIdIsIn(region.state, model.state[i]))
                {
                    count++;
                    if (region.state.length === count && !multiselect.checkIfIdIsIn(model.region, region))
                    {
                        model.region.push(region);
                    }
                }
            }
        });

        return model;
    };
    multiselect.OnClickSelect = function (column, item, data, isSingleOnly) {
        if(isSingleOnly == undefined) isSingleOnly = false;
        model = data;
        switch (column) {
            case 'region':
                angular.forEach(item.state, function (state) {
                    if (!multiselect.checkIfIdIsIn(model.state, state) && !isSingleOnly)
                        model.state.push(state);
                    angular.forEach(state.location, function (location) {
                        if (!multiselect.checkIfIdIsIn(model.location, location) && !isSingleOnly)
                            model.location.push(location);
                        location_id.push(location.id);
                    });
                });
                break;
            case 'state':
                angular.forEach(item.location, function (location) {
                    if (!multiselect.checkIfIdIsIn(model.location, location) && !isSingleOnly)
                        model.location.push(location);
                    location_id.push(location.id);
                });
                break;
            case 'location':
                location_id.push(item.id);
                break;
            case 'quarter':
                quarter_id.push(item.id);
                break;
        }
        return {model: multiselect.checkHoleSelectedArray(dataBundle), location_id: location_id, quarter_id: quarter_id};
    };
    multiselect.OnRemoveSelect = function (column, item, data, isSingleOnly) {
        if(isSingleOnly == undefined) isSingleOnly = false;
        model = data;
        switch (column) {
            case 'region':
                angular.forEach(item.state, function (state) {
                    angular.forEach(state.location, function (location) {
                        angular.forEach(location_id, function (id, index) {
                            if (id === location.id && !isSingleOnly)
                            {
                                location_id.splice(index, 1);
                            }
                        });
                    });
                });
                break;
            case 'state':
                angular.forEach(item.location, function (location) {
                    angular.forEach(location_id, function (id, index) {
                        if (id === location.id && !isSingleOnly)
                        {
                            location_id.splice(index, 1);
                        }
                    });
                });
                break;
            case 'location':
                angular.forEach(location_id, function (id, index) {
                    if (id === item.id && !isSingleOnly)
                    {
                        location_id.splice(index, 1);
                    }
                });
                break;
            case 'quarter':
                for (var n = 0; n < quarter_id.length; n++) {
                    if (quarter_id[n] === item.id) {
                        quarter_id.splice(n, 1);
                        break;
                    }
                }
                break;
        }
        return {model: multiselect.deleteKaskade(column, item), location_id: location_id, quarter_id: quarter_id};
    };
    multiselect.deleteKaskade = function (column, item) {
        switch (column) {
            case 'region':
                var deleteItem = item;
                angular.forEach(deleteItem.state, function (state) {
                    angular.forEach(model.state, function (modelState, stateModelIndex) {
                        if (state.id === modelState.id)
                        {
                            model.state.splice(stateModelIndex, 1);
                        }
                    });
                    angular.forEach(state.location, function (location) {
                        angular.forEach(model.location, function (modelLocation, locationModelIndex) {
                            if (location.id === modelLocation.id)
                            {
                                model.location.splice(locationModelIndex, 1);
                            }
                        });
                    });
                });
                break;
            case 'state':
                angular.forEach(dataBundle, function (region) {
                    angular.forEach(region.state, function (state) {
                        if (state.id === item.id)
                        {
                            var deleteItem = region;

                            angular.forEach(model.region, function (region, regionModelIndex) {
                                if (deleteItem.id === region.id)
                                {
                                    model.region.splice(regionModelIndex, 1);
                                }
                            });
                            angular.forEach(deleteItem.state, function (state) {
                                if (state.id === item.id) {
                                    angular.forEach(state.location, function (location) {
                                        angular.forEach(model.location, function (modelLocation, locationModelIndex) {
                                            if (location.id === modelLocation.id)
                                            {
                                                model.location.splice(locationModelIndex, 1);
                                            }
                                        });
                                    });
                                }
                            });

                        }
                    });
                });
                break;
            case 'location':
                angular.forEach(dataBundle, function (region) {
                    angular.forEach(region.state, function (state) {
                        angular.forEach(state.location, function (location) {
                            if (location.id === item.id)
                            {
                                var deleteItem = region;

                                angular.forEach(model.region, function (region, regionModelIndex) {
                                    if (deleteItem.id === region.id)
                                    {
                                        model.region.splice(regionModelIndex, 1);
                                    }
                                });
                                angular.forEach(deleteItem.state, function (state) {
                                    angular.forEach(model.state, function (modelState, stateModelIndex) {
                                        if (state.id === modelState.id)
                                        {
                                            model.state.splice(stateModelIndex, 1);
                                        }
                                    });
                                });
                            }
                        });
                    });
                });
                break;
        }
        return(multiselect.checkHoleSelectedArray(dataBundle));
    };
    multiselect.groupByRegion = function (item) {
        angular.forEach(dataBundle, function (region) {
            angular.forEach(region.state, function (state) {
                if (multiselect.checkIfIdIsIn(state.location, item))
                {
                    groupName = region.name;
                }
            });
        });
        return groupName;
    };
    multiselect.quarterGroupByRegion = function (item) {
        var groupName = "";
        if (item.hasOwnProperty("region_id")) {
            angular.forEach(dataBundle, function (region) {
                if (region.id === item.region_id) {
                    groupName = region.name;
                }
            });
        }
        return groupName;
    };
    multiselect.groupByPlzNumberOne = function (item) {
        if (!item.id)
            return item.name.substring(0, 1);
        else
            return '--- Einzugsbereiche ---';
    };
    multiselect.groupFilterPLZ = ['--- Einzugsbereiche ---','0','1','2','3','4','5','6','7','8','9'];
    multiselect.checkSelection = function (item) {
        var listOfLocation = [];
        angular.forEach(dataBundle, function (region) {
            if (region.id === parseInt(item))
            {
                angular.forEach(region.state, function (state) {
                    angular.forEach(state.location, function (location) {
                        listOfLocation.push(location);
                    });
                });
            }

        });
        return listOfLocation;
    };
    multiselect.selectAll = function (data, selected) {
        var select = {rows: [], ids: []};
        if (data.length !== selected.length)
        {
            angular.forEach(data, function (row) {
                select.ids.push(row.id);
                select.rows.push(row);
            });
        }

        return select;
    };
    multiselect.readIdsFromList = function (list) {
        var ids = [];
        angular.forEach(list, function (row, index) {
            ids[index] = row.id;
        });
        return ids;
    };

    return multiselect;
});


"use strict";
/**
 * @ngdoc directive
 * @name global.service:exampleService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('regionService', function (apiService) {

    var service = {};

    service.deactivateRegion = function (id) {
        var data = {
            id: id,
            activate: false
        };
        return apiService.post("region/activate", data);
    };

    service.activateRegion = function (id) {
        var data = {
            id: id,
            activate: true
        };
        return apiService.post("region/activate", data);
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:organisationService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('organisationService', function (apiService) {

    var service = {};

    service.getOrganisation = function (data) {
        return apiService.post("organisation/read", data);
    };

    service.deactivateOrganisation = function (id) {
        var data = {
            id: id,
            activate: false
        };
        return apiService.post("organisation/activate", data);
    };

    service.activateOrganisation = function (id) {
        var data = {
            id: id,
            activate: true
        };
        return apiService.post("organisation/activate", data);
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:newsService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('newsService', function (apiService) {

    var service = {};

    service.deactivateNews = function (id) {
        var data = {
            id: id,
            activate: false
        };
        return apiService.post("news/activate", data);
    };

    service.activateNews = function (id) {
        var data = {
            id: id,
            activate: true
        };
        return apiService.post("news/activate", data);
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:exampleService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('locationService', function (apiService) {

    var service = {};

    service.getState = function ($regionId) {
        if($regionId) {
            return apiService.post("state/read", {region_id: $regionId});
        } else {
            return apiService.post("state/read");
        }
    };

    service.getRegion = function () {
        return apiService.post("region/readoptionlist");
    };

    service.getLocationByID = function (id) {
        return apiService.post("location/read", {id: id});
    };

    service.getLocation = function (id) {
        var data = {
            id: id
        };
        return apiService.post("location/readoptionlist", data);
    };

    service.deactivateLocation = function (id) {
        var data = {
            id: id,
            activate: false
        };
        return apiService.post("location/activate", data);
    };

    service.activateLocation = function (id) {
        var data = {
            id: id,
            activate: true
        };
        return apiService.post("location/activate", data);
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.directive:profilStreamFollowing
 * @scope
 * @restrict E
 *
 * @description
 * A description of the directive
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').directive('helpPopOver', function ($filter, $compile) {

    return {
        restrict: 'E',
        replace: true,
        scope: {
            help: '@'
        },
        link: function (scope, element, attrs) {
            var html = '<a class="help-padded-left" ng-click="$event.stopPropagation()" tabindex="-1" data-toggle="helpPopOver" data-content="' + $filter('translate')(scope.help) +
                '"><i class="fa fa-question fa-1 fa-border" aria-hidden="true"></i></a>';
            var el = $compile(html)(scope);
            element.append(el);

            $('[data-toggle="helpPopOver"]').popover({
                animation: true,
                placement: 'auto',
                trigger: 'focus',
                html: true
            });

        }
    };
});

"use strict";
/**
 * @ngdoc directive
 * @name global.service:adminService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('gridService', function (apiService, localStorageService) {

    var service = {};

    service.readData = function (route, data) {
        return apiService.post(route, data);
    };

    service.updateData = function (route, data) {
        return apiService.post(route, data);
    };

    service.checkVisible = function (field, grid) {
        var user = localStorageService.get('user');
        var counter = 0;

        //todo something more readable like this
        var rules = {
            //checks

            //user
            ssh: {
                trainer: ['!ADMIN', '!LOKO', '!TRAINER'],
                withoutdata: [],
                ssh: [],
                function: [],
                name: [],
                location: [],
                directhelp: []
            },

            //directhelp

            //location,...


            //kg



            bla: {}
        };


        var visible = {
            ADMIN: {
                //ssh: {withoutdata: false, ssh: false},
                //location: {telefon: false, directhelp: false, sshsum: false, sshactive: false},
                //hhexchange: {cash_up: false}
            },
            BUKO: {
                loko: {function: false},
                trainer: {function: false, withoutdata: false},
                ssh: {function: false, lastname: false, location: false, withoutdata: false, ssh: false},
                location: {function: false, telefon: false, sshsum: false, sshactive: false},
                directhelptyp: {actions: false},
                employmenttype: {function: false}
            },
            LOKO: {
                trainer: {function: false, location: false},
                ssh: {location: false},
                directhelptyp: {actions: false}
            },
            EFB: {
                ssh: {function: false, ssh: false},
                location: {ssh: false, directhelp: false},
                directhelptyp: {actions: false}
            },
            TRAINER: {
                ssh: {function: false},
                directhelptyp: {actions: false}
            },
            SSH: {
                ssh: {function: false},
                directhelptyp: {actions: false}
            },
            SSHPLUS: {
                directhelptyp: {actions: false}
            },
            REKO: {
                directhelptyp: {actions: false}
            }
        };

        var roleSlug, i;
        var doShow = true;
        for(i = 0; i < user.user_role_map.length; i++) {
            roleSlug = user.user_role_map[i].role.slug;

            if (visible[roleSlug] && visible[roleSlug][grid] !== undefined) {

                if(visible[roleSlug][grid]) {
                    return true;
                }
                doShow = false;

            } else {
                return true;
            }
        }

        return doShow;
    };

    return service;
});


"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:gridController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('gridController', function ($scope, $rootScope, $state) {

    //sits inside something that has in $scope:
    //getTableData()
    //gridApi

    $scope.failed = true; //not properly paginated data

    function update() {
        $scope.currentPage = $scope.gridApi.pagination.getPage();
        $scope.currentPageOrig = $scope.gridApi.pagination.getPage();
        $scope.totalPages = $scope.gridApi.pagination.getTotalPages();
        $("#uigrid_pagenavi_input")[0].value = $scope.currentPageOrig;

        $scope.failed = false;
        if(isNaN($scope.totalPages)) {
            $scope.failed = true;
        }
    }

    $scope.getTableData().then(function() {
        update();
        $scope.gridApi.pagination.on.paginationChanged($scope, update);
    });

    $scope.nextPage = function() {
        $scope.gridApi.pagination.nextPage();
    };
    $scope.previousPage = function() {
        $scope.gridApi.pagination.previousPage();
    };

    $scope.$on("gridLoaded", function (event, data) {
        $scope.gridApi.grid.element[0].getElementsByClassName("ui-grid-viewport")[1].scrollTop = 0;
    });

    $scope.goToPage = function(targetPageNr) {
        var $input = $("#uigrid_pagenavi_input");
        var pageInt = parseInt(targetPageNr);
        if(isNaN(pageInt) || pageInt === null || !pageInt || pageInt < 1 || pageInt > $scope.totalPages) {
            $input[0].blur();
            $input[0].value = $scope.currentPageOrig;
        } else {
            $scope.gridApi.pagination.seek(pageInt);
        }

    };
});

"use strict";

/*
https://www.malot.fr/bootstrap-datetimepicker/
http://momentjs.com/docs/#/parsing/

Do NOT use ng-change. use datepicker-change instead

Kinda messy because smalot-bootstrap-datetimepicker
is not designed to allow free keyboard input


*/
angular.module('frontendApp').directive("sscDatepicker", function (formService, $rootScope, moment, $timeout) {

    var modelFormats = {//format of model, so moment can parse it
        API_DAY: "YYYY-MM-DD",
        API_MINUTE: "YYYY-MM-DD HH:mm",
        API_SECOND: "YYYY-MM-DD HH:mm:ss"
    };
    var viewFormats = {//formats of datepicker, so datepicker can parse it
        DATEPICKER_DAY: "d.m.yyyy",
        DATEPICKER_MINUTE: "d.m.yyyy hh:ii"
    };
    var viewMomentFormats = {//formats of datepicker, so moment can parse it
        DATEPICKER_DAY: "D.M.YYYY",
        DATEPICKER_MINUTE: "D.M.YYYY HH:mm"
    };
    function translateFormat(format, formatsObj) {
        if(formatsObj[format]) {
            return formatsObj[format];
        }
        throw "datepicker - unsupported format";
    }
    function resolveMinView(datepickerFormat) {
        var search = [
            ["y", 4],//year
            ["m", 3],//month
            ["d", 2],//day
            ["h", 1],//hour
            ["i", 0],//minute
            ["s", 0]//second
        ];
        var min = 4;
        for(var i = 0; i < search.length; i++) {
            if(datepickerFormat.indexOf(search[i][0]) > -1) {
                min = search[i][1];
            }
        }
        return min;
    }
    function cleanupDatepickerDateObj(dateObj, minView) {
        var result = new Date(dateObj);
        //always strip milliseconds & seconds
        result.setMilliseconds(0);
        result.setSeconds(0);
        if(minView > 0) {//greater than minutes
            result.setMinutes(0);
        }
        if(minView > 1) {//greater than hours
            result.setHours(0);
        }
        if(minView > 2) {//greater than days
            result.setDate(1);
        }
        if(minView > 3) {//greater than months
            result.setMonth(0);
        }
        return result;
    }

    return{
        priority: 1,
        require: 'ngModel',
        scope: {
            datepickerChange: "&" //wasn't possible with ng-change
        },
        link: function ($scope, $element, $attrs, $ngModel) {
            $attrs.$set('type',"text");
            $attrs.$set('autocomplete',"off");
            $attrs.$set('placeholder', "z.B. " + moment().format(translateFormat($attrs.datepickerFormat, viewMomentFormats)));

            var $elem = $($element);
            $elem.addClass("ssc-datepicker");

            var newModelDateStr = false;
            var lastModelDateStr;

            var shakeTimeout;

            //init picker module
            var params = {
                format: translateFormat($attrs.datepickerFormat, viewFormats),
                weekStart: 1,
                language: "de-DE",
                todayBtn: "linked",
                bootcssVer: 3,
                pickerPosition: "top-right",
                autoclose: !0,
                startView: 2,
                minView: resolveMinView(translateFormat($attrs.datepickerFormat, viewFormats)),
                keyboardNavigation: false,
                forceParse: false
            };
            $elem.datetimepicker(params);

            //on date selected via UI picker
            $elem.on('changeDate', function (event) {
                var cleanDate = cleanupDatepickerDateObj(event.date, params.minView);
                if (this.value) {
                    lastModelDateStr = moment(cleanDate).format(translateFormat($attrs.datepickerModelFormat, modelFormats));
                    $ngModel.$setViewValue(lastModelDateStr);
                    updateRange(cleanDate);
                    $timeout(function() {
                        $scope.datepickerChange();
                    }, 20);
                }
            });

            $element.bind('blur', function () {
                if(newModelDateStr === false) {//no change
                    return;
                }
                if(newModelDateStr === "Invalid date") { //user typed in something invalid

                    //reset to last valid input

                    newModelDateStr = false;
                    var outStr = moment(lastModelDateStr, translateFormat($attrs.datepickerModelFormat, modelFormats)).format(translateFormat($attrs.datepickerFormat, viewMomentFormats));
                    if(lastModelDateStr === "" || lastModelDateStr === null || !lastModelDateStr) {
                        outStr = "";
                    }
                    $element[0].value = outStr;
                    $elem.datetimepicker('update'); //so datepicker has correct date preselected
                    updateRange(null);

                    //color red, and shake for one second
                    $elem.addClass("error error-shake");
                    clearTimeout(shakeTimeout);
                    shakeTimeout = setTimeout(function() {
                        $elem.removeClass("error error-shake");
                    }, 1000);

                    return;
                }

                //valid new input
                lastModelDateStr = newModelDateStr;
                newModelDateStr = false;
                $scope.datepickerChange();
            });


            function updateRange(dateObj) {
                //update to and from ranges
                if($attrs.datepickerType === "fromto") {
                    if ($attrs.datepickerEndId) {
                        if(dateObj !== null) {
                            $('#' + $attrs.datepickerEndId).datetimepicker('setStartDate', dateObj);
                        } else {
                            $('#' + $attrs.datepickerEndId).datetimepicker('setStartDate', new Date(-9000000000000)); //hack. null doesn't unset, despite what doc says
                        }
                    }
                    if ($attrs.datepickerStartId) {
                        if(dateObj !== null) {
                            $('#' + $attrs.datepickerStartId).datetimepicker('setEndDate', dateObj);
                        } else {
                            $('#' + $attrs.datepickerStartId).datetimepicker('setEndDate', new Date(9000000000000)); //hack. null doesn't unset, despite what doc says
                        }
                    }
                }
            }


            $ngModel.$parsers.push(function(viewDateStr) { //convert data from view format to model format

                //for whatever reason viewDateStr is sometimes formatted like the model when nothing has changed
                //will be ignored
                var modelToModelStr = moment(viewDateStr, translateFormat($attrs.datepickerModelFormat, modelFormats)).format(translateFormat($attrs.datepickerModelFormat, modelFormats));
                if(modelToModelStr === viewDateStr) { //view equals model - ignore
                    return viewDateStr;
                }

                //convert view to model
                var modelStr = moment(viewDateStr, translateFormat($attrs.datepickerFormat, viewMomentFormats), true).format(translateFormat($attrs.datepickerModelFormat, modelFormats));

                //if something has changed, make it known
                if(modelStr !== lastModelDateStr) {
                    newModelDateStr = modelStr;
                }

                //nonsense user input
                if(modelStr === "Invalid date") {
                    modelStr = lastModelDateStr;
                }

                //empty input
                if(viewDateStr.trim() === "") {
                    modelStr = null;
                    newModelDateStr = null;
                    updateRange(null);
                }

                var date = moment(modelStr, translateFormat($attrs.datepickerModelFormat, modelFormats)).toDate();
                updateRange(date);

                return modelStr;
            });

            $ngModel.$formatters.push(function (modelDateStr) { //convert data from model format to view format
                if(!modelDateStr) {
                    updateRange(null);
                    return modelDateStr;
                }

                var date = moment(modelDateStr, translateFormat($attrs.datepickerModelFormat, modelFormats)).toDate();
                updateRange(date);

                var momentDate = moment(date);

                var modelStr = momentDate.format(translateFormat($attrs.datepickerModelFormat, modelFormats));
                var viewStr = momentDate.format(translateFormat($attrs.datepickerFormat, viewMomentFormats));

                if(!lastModelDateStr) {
                    lastModelDateStr = modelStr;
                }

                $ngModel.$setViewValue(modelStr); //make it so model is correct format on loading
                                                    //and it can save correctly even if input not touched

                setTimeout(function() {
                    $elem.datetimepicker('update');
                },20);

                return viewStr;
            });
        }
    };
});

"use strict";

angular.module('frontendApp')

/* file uploads */
.directive("ngUploadChange",function(){
    return{
        scope:{
            ngUploadChange:"&"
        },
        link:function($scope, $element, $attrs){
            $element.on("change",function(event){
                $scope.$apply(function(){
                    $scope.ngUploadChange({$event: event})
                });
            });
            $scope.$on("$destroy",function(){
                $element.off();
            });
        }
    };
});

"use strict";

//angular.module('frontendApp')

//none - TODO

"use strict";

angular.module('frontendApp')

//Dezimaltrennzeichen
    .directive('forcePlus', ['$filter',
        function($filter) {
            return {
                restrict:'A',
                require: 'ngModel',
                link: function(scope, element, attrs, ngModelController) {

                    ngModelController.$formatters.push(function(data) {
                        //convert data from model format to view format

                        data=$filter('addPlus')(data);

                        return data;
                    });
                }
            };
        }
    ]).filter('addPlus', [
    function() {
        return function(input) {
            var ret;
            if(input && input[0] != "-" && input != "0,00000") {
                ret = "+" + input;
            }
            else ret = input;
            return ret;
        };
    }
]);
"use strict";

angular.module('frontendApp')

.directive("fieldAttributeManager",function(){
    return{
        //require: 'ngModel',field-attribute-manager
        
        link:function($scope, $element, $attrs){
            var debug = false; //orange=hide, purple=disabled
            var inputList = ["input", "select", "textarea"]; 
            var attrNeedle = ["propertieslabel","errorlabel"];
            var lastProperties=undefined;
            if(debug)console.log("fieldAttributeManager: loaded");
            
            //run main
            var run = function(propertyData){  
                if(debug)var start =new Date().getTime();

                if(propertyData && (JSON.stringify(propertyData) !== JSON.stringify(lastProperties)) ){
                    var properties = getProperties(propertyData);
                    handleInputs(properties);

                    //remember
                    lastProperties=propertyData;
                }
                
                if(debug){
                    var end=new Date().getTime();
                    console.log( (end-start)+"ms" ); //~5ms
                }
            };
           
            //property handles
            var handleProperties = function (element, iProperties, iPropertiesLast,pathValue) {
                //enable/disable/hide if needed
                var isHidden = false;   
                if (isPropertyHidden(iProperties) ) {//&& !isPropertyHidden(iPropertiesLast)
                    hideInputArea(element, true);
                    isHidden = true;
                    if (debug)console.log("hide:" + pathValue);
                } else {
                    //if (isPropertyHidden(iPropertiesLast)) {
                        hideInputArea(element, false);
                        isHidden = false;
                        if (debug)console.log("show:" + pathValue);
                    //}
                }
                if (!isHidden) {
                    if (isPropertyDisabled(iProperties) ) {//&& !isPropertyDisabled(iPropertiesLast)
                        disableInput(element, true);
                        if (debug)console.log("disable:" + pathValue);
                    } else {
                        //if (isPropertyDisabled(iPropertiesLast)) {
                           disableInput(element, false);
                           if (debug) console.log("enable:" + pathValue);
                        //}
                    }
                }
            };
            
            //handle inputs
            var handleInputs = function(properties){
                //search for inputs
                for (var iKey in inputList) {
                    var selector="";
                    for (var iAttr in attrNeedle) {
                        if(selector!==""){
                            selector+=",";
                        }
                        selector+="div ["+attrNeedle[iAttr]+"] "+inputList[iKey];
                    }
            
                    var htmlInputs = $($element).find(selector);
                    htmlInputs.each(function( index ) {
                        var element=$( this );
                        
                        //search attr
                        var pathValue = undefined;
                        for (var iAttr in attrNeedle) {
                            var pathValueTmp = $(this).parent().attr(attrNeedle[iAttr]);
                            if(!pathValueTmp){
                                //specials.. e.g. usersearch
                                pathValueTmp= $(this).parent().parent().attr(attrNeedle[iAttr]);
                            }
                            if(pathValueTmp){
                                pathValue=pathValueTmp;
                                break;//take first found
                            }
                        }

                        if(pathValue){     
                            //get properties for input
                            var iProperties = getPropertyForInput(pathValue,properties);
                            //var iPropertiesLast = getPropertyForInput(pathValue,lastProperties);
                            var iPropertiesLast = undefined;
                            //compare last with current properties
                            //if(JSON.stringify(iProperties) !== JSON.stringify(iPropertiesLast) ){//warum gleich?
                                handleProperties(element, iProperties, iPropertiesLast,pathValue);
                            //}
                        }
                    });
                } 
            };
            
            //get properties for input
            var getPropertyForInput = function (pathValue, properties) {
                var getData = function (obj, i) {
                    if (obj) {
                        return obj[i];
                    }
                };
                
                return pathValue.split('.').reduce(getData, properties);
            };
            
            //get properties
            var getProperties = function(propertyData){
                var properties = propertyData;
                
                if(!propertyData){
                    if(debug)console.log("fieldAttributeManager: propertyData not found.. using fallback via scope");
                    if($scope.required){
                        properties = $scope.required;
                    }
                }
                
                if(!properties){
                    console.error("fieldAttributeManager: no properties found");
                    return;
                }
                
                return properties;
            };

            //helper
            var hideInputArea = function(element,hide){   
                var target=element.closest("div.row");
                
                if(target.find(inputList.join()).length>1){
                    var targets = $([]);
                    targets = targets.add(element);
                    targets = targets.add(element.closest("div").prev());
                    targets = targets.add(element.closest("div").next());
                    target=targets;
                }

                if(hide){
                    if(debug){
                        target.css("background-color","#FF4000");  
                    }else{
                        //target.hide();
                        target.css("display", "none");
                    }   
                }else{
                    if(debug){
                        target.css("background-color","transparent");  
                    }else{
                        //target.show();
                        target.css("display", "");
                    }  
                }
                  
            };
            var disableInput = function(element,disable){
                if(disable){
                    if(debug){
                        element.closest("div.row").css("background-color","#B404AE");  
                    }else{
                        element.attr('disabled','disabled');
                    }  
                }else{
                    if(debug){
                        element.closest("div.row").css("background-color","transparent");  
                    }else{
                        if(element.attr('forcedisabled') || element.attr('data-forcedisabled')) {
                            element.attr('disabled','disabled');
                        } else {
                            element.removeAttr('disabled');
                        }
                    }  
                }
            };
            
            var isPropertyHidden = function(property){
                return (property && property.hidden); 
            };
            var isPropertyDisabled = function(property){
                return (property && property.disabled);
            };
           
            $scope.$on("onSscLoadComplete", function (event, propertyData) {
                
                if(debug)console.log("got onSscLoadComplete broadcast");

                window.setTimeout(function(propertyData){
                    if(debug)console.log("fieldAttributeManager: run via onSscLoadComplete");
                    run(propertyData);
                },0,propertyData); 
            });
        }
        
    };
});

"use strict";
/*
adds a class faster than ng-class - which only hast priority 0
only done initially. does not watch for changes

usage
<div fastaddclass="shouldAddClass ? 'classname' : ''"></div>
-> adds value of fastaddclass as class

*/
angular.module('frontendApp').directive('fastaddclass', function() {
    return {
        restrict: 'A',
        priority: 600,
        scope: {
            fastaddclass: '='
        },
        link: function(scope, element, attrs) {
            element.addClass(scope.fastaddclass);
        }
    };
});
"use strict";

angular.module('frontendApp')

//Dezimaltrennzeichen
        .directive('decimalSeparatorGerman', ['$filter',
            function ($filter) {
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    link: function (scope, element, attrs, ngModelController) {
                        ngModelController.$parsers.push(function (data, attrs) {
                            //convert data from view format to model format
                            data = $filter('comma2decimal')(data);

                            return data;
                        });

                        ngModelController.$formatters.push(function (data) {
                            //convert data from model format to view format
                            var precision = attrs.precision;
                            if(precision === undefined || precision === null) precision = 0;
                            data = $filter('decimal2comma')(data,attrs.precision);
                            return data;
                        });
                    }
                };
            }
        ]).filter('comma2decimal', [
    function () {
        return function (input) {
            var ret = (input) ? input.toString().trim().replace(",", ".") : null;
            ret = parseFloat(ret);
            if (!isNaN(ret)) {
                return ret;
            }
            return input;
        };
    }
]).filter('decimal2comma', [
    function () {
        return function (input,precision) {
            if(!precision)
                precision = 0;
                
            if( !(input || input === "0" || input === 0) )
                return null;
             
            var result = parseFloat(input).toFixed(precision);
            return result.toString().replace(".", ",");
        };
    }
])
.filter('decimal2currency', [
    function () {
        return function (input) {
            var value = (input) ? parseFloat(Math.round(input * 100) / 100).toFixed(2) : null;
            var  result = (value) ? value.toString().replace(".", ",") : null;
            if (result) {
                var split = result.split(",");
                if (split.length > 1) {
                    var wholeDecimal = "" + split[0];
                    var fractDecimal = "" + split[1];

                    //remove trailing zeros
                    fractDecimal = fractDecimal.replace(/0+$/, "");
                    if (fractDecimal.length > 0) {
                        if (fractDecimal.length === 1) {
                            fractDecimal += "0";
                        }
                        result = wholeDecimal + "," + fractDecimal;
                    } else {
                        result = wholeDecimal;
                    }
                }
            }
            return result;
        };
    }
]);
"use strict";

//DEPRECATED, use ssc-datepicker instead
angular.module('frontendApp')
.directive("datepicker", function (formService, $rootScope) {
    return{
        priority: 1,
        require: 'ngModel',
        datepickerNoautosave: "@",
        link: function ($scope, $element, $attrs, $ngModel) {
            console.log("deprecated datepicker");
            var $elem = $($element);

            var params = {
                format: "dd.mm.yyyy",
                weekStart: 1,
                language: "de-DE",
                todayBtn: "linked",
                bootcssVer: 3,
                pickerPosition: "top-right",
                autoclose: !0,
                startView: 'month',
                minView: 'month'
            };

            /*if($elem[0].id){
                if ($elem[0].id === "startdate" || $elem[0].id === "enddate" || $elem[0].id === "begin" || $elem[0].id === "end") {
                    params.startDate = "+0d";
                }
            }*/

            $elem.datetimepicker(params);

            $elem.on('change', function (event) {
                //sry leute, keine idee mehr wie ich das umgehen soll
                var naFIXME=false;
                if($attrs.fixme=="true"){
                    $ngModel.$setViewValue(this.value);
                    naFIXME=true;
                }

                if(!naFIXME){
                    var date = formService.newDate(this.value);
                    var writtenManually = false;

                    if ($elem[0].id === "begin") {
                        $scope.model.date_begin = formService.formatDate(date, formService.getApiDateFormatMinute());
                         console.log($scope.model.date_begin);
                        if (date) {
                            var date = new Date(date);
                            $('#end').datetimepicker('setStartDate', date);
                        }
                    }

                    if ($elem[0].id === "end") {
                        $scope.model.date_end = formService.formatDate(date, formService.getApiDateFormatMinute());
                        console.log($scope.model.date_end);
                        if (date) {
                            var date = new Date(date);
                            $('#begin').datetimepicker('setEndDate', date);
                        }
                    }

                    if ($elem[0].id === "startdate") {
                        $scope.model.valid_from = formService.formatDate(date, formService.getApiDateFormatMinute());
                         console.log($scope.model.valid_from);
                        if (date && $('#enddate').length === 0) {
                            var date = new Date(date);
                            $('#enddate').datetimepicker('setStartDate', date);
                        }
                    }

                    if ($elem[0].id === "enddate") {
                        $scope.model.valid_until = formService.formatDate(date, formService.getApiDateFormatMinute());
                         console.log($scope.model.valid_until);
                        if (date && $('#enddate') === 0) {
                            var date = new Date(date);
                            $('#startdate').datetimepicker('setEndDate', date);
                        }
                    }

                    if ($elem[0].id === "from") {
                        $rootScope.from = formService.formatDate(date, formService.getApiDateFormatDay());
                        if (date) {
                            var date = new Date(date);
                            $('#to').datetimepicker('setStartDate', date);
                        }
                    }

                    if ($elem[0].id === "to") {
                        $rootScope.to = formService.formatDate(date, formService.getApiDateFormatDay());
                        if (date) {
                            var date = new Date(date);
                            $('#from').datetimepicker('setEndDate', date);
                        }
                    }
                    if ($elem[0].id === "fromtwo") {
                        $rootScope.fromtwo = formService.formatDate(date, formService.getApiDateFormatDay());
                        if (date) {
                            var date = new Date(date);
                            $('#totwo').datetimepicker('setStartDate', date);
                        }
                    }

                    if ($elem[0].id === "totwo") {
                        $rootScope.totwo = formService.formatDate(date, formService.getApiDateFormatDay());
                        if (date) {
                            var date = new Date(date);
                            $('#fromtwo').datetimepicker('setEndDate', date);
                        }
                    }



                    //create household
                    if ($elem[0].id === "firstvisit") {
                        var dateStr = formService.formatDate(date, formService.getApiDateFormatDay());
                        $scope.data.ssc.first_visit_at = dateStr;
                        writtenManually = true;
                        if (date) {
                            var date = new Date(date);
                            $('#secondvisit').datetimepicker('setStartDate', date);
                        }
                    }
                    if ($elem[0].id === "secondvisit") {
                        var dateStr = formService.formatDate(date, formService.getApiDateFormatDay());
                        $scope.data.ssc.second_visit_at = dateStr;
                        writtenManually = true;
                        if (date) {
                            var date = new Date(date);
                            $('#firstvisit').datetimepicker('setEndDate', date);
                        }
                    }


                    if(!writtenManually) {
                        $ngModel.$setViewValue(date);
                    }
                }

                var eventFake = {
                    target: {
                        attributes: [
                            {name: 'ng-model', nodeValue: $attrs.ngModel}]
                    }
                };
                if (!$attrs.datepickerNoautosave || $attrs.datepickerNoautosave == 'false') {
                    $scope.save(eventFake);
                }
            });
        }
    };
});

"use strict";

angular.module('frontendApp')

//Dezimaltrennzeichen
        .directive('dateformat', ['$filter',
            function ($filter) {
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    scope: {
                        datetype: '@'
                    },
                    link: function (scope, element, attrs, ngModelController) {
                        ngModelController.$parsers.push(function (data) {
                            //convert data from view format to model format
                            data = $filter('format2model')(data, scope.datetype);
                            return data;
                        });

                        ngModelController.$formatters.push(function (data) {
                            //convert data from model format to view format
                            data = $filter('model2format')(data, scope.datetype);
                            return data;
                        });
                    }
                };
            }
        ]).filter('format2model', [
    function () {
        return function (input) {
            if (typeof input === 'string' || input instanceof String) {
                var dateSpl = input.split(".");
                if (dateSpl.length === 3) {
                    return dateSpl[2] + "-" + dateSpl[1] + "-" + dateSpl[0];
                }
            }
        };
    }
]).filter('model2format', ['formService', function(formService) {
    return function (input, datetype) {
        return formService.dateModel2Format(input, datetype);
    };
}]);
"use strict";
angular.module('frontendApp').filter('capitalize', function() {
    return function(input) {
        return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
    }
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:formService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('formService', function ($filter, apiService) {

    var service = {};
    //service.check - returns: true check passed, false check failed
    service.check = function (required, model) {
        if (model == undefined || required == undefined) {
            return false;
        }

        var passedCheck = true;
        angular.forEach(required, function (requireValue, requireKey) {
            if (requireValue && passedCheck) {
                if (model[requireKey] === "" || model[requireKey] == undefined) {
                    passedCheck = false;                    
                }
            }
        });
        return passedCheck;
    };
    service.getApiDateFormatDay = function () {
        return "yyyy-MM-dd";
    };
    service.getApiDateFormatMinute = function () {
        return "yyyy-MM-dd HH:mm";
    };
    service.toApiDate = function (inputStr) {        
        return service.formatDate(inputStr, 'yyyy-MM-dd HH:mm:ss');
    };
    service.toInputDate = function (inputStr) {
        return service.formatDate(inputStr, 'yyyy-MM-dd HH:mm');
    };
    //returns date formatted, or "" if something went wrong
    service.formatDate = function (inputStr, format) {
        if (!inputStr) {
            return '';
        }
        var result = $filter('date')(new Date(inputStr), format);
        if (typeof result !== "string") {
            return "";
        }
        return result;
    };
    service.newDate = function (input) {
        var mainComponents = input.split(" ");
        var dateComponents = mainComponents[0].split(".");
        return dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0] + " 00:00";
    };

    service.newDateMinute = function (input) {        
        var mainComponents = input.split(" ");
        var dateComponents = mainComponents[0].split(".");
        var timeComponents = mainComponents[1].split(":");
        if(dateComponents[1].length === 1) {
            dateComponents[1] = "0" + dateComponents[1];
        }
        if(dateComponents[0].length === 1) {
            dateComponents[0] = "0" + dateComponents[0];
        }
        return dateComponents[2] + "-" + dateComponents[1] + "-" + dateComponents[0] + " " + timeComponents[0] + ":" + timeComponents[1];
    };

    service.dateModel2Format = function(input, datetype) {
        if (!input)
            return input;

        var mainComponents = input.split(" ");
        var dateComponents = mainComponents[0].split("-");
        if (mainComponents.length > 1) {
            var timeComponents = mainComponents[1].split(":");

            if (datetype == "second")
                return dateComponents[2] + "." + dateComponents[1] + "." + dateComponents[0] + " " + timeComponents[0] + ":" + timeComponents[1] + ":" + timeComponents[2];
            if (datetype == "minute")
                return dateComponents[2] + "." + dateComponents[1] + "." + dateComponents[0] + " " + timeComponents[0] + ":" + timeComponents[1];
        }
        return dateComponents[2] + "." + dateComponents[1] + "." + dateComponents[0];
    };

    service.formatGrid = function (data, cols, headcol) {
        angular.forEach(data, function (row) {
            angular.forEach(cols, function (col) {
                if (headcol === 'directhelp_price')
                {
                    if (row[headcol] && row[headcol].length !== 0)
                    {
                        var mainComponents = row[headcol][0][col].split(" ");
                        var dateComponents = mainComponents[0].split("-");
                        row[headcol][0][col] = dateComponents[2] + "." + dateComponents[1] + "." + dateComponents[0];
                    }
                } else {
                    if (row[col]) {
                        var mainComponents = row[col].split(" ");
                        var dateComponents = mainComponents[0].split("-");
                        var timeComponents = mainComponents[1].split(":");
                        if(headcol === 'news')
                        {
                           row[col] = dateComponents[2] + "." + dateComponents[1] + "." + dateComponents[0] + " " + timeComponents[0] + ":" + timeComponents[0]; 
                        }
                        else{
                            row[col] = dateComponents[2] + "." + dateComponents[1] + "." + dateComponents[0];
                        }
                    }
                }
            });
        });
        return data;
    }
    
    service.sendTest = function(data){
        return apiService.post("exchange/testit/time", data);
    }


    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name footerService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('footerService', function($q, $http, api, ngDialog) {
    var service = {};

    var $footer, $footerParent, $offset;

    service.reload = function() {
        $footer = $("#sscFooter");
        $footerParent = $footer.parent();
        $offset = $("#footeroffset");
    };
    service.reload();
    function update() {
        var pageHeight = $footerParent.offset().top;
        var fillHeight = Math.floor(Math.max(0, window.innerHeight - pageHeight - $footer.outerHeight()));

        $offset.css("height", fillHeight);
    }
    update();
    setInterval(update, 25);

    return service;
});
"use strict";
/**
 * @ngdoc controller
 * @name footer controller
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('footerController', function ($scope, $element, footerService){
    footerService.reload();
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:deploymenttypeService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('employmenttypeService', function (apiService) {

    var service = {};

    service.deactivateDeploymenttype = function (id) {
        var data = {
            id: id,
            activate: false
        };
        return apiService.post("employmenttype/activate", data);
    };

    service.activateDeploymenttype = function (id) {
        var data = {
            id: id,
            activate: true
        };
        return apiService.post("employmenttype/activate", data);
    };

    return service;
});
"use strict";
/**
 * @ngdoc directive
 * @name global.service:directhelpService
 * @scope
 * @restrict E
 *
 * @description
 * A description of the service
 *
 * @param {object}  field   A field object
 *
 */

angular.module('frontendApp').factory('directhelpService', function (apiService) {

    var service = {};

    service.readDirecthelptyp = function () {
        return apiService.post("directhelptype/read");
    };

    service.readDirecthelptypWithoutArchiv = function () {
        return apiService.post("directhelptype/readtype");
    };

    service.deactivateDirecthelp = function (id) {
        var data = {
            id: id,
            activate: false
        };
        return apiService.post("directhelp/activate", data);
    };

    service.activateDirecthelp = function (id) {
        var data = {
            id: id,
            activate: true
        };
        return apiService.post("directhelp/activate", data);
    };

    service.archiveDirecthelp = function (id) {
        return apiService.post("directhelp/archive", {id: id});
    };

    service.readViaLocation = function(data) {
        return apiService.post("directhelp/readViaLocation", data);
    };


    return service;
});
"use strict";
angular.module('frontendApp')

    .value('cookieLawName', '_cle')
    .value('cookieLawAccepted', 'accepted')
    .value('cookieLawDeclined', 'declined')
    .value('cookieVersionReloadName', '_vsRld');
"use strict";
angular.module('frontendApp')

    .factory('CookieService', function () {
      var readCookie = function (key) {
        var nameEQ = key + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }

      var get = function (key) {
        return readCookie(key);
      };

      var set = function (key, value) {
        document.cookie = key + '=' + value;
      };

      return {
        get: get,
        set: set
      }
    });
"use strict";
angular.module('frontendApp')

    .factory('CookieLawService', [
      'CookieService',
      'cookieLawName',
      'cookieLawAccepted',
      'cookieLawDeclined',
      function (CookieService, cookieLawName, cookieLawAccepted, cookieLawDeclined) {
        var accept = function (expireDate) {
          CookieService.set(cookieLawName, cookieLawAccepted + ';expires=' + expireDate);
        };

        var decline = function () {
          CookieService.set(cookieLawName, cookieLawDeclined);
        };

        var isEnabled = function () {
          return CookieService.get(cookieLawName) === cookieLawAccepted;
        };

        return {
          accept: accept,
          decline: decline,
          isEnabled: isEnabled
        };
      }]);
"use strict";


angular.module('frontendApp').factory('apiService', function ($http, api, $q, xsrfTokenService) {
    var service = {};


    service.post = function(route, data, config) {
        var deferred = $q.defer();
        xsrfTokenService.getToken().then(function () {
            $http.post(api.root + route, data, config)
                .success(function (data, status) {
                    deferred.resolve(data.data);
                })
                .error(function (error) {
                    deferred.reject(error);
                });
        });

        return deferred.promise;
    };
    
    /**
     * 
     * @param obj header
     * @returns filename or null
     */
    function getFilenameFromContentDisposition(header) {
        var filename = null;
        var disposition = header["content-disposition"];
        if (disposition && disposition.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
        }
        return filename;
    }
    
    service.postArraybuffer = function(route, data) {
        var deferred = $q.defer();

        $http.post(api.root + route, data, {responseType:'arraybuffer'})
            .success(function (data, status, headersGetter, config) {
                var filename = getFilenameFromContentDisposition(headersGetter());
                deferred.resolve({data: data, filename: filename});
            })
            .error(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };
    
    service.get = function(route, data) {
        var deferred = $q.defer();

        $http.get(api.root + route, data)
            .success(function (data, status) {
                deferred.resolve(data.data);
            })
            .error(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    return service;
});
"use strict";
/**
 * @ngdoc provider
 * @name global.provider:ApiInterceptor
 * @scope
 * @restrict E
 *
 * @description
 * Interceptor is injected into angulars $http-service and is able to check/control all requests/repsonses
 * between front- and backend
 *
 */
angular.module('frontendApp').config(function ($httpProvider) 
{
    $httpProvider.interceptors.push(function ($q, CookieService, cookieVersionReloadName) 
    {
        return {
            response: function (response)
            {
                var deferred = $q.defer();
                var version = response.headers('Version');
                    
                // console.log("checking Versions:");
                // console.log("  ETag          : "+version);
                // console.log("  window.version: "+window.version.tag);
                // console.log("  Cookie version: "+CookieService.get(cookieVersionReloadName));
                
                // check window.version.tag, version and last reload cookie to prevent endless loop
                deferred.resolve(response);
                if (!window.version || !window.version.tag || !version ||
                    window.version.tag === version || 
                    (CookieService.get(cookieVersionReloadName) === version)) 
                {            
                    // console.log("checking Versions: RESOLVE");
                    deferred.resolve(response);
                } 
                else
                {   
                    // console.log("checking Versions: RELOAD");
                    if(CookieService.get(cookieVersionReloadName) !== null)
                    {
                        var expireDate = new Date();
                        expireDate.setDate(expireDate.getDate() -1);
                        //remove existing cookie
                        CookieService.set(cookieVersionReloadName, ';expires=' + expireDate);
                    }
                    window.location.reload();
                    //set cookie with last loaded version to prevent reload loop - expires after 24h
                                    
                    var expireDate = new Date();
                    expireDate.setDate(expireDate.getDate() + 1);
                    CookieService.set(cookieVersionReloadName, version + ';expires=' + expireDate);
                }
                return deferred.promise;
            }
        };
    });   
});
"use strict";
angular.module('frontendApp').config(['$translateProvider', '$provide',
    function($translateProvider){
        
        $translateProvider.useStaticFilesLoader({
            prefix: 'resources/i18n/locale-',
            suffix: '.json'
        });
        $translateProvider.useLocalStorage();
        $translateProvider.fallbackLanguage('de_DE');
        $translateProvider.preferredLanguage('de_DE');
       $translateProvider.useSanitizeValueStrategy('escapeParameters');
    }
]);
"use strict";
/**
* @ngdoc directive
* @name global.directive:languageSelect
* @scope
* @restrict E
*
* @description
* A description of the directive
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').directive('languageSelect', function ($translate) {
    return { 
        restrict: 'E',
        replace: true,
        templateUrl: 'templates/components/core/language/language.view.html' + "?v=" + window.version.tag,
        controller: 'languageController'
    } 
});
"use strict";
/**
 * @ngdoc controller
 * @name dashboard.controller:languageController
 * @description
 * A description of the controller, service or filter
 */

angular.module('frontendApp').controller('languageController', function ($scope, $rootScope, $translate) {

    $scope.locale = $translate.proposedLanguage() || $translate.use();

    $scope.changeLang = function (key) {
        $translate.use(key).then(function (key) {
          $scope.locale = $translate.use();
        }, function (key) {
          console.log("Sprache konnte nicht gewechselt werden.");
        });
    };
});
"use strict";
angular.module('frontendApp').factory('xsrfTokenService', function ($http, api, $rootScope, $q) {
    var service = {};

    service.getToken = function () {
        var deferred = $q.defer()
        if (!$rootScope.xsrfTokenValid) {
            $http.get(api.root + 'public/csrf-cookie').then(function () {
                $rootScope.xsrfTokenValid = true;
                deferred.resolve();
            });
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    }

    return service;
});
"use strict";
/**
* @ngdoc directive
* @name global.service:registerService
* @scope
* @restrict E
*
* @description
* A description of the service
*
* @param {object}  field   A field object
*
*/
    
angular.module('frontendApp').config(function ($authProvider, api) {
	
    $authProvider.loginUrl = api.root + 'public/login';
    $authProvider.signupUrl = api.root + 'public/signup';
});
"use strict";
/**
 * @ngdoc provider
 * @name global.provider:ApiInterceptor
 * @scope
 * @restrict E
 *
 * @description
 * Interceptor is injected into angulars $http-service and is able to check/control all requests/repsonses
 * between front- and backend
 *
 */

angular.module('frontendApp').config(function ($httpProvider) {
    $httpProvider.interceptors.push(function (localStorageService, $state, $injector, $q, $rootScope, PermRoleStore, $cookies) {
        var logout = function () {
            localStorageService.remove('user');
            $rootScope.authenticated = false;
            $rootScope.currentUser = null;
            PermRoleStore.clearStore();
            $state.go('login');
        };


        var handleResponse = function (response) {
            if ($rootScope.isInMaintenance && !$rootScope.blockedByMaintenance && $cookies.get('maintenanceKey') !== "t4m") {
                $rootScope.blockedByMaintenance = true;
                logout();
                return $q.reject(response);
            }

            //treat timeout as success
            if (response.status === -1 && response.config.timeoutIsSuccess) {
                response.status = 200;
                response.data = {data: null};
            }
            if (response.status === 204) {
                response.status = 200;
                response.data = {data: null};
            }
            //no error -> success
            if (response.status < 400 && response.data && response.data.error == null) {
                return $q.resolve(response);
            }
            //error
            launchErrorParticle();

            if (!response.data) {
                return $q.reject(response);
            }
            if (response.status === 419) {
                $rootScope.xsrfTokenValid = false;
                logout();
                return $q.reject(response);
            }

            switch (response.data.error) {
                case "token_invalid":
                case "unauthenticated":
                case "token_not_provided":
                case "token_expired":
                case "user_not_found":
                    logout();
                    break;
                case "insufficent_rights":
                    $state.go('denied');
                    break;
                case "file not found":
                    alert('here');
                    $state.go('exchange.archiv');
                    break;
            }
            return $q.reject(response);
        };

        //disable input fields during loading
        //and show loading animation (spinner) in top left
        var requestCount = 0;
        var $spinner;
        var styleRule = "input, select, textarea, .checklabel, .checklabelText, .createdropper, .disableduringload, .search, .ssc-ui-select { pointer-events: none; opacity: 0.4; user-select: none; }";
        var $styleTag = $("<div />", {
            html: '&shy;<style>' + styleRule + '</style>'
        });
        var updateRequestCount = function (val) {
            var oldCount = requestCount;
            requestCount += val;

            if (oldCount === 0 && requestCount > 0) {
                $spinner = $("#isRequestingSpinner");
                $spinner.addClass("isRequestingSpinnerShow");

                $styleTag.appendTo("body");
            }
            if (oldCount > 0 && requestCount === 0) {
                $spinner = $("#isRequestingSpinner");
                $spinner.removeClass("isRequestingSpinnerShow");

                $styleTag.detach();
            }
        };

        return {
            // all request made by $http
            'request': function (config) {
                if (!config.inBackground) {
                    updateRequestCount(1);
                }
                // try to find token in localStorage
                var user = localStorageService.get('user');
                if (user && !config.data) {
                    config.data = {};
                }
                return config;
            },

            'response': function (response) { //http success
                if (!response.config.inBackground) {
                    updateRequestCount(-1);
                }
                return handleResponse(response);
            },
            'responseError': function (response) { //http error
                if (!response.config.inBackground) {
                    updateRequestCount(-1);
                }
                return handleResponse(response);
            },
            'requestError': function (response) {
                if (!response.config.inBackground) {
                    updateRequestCount(-1);
                }
            }
        };
    });

    /**
     * triggers an animation for http request errors next to the top left loading spinner
     */
    function launchErrorParticle() {
        var transitionTime = 500;
        var waitTime = 500;
        var $particle = $("<div class='isRequestingSpinnerParticle'><i class=\"fa fa-exclamation-triangle\"></i></div>");
        $particle[0].style.top = "20px";
        $('body').append($particle);
        setTimeout(function () {
            $particle[0].style.opacity = 1;
            $particle[0].style.top = "45px";
        }, 20);
        setTimeout(function () {
            $particle[0].style.opacity = 0;
            $particle[0].style.top = "70px";
        }, transitionTime + waitTime + 20);
        setTimeout(function () {
            $particle.remove();
        }, transitionTime + waitTime + transitionTime + 40);
    }
});
   

angular.module('frontendApp').config(['$stateProvider', '$urlRouterProvider', '$locationProvider',
    function ($stateProvider, $urlRouterProvider, $locationProvider) {
        
        $urlRouterProvider.deferIntercept();  // <- necessary! We let urlRouter wait so we can resolve permissions 1st! .. sync at end of file
        $locationProvider.html5Mode(true).hashPrefix('!');

        $urlRouterProvider.otherwise(function ($injector) {
            var $state = $injector.get("$state");
            $state.go('404');
        });

        // -----------------------------------------------------
        // Routes
        // -----------------------------------------------------
        $stateProvider
            .state('login', {
                url: "/",
                params: {
                    verified: null
                },
                views: {
                    "": {
                        templateUrl: "templates/layouts/100.html" + "?v=" + window.version.tag
                    },
                    "header@login": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "full@login": {
                        templateUrl: "templates/static/login.html" + "?v=" + window.version.tag
                    },
                    "footer@login": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Login'
                },
                onEnter: function ($rootScope, $state) {
                    if ($rootScope.authenticated) {
                        $state.go("home");
                    }
                }
            })
            .state('forgotpass', {
                url: "/forgotpass",
                params: {
                    verified: null
                },
                views: {
                    "": {
                        templateUrl: "templates/layouts/100.html" + "?v=" + window.version.tag
                    },
                    "header@forgotpass": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "full@forgotpass": {
                        templateUrl: "templates/static/forgotpass.html" + "?v=" + window.version.tag
                    },
                    "footer@forgotpass": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Password vergessen'
                },
                onEnter: function ($rootScope, $state) {
                    if ($rootScope.authenticated) {
                        $state.go("home");
                    }
                }
            })
            .state('passwordReset', {
                url: "/passwordreset/:token",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100.html" + "?v=" + window.version.tag
                    },
                    "header@passwordReset": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "full@passwordReset": {
                        template: "<reset-password></reset-password>"
                    },
                    "footer@passwordReset": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Password vergessen'
                },
                onEnter: function ($rootScope, $state) {                    
                }
            })
            
            .state('home', {
                url: "/home",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100-100.html" + "?v=" + window.version.tag
                    },
                    "header@home": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "breadcrumb@home": {
                        template: "<div ncy-breadcrumb></div>"
                    },
                    "menu@home": {
                        template: "<mainmenu></mainmenu>"
                    },
                    "full@home": {
                        templateUrl: "templates/static/home.html" + "?v=" + window.version.tag
                    },
                    "footer@home": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Home'
                },
                onEnter: function (userService, $state) {
                    if (userService.forceTwoFactorAuth()) {
                        $state.go("twoFactorAuth");
                    }
                },
                data: {
                    permissions: {
                        except: ['UNVERIFIED'],
                        redirectTo: 'requireNewPw'
                    }
                }
            })
            .state('requireNewPw', { //force new pw - first login
                url: "/neuesPasswort",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100.html" + "?v=" + window.version.tag
                    },
                    "header@requireNewPw": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "full@requireNewPw": {
                        templateUrl: "templates/static/requireNewPw.html" + "?v=" + window.version.tag
                    },
                    "footer@requireNewPw": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                }
            })
            .state('twoFactorAuth', {
                url: "/2fa",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100.html" + "?v=" + window.version.tag
                    },
                    "header@twoFactorAuth": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "full@twoFactorAuth": {
                        templateUrl: "templates/static/createTwoFactor.html" + "?v=" + window.version.tag
                    },
                    "footer@twoFactorAuth": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                }
            })
            ////////////////////// Stromspar-Check
            //////////////////////////////
            .state('ssc', {
                url: "/stromspar-check",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100-100.html" + "?v=" + window.version.tag
                    },
                    "header@ssc": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "breadcrumb@ssc": {
                        template: "<div ncy-breadcrumb></div>"
                    },
                    "menu@ssc": {
                        template: "<mainmenu></mainmenu>"
                    },
                    "full@ssc": {
                        templateUrl: "templates/static/ssc/ssc.html" + "?v=" + window.version.tag
                    },
                    "footer@ssc": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                redirectTo: 'ssc.overview',
                ncyBreadcrumb: {
                    label: 'Beratungen'
                },
                 onEnter: function (userService, $state) {
                    if (userService.forceTwoFactorAuth()) {
                        $state.go("twoFactorAuth");
                    }
                },
                data: {
                    permissions: {
                        except: ['UNVERIFIED'],
                        redirectTo: 'requireNewPw'
                    }
                }
            })
            .state('ssc.overview', {
                params: {
                    status: null
                },
                views: {
                    "full": {
                        templateUrl: "templates/static/ssc/ssc.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Übersicht'
                }
            })
            .state('ssc.log', {
                url: "/log/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/ssc/log/log.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Logverlauf'
                }
            })

            .state('ssc.check', {
                url: "/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/ssc/sscoverview/sscoverview.html" + "?v=" + window.version.tag
                    },
                },
                ncyBreadcrumb: {
                    label: 'Übersicht'
                }
            })
            .state('ssc.create', {
                url: "/erstellen",
                views: {
                    "full": {
                        templateUrl: "templates/static/ssc/household/create/create.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Haushalt anlegen'
                }
            })
            .state('ssc.deletion_requests', {
                url: "/loeschantraege",
                params: {
                    status: null
                },
                views: {
                    "full": {
                        template: "<tabmenudeletionrequests></tabmenudeletionrequests>"
                    }
                },
                ncyBreadcrumb: {
                    label: 'Löschanträge'
                }
            })
            .state('ssc.check.overview', {
                abstract: true,
                url: "",
                views: {
                    "full@ssc": {
                        templateUrl: "templates/layouts/80-20.html" + "?v=" + window.version.tag
                    },
                    "tile@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/ssc_top.html" + "?v=" + window.version.tag
                    },
                    "right@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/ssc_right.html" + "?v=" + window.version.tag
                    },
                    "comment@ssc.check.overview": {
                        template: "<div><comment-create></comment-create><comment-overview></comment-overview></div>"
                    }
                },
                ncyBreadcrumb: {
                    skip: true
                }
            })
            .state('ssc.check.overview.download', {
                url: "/download",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/download/download.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Dokumente'
                }
            })
            .state('ssc.check.overview.household', {
                url: "/uebersicht",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/household/household.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Übersicht Check'
                }
            })
            .state('ssc.check.overview.generalInformation', {
                url: "/allgemeine-angaben",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/generalInformation/generalInformation.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Allgemeine Angaben'
                }
            })
            .state('ssc.check.overview.energy', {
                url: "/energie-und-wasser",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/energy/energy.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Energie-, Wärme und Wasserverbrauch'
                }
            })
            .state('ssc.check.overview.heat', {
                url: "/waerme",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/heat/heat.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Soforthilfen Wärme'
                }
            }) 
            .state('ssc.check.overview.heattool', {
                url: "/waermetool",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/energy/heattool.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Soforthilfen Wärme-Tool'
                }
            })             
            .state('ssc.check.overview.lighting', {
                url: "/beleuchtung",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/lighting/lighting.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Beleuchtung'
                }
            })
            .state('ssc.check.overview.standby', {
                url: "/standby",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/standby/standby.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Stand-by'
                }
            })
            .state('ssc.check.overview.electricBoiler', {
                url: "/warmwasseraufbereitung",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/electricBoiler/electricBoiler.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Elektroboiler'
                }
            })
            .state('ssc.check.overview.toiletFlush', {
                url: "/toilettenspuehlung",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/toiletFlush/toiletFlush.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Toilettenspülung'
                }
            })
            .state('ssc.check.overview.shower', {
                url: "/dusche",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/shower/shower.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Dusche'
                }
            }).state('ssc.check.overview.tap', {
                url: "/wasserhahn",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/tap/tap.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Wasserhahn'
                }
            })
            .state('ssc.check.overview.refrigerator', {
                url: "/refrigerator",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/refrigerator/refrigerator.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Kühlgeräteerfassung und –tausch'
                }
            })
            .state('ssc.check.overview.device', {
                url: "/sonstige-geraete",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/device/device.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Weitere Strom verbrauchende Geräte'
                }
            })
            .state('ssc.check.overview.telephone', {
                url: "/telephone",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/telephone/general.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Telefonberatung/Sprechstunde'
                }
            })
            .state('ssc.check.overview.telephoneInfo', {
                url: "/telephone-info",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/telephone/info.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Telefonberatung/Sprechstunde: Weitere Infos'
                }
            })
            .state('ssc.check.overview.tips', {
                url: "/tips",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/tips/tips.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Weitere Tipps für den Haushalt'
                }
            })
            .state('ssc.check.overview.kia', {
                url: "/kia",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/kia/kia.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Klimaschutz im Alltag'
                }
            })
            .state('ssc.check.overview.photovoltaic', {
                url: "/balkon-solar",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/photovoltaic/photovoltaic.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Balkon Solar'
                }
            })
            .state('ssc.check.overview.abstract', {
                url: "/zusammenfassung",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/ssc/abstract/abstract.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Zusammenfassung'
                }
            })
            .state('ssc.check.overview.monitoring', {
                url: "/monitoring",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/monitoring/monitoring/monitoring.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Monitoring'
                }
            })
            .state('ssc.check.overview.monitoringheattool', {
                url: "/monitoring-waermetool",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/monitoring/monitoring/heattool.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Monitoring Wärme-Tool'
                }
            })
            .state('ssc.check.overview.monitoringheatdirecthelp', {
                url: "/monitoring-waermesoforthilfe",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/monitoring/heatdirecthelp/heatdirecthelp.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Monitoring Wärmesoforthilfe'
                }
            })
            .state('ssc.check.overview.monitoringdirecthelp', {
                url: "/monitoring-soforthilfe",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/monitoring/directhelp/directhelp.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Monitoring Soforthilfe'
                }
            })
            .state('ssc.check.overview.monitoringmoredevices', {
                url: "/monitoring-weitere-geraete",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/monitoring/moredevices/moredevices.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Monitoring weitere Geräte'
                }
            })
            .state('ssc.check.overview.monitoringquestion', {
                url: "/monitoring-fragen",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/monitoring/question/question.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Monitoring Fragen'
                }
            })
            .state('ssc.check.overview.monitoringsuccess', {
                url: "/monitoring-einsparerfolge",
                views: {
                    "left@ssc.check.overview": {
                        templateUrl: "templates/static/monitoring/success/success.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Monitoring Einsparerfolge'
                }
            })

            ////////////////////// Benutzer
            //////////////////////////////
            .state('user', {
                url: "/benutzer",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100-100.html" + "?v=" + window.version.tag
                    },
                    "header@user": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "breadcrumb@user": {
                        template: "<div ncy-breadcrumb></div>"
                    },
                    "menu@user": {
                        template: "<mainmenu></mainmenu>"
                    },
                    "footer@user": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                redirectTo: 'user.overview',
                ncyBreadcrumb: {
                    label: 'Benutzer'
                },
                 onEnter: function (userService, $state) {
                    if (userService.forceTwoFactorAuth()) {
                        $state.go("twoFactorAuth");
                    }
                },
                data: {
                    permissions: {
                        except: ['UNVERIFIED'],
                        redirectTo: 'requireNewPw'
                    }
                }
            })
            .state('user.overview', {
                views: {
                    "full": {
                        templateUrl: "templates/static/user/user.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Übersicht'
                }
            })
            .state('user.employmenttype', {
                url: "/beschaeftigungsverhaeltnis",
                views: {
                    "full": {
                        templateUrl: "templates/static/employmenttype/employmenttype.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Beschäftigungsverhältnis'
                }
            })
            .state('user.employmenttype.update', {
                url: "/bearbeiten/:id",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/employmenttype/employmenttypeUpdate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'anlegen'
                }
            })
            .state('user.employmenttype.create', {
                url: "/anlegen",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/employmenttype/employmenttypeCreate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'anlegen'
                }
            })
            .state('user.overview.ssh', {
                url: "/stromsparhelfer/:id",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/userStromsparhelfer.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Stromsparhelfer'
                }
            })
            .state('user.create', {
                url: "/anlegen",
                params: {
                    roleId: null
                },
                views: {
                    "full": {
                        templateUrl: "templates/static/user/userCreate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Benutzer anlegen'
                }
            })
            .state('user.update', {
                url: "/bearbeiten/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/user/userUpdate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Benutzer bearbeiten'
                }
            })
            .state('user.update.rolelocationCreate', {
                url: "/anlegen/:id",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/userCreateRoleLocation.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Rolle und Standort anlegen'
                }
            })
            .state('user.update.rolelocationUpdate', {
                url: "/bearbeiten/:roleId/:roleMapId",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/userUpdateRoleLocation.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Rolle und Standort bearbeiten'
                }
            })
            .state('user.update.password', {
                url: "/passwort",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/userChangePassword.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Nutzerpasswort ändern'
                }
            })
            .state('user.update.twoFactorAuth', {
                url: "/2fa",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/createTwoFactor.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: "Zwei Faktor Autorisierung"
                }
            })
            .state('user.update.substitute', {
                url: "/vertretung/:roleMapId",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/substitute/userSubstitute.html" + "?v=" + window.version.tag
                    },
                },
                ncyBreadcrumb: {
                    label: 'Vertretungen'
                }
            })
            .state('user.update.substitute.create', {
                url: "/anlegen",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/substitute/userSubstituteCreate.html" + "?v=" + window.version.tag
                    },
                },
                ncyBreadcrumb: {
                    label: 'Vertretung anlegen'
                }
            })
            .state('user.update.substitute.update', {
                url: "/bearbeiten/:substituteId",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/substitute/userSubstituteCreate.html" + "?v=" + window.version.tag
                    },
                },
                ncyBreadcrumb: {
                    label: 'Vertretung bearbeiten'
                }
            })

            .state('user.update.employmenttyp', {
                url: "/beschaeftigungsverhaeltnis/:roleMapId",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/employmenttyp/userEmploymenttyp.html" + "?v=" + window.version.tag
                    },
                },
                ncyBreadcrumb: {
                    label: 'Beschäftigungsverhältnisse'
                }
            })
            .state('user.update.employmenttyp.create', {
                url: "/anlegen",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/employmenttyp/userEmploymenttypCreate.html" + "?v=" + window.version.tag
                    },
                },
                ncyBreadcrumb: {
                    label: 'Beschäftigungsverhältnisse anlegen'
                }
            })
            .state('user.update.employmenttyp.update', {
                url: "/bearbeiten/:userEmplyomentId",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/employmenttyp/userEmploymenttypCreate.html" + "?v=" + window.version.tag
                    },
                },
                ncyBreadcrumb: {
                    label: 'Beschäftigungsverhältnisse bearbeiten'
                }
            })

            .state('user.create.employment', {
                url: "/anlegen/:roleId",
                views: {
                    "full@user": {
                        templateUrl: "templates/static/user/userEmplyoment.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Beschäftigungsverhältnis anlegen'
                }
            })
            .state('user.detail', {
                url: "/detail/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/user/userDetail.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Details'
                }
            })
            .state('user.changeMyPassword', {
                url: "/eigenespasswort",
                views: {
                    "full": {
                        templateUrl: "templates/static/user/userChangeMyPassword.html" + "?v=" + window.version.tag
                    },
                },
                ncyBreadcrumb: {
                    label: 'Eigenes Passwort ändern'
                }
            })


            ////////////////////// Soforthilfe
            //////////////////////////////
            .state('directhelp', {
                url: "/soforthilfe",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100-100.html" + "?v=" + window.version.tag
                    },
                    "header@directhelp": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "breadcrumb@directhelp": {
                        template: "<div ncy-breadcrumb></div>"
                    },
                    "menu@directhelp": {
                        template: "<mainmenu></mainmenu>"
                    },
                    "full@directhelp": {
                        templateUrl: "templates/static/directhelp/directhelp.html" + "?v=" + window.version.tag
                    },
                    "footer@directhelp": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                redirectTo: 'directhelp.overview',
                ncyBreadcrumb: {
                    label: 'Soforthilfe'
                },
                 onEnter: function (userService, $state) {
                    if (userService.forceTwoFactorAuth()) {
                        $state.go("twoFactorAuth");
                    }
                },
                data: {
                    permissions: {
                        except: ['UNVERIFIED'],
                        redirectTo: 'requireNewPw'
                    }
                }
            })
            .state('directhelp.overview', {
                views: {
                    "full": {
                        templateUrl: "templates/static/directhelp/directhelp.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Übersicht'
                }
            })
            .state('directhelp.create', {
                url: "/anlegen",
                views: {
                    "full": {
                        templateUrl: "templates/static/directhelp/directhelpCreate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Soforthilfe anlegen'
                }
            })
            .state('directhelp.update', {
                url: "/bearbeiten/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/directhelp/directhelpUpdate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Soforthilfe bearbeiten'
                }
            })          
            .state('directhelp.locationpricelist', {
                url: "/locationpricelist/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/directhelp/directhelpLocationPricelist.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Soforthilfe nach Standort'
                }
            })
            .state('directhelp.typ', {
                url: "/typen",
                views: {
                    "full": {
                        templateUrl: "templates/static/directhelpTyp/directhelpTyp.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Soforthilfetypen'
                }
            })
            .state('directhelp.typ.create', {
                url: "/anlegen",
                views: {
                    "full@directhelp": {
                        templateUrl: "templates/static/directhelpTyp/directhelpTypCreate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Soforthilfetyp anlegen'
                }
            })
            .state('directhelp.typ.update', {
                url: "/bearbeiten/:id",
                views: {
                    "full@directhelp": {
                        templateUrl: "templates/static/directhelpTyp/directhelpTypUpdate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Soforthilfetyp bearbeiten'
                }
            })
            .state('directhelp.prices', {
                url: "/preise/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/directhelpPrices/directhelpPrices.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Preisübersicht'
                }
            })
            .state('directhelp.prices.create', {
                url: "/anlegen",
                views: {
                    "full@directhelp": {
                        templateUrl: "templates/static/directhelpPrices/directhelpPricesCreate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Preis anlegen'
                }
            })
            .state('directhelp.prices.update', {
                url: "/bearbeiten/:idPrice",
                views: {
                    "full@directhelp": {
                        templateUrl: "templates/static/directhelpPrices/directhelpPricesUpdate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Preis bearbeiten'
                }
            })


            ////////////////////// Standorte
            //////////////////////////////
            .state('location', {
                url: "/standorte",
                params: {
                    status: null
                },
                views: {
                    "": {
                        templateUrl: "templates/layouts/100-100.html" + "?v=" + window.version.tag
                    },
                    "header@location": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "breadcrumb@location": {
                        template: "<div ncy-breadcrumb></div>"
                    },
                    "menu@location": {
                        template: "<mainmenu></mainmenu>"
                    },
                    "full@location": {
                        templateUrl: "templates/static/location/location.html" + "?v=" + window.version.tag
                    },
                    "footer@location": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                redirectTo: 'location.overview',
                ncyBreadcrumb: {
                    label: 'Standorte'
                },
                 onEnter: function (userService, $state) {
                    if (userService.forceTwoFactorAuth()) {
                        $state.go("twoFactorAuth");
                    }
                },
                data: {
                    permissions: {
                        except: ['UNVERIFIED'],
                        redirectTo: 'requireNewPw'
                    }
                }
            })
            .state('location.overview', {
                params: {
                    status: null
                },
                views: {
                    "full": {
                        templateUrl: "templates/static/location/location.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Übersicht'
                }
            })
            .state('location.detail', {
                url: "/detail/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/location/locationDetail.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Standort Details'
                }
            })
            .state('location.update', {
                url: "/bearbeiten/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/location/locationUpdate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Standort bearbeiten'
                }
            })
            .state('location.create', {
                url: "/anlegen",
                views: {
                    "full": {
                        templateUrl: "templates/static/location/locationCreateLocation.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Standort anlegen'
                }
            })
            .state('location.delete', {
                url: "/entfernen/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/location/locationDeleteLocation.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Standort löschen'
                }
            })
            .state('location.regionDetail', {
                url: "/region/detail/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/location/regionDetail.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Region Details'
                }
            })
            .state('location.regionUpdate', {
                url: "/region/bearbeiten/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/location/regionUpdate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Region bearbeiten'
                }
            })
            .state('location.regionCreate', {
                url: "/region/anlegen",
                views: {
                    "full": {
                        templateUrl: "templates/static/location/locationCreateRegion.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Region anlegen'
                }
            })
            .state('location.regionDelete', {
                url: "/region/entfernen/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/location/locationDeleteRegion.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Region löschen'
                }
            })
            .state('location.organisation', {
                url: "/organisation/detail/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/organisation/organisationDetail.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Organisation Detail'
                }
            })
            .state('location.organisationUpdate', {
                url: "/organisation/bearbeiten/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/organisation/organisationUpdate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Organisation bearbeiten'
                }
            })
            .state('location.organisationDelete', {
                url: "/organisation/entfernen/:id",
                views: {
                    "full": {
                        templateUrl: "templates/static/organisation/organisationDelete.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Organisation löschen'
                }
            })
            .state('location.organisationCreate', {
                url: "/organisation/anlegen",
                views: {
                    "full": {
                        templateUrl: "templates/static/organisation/organisationCreate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Organisation anlegen'
                }
            })



            ////////////////////// News
            //////////////////////////////
            .state('news', {
                url: "/news",
                params: {
                    status: null
                },
                views: {
                    "": {
                        templateUrl: "templates/layouts/100-100.html" + "?v=" + window.version.tag
                    },
                    "header@news": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "breadcrumb@news": {
                        template: "<div ncy-breadcrumb></div>"
                    },
                    "menu@news": {
                        template: "<mainmenu></mainmenu>"
                    },
                    "full@news": {
                        templateUrl: "templates/static/news/news.html" + "?v=" + window.version.tag
                    },
                    "footer@news": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                redirectTo: 'news.overview',
                ncyBreadcrumb: {
                    label: 'News'
                },
                 onEnter: function (userService, $state) {
                    if (userService.forceTwoFactorAuth()) {
                        $state.go("twoFactorAuth");
                    }
                },
                data: {
                    permissions: {
                        except: ['UNVERIFIED'],
                        redirectTo: 'requireNewPw'
                    }
                }
            })
            .state('news.overview', {
                params: {
                    status: null
                },
                views: {
                    "full": {
                        templateUrl: "templates/static/news/news.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Übersicht'
                }
            })
            .state('news.create', {
                url: "/anlegen",
                params: {
                    status: null
                },
                views: {
                    "full": {
                        templateUrl: "templates/static/news/newsCreate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'News anlegen'
                }
            })
            .state('news.update', {
                url: "/bearbeiten/:id",
                params: {
                    status: null
                },
                views: {
                    "full": {
                        templateUrl: "templates/static/news/newsUpdate.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'News bearbeiten'
                }
            })
            .state('news.detail', {
                url: "/detail/:id",
                params: {
                    status: null
                },
                views: {
                    "full": {
                        templateUrl: "templates/static/news/newsDetail.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'News Details'
                }
            })
            .state('exchange', {
                url: "/kuehlgeraetetausch",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100-100.html" + "?v=" + window.version.tag
                    },
                    "header@exchange": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "breadcrumb@exchange": {
                        template: "<div ncy-breadcrumb></div>"
                    },
                    "menu@exchange": {
                        template: "<mainmenu></mainmenu>"
                    },
                    "full@exchange": {
                        templateUrl: "templates/static/exchange/exchange.html" + "?v=" + window.version.tag
                    },
                    "footer@exchange": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                redirectTo: 'exchange.overview',
                ncyBreadcrumb: {
                    label: 'Kühlgerätetausch'
                },
                 onEnter: function (userService, $state) {
                    if (userService.forceTwoFactorAuth()) {
                        $state.go("twoFactorAuth");
                    }
                },
                data: {
                    permissions: {
                        except: ['UNVERIFIED'],
                        redirectTo: 'requireNewPw'
                    }
                }
            })
            .state('exchange.overview', {
                views: {
                    "full": {
                        templateUrl: "templates/static/exchange/exchange.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Übersicht'
                }
            })
            .state('exchange.archiv', {
                url: "/archiv",
                views: {
                    "full": {
                        templateUrl: "templates/static/exchange/archiv.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Archiv'
                }
            })
            .state('review', {
                url: "/auswertung",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100-100.html" + "?v=" + window.version.tag
                    },
                    "header@review": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "breadcrumb@review": {
                        template: "<div ncy-breadcrumb></div>"
                    },
                    "menu@review": {
                        template: "<mainmenu></mainmenu>"
                    },
                    "full@review": {
                        templateUrl: "templates/static/review/review.html" + "?v=" + window.version.tag
                    },
                    "footer@review": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                redirectTo: 'review.overview',
                ncyBreadcrumb: {
                    label: 'Auswertungen'
                },
                 onEnter: function (userService, $state) {
                    if (userService.forceTwoFactorAuth()) {
                        $state.go("twoFactorAuth");
                    }
                },
                data: {
                    permissions: {
                        except: ['UNVERIFIED'],
                        redirectTo: 'requireNewPw'
                    }
                }
            })
            .state('review.overview', {
                views: {
                    "full": {
                        templateUrl: "templates/static/review/review.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Übersicht'
                }
            })
            .state('help', {
                url: "/hilfe",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100-100.html" + "?v=" + window.version.tag
                    },
                    "header@help": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "breadcrumb@help": {
                        template: "<div ncy-breadcrumb></div>"
                    },
                    "menu@help": {
                        template: "<mainmenu></mainmenu>"
                    },
                    "full@help": {
                        templateUrl: "templates/static/help.html" + "?v=" + window.version.tag
                    },
                    "footer@help": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                },
                ncyBreadcrumb: {
                    label: 'Hilfe'
                }
            })
            .state('404', {
                url: "/404",
                views: {
                    "": {
                        templateUrl: "templates/layouts/100-100.html" + "?v=" + window.version.tag
                    },
                    "header@404": {
                        templateUrl: "templates/partials/header.html" + "?v=" + window.version.tag
                    },
                    "menu@404": {
                        template: "<mainmenu></mainmenu>"
                    },
                    "full@404": {
                        templateUrl: "templates/static/404.html" + "?v=" + window.version.tag
                    },
                    "footer@404": {
                        templateUrl: "templates/partials/footer.html" + "?v=" + window.version.tag
                    }
                }
            });

    }]);


angular.module('frontendApp').run(function ($rootScope, localStorageService) {

    $rootScope.title = "Stromspar-Check";

    function updateUser() {
        var user = localStorageService.get('user');
        if (user) {
            $rootScope.authenticated = true;
            $rootScope.currentUser = user;
        }
    }
    updateUser();

    $rootScope.$on("$stateChangeStart", function (ev, to, toParams, from, fromParams) {
        updateUser();
        $rootScope.nextState = to;
        $rootScope.previousState = from;
    });

    $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        setTimeout(function() {//screws with history otherwise, so delay
            if (to.ncyBreadcrumb) {
                document.title = to.ncyBreadcrumb.label + " - Stromspar-Check";
            } else {
                document.title = "Stromspar-Check";
            }
        }, 10);
    });
});


angular.module('frontendApp').run(function (localStorageService, apiService, PermRoleStore, $urlRouter, xsrfTokenService) {
    apiService.post('public/permissions', {}).then(function (permissions) {
        var user = localStorageService.get('user');
        angular.forEach(permissions, function (role) {
            PermRoleStore.defineRole(role.slug, function () {
                var result = false;
                if (user) {
                    angular.forEach(user.user_role_map, function (roles_user) {
                        if (role.slug === roles_user.role.slug) {
                            result = true;
                        }
                    });
                }
                return result;
            });
        });
    }).then(function () {
        // Once permissions are set-up
        // kick-off router and start the application rendering
        $urlRouter.sync();
        // Also enable router to listen to url changes
        $urlRouter.listen();
    });
});

angular.module('frontendAppCache', []).run(['$templateCache', function($templateCache) {$templateCache.put('templates/components/core/language/language.view.html','<ul><li><a href="" ng-click="changeLang(\'en_US\')" ng-class="{active: locale==\'en_US\'}">Englisch</a></li><li><a href="" ng-click="changeLang(\'de_DE\')" ng-class="{active: locale==\'de_DE\'}">German</a></li></ul>');
$templateCache.put('templates/components/shared/grid/grid.view.html','<div><div ng-controller="gridController"><h4 data-ng-bind="title"></h4><div class="subheading" ng-if="subheading" ng-bind="subheading"></div><div ng-if="title === \'Haushalte mit KG-Tausch\' && toBeBilled.length > 0" class="col-lg-4 col-md-4 col-sm-4 col-sm-offset-8 ButtonInGridMargin"><a href="" permission="" permission-only=\'["LOKO"]\'><button type="button" ng-click="pushToBillPerButton()" class="redbutton" data-ng-bind="\'BTN_CREATE_BILL\' | translate"></button></a></div><div id="gridConfigview" ui-grid="gridOptions" ui-grid-exporter="" ui-grid-pagination="" ui-grid-auto-resize="" ui-grid-selection="" ui-grid-move-columns="" class="grid"></div><div class="watermark" data-ng-if="gridOptions.totalItems == 0" data-ng-bind="\'404_NODATA\' | translate"></div><div ng-show="gridApi.pagination && !failed"><div class="ssc-grid-navi-perpage"><span class="" style="width:60px; display:inline-block"><select class="createdropper" style="width:50px" ng-model="gridOptions.paginationPageSize" ng-options="value for value in [5, 10, 25, 50, 100]"></select></span> <span class="nlabel hidden-xs">&nbsp;&nbsp;pro Seite</span></div><div class="ssc-grid-navi-export" ng-if="showExport"><span><button type="button" class="redbutton" ng-click="downloadCsv()"><i class="ssc-icon ssc-icon-downloads marg-right-small" aria-hidden="true"></i> <span ng-bind="\'SEARCH_SSC_EXPORT\' | translate"></span></button></span></div><div class="ssc-grid-navi-pages"><span class="nlabel hidden-xs">Seite&nbsp;</span> <span class="" style="width:60px; display:inline-block"><input class="createinputter center" id="uigrid_pagenavi_input" title="{{\'PAGI_CURRENT\' | translate}}" ng-model="currentPage" ng-change="goToPage(currentPage)" ng-model-options="{updateOn: \'change\'}"></span> <span class="nlabel">&nbsp;von {{totalPages}}&nbsp;</span> <span class="" style="width:40px; display:inline-block"><button class="redbutton" ng-disabled="!currentPageOrig || currentPageOrig <= 1" ng-click="previousPage()" title="{{\'PAGI_PRE\' | translate}}"><i class="fa fa-chevron-left" aria-hidden="true"></i></button></span> &nbsp; <span class="" style="width:40px; display:inline-block"><button class="redbutton" ng-disabled="!currentPageOrig || currentPageOrig >= totalPages" ng-click="nextPage()" title="{{\'PAGI_NEXT\' | translate}}"><i class="fa fa-chevron-right" aria-hidden="true"></i></button></span></div></div></div></div>');
$templateCache.put('templates/components/shared/review/review.view.html','<div><h4 data-ng-bind="title"></h4><fieldset><div class="row"><div class="col-sm-4"><label for="filter" ng-bind="\'REVIEW_REVIEW\' | translate" class="ssc-filterlabel"></label><select class="createdropper" ng-model="review" id="filter" ng-change="showtemplate(review.id)" ng-options="r.name for r in reviews | orderBy: \'name\'"></select></div></div></fieldset><div class="filter-content"></div><div class="row margcreatetop" ng-show="review"><hr class="small-hr"><div class="col-sm-5 col-sm-offset-2 col-md-3 col-md-offset-6 ssc-email-notify"><span class="ssc-email-notify-label" ng-bind="\'REVIEW_EMAIL_NOTIFY_LABEL\' | translate"></span> <input type="checkbox" ng-true-value="true" ng-false-value="false" ng-model="doSendEmail" id="reportDoSendEmail" ng-change="updateEmail"> <label class="checklabel" for="reportDoSendEmail"></label> <span data-ng-bind="doSendEmail ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span><div class="ssc-email-notify-recipient">{{\'REVIEW_EMAIL_NOTIFY_RECIPIENT\' | translate}}{{userEmail}}</div></div><div class="col-sm-5 col-md-3"><button ng-click="createReview(review.id, doSendEmail)" class="redbutton" type="submit" data-ng-disabled="!submitEnabled && (review.id == 24 || review.id == 23 || review.id == 34 || review.id == 31)"><span data-ng-bind="\'BTN_CREATEREVIEW\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/shared/sscErrorbox/sscErrorbox.view.html','<div class="ssc-errorbox"><div class="row"><div class="col-sm-12 margcreatetop" ng-if="messages && messages.length > 0"><div class="errorfield"><div class="row hlabel"><span data-ng-bind="sscErrorboxTitle ? sscErrorboxTitle : (\'FORM_ERROR_TITLE\' | translate)" class="ng-binding"></span></div><div class="row"><div class="col-sm-12 form-fill-text p-top-15 p-bottom-15"><div ng-repeat="message in messages"><div ng-if="message.type === \'error\'"><i class="fa fa-warning"></i> {{message.text}}</div><div ng-if="message.type === \'warning\'" class="warning"><span><i class="fa fa-bell"></i> {{message.text}}</span></div></div></div></div></div></div></div></div>');
$templateCache.put('templates/components/shared/sscExpandAllBtn/sscExpandAllBtn.view.html','<button class="greybutton center" ng-click="toggle()" ng-disabled="!isEnabled"><div ng-show="sscIsExpanded"><span class="marg-right-small">Alle Einklappen</span><div class="glyphicon glyphicon-chevron-down"></div></div><div ng-show="!sscIsExpanded"><span class="marg-right-small">Alle Ausklappen</span><div class="glyphicon glyphicon-chevron-right"></div></div></button>');
$templateCache.put('templates/components/shared/sscTacho/sscTacho.view.html','<div class="ssc-tacho"><div ng-if="sscTacho.styleArrowTop"><div class="ssc-tacho-outer-label" ng-style="sscTacho.styleLabelTop">Wohnung</div><div class="ssc-tacho-arrow-top" ng-style="sscTacho.styleArrowTop"></div></div><div class="ssc-tacho-bar"><div class="ssc-tacho-gradient"></div><div class="ssc-tacho-inner-label">{{sscTachoLabel | translate}}</div><div class="ssc-tacho-gradient"></div></div><div ng-if="sscTacho.styleArrowBottom"><div class="ssc-tacho-arrow-bottom" ng-style="sscTacho.styleArrowBottom"></div><div class="ssc-tacho-outer-label" ng-style="sscTacho.styleLabelBottom">Haus</div></div></div>');
$templateCache.put('templates/components/shared/sscToggleCaret/sscToggleCaret.view.html','<div class="ssc-toggle-caret" ng-click="toggle()" ng-class="{\'ssc-invisible\': sscToggleCaretHidden}" title="{{sscToggleCaretModel?\'Einklappen\':\'Ausklappen\'}}"><i class="fa fa-caret-right" aria-hidden="true" ng-if="!sscToggleCaretModel"></i> <i class="fa fa-caret-down" aria-hidden="true" ng-if="sscToggleCaretModel"></i></div>');
$templateCache.put('templates/components/shared/sscTreeSelect/sscTreeSelect.view.html','<div class="ssc-tree-select" ng-show="sscTreeSelectModel"><input type="checkbox" id="{{baseId + \'all\'}}" ng-model="sscTreeSelectBund" ng-disabled="disableBund"> <label for="{{baseId + \'all\'}}">Bund &nbsp; <span class="red" ng-click="updateAll()">[Alle]</span> <span class="red" ng-click="toggleAllActive()">[Aktive]</span></label><div style="height:5px"></div><div ng-repeat="(itemIndex, item) in sscTreeSelectModel track by itemIndex"><div ng-if="item.name" class="ssc-tree-select-line"><ssc-toggle-caret ssc-toggle-caret-model="item.expanded" ssc-toggle-caret-hidden="!item.children"></ssc-toggle-caret><input type="checkbox" id="{{baseId + \'0\' + itemIndex}}" ng-model="item.checked" ng-disabled="item.disabled"> <label for="{{baseId + \'0\' + itemIndex}}">{{item.name}} &nbsp; <span class="red" ng-click="update([itemIndex])">[Alle]</span> <span class="red" ng-click="toggleActive([itemIndex])">[Aktive]</span></label><div ng-repeat="(subItemIndex, subItem) in item.children track by subItemIndex" style="padding-left: 20px" ng-if="item.children && item.expanded"><ssc-toggle-caret ssc-toggle-caret-model="subItem.expanded" ssc-toggle-caret-hidden="!subItem.children"></ssc-toggle-caret><input type="checkbox" id="{{baseId + \'1\' + itemIndex + \'_\' + subItemIndex}}" ng-model="subItem.checked" ng-disabled="subItem.disabled"> <label for="{{baseId + \'1\' + itemIndex + \'_\' + subItemIndex}}">{{subItem.name}} &nbsp; <span class="red" ng-click="update([itemIndex, subItemIndex])" ng-if="subItem.children">[Alle]</span> <span class="red" ng-click="toggleActive([itemIndex, subItemIndex])">[Aktive]</span></label><div ng-repeat="(subSubItemIndex, subSubItem) in subItem.children track by subSubItemIndex" style="padding-left: 40px" ng-if="subItem.children && subItem.expanded"><input type="checkbox" id="{{baseId + \'2\' + itemIndex + \'_\' + subItemIndex + \'_\' + subSubItemIndex}}" ng-model="subSubItem.checked" ng-disabled="subSubItem.disabled"> <label for="{{baseId + \'2\' + itemIndex + \'_\' + subItemIndex + \'_\' + subSubItemIndex}}">{{subSubItem.name}}</label></div></div></div><div ng-if="!item.name"><hr class="small-hr"></div></div></div>');
$templateCache.put('templates/components/shared/global/newDate.view.html','<div ng-controller="newDateController"><div class="col-sm-6 col-sm-offset-1" style="padding-top: 300px"><div class="row"><div class="col-sm-6"><label for="from" ng-bind="\'SEARCH_FROM\' | translate" class="ssc-filterlabel"></label> <input id="from" class="inputter" type="text" placeholder=\'Beispiel "2016-08-01"\' data-ng-model="from" new-datepicker="" datepicker-start-id="1"></div><div class="col-sm-6"><label for="to" ng-bind="\'SEARCH_TO\' | translate" class="ssc-filterlabel"></label> <input id="to" class="inputter" type="text" placeholder=\'Beispiel "2016-08-01"\' data-ng-model="to" new-datepicker="" datepicker-model-format="dd.mm.yyyy" datepicker-end-id="1"></div></div></div><div class="col-sm-6 col-sm-offset-1"><div class="row"><div class="col-sm-6"><label data-ng-bind="from" class="ssc-filterlabel"></label></div><div class="col-sm-6"><label data-ng-bind="to" class="ssc-filterlabel"></label></div></div></div></div>');
$templateCache.put('templates/components/content/directhelp/directhelpCreate/directhelpCreate.view.html','<div class="container"><div permission="" permission-except=\'["ADMIN"]\' style="text-align:center"><h4>Nicht gefunden</h4></div><div class="row" permission="" permission-only=\'["ADMIN"]\'><div class="col-sm-12"><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div><div class="col-sm-7 field"><div data-ng-if="!edit" class="row hlabel" data-ng-bind="\'DIRECTHELP_NEW\' | translate"></div><div data-ng-if="edit" class="row hlabel" data-ng-bind="\'DIRECTHELP_UPDATE\' | translate:{name:name}"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.directhelp_type_id + \'\').length == 0) || (model.directhelp_type_id == null)) && required.directhelp_type_id && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'DIRECTHELP_TYPE\' | translate"></span> <span data-ng-if="required.directhelp_type_id">*</span></div><div class="col-sm-6"><select data-ng-class="{\'input-required-border\': (((model.directhelp_type_id + \'\').length == 0) || (model.directhelp_type_id == null)) && required.directhelp_type_id && saved}" class="createdropper rightdropper" ng-model="model.directhelp_type_id" ng-change="isDirecthelpTypeBulb(model.directhelp_type_id)" ng-disabled="model.not_editable"><option ng-repeat="item in directhelptyp" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div data-ng-if="(((model.directhelp_type_id + \'\').length == 0) || (model.directhelp_type_id == null)) && required.directhelp_type_id && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" data-ng-if="model.slug == \'BULBS\'"><div data-ng-class="{\'input-required\': (((model.sockel + \'\').length == 0) || (model.sockel == null)) && required.sockel && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'DIRECTHELP_SOCKEL\' | translate"></span> <span data-ng-if="required.sockel">*</span></div><div class="col-sm-6"><select data-ng-class="{\'input-required-border\': model.slug == \'BULBS\' && (((model.sockel + \'\').length == 0) || (model.sockel == null)) && required.sockel && saved}" class="createdropper rightdropper" ng-model="model.sockel" ng-disabled="model.not_editable"><option ng-repeat="item in lightsockettype" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div data-ng-if="(((model.sockel + \'\').length == 0) || (model.sockel == null)) && required.sockel && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" data-ng-if="model.slug == \'BULBS\'"><div data-ng-class="{\'input-required\': (((model.lamp_lifetime_id + \'\').length == 0) || (model.lamp_lifetime_id == null)) && required.lamp_lifetime_id && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'DIRECTHELP_LIFETIME\' | translate"></span> <span data-ng-if="required.lamp_lifetime_id">*</span></div><div class="col-sm-6"><select data-ng-class="{\'input-required-border\': model.slug == \'BULBS\' && (((model.lamp_lifetime_id + \'\').length == 0) || (model.lamp_lifetime_id == null)) && required.lamp_lifetime_id && saved}" class="createdropper rightdropper" ng-model="model.lamp_lifetime_id" ng-disabled="model.not_editable"><option ng-repeat="item in lightlifetimetype" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div data-ng-if="(((model.lamp_lifetime_id + \'\').length == 0) || (model.lamp_lifetime_id == null)) && required.lamp_lifetime_id && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" data-ng-if="model.slug == \'BULBS\'"><div data-ng-class="{\'input-required\': (((model.luminous_color + \'\').length == 0) || (model.luminous_color == null)) && required.luminous_color && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'DIRECTHELP_LUMINOUSCOLOR\' | translate"></span> <span data-ng-if="required.luminous_color">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.luminous_color + \'\').length == 0) || (model.luminous_color == null)) && required.luminous_color && saved}" class="createinputter" ng-model="model.luminous_color" ng-disabled="model.not_editable"></div><div data-ng-if="(((model.luminous_color + \'\').length == 0) || (model.luminous_color == null)) && required.luminous_color && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.description + \'\').length == 0) || (model.description == null)) && required.description && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'DIRECTHELP_TITLE\' | translate"></span> <span data-ng-if="required.description">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.description + \'\').length == 0) || (model.description == null)) && required.description && saved}" class="createinputter" ng-model="model.description" ng-disabled="model.not_editable"></div><div data-ng-if="(((model.description + \'\').length == 0) || (model.description == null)) && required.description && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.productnumber_old + \'\').length == 0) || (model.productnumber_old == null)) && required.productnumber_old && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'DIRECTHELP_NUMBER_OLD\' | translate"></span> <span data-ng-if="required.productnumber_old">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.productnumber_old + \'\').length == 0) || (model.productnumber_old == null)) && required.productnumber_old && saved}" class="createinputter" ng-model="model.productnumber_old" ng-disabled="model.not_editable"></div><div data-ng-if="(((model.productnumber_old + \'\').length == 0) || (model.productnumber_old == null)) && required.productnumber_old && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.productnumber_new + \'\').length == 0) || (model.productnumber_new == null)) && required.productnumber_new && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'DIRECTHELP_NUMBER_NEW\' | translate"></span> <span data-ng-if="required.productnumber_new">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.productnumber_new + \'\').length == 0) || (model.productnumber_new == null)) && required.productnumber_new && saved}" class="createinputter" ng-model="model.productnumber_new" ng-disabled="model.not_editable"></div><div data-ng-if="(((model.productnumber_new + \'\').length == 0) || (model.productnumber_new == null)) && required.productnumber_new && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.calculation_value + \'\').length == 0) || (model.calculation_value == null)) && required.calculation_value && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'DIRECTHELP_CALCULATEDVALUE\' | translate"></span> <span data-ng-if="required.calculation_value">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.calculation_value + \'\').length == 0) || (model.calculation_value == null)) && required.calculation_value && saved}" class="createinputter" ng-model="model.calculation_value" ng-disabled="model.not_editable" decimal-separator-german="" precision="4"></div><div data-ng-if="(((model.calculation_value + \'\').length == 0) || (model.calculation_value == null)) && required.calculation_value && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.tile + \'\').length == 0) || (model.tile == null)) && required.tile && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'DIRECTHELP_TILE\' | translate"></span> <span data-ng-if="required.tile">*</span></div><div class="col-sm-6"><ui-select ng-disabled="model.not_editable" data-ng-class="{\'input-required-border\': (((model.tile + \'\').length == 0) || (model.tile == null)) && required.tile && saved}" class="ssc-ui-select" multiple="" theme="selectize" sortable="true" ng-model="model.tile"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="item1 in model.tileList | filter:$select.search"><div data-ng-bind-html="item1.name"></div></ui-select-choices></ui-select></div><div data-ng-if="(((model.tile + \'\').length == 0) || (model.tile == null)) && required.tile && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.report_categorie + \'\').length == 0) || (model.report_categorie == null)) && required.report_categorie && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'DIRECTHELP_REPORT_CATEGORIE\' | translate"></span> <span data-ng-if="required.report_categorie">*</span></div><div class="col-sm-6"><ui-select ng-disabled="model.not_editable" data-ng-class="{\'input-required-border\': (((model.report_categorie + \'\').length == 0) || (model.report_categorie == null)) && required.report_categorie && saved}" class="ssc-ui-select" multiple="" theme="selectize" sortable="true" ng-model="model.report_categorie"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="item1 in model.reportCategorieList | filter:$select.search"><div data-ng-bind-html="item1.name" ng-if="!isReportCategorieSet(item1.id)"></div></ui-select-choices></ui-select></div><div data-ng-if="(((model.report_categorie + \'\').length == 0) || (model.report_categorie == null)) && required.report_categorie && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.status + \'\').length == 0) || (model.status == null)) && required.status && saved}" class="col-sm-6 ilabel"><span data-ng-bind="\'DIRECTHELP_STATUS\' | translate"></span> <span data-ng-if="required.status">*</span></div><div class="col-sm-5"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="model.status" ng-disabled="model.not_editable" value="required.ident" id="checkboxDirecthelpStatus" ng-checked="model.status == 1"> <label class="checklabel" for="checkboxDirecthelpStatus"></label> <span data-ng-bind="model.status == 1 ? (\'ACTIVE\' | translate) : (\'INACTIVE\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.status + \'\').length == 0) || (model.status == null)) && required.status && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div data-ng-if="!edit" class="col-sm-4 col-sm-offset-1 field"><div class="row hlabel" data-ng-bind="\'DIRECTHELP_PRICE\' | translate"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.price_ek + \'\').length == 0) || (model.price_ek == null)) && required.price_ek && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'DIRECTHELP_EK_PRICE\' | translate"></span> <span data-ng-if="required.price_ek">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.price_ek + \'\').length == 0) || (model.price_ek == null)) && required.price_ek && saved}" class="createinputter" ng-model="model.price_ek" decimal-separator-german=""></div><div class="col-md-2 ilabel">\u20AC</div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.price_vk + \'\').length == 0) || (model.price_vk == null)) && required.price_vk && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'DIRECTHELP_VK_PRICE\' | translate"></span> <span data-ng-if="required.price_vk">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.price_vk + \'\').length == 0) || (model.price_vk == null)) && required.price_vk && saved}" class="createinputter" ng-model="model.price_vk" decimal-separator-german=""></div><div class="col-md-2 ilabel">\u20AC</div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.valid_from + \'\').length == 0) || (model.valid_from == null)) && required.valid_from && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'DIRECTHELP_VALID_FROM\' | translate"></span> <span data-ng-if="required.valid_from">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.valid_from + \'\').length == 0) || (model.valid_from == null)) && required.valid_from && saved}" class="createinputter" id="startdate" ssc-datepicker="" data-ng-model="model.valid_from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY"></div><div data-ng-if="(((model.valid_from + \'\').length == 0) || (model.valid_from == null)) && required.valid_from && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="col-sm-3 col-sm-offset-9"><button data-ng-if="!edit" ng-click="save()" class="redbutton" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button> <button data-ng-if="edit" ng-click="update()" class="redbutton" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/directhelp/search/search.view.html','<div><div class="container"><div class="row"><div class="col-sm-6 col-lg-4"><form ng-submit="search()"><input data-ng-model="searchfield" class="createinputter" type="search" placeholder="{{\'SEARCH_TITLE_DIRECTHELP\' | translate}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div><div class="col-sm-3"><span data-toggle="collapse" href="#filter-collapse" ng-click="showDetails = !showDetails"><a class="searchtext"><span data-ng-bind="\'SEARCH_MORE\' | translate"></span> <i class="glyphicon" aria-hidden="true" ng-class="{\'glyphicon-chevron-right\': !showDetails, \'glyphicon-chevron-down\': showDetails}"></i></a></span></div><div class="col-sm-5 text-right" data-ng-if="bSearch"><a class="searchtext" ng-click="clearFilter()"><i class="fa fa-remove marg-right-small" aria-hidden="true"></i>{{\'SEARCH_RESET\' | translate}}</a></div></div></div><div class="collapse" id="filter-collapse"><div class="graybg margcreatetop"><div class="container"><div class="push-top"></div><div class="col-sm-5"><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="time" ssc-datepicker="" data-ng-model="time" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY"></div><div class="col-sm-6 col-sm-offset-1"><div class="row"><div class="col-sm-6"><label for="from" ng-bind="\'SEARCH_FROM\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div><div class="col-sm-6"><label for="to" ng-bind="\'SEARCH_TO\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div><div class="row push-bottom"><div class="col-sm-offset-8 col-sm-4 col-lg-offset-9 col-lg-3"><button type="submit" class="greybutton" ng-click="search()"><i class="fa fa-filter" aria-hidden="true"></i> <span data-ng-bind="\'SEARCH_SEARCH\' | translate"></span></button></div></div></div></div></div></div>');
$templateCache.put('templates/components/content/directhelpPrices/directhelpPricesCreate/directhelpPricesCreate.view.html','<div class="container"><div permission="" permission-except=\'["ADMIN"]\' style="text-align:center"><h4>Nicht gefunden</h4></div><div class="row" permission="" permission-only=\'["ADMIN"]\'><div class="col-sm-12"><h4>{{actionTitle}}</h4><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div><div class="col-sm-7 field"><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.price_ek + \'\').length == 0) || (model.price_ek == null)) && required.price_ek && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'DIRECTHELP_EK_PRICE\' | translate"></span> <span data-ng-if="required.price_ek">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.price_ek + \'\').length == 0) || (model.price_ek == null)) && required.price_ek && saved}" class="createinputter" ng-model="model.price_ek" decimal-separator-german="" precision="2"></div><div class="col-xs-3 col-sm-1 ilabel">\u20AC</div><div data-ng-if="(((model.price_ek + \'\').length == 0) || (model.price_ek == null)) && required.price_ek && saved" class="col-xs-3 col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.price_vk + \'\').length == 0) || (model.price_vk == null)) && required.price_vk && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'DIRECTHELP_VK_PRICE\' | translate"></span> <span data-ng-if="required.price_vk">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.price_vk + \'\').length == 0) || (model.price_vk == null)) && required.price_vk && saved}" class="createinputter" ng-model="model.price_vk" decimal-separator-german="" precision="2"></div><div class="col-xs-3 col-sm-1 ilabel">\u20AC</div><div data-ng-if="(((model.price_vk + \'\').length == 0) || (model.price_vk == null)) && required.price_vk && saved" class="col-xs-3 col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.valid_from + \'\').length == 0) || (model.valid_from == null)) && required.valid_from && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'DIRECTHELP_VALID_FROM\' | translate"></span> <span data-ng-if="required.valid_from">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.valid_from + \'\').length == 0) || (model.valid_from == null)) && required.valid_from && saved}" class="createinputter" id="startdate" ssc-datepicker="" data-ng-model="model.valid_from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div data-ng-if="(((model.valid_from + \'\').length == 0) || (model.valid_from == null)) && required.valid_from && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="col-sm-3 col-sm-offset-9"><button ng-click="save()" class="redbutton" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/directhelptyp/directhelpTypCreate/directhelpTypCreate.view.html','<div class="container"><div permission="" permission-except=\'["ADMIN"]\' style="text-align:center"><h4>Nicht gefunden</h4></div><div class="row" permission="" permission-only=\'["ADMIN"]\'><div class="col-sm-12"><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div><div class="col-sm-7 field"><div data-ng-if="!edit" class="row hlabel" data-ng-bind="\'DIRECTHELP_TYP_NEW\'| translate"></div><div data-ng-if="edit" class="row hlabel" data-ng-bind="\'DIRECTHELP_TYP_UPDATE\' | translate:{name:name}"></div><div class="row margcreatetop margcreatebot"><div data-ng-class="{\'input-required\': (((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'DIRECTHELP_TITLE\' | translate"></span> <span data-ng-if="required.name">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved}" class="createinputter" ng-model="model.name"></div><div data-ng-if="(((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="col-sm-3 col-sm-offset-9"><button data-ng-if="!edit" ng-click="save()" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button> <button data-ng-if="edit" ng-click="update()" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/directhelptyp/search/search.view.html','<div class="container" ng-controller="searchDirecthelptypController"><div class="row margcreatebot"><div class="col-sm-4"><form ng-submit="search()"><input data-ng-model="searchfield" class="createinputter" type="search" placeholder="{{\'SEARCH_TITLE_DIRECTHELPTYP\' | translate}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div><div class="col-sm-8 text-right" data-ng-if="bSearch"><a class="searchtext" ng-click="clearFilter()" data-ng-bind="\'SEARCH_RESET\' | translate"></a></div></div></div>');
$templateCache.put('templates/components/content/exchange/search/search.view.html','<div><div class="container"><div class="row"><div class="col-sm-4"><form ng-submit="search()"><input data-ng-model="searchfield" class="createinputter" type="search" placeholder="{{\'SEARCH_TITLE_EXCHANGE\'| translate}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div><div class="col-sm-3"><span data-toggle="collapse" href="#filter-collapse" ng-click="showDetails = !showDetails"><a class="searchtext"><span data-ng-bind="\'SEARCH_MORE\' | translate"></span> <i class="glyphicon" aria-hidden="true" ng-class="{\'glyphicon-chevron-right\': !showDetails, \'glyphicon-chevron-down\': showDetails}"></i></a></span></div><div class="col-sm-5 text-right" data-ng-if="bSearch"><a class="searchtext" ng-click="clearFilter()"><i class="fa fa-remove marg-right-small" aria-hidden="true"></i>{{\'SEARCH_RESET\' | translate}}</a></div></div></div><div class="collapse" id="filter-collapse"><div class="graybg margcreatetop"><div class="container"><div class="push-top"></div><div class="col-sm-5"><label for="places" ng-bind="\'SEARCH_PLACES\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((model.location_id + \'\').length == 0) || (model.location_id == null)) && required && saved}" class="createdropper" id="places" ng-model="location"><option ng-repeat="item in dropLocation" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-6 col-sm-offset-1"><label for="status" ng-bind="\'SEARCH_STATUS\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((model.status_id + \'\').length == 0) || (model.status_id == null)) && required && saved}" class="createdropper" id="status" ng-model="status"><option ng-repeat="item in dropStatus" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-5"><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="time" ssc-datepicker="" data-ng-model="time" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY"></div><div class="col-sm-6 col-sm-offset-1"><div class="row"><div class="col-sm-6"><label for="from" ng-bind="\'SEARCH_FROM\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div><div class="col-sm-6"><label for="to" ng-bind="\'SEARCH_TO\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div><div class="col-sm-6 col-sm-offset-6 push-bottom"><div class="row"><div class="col-sm-offset-6 col-sm-6"><button type="submit" class="greybutton" ng-click="search()"><i class="fa fa-filter" aria-hidden="true"></i> <span data-ng-bind="\'SEARCH_SEARCH\' | translate"></span></button></div></div></div></div></div></div></div>');
$templateCache.put('templates/components/content/location/createLocation/createLocation.view.html','<div class="container"><div class="row"><div class="col-sm-12"><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div><div ng-if="!model.fridge_exchange && !model.loc_kg_programm && saved" class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_ONE_EXCHANGE\' | translate"></div></div></div><div class="col-sm-6 field"><div data-ng-if="!edit" class="row hlabel" data-ng-bind="\'LOCATION_LOCATION_TITLE\' | translate"></div><div data-ng-if="edit" class="row hlabel" data-ng-bind="\'LOCATION_LOCATION_UPDATE_TITLE\' | translate:{name:name}"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_LOCATIONNAME\' | translate"></span> <span data-ng-if="required.name">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved}" ng-model="model.name" ng-disabled="limitedAccess"></div><div data-ng-if="(((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.name2 + \'\').length == 0) || (model.name2 == null)) && required.name2 && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_LOCATIONNAME2\' | translate"></span> <span data-ng-if="required.name2">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.name2 + \'\').length == 0) || (model.name2 == null)) && required.name2 && saved}" ng-model="model.name2" ng-disabled="limitedAccess"></div><div data-ng-if="(((model.name2 + \'\').length == 0) || (model.name2 == null)) && required.name2 && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.name3 + \'\').length == 0) || (model.name3 == null)) && required.name3 && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_LOCATIONNAME3\' | translate"></span> <span data-ng-if="required.name3">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.name3 + \'\').length == 0) || (model.name3 == null)) && required.name3 && saved}" ng-model="model.name3" ng-disabled="limitedAccess"></div><div data-ng-if="(((model.name3 + \'\').length == 0) || (model.name3 == null)) && required.name3 && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': required.ident && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_IDENT\' | translate"></span> <span data-ng-if="required.ident">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': required.ident && saved}" ng-model="model.ident" ng-disabled="limitedAccess"></div><div data-ng-if="required.ident && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.state_id + \'\').length == 0) || (model.state_id == null)) && required && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_STATE\' | translate"></span> <span data-ng-if="required.state_id">*</span></div><div class="col-sm-7"><select data-ng-class="{\'input-required-border\': (((model.state_id + \'\').length == 0) || (model.state_id == null)) && required && saved}" class="createdropper" ng-model="model.state_id" ng-disabled="limitedAccess"><option ng-repeat="item in dropState" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div data-ng-if="(((model.state_id + \'\').length == 0) || (model.state_id == null)) && required.state_id && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_STREET\' | translate"></span> <span data-ng-if="required.street">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved}" ng-model="model.street" ng-disabled="noAccess"></div><div data-ng-if="(((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.postalcode + \'\').length !=5) || (model.postalcode == null)) && required.postalcode && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PLZ\' | translate"></span> <span data-ng-if="required.postalcode">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.postalcode + \'\').length !=5) || (model.postalcode == null)) && required.postalcode && saved}" ng-model="model.postalcode" ng-disabled="noAccess"></div><div data-ng-if="(((model.postalcode + \'\').length !=5) || (model.postalcode == null)) && required.postalcode && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PLACE\' | translate"></span> <span data-ng-if="required.city">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved}" ng-model="model.city" ng-disabled="noAccess"></div><div data-ng-if="(((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved || error.telephone}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PHONE\' | translate"></span> <span data-ng-if="required.telephone">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved || error.telephone}" ng-model="model.telephone" ng-disabled="noAccess"></div><div data-ng-if="(((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved || error.telephone" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.fax + \'\').length == 0) || (model.fax == null)) && required.fax && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_FAX\' | translate"></span> <span data-ng-if="required.fax">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.fax + \'\').length == 0) || (model.fax == null)) && required.fax && saved}" ng-model="model.fax" ng-disabled="noAccess"></div><div data-ng-if="(((model.fax + \'\').length == 0) || (model.fax == null)) && required.fax && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.sponsor_name + \'\').length == 0) || (model.sponsor_name == null)) && required.sponsor_name && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_SPONSOR_NAME\' | translate"></span> <span data-ng-if="required.sponsor_name">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.sponsor_name + \'\').length == 0) || (model.sponsor_name == null)) && required.sponsor_name && saved}" ng-model="model.sponsor_name" ng-disabled="noAccess"></div><div data-ng-if="(((model.sponsor_name + \'\').length == 0) || (model.sponsor_name == null)) && required.sponsor_name && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.email + \'\').length == 0) || (model.email == null)) && required.email && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_EMAIL\' | translate"></span> <span data-ng-if="required.email">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.email + \'\').length == 0) || (model.email == null)) && required.email && saved}" ng-model="model.email" ng-disabled="noAccess"></div><div data-ng-if="(((model.email + \'\').length == 0) || (model.email == null)) && required.email && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.internet + \'\').length == 0) || (model.internet == null)) && required.internet && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_INTERNET\' | translate"></span> <span data-ng-if="required.internet">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.internet + \'\').length == 0) || (model.internet == null)) && required.internet && saved}" ng-model="model.internet" ng-disabled="noAccess"></div><div data-ng-if="(((model.internet + \'\').length == 0) || (model.internet == null)) && required.internet && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_NOTICE\' | translate"></span> <span data-ng-if="required.comment">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved}" ng-model="model.comment" ng-disabled="limitedAccess"></div><div data-ng-if="(((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.alt_description_check + \'\').length == 0) || (model.alt_description_check == null)) && required.alt_description_check && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_SSC\' | translate"></span> <span data-ng-if="required.alt_description_check">*</span></div><div class="col-sm-7 margcreatetop"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.alt_description_check + \'\').length == 0) || (model.alt_description_check == null)) && required.alt_description_check && saved}" ng-model="model.alt_description_check" ng-disabled="limitedAccess"></div><div data-ng-if="(((model.alt_description_check + \'\').length == 0) || (model.alt_description_check == null)) && required.alt_description_check && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.alt_description_user + \'\').length == 0) || (model.alt_description_user == null)) && required.alt_description_user && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_SSH\' | translate"></span> <span data-ng-if="required.alt_description_user">*</span></div><div class="col-sm-7 margcreatetop"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.alt_description_user + \'\').length == 0) || (model.alt_description_user == null)) && required.alt_description_user && saved}" ng-model="model.alt_description_user" ng-disabled="limitedAccess"></div><div data-ng-if="(((model.alt_description_user + \'\').length == 0) || (model.alt_description_user == null)) && required.alt_description_user && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="col-sm-5 col-sm-offset-1 field"><div class="row hlabel" data-ng-bind="\'LOCATION_AUTH\' | translate"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved}" class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_STATUS\' | translate"></span> <span data-ng-if="required.status">*</span></div><div class="col-sm-5"><input type="checkbox" ng-model="model.status" value="required.ident" id="checkboxLocationStatus" ng-true-value="1" ng-false-value="0" ng-checked="model.status == 1" ng-disabled="limitedAccess"> <label class="checklabel" for="checkboxLocationStatus"></label> <span data-ng-bind="model.status == 1 ? (\'ACTIVE\' | translate) : (\'INACTIVE\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.alt_description_user && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><hr class="small-hr"><div class="row"><div class="col-sm-6 nlabel" data-ng-class="{\'error\': !isFridgeExchangeValid()}">{{\'LOCATION_FRIDGE_SWAP\' | translate}}*</div></div><div class="row" data-ng-class="{\'error\': !isFridgeExchangeValid()}"><div class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_FREEZ\' | translate"></span> <span data-ng-if="required.fridge_exchange">*</span></div><div class="col-sm-5"><input type="checkbox" ng-model="model.fridge_exchange" value="required.ident" id="checkboxLocationFridge" ng-true-value="1" ng-false-value="0" ng-checked="model.fridge_exchange == 1" ng-disabled="limitedAccess"> <label class="checklabel" for="checkboxLocationFridge"></label> <span data-ng-bind="model.fridge_exchange == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row" data-ng-class="{\'error\': !isFridgeExchangeValid()}"><div class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_LOKAL\' | translate"></span> <span data-ng-if="required.loc_kg_programm">*</span></div><div class="col-sm-5"><input type="checkbox" ng-model="model.loc_kg_programm" value="required.ident" id="checkboxLocationKg" ng-true-value="1" ng-false-value="0" ng-checked="model.loc_kg_programm == 1" ng-disabled="limitedAccess"> <label class="checklabel" for="checkboxLocationKg"></label> <span data-ng-bind="model.loc_kg_programm == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row" data-ng-class="{\'error\': !isFridgeExchangeValid()}"><div class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_FRIDGE_COMPLETE\' | translate"></span> <span data-ng-if="required.fridge_subsidy_complete">*</span></div><div class="col-sm-5"><input type="checkbox" ng-model="model.fridge_subsidy_complete" value="required.ident" id="checkboxFridgeSubsidyComplete" ng-true-value="1" ng-false-value="0" ng-checked="model.fridge_subsidy_complete == 1" ng-disabled="limitedAccess"> <label class="checklabel" for="checkboxFridgeSubsidyComplete"></label> <span data-ng-bind="model.fridge_subsidy_complete === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><hr class="small-hr"><div class="row"><div data-ng-class="{\'input-required\': (((model.monitoring + \'\').length == 0) || (model.monitoring == null) || (model.monitoring == 0)) && required.monitoring && saved}" class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_MONITOR\' | translate"></span> <span data-ng-if="required.monitoring">*</span></div><div class="col-sm-5"><input type="checkbox" ng-model="model.monitoring" value="required.ident" id="checkboxLocationMonitoring" ng-true-value="1" ng-false-value="0" ng-checked="model.monitoring == 1" ng-disabled="limitedAccess"> <label class="checklabel" for="checkboxLocationMonitoring"></label> <span data-ng-bind="model.monitoring == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.monitoring + \'\').length == 0) || (model.monitoring == null) || (model.monitoring == 0)) && required.monitoring && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.luminous_color + \'\').length == 0) || (model.luminous_color == null) || (model.luminous_color == 0)) && required.luminous_color && saved}" class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_LUMINOUSCOLOR\' | translate"></span> <span data-ng-if="required.luminous_color">*</span></div><div class="col-sm-5"><input type="checkbox" ng-model="model.luminous_color" value="required.ident" id="checkboxLocationLuminousColor" ng-true-value="1" ng-false-value="0" ng-checked="model.luminous_color == 1" ng-disabled="limitedAccess"> <label class="checklabel" for="checkboxLocationLuminousColor"></label> <span data-ng-bind="model.luminous_color == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.luminous_color + \'\').length == 0) || (model.luminous_color == null) || (model.luminous_color == 0)) && required.luminous_color && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.photovoltaic + \'\').length == 0) || (model.photovoltaic == null) || (model.photovoltaic == 0)) && required.photovoltaic && saved}" class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_PHOTOVOLTAIC\' | translate"></span> <span data-ng-if="required.photovoltaic">*</span></div><div class="col-sm-5"><input type="checkbox" ng-model="model.photovoltaic" value="required.ident" id="checkboxLocationPhotovoltaic" ng-true-value="1" ng-false-value="0" ng-checked="model.photovoltaic == 1" ng-disabled="limitedAccess"> <label class="checklabel" for="checkboxLocationPhotovoltaic"></label> <span data-ng-bind="model.photovoltaic == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.photovoltaic + \'\').length == 0) || (model.photovoltaic == null) || (model.photovoltaic == 0)) && required.photovoltaic && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.climate_protection + \'\').length == 0) || (model.climate_protection == null) || (model.climate_protection == 0)) && required.climate_protection && saved}" class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_CLIMATE_PROTECTION\' | translate"></span> <span data-ng-if="required.climate_protection">*</span></div><div class="col-sm-5"><input type="checkbox" ng-model="model.climate_protection" value="required.ident" id="checkboxLocationClimateProtection" ng-true-value="1" ng-false-value="0" ng-checked="model.climate_protection == 1" ng-disabled="limitedAccess"> <label class="checklabel" for="checkboxLocationClimateProtection"></label> <span data-ng-bind="model.climate_protection == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.climate_protection + \'\').length == 0) || (model.climate_protection == null) || (model.climate_protection == 0)) && required.climate_protection && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.fridge_exchange_intervention + \'\').length == 0) || (model.fridge_exchange_intervention == null) || (model.fridge_exchange_intervention == 0)) && required.fridge_exchange_intervention && saved}" class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_FRIDGE_EXCHANGE_INTERVENTION\' | translate"></span> <span data-ng-if="required.fridge_exchange_intervention">*</span></div><div class="col-sm-5"><input type="checkbox" ng-model="model.fridge_exchange_intervention" value="required.ident" id="checkboxLocationFridgeExchangeIntervention" ng-true-value="1" ng-false-value="0" ng-checked="model.fridge_exchange_intervention == 1" ng-disabled="limitedAccess"> <label class="checklabel" for="checkboxLocationFridgeExchangeIntervention"></label> <span data-ng-bind="model.fridge_exchange_intervention == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.fridge_exchange_intervention + \'\').length == 0) || (model.fridge_exchange_intervention == null) || (model.fridge_exchange_intervention == 0)) && required.fridge_exchange_intervention && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.quartier_approach + \'\').length == 0) || (model.quartier_approach == null) || (model.quartier_approach == 0)) && required.quartier_approach && saved}" class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_QUART\' | translate"></span> <span data-ng-if="required.quartier_approach">*</span></div><div class="col-sm-5"><input type="checkbox" ng-model="model.quartier_approach" value="required.ident" id="checkboxLocationquartier_approach" ng-true-value="1" ng-false-value="0" ng-checked="model.quartier_approach == 1" ng-disabled="limitedAccess"> <label class="checklabel" for="checkboxLocationquartier_approach"></label> <span data-ng-bind="model.quartier_approach == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.quartier_approach + \'\').length == 0) || (model.quartier_approach == null) || (model.quartier_approach == 0)) && required.quartier_approach && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" ng-show="model.quartier_approach == 1"><div class="col-sm-10 col-sm-offset-1"><div class="row margcreatetop" ng-repeat="(quarterIndex, quarter) in model.location_quarters"><div class="col-sm-12"><span data-ng-bind="(\'LOCATION_QUARTER_LABEL\' | translate) + \' \' + (quarterIndex + 1)"></span></div><div class="col-xs-10"><input ng-model="quarter.name" class="createinputter" ng-disabled="limitedAccess || noAccess"></div><div class="col-xs-2"><ssc-delete-button delete-enabled="!limitedAccess && !noAccess" delete-onclick="removeQuarter(quarterIndex)" delete-class="sscDeleteVertAlign"></ssc-delete-button></div></div><div class="row"><div class="col-sm-10"><ssc-add-button add-onclick="addQuarter()" add-label="LOCATION_QUARTER_ADD" add-is-saving="isSaving" add-enabled="!limitedAccess && !noAccess"></ssc-add-button></div></div><hr class="small-hr"></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.logo + \'\').length == 0) || (model.logo == null)) && required.logo && saved}" class="col-sm-11 ilabel"><span data-ng-bind="\'LOCATION_LOGO\' | translate"></span> <span data-ng-if="required.logo">*</span></div><div class="col-sm-12 button-row no-padd" ng-if="!noAccess && !model.logo_delete"><input type="file" ng-upload-change="fileChanged($event,\'logo_upload\')" class="custom-file-input"></div><div class="col-sm-12" data-ng-if="model.logo"><img ng-src="{{model.logo}}" style="max-width:100%;max-height:200px;"></div><div class="col-sm-6 ilabel" ng-if="model.logo && !noAccess"><span data-ng-bind="\'LOCATION_LOGO_DELETE\' | translate"></span></div><div class="col-sm-6" ng-if="model.logo && !noAccess"><input type="checkbox" ng-model="model.logo_delete" value="required.ident" id="checkboxLocationLogoDelete" ng-true-value="1" ng-false-value="0" ng-checked="model.logo_delete == 1"> <label class="checklabel" for="checkboxLocationLogoDelete"></label> <span data-ng-bind="model.logo_delete == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.logo + \'\').length == 0) || (model.logo == null)) && required.logo && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><hr class="small-hr"><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.logo_2 + \'\').length == 0) || (model.logo_2 == null)) && required.logo_2 && saved}" class="col-sm-11 ilabel"><span data-ng-bind="\'LOCATION_LOGO2\' | translate"></span> <span data-ng-if="required.logo_2">*</span></div><div class="col-sm-12 button-row no-padd" ng-if="!noAccess && !model.logo_2_delete"><input type="file" ng-upload-change="fileChanged($event,\'logo_2_upload\')" class="custom-file-input"></div><div class="col-sm-12" data-ng-if="model.logo_2"><img ng-src="{{model.logo_2}}" style="max-width:100%;max-height:200px;"></div><div class="col-sm-6 ilabel" ng-if="model.logo_2 && !noAccess"><span data-ng-bind="\'LOCATION_LOGO_DELETE\' | translate"></span></div><div class="col-sm-6" ng-if="model.logo_2 && !noAccess"><input type="checkbox" ng-model="model.logo_2_delete" value="required.ident" id="checkboxLocationLogo2Delete" ng-true-value="1" ng-false-value="0" ng-checked="model.logo_2_delete == 1"> <label class="checklabel" for="checkboxLocationLogo2Delete"></label> <span data-ng-bind="model.logo_2_delete == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.logo_2 + \'\').length == 0) || (model.logo_2 == null)) && required.logo_2 && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="col-sm-12"><div class="col-sm-6 field"><div class="row hlabel" data-ng-bind="\'LOCATION_PRIVACY_TITLE\' | translate"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.privacy_name + \'\').length == 0) || (model.privacy_name == null)) && required.privacy_name && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_NAME\' | translate"></span> <span data-ng-if="required.privacy_name">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.privacy_name + \'\').length == 0) || (model.privacy_name == null)) && required.privacy_name && saved}" ng-model="model.privacy_name" ng-disabled="noAccess"></div><div data-ng-if="(((model.privacy_name + \'\').length == 0) || (model.privacy_name == null)) && required.privacy_name && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.privacy_street + \'\').length == 0) || (model.privacy_street == null)) && required.privacy_street && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_STREET\' | translate"></span> <span data-ng-if="required.privacy_street">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.privacy_street + \'\').length == 0) || (model.privacy_street == null)) && required.privacy_street && saved}" ng-model="model.privacy_street" ng-disabled="noAccess"></div><div data-ng-if="(((model.privacy_street + \'\').length == 0) || (model.privacy_street == null)) && required.privacy_street && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.privacy_postalcode + \'\').length == 0) || (model.privacy_postalcode == null)) && required.privacy_postalcode && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_PLZ\' | translate"></span> <span data-ng-if="required.privacy_postalcode">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.privacy_postalcode + \'\').length == 0) || (model.privacy_postalcode == null)) && required.privacy_postalcode && saved}" ng-model="model.privacy_postalcode" ng-disabled="noAccess"></div><div data-ng-if="(((model.privacy_postalcode + \'\').length == 0) || (model.privacy_postalcode == null)) && required.privacy_postalcode && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.privacy_city + \'\').length == 0) || (model.privacy_city == null)) && required.privacy_city && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_CITY\' | translate"></span> <span data-ng-if="required.privacy_city">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.privacy_city + \'\').length == 0) || (model.privacy_city == null)) && required.privacy_city && saved}" ng-model="model.privacy_city" ng-disabled="noAccess"></div><div data-ng-if="(((model.privacy_city + \'\').length == 0) || (model.privacy_city == null)) && required.privacy_city && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.privacy_telephone + \'\').length == 0) || (model.privacy_telephone == null)) && required.privacy_telephone && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_PHONE\' | translate"></span> <span data-ng-if="required.privacy_telephone">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.privacy_telephone + \'\').length == 0) || (model.privacy_telephone == null)) && required.privacy_telephone && saved}" ng-model="model.privacy_telephone" ng-disabled="noAccess"></div><div data-ng-if="(((model.privacy_telephone + \'\').length == 0) || (model.privacy_telephone == null)) && required.privacy_telephone && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.privacy_email + \'\').length == 0) || (model.privacy_email == null)) && required.privacy_email && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_EMAIL\' | translate"></span> <span data-ng-if="required.privacy_email">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.privacy_email + \'\').length == 0) || (model.privacy_email == null)) && required.privacy_email && saved}" ng-model="model.privacy_email" ng-disabled="noAccess"></div><div data-ng-if="(((model.privacy_email + \'\').length == 0) || (model.privacy_email == null)) && required.privacy_email && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.privacy_internet + \'\').length == 0) || (model.privacy_internet == null)) && required.privacy_internet && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_INTERNET\' | translate"></span> <span data-ng-if="required.privacy_internet">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.privacy_internet + \'\').length == 0) || (model.privacy_internet == null)) && required.privacy_internet && saved}" ng-model="model.privacy_internet" ng-disabled="noAccess"></div><div data-ng-if="(((model.privacy_internet + \'\').length == 0) || (model.privacy_internet == null)) && required.privacy_internet && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="col-sm-5 col-sm-offset-1 field field"><div class="row hlabel" data-ng-bind="\'LOCATION_AUTHORITY_TITLE\' | translate"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.authority_name + \'\').length == 0) || (model.authority_name == null)) && required.authority_name && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_AUTHORITY_NAME\' | translate"></span> <span data-ng-if="required.authority_name">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.authority_name + \'\').length == 0) || (model.authority_name == null)) && required.authority_name && saved}" ng-model="model.authority_name" ng-disabled="noAccess"></div><div data-ng-if="(((model.authority_name + \'\').length == 0) || (model.authority_name == null)) && required.authority_name && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.authority_street + \'\').length == 0) || (model.authority_street == null)) && required.authority_street && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_STREET\' | translate"></span> <span data-ng-if="required.authority_street">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.authority_street + \'\').length == 0) || (model.authority_street == null)) && required.authority_street && saved}" ng-model="model.authority_street" ng-disabled="noAccess"></div><div data-ng-if="(((model.authority_street + \'\').length == 0) || (model.authority_street == null)) && required.authority_street && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.authority_postalcode + \'\').length == 0) || (model.authority_postalcode == null)) && required.authority_postalcode && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_PLZ\' | translate"></span> <span data-ng-if="required.authority_postalcode">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.authority_postalcode + \'\').length == 0) || (model.authority_postalcode == null)) && required.authority_postalcode && saved}" ng-model="model.authority_postalcode" ng-disabled="noAccess"></div><div data-ng-if="(((model.authority_postalcode + \'\').length == 0) || (model.authority_postalcode == null)) && required.authority_postalcode && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.authority_city + \'\').length == 0) || (model.authority_city == null)) && required.authority_city && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_CITY\' | translate"></span> <span data-ng-if="required.authority_city">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.authority_city + \'\').length == 0) || (model.authority_city == null)) && required.authority_city && saved}" ng-model="model.authority_city" ng-disabled="noAccess"></div><div data-ng-if="(((model.authority_city + \'\').length == 0) || (model.authority_city == null)) && required.authority_city && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.authority_telephone + \'\').length == 0) || (model.authority_telephone == null)) && required.authority_telephone && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_PHONE\' | translate"></span> <span data-ng-if="required.authority_telephone">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.authority_telephone + \'\').length == 0) || (model.authority_telephone == null)) && required.authority_telephone && saved}" ng-model="model.authority_telephone" ng-disabled="noAccess"></div><div data-ng-if="(((model.authority_telephone + \'\').length == 0) || (model.authority_telephone == null)) && required.authority_telephone && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.authority_email + \'\').length == 0) || (model.authority_email == null)) && required.authority_email && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_EMAIL\' | translate"></span> <span data-ng-if="required.authority_email">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.authority_email + \'\').length == 0) || (model.authority_email == null)) && required.authority_email && saved}" ng-model="model.authority_email" ng-disabled="noAccess"></div><div data-ng-if="(((model.authority_email + \'\').length == 0) || (model.authority_email == null)) && required.authority_email && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.authority_internet + \'\').length == 0) || (model.authority_internet == null)) && required.authority_internet && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_PRIVACY_INTERNET\' | translate"></span> <span data-ng-if="required.authority_internet">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.authority_internet + \'\').length == 0) || (model.authority_internet == null)) && required.authority_internet && saved}" ng-model="model.authority_internet" ng-disabled="noAccess"></div><div data-ng-if="(((model.authority_internet + \'\').length == 0) || (model.authority_internet == null)) && required.authority_internet && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div></div><div class="row"><div class="col-sm-3 col-sm-offset-9"><button ng-click="save()" class="redbutton" id="roleplace" type="submit" ng-if="!noAccess"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/location/createOrganisation/createOrganisation.view.html','<div class="container"><div class="row"><div class="col-sm-12"><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div><div class="col-sm-6 field"><div data-ng-if="!edit" class="row hlabel" data-ng-bind="\'LOCATION_ORGANISATION_TITLE\'| translate"></div><div data-ng-if="edit" class="row hlabel" data-ng-bind="\'LOCATION_ORGANISATION_UPDATE_TITLE\' | translate:{name:name}"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION_NAME\' | translate"></span> <span data-ng-if="required.name">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved}" ng-model="model.name"></div><div data-ng-if="(((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION_STREET\' | translate"></span> <span data-ng-if="required.street">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved}" ng-model="model.street"></div><div data-ng-if="(((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="message.postalcode" data-ng-class="{\'input-required\': (((model.postalcode + \'\').length !=5) || (model.postalcode == null)) && required.postalcode && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION_PLZ\' | translate"></span> <span data-ng-if="required.postalcode">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.postalcode + \'\').length !=5) || (model.postalcode == null)) && required.postalcode && saved}" ng-model="model.postalcode"></div><div data-ng-if="(((model.postalcode + \'\').length !=5) || (model.postalcode == null)) && required.postalcode && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION_CITY\' | translate"></span> <span data-ng-if="required.city">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved}" ng-model="model.city"></div><div data-ng-if="(((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION_TELEPHONE\' | translate"></span> <span data-ng-if="required.telephone">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved}" ng-model="model.telephone"></div><div data-ng-if="(((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.fax + \'\').length == 0) || (model.fax == null)) && required.fax && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION_FAX\' | translate"></span> <span data-ng-if="required.fax">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.fax + \'\').length == 0) || (model.fax == null)) && required.fax && saved}" ng-model="model.fax"></div><div data-ng-if="(((model.fax + \'\').length == 0) || (model.fax == null)) && required.fax && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION_COMMENT\' | translate"></span> <span data-ng-if="required.comment">*</span></div><div class="col-sm-7"><input class="createinputter" data-ng-class="{\'input-required-border\': (((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved}" ng-model="model.comment"></div><div data-ng-if="(((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved}" class="col-sm-6 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION_STATUS\' | translate"></span> <span data-ng-if="required.status">*</span></div><div class="col-sm-3 col-sm-offset-2 padd-top"><input type="checkbox" ng-model="model.status" value="required.ident" id="checkboxOrgStatus" ng-true-value="1" ng-false-value="0" ng-checked="model.status == 1"> <label class="checklabel" for="checkboxOrgStatus"></label> <span data-ng-bind="model.status==1 ? (\'ACTIVE\'|translate) : (\'INACTIVE\'|translate)" class="checklabelText"></span></div><div data-ng-if="(((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.logo + \'\').length == 0) || (model.logo == null)) && required.logo && saved}" class="col-sm-11 col-lg-4 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION_LOGO\' | translate"></span> <span data-ng-if="required.logo">*</span></div><div class="col-sm-12 col-lg-7 button-row no-padd-to-lg"><input type="file" ng-upload-change="fileChanged($event,\'logo_upload\')" class="custom-file-input no-padd"></div><div class="col-sm-12" data-ng-if="model.logo"><img ng-src="{{model.logo}}" style="max-width: 100%;max-height:200px;"></div><div data-ng-if="(((model.logo + \'\').length == 0) || (model.logo == null)) && required.logo && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><hr class="small-hr"><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.logo_2 + \'\').length == 0) || (model.logo_2 == null)) && required.logo_2 && saved}" class="col-sm-11 col-lg-4 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION_LOGO2\' | translate"></span> <span data-ng-if="required.logo_2">*</span></div><div class="col-sm-12 col-lg-7 button-row no-padd-to-lg"><input type="file" ng-upload-change="fileChanged($event,\'logo_2_upload\')" class="custom-file-input no-padd"></div><div class="col-sm-12" data-ng-if="model.logo_2"><img ng-src="{{model.logo_2}}" style="max-width: 100%;max-height:200px;"></div><div data-ng-if="(((model.logo_2 + \'\').length == 0) || (model.logo_2 == null)) && required.logo_2 && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="col-sm-3 col-sm-offset-9"><button ng-click="save()" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/location/createRegion/createRegion.view.html','<div class="container"><div class="row"><div class="col-sm-12"><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div><div class="col-sm-6 field"><div data-ng-if="!edit" class="row hlabel" data-ng-bind="\'LOCATION_REGION_TITLE\'| translate"></div><div data-ng-if="edit" class="row hlabel" data-ng-bind="\'LOCATION_REGION_UPDATE_TITLE\' | translate:{name:name}"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_NAME\' | translate"></span> <span data-ng-if="required.name">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved}" class="createinputter" ng-model="model.name"></div><div data-ng-if="(((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.states + \'\').length == 0) || (model.states == null)) && required.states && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_STATES\' | translate"></span> <span data-ng-if="required.states">*</span></div><div class="col-sm-7"><ui-select class="ssc-ui-select" on-select="OnClickSelect($item)" on-remove="OnRemoveSelect($item)" multiple="" data-ng-class="{\'input-required-border\': (((model.states + \'\').length == 0) || (model.states == null)) && required.states && saved}" data-ng-model="model.states" theme="selectize" sortable="true"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdownStates | filter:$select.search"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div data-ng-if="(((model.states + \'\').length == 0) || (model.states == null)) && required.states && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.organisation.id + \'\').length == 0) || (model.organisation.id == null)) && required.organisation && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_ORGANISATION\' | translate"></span> <span data-ng-if="required.organisation">*</span></div><div class="col-sm-7"><select data-ng-class="{\'input-required-border\': (((model.organisation.id + \'\').length == 0) || (model.organisation.id == null)) && required.organisation && saved}" class="createdropper" ng-model="model.organisation.id"><option ng-repeat="item in dropOrganisation" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div data-ng-if="(((model.organisation.id + \'\').length == 0) || (model.organisation.id == null)) && required.organisation && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.status + \'\').length == 0) || (model.status == null)) && required.status && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_STATUS\' | translate"></span> <span data-ng-if="required.status">*</span></div><div class="col-sm-3 col-sm-offset-4 padd-top"><input data-ng-class="{\'input-required-border\': (((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved}" type="checkbox" ng-model="model.status" ng-true-value="1" ng-false-value="0" id="checkboxRegionStatus" ng-checked="model.status == 1"> <label class="checklabel" for="checkboxRegionStatus"></label> <span data-ng-bind="model.status==1 ? (\'ACTIVE\'|translate) : (\'INACTIVE\'|translate)" class="checklabelText"></span></div><div data-ng-if="(((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="col-sm-3 col-sm-offset-9"><button data-ng-if="!edit" ng-click="save()" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button> <button data-ng-if="edit" ng-click="update()" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/location/detailLocation/detailLocation.view.html','<div class="container"><div class="col-sm-5 field"><div class="row hlabel" data-ng-bind="\'LOCATION_LOCATION_TITLE_DETAILS\' | translate"></div><div class="row margcreatetop" data-ng-if="model.name"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_NAME\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-bind="model.name"></span><br data-ng-if="model.name2 || model.name3"><span data-ng-bind="model.name2"></span><br data-ng-if="model.name3"><span data-ng-bind="model.name3"></span></div></div><div class="row" data-ng-if="model.ident"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_LOCATIONID\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.ident"></div></div><div class="row" data-ng-if="model.get_state"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_STATE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.get_state.name"></div></div><div class="row" data-ng-if="model.street"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_STREET\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.street"></div></div><div class="row" data-ng-if="model.postalcode"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PLZ\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.postalcode"></div></div><div class="row" data-ng-if="model.city"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PLACE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.city"></div></div><div class="row" data-ng-if="model.telephone"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PHONE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.telephone"></div></div><div class="row" data-ng-if="model.fax"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_FAX\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.fax"></div></div><div class="row" data-ng-if="model.comment"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_NOTICE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.comment"></div></div><div class="row" data-ng-if="model.alt_description_check"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_SSC\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.alt_description_check"></div></div><div class="row" data-ng-if="model.alt_description_user"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_SSH\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.alt_description_user"></div></div></div><div class="col-sm-5 col-sm-offset-1 field"><div class="row hlabel" data-ng-bind="\'LOCATION_LOCATION_TITLE_DETAILS_STATUS\' | translate"></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_STATUS\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-if="model.status == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span> <span data-ng-if="model.status == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_FREEZ\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-if="model.fridge_exchange == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span> <span data-ng-if="model.fridge_exchange == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_LOKAL\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-if="model.loc_kg_programm == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span> <span data-ng-if="model.loc_kg_programm == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_MONITOR\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-if="model.monitoring == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span> <span data-ng-if="model.monitoring == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_LUMINOUSCOLOR\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-if="model.luminous_color == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span> <span data-ng-if="model.luminous_color == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_CLIMATE_PROTECTION\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-if="model.climate_protection == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span> <span data-ng-if="model.climate_protection == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_FRIDGE_EXCHANGE_INTERVENTION\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-if="model.fridge_exchange_intervention == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span> <span data-ng-if="model.fridge_exchange_intervention == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_QUART\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-if="model.quartier_approach == 1">{{\'LOCATION_ACTIVE\' | translate}} ({{implode(model.location_quarters, \', \', \'name\')}})</span> <span data-ng-if="model.quartier_approach == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div></div></div><div class="col-sm-5 field"><div class="row hlabel" data-ng-bind="\'LOCATION_PRIVACY_TITLE\' | translate"></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_NAME\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.privacy_name"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_STREET\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.privacy_street"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_PLZ\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.privacy_postalcode"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_CITY\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.privacy_city"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_PHONE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.privacy_telephone"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_EMAIL\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.privacy_email"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_INTERNET\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.privacy_internet"></div></div></div><div class="col-sm-5 col-sm-offset-1 field"><div class="row hlabel" data-ng-bind="\'LOCATION_AUTHORITY_TITLE\' | translate"></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_AUTHORITY_NAME\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.authority_name"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_STREET\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.authority_street"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_PLZ\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.authority_postalcode"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_CITY\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.authority_city"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_PHONE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.authority_telephone"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_EMAIL\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.authority_email"></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PRIVACY_INTERNET\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.authority_internet"></div></div></div></div>');
$templateCache.put('templates/components/content/location/detailOrganisation/detailOrganisation.view.html','<div class="container"><div class="col-sm-5 field"><div class="row hlabel" data-ng-bind="\'LOCATION_ORGANISATION_TITLE_DETAILS\' | translate"></div><div class="row margcreatetop" data-ng-if="model.name"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_NAME\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.name"></div></div><div class="row" data-ng-if="model.get_states"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_STATE\' | translate"></div><div class="fieldContent col-sm-7"><span data-ng-repeat="state in model.get_states"><span ng-if="$index !== 0">,</span> <span data-ng-bind="state.name"></span></span></div></div><div class="row" data-ng-if="model.ident"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_LOCATIONID\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.ident"></div></div><div class="row" data-ng-if="model.get_state"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_STATE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.get_state.name"></div></div><div class="row" data-ng-if="model.street"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_STREET\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.street"></div></div><div class="row" data-ng-if="model.postalcode"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PLZ\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.postalcode"></div></div><div class="row" data-ng-if="model.city"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PLACE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.city"></div></div><div class="row" data-ng-if="model.telephone"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_PHONE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.telephone"></div></div><div class="row" data-ng-if="model.fax"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_FAX\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.fax"></div></div><div class="row" data-ng-if="model.comment"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_NOTICE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.comment"></div></div><div class="row" data-ng-if="model.alt_description_check"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_SSC\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.alt_description_check"></div></div><div class="row" data-ng-if="model.alt_description_user"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_SSH\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.alt_description_user"></div></div></div></div>');
$templateCache.put('templates/components/content/location/detailRegion/detailRegion.view.html','<div class="container"><div class="col-sm-5 field"><div class="row hlabel" data-ng-bind="\'LOCATION_REGION_TITLE_DETAILS\' | translate"></div><div class="row margcreatetop" data-ng-if="model.name"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_NAME\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.name"></div></div><div class="row" data-ng-if="model.get_states"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_STATE\' | translate"></div><div class="fieldContent col-sm-7"><span data-ng-repeat="state in model.get_states"><span ng-if="$index !== 0">,</span> <span data-ng-bind="state.name"></span></span></div></div><div class="row" data-ng-if="model.organisation"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_ORGANISATION\' | translate"></div><div class="fieldContent col-sm-7" data-ng-bind="model.organisation.name"></div></div><div class="row" data-ng-if="model.states"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_STATE\' | translate"></div><div class="fieldContent col-sm-7"><span data-ng-repeat="state in model.states"><span ng-if="$index !== 0">,</span> <span data-ng-bind="state.name"></span></span></div></div><div class="row"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_STATUS\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-if="model.status == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span> <span data-ng-if="model.status == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div></div></div></div>');
$templateCache.put('templates/components/content/location/search/search.view.html','<div><div class="container"><div class="row"><div class="col-sm-4"><form ng-submit="search()"><input data-ng-model="searchfield" class="createinputter" type="search" placeholder="{{\'SEARCH_TITLE_LOCATIONS\'| translate}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div><div class="col-sm-3"><span data-toggle="collapse" href="#filter-collapse" ng-click="showDetails = !showDetails"><a class="searchtext"><span data-ng-bind="\'SEARCH_MORE\' | translate"></span> <i class="glyphicon" aria-hidden="true" ng-class="{\'glyphicon-chevron-right\': !showDetails, \'glyphicon-chevron-down\': showDetails}"></i></a></span></div><div class="col-sm-5 text-right" data-ng-if="bSearch"><a class="searchtext" ng-click="clearFilter()"><i class="fa fa-remove marg-right-small" aria-hidden="true"></i>{{\'SEARCH_RESET\' | translate}}</a></div></div></div><div class="collapse" id="filter-collapse"><div class="graybg margcreatetop"><div class="container"><div class="push-top"></div><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_LOCATION\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((location_id + \'\').length == 0) || (location_id == null)) && required && saved}" class="createdropper" ng-model="location_id" id="filter"><option ng-repeat="item in dropLocation" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-6 col-sm-offset-1"><label for="places" ng-bind="\'SEARCH_REGION\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((region_id + \'\').length == 0) || (region_id == null)) && required && saved}" class="createdropper" ng-model="region_id" id="places"><option ng-repeat="item in dropRegion" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-3"><label for="filter-is-only-active" ng-bind="\'Nur Aktive Eintr\xE4ge\' | translate" class="ssc-filterlabel"></label> <input type="checkbox" ng-true-value="1" ng-false-value="0" ng-disabled="isDisabled" ng-model="isOnlyActive" id="filter-is-only-active"> <label class="checklabel" for="filter-is-only-active"></label> <span data-ng-bind="isOnlyActive === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="col-sm-6 col-sm-offset-6 push-bottom"><div class="row"><div class="col-sm-offset-6 col-sm-6"><button type="submit" class="greybutton" ng-click="search()"><i class="fa fa-filter" aria-hidden="true"></i> <span data-ng-bind="\'SEARCH_SEARCH\' | translate"></span></button></div></div></div></div></div></div></div>');
$templateCache.put('templates/components/content/news/newsBox/newsBox.view.html','<div class="news-box"><div class="col-md-12" data-ng-if="length > 0"><div class="col-md-12 field-news margcreatebot" ng-repeat="item in news"><div class="row newslabel"><i class="fa fa-newspaper-o marg-right-small" aria-hidden="true"></i>{{item.headline}}</div><div class="row margcreatetop margcreatebot newstext"><div class="col-sm-12 field-text" data-ng-bind-html="trustAsHtml(item.text)"></div></div></div></div></div>');
$templateCache.put('templates/components/content/news/newsCreate/newsCreate.view.html','<div class="container"><div class="row"><div class="col-sm-12"><h4><span data-ng-if="!edit" data-ng-bind="\'NEWS_CREATE_TITLE\'| translate"></span> <span data-ng-if="edit" data-ng-bind="\'NEWS_UPDATE_TITLE\'| translate:{name:name}"></span></h4><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div><div class="col-sm-12 field"><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.headline + \'\').length == 0) || (model.headline == null)) && required.headline && saved}" class="col-sm-4 col-md-2 ilabel"><span data-ng-bind="\'NEWS_CREATE_HEADER\' | translate"></span> <span data-ng-if="required.headline">*</span></div><div class="col-sm-7 col-md-9"><input data-ng-class="{\'input-required-border\': (((model.headline + \'\').length == 0) || (model.headline == null)) && required.headline && saved}" class="createinputter" ng-model="model.headline"></div><div data-ng-if="(((model.headline + \'\').length == 0) || (model.headline == null)) && required.headline && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.text + \'\').length == 0) || (model.text == null)) && required.text && saved}" class="col-sm-4 col-md-2 ilabel"><span data-ng-bind="\'NEWS_CREATE_TEXT\' | translate"></span> <span data-ng-if="required.text">*</span></div><div class="col-sm-7 col-md-9"><textarea ng-model="model.text" ng-model-options="{updateOn: \'blur\'}" class="createinputter" ui-tinymce="editorOptions"></textarea></div><div data-ng-if="(((model.text + \'\').length == 0) || (model.text == null)) && required.text && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div><div class="row"><div data-ng-class="{\'input-required\': (((model.valid_from + \'\').length == 0) || (model.valid_from == null)) && required.valid_from && saved}" class="col-sm-4 col-md-2 ilabel"><span data-ng-bind="\'NEWS_CREATE_ONLINESTART\' | translate"></span> <span data-ng-if="required.valid_from">*</span></div><div class="col-sm-8 col-md-4"><input data-ng-class="{\'input-required-border\': (((model.valid_from + \'\').length == 0) || (model.valid_from == null)) && required.valid_from && saved}" class="createinputter" id="startdate" ssc-datepicker="" data-ng-model="model.valid_from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE" datepicker-type="fromto" datepicker-end-id="enddate"></div><div data-ng-if="(((model.valid_from + \'\').length == 0) || (model.valid_from == null)) && required.valid_from && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div><div class="clearing"></div><div data-ng-class="{\'input-required\': (((model.valid_until + \'\').length == 0) || (model.valid_until == null)) && required.valid_until && saved}" class="col-sm-4 col-md-2 ilabel"><span data-ng-bind="\'NEWS_CREATE_ONLINESTOP\' | translate"></span> <span data-ng-if="required.valid_until">*</span></div><div class="col-sm-8 col-md-4"><input data-ng-class="{\'input-required-border\': (((model.valid_until + \'\').length == 0) || (model.valid_until == null)) && required.valid_until && saved}" class="createinputter" id="enddate" ssc-datepicker="" data-ng-model="model.valid_until" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE" datepicker-type="fromto" datepicker-start-id="startdate"></div><div data-ng-if="(!model.valid_until) && required.valid_until && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.role + \'\').length == 0) || (model.role == null)) && required.role && saved}" class="col-sm-4 col-md-2 ilabel"><span data-ng-bind="\'NEWS_CREATE_ROLE\' | translate"></span> <span data-ng-if="required.role">*</span></div><div class="col-sm-8 col-md-4"><ui-select on-select="OnClickSelect($item)" on-remove="OnRemoveSelect($item)" data-ng-class="{\'input-required-border\': (((model.role + \'\').length == 0) || (model.role == null)) && required.role && saved}" class="ssc-ui-select" multiple="" theme="selectize" sortable="true" ng-model="model.rolenews"><ui-select-match>{{$item.role}}</ui-select-match><ui-select-choices repeat="item in dropRole | filter:$select.search"><div data-ng-bind-html="item.role"></div></ui-select-choices></ui-select></div><div data-ng-if="(((model.role + \'\').length == 0) || (model.role == null)) && required.role && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div><div class="clearing"></div><div data-ng-class="{\'input-required\': (((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved}" class="col-sm-4 col-md-2 ilabel"><span data-ng-bind="\'LOCATION_STATUS\' | translate"></span> <span data-ng-if="required.status">*</span></div><div class="col-sm-3 col-sm-offset-5 col-md-offset-1"><input data-ng-class="{\'input-required-border\': (((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved}" type="checkbox" ng-model="model.status" ng-true-value="1" ng-false-value="0" ng-chid="checkboxNews" id="checkboxNews" ng-checked="model.status == 1"> <label class="checklabel" for="checkboxNews"></label> <span data-ng-bind="model.status==1 ? (\'ACTIVE\'|translate) : (\'INACTIVE\'|translate)" class="checklabelText"></span></div><div data-ng-if="(((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div></div></div><div class="col-sm-5 col-sm-offset-7 col-md-3 col-md-offset-9"><button data-ng-if="!edit" ng-click="save()" class="redbutton" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button> <button data-ng-if="edit" ng-click="update()" class="redbutton" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/news/newsDetail/newsDetail.view.html','<div class="container"><div class="col-sm-5 field"><div class="row hlabel" data-ng-bind="\'NEWS_NEWS_TITLE_DETAILS\' | translate"></div><div class="row" margcreatetop="" data-ng-if="model.headline"><div class="col-sm-4 fieldLabel" data-ng-bind="\'NEWS_CREATE_HEADER\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.headline"></div></div><div class="row" data-ng-if="model.text"><div class="col-sm-4 fieldLabel" data-ng-bind="\'NEWS_CREATE_TEXT\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind-html="trustAsHtml(model.text)"></div></div><div class="row" data-ng-if="model.userrole"><div class="col-sm-4 fieldLabel" data-ng-bind="\'NEWS_CREATE_ROLE\' | translate"></div><div class="col-sm-7 fieldContent"><div ng-repeat="item in model.userrole" data-ng-bind="item.role"></div></div></div><div class="row" data-ng-if="model.valid_from"><div class="col-sm-4 fieldLabel" data-ng-bind="\'NEWS_CREATE_ONLINESTART\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.valid_from"></div></div><div class="row" data-ng-if="model.valid_until"><div class="col-sm-4 fieldLabel" data-ng-bind="\'NEWS_CREATE_ONLINESTOP\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.valid_until"></div></div><div class="row" data-ng-if="model.status"><div class="col-sm-4 fieldLabel" data-ng-bind="\'LOCATION_STATUS\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-if="model.status == 1" data-ng-bind="\'LOCATION_ACTIVE\' | translate"></span> <span data-ng-if="model.status == 0" data-ng-bind="\'LOCATION_INACTIVE\' | translate"></span></div></div></div></div>');
$templateCache.put('templates/components/content/news/search/search.view.html','<div><div class="container"><div class="row"><div class="col-sm-4"><form ng-submit="search()"><input data-ng-model="searchfield" class="createinputter" type="search" placeholder="{{\'SEARCH_TITLE_NEWS\' | translate}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div><div class="col-sm-3"><span data-toggle="collapse" href="#filter-collapse" ng-click="showDetails = !showDetails"><a class="searchtext"><span data-ng-bind="\'SEARCH_MORE\' | translate"></span> <i class="glyphicon" aria-hidden="true" ng-class="{\'glyphicon-chevron-right\': !showDetails, \'glyphicon-chevron-down\': showDetails}"></i></a></span></div><div class="col-sm-5 text-right" data-ng-if="bSearch"><a class="searchtext" ng-click="clearFilter()"><i class="fa fa-remove marg-right-small" aria-hidden="true"></i>{{\'SEARCH_RESET\' | translate}}</a></div></div></div><div class="collapse" id="filter-collapse"><div class="graybg margcreatetop"><div class="container"><div class="push-top"></div><div class="col-sm-5"><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="time" data-ng-model="time"></div><div class="col-sm-6 col-sm-offset-1"><div class="row"><div class="col-sm-6"><label for="from" ng-bind="\'SEARCH_FROM\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div><div class="col-sm-6"><label for="to" ng-bind="\'SEARCH_TO\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div><div class="col-sm-6 col-sm-offset-6 push-bottom"><div class="row"><div class="col-sm-offset-6 col-sm-6"><button type="submit" class="greybutton" ng-click="search()"><i class="fa fa-filter" aria-hidden="true"></i> <span data-ng-bind="\'SEARCH_SEARCH\' | translate"></span></button></div></div></div></div></div></div></div>');
$templateCache.put('templates/components/content/review/reportList/reportList.view.html','<div class="col-sm-12 minimal-box margcreatetop"><div class="field-text"><div class="report-list-title"><b ng-bind="(\'BTN_REVIEW\' | translate)"></b> <span style="color: #aaa">(aktualisiert automatisch)</span></div><div ng-if="(!data || data.length == 0)" ng-bind="(\'REVIEW_NONE_CREATED\' | translate)"></div><div ng-repeat="item in data track by item.token" class="row report-list-item"><div ng-if="item.is_success" ng-class="{\'font-weight-bold\': !item.seen_at}"><div class="col-xs-7"><a href="{{apiRoot}}report/download?token={{item.token}}" target="_blank" title="Herunterladen"><i class="fa fa-file" aria-hidden="true"></i> {{item.name}}</a></div><div class="col-xs-5 align-right">{{item.created_at}}\u2192{{item.finished_at_short}}</div></div><div ng-if="item.finished_at && !item.is_success"><div class="col-xs-7"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{item.name}} ({{\'FORM_ERROR_GENERIC\' | translate}})</div><div class="col-xs-5 align-right">{{item.created_at}}\u2192{{item.finished_at_short}}</div></div><div ng-if="!item.finished_at"><div class="col-xs-7"><i class="fa fa-hourglass"></i> {{item.name}}</div><div class="col-xs-5 align-right">{{item.created_at}}</div></div></div></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/search/search.view.html','<div><div class="container"><div class="row hidden-xs"><div class="col-sm-6 col-sm-offset-6"><label for="consultation-type" class="ssc-filterlabel" data-ng-bind="\'SEARCH_CONSULTATION_TYPE\' | translate"></label></div></div><div class="row"><div class="col-sm-4"><form ng-submit="search()"><input data-ng-model="searchfield" class="createinputter" type="search" placeholder="{{\'SEARCH_TITLE_SSC\'| translate}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div><div class="col-sm-2"><span data-toggle="collapse" href="#filter-collapse" ng-click="showDetails = !showDetails"><a class="searchtext"><span data-ng-bind="\'SEARCH_MORE\' | translate"></span> <i class="glyphicon" aria-hidden="true" ng-class="{\'glyphicon-chevron-right\': !showDetails, \'glyphicon-chevron-down\': showDetails}"></i></a></span></div><div class="col-sm-3"><label for="consultation-type" class="visible-xs-block ssc-filterlabel" data-ng-bind="\'SEARCH_CONSULTATION_TYPE\' | translate"></label><select class="createdropper" id="consultation-type" ng-model="consultationType" ng-change="consultationTypeChanged()"><option ng-repeat="item in dropConsultation" ng-value="item.name" data-ng-bind="item.description"></option></select></div><div class="col-sm-3 text-right" data-ng-if="bSearch"><a class="searchtext" ng-click="clearFilter()"><i class="fa fa-remove marg-right-small" aria-hidden="true"></i>{{\'SEARCH_RESET\' | translate}}</a></div></div></div><div class="collapse" id="filter-collapse"><div class="graybg margcreatetop"><div class="container"><div class="row push-top"><div class="col-sm-6"><label for="filter" ng-bind="\'SEARCH_FILTER\' | translate" class="ssc-filterlabel"></label><select class="createdropper" id="filter" ng-model="householdfilter"><option value=""></option><option permission="" permission-only=\'["SSH", "LOKO", "REKO", "BUKO", "EFB", "ADMIN"]\' value="hh_transferleistung">{{\'SEARCH_SSC_FILTER_3\'| translate}}</option><option permission="" permission-only=\'["SSH", "LOKO", "REKO", "BUKO", "EFB", "ADMIN"]\' value="hh_singleparent">{{\'SEARCH_SSC_FILTER_4\'| translate}}</option><option permission="" permission-only=\'["SSH", "LOKO", "REKO", "BUKO", "EFB", "ADMIN"]\' value="hh_retired">{{\'SEARCH_SSC_FILTER_5\'| translate}}</option><option permission="" permission-only=\'["LOKO", "TRAINER", "REKO", "BUKO", "EFB", "ADMIN"]\' value="hh_heating_tool">{{\'SEARCH_SSC_FILTER_6\' | translate}}</option><option permission="" permission-only=\'["LOKO", "TRAINER", "REKO", "BUKO", "EFB", "ADMIN"]\' value="hh_heating_costs">{{\'SEARCH_SSC_FILTER_7\' | translate}}</option><option permission="" permission-only=\'["LOKO", "TRAINER", "REKO", "BUKO", "EFB", "ADMIN"]\' value="hh_electricity_invoice">{{\'SEARCH_SSC_FILTER_8\' | translate}}</option></select></div><div class="col-sm-3"><label for="role" ng-bind="\'SEARCH_ROLE\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((model.role_id + \'\').length == 0) || (model.role_id == null)) && required && saved}" class="createdropper" id="role" ng-model="roleSlug" ng-change="updateLocation()"><option value=""></option><option ng-repeat="item in dropRole" ng-value="item.slug" data-ng-bind="item.role"></option></select></div><div class="col-sm-3"><label for="places" ng-bind="\'SEARCH_PLACES\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((model.location_id + \'\').length == 0) || (model.location_id == null)) && required && saved}" class="createdropper" id="places" ng-model="location"><option value=""></option><option ng-repeat="item in dropLocation" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div><div class="row push"><div class="col-sm-3"><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="time" ng-disabled="(from || to || !timeframe_setting)" ssc-datepicker="" data-ng-model="timeframe" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY"></div><div class="col-sm-3"><label for="timeframesetting" class="ssc-filterlabel">&nbsp;</label><select class="createdropper" id="timeframesetting" ng-model="timeframe_setting"><option value="" selected="">--Datumsart--</option><option value="ssc.created_at">{{\'SEARCH_SSC_TIMEFRAME_1\'| translate}}</option><option value="second_visit_clearance">{{\'SEARCH_SSC_TIMEFRAME_5\'| translate}}</option><option value="ssc.first_visit_at">{{\'SEARCH_SSC_TIMEFRAME_2\'| translate}}</option><option value="ssc.second_visit_at">{{\'SEARCH_SSC_TIMEFRAME_3\'| translate}}</option><option value="closed_date">{{\'SEARCH_SSC_TIMEFRAME_4\'| translate}}</option><option value="monitoring_closed_date">{{\'SEARCH_SSC_TIMEFRAME_6\'| translate}}</option></select></div><div class="col-sm-6"><div class="row"><div class="col-sm-6"><label for="from" ng-bind="\'SEARCH_FROM\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="from" ng-disabled="timeframe || !timeframe_setting" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div><div class="col-sm-6"><label for="to" ng-bind="\'SEARCH_TO\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="to" ng-disabled="timeframe || !timeframe_setting" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div><div class="col-sm-6 col-sm-offset-6 push-bottom"><div class="row"><div class="col-sm-offset-6 col-sm-6"><button type="submit" class="greybutton" ng-click="search()"><i class="fa fa-filter" aria-hidden="true"></i> <span data-ng-bind="\'SEARCH_SEARCH\' | translate"></span></button></div></div></div></div></div></div></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/sscCopyButton/sscCopyButton.view.html','<button type="button" class="redbutton" ng-disabled="isRunning || disabled" ng-click="copySsc()"><i class="fa fa-copy marg-right-small" aria-hidden="true"></i>{{\'BTN_SSC_COPY\' | translate}}</button>');
$templateCache.put('templates/components/content/stromsparcheck/sscLogButton/sscLogButton.view.html','<a class="navbar-backlink" ui-sref="ssc.log({id: state.id})"><button type="button" class="redbutton"><i class="fa fa-history marg-right-small" aria-hidden="true"></i>{{\'BTN_LOG_HISTORY\' | translate}}</button></a>');
$templateCache.put('templates/components/content/stromsparcheck/plausi/plausi_large.view.html','<div class="plausi-fit"><h4>Plausibilit\xE4tsbox</h4><div class="plausi-article"><header class="row"><span class="plausi-icon plausi-icon-electricity">&nbsp;</span> <span data-ng-bind="\'SSC_PLAUSI_TITLE_ELECTRICITY\' | translate"></span></header><div class="row plausi-head hidden-xs hidden-md"><div class="col-sm-4"><span data-ng-bind="\'SSC_PLAUSI_CONSUMPTION_INVOICE\'| translate"></span></div><div class="col-sm-4"><span data-ng-bind="\'SSC_PLAUSI_CONSUMPTION_ANALYTICS\'| translate"></span><help-pop-over help="TIP_PLAUSI_CONSUMPTION_ANALYTICS"></help-pop-over></div><div class="col-sm-4"><span data-ng-bind="\'SSC_PLAUSI_SAVING_DIRECTHELP\'| translate"></span></div></div><div class="row"><div class="col-sm-12 plausi-head visible-md visible-xs"><span data-ng-bind="\'SSC_PLAUSI_CONSUMPTION_INVOICE\'| translate"></span></div><div class="col-sm-4 col-md-12 col-lg-4 plausi-info"><span data-ng-bind="consumption_invoice"></span></div><div class="col-sm-12 plausi-head visible-md visible-xs"><span data-ng-bind="\'SSC_PLAUSI_CONSUMPTION_ANALYTICS\'| translate"></span><help-pop-over help="TIP_PLAUSI_CONSUMPTION_ANALYTICS"></help-pop-over></div><div class="col-sm-4 col-md-12 col-lg-4 plausi-info"><span data-ng-bind="consumption_analytics"></span></div><div class="col-sm-12 plausi-head visible-md visible-xs"><span data-ng-bind="\'SSC_PLAUSI_SAVING_DIRECTHELP\'| translate"></span></div><div class="col-sm-4 col-md-12 col-lg-4 plausi-info"><span data-ng-bind="consumption_directhelp"></span></div></div></div><div class="plausi-article"><header class="row"><span class="plausi-icon plausi-icon-water">&nbsp;</span> <span data-ng-bind="\'SSC_PLAUSI_TITLE_WATER\' | translate"></span></header><div class="row plausi-head hidden-md hidden-xs"><div class="col-sm-6"><span data-ng-bind="\'SSC_PLAUSI_WATER_TOTAL\'| translate"></span><help-pop-over help="TIP_PLAUSI_WATER_TOTAL"></help-pop-over></div><div class="col-sm-6"><span data-ng-bind="\'SSC_PLAUSI_WATER_ESTIMATE\'| translate"></span><help-pop-over help="TIP_PLAUSI_WATER_ESTIMATE"></help-pop-over></div></div><div class="row"><div class="col-sm-12 plausi-head visible-md visible-xs"><span data-ng-bind="\'SSC_PLAUSI_WATER_TOTAL\'| translate"></span><help-pop-over help="TIP_PLAUSI_WATER_TOTAL"></help-pop-over></div><div class="col-sm-6 col-md-12 col-lg-6 plausi-info"><span data-ng-bind="water_total"></span></div><div class="col-sm-12 plausi-head visible-md visible-xs"><span data-ng-bind="\'SSC_PLAUSI_WATER_ESTIMATE\'| translate"></span><help-pop-over help="TIP_PLAUSI_WATER_ESTIMATE"></help-pop-over></div><div class="col-sm-6 col-md-12 col-lg-6 plausi-info"><span data-ng-bind="water_estimate"></span></div></div><div class="row plausi-head hidden-md hidden-xs"><div class="col-sm-6"><span data-ng-bind="\'SSC_PLAUSI_CONSUMPTION_SHOWER\'| translate"></span><help-pop-over help="TIP_PLAUSI_CONSUMPTION_SHOWER"></help-pop-over></div><div class="col-sm-6"><span data-ng-bind="\'SSC_PLAUSI_SAVING_DIRECTHELP\'| translate"></span></div></div><div class="row"><div class="col-sm-12 plausi-head visible-md visible-xs"><span data-ng-bind="\'SSC_PLAUSI_CONSUMPTION_SHOWER\'| translate"></span><help-pop-over help="TIP_PLAUSI_CONSUMPTION_SHOWER"></help-pop-over></div><div class="col-sm-6 col-md-12 col-lg-6 plausi-info"><span data-ng-bind="consumption_shower"></span></div><div class="col-sm-12 plausi-head visible-md visible-xs"><span data-ng-bind="\'SSC_PLAUSI_SAVING_DIRECTHELP\'| translate"></span></div><div class="col-sm-6 col-md-12 col-lg-6 plausi-info"><span data-ng-bind="water_saving_directhelp"></span></div></div></div><div class="plausi-article"><div class="row plausi-head"><span data-ng-bind="\'SSC_PLAUSI_EK_PLANNED_HELP\'| translate"></span></div><div class="row plausi-info"><span data-ng-bind="ek_wert"></span></div></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/plausi/plausi_small.view.html','<div class="plausi-thin"><h4>Plausibilit\xE4tsbox</h4><div class="plausi-article"><header><span class="plausi-icon plausi-icon-electricity">&nbsp;</span> <span data-ng-bind="\'SSC_PLAUSI_TITLE_ELECTRICITY\' | translate"></span></header><div class="plausi-head"><span data-ng-bind="\'SSC_PLAUSI_CONSUMPTION_INVOICE\'| translate"></span></div><div class="plausi-info" ng-bind="consumption_invoice"></div><div class="plausi-head"><span data-ng-bind="\'SSC_PLAUSI_CONSUMPTION_ANALYTICS\'| translate"></span><help-pop-over help="TIP_PLAUSI_CONSUMPTION_ANALYTICS"></help-pop-over></div><div class="plausi-info" ng-bind="consumption_analytics"></div><div class="plausi-head"><span data-ng-bind="\'SSC_PLAUSI_SAVING_DIRECTHELP\'| translate"></span></div><div class="plausi-info" ng-bind="consumption_directhelp"></div></div><div class="plausi-article"><header><span class="plausi-icon plausi-icon-water">&nbsp;</span> <span data-ng-bind="\'SSC_PLAUSI_TITLE_WATER\' | translate"></span></header><div class="plausi-head"><span data-ng-bind="\'SSC_PLAUSI_WATER_TOTAL\'| translate"></span><help-pop-over help="TIP_PLAUSI_WATER_TOTAL"></help-pop-over></div><div class="plausi-info" ng-bind="water_total"></div><div class="plausi-head"><span data-ng-bind="\'SSC_PLAUSI_WATER_ESTIMATE\'| translate"></span><help-pop-over help="TIP_PLAUSI_WATER_ESTIMATE"></help-pop-over></div><div class="plausi-info" ng-bind="water_estimate"></div><div class="plausi-head"><span data-ng-bind="\'SSC_PLAUSI_CONSUMPTION_SHOWER\'| translate"></span><help-pop-over help="TIP_PLAUSI_CONSUMPTION_SHOWER"></help-pop-over></div><div class="plausi-info" ng-bind="consumption_shower"></div><div class="plausi-head"><span data-ng-bind="\'SSC_PLAUSI_SAVING_DIRECTHELP\'| translate"></span></div><div class="plausi-info" ng-bind="water_saving_directhelp"></div></div><div class="plausi-article"><div class="plausi-head"><span data-ng-bind="\'SSC_PLAUSI_EK_PLANNED_HELP\'| translate"></span></div><div class="plausi-info" ng-bind="ek_wert"></div></div></div>');
$templateCache.put('templates/components/content/user/search/search.view.html','<div data-ng-init="createDatepicker()"><div class="container"><div class="row"><div class="col-sm-4"><form ng-submit="search()"><input data-ng-model="searchfield" class="createinputter" type="search" placeholder="{{\'SEARCH_TITLE_USER\' | translate}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div><div class="col-sm-3"><span data-toggle="collapse" href="#filter-collapse" ng-click="showDetails = !showDetails"><a class="searchtext"><span data-ng-bind="\'SEARCH_MORE\' | translate"></span> <i class="glyphicon" aria-hidden="true" ng-class="{\'glyphicon-chevron-right\': !showDetails, \'glyphicon-chevron-down\': showDetails}"></i></a></span></div><div class="col-sm-5 text-right" data-ng-if="bSearch"><a class="searchtext" ng-click="clearFilter()"><i class="fa fa-remove marg-right-small" aria-hidden="true"></i>{{\'SEARCH_RESET\' | translate}}</a></div></div></div><div class="collapse" id="filter-collapse"><div class="graybg margcreatetop"><div class="container"><div class="push-top"></div><div class="col-sm-4"><label for="filter" ng-bind="\'SEARCH_LOCATION\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((location_id + \'\').length == 0) || (location_id == null)) && required && saved}" class="createdropper" ng-model="location_id" id="filter"><option ng-repeat="item in dropLocation" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-4"><label for="filter-right" ng-bind="\'SEARCH_RIGHT\' | translate" class="ssc-filterlabel"></label><select class="createdropper" ng-model="user_right" id="filter-right"><option ng-repeat="item in dropRights" value="{{item.name}}" data-ng-bind="item.label | translate"></option></select></div><div class="col-sm-3" permission="" permission-only="[\'ADMIN\',\'LOKO\',\'BUKO\',\'REKO\',\'EFB\',\'TRAINER\']"><label for="filter-is-only-active" ng-bind="\'Nur Aktive Nutzer\' | translate" class="ssc-filterlabel"></label> <input type="checkbox" ng-true-value="1" ng-false-value="0" ng-disabled="isDisabled" ng-model="isOnlyActive" id="filter-is-only-active"> <label class="checklabel" for="filter-is-only-active"></label> <span data-ng-bind="isOnlyActive === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="col-sm-6 col-sm-offset-6 push-bottom"><div class="row"><div class="col-sm-offset-6 col-sm-6"><button type="submit" class="greybutton" ng-click="search()"><i class="fa fa-filter" aria-hidden="true"></i> <span data-ng-bind="\'SEARCH_SEARCH\' | translate"></span></button></div></div></div></div></div></div></div>');
$templateCache.put('templates/components/content/user/twoFactorAuth/twoFactorAuth.view.html','<div class="container"><div class="row"><div class="col-sm-8 col-md-6 field"><div class="row hlabel"><span ng-bind="\'USER_CREATE_TWO_FACTOR_AUTH_HEADER\' | translate"></span></div><div data-ng-if="showErrorBox()" class="col-sm-12 errorfield margcreatetop margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" ng-bind="error"></div></div></div><div ng-show="isLoading" style="height: 25em;"></div><div ng-show="isLoading === false"><div class="row margcreatetop"><div class="col-sm-11 ilabel"><span ng-bind="\'USER_TWO_FACTOR_TOKEN_DESCRIPTION\' | translate"></span></div></div><div class="row margcreatebot"><div class="col-sm-11 ilabel"><span ng-bind="\'USER_TWO_FACTOR_TOKEN\' | translate"></span></div><div class="col-sm-11"><textarea class="createinputter" ng-model="model.secret" disabled=""></textarea></div></div><div class="row margcreatebot"><div class="col-sm-11 ilabel"><span ng-bind="\'USER_TWO_FACTOR_PASSWORD_DESCRIPTION\' | translate"></span></div></div><div class="row margcreatebot"><div class="col-sm-4 ilabel"><span ng-bind="\'USER_TWO_FACTOR_PASSWORD\' | translate"></span></div><div class="col-sm-7"><input class="createinputter" ng-model="model.one_time_password"></div></div></div></div></div><div class="row"><div class="col-sm-3 col-sm-offset-9"><button ng-click="save()" class="redbutton" type="submit" ng-disabled="isLoading || isSaving"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_CONFIRM\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/user/userChangePassword/userChangePassword.view.html','<div class="container"><div ng-show="isNotFound" style="text-align:center"><h4>Nicht gefunden</h4></div><div ng-show="!isNotFound"><div class="row"><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && (!check() || pwInvalid)" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div></div><div class="row"><div class="col-sm-6 field"><div data-ng-if="mode == MODE_OTHER_PW" class="row hlabel" data-ng-bind="\'BTN_CHANGE_USER_PASSWORD\' | translate"></div><div data-ng-if="mode == MODE_MY_PW" class="row hlabel" data-ng-bind="\'BTN_CHANGE_MY_PASSWORD\' | translate"></div><div class="margcreatetop"></div><div data-ng-if="mode == MODE_OTHER_PW"><div class="row"><div class="col-sm-4 ilabel" data-ng-bind="\'USER_FULLNAME\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.name"></div></div><div class="row"><div class="col-sm-4 ilabel" data-ng-bind="\'USER_USERNAME\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.username"></div></div></div><div class="row ilabel">{{\'FORM_ERROR_PW_GUIDELINES\' | translate}}</div><div class="row" data-ng-class="{\'error\': (pwInvalid && saved) || ((((model.newPassword + \'\').length == 0) || (model.newPassword == null)) && required.newPassword && saved)}"><div class="col-sm-5 ilabel"><span data-ng-bind="\'USER_NEW_PASSWORD\' | translate"></span> <span data-ng-if="required.newPassword">*</span></div><div class="col-sm-6"><input class="createinputter" ng-model="model.newPassword" type="password" ng-change="checkPw()"></div><div data-ng-if="(((model.newPassword + \'\').length == 0) || (model.newPassword == null)) && required.newPassword && saved || (pwInvalid && saved)" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-sm-5 ilabel" data-ng-class="{\'input-required\': (((model.newPasswordRepeat + \'\').length == 0) || (model.newPasswordRepeat == null) || model.newPasswordRepeat != model.newPassword) && required.newPasswordRepeat && saved}"><span data-ng-bind="\'USER_PASSWORD_REPEAT\' | translate"></span> <span data-ng-if="required.newPasswordRepeat">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.newPasswordRepeat + \'\').length == 0) || (model.newPasswordRepeat == null) || model.newPasswordRepeat != model.newPassword) && required.newPasswordRepeat && saved}" class="createinputter" ng-model="model.newPasswordRepeat" type="password"></div><div data-ng-if="(((model.newPasswordRepeat + \'\').length == 0) || (model.newPasswordRepeat == null) || model.newPasswordRepeat != model.newPassword) && required.newPasswordRepeat && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatebot"></div></div></div><div class="row"><div class="col-sm-3 col-sm-offset-9"><button ng-click="save()" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_CHANGE_PASSWORD\' | translate"></span></button></div></div></div></div>');
$templateCache.put('templates/components/content/user/userDetail/userDetail.view.html','<div class="container"><div ng-show="notFound" style="text-align:center"><h4>Nicht gefunden</h4></div><div ng-show="!notFound"><div data-ng-controller="submenuController"><div class="row"><div class="col-sm-4" data-ng-if="id == userId"><a href="" ui-sref="user.changeMyPassword"><button type="button" class="redbutton" data-ng-bind="\'BTN_CHANGE_MY_PASSWORD\' | translate"></button></a></div><div class="col-sm-4" ng-show="model.CAN_WRITE"><a href="" ui-sref="user.update({id: id})"><button type="button" class="redbutton" data-ng-bind="\'BTN_USER_UPDATE\' | translate"></button></a></div></div></div><div class="row"><div class="col-sm-12"><div class="col-sm-5 field"><div class="row hlabel" data-ng-bind="\'USER_DETAIL_TITLE\' | translate"></div><div class="row margcreatetop" data-ng-if="model.name"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_LASTNAME\' | translate"></div><div class="col-sm-7 fieldContent"><span data-ng-bind="model.salutation | capitalize"></span> <span data-ng-bind="model.name"></span></div></div><div class="row" data-ng-if="model.email"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_MAIL\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.email"></div></div><div class="row" data-ng-if="model.username"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_USERNAME\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="model.username"></div></div></div></div></div><div class="row" data-ng-repeat="place in model.user_role_map"><div class="col-sm-12" ng-repeat="item in place.user_role_area_map.location" ng-if="$even"><div class="field margcreatetop col-sm-6"><div class="row hlabel" data-ng-if="place.user_role_area_map.location[$index].name"><span data-ng-bind="\'USER_LOCATION\' | translate"></span>: <span data-ng-bind="place.user_role_area_map.location[$index].name"></span></div><div class="row" data-ng-if="place.user_role_area_map.location[$index].mobilephone"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_MOBILEPHONE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.location[$index].mobilephone"></div></div><div class="row" data-ng-if="place.user_role_area_map.location[$index].street"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_STREET\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.location[$index].street"></div></div><div class="row" data-ng-if="place.user_role_area_map.location[$index].postalcode"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_PLZ\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.location[$index].postalcode"></div></div><div class="row" data-ng-if="place.user_role_area_map.location[$index].city"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_PLACE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.location[$index].city"></div></div></div><div class="field margcreatetop col-sm-5 col-sm-offset-1" data-ng-if="place.user_role_area_map.location.length > $index + 1"><div class="row hlabel" data-ng-if="place.user_role_area_map.location[$index + 1].name"><span data-ng-bind="\'USER_LOCATION\' | translate"></span>: <span data-ng-bind="place.user_role_area_map.location[$index + 1].name"></span></div><div class="row" data-ng-if="place.user_role_area_map.location[$index + 1].mobilephone"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_MOBILEPHONE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.location[$index + 1].mobilephone"></div></div><div class="row" data-ng-if="place.user_role_area_map.location[$index + 1].street"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_STREET\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.location[$index + 1].street"></div></div><div class="row" data-ng-if="place.user_role_area_map.location[$index + 1].postalcode"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_PLZ\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.location[$index + 1].postalcode"></div></div><div class="row" data-ng-if="place.user_role_area_map.location[$index + 1].city"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_PLACE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.location[$index + 1].city"></div></div></div></div><div class="col-sm-12" ng-repeat="item in place.user_role_area_map.region" ng-if="$even"><div class="field margcreatetop col-sm-6"><div class="row hlabel" data-ng-if="place.user_role_area_map.region[$index].name"><span data-ng-bind="\'USER_REGION\' | translate"></span>: <span data-ng-bind="place.user_role_area_map.region[$index].name"></span></div><div class="row" data-ng-if="place.user_role_area_map.region[$index].mobilephone"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_MOBILEPHONE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.region[$index].mobilephone"></div></div><div class="row" data-ng-if="place.user_role_area_map.region[$index].street"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_STREET\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.region[$index].street"></div></div><div class="row" data-ng-if="place.user_role_area_map.region[$index].postalcode"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_PLZ\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.region[$index].postalcode"></div></div><div class="row" data-ng-if="place.user_role_area_map.region[$index].city"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_PLACE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.region[$index].city"></div></div></div><div class="field margcreatetop col-sm-5 col-sm-offset-1" data-ng-if="place.user_role_area_map.location.length > $index + 1"><div class="row hlabel" data-ng-if="place.user_role_area_map.region[$index + 1].name"><span data-ng-bind="\'USER_REGION\' | translate"></span>: <span data-ng-bind="place.user_role_area_map.region[$index + 1].name"></span></div><div class="row" data-ng-if="place.user_role_area_map.region[$index + 1].mobilephone"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_MOBILEPHONE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.region[$index + 1].mobilephone"></div></div><div class="row" data-ng-if="place.user_role_area_map.region[$index + 1].street"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_STREET\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.region[$index + 1].street"></div></div><div class="row" data-ng-if="place.user_role_area_map.region[$index + 1].postalcode"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_PLZ\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.region[$index + 1].postalcode"></div></div><div class="row" data-ng-if="place.user_role_area_map.region[$index + 1].city"><div class="col-sm-4 fieldLabel" data-ng-bind="\'USER_PLACE\' | translate"></div><div class="col-sm-7 fieldContent" data-ng-bind="place.user_role_area_map.region[$index + 1].city"></div></div></div></div></div></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/tile/tile_large.view.html','<div><h4>ID <span data-ng-bind="id"></span> - <span data-ng-bind="name"></span> (<span data-ng-bind="consultation_type.description"></span>)</h4><div class="row overview-large"><div class="col-sm-3 col-xs-4"><div class="tile" ng-click="overview()" title="{{\'SSC_TILE_OVERVIEW\' | translate}}"><div class="icon overview"><span data-ng-if="data.data_overview == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_overview == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_overview == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_OVERVIEW_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_OVERVIEW\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="generalInformation()" title="{{\'SSC_TILE_GENERALINFO\' | translate}}"><div class="icon generalInformation"><span data-ng-if="data.data_generalInformation == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_generalInformation == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_generalInformation == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_GENERALINFO_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_GENERALINFO\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="energy()" title="{{\'SSC_TILE_ENERGY\' | translate}}"><div class="icon energy"><span data-ng-if="data.data_energy == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_energy == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_energy == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_ENERGY_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_ENERGY\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="heat()" title="{{\'SSC_TILE_HEAT\' | translate}}"><div class="icon heat"><span data-ng-if="data.data_heat == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_heat == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_heat == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_HEAT_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_HEAT\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="lighting()" title="{{\'SSC_TILE_LIGHTING\' | translate}}"><div class="icon lighting"><span data-ng-if="data.data_lighting == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_lighting == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_lighting == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_LIGHTING_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_LIGHTING\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="standby()" title="{{\'SSC_TILE_STANDBY\' | translate}}"><div class="icon standby"><span data-ng-if="data.data_standby == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_standby == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_standby == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_STANDBY_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_STANDBY\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="electricBoiler()" title="{{\'SSC_TILE_ELECTRICBOILER\' | translate}}"><div class="icon electricBoiler"><span data-ng-if="data.data_electricBoiler == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_electricBoiler == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_electricBoiler == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_ELECTRICBOILER_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_ELECTRICBOILER\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="toiletFlush()" title="{{\'SSC_TILE_TOILETFLUSH\' | translate}}"><div class="icon toiletFlush"><span data-ng-if="data.data_toiletFlush == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_toiletFlush == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_toiletFlush == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_TOILETFLUSH_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_TOILETFLUSH\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="shower()" title="{{\'SSC_TILE_SHOWER\' | translate}}"><div class="icon shower"><span data-ng-if="data.data_shower == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_shower == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_shower == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_SHOWER_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_SHOWER\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="tap()" title="{{\'SSC_TILE_TAP\' | translate}}"><div class="icon tap"><span data-ng-if="data.data_tap == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_tap == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_tap == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_TAP_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_TAP\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="!data.is_telephone_check"><div class="tile" ng-click="refrigerator()" title="{{\'SSC_TILE_REFRIGERATOR\' | translate}}"><div class="icon refrigerator"><span data-ng-if="data.data_refrigerator == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_refrigerator == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_refrigerator == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_REFRIGERATOR_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_REFRIGERATOR\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="data.has_climate_protection" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="kia()" title="{{\'SSC_TILE_KIA\' | translate}}"><div class="icon kia"><span data-ng-if="data.data_kia == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_kia == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_kia == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_KIA_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_KIA\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="data.has_photovoltaic" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="photovoltaic()" title="{{\'SSC_TILE_PHOTOVOLTAIC\' | translate}}"><div class="icon photovoltaic"><span data-ng-if="data.data_photovoltaic == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_photovoltaic == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_photovoltaic == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_PHOTOVOLTAIC_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_PHOTOVOLTAIC\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="device()" title="{{\'SSC_TILE_DEVICE\' | translate}}"><div class="icon device"><span data-ng-if="data.data_device == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_device == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_device == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_DEVICE_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_DEVICE\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="data.is_telephone_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="telephone()" title="{{\'SSC_TILE_TELEPHONE\' | translate}}"><div class="icon telephone"><span data-ng-if="data.data_telephone_consultation == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_telephone_consultation == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_telephone_consultation == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_TELEPHONE_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_TELEPHONE\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="tips()" title="{{\'SSC_TILE_TIPS\' | translate}}"><div class="icon tips"><span data-ng-if="data.data_tips == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_tips == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_tips == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_TIPS_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_TIPS\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="data.is_telephone_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="telephoneInfo()" title="{{\'SSC_TILE_TELEPHONE_INFO\' | translate}}"><div class="icon telephone-info"><span data-ng-if="data.data_telephone_consultation_info == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_telephone_consultation_info == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_telephone_consultation_info == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'SSC_TILE_TELEPHONE_INFO_SH\' | translate"></span><br><span class="title" data-ng-bind="\'SSC_TILE_TELEPHONE_INFO\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="data.is_monitoring_state" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="monitoring()" title="{{\'MONITORING_TITLE\' | translate}}"><div class="icon monitoring"><span data-ng-if="data.data_monitoring == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoring == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoring == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'MONITORING_TITLE_SH\' | translate"></span><br><span class="title" data-ng-bind="\'MONITORING_TITLE\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="data.is_monitoring_state" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="monitoringdirecthelp()" title="{{\'MONITORING_DIRECTHELP_TITLE\' | translate}}"><div class="icon monitoringdirecthelp"><span data-ng-if="data.data_monitoringdirecthelp == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringdirecthelp == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringdirecthelp == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'MONITORING_DIRECTHELP_TITLE_SH\' | translate"></span><br><span class="title" data-ng-bind="\'MONITORING_DIRECTHELP_TITLE\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="data.is_monitoring_state" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="monitoringmoredevices()" title="{{\'MONITORING_MOREDEVICES_TITLE\' | translate}}"><div class="icon monitoringmoredevices"><span data-ng-if="data.data_monitoringmoredevices == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringmoredevices == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringmoredevices == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'MONITORING_MOREDEVICES_TITLE_SH\' | translate"></span><br><span class="title" data-ng-bind="\'MONITORING_MOREDEVICES_TITLE\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="data.is_monitoring_state" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="monitoringquestion()" title="{{\'MONITORING_QUESTION_TITLE\' | translate}}"><div class="icon monitoringquestion"><span data-ng-if="data.data_monitoringquestion == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringquestion == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringquestion == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'MONITORING_QUESTION_TITLE_SH\' | translate"></span><br><span class="title" data-ng-bind="\'MONITORING_QUESTION_TITLE\' | translate"></span></div></div><div class="col-sm-3 col-xs-4" ng-if="data.is_monitoring_state" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile" ng-click="monitoringsuccess()" title="{{\'MONITORING_SUCCESS_TITLE\' | translate}}"><div class="icon monitoringsuccess"><span data-ng-if="data.data_monitoringsuccess == 1" class="iconstatus"><i class="big fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringsuccess == 2" class="iconstatus"><i class="big fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringsuccess == 3" class="iconstatus"><i class="big fa fa-exclamation-triangle" aria-hidden="true"></i></span></div><span class="title" data-ng-bind="\'MONITORING_SUCCESS_TITLE_SH\' | translate"></span><br><span class="title" data-ng-bind="\'MONITORING_SUCCESS_TITLE\' | translate"></span></div></div></div><div class="visible-xs" style="margin-top:3em;"></div><div class="col-sm-4"><a class="navbar-backlink" ui-sref="ssc.check.overview.download"><button type="button" class="redbutton"><i class="ssc-icon ssc-icon-downloads marg-right-small" aria-hidden="true"></i>{{\'BTN_DOWNLOAD\' | translate}}</button></a></div><div class="col-sm-4" ng-if="!data.is_telephone_check"><a class="navbar-backlink" ui-sref="ssc.check.overview.abstract"><button type="button" class="redbutton"><i class="ssc-icon ssc-icon-summary marg-right-small" aria-hidden="true"></i>{{\'BTN_SUMMARY\' | translate}}</button></a></div><div class="col-sm-4"><ssc-log-button></ssc-log-button></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/tile/tile_small.view.html','<div><h4>ID <span data-ng-bind="id"></span> - <span data-ng-bind="name"></span> (<span data-ng-bind="consultation_type.description"></span>)</h4><div class="row tilecontainer"><div class="col-flex-14"><div class="tile tile-small" title="{{\'SSC_TILE_OVERVIEW_SH\' | translate}} - {{\'SSC_TILE_OVERVIEW\' | translate}}" ng-click="overview()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.household\' }"><div class="icon overview"><span data-ng-if="data.data_overview == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_overview == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_overview == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_GENERALINFO_SH\' | translate}} - {{\'SSC_TILE_GENERALINFO\' | translate}}" ng-click="generalInformation()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.generalInformation\' }"><div class="icon generalInformation"><span data-ng-if="data.data_generalInformation == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_generalInformation == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_generalInformation == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_ENERGY_SH\' | translate}} - {{\'SSC_TILE_ENERGY\' | translate}}" ng-click="energy()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.energy\' }"><div class="icon energy"><span data-ng-if="data.data_energy == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_energy == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_energy == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_HEAT_SH\' | translate}} - {{\'SSC_TILE_HEAT\' | translate}}" ng-click="heat()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.heat\' }"><div class="icon heat"><span data-ng-if="data.data_heat == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_heat == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_heat == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_LIGHTING_SH\' | translate}} - {{\'SSC_TILE_LIGHTING\' | translate}}" ng-click="lighting()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.lighting\' }"><div class="icon lighting"><span data-ng-if="data.data_lighting == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_lighting == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_lighting == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_STANDBY_SH\' | translate}} - {{\'SSC_TILE_STANDBY\' | translate}}" ng-click="standby()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.standby\' }"><div class="icon standby"><span data-ng-if="data.data_standby == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_standby == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_standby == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_ELECTRICBOILER_SH\' | translate}} - {{\'SSC_TILE_ELECTRICBOILER\' | translate}}" ng-click="electricBoiler()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.electricBoiler\' }"><div class="icon electricBoiler"><span data-ng-if="data.data_electricBoiler == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_electricBoiler == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_electricBoiler == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_TOILETFLUSH_SH\' | translate}} - {{\'SSC_TILE_TOILETFLUSH\' | translate}}" ng-click="toiletFlush()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.toiletFlush\' }"><div class="icon toiletFlush"><span data-ng-if="data.data_toiletFlush == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_toiletFlush == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_toiletFlush == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_SHOWER_SH\' | translate}} - {{\'SSC_TILE_SHOWER\' | translate}}" ng-click="shower()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.shower\' }"><div class="icon shower"><span data-ng-if="data.data_shower == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_shower == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_shower == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_TAP_SH\' | translate}} - {{\'SSC_TILE_TAP\' | translate}}" ng-click="tap()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.tap\' }"><div class="icon tap"><span data-ng-if="data.data_tap == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_tap == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_tap == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="!data.is_telephone_check"><div class="tile tile-small" title="{{\'SSC_TILE_REFRIGERATOR_SH\' | translate}} - {{\'SSC_TILE_REFRIGERATOR\' | translate}}" ng-click="refrigerator()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.refrigerator\' }"><div class="icon refrigerator"><span data-ng-if="data.data_refrigerator == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_refrigerator == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_refrigerator == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="data.has_climate_protection" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_KIA_SH\' | translate}} - {{\'SSC_TILE_KIA\' | translate}}" ng-click="kia()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.kia\' }"><div class="icon kia"><span data-ng-if="data.data_kia == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_kia == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_kia == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="data.has_photovoltaic" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_PHOTOVOLTAIC_SH\' | translate}} - {{\'SSC_TILE_PHOTOVOLTAIC\' | translate}}" ng-click="photovoltaic()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.photovoltaic\' }"><div class="icon photovoltaic"><span data-ng-if="data.data_photovoltaic == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_photovoltaic == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_photovoltaic == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="!data.is_telephone_check && !data.is_fridge_exchange_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_DEVICE_SH\' | translate}} - {{\'SSC_TILE_DEVICE\' | translate}}" ng-click="device()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.device\' }"><div class="icon device"><span data-ng-if="data.data_device == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_device == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_device == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="data.is_telephone_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_TELEPHONE_SH\' | translate}} - {{\'SSC_TILE_TELEPHONE\' | translate}}" ng-click="telephone()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.telephone\' }"><div class="icon telephone"><span data-ng-if="data.data_telephone_consultation == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_telephone_consultation == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_telephone_consultation == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_TIPS_SH\' | translate}} - {{\'SSC_TILE_TIPS\' | translate}}" ng-click="tips()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.tips\' }"><div class="icon tips"><span data-ng-if="data.data_tips == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_tips == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_tips == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="data.is_telephone_check" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'SSC_TILE_TELEPHONE_INFO_SH\' | translate}} - {{\'SSC_TILE_TELEPHONE_INFO\' | translate}}" ng-click="telephoneInfo()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.telephoneInfo\' }"><div class="icon telephone-info"><span data-ng-if="data.data_telephone_consultation_info == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_telephone_consultation_info == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_telephone_consultation_info == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div></div><div class="row tilecontainer"><div class="col-flex-14" ng-if="data.is_monitoring_state" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'MONITORING_TITLE_SH\' | translate}} - {{\'MONITORING_TITLE\' | translate}}" ng-click="monitoring()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.monitoring\' }"><div class="icon monitoring"><span data-ng-if="data.data_monitoring == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoring == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoring == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="data.is_monitoring_state" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'MONITORING_DIRECTHELP_TITLE_SH\' | translate}} - {{\'MONITORING_DIRECTHELP_TITLE\' | translate}}" ng-click="monitoringdirecthelp()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.monitoringdirecthelp\' }"><div class="icon monitoringdirecthelp"><span data-ng-if="data.data_monitoringdirecthelp == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringdirecthelp == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringdirecthelp == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="data.is_monitoring_state" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'MONITORING_MOREDEVICES_TITLE_SH\' | translate}} - {{\'MONITORING_MOREDEVICES_TITLE\' | translate}}" ng-click="monitoringmoredevices()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.monitoringmoredevices\' }"><div class="icon monitoringmoredevices"><span data-ng-if="data.data_monitoringmoredevices == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringmoredevices == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringmoredevices == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="data.is_monitoring_state" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'MONITORING_QUESTION_TITLE_SH\' | translate}} - {{\'MONITORING_QUESTION_TITLE\' | translate}}" ng-click="monitoringquestion()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.monitoringquestion\' }"><div class="icon monitoringquestion"><span data-ng-if="data.data_monitoringquestion == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringquestion == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringquestion == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div><div class="col-flex-14" ng-if="data.is_monitoring_state" permission="" permission-only="[\'ADMIN\', \'LOKO\', \'SSH\', \'SSHPLUS\', \'TRAINER\', \'BUKO\', \'EFB\']"><div class="tile tile-small" title="{{\'MONITORING_SUCCESS_TITLE_SH\' | translate}} - {{\'MONITORING_SUCCESS_TITLE\' | translate}}" ng-click="monitoringsuccess()" ng-class="{ \'active\': $state.current.name == \'ssc.check.overview.monitoringsuccess\' }"><div class="icon monitoringsuccess"><span data-ng-if="data.data_monitoringsuccess == 1" class="iconstatus"><i class="small fa fa-check" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringsuccess == 2" class="iconstatus"><i class="small fa fa-pencil" aria-hidden="true"></i></span> <span data-ng-if="data.data_monitoringsuccess == 3" class="iconstatus"><i class="small fa fa-exclamation-triangle" aria-hidden="true"></i></span></div></div></div></div></div>');
$templateCache.put('templates/components/content/user/userCreate/userCreate.view.html','<div class="container"><div ng-show="isNotFound" style="text-align:center"><h4>Nicht gefunden</h4></div><div ng-show="!isNotFound"><div data-ng-controller="submenuController" ng-show="edit"><div class="row"><div class="col-sm-4" permission="" permission-only=\'["LOKO", "EFB", "BUKO", "ADMIN"]\'><a class="navbar-backlink" href="" ui-sref="user.update.rolelocationCreate({id: id})"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_USER_ADD_ROLE_LOCATION\' | translate}}</button></a></div><div class="col-sm-4"><span ng-if="id != userId"><a class="navbar-backlink" href="" ui-sref="user.update.password({roleId: id})" permission="" permission-only=\'["ADMIN"]\'><button type="button" class="redbutton" data-ng-bind="\'BTN_CHANGE_USER_PASSWORD\' | translate"></button></a></span> <a href="" ui-sref="user.changeMyPassword" ng-if="id == userId"><button type="button" class="redbutton" data-ng-bind="\'BTN_CHANGE_MY_PASSWORD\' | translate"></button></a></div><div class="col-sm-4" permission="" permission-only=\'["ADMIN"]\'><button type="button" class="redbutton" data-ng-bind="\'BTN_RESET_TWO_FACTOR_AUTH\' | translate" ng-if="model.has_two_factor_auth" ng-click="resetTwoFactorAuth()"></button></div></div></div><div class="row"><div class="col-sm-12"><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" ng-repeat="errorAlertItem in errorAlert" data-ng-bind="errorAlertItem.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_USERNAME_FORMAT\' | translate" ng-if="failedUsername"></div></div></div><div class="col-sm-5 field"><div data-ng-if="!edit" class="row hlabel" data-ng-bind="\'USER_CREATEUSER\' | translate"></div><div data-ng-if="edit" class="row hlabel"><span ng-bind="\'USER_UPDATEUSER\' | translate:{name:name}"></span><help-pop-over help="TIP_USER_UPDATE_RIGHTS" ng-if="!model.CAN_WRITE"></help-pop-over></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.salutation + \'\').length == 0) || (model.salutation == null)) && required.salutation && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_TITLE\' | translate"></span> <span data-ng-if="required.salutation">*</span></div><div class="col-sm-7"><select data-ng-class="{\'input-required-border\': (((model.salutation + \'\').length == 0) || (model.salutation == null)) && required.salutation && saved}" class="createdropper leftdropper" ng-model="model.salutation" ng-disabled="!model.CAN_WRITE && edit"><option value="frau" data-ng-bind="\'USER_FEMALE\' | translate"></option><option value="herr" data-ng-bind="\'USER_MALE\' | translate"></option></select></div><div data-ng-if="(((model.salutation + \'\').length == 0) || (model.salutation == null)) && required.salutation && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.firstname + \'\').length == 0) || (model.firstname == null)) && required.firstname && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_NAME\' | translate"></span> <span data-ng-if="required.firstname">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.firstname + \'\').length == 0) || (model.firstname == null)) && required.firstname && saved}" class="createinputter" ng-model="model.firstname" ng-disabled="!model.CAN_WRITE && edit"></div><div data-ng-if="(((model.firstname + \'\').length == 0) || (model.firstname == null)) && required.firstname && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.lastname + \'\').length == 0) || (model.lastname == null)) && required.lastname && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_LASTNAME\' | translate"></span> <span data-ng-if="required.lastname">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.lastname + \'\').length == 0) || (model.lastname == null)) && required.lastname && saved}" class="createinputter" ng-model="model.lastname" ng-disabled="!model.CAN_WRITE && edit"></div><div data-ng-if="(((model.lastname + \'\').length == 0) || (model.lastname == null)) && required.lastname && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': ( ((model.email + \'\').length == 0) || (model.email == null) || (!validEmail(model.email)) ) && required.email && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_MAIL\' | translate"></span> <span data-ng-if="required.email">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': ( ((model.email + \'\').length == 0) || (model.email == null) || (!validEmail(model.email)) ) && required.email && saved}" class="createinputter" ng-model="model.email" ng-disabled="!model.CAN_WRITE && edit"></div><div data-ng-if="( ((model.email + \'\').length == 0) || (model.email == null) || (!validEmail(model.email)) ) && required.email && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" data-ng-if="!edit"><div data-ng-class="{\'input-required\': (((model.username + \'\').length == 0) || !testUsername(model.username) || (model.username == null)) && required.username && saved || (changeRequired.username && changeRequired.username.toLowerCase() == model.username.toLowerCase())}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_USERNAME\' | translate"></span> <span data-ng-if="required.username">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.username + \'\').length == 0) || !testUsername(model.username) || (model.username == null)) && required.username && saved || (changeRequired.username && changeRequired.username.toLowerCase() == model.username.toLowerCase())}" class="createinputter" ng-model="model.username"></div><div data-ng-if="(((model.username + \'\').length == 0) || !testUsername(model.username) || (model.username == null)) && required.username && saved || (changeRequired.username && changeRequired.username.toLowerCase() == model.username.toLowerCase())" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" data-ng-if="edit"><div class="col-sm-4 ilabel"><span data-ng-bind="\'USER_USERNAME\' | translate"></span></div><div class="col-sm-7"><div class="fieldContent" data-ng-bind="model.username"></div></div></div><div class="row margcreatebot" data-ng-if="!edit"></div><div class="row margcreatebot" data-ng-if="edit"><div data-ng-class="{\'input-required\': (((model.aktiv + \'\').length == 0) || (model.aktiv == null)) && required.aktiv && saved || (changeRequired.aktiv && changeRequired.aktiv.toLowerCase() == model.username.toLowerCase())}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_STATUS\' | translate"></span> <span data-ng-if="required.aktiv">*</span></div><div class="col-sm-7"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="model.aktiv" value="required.aktiv" id="checkboxDirecthelpStatus" ng-checked="model.aktiv == 1" ng-disabled="!model.CAN_WRITE && edit"> <label class="checklabel" for="checkboxDirecthelpStatus"></label> <span data-ng-bind="model.aktiv == 1 ? (\'ACTIVE\' | translate) : (\'INACTIVE\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.aktiv + \'\').length == 0) || (model.aktiv == null)) && required.aktiv && saved || (changeRequired.aktiv && changeRequired.aktiv.toLowerCase() == model.aktiv.toLowerCase())" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot" data-ng-if="edit"><div data-ng-class="{\'input-required\': (((model.right_report_controlling_list + \'\').length == 0) || (model.right_report_controlling_list == null)) && required.right_report_controlling_list && saved || changeRequired.right_report_controlling_list}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_RIGHT_REPORT_CONTROLLING_LIST\' | translate"></span> <span data-ng-if="required.right_report_controlling_list">*</span></div><div class="col-sm-7"><input type="checkbox" ng-true-value="true" ng-false-value="false" ng-model="model.right_report_controlling_list" value="required.right_report_controlling_list" id="checkbox-right_report_controlling_list" ng-checked="model.right_report_controlling_list == 1" ng-disabled="!model.CAN_WRITE && edit"> <label class="checklabel" for="checkbox-right_report_controlling_list"></label> <span data-ng-bind="model.right_report_controlling_list ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div data-ng-if="(((model.right_report_controlling_list + \'\').length == 0) || (model.right_report_controlling_list == null)) && required.right_report_controlling_list && saved || changeRequired.right_report_controlling_list" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot" data-ng-if="edit && !model.has_two_factor_auth && logged_in_user_id == model.id"><div class="col-sm-12 ilabel"><a ui-sref="twoFactorAuth" ng-bind="\'USER_TWO_FACTOR_AUTH\' | translate"></a></div></div></div><div class="col-sm-6 col-sm-offset-1 field" data-ng-if="!edit"><div class="row hlabel" data-ng-bind="\'USER_PLACEROLE\' | translate"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.role_id + \'\').length == 0) || (model.role_id == null)) && required.role_id && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_ROLE\' | translate"></span> <span data-ng-if="required.role_id">*</span></div><div class="col-sm-7"><select data-ng-change="clearAdress(); updateRequired()" data-ng-class="{\'input-required-border\': (((model.role_id + \'\').length == 0) || (model.role_id == null)) && required.role_id && saved}" class="createdropper rightdropper" ng-model="model.role_id"><option ng-repeat="item in dropRole" ng-value="item.id" data-ng-bind="item.dropName" ng-if="item.slug != \'SSHPLUS\'"></option></select></div><div data-ng-if="(((model.role_id + \'\').length == 0) || (model.role_id == null)) && required.role_id && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div ng-show="showLocation()" class="row"><div data-ng-class="{\'input-required\': (((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_LOCATION\' | translate"></span> <span data-ng-if="required.location">*</span></div><div class="col-sm-7"><select data-ng-change="setLocationAdress()" data-ng-class="{\'input-required-border\': (((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved}" class="createdropper rightdropper" ng-model="model.location"><option ng-repeat="item in dropLocation" value="{{item.id}}">{{item.name}}</option></select></div><div data-ng-if="(((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div ng-show="showOrganisation()" class="row"><div data-ng-class="{\'input-required\': (((model.organisation + \'\').length == 0) || (model.organisation == null)) && required.organisation && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_ORGANISATION\' | translate"></span> <span data-ng-if="required.organisation">*</span></div><div class="col-sm-7"><select data-ng-class="{\'input-required-border\': (((model.organisation + \'\').length == 0) || (model.organisation == null)) && required.organisation && saved}" class="createdropper rightdropper" ng-model="model.organisation"><option ng-repeat="item in dropOrganisation" value="{{item.id}}" ng-if="(item.status==1)">{{item.name}}</option></select></div><div data-ng-if="(((model.organisation + \'\').length == 0) || (model.organisation == null)) && required.organisation && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div ng-show="showStates()" class="row"><div data-ng-class="{\'input-required\': (((model.states + \'\').length == 0) || (model.states == null)) && required.states && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_STATES\' | translate"></span> <span data-ng-if="required.states">*</span></div><div class="col-sm-7"><ui-select data-ng-model="model.states" on-select="OnClickSelect($item)" on-remove="OnRemoveSelect($item)" data-ng-class="{\'input-required-border\': (((model.states + \'\').length == 0) || (model.states == null)) && required.states && saved}" class="ssc-ui-select" multiple="" theme="selectize" sortable="true"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropState | filter:$select.search"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div data-ng-if="(((model.states + \'\').length == 0) || (model.states == null)) && required.states && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_STREET\' | translate"></span> <span data-ng-if="required.street">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved}" class="createinputter" ng-model="model.street"></div><div data-ng-if="(((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.postalcode + \'\').length == 0) || (model.postalcode == null)) && required.postalcode && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_PLZ\' | translate"></span> <span data-ng-if="required.postalcode">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.postalcode + \'\').length == 0) || (model.postalcode == null)) && required.postalcode && saved}" class="createinputter" ng-model="model.postalcode"></div><div data-ng-if="(((model.postalcode + \'\').length == 0) || (model.postalcode == null)) && required.postalcode && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_PLACE\' | translate"></span> <span data-ng-if="required.city">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved}" class="createinputter" ng-model="model.city"></div><div data-ng-if="(((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_PHONE\' | translate"></span> <span data-ng-if="required.telephone">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved}" class="createinputter" ng-model="model.telephone"></div><div data-ng-if="(((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.mobilephone + \'\').length == 0) || (model.mobilephone == null)) && required.mobilephone && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_MOBILEPHONE\' | translate"></span> <span data-ng-if="required.mobilephone">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.mobilephone + \'\').length == 0) || (model.mobilephone == null)) && required.mobilephone && saved}" class="createinputter" ng-model="model.mobilephone"></div><div data-ng-if="(((model.mobilephone + \'\').length == 0) || (model.mobilephone == null)) && required.mobilephone && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div ng-if="showComment()"><div class="row"><div data-ng-class="{\'input-required\': (((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_NOTICE\' | translate"></span> <span data-ng-if="required.comment">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved}" class="createinputter" ng-model="model.comment"></div><div data-ng-if="(((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="margcreatebot"></div></div></div><div class="col-sm-12 margcreatetop" ng-if="showEmployment()"><div class="col-sm-6 col-sm-offset-6 field"><div class="row hlabel padssh" data-ng-bind="\'USER_EMPLOYMENT_TITLE\' | translate"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_DATESTART\' | translate"></span> <span data-ng-if="required.date_begin">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved}" class="createinputter" id="begin" ssc-datepicker="" data-ng-model="model.date_begin" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="end"></div><div data-ng-if="(((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.date_end + \'\').length == 0) || (model.date_end == null)) && required.date_end && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_DATESTOP\' | translate"></span> <span data-ng-if="required.date_end">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.date_end + \'\').length == 0) || (model.date_end == null)) && required.date_end && saved}" class="createinputter" id="end" ssc-datepicker="" data-ng-model="model.date_end" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="begin"></div><div data-ng-if="(((model.date_end + \'\').length == 0) || (model.date_end == null)) && required.date_end && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.employment_id + \'\').length == 0) || (model.employment_id == null)) && required.employment_id && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_EMPLOYMENTMODE\' | translate"></span> <span data-ng-if="required.employment_id">*</span></div><div class="col-sm-7"><select data-ng-class="{\'input-required-border\': (((model.employment_id + \'\').length == 0) || (model.employment_id == null)) && required.employment_id && saved}" class="createdropper rightdropper" ng-model="model.employment_id"><option ng-repeat="item in dropEmploymentType" value="{{item.id}}">{{item.name}}</option></select></div><div data-ng-if="(((model.employment_id + \'\').length == 0) || (model.employment_id == null)) && required.employment_id && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="col-sm-3 col-sm-offset-9"><button data-ng-if="!edit" ng-click="save()" class="redbutton" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button> <button data-ng-if="edit && model.CAN_WRITE" ng-click="update()" class="redbutton" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div></div>');
$templateCache.put('templates/components/shared/menu/mainmenu/mainmenu.view.html','<nav><div class="container mainmenu"><div class="row clearing"><div class="col-sm-12"><div class="icon-bar"><a data-ng-repeat="item in menu" ui-sref="{{item.route}}{{item.routeParams}}" ui-sref-active="active" ui-nested="" permission="" permission-only="item.permissionOnly"><div class="{{item.class}}"></div><span data-ng-bind="item.title"></span></a></div></div></div></div></nav>');
$templateCache.put('templates/components/shared/menu/profilmenu/profilmenu.view.html','<div class="row"><div class="col-xs-7"><div data-ng-if="authenticated"><div class="element_bordered"><span data-ng-bind="\'NAV_HELLO\'| translate"></span> <a href="" ui-sref="user.update({id: user.id})"><span data-ng-bind="rootScopeName"></span></a></div></div></div><div class="col-xs-5 text-right"><a data-ng-controller="logoutController" data-ng-if="authenticated" href="" data-ng-click="logout();"><div class="element_bordered"><i class="fa fa-unlock-alt" aria-hidden="true"></i> <span ng-bind="\'NAV_LOGOUT\'| translate"></span></div></a></div></div>');
$templateCache.put('templates/components/shared/menu/tabmenu/tabmenu.view.html','<div><div data-ng-if="bSearch" class="container margcreatetop"><div class="row"><div class="col-sm-12"><h6><span data-ng-if="searchCounts !== 1" data-ng-bind="\'SEARCH_FILTER_TEXT\' | translate:{count:searchCounts}" class="marg-right-small"></span> <span data-ng-if="searchCounts === 1" data-ng-bind="\'SEARCH_FILTER_TEXT_SINGLE\' | translate:{count:searchCounts}" class="marg-right-small"></span> <a ng-click="clearFilterByBroadcast()" title="{{\'SEARCH_RESET\' | translate}}"><i class="fa fa-remove" aria-hidden="true"></i></a></h6></div></div></div><div class="container margcreatetop"><div class="row"><div class="col-sm-12" id="exTab3"><ul class="nav nav-pills" ssc-pill-stack=""><li data-ng-repeat="grid in grids" data-ng-class="{\'active\': $index == pageIndex}" value="{{$index}}" permission="" permission-only="grid.permissionOnly" permission-on-unauthorized="onUnauthorized"><a ng-click="changeIndex($index)" data-ng-class="{\'nav-pills-is-empty\': !(grid.data > 0)}"><span class="tabtitle" data-ng-bind="grid.title"></span> <span data-ng-bind="\' (\' + grid.data + \')\'"></span></a></li></ul><div class="tab-content clearfix"></div></div></div></div></div>');
$templateCache.put('templates/components/shared/menu/tabmenuReview/tabmenuReview.view.html','<div><div class="container"><div class="row"><div class="col-sm-12" id="exTab3"><ul class="nav nav-pills"><li data-ng-repeat="tab in tabs" data-ng-class="{\'active\': $index == pageIndex}" value="{{$index}}" permission="" permission-only="tab.permissionOnly" permission-on-unauthorized="onUnauthorized"><a ng-click="changeIndex($index)"><span class="tabtitle" data-ng-bind="tab.title"></span></a></li></ul><div class="tab-content clearfix"></div></div></div></div></div>');
$templateCache.put('templates/components/shared/search/sscSearch/sscSearch.view.html','<div><div class="container"><div class="row margcreatebot"><div class="col-sm-6 col-lg-4"><form ng-submit="sscSearchOnsubmit()"><input data-ng-model="sscSearchModel" class="createinputter" type="search" placeholder="{{sscSearchPlaceholder}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div><div class="col-xs-6 col-sm-2 col-lg-3"><a class="searchtext" ng-click="showDetails = !showDetails" data-ng-bind="\'SEARCH_MORE\' | translate"></a></div><div class="col-xs-6 col-sm-4 col-lg-5 text-right" data-ng-if="sscSearchFiltered"><a class="searchtext" ng-click="sscSearchOnclear()" data-ng-bind="\'SEARCH_RESET\' | translate"></a></div></div></div><div class="graybg"><div class="container graybg" ng-show="showDetails"><div ng-transclude=""></div><div class="row push-bottom"><div class="col-sm-offset-8 col-sm-4 col-lg-offset-9 col-lg-3"><button type="submit" class="greybutton" ng-click="sscSearchOnsubmit()"><i class="fa fa-filter" aria-hidden="true"></i> <span data-ng-bind="\'SEARCH_SEARCH\' | translate"></span></button></div></div></div></div></div>');
$templateCache.put('templates/components/core/auth/login/login.view.html','<div><div class="container" ng-show="blockedByMaintenance" style="text-align:center"><br><br><br><h4>Die SSC Datenbank zieht um und ist am 27.01.2020 ab 8 Uhr wieder verf\xFCgbar.</h4><div class="field-text">Bei Fragen k\xF6nnen Sie sich an die <b>Datenbank-Hotline</b> unter <b>030 293330-29</b> wenden.</div></div><div class="container" ng-show="!blockedByMaintenance"><div data-ng-if="showErrorBox()" class="col-sm-12 errorfield marginerrorlogin"><div class="row hlabel" data-ng-bind="\'FORM_ERRORLOGIN_TITLE\' | translate"></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text">{{error_message}}</div></div></div><div data-ng-if="verified" class="col-sm-12 field marginerrorlogin"><div class="row hlabel" data-ng-bind="\'FORM_VERIFY_SUCCESS_TITLE\' | translate"></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text-regular" data-ng-bind="\'FORM_VERIFY_SUCCESS_TEXT\' | translate"></div></div></div><div class="loginmargin"></div><form name="loginForm" method="post" class="col-lg-4 col-lg-offset-4 col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 loginfield"><div ng-show="showLoginCredentials()"><div class="inputtitle">{{\'LOGIN_USER\'| translate}}</div><input class="createinputter" type="text" ng-model="email" autofocus=""><div class="inputtitle margin-top-1em">{{\'LOGIN_PASSWORD\'| translate}}</div><input class="createinputter" type="password" ng-model="password"></div><div ng-show="showTwoFactorAuth()"><div class="inputtitle margcreatebot"><span ng-bind="\'LOGIN_TWO_FACTOR_DESCRIPTION\'| translate"></span></div><div class="inputtitle"><span ng-bind="\'LOGIN_TWO_FACTOR_PIN\'| translate"></span></div><input class="createinputter" type="text" ng-model="two_factor_pin"></div><button class="redbutton disableduringload" id="login" type="submit" ng-click="send();">{{\'LOGIN_LOGIN\' | translate}}</button><div class="inputtitle"><a href="forgotpass">{{\'LOGIN_FORGOT_PASS\' | translate}}</a><br><br>Bei Problemen mit dem Login k\xF6nnen Sie sich an diese Telefonnummer wenden: <b>030 293330 32</b></div></form></div></div>');
$templateCache.put('templates/components/core/auth/passwordForgotten/passwordForgotten.view.html','<div><div class="container"><div data-ng-if="reset_failure" class="col-sm-12 errorfield marginerrorlogin"><div class="row hlabel" data-ng-bind="\'LOGIN_RETRIEVE_NEW_PASS\' | translate"></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'LOGIN_RESET_FAIL\' | translate"></div></div></div><div data-ng-if="reset_successfull" class="col-sm-12 field marginerrorlogin"><div class="row hlabel" data-ng-bind="\'LOGIN_RETRIEVE_NEW_PASS\' | translate"></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text-regular" data-ng-bind="\'LOGIN_RESET_DONE\' | translate"></div><div class="col-sm-12 form-fill-text-regular"><a ui-sref="login" data-ng-bind="\'LOGIN_RETURN\' | translate"></a></div></div></div><div class="loginmargin"></div><form name="loginForm" method="post" class="col-lg-4 col-lg-offset-4 col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 loginfield"><div class="row loginpad"><div class="col-lg-11 col-md-11 col-sm-11"><div class="inputtitle">{{\'LOGIN_USER\'| translate}}</div><input class="inputfield" type="text" name="username" id="username" ng-model="email" ng-keyup="submitted = false" data-ng-class="{\'input-required\': access === false}" ng-disabled="passform_locked"></div></div><div class="row loginpad"><div class="col-lg-11 col-md-11 hidden-sm"><button class="loginbutton redbutton" id="login" type="submit" ng-click="submitted = true; reset();" ng-disabled="passform_locked">{{\'LOGIN_RETRIEVE_NEW_PASS\' | translate}}</button></div><div class="col-sm-11 hidden-lg hidden-md"><button class="loginbuttonsm redbutton" id="login" type="submit" ng-click="submitted = true; reset();" ng-disabled="passform_locked">{{\'LOGIN_RETRIEVE_NEW_PASS\' | translate}}</button></div></div></form></div></div>');
$templateCache.put('templates/components/core/auth/resetPassword/resetPassword.view.html','<div class="container"><div class="row"><div data-ng-if="errorAlert && !reset_successfull" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div></div><div class="row"><div ng-if="reset_successfull" class="col-sm-12 field"><div class="row hlabel" data-ng-bind="\'LOGIN_RETRIEVE_NEW_PASS\' | translate"></div><div class="row margcreatetop margcreatebot"><div class="form-fill-text-regular" data-ng-bind="\'LOGIN_RESET_PASS_SUCCESS\' | translate"></div><div class="form-fill-text-regular"><a ui-sref="login" data-ng-bind="\'LOGIN_RETURN\' | translate"></a></div></div></div></div><div class="col-sm-12 field ng-scope margcreatetop"><div class="row hlabel ng-binding" data-ng-bind="\'FORM_PASSWORD_RULES\' | translate"></div><div class="row margcreatetop margcreatebot"><div class="form-fill-text-regular ng-binding" data-ng-bind="\'FORM_ERROR_PW_GUIDELINES\' | translate"></div></div></div><div class="row"><div class="col-sm-6 col-sm-offset-3 field password-reset"><div class="row hlabel" data-ng-bind="\'BTN_CHANGE_USER_PASSWORD\' | translate"></div><div class="row"><div data-ng-class="{\'input-required\': (((model.username + \'\').length == 0) || (model.username == null)) && required.username && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'USER_USERNAME\' | translate"></span> <span data-ng-if="required.username">*</span></div><div class="col-sm-6"><input data-ng-class="{\'input-required-border\': (((model.username + \'\').length == 0) || (model.username == null)) && required.username && saved}" class="createinputter" name="username" ng-disabled="reset_successfull" ng-model="model.username" type="text"></div><div data-ng-if="(((model.username + \'\').length == 0) || (model.username == null)) && required.username && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.newPassword + \'\').length == 0) || (model.newPassword == null)) && required.newPassword && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'USER_NEW_PASSWORD\' | translate"></span> <span data-ng-if="required.newPassword">*</span></div><div class="col-sm-6" data-ng-class="{\'error\': pwInvalid}"><input data-ng-class="{\'input-required-border\': (((model.newPassword + \'\').length == 0) || (model.newPassword == null)) && required.newPassword && saved}" class="createinputter" ng-model="model.newPassword" ng-disabled="reset_successfull" type="password" ng-change="checkPw()"></div><div data-ng-if="(((model.newPassword + \'\').length == 0) || (model.newPassword == null)) && required.newPassword && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.newPasswordRepeat + \'\').length == 0) || (model.newPasswordRepeat == null) || model.newPasswordRepeat != model.newPassword) && required.newPasswordRepeat && saved}" class="col-sm-5 ilabel"><span data-ng-bind="\'USER_PASSWORD_REPEAT\' | translate"></span> <span data-ng-if="required.newPasswordRepeat">*</span></div><div class="col-sm-6" data-ng-class="{\'error\': pwInvalid}"><input data-ng-class="{\'input-required-border\': (((model.newPasswordRepeat + \'\').length == 0) || (model.newPasswordRepeat == null) || model.newPasswordRepeat != model.newPassword) && required.newPasswordRepeat && saved}" class="createinputter" ng-model="model.newPasswordRepeat" ng-disabled="reset_successfull" type="password" ng-change="checkPw()"></div><div data-ng-if="(((model.newPasswordRepeat + \'\').length == 0) || (model.newPasswordRepeat == null) || model.newPasswordRepeat != model.newPassword) && required.newPasswordRepeat && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatebot"></div></div></div><div class="row"><div class="col-sm-3 col-sm-offset-6"><button ng-click="save()" ng-disabled="reset_successfull" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_CHANGE_PASSWORD\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/exchange/archiv/search/search.view.html','<div><div class="container"><div class="row"><div class="col-sm-4"><form ng-submit="search()"><input data-ng-model="searchfield" class="createinputter" type="search" placeholder="{{\'SEARCH_TITLE_ARCHIV\'| translate}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div><div class="col-sm-3"><span data-toggle="collapse" href="#filter-collapse" ng-click="showDetails = !showDetails"><a class="searchtext"><span data-ng-bind="\'SEARCH_MORE\' | translate"></span> <i class="glyphicon" aria-hidden="true" ng-class="{\'glyphicon-chevron-right\': !showDetails, \'glyphicon-chevron-down\': showDetails}"></i></a></span></div><div class="col-sm-5 text-right" data-ng-if="bSearch"><a class="searchtext" ng-click="clearFilter()"><i class="fa fa-remove marg-right-small" aria-hidden="true"></i>{{\'SEARCH_RESET\' | translate}}</a></div></div></div><div class="collapse" id="filter-collapse"><div class="graybg margcreatetop"><div class="container"><div class="push-top"></div><div class="col-sm-5"><label for="places" ng-bind="\'SEARCH_PLACES\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((model.location_id + \'\').length == 0) || (model.location_id == null)) && required && saved}" class="createdropper" id="places" ng-model="location"><option ng-repeat="item in dropLocation" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-5"><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="time" ssc-datepicker="" data-ng-model="time" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY"></div><div class="col-sm-6"><div class="row"><div class="col-sm-6"><label for="from" ng-bind="\'SEARCH_FROM\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div><div class="col-sm-6"><label for="to" ng-bind="\'SEARCH_TO\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div><div class="col-sm-6 col-sm-offset-6 push-bottom"><div class="row"><div class="col-sm-offset-6 col-sm-6"><button type="submit" class="greybutton" ng-click="search()"><i class="fa fa-filter" aria-hidden="true"></i> <span data-ng-bind="\'SEARCH_SEARCH\' | translate"></span></button></div></div></div></div></div></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/comment/commentCreate/commentCreate.view.html','<div class="row"><div class="col-sm-12"><hr><h4 data-ng-bind="\'SSC_COMMENTS\' | translate"></h4></div><div class="margcreatebot margcreatetop"><div class="col-sm-12"><textarea ng-disabled="disableComments" data-ng-class="{\'input-required-border\': (((model.text + \'\').length == 0) || (model.text == null)) && required.text && saved}" class="createinputter" ng-model="comment" placeholder="{{\'SSC_COMMENT_LABEL\' | translate}}"></textarea></div><div data-ng-if="(((model.text + \'\').length == 0) || (model.text == null)) && required.text && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="col-sm-5 col-sm-offset-7"><button ng-click="addcomment()" class="redbutton" ng-disabled="comment === \'\' || isSaving" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'SSC_COMMENT_BTN\' | translate"></span></button></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/comment/commentOverview/commentOverview.view.html','<div class="row"><div class="comments col-sm-12"><div ng-repeat="comment in comments" class="comment" ng-class="{ \'col-sm-9\': (comment.user.roles[0] == \'Stromsparhelfer\' || comment.user.roles[0] == \'Stromsparhelfer +\' || comment.user.roles[0] == \'Lokaler Koordinator\') , \'col-sm-9 col-sm-offset-3\': !(comment.user.roles[0] == \'Stromsparhelfer\' || comment.user.roles[0] == \'Stromsparhelfer +\' || comment.user.roles[0] == \'Lokaler Koordinator\') }"><p class="commentHeadline"><span ng-bind="comment.created_at"></span> - <b><span data-ng-bind="comment.user.name"></span></b></p><p data-ng-bind-html="comment.message"></p></div></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/form/sscAddButton/sscAddButton.view.html','<button href="#" class="redbutton" ng-click="addOnclick()" ng-disabled="addIsSaving > 0 || !addEnabled"><i class="fa fa-plus marg-right-small" aria-hidden="true" ng-hide="addIsSaving > 0"></i> <i class="fa fa-circle-o-notch loader fa-spin fa-fw marg-right-small" ng-if="addIsSaving > 0"></i> <span data-ng-bind="addLabel | translate"></span></button>');
$templateCache.put('templates/components/content/stromsparcheck/form/sscAdvice/sscAdvice.view.html','<div class="ssc-advice"><div ng-repeat="(index, advice) in advices track by advice.id"><div class="row"><div class="col-xs-12" ng-if="!$first"><hr></div><div class="col-xs-12"><h4><span ng-bind="getHeaderText(advice)"></span>&nbsp;{{index + 1}}<span ng-if="isAdvice(advice) || isPraise(advice)">:&nbsp;</span> <span ng-if="advice.advice_type && (isAdvice(advice) || isPraise(advice))">{{advice.advice_type}}</span> <span ng-if="!advice.advice_type && (isAdvice(advice) || isPraise(advice))" ng-bind="\'SSC_ADVICE_CUSTOM\' | translate"></span><ssc-delete-button delete-onclick="deleteAdvice(advice.id)" delete-enabled="tableProperties.canDelete" delete-class="sscDeleteAccordion"></ssc-delete-button></h4></div></div><div class="row" ng-if="showTopTips"><div class="col-sm-8 ilabel" errorlabel="ssc_advice.{{index}}.is_top_tip"><span ng-bind="\'SSC_ADVICE_TOP_TIP\' | translate"></span></div><div class="col-sm-4" errorlabel="ssc_advice.{{index}}.is_top_tip"><input type="checkbox" ng-true-value="true" ng-false-value="false" ng-model="advice.is_top_tip" value="required.status" id="is_top_tip-{{advice.id}}" ng-checked="advice.is_top_tip === true" ng-change="updateAdvice(advice, \'is_top_tip\')"> <label class="checklabel" for="is_top_tip-{{advice.id}}"></label> <span data-ng-bind="advice.is_top_tip === true ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row" ng-if="showSource"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ADVICE_SOURCE\' | translate"></span></div><div class="col-sm-8"><input type="text" ng-model="advice.source" class="createinputter" ng-disabled="true"></div></div><div class="row" ng-if="showTitle(advice)"><div class="col-sm-4 ilabel" errorlabel="ssc_advice.{{index}}.title"><span data-ng-bind="\'SSC_ADVICE_TITLE\' | translate"></span></div><div class="col-sm-8" errorlabel="ssc_advice.{{index}}.title"><input type="text" ng-model="advice.title" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="updateAdvice(advice, \'title\')" ng-if="!showDefaultTextFields(advice)"> <input type="text" ng-model="advice.title_default" class="createinputter" disabled="" ng-if="showDefaultTextFields(advice)"></div></div><div class="row"><div class="col-sm-4 ilabel" ng-if="advice.advice_id === null"><span data-ng-bind="(freeTextDescriptionLabel ? freeTextDescriptionLabel : \'SSC_ADVICE_DESCRIPTION\') | translate" ng-if="isAdvice(advice)"></span> <span data-ng-bind="(freeTextDescriptionLabel ? freeTextDescriptionLabel : \'SSC_ADVICE_DESCRIPTION_EXPLANATION\') | translate" ng-if="isExplanation(advice)"></span> <span data-ng-bind="(freeTextDescriptionLabel ? freeTextDescriptionLabel : \'SSC_ADVICE_DESCRIPTION_PRAISE\') | translate" ng-if="IsPraise(advice)"></span></div><div class="col-sm-4 ilabel" ng-if="advice.advice_id !== null"><span data-ng-bind="\'SSC_ADVICE_DESCRIPTION\' | translate" ng-if="isAdvice(advice)"></span> <span data-ng-bind="\'SSC_ADVICE_DESCRIPTION_EXPLANATION\' | translate" ng-if="isExplanation(advice)"></span> <span data-ng-bind="\'SSC_ADVICE_DESCRIPTION_PRAISE\' | translate" ng-if="isPraise(advice)"></span></div><div class="col-sm-8"><div ng-bind-html="advice.description_default" class="description-disabled-box" ng-if="showDefaultTextFields(advice)"></div><textarea ng-model="advice.description" ng-model-options="{updateOn: \'blur\'}" ng-if="!showDefaultTextFields(advice)" ng-change="updateAdvice(advice, \'description\')" class="createinputter" ui-tinymce=""></textarea></div></div></div><div ng-if="!templatesVisible" class="row"><div class="col-sm-4" ng-if="isAdvice()"><ssc-add-button add-onclick="showTemplates()" add-enabled="tableProperties.canCreate" add-is-saving="isSaving" add-label="SSC_ADVICE_ADD"></ssc-add-button></div><div class="col-sm-4" ng-if="isExplanation()"><ssc-add-button add-onclick="addAdvice()" add-enabled="tableProperties.canCreate" add-is-saving="isSaving" add-label="SSC_ADVICE_ADD_EXPLANATION"></ssc-add-button></div><div class="col-sm-4" ng-if="isPraise()"><ssc-add-button add-onclick="showTemplates()" add-enabled="tableProperties.canCreate" add-is-saving="isSaving" add-label="SSC_ADVICE_ADD_PRAISE"></ssc-add-button></div></div><div ng-if="templatesVisible"><div class="margcreatebot row"><hr ng-if="advices.length > 0"><div><span><button ng-click="hideTemplates()" class="sscDeleteButton sscDeleteAccordion" title="{{\'BTN_CLOSE\' | translate}}"><i class="fa fa-close"></i></button></span></div><div class="col-xs-12"><h4 ng-if="!isPraise()" ng-bind="\'SSC_ADVICE_ADD\' | translate"></h4><h4 ng-if="isPraise()" ng-bind="\'SSC_ADVICE_ADD_PRAISE\' | translate"></h4></div></div><div class="row"><div ng-repeat="category in getOptions() track by category.id" ng-click="toggleCategory(category)" class="accordeon col-lg-6"><div class="field"><div class="panel-heading hlabel accordion-toggle" ng-class="{collapsed: !isCategoryVisible(category)}">{{category.description}}</div><div ng-repeat="theme in category.themes track by theme.id" ng-show="isCategoryVisible(category)" class="row"><div class="ilabel col-xs-12">{{theme.description}}</div><div ng-repeat="advice in theme.advices track by advice.id" class="row clicktext" ng-click="addAdvice(advice)"><div class="col-xs-3">{{advice.shortcut}}</div><div class="col-xs-9" ng-class="{margcreatebot: $last}">{{advice.title}}</div></div></div></div></div></div><div class="row"><div class="col-sm-4"><button ng-click="addAdvice(null)" class="redbutton" ng-bind="(freeTextLabel ? freeTextLabel : \'SSC_ADVICE_FREE_TEXT\') | translate"></button></div></div></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/form/sscDeleteButton/sscDeleteButton.view.html','<span><button ng-disabled="deleteEnabled !== true" ng-click="deleteOnclick(); $event.stopPropagation()" class="sscDeleteButton disableduringload {{deleteClass}}" title="{{\'BTN_DELETE\'|translate}}"><i class="fa fa-trash"></i></button></span>');
$templateCache.put('templates/components/content/stromsparcheck/form/sscHeatingTool/sscHeatingTool.view.html','<div field-attribute-manager=""><div class="row"><div class="col-sm-9"></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordeon1" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion1" href="#collapse1"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_HEADLINE\' | translate"></span></div><div id="collapse1" class="collapse in"><ssc-errorbox data-messages="errors.heating_tool.messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="{{table}}.bill_heating_begin" dataobj="properties" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_BEGIN\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_BILL_HEATING_BEGIN"></help-pop-over><span data-ng-if="properties[table].bill_heating_begin.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.bill_heating_begin" dataobj="properties"><input class="createinputter" id="bill_heating_begin_date" ng-model="content[table].bill_heating_begin" datepicker-change="saveWrapper(\'content.\'+table+\'.bill_heating_begin\')" ssc-datepicker="" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-end-id="bill_heating_end_date" datepicker-type="fromto"></div><div errorlabel="{{table}}.bill_usage_begin" dataobj="properties" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_USAGE_BEGIN\' | translate"></span> <span data-ng-if="properties[table].bill_usage_begin.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.bill_usage_begin" dataobj="properties"><input class="createinputter" id="bill_usage_begin_date" ng-model="content[table].bill_usage_begin" datepicker-change="saveWrapper(\'content.\'+table+\'.bill_usage_begin\')" ssc-datepicker="" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-end-id="bill_usage_end_date" datepicker-type="fromto"></div></div><div class="row"><div class="col-sm-3 ilabel" errorlabel="{{table}}.bill_heating_end" dataobj="properties"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_END\' | translate"></span> <span data-ng-if="properties[table].bill_heating_end.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.bill_heating_end" dataobj="properties"><input class="createinputter" id="bill_heating_end_date" ng-model="content[table].bill_heating_end" datepicker-change="saveWrapper(\'content.\'+table+\'.bill_heating_end\')" ssc-datepicker="" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-start-id="bill_heating_begin_date" datepicker-type="fromto"></div><div errorlabel="{{table}}.bill_usage_end" dataobj="properties" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_USAGE_END\' | translate"></span> <span data-ng-if="properties[table].bill_usage_end.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.bill_usage_end" dataobj="properties"><input class="createinputter" id="bill_usage_end_date" ng-model="content[table].bill_usage_end" datepicker-change="saveWrapper(\'content.\'+table+\'.bill_usage_end\')" ssc-datepicker="" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-start-id="bill_usage_begin_date" datepicker-type="fromto"></div></div><div class="row"><div errorlabel="{{table}}.bill_heating_days" ng-class="properties[table].bill_heating_days.warning ? \'warning\' : \'\'" dataobj="properties" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_DAYS\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_BILL_HEATING_DAYS"></help-pop-over><span data-ng-if="properties[table].bill_heating_days.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.bill_heating_days" ng-class="properties[table].bill_heating_days.warning ? \'warning\' : \'\'" dataobj="properties"><input class="createinputter" ng-model="content[table].bill_heating_days" forcedisabled="true"></div><div errorlabel="{{table}}.bill_usage_days" dataobj="properties" ng-class="properties[table].bill_usage_days.warning ? \'warning\' : \'\'" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_USAGE_DAYS\' | translate"></span> <span data-ng-if="properties[table].bill_usage_days.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.bill_usage_days" dataobj="properties" ng-class="properties[table].bill_usage_days.warning ? \'warning\' : \'\'"><input class="createinputter" ng-model="content[table].bill_usage_days" forcedisabled="true"></div></div><div class="row"><div errorlabel="{{table}}.heating_degree_days" ng-class="properties[table].heating_degree_days.warning ? \'warning\' : \'\'" dataobj="properties" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_HEATING_DEGREE_DAYS\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_HEATING_DEGREE_DAYS"></help-pop-over><span data-ng-if="properties[table].heating_degree_days.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.heating_degree_days" ng-class="properties[table].heating_degree_days.warning ? \'warning\' : \'\'" dataobj="properties"><input class="createinputter" ng-model="content[table].heating_degree_days" decimal-separator-german="" precision="0" forcedisabled="true"></div><div errorlabel="{{table}}.usage_degree_days" dataobj="properties" ng-class="properties[table].usage_degree_days.warning ? \'warning\' : \'\'" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USAGE_DEGREE_DAYS\' | translate"></span> <span data-ng-if="properties[table].usage_degree_days.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.usage_degree_days" dataobj="properties" ng-class="properties[table].usage_degree_days.warning ? \'warning\' : \'\'"><input class="createinputter" ng-model="content[table].usage_degree_days" decimal-separator-german="" precision="0" forcedisabled="true"></div></div><div class="row"><div errorlabel="{{table}}.fuel_type" dataobj="properties" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_FUEL_QUANTITY\' | translate"></span> <span data-ng-if="properties[table].fuel_type.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.fuel_type" dataobj="properties"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_FUEL_TYPE\' | translate"></span><select class="createdropper" ng-model="content[table].fuel_type" ng-model-options="{updateOn: \'blur\'}" ng-change="saveEvent(undefined, \'content.\'+table+\'.fuel_type\');"><option value=""></option><option ng-repeat="item in content.ssc_fuel_types_heating" ng-value="item.name" data-ng-bind="item.description"></option></select></div><div class="col-sm-3" errorlabel="{{table}}.fuel_type" dataobj="properties"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_FUEL_AMOUNT\' | translate"></span> <input class="createinputter" ng-model="content[table].fuel_amount" ng-blur="saveEvent($event);" decimal-separator-german="" precision="3"></div><div class="col-sm-3" errorlabel="{{table}}.fuel_type" dataobj="properties"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_FUEL_COSTS\' | translate"></span> <span class="nowrap"><input class="createinputter" ng-model="content[table].fuel_costs" ng-blur="saveEvent($event);" decimal-separator-german="" precision="3"> <span class="ilabel">\u20AC</span></span></div></div><div class="row"><div errorlabel="{{table}}.fuel_type_additionally" dataobj="properties" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_ADDITIONALLY_NOT_RECORDED\' | translate"></span> <span data-ng-if="properties[table].fuel_type_additionally.required">*</span></div><div class="col-sm-9 no-padd"><div class="row"><div class="col-sm-12"><div class="inlineblock" errorlabel="{{table}}.bill_additionally"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="content[table].bill_additionally" id="bill_additionally" ng-checked="content[table].bill_additionally === 1" ng-change="saveEvent(null,\'content.\'+table+\'.bill_additionally\');"><label class="checklabel" for="bill_additionally"></label> <span data-ng-bind="content[table].bill_additionally == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="clearfix"></div></div></div><div class="row"><div class="col-sm-4" errorlabel="{{table}}.fuel_type_additionally" dataobj="properties" ng-show="content[table].bill_additionally === 1"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_FUEL_TYPE\' | translate"></span><select class="createdropper" ng-model="content[table].fuel_type_additionally" ng-model-options="{updateOn: \'blur\'}" ng-change="saveEvent(undefined, \'content.\'+table+\'.fuel_type_additionally\');"><option value=""></option><option ng-repeat="item in content.ssc_fuel_types_heating" ng-value="item.name" data-ng-bind="item.description"></option></select></div><div class="col-sm-4" errorlabel="{{table}}.fuel_type_additionally" dataobj="properties" ng-show="content[table].bill_additionally === 1"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_FUEL_AMOUNT\' | translate"></span> <input class="createinputter" ng-model="content[table].fuel_amount_additionally" ng-blur="saveEvent($event);" decimal-separator-german="" precision="3"></div><div class="col-sm-4" errorlabel="{{table}}.fuel_type_additionally" dataobj="properties" ng-show="content[table].bill_additionally === 1"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_FUEL_COSTS\' | translate"></span> <span class="nowrap"><input class="createinputter" ng-model="content[table].fuel_costs_additionally" ng-blur="saveEvent($event);" decimal-separator-german="" precision="3"> <span class="ilabel">\u20AC</span></span></div></div></div></div><div class="row"><div class="col-sm-3 ilabel" ng-show="content[table].bill_additionally" errorlabel="{{table}}.fuel_add_total_kwh_price" dataobj="properties"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_ADDITIONAL_ENERGY\' | translate"></span></div><div class="col-sm-3" ng-show="content[table].bill_additionally" errorlabel="{{table}}.fuel_add_total_kwh" dataobj="properties"><input class="createinputter" ng-model="content[table].fuel_add_total_kwh" forcedisabled="true" decimal-separator-german=""></div><div class="col-sm-3 col-sm-offset-3" ng-show="content[table].bill_additionally" errorlabel="{{table}}.fuel_add_total_kwh_price" dataobj="properties"><span class="nowrap"><input class="createinputter" ng-model="content[table].fuel_add_total_kwh_price" forcedisabled="true" decimal-separator-german="" precision="2"> <span class="ilabel">\u20AC</span></span></div></div><div class="row"><div errorlabel="{{table}}.fuel_total_kwh" dataobj="properties" class="ilabel col-sm-3"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_FUEL_AMOUNT_OF_ENERGY_YEAR\' | translate"></span> <span data-ng-if="properties[table].fuel_total_kwh.required">*</span></div><div errorlabel="{{table}}.fuel_total_kwh" dataobj="properties" class="col-sm-3"><input class="createinputter" ng-model="content[table].fuel_total_kwh" forcedisabled="true" decimal-separator-german=""></div><div errorlabel="{{table}}.fuel_total_kwh_price" dataobj="properties" class="ilabel col-sm-3"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_FUEL_TOTAL_KWH\' | translate"></span> <span data-ng-if="properties[table].fuel_total_kwh_price.required">*</span></div><div errorlabel="{{table}}.fuel_total_kwh_price" dataobj="properties" class="col-sm-3"><span class="nowrap"><input class="createinputter" ng-model="content[table].fuel_total_kwh_price" forcedisabled="true" decimal-separator-german="" precision="2"> <span class="ilabel">\u20AC</span></span></div></div><div class="row"><div class="col-sm-12"><h5 data-ng-bind="\'SSC_HEAT_TOOL_HEATING_TITLE\' | translate"></h5></div></div><div class="row"><div errorlabel="{{table}}.distr_base_heating_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_DISTR_BASE_HEATING\' | translate"></span> <span data-ng-if="properties[table].distr_base_heating_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.distr_base_heating_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].distr_base_heating_cost" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">%</div><div errorlabel="{{table}}.distr_base_heating_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_heated_area" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_BUILDING_HEATED_AREA\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_BILL_HEATING_BUILDING_HEATED_AREA"></help-pop-over><span data-ng-if="properties[table].building_heated_area.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.building_heated_area" dataobj="properties"><input class="createinputter" ng-model="content[table].building_heated_area" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">m\xB2</div><div errorlabel="{{table}}.building_heated_area" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_heated_area" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_FLAT_HEATED_AREA\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_BILL_HEATING_FLAT_HEATED_AREA"></help-pop-over><span data-ng-if="properties[table].flat_heated_area.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_heated_area" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_heated_area" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">m\xB2</div><div errorlabel="{{table}}.flat_heated_area" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.distr_use_heating_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_DISTR_USE_HEATING\' | translate"></span> <span data-ng-if="properties[table].distr_use_heating_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.distr_use_heating_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].distr_use_heating_cost" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">%</div><div errorlabel="{{table}}.distr_use_heating_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_heat_units" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_BUILDING_HEAT_UNITS\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_BILL_HEATING_BUILDING_HEAT_UNITS"></help-pop-over><span data-ng-if="properties[table].building_heat_units.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.building_heat_units" dataobj="properties"><input class="createinputter" ng-model="content[table].building_heat_units" ng-blur="saveEvent($event);" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">Einheiten</div><div errorlabel="{{table}}.building_heat_units" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_heat_units_year" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_BUILDING_HEAT_UNITS_YEAR\' | translate"></span> <span data-ng-if="properties[table].building_heat_units_year.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.building_heat_units_year" dataobj="properties"><input class="createinputter" ng-model="content[table].building_heat_units_year" ng-blur="saveEvent($event);" forcedisabled="true" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">Einheiten</div><div errorlabel="{{table}}.building_heat_units_year" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_heat_units" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_FLAT_HEAT_UNITS\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_BILL_HEATING_FLAT_HEAT_UNITS"></help-pop-over><span data-ng-if="properties[table].flat_heat_units.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_heat_units" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_heat_units" ng-blur="saveEvent($event);" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">Einheiten</div><div errorlabel="{{table}}.flat_heat_units" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="{{table}}.flat_heat_units_year" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_FLAT_HEAT_UNITS_YEAR\' | translate"></span> <span data-ng-if="properties[table].flat_heat_units_year.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_heat_units_year" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_heat_units_year" ng-blur="saveEvent($event);" forcedisabled="true" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">Einheiten</div><div errorlabel="{{table}}.flat_heat_units_year" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-sm-12"><h5 data-ng-bind="\'SSC_HEAT_TOOL_WARMWATER_TITLE\' | translate"></h5></div></div><div class="row"><div errorlabel="{{table}}.water_heating_id" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_WATER_HEATING_TYPE\' | translate"></span> <span data-ng-if="properties[table].water_heating_id.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.water_heating_id" dataobj="properties"><select class="createdropper" ng-model="content[table].water_heating_id" ng-model-options="{updateOn: \'blur\'}" ng-change="saveEvent(undefined, \'content.\'+table+\'.water_heating_id\');"><option value=""></option><option ng-repeat="item in content.ssc_water_heating_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-1 ilabel no-padd"></div><div errorlabel="{{table}}.water_heating_id" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.distr_base_cost_hw" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_DISTR_BASE_COST_HW\' | translate"></span> <span data-ng-if="properties[table].distr_base_cost_hw.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.distr_base_cost_hw" dataobj="properties"><input class="createinputter" ng-model="content[table].distr_base_cost_hw" ng-blur="saveEvent($event);" decimal-separator-german="" precision="0"></div><div class="col-sm-1 ilabel no-padd">%</div><div errorlabel="{{table}}.distr_base_cost_hw" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_total_usable_area" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_BUILDING_TOTAL_USABLE_AREA\' | translate"></span> <span data-ng-if="properties[table].building_total_usable_area.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.building_total_usable_area" dataobj="properties"><input class="createinputter" ng-model="content[table].building_total_usable_area" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">m\xB2</div><div errorlabel="{{table}}.building_total_usable_area" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_living_area" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_FLAT_LIVING_AREA\' | translate"></span> <span data-ng-if="properties[table].flat_living_area.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_living_area" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_living_area" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">m\xB2</div><div errorlabel="{{table}}.flat_living_area" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.distr_use_cost_hw" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_DISTR_USE_COST_HW\' | translate"></span> <span data-ng-if="properties[table].distr_use_cost_hw.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.distr_use_cost_hw" dataobj="properties"><input class="createinputter" ng-model="content[table].distr_use_cost_hw" forcedisabled="true" decimal-separator-german="" precision="0"></div><div class="col-sm-1 ilabel no-padd">%</div><div errorlabel="{{table}}.distr_use_cost_hw" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_hw_bill" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_BUILDING_HW_BILL\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_BILL_HEATING_BUILDING_HW_BILL"></help-pop-over><span data-ng-if="properties[table].building_hw_bill.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.building_hw_bill" dataobj="properties"><input class="createinputter" ng-model="content[table].building_hw_bill" ng-blur="saveEvent($event);" decimal-separator-german="" precision="3"></div><div class="col-sm-1 ilabel no-padd">m\xB3</div><div errorlabel="{{table}}.building_hw_bill" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_hw_year" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_BUILDING_HW_YEAR\' | translate"></span> <span data-ng-if="properties[table].building_hw_year.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.building_hw_year" dataobj="properties"><input class="createinputter" ng-model="content[table].building_hw_year" forcedisabled="true" decimal-separator-german="" precision="3"></div><div class="col-sm-1 ilabel no-padd">m\xB3</div><div errorlabel="{{table}}.building_hw_year" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_hw_bill" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_FLAT_HW_BILL\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_BILL_HEATING_FLAT_HW_BILL"></help-pop-over><span data-ng-if="properties[table].flat_hw_bill.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_hw_bill" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_hw_bill" ng-blur="saveEvent($event);" decimal-separator-german="" precision="3"></div><div class="col-sm-1 ilabel no-padd">m\xB3</div><div errorlabel="{{table}}.flat_hw_bill" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_hw_year" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_FLAT_HW_YEAR\' | translate"></span> <span data-ng-if="properties[table].flat_hw_year.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_hw_year" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_hw_year" forcedisabled="true" decimal-separator-german="" precision="3"></div><div class="col-sm-1 ilabel no-padd">m\xB3</div><div errorlabel="{{table}}.flat_hw_year" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_hw_fuel_bill_pct" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_BUILDING_HW_FUEL_BILL_PCT\' | translate"></span> <span data-ng-if="properties[table].building_hw_fuel_bill_pct.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.building_hw_fuel_bill_pct" dataobj="properties"><input class="createinputter" ng-model="content[table].building_hw_fuel_bill_pct" ng-blur="calculateFuelPart();" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">%</div><div errorlabel="{{table}}.building_hw_fuel_bill_pct" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_hw_fuel_bill" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_BUILDING_HW_FUEL_BILL\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_BILL_HEATING_BUILDING_HW_FUEL_BILL"></help-pop-over><span data-ng-if="properties[table].building_hw_fuel_bill.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.building_hw_fuel_bill" dataobj="properties"><input class="createinputter" ng-model="content[table].building_hw_fuel_bill" ng-blur="saveEvent($event);" decimal-separator-german="" precision="0"></div><div class="col-sm-1 ilabel no-padd">kWh</div><div errorlabel="{{table}}.building_hw_fuel_bill" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_hw_fuel_year" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_BILL_HEATING_BUILDING_HW_FUEL_YEAR\' | translate"></span> <span data-ng-if="properties[table].building_hw_fuel_year.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.building_hw_fuel_year" dataobj="properties"><input class="createinputter" ng-model="content[table].building_hw_fuel_year" forcedisabled="true" decimal-separator-german="" precision="0"></div><div class="col-sm-1 ilabel no-padd">kWh</div><div errorlabel="{{table}}.building_hw_fuel_year" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div></div></div></div><div id="accordeon9" class="accordeon" ng-if="roomsAvailable()"><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion9" href="#collapse9"><span data-ng-bind="\'SSC_HEAT_TOOL_ROOMS_HEADLINE\' | translate"></span></div><div id="collapse9" class="collapse"><ssc-errorbox data-messages="errors.rooms.messages"></ssc-errorbox><div class="margcreatetop"></div><div class="row"><div errorlabel="{{table}}.consumption_per_room" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_CONSUMPTION_PER_ROOM\' | translate"></span> <span data-ng-if="properties[table].consumption_per_room.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.consumption_per_room" dataobj="properties"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="content[table].consumption_per_room" id="consumption_per_room" ng-checked="content[table].consumption_per_room === 1" ng-change="saveEvent(null,\'content.\'+table+\'.consumption_per_room\');"> <label class="checklabel" for="consumption_per_room"></label> <span data-ng-bind="content[table].consumption_per_room == 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="{{table}}.consumption_per_room" dataobj="properties" class="col-sm-2"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div ng-show="content[table].consumption_per_room === 1"><div class="row"><div class="col-sm-3 hidden-xs ilabel"><span ng-bind="\'SSC_HEAT_TOOL_ROOMS_ROOM_TYPE\' | translate"></span></div><div class="col-sm-4 hidden-xs ilabel"><span ng-bind="\'SSC_HEAT_TOOL_ROOMS_CONSUMPTION_UNITS\' | translate"></span></div><div class="col-sm-4 hidden-xs ilabel"><span ng-bind="\'SSC_HEAT_TOOL_ROOMS_CONSUMPTION_KWH\' | translate"></span></div></div><div ng-repeat="(roomIndex, room) in content.ssc_heating_tool_room track by room.id" class="row"><div class="visible-xs flabel"><span ng-bind="\'SSC_HEAT_TOOL_ROOM_HEADLINE\' | translate"></span> <span>{{ roomIndex + 1}}</span><ssc-delete-button delete-enabled="tableProperties.ssc_heating_tool_room.canDelete && !savingRooms" delete-onclick="delete(\'sscheatingtoolroom\', roomIndex, room.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div class="col-xs-12 visible-xs ilabel" errorlabel="ssc_heating_tool_room.{{roomIndex}}.room_id" dataobj="properties"><span data-ng-bind="\'SSC_HEAT_TOOL_ROOMS_ROOM_TYPE\' | translate"></span> <span data-ng-if="required.ssc_heating_tool_room[roomIndex].room_id.required">*</span></div><div class="col-sm-3" errorlabel="ssc_heating_tool_room.{{roomIndex}}.room_id" dataobj="properties"><select class="createdropper" ng-model="content.ssc_heating_tool_room[roomIndex].room_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(room, \'ssc_heating_tool_room.room_id\')" ng-options="item.id as item.name for item in content.ssc_room_types"><option value=""></option></select></div><div class="col-xs-12 visible-xs ilabel" errorlabel="ssc_heating_tool_room.{{roomIndex}}.consumption_units" dataobj="properties"><span data-ng-bind="\'SSC_HEAT_TOOL_ROOMS_CONSUMPTION_UNITS\' | translate"></span> <span data-ng-if="required.ssc_heating_tool_room[roomIndex].consumption_units.required">*</span></div><div class="col-sm-4" errorlabel="ssc_heating_tool_room.{{roomIndex}}.consumption_units" dataobj="properties"><input class="createinputter" ng-model="content.ssc_heating_tool_room[roomIndex].consumption_units" ng-change="save(room, \'ssc_heating_tool_room.consumption_units\')" ng-model-options="{updateOn: \'blur\'}" decimal-separator-german="" precision="2"></div><div class="col-xs-12 visible-xs ilabel" errorlabel="ssc_heating_tool_room.{{roomIndex}}.consumption_kwh" dataobj="properties"><span data-ng-bind="\'SSC_HEAT_TOOL_ROOMS_CONSUMPTION_KWH\' | translate"></span></div><div class="col-xs-10 col-sm-3" errorlabel="ssc_heating_tool_room.{{roomIndex}}.consumption_kwh" dataobj="properties"><input class="createinputter" ng-model="content.ssc_heating_tool_room[roomIndex].consumption_kwh" forcedisabled="true" decimal-separator-german="" precision="0"></div><div class="col-xs-2 col-sm-1 ilabel no-padd">kWh</div><div class="col-sm-1 hidden-xs"><ssc-delete-button delete-enabled="tableProperties.ssc_heating_tool_room.canDelete && !savingRooms" delete-onclick="delete(\'sscheatingtoolroom\', roomIndex, room.id)" delete-class="sscDeleteVertAlign"></ssc-delete-button></div></div><div class="row"><div class="col-sm-3 ilabel"><span ng-bind="\'SSC_HEAT_TOOL_ROOMS_TOTAL\' | translate"></span></div><div class="col-xs-12 visible-xs ilabel" errorlabel="ssc_heating_tool_room.{{roomIndex}}.consumption_kwh" dataobj="properties"><span data-ng-bind="\'SSC_HEAT_TOOL_ROOMS_CONSUMPTION_UNITS\' | translate"></span></div><div class="col-sm-4" errorlabel="ssc_heating_tool.rooms_consumption_units" dataobj="properties"><input class="createinputter" ng-model="content.ssc_heating_tool.rooms_consumption_units" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-xs-12 visible-xs ilabel" errorlabel="ssc_heating_tool_room.{{roomIndex}}.consumption_kwh" dataobj="properties"><span data-ng-bind="\'SSC_HEAT_TOOL_ROOMS_CONSUMPTION_KWH\' | translate"></span></div><div class="col-xs-10 col-sm-3" errorlabel="ssc_heating_tool.rooms_consumption_kwh" dataobj="properties"><input class="createinputter" ng-model="content.ssc_heating_tool.rooms_consumption_kwh" forcedisabled="true" decimal-separator-german="" precision="0"></div><div class="col-xs-2 col-sm-1 ilabel no-padd">kWh</div></div><div class="row"><div class="col-sm-4"><ssc-add-button add-enabled="tableProperties.ssc_heating_tool_room.canCreate" add-label="SSC_HEAT_TOOL_ROOMS_ADD_ROOM" add-is-saving="savingRooms" add-onclick="addRoom()"></ssc-add-button></div></div></div></div></div></div><div id="accordeon2" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion2" href="#collapse2"><span data-ng-bind="\'SSC_HEAT_TOOL_DB_HEADLINE\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_DB_HEADLINE"></help-pop-over></div><div id="collapse2" class="collapse"><div class="margcreatetop"></div><div class="row"><div errorlabel="{{table}}.flat_hw_year" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_DB_FLAT_HW_YEAR\' | translate"></span> <span data-ng-if="properties[table].flat_hw_year.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_hw_year" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_hw_year" forcedisabled="true" decimal-separator-german="" precision="3"></div><div class="col-sm-1 ilabel no-padd">m\xB3</div><div errorlabel="{{table}}.flat_hw_year" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_hw_energy" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_DB_FLAT_HW_ENERGY\' | translate"></span> <span data-ng-if="properties[table].flat_hw_energy.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_hw_energy" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_hw_energy" forcedisabled="true" decimal-separator-german="" precision="0"></div><div class="col-sm-1 ilabel no-padd">kWh</div><div errorlabel="{{table}}.flat_hw_energy" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.hw_fuel_price" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_DB_HW_FUEL_PRICE\' | translate"></span> <span data-ng-if="properties[table].hw_fuel_price.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.hw_fuel_price" dataobj="properties"><input class="createinputter" ng-model="content[table].hw_fuel_price" forcedisabled="true" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">\u20AC/kWh</div><div errorlabel="{{table}}.hw_fuel_price" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.hw_heating_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_DB_HW_HEATING_COST\' | translate"></span> <span data-ng-if="properties[table].hw_heating_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.hw_heating_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].hw_heating_cost" forcedisabled="true" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">\u20AC/kWh</div><div errorlabel="{{table}}.hw_heating_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.measured_heating_consumption" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_DB_MEASURED_HEATING_CONSUMPTION\' | translate"></span> <span data-ng-if="properties[table].measured_heating_consumption.required">*</span></div><div ng-if="content[table].measured_heating_consumption>0" class="col-sm-6" errorlabel="{{table}}.measured_heating_consumption" dataobj="properties"><input class="createinputter" ng-model="content[table].measured_heating_consumption" forcedisabled="true" decimal-separator-german="" precision="0"></div><div ng-if="content[table].measured_heating_consumption>0" class="col-sm-1 ilabel no-padd">kWh</div><div ng-if="content[table].measured_heating_consumption<=0" class="col-sm-2 ilabel no-padd"><span data-ng-bind="\'SSC_HEAT_TOOL_READ_HELP\' | translate"></span></div><div errorlabel="{{table}}.measured_heating_consumption" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.calc_hkv_consumption" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_DB_CALC_HKV_CONSUMTION\' | translate"></span> <span data-ng-if="properties[table].calc_hkv_consumption.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.calc_hkv_consumption" dataobj="properties"><input class="createinputter" ng-model="content[table].calc_hkv_consumption" forcedisabled="true" decimal-separator-german="" precision="0"></div><div class="col-sm-1 ilabel no-padd">kWh</div><div errorlabel="{{table}}.calc_hkv_consumption" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.heating_fuel_price" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_DB_HEATING_FUEL_PRICE\' | translate"></span> <span data-ng-if="properties[table].heating_fuel_price.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.heating_fuel_price" dataobj="properties"><input class="createinputter" ng-model="content[table].heating_fuel_price" forcedisabled="true" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">\u20AC/kWh</div><div errorlabel="{{table}}.heating_fuel_price" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.radiator_additional_price" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_DB_RADIATOR_ADDITIONAL_PRICE\' | translate"></span> <span data-ng-if="properties[table].radiator_additional_price.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.radiator_additional_price" dataobj="properties"><input class="createinputter" ng-model="content[table].radiator_additional_price" forcedisabled="true" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">\u20AC/kWh</div><div errorlabel="{{table}}.radiator_additional_price" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div></div></div></div><div id="accordeon3" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion3" href="#collapse3"><span data-ng-bind="\'SSC_HEAT_TOOL_STAT_HEADLINE\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_STAT_HEADLINE"></help-pop-over></div><div id="collapse3" class="collapse"><div class="margcreatetop"></div><div class="row"><div data-ng-class="{\'input-required\': false}" class="col-sm-8"></div><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_STAT_AREA_AVG\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_STAT_AREA_AVG"></help-pop-over></div></div><div class="row"><div errorlabel="{{table}}.stat_living_space_pct" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_STAT_LIVING_SPACE_PCT\' | translate"></span> <span data-ng-if="properties[table].stat_living_space_pct.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.stat_living_space_pct" dataobj="properties"><input class="createinputter" ng-model="content[table].stat_living_space_pct" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">%</div><div class="col-sm-4 ilabel"></div></div><div class="row"><div errorlabel="{{table}}.stat_heating_pct" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_STAT_HEATING_PCT\' | translate"></span><help-pop-over help="TIP_HEAT_TOOL_STAT_HEATING_PCT"></help-pop-over><span data-ng-if="properties[table].stat_heating_pct.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.stat_heating_pct" dataobj="properties"><input class="createinputter" ng-model="content[table].stat_heating_pct" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">%</div><div class="col-sm-3" errorlabel="{{table}}.stat_heating_avg" dataobj="properties"><input class="createinputter" ng-model="content[table].stat_heating_avg" forcedisabled="true" decimal-separator-german="" force-plus="" precision="2"></div><div class="col-sm-1 ilabel no-padd">%</div></div><div class="row"><div errorlabel="{{table}}.stat_hw_pct" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_STAT_HW_PCT\' | translate"></span> <span data-ng-if="properties[table].stat_hw_pct.required">*</span></div><div class="col-sm-3" errorlabel="{{table}}.stat_hw_pct" dataobj="properties"><input class="createinputter" ng-model="content[table].stat_hw_pct" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">%</div><div class="col-sm-3" errorlabel="{{table}}.stat_hw_avg" dataobj="properties"><input class="createinputter" ng-model="content[table].stat_hw_avg" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">%</div></div><div class="row" ng-show="tachoCss.visible"><div class="col-sm-12"><div id="tacho" class="tacho"><div id="tacho_wrapper" class="tacho_wrapper"><div id="tacho_drop" class="tacho_drop"><div id="tacho_top" class="tacho_top" ng-style="tachoCss.tachotop"><div id="tacho_top_title" class="tacho_top_title" ng-style="tachoCss.headlinetop">Geb\xE4ude</div><div id="tacho_top_arrow" class="tacho_top_arrow"></div></div><div id="tacho_bottom" class="tacho_bottom" ng-style="tachoCss.tachobottom"><div id="tacho_bottom_arrow" class="tacho_bottom_arrow"></div><div id="tacho_bottom_title" class="tacho_bottom_title" ng-style="tachoCss.headlinebottom">Wohnung</div></div></div><img id="tacho_image" class="tacho_image" src="../dist/resources/img/stromsparcheck/bandtacho_band.svg" alt=""><div class="tachoheattool"><span ng-repeat="lable in tachoLableCss" ng-style="lable.lineCss" data-ng-bind="\'|\'"></span> <span ng-repeat="lable in tachoLableCss" ng-style="lable.lableCss" data-ng-bind="lable.lable"></span></div></div></div></div></div><div class="margcreatetop"></div></div></div></div><div ng-show="showHeatingCostCalculation()"><h4 data-ng-bind="\'SSC_HEAT_TOOL_HEAT_METERING_HEADLINE\' | translate"></h4><div id="accordeon4" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion4" href="#collapse4"><span data-ng-bind="\'SSC_HEAT_TOOL_HEAT_METERING_HEADLINE_ADDITIONAL_COSTS\' | translate"></span></div><div id="collapse4" class="collapse"><div class="margcreatetop"></div><div class="row"><div errorlabel="{{table}}.cost_heat_electric" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_ELECTRIC\' | translate"></span> <span data-ng-if="properties[table].cost_heat_electric.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_heat_electric" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_electric" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_electric" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_heat_maintenance_boiler" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_MAINTENANCE_BOILER\' | translate"></span> <span data-ng-if="properties[table].cost_heat_maintenance_boiler.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_heat_maintenance_boiler" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_maintenance_boiler" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_maintenance_boiler" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_heat_monitoring" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_MONITORING\' | translate"></span> <span data-ng-if="properties[table].cost_heat_monitoring.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_heat_monitoring" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_monitoring" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_monitoring" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_heat_maintenance_hw_gen" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_MAINTENANCE_HW_GEN\' | translate"></span> <span data-ng-if="properties[table].cost_heat_maintenance_hw_gen.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_heat_maintenance_hw_gen" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_maintenance_hw_gen" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_maintenance_hw_gen" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_heat_emission_measure" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_EMISSION_MEASURE\' | translate"></span> <span data-ng-if="properties[table].cost_heat_emission_measure.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_heat_emission_measure" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_emission_measure" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_emission_measure" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_heat_heatserv_charge" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_HEATSERC_CHARGE\' | translate"></span> <span data-ng-if="properties[table].cost_heat_heatserv_charge.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_heat_heatserv_charge" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_heatserv_charge" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_heatserv_charge" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_heat_distrib_rent" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_DISTRIB_RENT\' | translate"></span> <span data-ng-if="properties[table].cost_heat_distrib_rent.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_heat_distrib_rent" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_distrib_rent" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_distrib_rent" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_heat_other" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_OTHER\' | translate"></span> <span data-ng-if="properties[table].cost_heat_other.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_heat_other" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_other" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_other" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_heat_total" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_TOTAL\' | translate"></span> <span data-ng-if="properties[table].cost_heat_total.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_heat_total" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_total" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_total" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div></div></div></div><div id="accordeon10" class="accordeon" ng-if="table === \'ssc_heating_tool\'"><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion10" href="#collapse10"><span data-ng-bind="\'SSC_HEAT_TOOL_HEATING_COSTS_MISC_HEADLINE\' | translate"></span></div><div id="collapse10" class="collapse"><div class="margcreatetop"></div><div class="row"><div errorlabel="{{table}}.cost_heat_misc_1" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_MISC_1\' | translate"></span> <span data-ng-if="properties[table].cost_heat_misc_1.required">*</span></div><div class="col-sm-6 col-xs-10" errorlabel="{{table}}.cost_heat_misc_1" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_misc_1" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-xs-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_misc_1" dataobj="properties" class="col-xs-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_heat_misc_2" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_MISC_2\' | translate"></span> <span data-ng-if="properties[table].cost_heat_misc_2.required">*</span></div><div class="col-sm-6 col-xs-10" errorlabel="{{table}}.cost_heat_misc_2" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_misc_2" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-xs-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_heat_misc_2" dataobj="properties" class="col-xs-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_heat_misc_total" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_COST_HEAT_MISC_TOTAL\' | translate"></span></div><div class="col-sm-6 col-xs-10" errorlabel="{{table}}.cost_heat_misc_total" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_heat_misc_total" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2" forcedisabled="true"></div><div class="col-xs-1 ilabel no-padd">\u20AC</div></div><div class="margcreatebot"></div></div></div></div><div id="accordeon5" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion5" href="#collapse5"><span data-ng-bind="\'SSC_HEAT_TOOL_ADDITIONAL_COSTS_HEADLINE\' | translate"></span></div><div id="collapse5" class="collapse"><div class="margcreatetop"></div><div class="row"><div errorlabel="{{table}}.cost_hw_meter_rent" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_ADDITIONAL_COSTS_HW_METER_RENT\' | translate"></span> <span data-ng-if="properties[table].cost_hw_meter_rent.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_hw_meter_rent" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_hw_meter_rent" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_hw_meter_rent" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_hw_meter_maintenance" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_ADDITIONAL_COSTS_HW_METER_MAINTENANCE\' | translate"></span> <span data-ng-if="properties[table].cost_hw_meter_maintenance.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_hw_meter_maintenance" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_hw_meter_maintenance" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_hw_meter_maintenance" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_hw_other" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_ADDITIONAL_COSTS_HW_OTHER\' | translate"></span> <span data-ng-if="properties[table].cost_hw_other.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_hw_other" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_hw_other" ng-blur="saveEvent($event);" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_hw_other" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.cost_hw_total" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_ADDITIONAL_COSTS_HW_TOTAL\' | translate"></span> <span data-ng-if="properties[table].cost_hw_total.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.cost_hw_total" dataobj="properties"><input class="createinputter" ng-model="content[table].cost_hw_total" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.cost_hw_total" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.total_fuel_add_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_ADDITIONAL_COSTS_TOTAL_FUEL_ADD_COST\' | translate"></span> <span data-ng-if="properties[table].total_fuel_add_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.total_fuel_add_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].total_fuel_add_cost" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.total_fuel_add_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.fuel_costs_heating" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_ADDITIONAL_COSTS_FUEL_COSTS_HEATING\' | translate"></span> <span data-ng-if="properties[table].fuel_costs_heating.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.fuel_costs_heating" dataobj="properties"><input class="createinputter" ng-model="content[table].fuel_costs_heating" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.fuel_costs_heating" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.fuel_costs_hw" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_ADDITIONAL_COSTS_FUEL_COSTS_HW\' | translate"></span> <span data-ng-if="properties[table].fuel_costs_hw.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.fuel_costs_hw" dataobj="properties"><input class="createinputter" ng-model="content[table].fuel_costs_hw" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.fuel_costs_hw" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.total_heating_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_ADDITIONAL_COSTS_TOTAL_HEATING_COST\' | translate"></span> <span data-ng-if="properties[table].total_heating_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.total_heating_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].total_heating_cost" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.total_heating_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.total_hw_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_ADDITIONAL_COSTS_TOTAL_HW_COST\' | translate"></span> <span data-ng-if="properties[table].total_hw_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.total_hw_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].total_hw_cost" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.total_hw_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div></div></div></div><div id="accordeon6" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion6" href="#collapse6"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_HEADLINE\' | translate"></span></div><div id="collapse6" class="collapse"><div class="margcreatetop"></div><div class="row"><div errorlabel="{{table}}.to_distr_base_cost_heat" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_TO_DISTR_BASE_COST_HEAT\' | translate"></span> <span data-ng-if="properties[table].to_distr_base_cost_heat.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.to_distr_base_cost_heat" dataobj="properties"><input class="createinputter" ng-model="content[table].to_distr_base_cost_heat" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.to_distr_base_cost_heat" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" errorlabel="{{table}}.building_heated_area" dataobj="properties"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_BUILDING_HEATED_AREA\' | translate"></span></div><div class="col-sm-6" errorlabel="{{table}}.building_heated_area" dataobj="properties"><input class="createinputter" ng-model="content[table].building_heated_area" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">m\xB2</div><div errorlabel="{{table}}.building_heated_area" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.price_per_heat_unit" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_PRICE_PER_HEAT_UNIT\' | translate"></span> <span data-ng-if="properties[table].price_per_heat_unit.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.price_per_heat_unit" dataobj="properties"><input class="createinputter" ng-model="content[table].price_per_heat_unit" forcedisabled="true" decimal-separator-german="" precision="7"></div><div class="col-sm-1 ilabel no-padd">\u20AC/m\xB2</div><div errorlabel="{{table}}.price_per_heat_unit" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_heated_area" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_FLAT_HEATED_AREA\' | translate"></span></div><div class="col-sm-6" errorlabel="{{table}}.flat_heated_area" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_heated_area" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">m\xB2</div><div errorlabel="{{table}}.flat_heated_area" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_base_heat_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_FLAT_BASE_HEAT_COST\' | translate"></span> <span data-ng-if="properties[table].flat_base_heat_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_base_heat_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_base_heat_cost" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.flat_base_heat_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.to_distr_use_cost_heat" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_TO_DISTR_USE_COST_HEAT\' | translate"></span> <span data-ng-if="properties[table].to_distr_use_cost_heat.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.to_distr_use_cost_heat" dataobj="properties"><input class="createinputter" ng-model="content[table].to_distr_use_cost_heat" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.to_distr_use_cost_heat" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_heat_units" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_BUILDING_HEAT_UNITS\' | translate"></span></div><div class="col-sm-6" errorlabel="{{table}}.building_heat_units" dataobj="properties"><input class="createinputter" ng-model="content[table].building_heat_units" forcedisabled="true" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">Einheiten</div><div errorlabel="{{table}}.building_heat_units" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.price_per_distr_unit" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_PRICE_PER_DISTR_UNIT\' | translate"></span> <span data-ng-if="properties[table].price_per_distr_unit.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.price_per_distr_unit" dataobj="properties"><input class="createinputter" ng-model="content[table].price_per_distr_unit" forcedisabled="true" decimal-separator-german="" precision="7"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.price_per_distr_unit" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_heat_units" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_FLAT_HEAT_UNITS\' | translate"></span></div><div class="col-sm-6" errorlabel="{{table}}.flat_heat_units" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_heat_units" forcedisabled="true" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">Einheiten</div><div errorlabel="{{table}}.flat_heat_units" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_use_cost_heat" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_FLAT_USE_COST_HEAT\' | translate"></span> <span data-ng-if="properties[table].flat_use_cost_heat.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_use_cost_heat" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_use_cost_heat" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-2 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.flat_use_cost_heat" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.fuel_add_total_kwh_price" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_ADDITIONAL_COST\' | translate"></span> <span data-ng-if="properties[table].fuel_add_total_kwh_price.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.fuel_add_total_kwh_price" dataobj="properties"><input class="createinputter" ng-model="content[table].fuel_add_total_kwh_price" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-2 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.fuel_add_total_kwh_price" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.heat_cost_all" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_ALL_USE_COST_HEAT\' | translate"></span> <span data-ng-if="properties[table].heat_cost_all.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.heat_cost_all" dataobj="properties"><input class="createinputter" ng-model="content[table].heat_cost_all" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-2 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.heat_cost_all" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.heat_cost_if_average" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_COST_IF_AVERAGE\' | translate"></span> <span data-ng-if="properties[table].heat_cost_if_average.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.heat_cost_if_average" dataobj="properties"><input class="createinputter" ng-model="content[table].heat_cost_if_average" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.heat_cost_if_average" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.heat_cost_divergence" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_COST_DIVERGENCE\' | translate"></span> <span data-ng-if="properties[table].heat_cost_divergence.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.heat_cost_divergence" dataobj="properties"><input class="createinputter" ng-model="content[table].heat_cost_divergence" forcedisabled="true" decimal-separator-german="" force-plus="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.heat_cost_divergence" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_total_heat_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_FLAT_TOTAL_HEAT_COST\' | translate"></span> <span data-ng-if="properties[table].flat_total_heat_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_total_heat_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_total_heat_cost" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.flat_total_heat_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_total_all_heat_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_HEAT_FLAT_TOTAL_ALL_HEAT_COST\' | translate"></span> <span data-ng-if="properties[table].flat_total_heat_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_total_all_heat_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_total_all_heat_cost" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.flat_total_all_heat_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div></div></div></div><div id="accordeon7" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion7" href="#collapse7"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_HEADLINE\' | translate"></span></div><div id="collapse7" class="collapse"><div class="margcreatetop"></div><div class="row"><div errorlabel="{{table}}.to_distr_base_cost_hw" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_TO_DISTR_BASE_COST_HW\' | translate"></span> <span data-ng-if="properties[table].to_distr_base_cost_hw.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.to_distr_base_cost_hw" dataobj="properties"><input class="createinputter" ng-model="content[table].to_distr_base_cost_hw" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.to_distr_base_cost_hw" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_total_usable_area" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_BUILDING_TOTAL_USABLE_AREA\' | translate"></span></div><div class="col-sm-6" errorlabel="{{table}}.building_total_usable_area" dataobj="properties"><input class="createinputter" ng-model="content[table].building_total_usable_area" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">m\xB2</div><div errorlabel="{{table}}.building_total_usable_area" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.price_per_hw_unit" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_PRICE_PER_HW_UNIT\' | translate"></span> <span data-ng-if="properties[table].price_per_hw_unit.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.price_per_hw_unit" dataobj="properties"><input class="createinputter" ng-model="content[table].price_per_hw_unit" forcedisabled="true" decimal-separator-german="" precision="7"></div><div class="col-sm-1 ilabel no-padd">\u20AC/m\xB2</div><div errorlabel="{{table}}.price_per_hw_unit" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_living_area" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_FLAT_HEATED_AREA\' | translate"></span></div><div class="col-sm-6" errorlabel="{{table}}.flat_living_area" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_living_area" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">m\xB2</div><div errorlabel="{{table}}.flat_living_area" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_base_cost_hw" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_FLAT_BASE_COST_HW\' | translate"></span> <span data-ng-if="properties[table].flat_base_cost_hw.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_base_cost_hw" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_base_cost_hw" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.flat_base_cost_hw" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.to_distr_use_cost_hw" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_TO_DISTR_USE_COST_HW\' | translate"></span> <span data-ng-if="properties[table].to_distr_use_cost_hw.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.to_distr_use_cost_hw" dataobj="properties"><input class="createinputter" ng-model="content[table].to_distr_use_cost_hw" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.to_distr_use_cost_hw" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.building_hw_bill" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_BUILDING_HW_BILL\' | translate"></span></div><div class="col-sm-6" errorlabel="{{table}}.building_hw_bill" dataobj="properties"><input class="createinputter" ng-model="content[table].building_hw_bill" forcedisabled="true" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">m\xB3</div><div errorlabel="{{table}}.building_hw_bill" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.price_per_distr_unit_hw" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_PRICE_PER_DISTR_UNIT_HW\' | translate"></span> <span data-ng-if="properties[table].price_per_distr_unit_hw.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.price_per_distr_unit_hw" dataobj="properties"><input class="createinputter" ng-model="content[table].price_per_distr_unit_hw" forcedisabled="true" decimal-separator-german="" precision="7"></div><div class="col-sm-1 ilabel no-padd">\u20AC/m\xB3</div><div errorlabel="{{table}}.price_per_distr_unit_hw" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_hw_bill" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_FLAT_HW_BILL\' | translate"></span></div><div class="col-sm-6" errorlabel="{{table}}.flat_hw_bill" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_hw_bill" forcedisabled="true" decimal-separator-german="" precision="4"></div><div class="col-sm-1 ilabel no-padd">m\xB3</div><div errorlabel="{{table}}.flat_hw_bill" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_use_cost_hw" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_FLAT_USE_COST_HW\' | translate"></span> <span data-ng-if="properties[table].flat_use_cost_hw.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_use_cost_hw" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_use_cost_hw" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.flat_use_cost_hw" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.hw_cost_if_average" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_HW_COST_IF_AVERAGE\' | translate"></span> <span data-ng-if="properties[table].hw_cost_if_average.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.hw_cost_if_average" dataobj="properties"><input class="createinputter" ng-model="content[table].hw_cost_if_average" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.hw_cost_if_average" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.hw_cost_divergence" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_HW_COST_DIVERGENCE\' | translate"></span> <span data-ng-if="properties[table].hw_cost_divergence.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.hw_cost_divergence" dataobj="properties"><input class="createinputter" ng-model="content[table].hw_cost_divergence" forcedisabled="true" decimal-separator-german="" force-plus="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.hw_cost_divergence" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.total_hw_heating_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_TOTAL_HW_HEATING_COST\' | translate"></span> <span data-ng-if="properties[table].total_hw_heating_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.total_hw_heating_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].total_hw_heating_cost" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.total_hw_heating_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div></div></div></div><div id="accordeon8" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion8" href="#collapse8"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_HEAT_HEADLINE\' | translate"></span></div><div id="collapse8" class="collapse"><div class="margcreatetop"></div><div class="row"><div errorlabel="{{table}}.flat_heat_hw_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_HEAT_FLAT_HEAT_HW_COST\' | translate"></span> <span data-ng-if="properties[table].flat_heat_hw_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_heat_hw_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_heat_hw_cost" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.flat_heat_hw_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.flat_heat_hw_all_cost" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_HEAT_FLAT_HEAT_HW_ALL_COST\' | translate"></span> <span data-ng-if="properties[table].flat_heat_hw_all_cost.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.flat_heat_hw_all_cost" dataobj="properties"><input class="createinputter" ng-model="content[table].flat_heat_hw_all_cost" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.flat_heat_hw_all_cost" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.heat_hw_cost_if_average" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_HEAT_HW_COST_ID_AVERAGE\' | translate"></span> <span data-ng-if="properties[table].heat_hw_cost_if_average.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.heat_hw_cost_if_average" dataobj="properties"><input class="createinputter" ng-model="content[table].heat_hw_cost_if_average" forcedisabled="true" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.heat_hw_cost_if_average" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="{{table}}.total_cost_divergence" dataobj="properties" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_TOOL_USE_COSTS_WARMWATER_HEAT_TOTAL_COST_DIVERGENCE\' | translate"></span> <span data-ng-if="properties[table].total_cost_divergence.required">*</span></div><div class="col-sm-6" errorlabel="{{table}}.total_cost_divergence" dataobj="properties"><input class="createinputter" ng-model="content[table].total_cost_divergence" forcedisabled="true" decimal-separator-german="" force-plus="" precision="2"></div><div class="col-sm-1 ilabel no-padd">\u20AC</div><div errorlabel="{{table}}.total_cost_divergence" dataobj="properties" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div></div></div></div></div><div class="row"><div class="col-md-offset-9 col-md-3"><button data-ng-if="1" ng-click="ready(\'HEATING_TOOL\')" class="redbutton" type="submit"><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/form/sscHouselocation/sscHouselaction.view.html','<div class="house_wrapper"><input type="hidden" name="location_old" ng-model="data.monitoring_heatdirecthelp.location_old"><div class="house_roof"><div class="house_roof_inner" errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h1" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h1 == 1" id="fw_lwh_old_h1" ng-change="update_flat_old_position()" ng-true-value="1" ng-false-value="0"></div></div><table class="house_body"><tbody><tr><td errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h2" id="fw_lwh_old_h2" ng-true-value="1" ng-false-value="0" ng-change="update_flat_old_position()" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h2 == 1"></td><td errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h3" id="fw_lwh_old_h3" ng-true-value="1" ng-false-value="0" ng-change="update_flat_old_position()" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h3 == 1"></td><td errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h4" id="fw_lwh_old_h4" ng-true-value="1" ng-false-value="0" ng-change="update_flat_old_position()" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h4 == 1"></td></tr><tr><td errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h5" id="fw_lwh_old_h5" ng-true-value="1" ng-false-value="0" ng-change="update_flat_old_position()" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h5 == 1"></td><td errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h6" id="fw_lwh_old_h6" ng-true-value="1" ng-false-value="0" ng-change="update_flat_old_position()" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h6 == 1"></td><td errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h7" id="fw_lwh_old_h7" ng-true-value="1" ng-false-value="0" ng-change="update_flat_old_position()" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h7 == 1"></td></tr><tr><td errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h8" id="fw_lwh_old_h8" ng-true-value="1" ng-false-value="0" ng-change="update_flat_old_position()" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h8 == 1"></td><td errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h9" id="fw_lwh_old_h9" ng-true-value="1" ng-false-value="0" ng-change="update_flat_old_position()" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h9 == 1"></td><td errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h10" id="fw_lwh_old_h10" ng-true-value="1" ng-false-value="0" ng-change="update_flat_old_position()" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h10 == 1"></td></tr><tr><td errorlabel="monitoring_heatdirecthelp.location_old" dataobj="required" colspan="3"><input class="basement" style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix_old.fw_lwh_old_h11" id="fw_lwh_old_h11" ng-change="update_flat_old_position()" ng-true-value="1" ng-false-value="0" ng-checked="position_flat_house_matrix_old.fw_lwh_old_h11 == 1"></td></tr></tbody></table></div>');
$templateCache.put('templates/components/content/stromsparcheck/form/sscInput/sscInput.view.html','<div><div ng-if="!properties[column].hidden"><div class="row" ng-class="{\'error\': properties[column].error, \'warning\': properties[column].warning}" title="{{properties[column].error + properties[column].warning}}"><div class="col-sm-4 ilabel"><span ng-bind="label | translate"></span> <span ng-bind-html="labelHtml |translate"></span> <span data-ng-if="isRequired">*</span><help-pop-over help="{{help}}" ng-if="help"></help-pop-over></div><div ng-if="type === \'input\' || !type"><div class="col-sm-6 col-xs-8"><input class="createinputter" ng-model="record[column]" ng-blur="save()" ng-disabled="isDisabled" ng-focus="focus()" decimal-separator-german="" precision="{{precision}}" ng-if="!isText"> <input class="createinputter" ng-model="record[column]" ng-blur="save()" ng-disabled="isDisabled" ng-focus="focus()" ng-if="isText && !options"> <input class="createinputter" ng-model="record[column]" ng-blur="save()" ng-disabled="isDisabled" ng-focus="focus()" ng-if="isText && options" list="{{inputUniqueId}}_list"><datalist id="{{inputUniqueId}}_list" ng-if="options"><option ng-repeat="option in options" value="{{option[optionfield]}}"></option></datalist></div></div><div ng-if="type === \'textarea\' || !type"><div class="col-sm-6 col-xs-8"><textarea ng-model="record[column]" ng-blur="save()" ng-disabled="isDisabled" ng-focus="focus()" style="height:6em;" class="createinputter"></textarea></div></div><div ng-if="type === \'select\' || !type"><div class="col-sm-6 col-xs-8" ng-if="type === \'select\'"><select class="createdropper" ng-model="record[column]" ng-change="save(record, tableField)" ng-disabled="isDisabled" ng-options="item.id as item[optionfield] for item in options"><option value=""></option></select></div></div><div ng-if="type === \'toggle\' || !type"><div class="col-sm-6 col-xs-8"><div ng-if="inverted"><input type="checkbox" ng-true-value="0" ng-false-value="1" ng-disabled="isDisabled" ng-model="record[column]" id="{{inputUniqueId}} + \'invert\'" ng-change="save()"> <label class="checklabel" for="{{inputUniqueId}} + \'invert\'"></label> <span data-ng-bind="record[column] ? (\'NO\' | translate) : (\'YES\' | translate)" class="checklabelText"></span></div><div ng-if="!inverted"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-disabled="isDisabled" ng-model="record[column]" id="{{inputUniqueId}}" ng-change="save()"> <label class="checklabel" for="{{inputUniqueId}}"></label> <span data-ng-bind="record[column] === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div><div ng-if="type === \'label\' || !type"><div class="col-sm-6 col-xs-8 nlabel"><span ng-if="!displayValue"><span data-ng-bind="record[column] | decimal2comma: precision" ng-if="!isText"></span> <span data-ng-bind="record[column]" ng-if="isText"></span></span> <span ng-if="displayValue"><span data-ng-bind="displayValue | decimal2comma: precision" ng-if="!isText"></span> <span data-ng-bind="displayValue" ng-if="isText"></span></span> &nbsp;<span ng-bind="unit"></span> <span ng-bind-html="unitHtml"></span></div></div><div ng-if="type === \'date\' || !type"><div class="col-sm-6 col-xs-8"><input class="createinputter" ssc-datepicker="" data-ng-model="record[column]" ng-focus="focus()" datepicker-change="save()" ng-disabled="isDisabled" datepicker-format="{{convertViewFormat(dateformattype)}}" datepicker-model-format="{{convertModelFormat(datemodeltype)}}"></div></div><div class="col-sm-1 col-xs-2 ilabel no-padd"><span ng-hide="type === \'label\'"><span ng-bind="unit"></span> <span ng-bind-html="unitHtml"></span></span></div><div class="col-sm-1 col-xs-2" ng-if="properties[column].error || properties[column].warning"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div>');
$templateCache.put('templates/components/content/user/employmenttype/employmenttypeCreate/employmenttypeCreate.view.html','<div class="container"><div permission="" permission-except=\'["ADMIN"]\' style="text-align:center"><h4>Nicht gefunden</h4></div><div class="row" permission="" permission-only=\'["ADMIN"]\'><div class="col-sm-12"><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div><div class="col-sm-7 field"><div data-ng-if="!edit" class="row hlabel" data-ng-bind="\'EMPLOYMENTTYPE_NEW\'| translate"></div><div data-ng-if="edit" class="row hlabel" data-ng-bind="\'EMPLOYMENTTYPE_UPDATE\' | translate:{name:name}"></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'EMPLOYMENTTYPE_TITLE\' | translate"></span> <span data-ng-if="required.name">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved}" class="createinputter" ng-model="model.name"></div><div data-ng-if="(((model.name + \'\').length == 0) || (model.name == null)) && required.name && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.status + \'\').length == 0) || (model.status == null)) && required.status && saved}" class="col-sm-6 ilabel"><span data-ng-bind="\'DIRECTHELP_STATUS\' | translate"></span> <span data-ng-if="required.status">*</span></div><div class="col-sm-5"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="model.status" value="required.status" id="checkboxEmploymenttypeStatus" ng-checked="model.status == 1"> <label class="checklabel" for="checkboxEmploymenttypeStatus"></label> <span data-ng-bind="model.status==1 ? (\'ACTIVE\'|translate) : (\'INACTIVE\'|translate)" class="checklabelText"></span></div><div data-ng-if="(((model.status + \'\').length == 0) || (model.status == null)) && required.status && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="col-sm-3 col-sm-offset-9"><button data-ng-if="!edit" ng-click="save()" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button> <button data-ng-if="edit" ng-click="update()" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/user/employmenttype/search/search.view.html','<div class="container"><div class="row margcreatebot"><div class="col-sm-4"><form ng-submit="search()"><input data-ng-model="searchfield" class="createinputter" type="search" placeholder="{{\'SEARCH_TITLE_EMPLOYMENTTYP\'| translate}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div><div class="col-sm-8 text-right" data-ng-if="bSearch"><a class="searchtext" ng-click="clearFilter()" data-ng-bind="\'SEARCH_RESET\' | translate"></a></div></div></div>');
$templateCache.put('templates/components/content/user/userByRole/roleBox/roleBox.view.html','<div><div class="col-md-12 role-box"><table class="table table-striped margcreatetop"><tr ng-repeat="item in roles" class="ui-grid-row"><td class="ui-grid-cell"><div data-ng-bind="item.user_role_area_map.location[0].name" ng-if="item.user_role_area_map.location"></div><div data-ng-bind="item.user_role_area_map.state[0].name" ng-if="item.user_role_area_map.state"></div><div data-ng-bind="item.user_role_area_map.organisation[0].name" ng-if="item.user_role_area_map.organisation"></div><div data-ng-bind="item.user_role_area_map.region[0].name" ng-if="item.user_role_area_map.region"></div></td><td class="ui-grid-cell"><div data-ng-bind="item.role.role"></div></td></tr></table></div></div>');
$templateCache.put('templates/components/content/user/userByRole/search/search.view.html','<div><div class="container"><div class="row"><div class="col-sm-4"><form ng-submit="search()"><input data-ng-model="searchfield" class="createinputter" type="search" placeholder="{{\'SEARCH_TITLE_SSHS\'| translate}}"> <button type="submit" class="search"><i class="fa fa-search" aria-hidden="true"></i></button></form></div></div></div><div class="collapse" id="filter-collapse"><div class="graybg margcreatetop"><div class="container"><div class="push-top"></div><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_LOCATION\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((location_id + \'\').length == 0) || (location_id == null)) && required && saved}" class="createdropper" ng-model="location_id" id="filter"><option ng-repeat="item in dropLocation" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-6 col-sm-offset-1"><label for="places" ng-bind="\'SEARCH_REGION\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((region_id + \'\').length == 0) || (region_id == null)) && required && saved}" class="createdropper" ng-model="region_id" id="places"><option ng-repeat="item in dropRegion" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-6 col-sm-offset-6 push-bottom"><div class="row"><div class="col-sm-offset-6 col-sm-6"><button type="submit" class="greybutton" ng-click="search()"><i class="fa fa-filter" aria-hidden="true"></i> <span data-ng-bind="\'SEARCH_SEARCH\' | translate"></span></button></div></div></div></div></div></div></div>');
$templateCache.put('templates/components/content/user/userSubstitute/userSubstituteCreate/userSubstituteCreate.view.html','<div class="container"><div ng-show="isNotFound" style="text-align:center"><h4>Nicht gefunden</h4></div><div ng-show="!isNotFound"><div ng-if="!formVars.canCreateSubstitute"><ssc-errorbox data-messages="[{type:\'error\',text:(\'FORM_ERROR_SUBSTITUTE_ROLE\' | translate)}]" ssc-errorbox-title="\'FORM_ERROR_GENERIC\' | translate"></ssc-errorbox></div><div class="row" ng-if="formVars.canCreateSubstitute"><div class="col-sm-12"><h4><span data-ng-if="!edit" data-ng-bind="\'USER_CREATE_SUBSTITUTE\' | translate:{name: name}"></span> <span data-ng-if="edit" data-ng-bind="\'USER_UPDATE_SUBSTITUTE\' | translate:{name: name}"></span></h4><div class="subheading" ng-if="subheading" ng-bind="subheading"></div><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div><div class="col-sm-10 col-md-8 field"><div class="row" ng-if="showSshOption"><div data-ng-class="{\'input-required\': (((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_SUBSTITUTE_ROLE\' | translate"></span></div><div class="col-sm-7"><select class="createdropper rightdropper" ng-model="selector.role" data-ng-change="reloadUsers();"><option ng-value="SSH">LOKO</option><option ng-value="SSHPLUS">SSH+</option></select></div><div data-ng-if="(((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.user_id + \'\').length == 0) || (model.user_id == null)) && required.user_id && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_SUBSTITUTE\' | translate"></span> <span data-ng-if="required.user_id">*</span></div><div class="col-sm-7"><ui-select class="ssc-ui-select" theme="selectize" ng-model="user" on-select="OnClickSelect($item)" on-remove="OnRemoveSelect($item)" data-ng-class="{\'input-required-border\': (((model.user_id + \'\').length == 0) || (model.user_id == null)) && required.user_id && saved}"><ui-select-match>{{$select.selected.id + \' - \' + $select.selected.fullname}}</ui-select-match><ui-select-choices repeat="res in searchRes | filter:$select.search"><span data-ng-bind-html="(res.id + \' - \' + res.fullname) | highlight: $select.search"></span></ui-select-choices></ui-select></div><div data-ng-if="(((model.user_id + \'\').length == 0) || (model.user_id == null)) && required.user_id && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_DATESTART\' | translate"></span> <span data-ng-if="required.date_begin">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved}" class="createinputter" id="begin" ssc-datepicker="" data-ng-model="model.date_begin" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="end"></div><div data-ng-if="(((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.date_end + \'\').length == 0) || (model.date_end == null)) && required.date_end && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_DATESTOP\' | translate"></span> <span data-ng-if="required.date_end">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.date_end + \'\').length == 0) || (model.date_end == null)) && required.date_end && saved}" class="createinputter" id="end" ssc-datepicker="" data-ng-model="model.date_end" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="begin"></div><div data-ng-if="(((model.date_end + \'\').length == 0) || (model.date_end == null)) && required.date_end && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'LOCATION_STATUS\' | translate"></span> <span data-ng-if="required.status">*</span></div><div class="col-sm-3 col-sm-offset-4"><input data-ng-class="{\'input-required-border\': (((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved}" type="checkbox" ng-model="model.status" ng-true-value="1" ng-false-value="0" ng-chid="checkboxNews" id="checkboxNews" ng-checked="model.status == 1"> <label class="checklabel" for="checkboxNews"></label> <span data-ng-bind="model.status==1 ? (\'ACTIVE\'|translate) : (\'INACTIVE\'|translate)" class="checklabelText"></span></div><div data-ng-if="(((model.status + \'\').length == 0) || (model.status == null) || (model.status == 0)) && required.status && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatebot"></div></div></div><div class="col-sm-5 col-sm-offset-7 col-md-3 col-md-offset-9"><button ng-click="save()" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/check/download/download.view.html','<div><div id="accordeon1" class="accordeon"><div data-ng-repeat="c in downloads" class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-ng-class="{\'collapsed\': $index == 0}" data-toggle="collapse" data-parent="#accordion{{$index}}" href="#collapse{{$index}}"><span>{{c.name}} ({{c.ssc_download.length}})</span></div><div id="collapse{{$index}}" class="collapse download" data-ng-class="{\'in\': $index == 0}"><div class="margcreatetop"></div><div data-ng-repeat="d in c.ssc_download" class="row"><div class="col-xs-12"><a target="_blank" ng-href="{{d.file}}?ssc_id={{ssc_id}}"><i class="fa fa-file marg-right-small" aria-hidden="true"></i>{{d.title}}</a></div><div class="col-xs-12 settings" ng-show="d.settings.length > 0"><div class="row margcreatetop"><div class="col-xs-12 col-sm-3 col-lg-2" ng-repeat="s in d.settings"><span>{{s.description}}</span><div><input type="checkbox" ng-true-value="1" ng-false-value="0" id="schalter-{{d.id}}-{{s.id}}" ng-model="s.value" ng-change="updateSetting(d, s)" ng-disabled="d.is_disabled"> <label class="checklabel" for="schalter-{{d.id}}-{{s.id}}"></label> <span data-ng-bind="s.value === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div><hr></div></div><div class="margcreatetop"></div></div></div></div></div>');
$templateCache.put('templates/components/content/stromsparcheck/check/textmodul/textmodul.view.html','<div><h3>Textbausteine:</h3><select class="createdropper leftdropper" ng-options="d as d.name for d in data" ng-value="item" ng-model="subCategory"></select><select class="createdropper leftdropper" ng-options="ds as ds.name for ds in subCategory.child" ng-value="itemSub" ng-model="subSubCategory" data-ng-show="subCategory"></select><select class="createdropper leftdropper" ng-options="dss as dss.name for dss in subSubCategory.child" ng-value="itemSubSub" ng-model="subSubSubCategory" data-ng-show="subSubCategory.child"></select><ul data-ng-repeat="text in (subSubSubCategory.ssc_text_module?subSubSubCategory.ssc_text_module:subSubCategory.ssc_text_module)"><li data-ng-bind-html="text.text" data-ng-click="setText(text.text, id)" class="clicktext"></li></ul></div>');
$templateCache.put('templates/components/content/stromsparcheck/tile/legend/legend.view.html','<div class="legend"><h4 data-ng-bind="\'SSC_TILE_LEGEND_TITLE\' | translate"></h4><div><i class="icon fa fa-check" aria-hidden="true"></i> <span class="title" data-ng-bind="\'SSC_TILE_LEGEND_GREEN\' | translate"></span></div><div><i class="icon fa fa-pencil" aria-hidden="true"></i> <span class="title" data-ng-bind="\'SSC_TILE_LEGEND_YELLOW\' | translate"></span></div><div><i class="icon fa fa-exclamation-triangle" aria-hidden="true"></i> <span class="title" data-ng-bind="\'SSC_TILE_LEGEND_RED\' | translate"></span></div></div>');
$templateCache.put('templates/components/content/user/userCreate/roleLocationCreate/roleLocationCreate.view.html','<div class="container"><div ng-show="!hasAccess" style="text-align:center"><h4>Nicht gefunden</h4></div><div class="row" ng-show="hasAccess"><div class="col-sm-12"><h4>{{name}}</h4><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" ng-repeat="errorAlertItem in errorAlert" data-ng-bind="errorAlertItem.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div><div class="col-sm-6 field"><div class="row margcreatetop" ng-show="!edit"><div data-ng-class="{\'input-required\': (((model.role_id + \'\').length == 0) || (model.role_id == null)) && required.role_id && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_ROLE\' | translate"></span> <span data-ng-if="required.role_id && !edit">*</span></div><div class="col-sm-7"><select data-ng-disabled="edit" data-ng-class="{\'input-required-border\': (((model.role_id + \'\').length == 0) || (model.role_id == null)) && required.role_id && saved}" class="createdropper rightdropper" ng-model="model.role_id" data-ng-change="clearAdress(); updateRequired();"><option ng-repeat="item in dropRole" ng-value="item.id" data-ng-bind="item.dropName"></option></select></div><div data-ng-if="(((model.role_id + \'\').length == 0) || (model.role_id == null)) && required.role_id && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatetop" ng-show="edit"><div class="col-sm-4 ilabel"><span data-ng-bind="\'USER_ROLE\' | translate"></span></div><div class="col-sm-7"><div ng-repeat="item in dropRole" data-ng-bind="item.dropName" ng-if="item.id == model.role_id" class="fieldContent"></div></div></div><div ng-show="(model.role_id == 6 || model.role_id == 5 || model.role_id == 4 || model.role_id == 9) && !edit" class="row"><div data-ng-class="{\'input-required\': (((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_LOCATION\' | translate"></span> <span data-ng-if="required.role_id">*</span></div><div class="col-sm-7"><select data-ng-change="setLocationAdress()" data-ng-class="{\'input-required-border\': (((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved}" class="createdropper rightdropper" ng-model="model.location"><option ng-repeat="item in dropLocation" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div data-ng-if="(((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" ng-show="(model.role_id == 6 || model.role_id == 5 || model.role_id == 4 || model.role_id == 9) && edit"><div class="col-sm-4 ilabel"><span data-ng-bind="\'USER_LOCATION\' | translate"></span></div><div class="col-sm-7"><div ng-repeat="item in dropLocation" data-ng-bind="item.name" ng-if="item.id == model.location" class="fieldContent"></div></div></div><div ng-show="model.role_id == 3" class="row"><div data-ng-class="{\'input-required\': (((model.organisation + \'\').length == 0) || (model.organisation == null)) && required.organisation && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_ORGANISATION\' | translate"></span> <span data-ng-if="required.organisation">*</span></div><div class="col-sm-7"><select data-ng-class="{\'input-required-border\': (((model.organisation + \'\').length == 0) || (model.organisation == null)) && required.organisation && saved}" class="createdropper rightdropper" ng-model="model.organisation"><option ng-repeat="item in dropOrganisation" ng-value="item.id" ng-if="(item.status==1 || model.organisation==item.id)" data-ng-bind="item.name"></option></select></div><div data-ng-if="(((model.organisation + \'\').length == 0) || (model.organisation == null)) && required.organisation && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div ng-show="showStates()" class="row"><div data-ng-class="{\'input-required\': (((model.states + \'\').length == 0) || (model.states == null)) && required.states && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_STATES\' | translate"></span> <span data-ng-if="required.states">*</span></div><div class="col-sm-7"><div ng-repeat="item in states.locked" data-ng-bind="item.name" class="fieldContent"></div><ui-select data-ng-model="states.dropSelected" data-ng-class="{\'input-required-border\': (((model.states + \'\').length == 0) || (model.states == null)) && required.states && saved}" class="ssc-ui-select" multiple="" theme="selectize" sortable="true"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropState | filter:$select.search"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div data-ng-if="(((model.states + \'\').length == 0) || (model.states == null)) && required.states && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_STREET\' | translate"></span> <span data-ng-if="required.street">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved}" class="createinputter" ng-model="model.street"></div><div data-ng-if="(((model.street + \'\').length == 0) || (model.street == null)) && required.street && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.postalcode + \'\').length == 0) || (model.postalcode == null)) && required.postalcode && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_PLZ\' | translate"></span> <span data-ng-if="required.postalcode">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.postalcode + \'\').length == 0) || (model.postalcode == null)) && required.postalcode && saved}" class="createinputter" ng-model="model.postalcode"></div><div data-ng-if="(((model.postalcode + \'\').length == 0) || (model.postalcode == null)) && required.postalcode && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_PLACE\' | translate"></span> <span data-ng-if="required.city">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved}" class="createinputter" ng-model="model.city"></div><div data-ng-if="(((model.city + \'\').length == 0) || (model.city == null)) && required.city && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_PHONE\' | translate"></span> <span data-ng-if="required.telephone">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved}" class="createinputter" ng-model="model.telephone"></div><div data-ng-if="(((model.telephone + \'\').length == 0) || (model.telephone == null)) && required.telephone && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" data-ng-class="{\'margcreatebot\': model.role_id != 6 && model.role_id != 9}"><div data-ng-class="{\'input-required\': (((model.mobilephone + \'\').length == 0) || (model.mobilephone == null)) && required.mobilephone && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_MOBILEPHONE\' | translate"></span> <span data-ng-if="required.mobilephone">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.mobilephone + \'\').length == 0) || (model.mobilephone == null)) && required.mobilephone && saved}" class="createinputter" ng-model="model.mobilephone"></div><div data-ng-if="(((model.mobilephone + \'\').length == 0) || (model.mobilephone == null)) && required.mobilephone && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div data-ng-if="model.role_id == 6 || model.role_id == 9"><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_NOTICE\' | translate"></span> <span data-ng-if="required.comment">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved}" class="createinputter" ng-model="model.comment"></div><div data-ng-if="(((model.comment + \'\').length == 0) || (model.comment == null)) && required.comment && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div></div><div class="col-sm-3 col-sm-offset-9"><button ng-click="save()" class="redbutton" id="rolecity" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/review/overview/directhelpReview/bericht/bericht.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label ng-bind="areaTitle" class="ssc-filterlabel"></label><ssc-tree-select ssc-tree-select-model="areaTreeArr" ssc-tree-select-bund="bund"></ssc-tree-select></div><div class="col-sm-5 col-sm-offset-1"><div><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div><div><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div></div>');
$templateCache.put('templates/components/content/review/overview/directhelpReview/givenDirecthelps/givenDirecthelps.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label ng-bind="areaTitle" class="ssc-filterlabel"></label><ssc-tree-select ssc-tree-select-model="areaTreeArr" ssc-tree-select-bund="bund"></ssc-tree-select></div><div class="col-sm-5 col-sm-offset-1"><div><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div><div><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div></div>');
$templateCache.put('templates/components/content/review/overview/directhelpReview/kleinerstandortvergleich/kleinerstandortvergleich.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label for="places" ng-bind="\'SEARCH_LOCATION\' | translate" class="ssc-filterlabel"></label><ui-select id="places" class="ssc-ui-select" on-select="OnClickSelect($item)" on-remove="OnRemoveSelect($item)" multiple="" data-ng-class="{\'input-required-border\': (((model.location + \'\').length == 0) || (model.location == null)) && required.states && saved}" data-ng-model="model.location" theme="selectize" sortable="true" ng-disabled="region_id === null"><ui-select-match placeholder="{{\'SEARCH_SINGLESELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices group-by="groupByRegion" repeat="item in dropdown.dropdownLocation | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div></div><div class="row"><div class="col-sm-5 col-sm-offset-6"><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div>');
$templateCache.put('templates/components/content/review/overview/othersReview/freitagsauswertung/freitagsauswertung.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div><div class="col-sm-5 col-sm-offset-1"><label for="to" ng-bind="\'SEARCH_TO\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div>');
$templateCache.put('templates/components/content/review/overview/locationReview/akquiseliste/akquiseliste.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label ng-bind="areaTitle" class="ssc-filterlabel"></label><ssc-tree-select ssc-tree-select-model="areaTreeArr" ssc-tree-select-bund="bund"></ssc-tree-select></div><div class="col-sm-5 col-sm-offset-1"><div class="margcreatetop visible-xs"></div><label for="filter" ng-bind="\'SEARCH_AKQUISE\' | translate" class="ssc-filterlabel"></label> <a ng-click="selectAll()"><label class="floatright ssc-filterlabel" for="filter" data-ng-bind="model.akquise.length != dropdownAkquise.length ? (\'SEARCH_ALL\' | translate) : (\'SEARCH_NOTHING\' | translate)"></label></a><ui-select class="ssc-ui-select" on-select="OnClickSelectAkquise($item)" on-remove="OnRemoveSelectAkquise($item)" multiple="" data-ng-class="{\'input-required-border\': (((model.akquise + \'\').length == 0) || (model.akquise == null)) && required.akquise && saved}" data-ng-model="model.akquise" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdownAkquise | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select><div class="margcreatetop"></div><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"><div class="margcreatetop"></div><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"><div class="margcreatetop"></div></div></div></div>');
$templateCache.put('templates/components/content/review/overview/locationReview/abgeschlossenehh/abgeschlossenehh.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label ng-bind="areaTitle" class="ssc-filterlabel"></label><ssc-tree-select ssc-tree-select-model="areaTreeArr" ssc-tree-select-bund="bund" disable-bund="treeSelectDisableBund()"></ssc-tree-select></div><div class="col-sm-5 col-sm-offset-1"><div><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label><help-pop-over help="TIP_REVIEW_CLOSED_HH_TIME"></help-pop-over><label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div><div><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div></div>');
$templateCache.put('templates/components/content/review/overview/locationReview/auswertungsberichtssc/auswertungsberichtssc.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><div><label ng-bind="areaTitle" class="ssc-filterlabel"></label><ssc-tree-select ssc-tree-select-model="areaTreeArr" ssc-tree-select-bund="bund"></ssc-tree-select></div><div><label for="filter" ng-bind="\'SEARCH_PLZ\' | translate" class="ssc-filterlabel"></label><ui-select class="ssc-ui-select" on-select="OnClickSelectPLZ($item)" on-remove="OnRemoveSelectPLZ($item)" multiple="" data-ng-class="{\'input-required-border\': (((model.plz + \'\').length == 0) || (model.plz == null)) && required.plz && saved}" data-ng-model="model.plz" theme="selectize" ng-click="refreshPlzDropdown()" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\'| translate}}">{{$item.name}}</ui-select-match><ui-select-choices group-filter="groupFilterPLZ" group-by="groupByPlzNumberOne" repeat="item in dropdownPLZ | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div><label for="extralocation" ng-bind="\'SEARCH_EXTRALOCATION\' | translate" class="ssc-filterlabel"></label> <input id="extralocation" class="createinputter" type="text" ng-model="extralocation"></div><div class="row"><label for="name" ng-bind="\'SEARCH_NAMEPLZ\' | translate" class="ssc-filterlabel"></label><div class="col-sm-7"><input id="name" class="createinputter" type="text" placeholder="{{\'SEARCH_PNAME\'| translate}}" ng-model="plzArea.name" ng-disabled="plzArea.zip.length < 2"></div><div class="col-sm-4 col-sm-offset-1"><button ng-click="savePLZ()" class="redbutton nomargin" id="roleplace" type="submit" ng-disabled="plzArea.zip.length < 2 || plzArea.name === null"><span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div><div class="row"><label ng-bind="\'SEARCH_PLZAREA\' | translate" class="ssc-filterlabel"></label><div class="col-sm-7"><ui-select class="ssc-ui-select" on-select="OnClickSelectPLZArea($item)" on-remove="OnRemoveSelectPLZArea($item)" multiple="" data-ng-class="{\'input-required-border\': (((model.plzarea + \'\').length == 0) || (model.plzarea == null)) && required.plzarea && saved}" data-ng-model="model.plzarea" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\'| translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdownPLZArea | filter:{name : $select.search}"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-4 col-sm-offset-1"><button ng-click="deletePLZArea()" class="redbutton nomargin" type="submit" ng-disabled="plzArea_id.length === 0"><span data-ng-bind="\'BTN_DELETE\' | translate"></span></button></div></div></div><div class="col-sm-5 col-sm-offset-1"><div><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from_d" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from_d" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to_d"></div><div><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="to_d" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to_d" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from_d"></div><div><label for="places" ng-bind="\'SEARCH_SHOWERTIME\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((showertime_id + \'\').length == 0) || (showertime_id == null)) && required && saved}" class="createdropper" ng-model="showertime_id" id="places"><option ng-repeat="item in showertime" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div><label for="consultation-type" ng-bind="\'SEARCH_CONSULTATION_TYPE\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((consultation_type + \'\').length == 0) || (consultation_type == null)) && required && saved}" class="createdropper" ng-model="consultation_type" id="consultation-type"><option ng-repeat="item in consultation_types" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div><label for="ssc_type" ng-bind="\'SEARCH_SSC_TYPE\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((ssc_type + \'\').length == 0) || (ssc_type == null)) && required && saved}" class="createdropper" ng-model="ssc_type" id="ssc_type"><option ng-repeat="item in ssc_types" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div></div></div>');
$templateCache.put('templates/components/content/review/overview/locationReview/auswertungssh/auswertungssh.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label for="places" ng-bind="\'SEARCH_LOCATION\' | translate" class="ssc-filterlabel"></label><ui-select class="ssc-ui-select" on-select="OnClickSelect($item)" on-remove="OnRemoveSelect($item)" multiple="" data-ng-class="{\'input-required-border\': (((model.location + \'\').length == 0) || (model.location == null)) && required.states && saved}" data-ng-model="model.location" theme="selectize" sortable="true" ng-disabled="region_id === null"><ui-select-match placeholder="{{\'SEARCH_SINGLESELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices group-by="groupByRegion" repeat="item in dropdown.dropdownLocation | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div></div><div class="row"><div class="col-sm-5 col-sm-offset-6"><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div></div>');
$templateCache.put('templates/components/content/review/overview/locationReview/beschaeftigungsfoerderung/beschaeftigungsfoerderung.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label ng-bind="areaTitle" class="ssc-filterlabel"></label><ssc-tree-select ssc-tree-select-model="areaTreeArr" ssc-tree-select-bund="bund"></ssc-tree-select></div><div class="col-sm-5 col-sm-offset-1"><div><label for="filter" ng-bind="\'SEARCH_EMPLOYMENT\' | translate" class="ssc-filterlabel"></label> <a ng-click="selectAll()"><label class="floatright ssc-filterlabel" for="filter" data-ng-bind="model.employment.length != dropdownEmployment.length ? (\'SEARCH_ALL\' | translate) : (\'SEARCH_NOTHING\' | translate)"></label></a><ui-select class="ssc-ui-select" on-select="OnClickSelectEmployment($item)" on-remove="OnRemoveSelectEmployment($item)" multiple="" data-ng-class="{\'input-required-border\': (((model.employment + \'\').length == 0) || (model.employment == null)) && required.employment && saved}" data-ng-model="model.employment" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdownEmployment | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div><label for="time" ng-bind="\'SEARCH_DAY\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY"></div></div></div></div>');
$templateCache.put('templates/components/content/review/overview/locationReview/evalmonitoring/evalmonitoring.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label ng-bind="areaTitle" class="ssc-filterlabel"></label><ssc-tree-select ssc-tree-select-model="areaTreeArr"></ssc-tree-select><div ng-if="isDev"><div class="margcreatetop"></div>Entwickleroptionen<div style="border: 1px solid black; padding: 10px;"><label ng-bind="\'Check Ids\' | translate" class="ssc-filterlabel"></label> <input class="createinputter" ng-model="devVars.checkIds" placeholder="z.B. 213,123,51235"><div class="margcreatetop"></div><label for="evalmonitoring-dev-check" ng-bind="\'Entwicklerdarstellung\' | translate" class="ssc-filterlabel" style="float: left"></label> <input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="devVars.isDebug" id="evalmonitoring-dev-check"> <label class="checklabel" for="evalmonitoring-dev-check"></label> <span data-ng-bind="devVars.isDebug ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span><div style="clear:both"></div></div></div></div><div class="col-sm-5 col-sm-offset-1"><div class="margcreatetop visible-xs"></div><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"><div class="margcreatetop"></div><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"><div class="margcreatetop"></div><label for="places" ng-bind="\'SEARCH_SHOWERTIME\' | translate" class="ssc-filterlabel"></label><select disabled="" data-ng-class="{\'input-required-border\': (((showertime_id + \'\').length == 0) || (showertime_id == null)) && required && saved}" class="createdropper" ng-model="showertime_id" id="places"><option ng-repeat="item in showertime" ng-value="item.id" data-ng-bind="item.name"></option></select><br><div class="nlabel ssc-form-hint">Aktuell nur Angaben des Haushalts verf\xFCgbar.</div></div></div></div>');
$templateCache.put('templates/components/content/review/overview/locationReview/quatieransatz/quatieransatz.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_QUARTER\' | translate" class="ssc-filterlabel"></label><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'quarter\', $item)" on-remove="OnRemoveSelect(\'quarter\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved}" data-ng-model="model.location" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\'| translate}}">{{$item.name}}</ui-select-match><ui-select-choices group-by="groupByRegion" repeat="item in dropdown.dropdownQuarter | filter: {name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div><div ng-show="checkShowPlz"><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_PLZ\' | translate" class="ssc-filterlabel"></label><ui-select class="ssc-ui-select" on-select="OnClickSelectPLZ($item)" on-remove="OnRemoveSelectPLZ($item)" multiple="" data-ng-class="{\'input-required-border\': (((model.plz + \'\').length == 0) || (model.plz == null)) && required.plz && saved}" data-ng-model="model.plz" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\'| translate}}">{{$item.name}}</ui-select-match><ui-select-choices group-filter="groupFilterPLZ" group-by="groupByPlzNumberOne" repeat="item in dropdownPLZ | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="places" ng-bind="\'SEARCH_SHOWERTIME\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((showertime_id + \'\').length == 0) || (showertime_id == null)) && required && saved}" class="createdropper" ng-model="showertime_id" id="places"><option ng-repeat="item in showertime" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div><div class="row"><div class="col-sm-5"><label for="extralocation" ng-bind="\'SEARCH_EXTRALOCATION\' | translate" class="ssc-filterlabel"></label> <input id="extralocation" class="createinputter" type="text" ng-model="extralocation"></div><div class="col-sm-5 col-sm-offset-1"><label for="to" ng-bind="\'SEARCH_ADDINFORMATION\' | translate" class="ssc-filterlabel"></label> <input data-ng-class="{\'input-required-border\': (((add + \'\').length == 0) || (add == null) || (add == 0)) && required.add && saved}" type="checkbox" ng-model="add" ng-true-value="1" ng-false-value="0" id="checkboxRegionStatus" ng-checked="add == 1"> <label class="searchchecklable" for="checkboxRegionStatus"></label> <span data-ng-bind="add == 1 ? (\'SEARCH_YES\' | translate) : (\'SEARCH_NO\' | translate)" class="searchchecklableText"></span></div></div><div class="row"><div class="col-sm-5"><label for="plz" ng-bind="\'SEARCH_NAMEPLZ\' | translate" class="ssc-filterlabel"></label></div></div><div class="row"><div class="col-sm-3"><input id="name" class="createinputter" type="text" placeholder="{{\'SEARCH_PNAME\'| translate}}" ng-model="plzArea.name" ng-disabled="plzArea.zip.length < 2"></div><div class="col-sm-2"><button ng-click="savePLZ()" class="redbutton nomargin" id="roleplace" type="submit" ng-disabled="plzArea.zip.length < 2 || plzArea.name === null"><span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_PLZAREA\' | translate" class="ssc-filterlabel"></label></div></div><div class="row"><div class="col-sm-3"><ui-select class="ssc-ui-select" on-select="OnClickSelectPLZArea($item)" on-remove="OnRemoveSelectPLZArea($item)" multiple="" data-ng-class="{\'input-required-border\': (((model.plzarea + \'\').length == 0) || (model.plzarea == null)) && required.plzarea && saved}" data-ng-model="model.plzarea" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\'| translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdownPLZArea | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-2"><button ng-click="deletePLZArea()" class="redbutton nomargin" id="roleplace" type="submit" ng-disabled="plzArea_id.length === 0"><span data-ng-bind="\'BTN_DELETE\' | translate"></span></button></div></div></div><div ng-if="!checkShowPlz"><div class="row"><div class="col-sm-5"><label for="extralocation" ng-bind="\'SEARCH_EXTRALOCATION\' | translate" class="ssc-filterlabel"></label> <input id="extralocation" class="createinputter" type="text" ng-model="extralocation"></div><div class="col-sm-5 col-sm-offset-1"><label for="places" ng-bind="\'SEARCH_SHOWERTIME\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((showertime_id + \'\').length == 0) || (showertime_id == null)) && required && saved}" class="createdropper" ng-model="showertime_id" id="places"><option ng-repeat="item in showertime" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div><div class="row"><div class="col-sm-5 col-sm-offset-6"><label for="to" ng-bind="\'SEARCH_ADDINFORMATION\' | translate" class="ssc-filterlabel"></label> <input data-ng-class="{\'input-required-border\': (((add + \'\').length == 0) || (add == null) || (add == 0)) && required.add && saved}" type="checkbox" ng-model="add" ng-true-value="1" ng-false-value="0" id="checkboxRegionStatus" ng-checked="add == 1"> <label class="searchchecklable" for="checkboxRegionStatus"></label> <span data-ng-bind="add == 1 ? (\'SEARCH_YES\' | translate) : (\'SEARCH_NO\' | translate)" class="searchchecklableText"></span></div></div></div></div>');
$templateCache.put('templates/components/content/review/overview/controllingReview/controllingenergy/controllingenergy.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_REGION\' | translate" class="ssc-filterlabel"></label> <a ng-click="selectAllLocation()"><label class="floatright ssc-filterlabel" for="filter" data-ng-bind="model.location.length != dropdown.dropdownLocation.length ? (\'SEARCH_ALL\' | translate) : (\'SEARCH_NOTHING\' | translate)"></label></a><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'region\', $item)" on-remove="OnRemoveSelect(\'region\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.region + \'\').length == 0) || (model.region == null)) && required.region && saved}" data-ng-model="model.region" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdown.dropdownRegion | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div></div><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_STATE\' | translate" class="ssc-filterlabel"></label><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'state\', $item)" on-remove="OnRemoveSelect(\'state\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.state + \'\').length == 0) || (model.state == null)) && required.state && saved}" data-ng-model="model.state" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdown.dropdownState | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_LOCATION\' | translate" class="ssc-filterlabel"></label><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'location\', $item)" on-remove="OnRemoveSelect(\'location\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved}" data-ng-model="model.location" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices group-by="groupByRegion" repeat="item in dropdown.dropdownLocation | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div></div></div>');
$templateCache.put('templates/components/content/review/overview/controllingReview/controllingmonitoring/controllingmonitoring.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_REGION\' | translate" class="ssc-filterlabel"></label> <a ng-click="selectAllLocation()"><label class="floatright ssc-filterlabel" for="filter" data-ng-bind="model.location.length != dropdown.dropdownLocation.length ? (\'SEARCH_ALL\' | translate) : (\'SEARCH_NOTHING\' | translate)"></label></a><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'region\', $item)" on-remove="OnRemoveSelect(\'region\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.region + \'\').length == 0) || (model.region == null)) && required.region && saved}" data-ng-model="model.region" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdown.dropdownRegion | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="time" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div></div><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_STATE\' | translate" class="ssc-filterlabel"></label><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'state\', $item)" on-remove="OnRemoveSelect(\'state\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.state + \'\').length == 0) || (model.state == null)) && required.state && saved}" data-ng-model="model.state" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdown.dropdownState | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_LOCATION\' | translate" class="ssc-filterlabel"></label><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'location\', $item)" on-remove="OnRemoveSelect(\'location\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved}" data-ng-model="model.location" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices group-by="groupByRegion" repeat="item in dropdown.dropdownLocation | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div></div></div>');
$templateCache.put('templates/components/content/review/overview/controllingReview/controllingreport/controllingreport.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label for="filter-region" ng-bind="\'SEARCH_REGION\' | translate" class="ssc-filterlabel"></label> <a ng-click="selectAllLocation()"><label class="floatright ssc-filterlabel" data-ng-bind="model.location.length != dropdown.dropdownLocation.length ? (\'SEARCH_ALL\' | translate) : (\'SEARCH_NOTHING\' | translate)"></label></a><ui-select input-id="filter-region" class="ssc-ui-select" on-select="OnClickSelect(\'region\', $item)" on-remove="OnRemoveSelect(\'region\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.region + \'\').length == 0) || (model.region == null)) && required.region && saved}" data-ng-model="model.region" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdown.dropdownRegion | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="filter-time-from" ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="filter-time-from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input id="filter-time-from" class="createinputter" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY"></div></div><div class="row"><div class="col-sm-5"><label for="filter-state" ng-bind="\'SEARCH_STATE\' | translate" class="ssc-filterlabel"></label><ui-select input-id="filter-state" class="ssc-ui-select" on-select="OnClickSelect(\'state\', $item)" on-remove="OnRemoveSelect(\'state\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.state + \'\').length == 0) || (model.state == null)) && required.state && saved}" data-ng-model="model.state" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdown.dropdownState | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="filter-time-to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="filter-time-to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY"></div></div><div class="row"><div class="col-sm-5"><label for="filter-location" ng-bind="\'SEARCH_LOCATION\' | translate" class="ssc-filterlabel"></label><ui-select input-id="filter-location" class="ssc-ui-select" on-select="OnClickSelect(\'location\', $item)" on-remove="OnRemoveSelect(\'location\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved}" data-ng-model="model.location" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices group-by="groupByRegion" repeat="item in dropdown.dropdownLocation | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-sm-5"><label for="filter-tabs" ng-bind="\'REVIEW_TABS\' | translate" class="ssc-filterlabel"></label><ui-select input-id="filter-tabs" class="ssc-ui-select" ng-model="export_tabs.selected" multiple="" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in export_tabs.options | filter:{name : $select.search} track by item.id"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="export-type" class="ssc-filterlabel" ng-bind="\'REVIEW_EXPORT_TYPE\' | translate"></label><select class="createinputter" id="export-type" ng-model="export_type"><option value="excel-archive">{{\'REVIEW_EXPORT_EXCEL_ARCHIVE\' | translate}}</option><option value="excel-tabs">{{\'REVIEW_EXPORT_EXCEL_TABS\' | translate}}</option><option value="csv-archive">{{\'REVIEW_EXPORT_CSV_ARCHIVE\' | translate}}</option></select></div></div></div>');
$templateCache.put('templates/components/content/review/overview/controllingReview/monitoringeinsparungen/monitoringeinsparungen.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label ng-bind="areaTitle" class="ssc-filterlabel"></label><ssc-tree-select ssc-tree-select-model="areaTreeArr"></ssc-tree-select></div><div class="col-sm-5 col-sm-offset-1"><div class="margcreatetop visible-xs"></div><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"><div class="margcreatetop"></div><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"><div class="margcreatetop"></div></div></div></div>');
$templateCache.put('templates/components/content/review/overview/controllingReview/zielerreichnungmonitoring/zielerreichnungmonitoring.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_REGION\' | translate" class="ssc-filterlabel"></label> <a ng-click="selectAllLocation()"><label class="floatright ssc-filterlabel" for="filter" data-ng-bind="model.location.length != dropdown.dropdownLocation.length ? (\'SEARCH_ALL\' | translate) : (\'SEARCH_NOTHING\' | translate)"></label></a><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'region\', $item)" on-remove="OnRemoveSelect(\'region\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.region + \'\').length == 0) || (model.region == null)) && required.region && saved}" data-ng-model="model.region" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdown.dropdownRegion | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="time" ng-bind="\'SEARCH_TIMEMONITORING\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div></div><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_STATE\' | translate" class="ssc-filterlabel"></label><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'state\', $item)" on-remove="OnRemoveSelect(\'state\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.state + \'\').length == 0) || (model.state == null)) && required.state && saved}" data-ng-model="model.state" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdown.dropdownState | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_LOCATION\' | translate" class="ssc-filterlabel"></label><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'location\', $item)" on-remove="OnRemoveSelect(\'location\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved}" data-ng-model="model.location" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices group-by="groupByRegion" repeat="item in dropdown.dropdownLocation | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label ng-bind="\'SEARCH_TIMECHECKS\' | translate" class="ssc-filterlabel"></label> <label for="fromtwo" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="fromtwo" ssc-datepicker="" data-ng-model="fromtwo" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="totwo"></div></div><div class="row"><div class="col-sm-5 col-sm-offset-6"><label for="totwo" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="totwo" ssc-datepicker="" data-ng-model="totwo" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="fromtwo"></div></div></div>');
$templateCache.put('templates/components/content/user/userCreate/employmenttypCreate/userEmplyomenttypCreate/userEmplyomenttypCreate.view.html','<div class="container"><div ng-show="isNotFound" style="text-align:center"><h4>Nicht gefunden</h4></div><div class="row" ng-show="!isNotFound"><div class="col-sm-12"><h4>{{actionTitle}}</h4><div class="subheading" ng-if="subheading" ng-bind="subheading"></div><div class="col-sm-8 col-md-6 field"><div class="row margcreatetop"><div data-ng-class="{\'input-required\': (((model.user_employment_type_id + \'\').length == 0) || (model.user_employment_type_id == null)) && required.user_employment_type_id && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_EMPLOYMENTMODE\' | translate"></span> <span data-ng-if="required.user_employment_type_id">*</span></div><div class="col-sm-7"><select data-ng-class="{\'input-required-border\': (((model.user_employment_type_id + \'\').length == 0) || (model.user_employment_type_id == null)) && required.user_employment_type_id && saved}" class="createdropper rightdropper" ng-model="model.user_employment_type_id"><option ng-repeat="item in employmentTypeList" ng-value="item.id" ng-disabled="item.status==0" data-ng-bind="item.name"></option></select></div><div data-ng-if="(((model.user_employment_type_id + \'\').length == 0) || (model.user_employment_type_id == null)) && required.user_employment_type_id && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div data-ng-class="{\'input-required\': (((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_DATESTART\' | translate"></span> <span data-ng-if="required.date_begin">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved}" class="createinputter" id="startdate" ssc-datepicker="" data-ng-model="model.date_begin" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="enddate"></div><div data-ng-if="(((model.date_begin + \'\').length == 0) || (model.date_begin == null)) && required.date_begin && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div data-ng-class="{\'input-required\': (((model.date_end + \'\').length == 0) || (model.date_end == null)) && required.date_end && saved}" class="col-sm-4 ilabel"><span data-ng-bind="\'USER_DATESTOP\' | translate"></span> <span data-ng-if="required.date_end">*</span></div><div class="col-sm-7"><input data-ng-class="{\'input-required-border\': (((model.date_end + \'\').length == 0) || (model.date_end == null)) && required.date_end && saved}" class="createinputter" id="enddate" ssc-datepicker="" data-ng-model="model.date_end" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="startdate"></div><div data-ng-if="(((model.date_end + \'\').length == 0) || (model.date_end == null)) && required.date_end && saved" class="col-sm-1"><div class="static-exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="col-sm-5 col-sm-offset-7 col-md-3 col-md-offset-9"><button ng-click="save()" class="redbutton" id="roleplace" type="submit"><i ng-if="isSaving" class="fa fa-circle-o-notch loader fa-spin fa-fw"></i> <span data-ng-bind="\'BTN_SAVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/components/content/review/overview/locationReview/standortberichtmonitoring/standortberichtmonitoring.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_REGION\' | translate"></label> <a ng-click="selectAllLocation()"><label class="floatright" for="filter" data-ng-bind="model.location.length != dropdown.dropdownLocation.length ? (\'SEARCH_ALL\' | translate) : (\'SEARCH_NOTHING\' | translate)"></label></a><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'region\', $item)" on-remove="OnRemoveSelect(\'region\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.region + \'\').length == 0) || (model.region == null)) && required.region && saved}" data-ng-model="model.region" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdown.dropdownRegion | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="time" ng-bind="\'SEARCH_TIME\' | translate"></label> <label for="from" class="floatright" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div></div><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_STATE\' | translate"></label><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'state\', $item)" on-remove="OnRemoveSelect(\'state\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.state + \'\').length == 0) || (model.state == null)) && required.state && saved}" data-ng-model="model.state" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in dropdown.dropdownState | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="to" class="floatright" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div></div><div class="row"><div class="col-sm-5"><label for="filter" ng-bind="\'SEARCH_LOCATION\' | translate"></label><ui-select class="ssc-ui-select" on-select="OnClickSelect(\'location\', $item)" on-remove="OnRemoveSelect(\'location\',$item)" multiple="" data-ng-class="{\'input-required-border\': (((model.location + \'\').length == 0) || (model.location == null)) && required.location && saved}" data-ng-model="model.location" theme="selectize" sortable="true"><ui-select-match placeholder="{{\'SEARCH_MULTISELECT\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices group-by="groupByRegion" repeat="item in dropdown.dropdownLocation | filter:{name : $select.search} | orderBy:\'name\'"><div data-ng-bind-html="item.name"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-sm-offset-1"><label for="places" ng-bind="\'SEARCH_SHOWERTIME\' | translate"></label><select data-ng-class="{\'input-required-border\': (((showertime_id + \'\').length == 0) || (showertime_id == null)) && required && saved}" class="createdropper" ng-model="showertime_id" id="places"><option ng-repeat="item in showertime" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div></div>');
$templateCache.put('templates/components/content/review/overview/locationReview/standortvergleich/standortvergleich.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label ng-bind="areaTitle" class="ssc-filterlabel"></label><ssc-tree-select ssc-tree-select-model="areaTreeArr" ssc-tree-select-bund="bund"></ssc-tree-select></div><div class="col-sm-5 col-sm-offset-1"><div><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"></div><div><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"></div><div><label for="showertime" ng-bind="\'SEARCH_SHOWERTIME\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((showertime_id + \'\').length == 0) || (showertime_id == null)) && required && saved}" class="createdropper" ng-model="showertime_id" id="showertime"><option ng-repeat="item in showertime" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div><label for="consultation-type" ng-bind="\'SEARCH_CONSULTATION_TYPE\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((consultation_type + \'\').length == 0) || (consultation_type == null)) && required && saved}" class="createdropper" ng-model="consultation_type" id="consultation-type"><option ng-repeat="item in consultation_types" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div><label for="extra-filter" ng-bind="\'SEARCH_EXTRA_FILTER\' | translate" class="ssc-filterlabel"></label><select data-ng-class="{\'input-required-border\': (((extra_filter + \'\').length == 0) || (extra_filter == null)) && required && saved}" class="createdropper" ng-model="extra_filter" id="extra-filter"><option></option><option ng-repeat="item in extra_filters" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div></div></div>');
$templateCache.put('templates/components/content/review/overview/locationReview/statuschecks/statuschecks.view.html','<div><h5 ng-bind="\'SEARCH_MORE\' | translate"></h5><div class="row"><div class="col-sm-5"><label ng-bind="areaTitle" class="ssc-filterlabel"></label><ssc-tree-select ssc-tree-select-model="areaTreeArr"></ssc-tree-select></div><div class="col-sm-5 col-sm-offset-1"><div class="margcreatetop visible-xs"></div><label ng-bind="\'SEARCH_TIME\' | translate" class="ssc-filterlabel"></label> <label for="from" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_FROM\' | translate"></label> <input class="createinputter" id="from" ssc-datepicker="" data-ng-model="from" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="to"><div class="margcreatetop"></div><label for="to" class="floatright ssc-filterlabel" ng-bind="\'SEARCH_TO\' | translate"></label> <input class="createinputter" id="to" ssc-datepicker="" data-ng-model="to" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="from"><div class="margcreatetop"></div></div></div></div>');
$templateCache.put('templates/layouts/100-100.html','<div ui-view="header"></div><div id="content"><div ui-view="menu"></div><div class="container"><a class="redbutton breadback" href="javascript:history.back()" rel="noreferrer"><i class="fa fa-arrow-left marg-right-small" aria-hidden="true"></i>{{\'BTN_BACK\' | translate}}</a><div><div ui-view="breadcrumb"></div></div></div><div ui-view="full"></div></div><div ui-view="footer"></div>');
$templateCache.put('templates/layouts/100.html','<div ui-view="header"></div><div id="content"><div ui-view="full"></div></div><div ui-view="footer"></div>');
$templateCache.put('templates/layouts/80-20.html','<div class="container"><div class="row"><div class="col-md-10"><div ui-view="tile"></div><div ui-view="left"></div><div ui-view="comment"></div></div><div class="col-md-2"><div ui-view="right"></div></div></div></div>');
$templateCache.put('templates/partials/footer.html','<div id="footeroffset"></div><footer data-ng-controller="footerController" id="sscFooter" class="footer"><div class="container"><div class="row"><div class="col-sm-4 col-xs-4"><div ng-show="authenticated"><a href="" ui-sref="home"><img src="resources/img/logo_ssc.svg" class="logo"></a></div><div ng-if="authenticated == false"><img src="resources/img/logo_ssc.svg" class="logo"></div></div><div class="col-sm-8 hidden-xs text-right"><img src="resources/img/ssc_footer_right.svg" class="logo_small"></div></div></div></footer>');
$templateCache.put('templates/partials/header.html','<header><nav class="header-first"><div class="container"><profilmenu></profilmenu></div></nav><div class="clearfix"></div></header>');
$templateCache.put('templates/landingpage/activate.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'BTN_ACTIVATE\' | translate"></span></h2><p data-ng-bind="\'LANDINGPAGE_ACTIVATE_TEXT\' | translate"></p></div><div class="row mw-padded-top-sm"><div class="col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton disableduringload" data-ng-bind="\'BTN_CANCEL\' | translate"></button></div><div class="col-sm-3 col-md-2"><button tabindex="-1" type="button" data-ng-click="activate(ngDialogData.id)" class="redbutton disableduringload"><span data-ng-bind="\'BTN_ACTIVATE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/landingpage/anonymize.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'LANDINGPAGE_ANONYMIZE_TITLE\' | translate"></span></h2></div><div class="row mw-padded-top-sm"><div class="col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton ng-binding" data-ng-bind="\'BTN_CANCEL\' | translate"></button></div><div class="col-sm-3 col-md-2"><button tabindex="-1" type="button" data-ng-click="anonymize()" class="redbutton ng-binding"><span data-ng-bind="\'LANDINGPAGE_ANONYMIZE_TITLE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/landingpage/canceled_evaluation.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'SSC_HH_EVALUATION_TITLE\' | translate"></span></h2></div><div class="row mw-padded-top-sm"><div class="col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton ng-binding" data-ng-bind="\'BTN_CANCEL\' | translate"></button></div><div class="col-sm-3 col-md-2"><button tabindex="-1" type="button" data-ng-click="canceledEvaluation()" class="redbutton ng-binding"><span data-ng-bind="\'LANDINGPAGE_SEND_REQUEST\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/landingpage/canceled_evaluation_error.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'SSC_HH_EVALUATION_TITLE\' | translate"></span></h2><p data-ng-bind="\'LANDINGPAGE_SEND_REQUEST_FAILURE_TEXT\' | translate"></p></div><div class="row mw-padded-top-sm"><div class="col-sm-offset-4 col-sm-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton ng-binding" data-ng-bind="\'BTN_CANCEL\' | translate"></button></div></div></div>');
$templateCache.put('templates/landingpage/check_delete.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div ng-if="ngDialogData.needReason"><div class="row"><h2><span data-ng-bind="\'LANDINGPAGE_CHECK_DELETE_REQUEST\' | translate"></span></h2></div><div ng-if="ngDialogData.needReason" class="row mw-padded-top-sm"><div class="col-md-4 col-md-offset-4"><label for="delete_reason_drop" class="ssc-filterlabel">Grund*</label><select data-ng-class="{\'input-required-border\': (((model.user_id + \'\').length === 0) || (model.user_id === null)) && required.user_id && saved}" class="createdropper rightdropper" ng-model="ngDialogData.reason" id="delete_reason_drop"><option ng-repeat="item in ngDialogData.dropDeleteReason" ng-value="item.id" data-ng-bind="item.name"></option></select><br><label for="delete_reason_comment" class="ssc-filterlabel">Bemerkung*</label> <textarea data-ng-class="{\'input-required-border\': (((model.text + \'\').length === 0) || (model.text === null)) &amp;&amp; required.text &amp;&amp; saved}" class="createinputter ng-pristine ng-valid ng-empty ng-touched" ng-model="ngDialogData.comment" id="delete_reason_comment"></textarea></div></div><div class="row mw-padded-top-sm"><div class="col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton ng-binding" data-ng-bind="\'BTN_CANCEL\' | translate"></button></div><div class="col-sm-3 col-md-2"><button tabindex="-1" type="button" data-ng-click="delete(ngDialogData.id, ngDialogData.comment, ngDialogData.reason)" class="redbutton ng-binding" ng-disabled="ngDialogData.needReason && (!ngDialogData.reason || !ngDialogData.comment)"><span data-ng-bind="\'LANDINGPAGE_CHECK_DELETE_REQUEST\' | translate"></span></button></div></div></div><div ng-if="!ngDialogData.needReason"><div class="row"><h2><span data-ng-bind="\'LANDINGPAGE_CHECK_DELETE\' | translate"></span></h2><p data-ng-bind="\'LANDINGPAGE_CHECK_DELETE_TEXT\' | translate"></p></div><div class="row mw-padded-top-sm"><div class="col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton ng-binding" data-ng-bind="\'BTN_CANCEL\' | translate"></button></div><div class="col-sm-3 col-md-2"><button tabindex="-1" type="button" data-ng-click="delete(ngDialogData.id, ngDialogData.comment, ngDialogData.reason)" class="redbutton ng-binding" ng-disabled="ngDialogData.needReason && (!ngDialogData.reason || !ngDialogData.comment)"><span data-ng-bind="\'LANDINGPAGE_CHECK_BTN_DELETE\' | translate"></span></button></div></div></div></div>');
$templateCache.put('templates/landingpage/check_delete_cancel.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'LANDINGPAGE_CHECK_DELETE_CANCEL\' | translate"></span></h2><p data-ng-bind="\'LANDINGPAGE_CHECK_DELETE_CANCEL_TEXT\' | translate"></p></div><div class="row mw-padded-top-sm"><div class="col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton ng-binding" data-ng-bind="\'BTN_CANCEL\' | translate"></button></div><div class="col-sm-3 col-md-2"><button tabindex="-1" type="button" data-ng-click="cancelDelete(ngDialogData.id)" class="redbutton ng-binding"><span data-ng-bind="\'LANDINGPAGE_CHECK_BTN_DELETE_CANCEL\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/landingpage/check_duplicate.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'LANDINGPAGE_CHECK_DUPLICATE_TITLE\' | translate"></span></h2><p data-ng-bind="\'LANDINGPAGE_CHECK_DUPLICATE_TEXT\' | translate"></p></div><div class="row mw-padded-top-sm"><div class="col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton disableduringload" data-ng-bind="\'BTN_BACK\' | translate"></button></div><div class="col-sm-3 col-md-2"><button tabindex="-1" type="button" data-ng-click="saveCheck()" class="redbutton disableduringload"><span data-ng-bind="\'BTN_SAVE_REGARDLESS\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/landingpage/confirm_dialog.html','<div class="text-center"><div class="row margcreatetop"><div class="col-xs-12"><h2 class="dialog-h" style="line-height: 2rem;">{{ngDialogData.diagTitle}}</h2><p class="nlabel" data-ng-bind="ngDialogData.diagDescription"></p></div></div><div class="row mw-padded-top-sm"><div class="col-sm-4 col-sm-offset-2"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(0)" class="greybutton ng-binding" data-ng-bind="ngDialogData.diagCancel"></button></div><div class="col-sm-4"><button tabindex="-1" type="button" data-ng-click="confirm(1)" class="redbutton ng-binding"><span data-ng-bind="ngDialogData.diagConfirm"></span></button></div></div></div>');
$templateCache.put('templates/landingpage/deactivate.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'BTN_DEACTIVATE\' | translate"></span></h2><p data-ng-bind="\'LANDINGPAGE_DEACTIVATE_TEXT\' | translate"></p></div><div class="row mw-padded-top-sm"><div class="col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton disableduringload" data-ng-bind="\'BTN_CANCEL\' | translate"></button></div><div class="col-sm-3 col-md-2"><button tabindex="-1" type="button" data-ng-click="deactivate(ngDialogData.id)" class="redbutton disableduringload"><span data-ng-bind="\'BTN_DEACTIVATE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/landingpage/directhelp_archive.html','<div class="mw-inverse text-center col-xs-12 landingpage" data-ng-controller="directhelpTypController"><div class="row"><h2><span data-ng-bind="\'BTN_ARCHIVE\' | translate"></span></h2><p>Soforthilfe: <i data-ng-bind="ngDialogData.description"></i></p><p data-ng-bind="\'LANDINGPAGE_DIRECTHELP_ARCHIVE_TEXT\' | translate"></p></div><div class="row mw-padded-top-sm"><div class="col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog()" class="greybutton ng-binding" data-ng-bind="\'BTN_CANCEL\' | translate"></button></div><div class="col-sm-3 col-md-2"><button tabindex="-1" type="button" data-ng-click="archiveDirecthelp(ngDialogData.id)" class="redbutton ng-binding"><span data-ng-bind="\'BTN_ARCHIVE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/landingpage/employmentdate_in_use.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'LANDINGPAGE_EMPLOYMENTDATEINUSE_FAILURE_TITLE\' | translate"></span></h2><p data-ng-bind="\'LANDINGPAGE_EMPLOYMENTDATEINUSE_FAILURE_TEXT\' | translate"></p></div><div class="row mw-padded-top-sm"><div class="col-sm-4 col-sm-offset-4 col-md-2 col-md-offset-5"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton ng-binding" data-ng-bind="\'BTN_CLOSE\' | translate"></button></div></div></div>');
$templateCache.put('templates/landingpage/ok_dialog.html','<div class="text-center"><div class="row" style="padding-left: 20px; padding-right: 20px; line-height: normal"><h2 class="dialog-h" style="margin-bottom: 0"><span ng-if="ngDialogData.diagIcon"><i class="fa {{ngDialogData.diagIcon}}" aria-hidden="true"></i></span> {{ngDialogData.diagTitle}}</h2><p class="nlabel" data-ng-bind="ngDialogData.diagDescription"></p></div><div class="row mw-padded-top-sm" style="padding-left: 10px; padding-right: 10px;"><div class="col-sm-4 col-sm-offset-4"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(0)" class="greybutton ng-binding" data-ng-bind="ngDialogData.diagClose ? ngDialogData.diagClose : (\'BTN_OK\' | translate)"></button></div></div></div>');
$templateCache.put('templates/landingpage/ready_confirm_warnings.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'LANDINGPAGE_CONFIRM_TITLE\' | translate"></span></h2></div><div class="row mw-padded-top-sm"><div class="col-sm-4 col-sm-offset-4 col-md-2 col-md-offset-5"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton ng-binding" data-ng-bind="\'BTN_NOTE_READ\' | translate"></button></div></div></div>');
$templateCache.put('templates/landingpage/ready_failed.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'LANDINGPAGE_READY_FAILURE_TITLE\' | translate"></span><i class="fa fa-exclamation-triangle ready-failed"></i></h2><p data-ng-bind="\'LANDINGPAGE_READY_FAILURE_TEXT\' | translate"></p></div><div class="row mw-padded-top-sm"><div class="col-sm-4 col-sm-offset-4 col-md-2 col-md-offset-5"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false)" class="greybutton ng-binding" data-ng-bind="\'BTN_CLOSE\' | translate"></button></div></div></div>');
$templateCache.put('templates/landingpage/ready_success.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'LANDINGPAGE_READY_SUCCESS_TITLE\' | translate"></span><i class="fa fa-check ready-success"></i></h2><p data-ng-bind="\'LANDINGPAGE_READY_SUCCESS_TEXT\' | translate"></p></div><div class="row mw-padded-top-sm"><div class="col-sm-4 col-sm-offset-4 col-md-2 col-md-offset-5"><button tabindex="-1" type="button" data-ng-click="closeThisDialog(false);" class="greybutton ng-binding" data-ng-bind="\'BTN_CLOSE\' | translate"></button></div></div></div>');
$templateCache.put('templates/landingpage/status.html','<div class="mw-inverse text-center col-xs-12 landingpage"><div class="row"><h2><span data-ng-bind="\'LANDINGPAGE_STATUS_TITLE\' | translate"></span></h2></div><div class="row mw-padded-top-sm"><div class="col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4"><button tabindex="-1" type="button" data-ng-click="resetStatus(); closeThisDialog(false);" class="greybutton ng-binding" data-ng-bind="\'BTN_CANCEL\' | translate"></button></div><div class="col-sm-3 col-md-2"><button tabindex="-1" type="button" data-ng-click="save(\'ssc\',\'status\',data.ssc.status); closeThisDialog(true);" class="redbutton ng-binding"><span data-ng-bind="\'LANDINGPAGE_STATUS_TITLE\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/static/404.html','<div class="container p-top-35"><div class="col-sm-12 field"><h4 class="text-center">Die Seite konnte leider nicht gefunden werden</h4></div></div>');
$templateCache.put('templates/static/changeToNewPassword.html','<div><div class="container"><div class="row"><div class="col-sm-12 field marginerrorlogin"><div class="row hlabel" data-ng-bind="\'FORM_UNVERIFIED_TITLE\' | translate"></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_UNVERIFIED_TEXT\' | translate"></div></div></div></div></div></div><user-change-password></user-change-password>');
$templateCache.put('templates/static/createTwoFactor.html','<div class="margcreatetop"><two-factor-auth></two-factor-auth></div>');
$templateCache.put('templates/static/forgotpass.html','<password-forgotten></password-forgotten>');
$templateCache.put('templates/static/help.html','<div class="container"><h1>Hilfe</h1></div>');
$templateCache.put('templates/static/home.html','<div class="container"><div class="row"><news-box></news-box></div><div class="row"><div class="col-lg-12"><div class="col-sm-6 col-md-5 field"><div class="row hlabel" data-ng-bind="\'HOME_TITLE_ACTIONS\' | translate"></div><div class="margcreatetop"></div><div class="row" permission="" permission-only=\'["SSH","SSHPLUS","ADMIN"]\'><div class="col-sm-10 col-sm-offset-1"><a href="" ui-sref="ssc.overview({status: 0})"><button type="button" class="redbutton">{{\'BTN_HOME_HOUSEHOLD_NO_DATE\' | translate}}</button></a></div></div><div class="row" permission="" permission-only=\'["SSH","SSHPLUS","ADMIN"]\'><div class="col-sm-10 col-sm-offset-1"><a href="" ui-sref="ssc.overview({status: 2})"><button type="button" class="redbutton">{{\'BTN_HOME_HOUSEHOLD_DATA_ENTRY\' | translate}}</button></a></div></div><div class="row" permission="" permission-only=\'["SSH","SSHPLUS","ADMIN"]\'><div class="col-sm-10 col-sm-offset-1"><a href="" ui-sref="ssc.overview({status: 4})"><button type="button" class="redbutton" data-ng-bind="\'BTN_HOME_HOUSEHOLD_FOLLOW_UP\' | translate"></button></a></div></div><div class="row" permission="" permission-only=\'["SSHPLUS","ADMIN","LOKO"]\'><div class="col-sm-10 col-sm-offset-1"><a href="" ui-sref="ssc.create"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_HOUSEHOLD_CREATE\' | translate}}</button></a></div></div><div class="row" permission="" permission-only=\'["ADMIN","EFB"]\'><div class="col-sm-10 col-sm-offset-1"><a href="" ui-sref="user.create"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_USER_CREATE\' | translate}}</button></a></div></div><div class="row" permission="" permission-only=\'["ADMIN","LOKO"]\'><div class="col-sm-10 col-sm-offset-1"><a href="" ui-sref="user.create({roleId: 6})"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_SSH_CREATE\' | translate}}</button></a></div></div><div class="row" permission="" permission-only=\'["ADMIN","TRAINER"]\'><div class="col-sm-10 col-sm-offset-1"><a href="" ui-sref="ssc.overview({status: 3})"><button type="button" class="redbutton" data-ng-bind="\'BTN_HOME_HOUSEHOLD_CHECK\' | translate"></button></a></div></div><div class="row" permission="" permission-only=\'["EFB","ADMIN"]\'><div class="col-sm-10 col-sm-offset-1"><a href="" ui-sref="location.create"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_LOCATION_CREATE\' | translate}}</button></a></div></div><div class="row" permission="" permission-only=\'["ADMIN","BUKO","EFB","REKO"]\'><div class="col-sm-10 col-sm-offset-1"><a href="" ui-sref="review"><button type="button" class="redbutton" data-ng-bind="\'BTN_REVIEW\' | translate"></button></a></div></div><div class="margcreatetop"></div></div><div class="col-sm-1"></div><div class="col-sm-5 col-md-6 field"><div class="row hlabel ng-binding" data-ng-bind="\'HOME_TITLE_ROLES_LOCATIONS\' | translate">Anlegen &amp; Bearbeiten</div><role-box></role-box></div></div></div></div>');
$templateCache.put('templates/static/imprint.html','<div class="container"><div class="row"><div class="col-xs-12"><h1>Impressum</h1><h5>Anbieter im Sinne von \xA7 5 TMG:</h5><p>Die Mehrwertmacher GmbH<br>Amtsgericht Dresden, HR B 26597<br>USt-ID-Nr.: DE 242 935 264<br>Gesch\xE4ftsf\xFChrer: Denni Klein, Carsten Dietmann<br></p><h5>Anschrift:</h5><adress><p>Die Mehrwertmacher GmbH<br>Gr\xFCne Str. 16 a<br>01067 Dresden<br></p><p>Telefon: +49 351 4864-3000<br>E-Mail: info@diemehrwertmacher.de<br></p></adress><h5>Konzeption und Design</h5><adress><p>OBER\xDCBER KARGER Kommunikationsagentur GmbH<br>Devrientstra\xDFe 11<br>01067 Dresden<br></p><p>Telefon: +49 (0) 351 82968-0<br>Telefax: +49 (0) 351 82968-88<br>E-Mail: info@oberueber-karger.de<br><a href="http://oberueber-karger.de" rel="nofollow">oberueber-karger.de</a><br></p><h5>Haftungsausschluss</h5><ul class="mw-padded-row"><li>Inhalt des Onlineangebotes<p>Der Anbieter \xFCbernimmt keinerlei Gew\xE4hr f\xFCr die Aktualit\xE4t, Korrektheit, Vollst\xE4ndigkeit oder Qualit\xE4t der bereitgestellten Informationen. Haftungsanspr\xFCche gegen den Anbieter, welche sich auf Sch\xE4den materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollst\xE4ndiger Informationen verursacht wurden, sind grunds\xE4tzlich ausgeschlossen, sofern seitens des Anbieters kein nachweislich vors\xE4tzliches oder grob fahrl\xE4ssiges Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Anbieter beh\xE4lt es sich ausdr\xFCcklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ank\xFCndigung zu ver\xE4ndern, zu erg\xE4nzen, zu l\xF6schen oder die Ver\xF6ffentlichung zeitweise oder endg\xFCltig einzustellen.</p></li><li>Verweise und Links<p>Bei direkten oder indirekten Verweisen auf fremde Internetseiten ("Links"), die au\xDFerhalb des Verantwortungsbereiches des Anbieters liegen, w\xFCrde eine Haftungsverpflichtung ausschlie\xDFlich in dem Fall in Kraft treten, in dem der Anbieter von den Inhalten Kenntnis hat und es ihm technisch m\xF6glich und zumutbar w\xE4re, die Nutzung im Falle rechtswidriger Inhalte zu verhindern. Der Anbieter erkl\xE4rt daher ausdr\xFCcklich, dass zum Zeitpunkt der Linksetzung die entsprechenden verlinkten Seiten frei von illegalen Inhalten waren. Der Anbieter hat keinerlei Einfluss auf die aktuelle und zuk\xFCnftige Gestaltung und auf die Inhalte der gelinkten/verkn\xFCpften Seiten. Deshalb distanziert er sich hiermit ausdr\xFCcklich von allen Inhalten aller gelinkten/verkn\xFCpften Seiten, die nach der Linksetzung ver\xE4ndert wurden. Diese Feststellung gilt f\xFCr alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie f\xFCr Fremdeintr\xE4ge in vom Anbieter eingerichteten G\xE4steb\xFCchern, Diskussionsforen und Mailinglisten. F\xFCr illegale, fehlerhafte oder unvollst\xE4ndige Inhalte und insbesondere f\xFCr Sch\xE4den, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der \xFCber Links auf die jeweilige Ver\xF6ffentlichung lediglich verweist.</p></li><li>Urheber- und Kennzeichenrecht<p>Der Anbieter ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zur\xFCckzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte gesch\xFCtzten Marken- und Warenzeichen unterliegen uneingeschr\xE4nkt den Bestimmungen des jeweils g\xFCltigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigent\xFCmer. Allein aufgrund der blo\xDFen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter gesch\xFCtzt sind! Die Rechte f\xFCr ver\xF6ffentlichte, vom Anbieter bzw. jeweiligen Auto selbst erstellte Objekte bleibt allein beim Anbieter bzw. Autor der Seiten. Eine Vervielf\xE4ltigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdr\xFCckliche Zustimmung des Anbieters bzw. Autors nicht gestattet.</p></li></ul></adress></div></div><div class="row"><div class="col-xs-12"><status></status></div></div></div>');
$templateCache.put('templates/static/login.html','<login></login>');
$templateCache.put('templates/static/privacy.html','<div class="container"><div class="row"><div class="col-xs-12"><h1>Datenschutz</h1><p>Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. (\xBBGoogle\xAB). Google Analytics verwendet sog. \xBBCookies\xAB, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie erm\xF6glichen. Die durch den Cookie erzeugten Informationen \xFCber Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA \xFCbertragen und dort gespeichert. Im Falle der Aktivierung der IP-Anonymisierung auf dieser Webseite wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der Europ\xE4ischen Union oder in anderen Vertragsstaaten des Abkommens \xFCber den Europ\xE4ischen Wirtschaftsraum zuvor gek\xFCrzt.</p><p>Nur in Ausnahmef\xE4llen wird die volle IP-Adresse an einen Server von Google in den USA \xFCbertragen und dort gek\xFCrzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports \xFCber die Websiteaktivit\xE4ten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegen\xFCber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser \xFCbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\xFChrt.</p><p>Sie k\xF6nnen die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht s\xE4mtliche Funktionen dieser Website vollumf\xE4nglich werden nutzen k\xF6nnen. Sie k\xF6nnen dar\xFCber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter dem folgenden Link verf\xFCgbare Browser-Plugin herunterladen und installieren: http://tools.google.com/dlpage/gaoptout?hl=de.</p></div></div></div>');
$templateCache.put('templates/static/requireNewPw.html','<div><div class="container"><div class="row"><div class="col-sm-12 field marginerrorlogin"><div class="row hlabel" data-ng-bind="\'FORM_UNVERIFIED_TITLE\' | translate"></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_UNVERIFIED_TEXT\' | translate"></div></div></div></div></div></div><user-change-password></user-change-password>');
$templateCache.put('templates/static/directhelp/directhelp.html','<div class="container" permission="" permission-only=\'["ADMIN"]\'><div class="row"><div class="col-sm-4"><a href="" ui-sref="directhelp.create"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_DIRECTHELP_CREATE\' | translate}}</button></a></div><div class="col-sm-4"><a href="" ui-sref="directhelp.typ"><button type="button" class="redbutton" data-ng-bind="\'BTN_DIRECTHELPTYP_OVERVIEW\' | translate"></button></a></div></div></div><searchdirecthelp></searchdirecthelp><tabmenudirecthelp></tabmenudirecthelp>');
$templateCache.put('templates/static/directhelp/directhelpCreate.html','<directhelp-create></directhelp-create>');
$templateCache.put('templates/static/directhelp/directhelpLocationPricelist.html','<div class="container" data-ng-controller="directhelpLocationPriceListController"><div class="row"><div class="col-sm-12"><h4>{{pageTitle}}</h4><div class="col-sm-12 field text-center"><div ng-if="!data"><h4>Wird erstellt...</h4></div><div ng-if="data"><div class="row rlabel"><div class="col-xs-4">Typ</div><div class="col-xs-4">Ausgegeben</div><div class="col-xs-4">Summe</div></div><div ng-if="(data.type.length==0)" class="row ui-grid-row"><div class="col-xs-12 rlabel text-left">Keine Soforthilfen ausgegeben.</div></div><div ng-if="(data.type.length!=0)"><div class="row ui-grid-row" ng-repeat="(groupname,groupdata) in data.type"><div class="col-xs-12 rlabel text-left">{{groupname}}</div><div style="clear:both" ng-repeat="(itemindex,item) in groupdata" ng-class="{\'table-row-gray\':(itemindex%2==0)}"><div class="col-xs-4 text-left">{{item.description}}</div><div class="col-xs-4">{{item.count}}</div><div class="col-xs-4"><div ng-if="item.price_ek">{{item.price_ek| decimal2comma: 2}} \u20AC</div><span ng-if="!item.price_ek">-</span></div><div style="clear:both"></div></div></div><div class="row margcreatetop"><div class="col-xs-4 text-bold text-left">Summe:</div><div class="col-xs-4 text-bold">{{data.sum.num_dh}}</div><div class="col-xs-4 text-bold">{{data.sum.price_ek| decimal2comma: 2}} \u20AC Netto</div></div><div class="row"><div class="col-xs-offset-8 col-xs-4 text-bold">{{data.sum.price_vk| decimal2comma: 2}} \u20AC Brutto</div></div><div class="row"><div class="col-xs-offset-8 col-xs-4 text-bold">{{data.sum.num_ssc}} SSC</div></div><div class="row"><div class="col-xs-offset-8 col-xs-4 text-bold">{{data.sum.price_vk_per_ssc}} \u20AC/SSC</div></div></div></div></div></div></div></div>');
$templateCache.put('templates/static/directhelp/directhelpUpdate.html','<div permission="" permission-except=\'["ADMIN"]\' style="text-align:center"><h4>Nicht gefunden</h4></div><div permission="" permission-only=\'["ADMIN"]\'><div class="container" data-ng-controller="submenuController"><div class="row"><div class="col-sm-4"><a href="" ui-sref="directhelp.prices.create({id: id})"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'BTN_DIRECTHELP_PRICE_CREATE\' | translate"></span></button></a></div></div></div><directhelp-create></directhelp-create><tabmenudirecthelpprices edit="1"></tabmenudirecthelpprices></div>');
$templateCache.put('templates/static/directhelpPrices/directhelpPrices.html','<tabmenudirecthelpprices edit="0"></tabmenudirecthelpprices>');
$templateCache.put('templates/static/directhelpPrices/directhelpPricesCreate.html','<directhelp-prices-create></directhelp-prices-create>');
$templateCache.put('templates/static/directhelpPrices/directhelpPricesUpdate.html','<directhelp-prices-create></directhelp-prices-create>');
$templateCache.put('templates/static/directhelpTyp/directhelpTyp.html','<div class="container"><div class="row"><div class="col-sm-4"><a href="" permission="" permission-only=\'["ADMIN"]\' ui-sref="directhelp.typ.create"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_DIRECTHELPTYP_CREATE\' | translate}}</button></a></div></div></div><searchdirecthelptyp></searchdirecthelptyp><tabmenudirecthelptyp></tabmenudirecthelptyp>');
$templateCache.put('templates/static/directhelpTyp/directhelpTypCreate.html','<directhelp-typ-create></directhelp-typ-create>');
$templateCache.put('templates/static/directhelpTyp/directhelpTypUpdate.html','<directhelp-typ-create></directhelp-typ-create>');
$templateCache.put('templates/static/employmenttype/employmenttype.html','<div permission="" permission-except=\'["ADMIN", "LOKO"]\' style="text-align:center"><h4>Nicht gefunden</h4></div><div permission="" permission-only=\'["ADMIN", "LOKO"]\'><div class="container"><div class="row"><div class="col-sm-4"><a href="" permission="" permission-only=\'["ADMIN"]\' ui-sref="user.employmenttype.create"><button type="button" class="redbutton" data-ng-bind="\'BTN_CREATE_EMPLOYMENT\' | translate"></button></a></div></div></div><searchemploymenttype></searchemploymenttype><tabmenuemploymenttype></tabmenuemploymenttype></div>');
$templateCache.put('templates/static/employmenttype/employmenttypeCreate.html','<employmenttype-create></employmenttype-create>');
$templateCache.put('templates/static/employmenttype/employmenttypeUpdate.html','<employmenttype-create></employmenttype-create>');
$templateCache.put('templates/static/exchange/archiv.html','<searcharchiv></searcharchiv><tabmenuarchiv></tabmenuarchiv>');
$templateCache.put('templates/static/exchange/exchange.html','<div class="container"><div class="row"><div class="col-lg-4 col-md-4 col-sm-4"><a href="" ui-sref="exchange.archiv" permission="" permission-only=\'["ADMIN","LOKO"]\'><button type="button" class="redbutton" data-ng-bind="\'BTN_ARCHIV\' | translate"></button></a></div></div></div><searchexchange></searchexchange><tabmenuexchange></tabmenuexchange>');
$templateCache.put('templates/static/news/news.html','<div class="container"><div class="row"><div class="col-sm-4"><a href="" permission="" permission-only=\'["ADMIN"]\' ui-sref="news.create"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_NEWS_CREATE\' | translate}}</button></a></div></div></div><searchnews></searchnews><tabmenunews></tabmenunews>');
$templateCache.put('templates/static/news/newsCreate.html','<news-create></news-create>');
$templateCache.put('templates/static/news/newsDetail.html','<div class="container" data-ng-controller="submenuController"><div class="row"><div class="col-sm-4"><a href="" ui-sref="news.update({id: id})"><button type="button" class="redbutton" data-ng-bind="\'BTN_NEWS_UPDATE\' | translate"></button></a></div></div></div><news-detail></news-detail>');
$templateCache.put('templates/static/news/newsUpdate.html','<news-create></news-create>');
$templateCache.put('templates/static/organisation/organisationCreate.html','<create-organisation></create-organisation>');
$templateCache.put('templates/static/organisation/organisationDetail.html','<div class="container" data-ng-controller="submenuController"><div class="row"><div class="col-sm-4"><a class="navbar-backlink" href="" ui-sref="location.organisationUpdate({id: id})"><button type="button" class="redbutton" data-ng-bind="\'BTN_ORGANISATION_UPDATE\' | translate"></button></a></div></div></div><detail-organisation></detail-organisation>');
$templateCache.put('templates/static/organisation/organisationUpdate.html','<create-organisation></create-organisation>');
$templateCache.put('templates/static/review/review.html','<tabmenureview></tabmenureview><div><div class="container"><div class="row"><div class="col-sm-12"><report-list></report-list></div></div></div></div>');
$templateCache.put('templates/static/location/location.html','<div class="container"><div class="row"><div class="col-sm-4" permission="" permission-only=\'["ADMIN","EFB","REKO"]\'><a href="" ui-sref="location.create"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_LOCATION_CREATE\' | translate}}</button></a></div><div class="col-sm-4" permission="" permission-only=\'["ADMIN","BUKO"]\'><a href="" ui-sref="location.regionCreate"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_REGION_CREATE\' | translate}}</button></a></div><div class="col-sm-4" permission="" permission-only=\'["ADMIN"]\'><a href="" ui-sref="location.organisationCreate"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_ORGANISATION_CREATE\' | translate}}</button></a></div></div></div><searchlocation></searchlocation><tabmenulocation></tabmenulocation>');
$templateCache.put('templates/static/location/locationCreateLocation.html','<create-location></create-location>');
$templateCache.put('templates/static/location/locationCreateOrganisation.html','<create-organisation></create-organisation>');
$templateCache.put('templates/static/location/locationCreateRegion.html','<create-region></create-region>');
$templateCache.put('templates/static/location/locationDetail.html','<div class="container" data-ng-controller="submenuController"><div class="row"><div class="col-sm-4"><a href="" ui-sref="location.update({id: id})"><button type="button" class="redbutton" data-ng-bind="\'BTN_LOCATION_UPDATE\' | translate"></button></a></div></div></div><detail-location></detail-location>');
$templateCache.put('templates/static/location/locationUpdate.html','<create-location></create-location>');
$templateCache.put('templates/static/location/regionDetail.html','<div class="container" data-ng-controller="submenuController"><div class="row"><div class="col-sm-4"><a href="" ui-sref="location.regionUpdate({id: id})"><button type="button" class="redbutton" data-ng-bind="\'BTN_REGION_UPDATE\' | translate"></button></a></div></div></div><detail-region></detail-region>');
$templateCache.put('templates/static/location/regionUpdate.html','<create-region></create-region>');
$templateCache.put('templates/static/ssc/ssc.html','<div class="container"><div class="row"><div class="col-sm-4" permission="" permission-only=\'["SSHPLUS", "LOKO", "ADMIN"]\'><a href="stromspar-check/erstellen"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_HOUSEHOLD_CREATE\' | translate}}</button></a></div><div class="col-sm-4" permission="" permission-only=\'["ADMIN"]\'><a href="stromspar-check/loeschantraege"><button type="button" class="redbutton"><i class="fa fa-trash marg-right-small" aria-hidden="true"></i>{{\'BTN_DELETION_REQUESTS\' | translate}}</button></a></div></div></div><searchssc></searchssc><tabmenussc></tabmenussc>');
$templateCache.put('templates/static/ssc/ssc_right.html','<div class="md-subtract-gutter-left"><plausi-small></plausi-small><a class="navbar-backlink" ui-sref="ssc.check.overview.download"><button type="button" class="redbutton"><i class="ssc-icon ssc-icon-downloads marg-right-small" aria-hidden="true"></i>{{\'BTN_DOWNLOAD\' | translate}}</button></a> <a class="navbar-backlink" ui-sref="ssc.check.overview.abstract"><button type="button" class="redbutton"><i class="ssc-icon ssc-icon-summary marg-right-small" aria-hidden="true"></i>{{\'BTN_SUMMARY\' | translate}}</button></a><ssc-log-button></ssc-log-button></div>');
$templateCache.put('templates/static/ssc/ssc_top.html','<tile-small></tile-small>');
$templateCache.put('templates/static/user/createTwoFactor.html','<two-factor-auth></two-factor-auth>');
$templateCache.put('templates/static/user/user.html','<div><div class="container"><div class="row"><div class="col-sm-4" permission="" permission-only=\'["ADMIN","LOKO","EFB","BUKO"]\'><a href="" ui-sref="user.create"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'BTN_USER_CREATE\' | translate}}</button></a></div><div class="col-sm-4" permission="" permission-only=\'["ADMIN"]\'><a href="" ui-sref="user.employmenttype"><button type="button" class="redbutton" data-ng-bind="\'BTN_EMPLOYMENT\' | translate"></button></a></div></div></div><searchuser></searchuser><tabmenuuser></tabmenuuser></div>');
$templateCache.put('templates/static/user/userChangeMyPassword.html','<div class="container"><user-change-password></user-change-password></div>');
$templateCache.put('templates/static/user/userChangePassword.html','<div class="container"><user-change-password></user-change-password></div>');
$templateCache.put('templates/static/user/userCreate.html','<user-create is-not-found="isNotFound"></user-create>');
$templateCache.put('templates/static/user/userCreateRoleLocation.html','<user-create-role-location></user-create-role-location>');
$templateCache.put('templates/static/user/userDetail.html','<user-detail></user-detail>');
$templateCache.put('templates/static/user/userStromsparhelfer.html','<searchlocation-ssh></searchlocation-ssh><tabmenulocation-ssh></tabmenulocation-ssh>');
$templateCache.put('templates/static/user/userUpdate.html','<div ng-show="isNotFound" style="text-align:center"><h4>Nicht gefunden</h4></div><div ng-show="!isNotFound"><user-create is-not-found="isNotFound"></user-create><tabmenuuserrolelocation></tabmenuuserrolelocation></div>');
$templateCache.put('templates/static/user/userUpdateRoleLocation.html','<user-create-role-location></user-create-role-location>');
$templateCache.put('templates/static/monitoring/directhelp/directhelp.html','<div data-ng-controller="monitoringDirecthelpController"><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'MONITORING_DIRECTHELP_TITLE_SH\' | translate) +\' - \'+ (\'MONITORING_DIRECTHELP_TITLE\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" href="#collapse_heat"><span data-ng-bind="\'MONITORING_DH_HEAT\' | translate"></span></div><div id="collapse_heat" class="collapse in"><ssc-errorbox data-messages="errors.heat.messages"></ssc-errorbox><div ng-repeat="clip in content.monitoring_installed_clip track by $index"><hr ng-if="$index > 0"><div class="margcreatetop"></div><div class="row"><div class="col-sm-4 ilabel" ng-bind="\'MONITORING_DH_HEAT_DIRECTHELP\' | translate"></div><div class="col-sm-7 nlabel" ng-bind="\'MONITORING_DH_HEAT_DIRECTHELP_CLIP\' | translate"></div></div><ssc-input data-type="label" data-field="monitoring_installed_clip.{{$index}}.room_id" data-displayfield="room_type.name" data-label="MONITORING_ROOM" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_installed_clip.{{$index}}.directhelp_usetype_id" data-options="formPageScope.content.monitoring_directhelp_usetype" data-optionfield="description" data-label="MONITORING_DH_USETYPE" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_installed_clip.{{$index}}.savings_feeling_answer_id" data-options="formPageScope.content.monitoring_yes_no_unknown_answer_type" data-optionfield="name" data-label="MONITORING_DH_SAVINGS_FEELING" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input></div><div ng-repeat="seal in content.monitoring_installed_shutter_strap_seal track by $index"><hr ng-if="$index > 0 || content.monitoring_installed_clip && content.monitoring_installed_clip.length > 0"><div class="margcreatetop"></div><div class="row"><div class="col-sm-4 ilabel" ng-bind="\'MONITORING_DH_HEAT_DIRECTHELP\' | translate"></div><div class="col-sm-7 nlabel" ng-bind="\'MONITORING_DH_HEAT_DIRECTHELP_SHUTTER_STRAP\' | translate"></div></div><ssc-input data-type="label" data-field="monitoring_installed_shutter_strap_seal.{{$index}}.room_id" data-displayfield="room_type.name" data-label="MONITORING_ROOM" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_installed_shutter_strap_seal.{{$index}}.directhelp_usetype_id" data-options="formPageScope.content.monitoring_directhelp_usetype" data-optionfield="description" data-label="MONITORING_DH_USETYPE" data-page="formPageScope"></ssc-input><ssc-input data-type="select" data-field="monitoring_installed_shutter_strap_seal.{{$index}}.savings_feeling_answer_id" data-options="formPageScope.content.monitoring_yes_no_unknown_answer_type" data-optionfield="name" data-label="MONITORING_DH_SAVINGS_FEELING" data-page="formPageScope"></ssc-input></div><div ng-repeat="doorbrush in content.monitoring_installed_doorbrush track by $index"><hr ng-if="$index > 0 || content.monitoring_installed_clip && content.monitoring_installed_clip.length > 0 || content.monitoring_installed_shutter_strap_seal && content.monitoring_installed_shutter_strap_seal.length > 0"><div class="margcreatetop"></div><div class="row"><div class="col-sm-4 ilabel" ng-bind="\'MONITORING_DH_HEAT_DIRECTHELP\' | translate"></div><div class="col-sm-7 nlabel" ng-bind="\'MONITORING_DH_HEAT_DIRECTHELP_DOORBRUSH\' | translate"></div></div><ssc-input data-type="label" data-field="monitoring_installed_doorbrush.{{$index}}.room_id" data-displayfield="room_type.name" data-label="MONITORING_ROOM" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_installed_doorbrush.{{$index}}.directhelp_usetype_id" data-options="formPageScope.content.monitoring_directhelp_usetype" data-optionfield="description" data-label="MONITORING_DH_USETYPE" data-page="formPageScope"></ssc-input><ssc-input data-type="select" data-field="monitoring_installed_doorbrush.{{$index}}.savings_feeling_answer_id" data-options="formPageScope.content.monitoring_yes_no_unknown_answer_type" data-optionfield="name" data-label="MONITORING_DH_SAVINGS_FEELING" data-page="formPageScope"></ssc-input></div><div ng-if="content.monitoring_heat_directhelp_other.seal_tape_directhelp != null"><hr><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_heat_directhelp_other.seal_tape_directhelp" data-displayfield="seal_tape_directhelp.description" data-label="MONITORING_DH_HEAT_DIRECTHELP" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_heat_directhelp_other.seal_tape_room_type" data-displayfield="seal_tape_room_type.name" data-label="MONITORING_ROOM" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_heat_directhelp_other.seal_tape_usetype_id" data-options="formPageScope.content.monitoring_directhelp_usetype" data-optionfield="description" data-label="MONITORING_DH_USETYPE" data-page="formPageScope"></ssc-input><ssc-input data-type="select" data-field="monitoring_heat_directhelp_other.seal_tape_savings_feeling_id" data-options="formPageScope.content.monitoring_yes_no_unknown_answer_type" data-optionfield="name" data-label="MONITORING_DH_SAVINGS_FEELING" data-page="formPageScope"></ssc-input></div><div ng-if="content.monitoring_heat_directhelp_other.thermometer_analog_directhelp != null"><hr><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_heat_directhelp_other.thermometer_analog" data-displayfield="thermometer_analog_directhelp.description" data-label="MONITORING_DH_HEAT_DIRECTHELP" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_heat_directhelp_other.thermometer_analog_observance_id" data-options="formPageScope.content.monitoring_observance_type" data-optionfield="description" data-label="MONITORING_DH_OBSERVANCE" data-page="formPageScope"></ssc-input><ssc-input data-type="input" data-field="monitoring_heat_directhelp_other.thermometer_analog_observance_reason" data-label="MONITORING_DH_OBSERVANCE_REASON" data-page="formPageScope" is-text="true"></ssc-input><ssc-input data-type="select" data-field="monitoring_heat_directhelp_other.thermometer_analog_improvement_id" data-options="formPageScope.content.monitoring_yes_no_unknown_answer_type" data-optionfield="name" data-label="MONITORING_DH_IMPROVEMENT" data-page="formPageScope"></ssc-input></div><div ng-if="content.monitoring_heat_directhelp_other.thermometer_digital_directhelp"><hr><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_heat_directhelp_other.thermometer_digital" data-displayfield="thermometer_digital_directhelp.description" data-label="MONITORING_DH_HEAT_DIRECTHELP" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_heat_directhelp_other.thermometer_digital_observance_id" data-options="formPageScope.content.monitoring_observance_type" data-optionfield="description" data-label="MONITORING_DH_OBSERVANCE" data-page="formPageScope"></ssc-input><ssc-input data-type="input" data-field="monitoring_heat_directhelp_other.thermometer_digital_observance_reason" data-label="MONITORING_DH_OBSERVANCE_REASON" data-page="formPageScope" is-text="true"></ssc-input><ssc-input data-type="select" data-field="monitoring_heat_directhelp_other.thermometer_digital_improvement_id" data-options="formPageScope.content.monitoring_yes_no_unknown_answer_type" data-optionfield="name" data-label="MONITORING_DH_IMPROVEMENT" data-page="formPageScope"></ssc-input></div><div class="margcreatebot"></div></div></div></div><div class="accordeon"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" href="#collapse_lighting"><span data-ng-bind="\'MONITORING_DH_LIGHTING\' | translate"></span></div><div id="collapse_lighting" class="collapse in"><ssc-errorbox data-messages="errors.lighting.messages"></ssc-errorbox><div class="margcreatetop" ng-if="!content.monitoring_lighting || content.monitoring_lighting.length === 0"></div><div ng-repeat="md in content.monitoring_lighting track by $index"><hr ng-if="$index > 0"><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_lighting.{{$index}}.lighting_room" data-displayfield="monitoring_room_type.name" data-label="MONITORING_ROOM" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_lighting.{{$index}}.directhelp_id" data-displayfield="directhelp.description" data-label="MONITORING_DH_LIGHTING_TYPE" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_lighting.{{$index}}.lighting_original_wattage" data-label="MONITORING_DH_LIGHTING_ORIGINAL_WATTAGE" data-unit="W" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_lighting.{{$index}}.lighting_replaced_wattage" data-label="MONITORING_DH_LIGHTING_REPLACED_WATTAGE" data-unit="W" data-page="formPageScope" data-help="" data-precision="1"></ssc-input><ssc-input data-type="label" data-field="monitoring_lighting.{{$index}}.lighting_spended_bulb_count" data-label="MONITORING_DH_LIGHTING_SPENDED_BULB_COUNT" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="monitoring_lighting.{{$index}}.lighting_current_bulb_count" data-label="MONITORING_DH_LIGHTING_CURRENT_BULB_COUNT" data-page="formPageScope" data-help="TIP_MONITORING_DH_LIGHTING_CURRENT_BULB_COUNT"></ssc-input><ssc-input data-type="input" data-field="monitoring_lighting.{{$index}}.lighting_current_burning_period" data-label="MONITORING_DH_LIGHTING_CURRENT_BURNING_PERIOD" data-unit="h/Tag" data-precision="2" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_lighting.{{$index}}.lighting_current_saving" data-label="MONITORING_DH_LIGHTING_CURRENT_SAVING" data-unit="kWh/a" data-page="formPageScope" data-help=""></ssc-input><div class="margcreatetop"></div></div></div></div></div><div class="accordeon margincreatetop"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" href="#collapse_standby"><span data-ng-bind="\'MONITORING_DH_NO_LOAD_LOSSES\' | translate"></span></div><div id="collapse_standby" class="collapse in"><ssc-errorbox data-messages="errors.standby.messages"></ssc-errorbox><div class="margcreatetop" ng-if="!content.monitoring_no_load_losses || content.monitoring_no_load_losses.length === 0"></div><div ng-repeat="md in content.monitoring_no_load_losses track by $index"><hr ng-if="$index > 0"><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_no_load_losses.{{$index}}.no_load_losses_room" data-displayfield="monitoring_room_type.name" data-label="MONITORING_ROOM" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_no_load_losses.{{$index}}.directhelp_id" data-displayfield="directhelp.description" data-label="MONITORING_DH_NO_LOAD_LOSSES_DH" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_no_load_losses.{{$index}}.standby_device_category_id" data-displayfield="standby_device_category.name" data-label="MONITORING_DH_NO_LOAD_LOSSES_CATEGORY" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_no_load_losses.{{$index}}.no_load_losses_original_standby_wattage" data-label="MONITORING_DH_NO_LOAD_LOSSES_ORIGINAL_STANDBY_WATTAGE" data-unit="W" data-page="formPageScope" data-help="" data-precision="1"></ssc-input><ssc-input data-type="label" data-field="monitoring_no_load_losses.{{$index}}.no_load_losses_original_stand_by_operation_time" data-label="MONITORING_DH_NO_LOAD_LOSSES_STAND_BY_OPERATION_TIME" data-unit="h/Tag" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="monitoring_no_load_losses.{{$index}}.no_load_losses_current_stand_by_operation_time" data-label="MONITORING_DH_NO_LOAD_LOSSES_CURRENT_STAND_BY_OPERATION_TIME" data-unit="h/Tag" data-page="formPageScope" data-help="" data-precision="2"></ssc-input><ssc-input data-type="input" data-field="monitoring_no_load_losses.{{$index}}.no_load_losses_current_stand_by_wattage" data-label="MONITORING_DH_NO_LOAD_LOSSES_CURRENT_STAND_BY_WATTAGE" data-unit="W" data-page="formPageScope" data-help="" data-precision="1"></ssc-input><ssc-input data-type="select" data-field="monitoring_no_load_losses.{{$index}}.no_load_losses_dh_in_use_id" data-options="formPageScope.content.monitoring_yes_no_answer_type" data-optionfield="name" data-label="MONITORING_DH_NO_LOAD_LOSSES_DH_IN_USE" data-page="formPageScope"></ssc-input><ssc-input data-type="label" data-field="monitoring_no_load_losses.{{$index}}.no_load_losses_current_saving" data-label="MONITORING_DH_NO_LOAD_LOSSES_CURRENT_SAVING" data-unit="kWh" data-page="formPageScope" data-help=""></ssc-input><div class="margcreatetop"></div></div></div></div></div><div class="accordeon margincreatetop"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" href="#collapse_hot_water"><span data-ng-bind="\'MONITORING_DH_HOT_WATER\' | translate"></span></div><div id="collapse_hot_water" class="collapse in"><ssc-errorbox data-messages="errors.hotWater.messages"></ssc-errorbox><div class="margcreatetop" ng-if="!content.monitoring_hot_water || content.monitoring_hot_water.length === 0"></div><div ng-repeat="md in content.monitoring_hot_water track by $index"><hr ng-if="$index > 0"><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_hot_water.{{$index}}.hot_water_room" data-displayfield="monitoring_room_type.name" data-label="MONITORING_ROOM" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_hot_water.{{$index}}.directhelp_id" data-displayfield="directhelp.description" data-label="MONITORING_DH_HOT_WATER_DH" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_hot_water.{{$index}}.hot_water_power_off_time" data-label="MONITORING_DH_HOT_WATER_POWER_OFF_TIME" data-unit="h/Tag" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="monitoring_hot_water.{{$index}}.hot_water_current_power_off_time" data-label="MONITORING_DH_HOT_WATER_CURRENT_POWER_OFF_TIME" data-unit="h/Tag" data-precision="2" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_hot_water.{{$index}}.hot_water_dh_in_use_id" data-options="formPageScope.content.monitoring_yes_no_answer_type" data-optionfield="name" data-label="MONITORING_DH_HOT_WATER_DH_IN_USE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_hot_water.{{$index}}.hot_water_current_saving" data-label="MONITORING_DH_HOT_WATER_CURRENT_SAVING" data-unit="kWh/a" data-page="formPageScope" data-help=""></ssc-input><div class="margcreatetop"></div></div></div></div></div><div class="accordeon margincreatetop"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" href="#collapse_toilet"><span data-ng-bind="\'MONITORING_DH_TOILET_FLUSH_SAVING\' | translate"></span></div><div id="collapse_toilet" class="collapse in"><ssc-errorbox data-messages="errors.toiletFlush.messages"></ssc-errorbox><div class="margcreatetop" ng-if="!content.monitoring_toilet_flush || content.monitoring_toilet_flush.length === 0"></div><div ng-repeat="md in content.monitoring_toilet_flush track by $index"><hr ng-if="$index > 0"><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_toilet_flush.{{$index}}.daily_flush_count" data-label="MONITORING_DH_TOILET_DAILY_FLUSH_COUNT" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="monitoring_toilet_flush.{{$index}}.current_daily_flush_count" data-label="MONITORING_DH_TOILET_CURRENT_DAILY_FLUSH_COUNT" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_toilet_flush.{{$index}}.dh_is_in_use" data-options="formPageScope.yesNoTypeArr" data-optionfield="name" data-label="MONITORING_DH_TOILET_DH_IN_USE" data-page="formPageScope"></ssc-input><ssc-input data-type="label" data-field="monitoring_toilet_flush.{{$index}}.saving_prediction" data-label="MONITORING_DH_TOILET_SAVING_PREDICTION" data-unit="m\xB3" data-page="formPageScope" data-help="" data-precision="3"></ssc-input><div class="margcreatetop"></div></div></div></div></div><div class="accordeon margincreatetop"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" href="#collapse_shower"><span data-ng-bind="\'MONITORING_DH_SHOWER_SAVING\' | translate"></span></div><div id="collapse_shower" class="collapse in"><ssc-errorbox data-messages="errors.shower.messages"></ssc-errorbox><div class="margcreatetop" ng-if="!content.monitoring_shower || content.monitoring_shower.length === 0"></div><div ng-repeat="md in content.monitoring_shower track by $index"><hr ng-if="$index > 0"><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_shower.{{$index}}.flow_rate_before" data-label="MONITORING_SHOWER_FLOW_RATE_BEFORE" data-unit="Liter/Min" data-page="formPageScope" data-help="" data-precision="1"></ssc-input><ssc-input data-type="label" data-field="monitoring_shower.{{$index}}.flow_rate_directhelp" data-label="MONITORING_SHOWER_FLOW_RATE_DIRECTHELP" data-unit="Liter/Min" data-page="formPageScope" data-help="" data-precision="1"></ssc-input><ssc-input data-type="label" data-field="monitoring_shower.{{$index}}.directhelp_id" data-displayfield="directhelp.description" data-label="MONITORING_SHOWER_DIRECTHELP_DESCRIPTION" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_shower.{{$index}}.shower_total_duration_week" data-label="MONITORING_SHOWER_DURATION_WEEK" data-unit="Min" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="monitoring_shower.{{$index}}.current_duration_week" data-label="MONITORING_SHOWER_CURRENT_DURATION_WEEK" data-unit="Min" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_shower.{{$index}}.dh_is_in_use" data-options="formPageScope.yesNoTypeArr" data-optionfield="name" data-label="MONITORING_SHOWER_DH_IS_IN_USE" data-page="formPageScope"></ssc-input><ssc-input data-type="label" data-field="monitoring_shower.{{$index}}.saving_prediction" data-label="MONITORING_SHOWER_SAVING_PREDICTION" data-unit="m\xB3/a" data-page="formPageScope" data-help="" data-precision="3"></ssc-input><div class="margcreatetop"></div></div></div></div></div><div class="accordeon margincreatetop"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" href="#collapse_tap"><span data-ng-bind="\'MONITORING_DH_TAP_SAVING\' | translate"></span></div><div id="collapse_tap" class="collapse in"><ssc-errorbox data-messages="errors.tap.messages"></ssc-errorbox><div class="margcreatetop" ng-if="!content.monitoring_tap || content.monitoring_tap.length === 0"></div><div ng-repeat="md in content.monitoring_tap track by $index"><hr ng-if="$index > 0"><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_tap.{{$index}}.tap_room" data-displayfield="monitoring_room_type.name" data-label="MONITORING_ROOM" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_tap.{{$index}}.directhelp_id" data-displayfield="directhelp.description" data-label="MONITORING_DH_TAP_DH" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_tap.{{$index}}.tap_original_flow_rate" data-label="MONITORING_DH_TAP_ORIGINAL_FLOW_RATE" data-unit="Liter/Min" data-page="formPageScope" data-help="" data-precision="1"></ssc-input><ssc-input data-type="select" data-field="monitoring_tap.{{$index}}.tap_dh_in_use_id" data-options="formPageScope.content.monitoring_yes_no_answer_type" data-optionfield="name" data-label="MONITORING_DH_TAP_DH_IN_USE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_tap.{{$index}}.tap_current_saving" data-label="MONITORING_DH_TAP_CURRENT_SAVING" data-unit="m\xB3/a" data-page="formPageScope" data-help="" data-precision="3"></ssc-input><div class="margcreatetop"></div></div></div></div></div><div class="accordeon margincreatetop"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" href="#collapse_kia"><span data-ng-bind="\'MONITORING_DH_KIA_SAVING\' | translate"></span></div><div id="collapse_kia" class="collapse in"><ssc-errorbox data-messages="errors.tap.messages"></ssc-errorbox><div class="margcreatetop" ng-if="!content.monitoring_kia_directhelp || content.monitoring_kia_directhelp.length === 0"></div><div ng-repeat="md in content.monitoring_kia_directhelp track by $index"><hr ng-if="$index > 0"><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_kia_directhelp.{{$index}}.directhelp_id" data-displayfield="directhelp.description" data-label="MONITORING_DH_KIA_DH" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_kia_directhelp.{{$index}}.usetype_id" data-options="formPageScope.content.monitoring_directhelp_usetype_kia" data-optionfield="description" data-label="MONITORING_DH_KIA_USETYPE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_kia_directhelp.{{$index}}.behavior_changed_id" data-options="formPageScope.content.monitoring_yes_no_unknown_answer_type" data-optionfield="name" data-label="MONITORING_DH_KIA_BEHAVIOR_CHANGED" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="monitoring_kia_directhelp.{{$index}}.weekly_bought_water_liter" data-label="MONITORING_DH_KIA_BOUGHT_WATER_SECOND_VISIT" data-unit="Liter/Woche" data-page="formPageScope" data-help="" data-precision="2"></ssc-input><ssc-input data-type="input" data-field="monitoring_kia_directhelp.{{$index}}.weekly_bought_water_liter_monitoring" data-label="MONITORING_DH_KIA_BOUGHT_WATER_THIRD_VISIT" data-unit="Liter/Woche" data-page="formPageScope" data-help="" data-precision="2"></ssc-input><div class="margcreatetop"></div></div><div ng-repeat="md in content.monitoring_kia_infomaterial track by $index"><hr ng-if="$index > 0 || content.monitoring_kia_directhelp.length > 0"><div class="margcreatetop"></div><ssc-input data-type="label" data-field="monitoring_kia_infomaterial.{{$index}}.directhelp_id" data-displayfield="directhelp.description" data-label="MONITORING_DH_KIA_INFOMATERIAL" data-unit="" is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="monitoring_kia_infomaterial.{{$index}}.usetype_id" data-options="formPageScope.content.monitoring_directhelp_usetype_kia" data-optionfield="description" data-label="MONITORING_DH_KIA_USETYPE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><div class="margcreatetop"></div></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/monitoring/monitoring/heattool.html','<ssc-heating-tool table="monitoring_heating_tool" tile-slug="MONITORING_HEATING_TOOL" route-prefix="monitoring"></ssc-heating-tool>');
$templateCache.put('templates/static/monitoring/monitoring/monitoring.html','<div data-ng-controller="monitoringController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'MONITORING_TITLE_SH\' | translate) +\' - \'+ (\'MONITORING_TITLE\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordeon1" class="accordeon"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" data-parent="#accordion1" href="#collapse1"><span data-ng-bind="\'MONITORING_GENERAL_INFORMATION\' | translate" ng-class="{\'error\': errors.general.hasError, \'warning\': !errors.general.hasError && errors.general.hasWarning}"></span></div><ssc-errorbox messages="errors.general.messages"></ssc-errorbox><div id="collapse1" class="collapse in"><div class="row"><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_DATA\' | translate"></span></div></div><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_DATA\' | translate"></span></div></div></div><div class="row margcreatetop"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_date" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_DATE\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_date.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_date" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="data.monitoring.third_visit_date" datepicker-change="save(\'monitoring\',\'third_visit_date\', data.monitoring.third_visit_date, data.monitoring.id)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div class="col-sm-1 rlabel no-padd"></div><div errorlabel="monitoring.third_visit_date" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_date" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_DATE\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_date.monitoring">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_date | date: \'dd.MM.yyyy\'"></span></div><div errorlabel="monitoring.second_visit_date" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_person_count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_PERSON_COUNT\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_person_count.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_person_count" dataobj="required"><input class="createinputter" ng-model="data.monitoring.third_visit_person_count" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'third_visit_person_count\', data.monitoring.third_visit_person_count, data.monitoring.id)"></div><div class="col-sm-1 rlabel no-padd"></div><div errorlabel="monitoring.third_visit_person_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_person_count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_PERSON_COUNT\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_person_count.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_person_count"></span></div><div errorlabel="monitoring.second_visit_person_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row margcreatebot"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_use_duration" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_USE_DURATION\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_use_duration.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_use_duration" dataobj="required"><input class="createinputter" ng-model="data.monitoring.third_visit_use_duration" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'third_visit_use_duration\', data.monitoring.third_visit_use_duration, data.monitoring.id)"></div><div class="col-sm-1 rlabel no-padd">Tage</div><div errorlabel="monitoring.third_visit_use_duration" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_use_duration" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_USE_DURATION\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_use_duration.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_use_duration"></span> <span>Tage</span></div><div errorlabel="monitoring.second_visit_use_duration" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion2" href="#collapse2"><span data-ng-bind="\'MONITORING_ENERGY\' | translate" ng-class="{\'error\': errors.electricity.hasError, \'warning\': !errors.electricity.hasError && errors.electricity.hasWarning}"></span></div><ssc-errorbox messages="errors.electricity.messages"></ssc-errorbox><div id="collapse2" class="collapse"><div class="row"><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_DATA\' | translate"></span></div></div><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_DATA\' | translate"></span></div></div></div><div class="row margcreatetop"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_energy_consumption_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_ENERGY_CONSUMPTION_YEAR\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_energy_consumption_year.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_energy_consumption_year" dataobj="required"><input class="createinputter" ng-model="data.monitoring.third_visit_energy_consumption_year" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'third_visit_energy_consumption_year\', data.monitoring.third_visit_energy_consumption_year, data.monitoring.id)"></div><div class="col-sm-1 rlabel no-padd">kWh/a</div><div errorlabel="monitoring.third_visit_energy_consumption_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_energy_consumption_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_ENERGY_CONSUMPTION_YEAR\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_energy_consumption_year.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_energy_consumption_year"></span> <span>kWh/a</span></div><div errorlabel="monitoring.second_visit_energy_consumption_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_energy_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_ENERGY_PRICE\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_energy_price.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_energy_price" dataobj="required"><input class="createinputter" ng-model="data.monitoring.third_visit_energy_price" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'third_visit_energy_price\', data.monitoring.third_visit_energy_price, data.monitoring.id)" decimal-separator-german="" precision="4"></div><div class="col-sm-1 rlabel no-padd">\u20AC/kWh</div><div errorlabel="monitoring.third_visit_energy_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_energy_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_ENERGY_PRICE\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_energy_price.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_energy_price | decimal2comma: 4"></span> <span>\u20AC/kWh</span></div><div errorlabel="monitoring.second_visit_energy_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_energy_variation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_ENERGY_VARIATION\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_energy_variation.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.third_visit_energy_variation | decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring.third_visit_energy_variation" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_energy_cost_variation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_ENERGY_COST_VARIATION\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_energy_cost_variation.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.third_visit_energy_cost_variation| decimal2comma: 2"></span> <span>\u20AC/a</span></div><div errorlabel="monitoring.third_visit_energy_cost_variation" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"></div></div><div class="row margcreatebot"><div class="col-sm-4 ilabel" errorlabel="monitoring.explanation_variation_energy_consumption"><span data-ng-bind="\'MONITORING_EXPLANATION_VARIATION_ENERGY_CONSUMPTION\' | translate"></span> <span data-ng-if="required.monitoring.explanation_variation_energy_consumption.required">*</span></div><div class="col-sm-7" errorlabel="monitoring.explanation_variation_energy_consumption" dataobj="required"><textarea ng-model="data.monitoring.explanation_variation_energy_consumption" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'explanation_variation_energy_consumption\', data.monitoring.explanation_variation_energy_consumption, data.monitoring.id)"></textarea></div><div errorlabel="monitoring.explanation_variation_energy_consumption" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion3" href="#collapse3"><span data-ng-bind="\'MONITORING_ELECTRIC_METER\' | translate" ng-class="{\'error\': errors.electricity_meter.hasError, \'warning\': !errors.electricity_meter.hasError && errors.electricity_meter.hasWarning}"></span></div><ssc-errorbox messages="errors.electricity_meter.messages"></ssc-errorbox><div id="collapse3" class="collapse"><div class="row margcreatetop"><div class="row col-sm-12"><div errorlabel="monitoring.first_reading" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_ELECTRIC_METER_FIRST_READING\' | translate"></span> <span data-ng-if="required.monitoring.first_reading.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.first_reading" dataobj="required"><input class="createinputter" dateformat="" data-ng-model="data.monitoring.first_reading" forcedisabled="true" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div class="col-sm-1 rlabel no-padd"></div><div errorlabel="monitoring.first_reading" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-12"><div errorlabel="monitoring.first_reading_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_ELECTRIC_METER_FIRST_READING_ID\' | translate"></span> <span data-ng-if="required.monitoring.first_reading_id.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.first_reading_id" dataobj="required"><input class="createinputter" disabled="disabled" ng-model="data.monitoring.first_reading_id" forcedisabled="true" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'first_reading_id\', data.monitoring.first_reading_id, data.monitoring.id)"></div><div class="col-sm-1 rlabel no-padd"></div><div errorlabel="monitoring.first_reading_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-12"><div errorlabel="monitoring.first_reading_count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_ELECTRIC_METER_FIRST_READING_COUNT\' | translate"></span> <span data-ng-if="required.monitoring.first_reading_count.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.first_reading_count" dataobj="required"><input class="createinputter" disabled="disabled" ng-model="data.monitoring.first_reading_count" forcedisabled="true" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'first_reading_count\', data.monitoring.first_reading_count, data.monitoring.id)" decimal-separator-german="" precision="1"></div><div class="col-sm-1 rlabel no-padd">kWh</div><div errorlabel="monitoring.first_reading_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-12"><div errorlabel="monitoring.second_reading" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_ELECTRIC_METER_SECOND_READING\' | translate"></span> <span data-ng-if="required.monitoring.second_reading.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.second_reading" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="data.monitoring.second_reading" datepicker-change="save(\'monitoring\',\'second_reading\', data.monitoring.second_reading, data.monitoring.id)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div class="col-sm-1 rlabel no-padd"></div><div errorlabel="monitoring.second_reading" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-12"><div errorlabel="monitoring.second_reading_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_ELECTRIC_METER_SECOND_READING_ID\' | translate"></span> <span data-ng-if="required.monitoring.second_reading_id.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.second_reading_id" dataobj="required"><input class="createinputter" ng-model="data.monitoring.second_reading_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'second_reading_id\', data.monitoring.second_reading_id, data.monitoring.id)"></div><div class="col-sm-1 rlabel no-padd"></div><div errorlabel="monitoring.second_reading_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-12"><div errorlabel="monitoring.second_reading_count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_ELECTRIC_METER_SECOND_READING_COUNT\' | translate"></span> <span data-ng-if="required.monitoring.second_reading_count.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.second_reading_count" dataobj="required"><input class="createinputter" ng-model="data.monitoring.second_reading_count" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'second_reading_count\', data.monitoring.second_reading_count, data.monitoring.id)" decimal-separator-german="" precision="1"></div><div class="col-sm-1 rlabel no-padd">kWh</div><div errorlabel="monitoring.second_reading_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row margcreatebot"><div class="row col-sm-12"><div errorlabel="monitoring.consumption_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_ELECTRIC_METER_CONSUMPTION_YEAR\' | translate"></span> <span data-ng-if="required.monitoring.consumption_year.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.consumption_year" dataobj="required"><input class="createinputter" ng-model="data.monitoring.consumption_year" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'consumption_year\', data.monitoring.consumption_year, data.monitoring.id)"></div><div class="col-sm-1 rlabel no-padd">kWh/a</div><div errorlabel="monitoring.consumption_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion4" href="#collapse4"><span data-ng-bind="\'MONITORING_WATER\' | translate" ng-class="{\'error\': errors.water.hasError, \'warning\': !errors.water.hasError && errors.water.hasWarning}"></span></div><ssc-errorbox messages="errors.water.messages"></ssc-errorbox><div id="collapse4" class="collapse"><div class="row"><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_DATA\' | translate"></span></div></div><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_DATA\' | translate"></span></div></div></div><div class="row margcreatetop"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_water_consumption_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_WATER_CONSUMPTION_YEAR\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_water_consumption_year.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_water_consumption_year" dataobj="required"><input class="createinputter" ng-model="data.monitoring.third_visit_water_consumption_year" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'third_visit_water_consumption_year\', data.monitoring.third_visit_water_consumption_year, data.monitoring.id)" decimal-separator-german="" precision="3"></div><div class="col-sm-1 rlabel no-padd">m\xB3/a</div><div errorlabel="monitoring.third_visit_water_consumption_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_water_consumption_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_WATER_CONSUMPTION_YEAR\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_water_consumption_year.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_water_consumption_year | decimal2comma: 3"></span> <span>m\xB3/a</span></div><div errorlabel="monitoring.second_visit_water_consumption_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_water_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_WATER_PRICE\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_water_price.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_water_price" dataobj="required"><input class="createinputter" ng-model="data.monitoring.third_visit_water_price" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'third_visit_water_price\', data.monitoring.third_visit_water_price, data.monitoring.id)" decimal-separator-german="" precision="2"></div><div class="col-sm-1 rlabel no-padd">\u20AC/m\xB3</div><div errorlabel="monitoring.third_visit_water_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_water_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_WATER_PRICE\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_water_price.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_water_price | decimal2comma: 2"></span> <span>\u20AC/m\xB3</span></div><div errorlabel="monitoring.second_visit_water_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_water_variation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_WATER_VARIATION\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_water_variation.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.third_visit_water_variation | decimal2comma: 3"></span> <span>m\xB3/a</span></div><div errorlabel="monitoring.third_visit_water_variation" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_water_cost_variation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_WATER_COST_VARIATION\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_water_cost_variation.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.third_visit_water_cost_variation| decimal2comma: 2"></span> <span>\u20AC/a</span></div><div errorlabel="monitoring.third_visit_water_cost_variation" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"></div></div><div class="row margcreatebot"><div class="col-sm-4 ilabel" errorlabel="monitoring.explanation_variation_water_consumption"><span data-ng-bind="\'MONITORING_EXPLANATION_VARIATION_WATER_CONSUMPTION\' | translate"></span> <span data-ng-if="required.monitoring.explanation_variation_water_consumption.required">*</span></div><div class="col-sm-7" errorlabel="monitoring.explanation_variation_water_consumption" dataobj="required"><textarea ng-model="data.monitoring.explanation_variation_water_consumption" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'explanation_variation_water_consumption\', data.monitoring.explanation_variation_water_consumption, data.monitoring.id)"></textarea></div><div errorlabel="monitoring.explanation_variation_water_consumption" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="row" ng-show="isHeatingToolVisible()"><div class="col-sm-3 col-sm-push-9"><a class="navbar-backlink" ui-sref="ssc.check.overview.monitoringheattool"><button type="button" class="redbutton"><span data-ng-bind="\'SSC_HEATTOOL_TITLE\' | translate"></span></button></a></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion6" href="#collapse6"><span data-ng-bind="\'MONITORING_WATER_ENERGY\' | translate" ng-class="{\'error\': errors.warmwater.hasError, \'warning\': !errors.warmwater.hasError && errors.warmwater.hasWarning}"></span></div><ssc-errorbox messages="errors.warmwater.messages"></ssc-errorbox><div id="collapse6" class="collapse"><div class="row"><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_DATA\' | translate"></span></div></div><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_DATA\' | translate"></span></div></div></div><div class="row margcreatetop"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_water_energy_consumption_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_WATER_ENERGY_CONSUMPTION_YEAR\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_water_energy_consumption_year.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_water_energy_consumption_year" dataobj="required"><input class="createinputter" ng-model="data.monitoring.third_visit_water_energy_consumption_year" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'third_visit_water_energy_consumption_year\', data.monitoring.third_visit_water_energy_consumption_year, data.monitoring.id)" decimal-separator-german=""></div><div class="col-sm-1 rlabel no-padd">kWh/a</div><div errorlabel="monitoring.third_visit_water_energy_consumption_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_water_energy_consumption_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_WATER_ENERGY_CONSUMPTION_YEAR\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_water_energy_consumption_year.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_water_energy_consumption_year | decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring.second_visit_water_energy_consumption_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_water_energy_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_WATER_ENERGY_PRICE\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_water_energy_price.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_water_energy_price" dataobj="required"><input class="createinputter" ng-model="data.monitoring.third_visit_water_energy_price" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'third_visit_water_energy_price\', data.monitoring.third_visit_water_energy_price, data.monitoring.id)" decimal-separator-german="" precision="4"></div><div class="col-sm-1 rlabel no-padd">\u20AC/kWh</div><div errorlabel="monitoring.third_visit_water_energy_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_water_energy_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_WATER_ENERGY_PRICE\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_water_energy_price.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_water_energy_price | decimal2comma:4"></span> <span>\u20AC/kWh</span></div><div errorlabel="monitoring.second_visit_water_energy_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_water_energy_variation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_WATER_ENERGY_VARIATION\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_water_energy_variation.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.third_visit_water_energy_variation | decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring.third_visit_water_energy_variation" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_water_energy_cost_variation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_WATER_ENERGY_COST_VARIATION\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_water_energy_cost_variation.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.third_visit_water_energy_cost_variation| decimal2comma:2"></span> <span>\u20AC/a</span></div><div errorlabel="monitoring.third_visit_water_energy_cost_variation" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"></div></div><div class="row margcreatebot"><div class="col-sm-4 ilabel" errorlabel="monitoring.explanation_variation_warmwater_energy_consumption"><span data-ng-bind="\'MONITORING_EXPLANATION_VARIATION_HEAT_ENERGY_WATER_CONSUMPTION\' | translate"></span> <span data-ng-if="required.monitoring.explanation_variation_warmwater_energy_consumption.required">*</span></div><div class="col-sm-7" errorlabel="monitoring.explanation_variation_warmwater_energy_consumption" dataobj="required"><textarea ng-model="data.monitoring.explanation_variation_warmwater_energy_consumption" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'explanation_variation_warmwater_energy_consumption\', data.monitoring.explanation_variation_warmwater_energy_consumption, data.monitoring.id)"></textarea></div><div errorlabel="monitoring.explanation_variation_warmwater_energy_consumption" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion5" href="#collapse5"><span data-ng-bind="\'MONITORING_HEAT_ENERGY\' | translate" ng-class="{\'error\': errors.heating.hasError, \'warning\': !errors.heating.hasError && errors.heating.hasWarning}"></span></div><ssc-errorbox messages="errors.heating.messages"></ssc-errorbox><div id="collapse5" class="collapse"><div class="row"><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_DATA\' | translate"></span></div></div><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_DATA\' | translate"></span></div></div></div><div class="row margcreatetop"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_heat_energy_consumption_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_HEAT_ENERGY_CONSUMPTION_YEAR\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_heat_energy_consumption_year.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_heat_energy_consumption_year" dataobj="required"><input class="createinputter" ng-model="data.monitoring.third_visit_heat_energy_consumption_year" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'third_visit_heat_energy_consumption_year\', data.monitoring.third_visit_heat_energy_consumption_year, data.monitoring.id)" decimal-separator-german=""></div><div class="col-sm-1 rlabel no-padd">kWh/a</div><div errorlabel="monitoring.third_visit_heat_energy_consumption_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_heat_energy_consumption_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_HEAT_ENERGY_CONSUMPTION_YEAR\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_heat_energy_consumption_year.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_heat_energy_consumption_year | decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring.second_visit_heat_energy_consumption_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_heat_energy_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_HEAT_ENERGY_PRICE\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_heat_energy_price.required">*</span></div><div class="col-sm-6" errorlabel="monitoring.third_visit_heat_energy_price" dataobj="required"><input class="createinputter" ng-model="data.monitoring.third_visit_heat_energy_price" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'third_visit_heat_energy_price\', data.monitoring.third_visit_heat_energy_price, data.monitoring.id)" decimal-separator-german="" precision="4"></div><div class="col-sm-1 rlabel no-padd">\u20AC/kWh</div><div errorlabel="monitoring.third_visit_heat_energy_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"><div errorlabel="monitoring.second_visit_heat_energy_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_HEAT_ENERGY_PRICE\' | translate"></span> <span data-ng-if="required.monitoring.second_visit_heat_energy_price.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.second_visit_heat_energy_price | decimal2comma: 4"></span> <span>\u20AC/kWh</span></div><div errorlabel="monitoring.second_visit_heat_energy_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_heat_energy_variation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_HEAT_ENERGY_VARIATION\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_heat_energy_variation.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.third_visit_heat_energy_variation| decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring.third_visit_heat_energy_variation" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"></div></div><div class="row"><div class="row col-sm-6"><div errorlabel="monitoring.third_visit_heat_energy_cost_variation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_HEAT_ENERGY_COST_VARIATION\' | translate"></span> <span data-ng-if="required.monitoring.third_visit_heat_energy_cost_variation.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="data.monitoring.third_visit_heat_energy_cost_variation| decimal2comma:4"></span> <span>\u20AC/a</span></div><div errorlabel="monitoring.third_visit_heat_energy_cost_variation" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row col-sm-6"></div></div><div class="row margcreatebot"><div class="col-sm-4 ilabel" errorlabel="monitoring.explanation_variation_heat_energy_consumption"><span data-ng-bind="\'MONITORING_EXPLANATION_VARIATION_HEAT_ENERGY_CONSUMPTION\' | translate"></span> <span data-ng-if="required.monitoring.explanation_variation_heat_energy_consumption.required">*</span></div><div class="col-sm-7" errorlabel="monitoring.explanation_variation_heat_energy_consumption" dataobj="required"><textarea ng-model="data.monitoring.explanation_variation_heat_energy_consumption" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'explanation_variation_heat_energy_consumption\', data.monitoring.explanation_variation_heat_energy_consumption, data.monitoring.id)"></textarea></div><div errorlabel="monitoring.explanation_variation_heat_energy_consumption" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="field" ng-show="isPhotovoltaicVisible()"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion7" href="#collapse7"><span data-ng-bind="\'MONITORING_PHOTOVOLTAIC\' | translate" ng-class="{\'error\': errors.photovoltaic.hasError, \'warning\': !errors.photovoltaic.hasError && errors.photovoltaic.hasWarning}"></span></div><ssc-errorbox messages="errors.photovoltaic.messages"></ssc-errorbox><div class="collapse" id="collapse7"><div class="row margcreatetop"><ssc-input type="toggle" field="monitoring_photovoltaic.technical_changes" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_TECHNICAL_CHANGES"></ssc-input></div><div><ssc-input type="textarea" field="monitoring_photovoltaic.technical_changes_description" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_TECHNICAL_CHANGES_DESCRIPTION" is-text="true"></ssc-input></div><div class="row"><ssc-input type="date" field="monitoring_photovoltaic.fault_at" page="formPageScope" data-datemodeltype="days" data-dateformattype="days" label="MONITORING_PHOTOVOLTAIC_FAULT_AT"></ssc-input></div><div class="row"><ssc-input type="input" field="monitoring_photovoltaic.fault_description" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_FAULT_DESCRIPTION" is-text="true"></ssc-input></div><div class="row"><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_THIRD_VISIT_DATA\' | translate"></span></div></div><div class="row col-sm-6"><div class="flabel"><span data-ng-bind="\'MONITORING_SECOND_VISIT_DATA\' | translate"></span></div></div></div><div class="row margcreatetop"><div class="row col-sm-6"><ssc-input type="input" field="monitoring_photovoltaic.system_power" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_SYSTEM_POWER" unit="W"></ssc-input></div><div class="row col-sm-6"><ssc-input type="label" field="ssc_photovoltaic.system_power" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_SYSTEM_POWER_CHECK" unit="W"></ssc-input></div></div><div class="row"><div class="row col-sm-6"><ssc-input type="date" field="monitoring_photovoltaic.production_reading_at" page="formPageScope" data-datemodeltype="days" data-dateformattype="days" help="TIP_MONITORING_PHOTOVOLTAIC_PRODUCTION_READING_AT" label="MONITORING_PHOTOVOLTAIC_PRODUCTION_READING_AT"></ssc-input></div><div class="row col-sm-6"><div errorlabel="ssc_photovoltaic.installed_at" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_PHOTOVOLTAIC_INSTALLED_AT_CHECK\' | translate"></span></div><div class="col-sm-7 rlabel" errorlabel="ssc_photovoltaic.installed_at" dataobj="required"><span data-ng-bind="data.ssc_photovoltaic.installed_at | date: \'dd.MM.yyyy\'"></span></div></div></div><div class="row"><div class="row col-sm-6"><ssc-input type="input" field="monitoring_photovoltaic.total_production" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_TOTAL_PRODUCTION" unit="kWh"></ssc-input></div></div><div class="row"><div class="row col-sm-6"><ssc-input type="input" disabled="true" field="monitoring_photovoltaic.annual_production" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_ANNUAL_PRODUCTION" unit="kWh/a"></ssc-input></div><div class="row col-sm-6"><ssc-input type="label" field="ssc_photovoltaic.annual_production" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_ANNUAL_PRODUCTION_CHECK" unit="kWh/a"></ssc-input></div></div><div class="row"><div class="row col-sm-6"><ssc-input type="input" field="monitoring_photovoltaic.avoided_electricity_consumption" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_AVOIDED_ELECTRICITY_CONSUMPTION" unit="kWh/a"></ssc-input></div><div class="row col-sm-6"><ssc-input type="label" field="ssc_photovoltaic.avoided_electricity_consumption" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_AVOIDED_ELECTRICITY_CONSUMPTION_CHECK" unit="kWh/a"></ssc-input></div></div><div class="row"><div class="row col-sm-6"><ssc-input type="input" disabled="true" field="monitoring_photovoltaic.utilisation_rate" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_UTILISATION_RATE" unit="%"></ssc-input></div><div class="row col-sm-6"><ssc-input type="label" field="ssc_photovoltaic.utilisation_rate" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_UTILISATION_RATE_CHECK" unit="%"></ssc-input></div></div><div class="row"><div class="row col-sm-6"><ssc-input type="input" disabled="true" field="monitoring_photovoltaic.self_sufficiency_level" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_SELF_SUFFICIENCY_LEVEL" unit="%"></ssc-input></div><div class="row col-sm-6"><ssc-input type="label" field="ssc_photovoltaic.self_sufficiency_level" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_SELF_SUFFICIENCY_LEVEL_CHECK" unit="%"></ssc-input></div></div><div class="row"><div class="row col-sm-6"><ssc-input type="input" disabled="true" field="monitoring_photovoltaic.savings_euro" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_SAVINGS_EURO" unit="Euro"></ssc-input></div><div class="row col-sm-6"><ssc-input type="label" field="ssc_photovoltaic.savings_euro" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_SAVINGS_EURO_CHECK" unit="Euro"></ssc-input></div></div><div class="row"><div class="row col-sm-6"><ssc-input type="input" disabled="true" field="monitoring_photovoltaic.savings_emission" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_SAVINGS_EMISSION" unit="kgCO\u2082"></ssc-input></div><div class="row col-sm-6"><ssc-input type="label" field="ssc_photovoltaic.savings_emission" page="formPageScope" label="MONITORING_PHOTOVOLTAIC_SAVINGS_EMISSION_CHECK" unit="kgCO\u2082"></ssc-input></div></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion10" href="#collapse10"><span data-ng-bind="\'MONITORING_FURTHER_OPTIMIZATION_TIPS\' | translate" ng-class="{\'error\': errors.tips.hasError, \'warning\': !errors.tips.hasError && errors.tips.hasWarning}"></span> <span data-ng-if="required.monitoring.further_optimization_tips.required">*</span></div><ssc-errorbox messages="errors.tips.messages"></ssc-errorbox><div id="collapse10" class="collapse"><div class="row margcreatetop margcreatebot"><div class="col-sm-12" errorlabel="monitoring.further_optimization_tips" dataobj="required"><textarea ng-model="data.monitoring.further_optimization_tips" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'further_optimization_tips\', data.monitoring.further_optimization_tips, data.monitoring.id)"></textarea></div><div errorlabel="monitoring.further_optimization_tips" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion11" href="#collapse11"><span data-ng-bind="\'MONITORING_INTERNAL_NOTES\' | translate" ng-class="{\'error\': errors.notes.hasError, \'warning\': !errors.notes.hasError && errors.notes.hasWarning}"></span> <span data-ng-if="required.monitoring.internal_notes.required">*</span></div><ssc-errorbox messages="errors.notes.messages"></ssc-errorbox><div id="collapse11" class="collapse"><div class="row margcreatetop margcreatebot"><div class="col-sm-12" errorlabel="monitoring.internal_notes" dataobj="required"><textarea ng-model="data.monitoring.internal_notes" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoring\',\'internal_notes\', data.monitoring.internal_notes, data.monitoring.id)"></textarea></div><div errorlabel="monitoring.internal_notes" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/monitoring/moredevices/moredevices.html','<div data-ng-controller="monitoringMoredevicesController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'MONITORING_MOREDEVICES_TITLE_SH\' | translate) +\' - \'+ (\'MONITORING_MOREDEVICES_TITLE\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div ng-repeat="md in data.monitoring_moredevices track by $index"><div id="accordeon1" class="accordeon"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" data-parent="#accordion1" href="#collapse{{$index}}"><span data-ng-bind="(\'MONITORING_DEVICE_FURTHER_DEVICES\' | translate) + \' \' + {{$index + 1}}"></span></div><div class="row" ng-show="showerrorboxlistna1[\'\'+{{$index}}]"><div class="col-sm-12"><div class="errorfield margcreatebot ng-scope"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate" class="ng-binding">Bitte alle Felder korrekt ausf\xFCllen</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.monitoring_moredevices"><div ng-repeat="(subkey, subvalue) in required.monitoring_moredevices[key]"><div ng-if="subvalue.error != null">{{$parent.$parent.$parent.showerrorboxlistna1[\'\'+$parent.$parent.$index]=1; subvalue.error;}}</div><div ng-if="subvalue.warning != null">{{$parent.$parent.$parent.showerrorboxlistna1[\'\'+$parent.$parent.$index]=1; subvalue.warning;}}</div></div></div></div></div></div></div></div><div id="collapse{{$index}}" class="collapse" data-ng-class="{\'in\': (openCollapse.indexOf(\'collapse{{$index}}\')!=-1)}"><div class="row margcreatetop"><div errorlabel="monitoring_moredevices.{{$index}}.category" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_DEVICE_CATEGORY\' | translate"></span> <span data-ng-if="required.monitoring_moredevices[$index].category.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="getCategory(md.category)"></span></div><div errorlabel="monitoring_moredevices.{{$index}}.category" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_moredevices.{{$index}}.type" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_DEVICE_TYPE\' | translate"></span> <span data-ng-if="required.monitoring_moredevices[$index].type.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="getType(md.type)"></span></div><div errorlabel="monitoring_moredevices.{{$index}}.type" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_moredevices.{{$index}}.room" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_DEVICE_ROOM\' | translate"></span> <span data-ng-if="required.monitoring_moredevices[$index].room.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="getRoom(md.room)"></span></div><div errorlabel="monitoring_moredevices.{{$index}}.room" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_moredevices.{{$index}}.possible_savings_energy" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_DEVICE_POSSIBLE_SAVINGS_ENERGY\' | translate"></span> <span data-ng-if="required.monitoring_moredevices[$index].possible_savings_energy.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="md.possible_savings_energy | decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring_moredevices.{{$index}}.possible_savings_energy" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_moredevices.{{$index}}.tip_realized_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_DEVICE_TIP_REALIZED\' | translate"></span> <span data-ng-if="required.monitoring_moredevices[$index].tip_realized_id.required">*</span></div><div class="col-sm-7" errorlabel="monitoring_moredevices.{{$index}}.tip_realized_id" dataobj="required"><select class="createdropper" ng-model="md.tip_realized_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringmoredevices\',\'tip_realized_id\', md.tip_realized_id, md.id)"><option value=""></option><option ng-repeat="item in data.monitoring_yes_no_changed_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="monitoring_moredevices.{{$index}}.tip_realized_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div data-ng-if="(md.tip_realized_id == 3)"><div class="row"><div errorlabel="monitoring_moredevices.{{$index}}.different_realization_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_DEVICE_DIFFERENT_REALIZATION\' | translate"></span> <span data-ng-if="required.monitoring_moredevices[$index].different_realization_id.required">*</span></div><div class="col-sm-7" errorlabel="monitoring_moredevices.{{$index}}.different_realization_id" dataobj="required"><select class="createdropper" ng-model="md.different_realization_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringmoredevices\',\'different_realization_id\', md.different_realization_id, md.id)"><option value=""></option><option ng-repeat="item in data.monitoring_different_realization" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="monitoring_moredevices.{{$index}}.different_realization_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_moredevices.{{$index}}.different_realization_current_saving" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_DEVICE_DIFFERENT_REALIZATION_CURRENT_SAVING\' | translate"></span> <span data-ng-if="required.monitoring_moredevices[$index].different_realization_current_saving.required">*</span></div><div class="col-sm-6" errorlabel="monitoring_moredevices.{{$index}}.different_realization_current_saving" dataobj="required"><input class="createinputter" ng-model="md.different_realization_current_saving" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringmoredevices\',\'different_realization_current_saving\', md.different_realization_current_saving, md.id)"></div><div class="col-sm-1 ilabel">kWh/a</div><div errorlabel="monitoring_moredevices.{{$index}}.different_realization_current_saving" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div data-ng-if="(md.tip_realized_id == 1 || md.tip_realized_id == 2)"><div class="row"><div errorlabel="monitoring_moredevices.{{$index}}.tip_realized_current_saving" dataobj="required" class="col-sm-4 ilabel"><span data-ng-if="(md.tip_realized_id == 1)" data-ng-bind="\'MONITORING_DEVICE_TIP_REALIZED_CURRENT_SAVING\' | translate"></span> <span data-ng-if="(md.tip_realized_id != 1)" data-ng-bind="\'MONITORING_DEVICE_TIP_NOT_REALIZED_CURRENT_SAVING\' | translate"></span> <span data-ng-if="required.monitoring_moredevices[$index].tip_realized_current_saving.required">*</span></div><div class="col-sm-7 rlabel"><span data-ng-bind="md.tip_realized_current_saving | decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring_moredevices.{{$index}}.tip_realized_current_saving" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="margcreatebot"></div></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/monitoring/question/question.html','<div data-ng-controller="monitoringQuestionController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'MONITORING_QUESTION_TITLE_SH\' | translate) +\' - \'+ (\'MONITORING_QUESTION_TITLE\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordeon1" class="accordeon"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" data-parent="#accordion1" href="#collapse1"><span data-ng-bind="\'MONITORING_QUESTION_MOST_IMPORTANT_REASON\' | translate"></span></div><div id="collapse1" class="collapse in"><div class="row" ng-show="showerrorbox1"><div class="col-sm-12"><div class="errorfield margcreatebot ng-scope"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate" class="ng-binding">Bitte alle Felder korrekt ausf\xFCllen5</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.monitoring_most_important_reason"><div ng-if="key == \'reduce_energy_costs\' || key == \'get_dh\' || key == \'preserve_climate\' || key == \'get_energy_tips\'"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox1 = 1; value.error;}}</div><div class="warning" ng-if="value.warning != null"><span>{{$parent.$parent.$parent.showerrorbox1 = 1; value.warning;}}</span></div></div></div></div></div></div></div></div><div class="margcreatetop"></div><div class="row"><div errorlabel="monitoring_most_important_reason.reduce_energy_costs" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_REDUCE_ENERGY_COSTS\' | translate"></span> <span data-ng-if="required.monitoring_most_important_reason.reduce_energy_costs.required">*</span></div><div class="col-sm-7 padd-checkbox" errorlabel="monitoring_most_important_reason.reduce_energy_costs" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_most_important_reason.reduce_energy_costs" value="data.monitoring_most_important_reason.reduce_energy_costs" id="reduce_energy_costs" ng-checked="data.monitoring_most_important_reason.reduce_energy_costs === 1" ng-change="save(\'monitoringmostimportantreason\', \'reduce_energy_costs\', data.monitoring_most_important_reason.reduce_energy_costs,data.monitoring_most_important_reason.id)" ng-click="resetValues(\'reduce_energy_costs\', data.monitoring_most_important_reason.reduce_energy_costs)"> <label class="checklabel" for="reduce_energy_costs"></label> <span data-ng-bind="data.monitoring_most_important_reason.reduce_energy_costs === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row"><div errorlabel="monitoring_most_important_reason.get_dh" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_GET_DH\' | translate"></span> <span data-ng-if="required.monitoring_most_important_reason.get_dh.required">*</span></div><div class="col-sm-7 padd-checkbox" errorlabel="monitoring_most_important_reason.get_dh" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_most_important_reason.get_dh" value="data.monitoring_most_important_reason.get_dh" id="get_dh" ng-checked="data.monitoring_most_important_reason.get_dh === 1" ng-change="save(\'monitoringmostimportantreason\', \'get_dh\', data.monitoring_most_important_reason.get_dh, data.monitoring_most_important_reason.id)" ng-click="resetValues(\'get_dh\', data.monitoring_most_important_reason.get_dh)"> <label class="checklabel" for="get_dh"></label> <span data-ng-bind="data.monitoring_most_important_reason.get_dh === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row"><div errorlabel="monitoring_most_important_reason.preserve_climate" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_PRESERE_CLIMATE\' | translate"></span> <span data-ng-if="required.monitoring_most_important_reason.preserve_climate.required">*</span></div><div class="col-sm-7 padd-checkbox" errorlabel="monitoring_most_important_reason.preserve_climate" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_most_important_reason.preserve_climate" value="data.monitoring_most_important_reason.preserve_climate" id="preserve_climate" ng-checked="data.monitoring_most_important_reason.preserve_climate === 1" ng-change="save(\'monitoringmostimportantreason\', \'preserve_climate\', data.monitoring_most_important_reason.preserve_climate, data.monitoring_most_important_reason.id)" ng-click="resetValues(\'preserve_climate\', data.monitoring_most_important_reason.preserve_climate)"> <label class="checklabel" for="preserve_climate"></label> <span data-ng-bind="data.monitoring_most_important_reason.preserve_climate === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row"><div errorlabel="monitoring_most_important_reason.get_energy_tips" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_GET_ENERGY_TIPS\' | translate"></span> <span data-ng-if="required.monitoring_most_important_reason.get_energy_tips.required">*</span></div><div class="col-sm-7 padd-checkbox" errorlabel="monitoring_most_important_reason.get_energy_tips" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_most_important_reason.get_energy_tips" value="data.monitoring_most_important_reason.get_energy_tips" id="get_energy_tips" ng-checked="data.monitoring_most_important_reason.get_energy_tips === 1" ng-change="save(\'monitoringmostimportantreason\', \'get_energy_tips\', data.monitoring_most_important_reason.get_energy_tips,data.monitoring_most_important_reason.id)" ng-click="resetValues(\'get_energy_tips\', data.monitoring_most_important_reason.get_energy_tips)"> <label class="checklabel" for="get_energy_tips"></label> <span data-ng-bind="data.monitoring_most_important_reason.get_energy_tips === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="monitoring_most_important_reason.get_energy_tips" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion2" href="#collapse2"><span data-ng-bind="\'MONITORING_QUESTION_COMFORT_USER_BEHAVIOUR_DEVICE_PORTFOLIO_CHANGES\' | translate"></span></div><div id="collapse2" class="collapse"><div class="row" ng-show="showerrorbox2"><div class="col-sm-12"><div class="errorfield margcreatebot ng-scope"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate" class="ng-binding">Bitte alle Felder korrekt ausf\xFCllen6</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.monitoring_questions"><div ng-if="key == \'power_off_multiple_socket_outlet_id\' || key == \'save_energy_water_after_ssc_id\' || key == \'new_refrigerator_within_local_id\' || key == \'other_new_devices_id\' || key == \'refrigerator\' || key == \'freezer\' || key == \'bulb\' || key == \'torchiere\' || key == \'tumbler\' || key == \'other\' || key == \'devices_disposed_id\' || key == \'refrigerator_old\' || key == \'freezer_old\' || key == \'bulb_old\' || key == \'torchiere_old\' || key == \'tumbler_old\' || key == \'other_old\' || key == \'other_info_old\'"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox2 = 1; value.error;}}</div><div class="warning" ng-if="value.warning != null"><span>{{$parent.$parent.$parent.showerrorbox2 = 1; value.warning;}}</span></div></div></div></div></div></div></div></div><div class="row margcreatetop"><div errorlabel="monitoring_questions.power_off_multiple_socket_outlet_id" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_POWER_OFF_MULTIPLE_SOCKET_OUTLET\' | translate"></span> <span data-ng-if="required.monitoring_questions.power_off_multiple_socket_outlet_id.required">*</span></div><div class="col-sm-4" errorlabel="monitoring_questions.power_off_multiple_socket_outlet_id" dataobj="required"><select class="createdropper" ng-model="data.monitoring_questions.power_off_multiple_socket_outlet_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'power_off_multiple_socket_outlet_id\', data.monitoring_questions.power_off_multiple_socket_outlet_id, data.monitoring_questions.id)"><option value=""></option><option ng-repeat="item in data.monitoring_switch_off_device" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="monitoring_questions.power_off_multiple_socket_outlet_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_questions.save_energy_water_after_ssc_id" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_SAVE_ENERGY_WATER_AFTER_SSC_GUIDANCE\' | translate"></span> <span data-ng-if="required.monitoring_questions.save_energy_water_after_ssc_id.required">*</span></div><div class="col-sm-4" errorlabel="monitoring_questions.save_energy_water_after_ssc_id" dataobj="required"><select class="createdropper" ng-model="data.monitoring_questions.save_energy_water_after_ssc_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'save_energy_water_after_ssc_id\', data.monitoring_questions.save_energy_water_after_ssc_id, data.monitoring_questions.id)"><option value=""></option><option ng-repeat="item in data.monitoring_yes_st_no_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="monitoring_questions.save_energy_water_after_ssc_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_questions.other_new_devices_id" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_OTHER_NEW_DEVICES\' | translate"></span> <span data-ng-if="required.monitoring_questions.other_new_devices_id.required">*</span></div><div class="col-sm-4" errorlabel="monitoring_questions.other_new_devices_id" dataobj="required"><select class="createdropper" ng-model="data.monitoring_questions.other_new_devices_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'other_new_devices_id\', data.monitoring_questions.other_new_devices_id, data.monitoring_questions.id)"><option value=""></option><option ng-repeat="item in data.monitoring_yes_no_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="monitoring_questions.other_new_devices_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_questions.kind_of_new_devices_id" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_KIND_OF_NEW_DEVICES\' | translate"></span> <span data-ng-if="required.monitoring_questions.kind_of_new_devices_id.required">*</span></div><div class="col-sm-4" errorlabel="monitoring_questions.kind_of_new_devices_id" dataobj="required"><div ng-model="data.monitoring_questions.kind_of_new_devices_id"><div class="row col-sm-6 no-padd"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_REFRIGERATOR\' | translate"></span><br><span data-ng-bind="\'MONITORING_QUESTION_DISCLAIMER_BMU\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.refrigerator" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.refrigerator" value="data.monitoring_new_devices_type.refrigerator" id="refrigerator" ng-checked="data.monitoring_new_devices_type.refrigerator === 1" ng-change="save(\'monitoringnewdevicestype\', \'refrigerator\', data.monitoring_new_devices_type.refrigerator, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="refrigerator"></label> <span data-ng-bind="data.monitoring_new_devices_type.refrigerator === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-6 no-padd"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_FREEZER\' | translate"></span><br><span data-ng-bind="\'MONITORING_QUESTION_DISCLAIMER_BMU\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.freezer" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.freezer" value="data.monitoring_new_devices_type.freezer" id="freezer" ng-checked="data.monitoring_new_devices_type.freezer === 1" ng-change="save(\'monitoringnewdevicestype\', \'freezer\', data.monitoring_new_devices_type.freezer, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="freezer"></label> <span data-ng-bind="data.monitoring_new_devices_type.freezer === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-6 no-padd padd-checkbox breakword"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_BULB\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.bulb" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.bulb" value="data.monitoring_new_devices_type.bulb" id="bulb" ng-checked="data.monitoring_new_devices_type.bulb === 1" ng-change="save(\'monitoringnewdevicestype\', \'bulb\', data.monitoring_new_devices_type.bulb, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="bulb"></label> <span data-ng-bind="data.monitoring_new_devices_type.bulb === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-6 no-padd padd-checkbox breakword"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_TORCHIERE\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.torchiere" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.torchiere" value="data.monitoring_new_devices_type.torchiere" id="torchiere" ng-checked="data.monitoring_new_devices_type.torchiere === 1" ng-change="save(\'monitoringnewdevicestype\', \'torchiere\', data.monitoring_new_devices_type.torchiere, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="torchiere"></label> <span data-ng-bind="data.monitoring_new_devices_type.torchiere === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-6 no-padd padd-checkbox breakword"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_TUMBLER\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.tumbler" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.tumbler" value="data.monitoring_new_devices_type.tumbler" id="tumbler" ng-checked="data.monitoring_new_devices_type.tumbler === 1" ng-change="save(\'monitoringnewdevicestype\', \'tumbler\', data.monitoring_new_devices_type.tumbler, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="tumbler"></label> <span data-ng-bind="data.monitoring_new_devices_type.tumbler === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-6 no-padd padd-checkbox breakword"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_OTHER\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.other" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.other" value="data.monitoring_new_devices_type.other" id="other" ng-checked="data.monitoring_new_devices_type.other === 1" ng-change="save(\'monitoringnewdevicestype\', \'other\', data.monitoring_new_devices_type.other, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="other"></label> <span data-ng-bind="data.monitoring_new_devices_type.other === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-offset-12 col-sm-12 no-padd padd-checkbox" id="other_info" errorlabel="monitoring_new_devices_type.other_info" dataobj="required"><input ng-app="" class="createinputter" ng-model="data.monitoring_new_devices_type.other_info" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringnewdevicestype\', \'other_info\', data.monitoring_new_devices_type.other_info, data.monitoring_new_devices_type.id)"></div></div></div><div errorlabel="monitoring_questions.kind_of_new_devices_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_questions.devices_disposed_id" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_DEVICES_DISPOSED\' | translate"></span> <span data-ng-if="required.monitoring_questions.devices_disposed_id.required">*</span></div><div class="col-sm-4" errorlabel="monitoring_questions.devices_disposed_id" dataobj="required"><select class="createdropper" ng-model="data.monitoring_questions.devices_disposed_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'devices_disposed_id\', data.monitoring_questions.devices_disposed_id, data.monitoring_questions.id)"><option value=""></option><option ng-repeat="item in data.monitoring_yes_no_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="monitoring_questions.devices_disposed_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="monitoring_questions.monitoring_new_devices_type" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_KIND_OF_DISPOSED_DEVICES\' | translate"></span> <span data-ng-if="required.monitoring_questions.kind_of_disposed_devices_id.required">*</span></div><div class="col-sm-4"><div ng-model="data.monitoring_questions.kind_of_disposed_devices_id"><div class="row col-sm-6 no-padd"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_REFRIGERATOR\' | translate"></span><br><span data-ng-bind="\'MONITORING_QUESTION_DISCLAIMER_BMU\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.refrigerator_old" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.refrigerator_old" value="data.monitoring_new_devices_type.refrigerator_old" id="old_refrigerator" ng-checked="data.monitoring_new_devices_type.refrigerator_old == 1" ng-change="save(\'monitoringnewdevicestype\', \'refrigerator_old\', data.monitoring_new_devices_type.refrigerator_old, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="old_refrigerator"></label> <span data-ng-bind="data.monitoring_new_devices_type.refrigerator_old === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-6 no-padd"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_FREEZER\' | translate"></span><br><span data-ng-bind="\'MONITORING_QUESTION_DISCLAIMER_BMU\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.freezer_old" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.freezer_old" value="data.monitoring_new_devices_type.freezer_old" id="old_freezer" ng-checked="data.monitoring_new_devices_type.freezer_old === 1" ng-change="save(\'monitoringnewdevicestype\', \'freezer_old\', data.monitoring_new_devices_type.freezer_old, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="old_freezer"></label> <span data-ng-bind="data.monitoring_new_devices_type.freezer_old === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-6 no-padd padd-checkbox breakword"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_BULB\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.bulb_old" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.bulb_old" value="data.monitoring_new_devices_type.bulb_old" id="old_bulb" ng-checked="data.monitoring_new_devices_type.bulb_old === 1" ng-change="save(\'monitoringnewdevicestype\', \'bulb_old\', data.monitoring_new_devices_type.bulb_old, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="old_bulb"></label> <span data-ng-bind="data.monitoring_new_devices_type.bulb_old === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-6 no-padd padd-checkbox breakword"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_TORCHIERE\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.torchiere_old" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.torchiere_old" value="data.monitoring_new_devices_type.torchiere_old" id="old_torchiere" ng-checked="data.monitoring_new_devices_type.torchiere_old === 1" ng-change="save(\'monitoringnewdevicestype\', \'torchiere_old\', data.monitoring_new_devices_type.torchiere_old, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="old_torchiere"></label> <span data-ng-bind="data.monitoring_new_devices_type.torchiere_old === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-6 no-padd padd-checkbox breakword"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_TUMBLER\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.tumbler_old" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.tumbler_old" value="data.monitoring_new_devices_type.tumbler_old" id="old_tumbler" ng-checked="data.monitoring_new_devices_type.tumbler_old === 1" ng-change="save(\'monitoringnewdevicestype\', \'tumbler_old\', data.monitoring_new_devices_type.tumbler_old, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="old_tumbler"></label> <span data-ng-bind="data.monitoring_new_devices_type.tumbler_old === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-6 no-padd padd-checkbox breakword"><span class="checklabelAddInfo" data-ng-bind="\'MONITORING_QUESTION_OTHER\' | translate"></span></div><div class="row col-sm-6 no-padd padd-checkbox" errorlabel="monitoring_new_devices_type.other_old" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.monitoring_new_devices_type.other_old" value="data.monitoring_new_devices_type.other_old" id="old_other" ng-checked="data.monitoring_new_devices_type.other_old === 1" ng-change="save(\'monitoringnewdevicestype\', \'other_old\', data.monitoring_new_devices_type.other_old, data.monitoring_new_devices_type.id)"> <label class="checklabel" for="old_other"></label> <span data-ng-bind="data.monitoring_new_devices_type.other_old === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div class="row col-sm-offset-12 col-sm-12 no-padd padd-checkbox" id="old_other_info" errorlabel="monitoring_new_devices_type.other_info_old" dataobj="required"><input ng-app="" class="createinputter" ng-model="data.monitoring_new_devices_type.other_info_old" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringnewdevicestype\', \'other_info_old\', data.monitoring_new_devices_type.other_info_old, data.monitoring_new_devices_type.id)"></div></div></div><div errorlabel="monitoring_questions.monitoring_new_devices_type" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion3" href="#collapse3"><span data-ng-bind="\'MONITORING_QUESTION_EVALUATION_SSC\' | translate"></span></div><div id="collapse3" class="collapse"><div class="row" ng-show="showerrorbox3"><div class="col-sm-12"><div class="errorfield margcreatebot ng-scope"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate" class="ng-binding">Bitte alle Felder korrekt ausf\xFCllen7</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.monitoring_questions"><div ng-if="key == \'counselling_interview_importance_id\' || key == \'counselling_interview_unimportant_info\' || key == \'recommendation_ssc_id\' || key == \'recommendation_ssc_info\' || key == \'measured_up_to_expectations_id\'"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox3 = 1; value.error;}}</div><div class="warning" ng-if="value.warning != null"><span>{{$parent.$parent.$parent.showerrorbox3 = 1; value.warning;}}</span></div></div></div></div></div></div></div></div><div class="row margcreatetop"><div errorlabel="monitoring_questions.counselling_interview_importance_id" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_COUNSELLING_INTERVIEW_IMPORTANCE\' | translate"></span> <span data-ng-if="required.monitoring_questions.counselling_interview_importance_id.required">*</span></div><div class="col-sm-4" errorlabel="monitoring_questions.counselling_interview_importance_id" dataobj="required"><select class="createdropper" ng-model="data.monitoring_questions.counselling_interview_importance_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'counselling_interview_importance_id\', data.monitoring_questions.counselling_interview_importance_id, data.monitoring_questions.id)"><option value=""></option><option ng-repeat="item in data.monitoring_importance" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="monitoring_questions.counselling_interview_importance_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_questions.counselling_interview_unimportant_info" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_COUNSELLING_INTERVIEW_UNIMPORTANT_INFO\' | translate"></span> <span data-ng-if="required.monitoring_questions.counselling_interview_unimportant_info.required">*</span></div><div class="col-sm-4" errorlabel="monitoring_questions.counselling_interview_unimportant_info"><textarea dataobj="required" ng-model="data.monitoring_questions.counselling_interview_unimportant_info" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'counselling_interview_unimportant_info\', data.monitoring_questions.counselling_interview_unimportant_info, data.monitoring_questions.id)"></textarea></div><div errorlabel="monitoring_questions.counselling_interview_unimportant_info" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_questions.recommendation_ssc_id" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_RECOMMENDATION_SSC\' | translate"></span> <span data-ng-if="required.monitoring_questions.recommendation_ssc_id.required">*</span></div><div class="col-sm-4" errorlabel="monitoring_questions.recommendation_ssc_id" dataobj="required"><select class="createdropper" ng-model="data.monitoring_questions.recommendation_ssc_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'recommendation_ssc_id\', data.monitoring_questions.recommendation_ssc_id, data.monitoring_questions.id)"><option value=""></option><option ng-repeat="item in data.monitoring_yes_no_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="monitoring_questions.recommendation_ssc_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_questions.recommendation_ssc_info" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_NO_RECOMMENDATION_SSC_INFO\' | translate"></span> <span data-ng-if="required.monitoring_questions.recommendation_ssc_info.required">*</span></div><div class="col-sm-4" errorlabel="monitoring_questions.recommendation_ssc_info" dataobj="required"><textarea ng-model="data.monitoring_questions.recommendation_ssc_info" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'recommendation_ssc_info\', data.monitoring_questions.recommendation_ssc_info, data.monitoring_questions.id)"></textarea></div><div errorlabel="monitoring_questions.recommendation_ssc_info" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="monitoring_questions.measured_up_to_expectations_id" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_QUESTION_MEASURED_UP_TO_EXPECTATIONS\' | translate"></span> <span data-ng-if="required.monitoring_questions.measured_up_to_expectations_id.required">*</span></div><div class="col-sm-4" errorlabel="monitoring_questions.measured_up_to_expectations_id" dataobj="required"><select class="createdropper" ng-model="data.monitoring_questions.measured_up_to_expectations_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'measured_up_to_expectations_id\', data.monitoring_questions.measured_up_to_expectations_id, data.monitoring_questions.id)"><option value=""></option><option ng-repeat="item in data.monitoring_one_to_six" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="monitoring_questions.measured_up_to_expectations_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><h4 class="margincreatetop" data-ng-bind="\'MONITORING_QUESTION_TOP_TIPS\' | translate" ng-if="data.ssc_advice.length > 0"></h4><div class="field" ng-repeat="(index, advice) in data.ssc_advice"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed box" data-toggle="collapse" data-parent="#accordion-tips-{{index}}" href="#collapse-tips-{{index}}"><div class="row"><div errorlabel="ssc_advice.{{index}}.adjustment_id" class="col-sm-4 no-padd padd-label"><span ng-bind="\'SSC_ADVICE_HEADER\' | translate"></span>&nbsp;{{index + 1}}:&nbsp; <span ng-if="advice.advice_type">{{advice.advice_type}}</span> <span ng-if="!advice.advice_type" ng-bind="\'SSC_ADVICE_CUSTOM\' | translate"></span></div><div class="col-sm-7" errorlabel="ssc_advice.{{index}}.adjustment_id" dataobj="required"><select class="createdropper em-1 weight-normal" ng-model="advice.adjustment_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'adviceadjustment\', \'adjustment_id\', advice.adjustment_id, advice.id)" ng-click="$event.stopPropagation()"><option value=""></option><option ng-repeat="item in data.ssc_advice_adjustment" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div></div><div id="collapse-tips-{{index}}" class="collapse"><div class="row"><div class="row"><div class="col-sm-12 advice-text"><p><span ng-if="advice.title"><b>{{advice.title}}</b><br></span> <span ng-bind-html="advice.description"></span></p></div></div></div></div></div><div class="field margcreatetop"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion23" href="#collapse23"><span data-ng-bind="\'MONITORING_QUESTION_SITUATION_INFORMATION\' | translate"></span></div><div id="collapse23" class="collapse"><div class="row" ng-show="showerrorbox23"><div class="col-sm-12"><div class="errorfield margcreatebot ng-scope"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate" class="ng-binding">Bitte alle Felder korrekt ausf\xFCllen3</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-if="key == \'situation_information\'"><div ng-repeat="(key, value) in required.monitoring_questions"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox23 = 1; value.error;}}</div><div class="warning" ng-if="value.warning != null">{{$parent.$parent.$parent.showerrorbox23 = 1; value.warning;}}</div></div></div></div></div></div></div></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12" errorlabel="monitoring_questions.situation_information" dataobj="required"><textarea ng-model="data.monitoring_questions.situation_information" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'situation_information\', data.monitoring_questions.situation_information, data.monitoring_questions.id)"></textarea></div></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion24" href="#collapse24"><span data-ng-bind="\'MONITORING_QUESTION_SITUATION_INTERNAL_NOTES\' | translate"></span></div><div id="collapse24" class="collapse"><div class="row" ng-show="showerrorbox24"><div class="col-sm-12"><div class="errorfield margcreatebot ng-scope"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate" class="ng-binding">Bitte alle Felder korrekt ausf\xFCllen4</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.monitoring_questions"><div ng-if="key == \'situation_internal_notes\'"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox24 = 1; value.error;}}</div><div class="warning" ng-if="value.warning != null">{{$parent.$parent.$parent.showerrorbox24 = 1; value.warning;}}</div></div></div></div></div></div></div></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12" errorlabel="monitoring_questions.situation_internal_notes" dataobj="required"><textarea ng-model="data.monitoring_questions.situation_internal_notes" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'monitoringquestions\', \'situation_internal_notes\', data.monitoring_questions.situation_internal_notes, data.monitoring_questions.id)"></textarea></div></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/monitoring/success/success.html','<div data-ng-controller="monitoringSuccessController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'MONITORING_SUCCESS_TITLE_SH\' | translate) +\' - \'+ (\'MONITORING_SUCCESS_TITLE\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordeon1" class="accordeon"><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle" data-toggle="collapse" data-parent="#accordion1" href="#collapse1"><span data-ng-bind="\'MONITORING_SUCCESS_SAVING_TOTAL\' | translate"></span></div><div class="row" ng-show="showerrorbox1"><div class="col-sm-12"><div class="errorfield margcreatebot ng-scope"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate" class="ng-binding">Bitte alle Felder korrekt ausf\xFCllen</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.monitoring_success"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox1 = 1; value.error;}}</div><div ng-if="value.warning != null"><span>{{$parent.$parent.$parent.showerrorbox1 = 1; value.warning;}}</span></div></div></div></div></div></div></div><div id="collapse1" class="collapse in"><div class="row margcreatetop"><div errorlabel="monitoring_success.saving_dh_sum" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_SAVING_DH_SUM\' | translate"></span> <span data-ng-if="required.monitoring_success.saving_dh_sum.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.saving_dh_sum | decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring_success.saving_dh_sum" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.saving_tips_sum" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_SAVING_TIPS_SUM\' | translate"></span> <span data-ng-if="required.monitoring_success.saving_tips_sum.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.saving_tips_sum"></span> <span>kWh/a</span></div><div errorlabel="monitoring_success.saving_tips_sum" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.saving_total_energy_electrical_water_tips_sum" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_SAVING_TOTAL_ENERGY_ELECTRICAL_WATER_TIPS_SUM\' | translate"></span> <span data-ng-if="required.monitoring_success.saving_total_energy_electrical_water_tips_sum.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.saving_total_energy_electrical_water_tips_sum | decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring_success.saving_total_energy_electrical_water_tips_sum" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.saving_water_sum" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_SAVING_WATER_SUM\' | translate"></span> <span data-ng-if="required.monitoring_success.saving_water_sum.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.saving_water_sum | decimal2comma:3"></span> <span>m\xB3/a</span></div><div errorlabel="monitoring_success.saving_water_sum" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.saving_nonelectrical_water_sum" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_SAVING_NONELECTRICAL_WATER_SUM\' | translate"></span> <span data-ng-if="required.monitoring_success.saving_nonelectrical_water_sum.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.saving_nonelectrical_water_sum | decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring_success.saving_nonelectrical_water_sum" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.saving_electrical_water_sum" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_SAVING_ELECTRICAL_WATER_SUM\' | translate"></span> <span data-ng-if="required.monitoring_success.saving_electrical_water_sum.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.saving_electrical_water_sum | decimal2comma"></span> <span>kWh/a</span></div><div errorlabel="monitoring_success.saving_electrical_water_sum" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.saving_space_heating" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_SAVING_SPACE_HEATING\' | translate"></span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.saving_space_heating | decimal2comma"></span> <span>kWh/a</span></div></div><div class="margcreatebot"></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse2"><span data-ng-bind="\'MONITORING_SUCCESS_FINANCIAL_TOTAL\' | translate"></span></div><div class="row" ng-show="showerrorbox2"><div class="col-sm-12"><div class="errorfield margcreatebot ng-scope"><div class="row hlabel"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> <span data-ng-bind="\'FORM_ERROR_TITLE\' | translate" class="ng-binding">Bitte alle Felder korrekt ausf\xFCllen</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.monitoring_success"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox2 = 1; value.error;}}</div><div ng-if="value.warning != null"><span>{{$parent.$parent.$parent.showerrorbox2 = 1; value.warning;}}</span></div></div></div></div></div></div></div><div id="collapse2" class="collapse"><div class="row margcreatetop"><div errorlabel="monitoring_success.financial_energy_dh" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_FINANCIAL_ENERGY_DH\' | translate"></span> <span data-ng-if="required.monitoring_success.financial_energy_dh.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.financial_energy_dh | decimal2comma:2"></span> <span>\u20AC/a</span></div><div errorlabel="monitoring_success.financial_energy_dh" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.financial_energy_tips" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_FINANCIAL_ENERGY_TIPS\' | translate"></span> <span data-ng-if="required.monitoring_success.financial_energy_tips.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.financial_energy_tips | decimal2comma:2"></span> <span>\u20AC/a</span></div><div errorlabel="monitoring_success.financial_energy_tips" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.financial_energy_dh_water_tips" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_FINANCIAL_ENERGY_DH_WATER_TIPS\' | translate"></span> <span data-ng-if="required.monitoring_success.financial_energy_dh_water_tips.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.financial_energy_dh_water_tips | decimal2comma:2"></span> <span>\u20AC/a</span></div><div errorlabel="monitoring_success.financial_energy_dh_water_tips" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.financial_energy_heating" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_FINANCIAL_ENERGY_HEATING\' | translate"></span> <span data-ng-if="required.monitoring_success.financial_energy_heating.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.financial_energy_heating | decimal2comma:2"></span> <span>\u20AC/a</span></div><div errorlabel="monitoring_success.financial_energy_heating" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.financial_energy_water" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_FINANCIAL_ENERGY_WATER\' | translate"></span> <span data-ng-if="required.monitoring_success.financial_energy_water.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.financial_energy_water | decimal2comma:2"></span> <span>\u20AC/a</span></div><div errorlabel="monitoring_success.financial_energy_water" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.financial_bottled_water" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_FINANCIAL_BOTTLED_WATER\' | translate"></span> <span data-ng-if="required.monitoring_success.financial_bottled_water.required">*</span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.financial_bottled_water | decimal2comma:2"></span> <span>\u20AC/a</span></div><div errorlabel="monitoring_success.financial_bottled_water" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="monitoring_success.financial_energy_space_heating" dataobj="required" class="col-sm-7 ilabel"><span data-ng-bind="\'MONITORING_SUCCESS_FINANCIAL_ENERGY_SPACE_HEATING\' | translate"></span></div><div class="col-sm-4 rlabel"><span data-ng-bind="data.monitoring_success.financial_energy_space_heating | decimal2comma"></span> <span>\u20AC/a</span></div></div><div class="margcreatebot"></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/abstract/abstract.html','<div data-ng-controller="abstractController" class="ssc-summary"><h4 ng-if="data.is_telephone" ng-bind="\'SSC_ABSTRACT_TELEPHONE_WARNING\' | translate"></h4><div id="accordeon1" ng-if="!data.is_telephone"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion1" href="#collapse1"><span data-ng-bind="(\'SSC_ABSTRACT_TITLE\' | translate)"></span></div><div id="collapse1" class="collapse in"><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_KIA\' | translate)"></span></div></div><table class="ilabel"><thead><tr><th><span data-ng-bind="\'SSC_ABSTRACT_KIA_DIRECTHELP\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_USED\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_COST\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_EMISSION_SAVINGS\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_COST_SAVINGS\' | translate"></span></th></tr></thead><tbody><tr ng-repeat="directhelp in data.kia"><td><span data-ng-bind="directhelp.name"></span></td><td><span data-ng-bind="directhelp.count"></span></td><td><span data-ng-bind="directhelp.cost | decimal2comma:2"></span></td><td><span data-ng-bind="directhelp.emission_savings | decimal2comma"></span></td><td><span data-ng-bind="directhelp.cost_savings | decimal2comma:2"></span></td></tr></tbody><tfoot><tr><td></td><td></td><td><span data-ng-bind="data.kia_cost | decimal2comma:2"></span></td><td><span data-ng-bind="data.kia_emission_savings | decimal2comma"></span></td><td><span data-ng-bind="data.kia_cost_savings | decimal2comma:2"></span></td></tr></tfoot></table><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_LIGHTING\' | translate)"></span></div></div><table class="ilabel"><thead><tr><th><span data-ng-bind="\'SSC_ABSTRACT_LAMP\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_USED\' | translate"></span></th><th><span data-ng-bind="\'SSC_ASSTRACT_COST\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_SAVINGS\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_AMORTISATION_TIME\' | translate"></span></th></tr></thead><tbody><tr ng-repeat="light in data.lighting"><td><span data-ng-bind="light.name"></span></td><td><span data-ng-bind="light.count"></span></td><td><span data-ng-bind="light.cost | decimal2comma:2"></span></td><td><span data-ng-bind="light.savings | decimal2comma"></span></td><td><span data-ng-bind="light.payback_time | decimal2comma: 1"></span></td></tr></tbody><tfoot><tr><td></td><td><span data-ng-bind="data.light_count"></span></td><td><span data-ng-bind="data.lighting_cost | decimal2comma:2"></span></td><td><span data-ng-bind="data.lighting_savings | decimal2comma"></span></td><td></td></tr></tfoot></table><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_NO_LOAD_LOSS\' | translate)"></span></div></div><table class="ilabel"><thead><tr><th><span data-ng-bind="\'SSC_ABSTRACT_CONNECTOR_STRIP\' | translate"></span></th><th><span data-ng-bind="\'SSC_ASSTRACT_COST\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_POWER_SAVING_POTENTIAL\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_AMORTISATION_TIME\' | translate"></span></th></tr></thead><tbody><tr ng-repeat="light in data.standby"><td><span data-ng-bind="light.name"></span></td><td><span data-ng-bind="light.cost | decimal2comma:2"></span></td><td><span data-ng-bind="light.savings | decimal2comma"></span></td><td><span data-ng-bind="light.payback_time | decimal2comma: 1"></span></td></tr></tbody><tfoot><tr><td></td><td><span data-ng-bind="data.standby_cost | decimal2comma:2"></span></td><td><span data-ng-bind="data.standby_savings | decimal2comma"></span></td><td></td></tr></tfoot></table><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_TOILET_FLUSH\' | translate)"></span></div></div><table class="ilabel"><thead><tr><th><span data-ng-bind="\'SSC_ABSTRACT_TYPE\' | translate"></span></th><th><span data-ng-bind="\'SSC_ASSTRACT_COST\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_TOILET_SAVING_POTENTIAL\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_AMORTISATION_TIME\' | translate"></span></th></tr></thead><tbody><tr ng-repeat="light in data.toilet_flush"><td><span data-ng-bind="light.name"></span></td><td><span data-ng-bind="light.cost | decimal2comma:2"></span></td><td><span data-ng-bind="light.savings | decimal2comma:3"></span></td><td><span data-ng-bind="light.payback_time | decimal2comma: 1"></span></td></tr></tbody><tfoot><tr><td></td><td><span data-ng-bind="data.toilet_cost | decimal2comma:2"></span></td><td><span data-ng-bind="data.toilet_flush_savings | decimal2comma:3"></span></td><td></td></tr></tfoot></table><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_WATER_HEATING\' | translate)"></span></div></div><table class="ilabel"><thead><tr><th><span data-ng-bind="\'SSC_ABSTRACT_TYPE\' | translate"></span></th><th><span data-ng-bind="\'SSC_ASSTRACT_COST\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_WATER_HEATING_SAVINGS_POTENTIAL\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_AMORTISATION_TIME\' | translate"></span></th></tr></thead><tbody><tr ng-repeat="item in data.hot_water"><td><span data-ng-bind="item.name"></span></td><td><span data-ng-bind="item.cost | decimal2comma:2"></span></td><td><span data-ng-bind="item.savings | decimal2comma"></span></td><td><span data-ng-bind="item.payback_time | decimal2comma: 1"></span></td></tr></tbody><tfoot><tr><td></td><td><span data-ng-bind="data.boiler_cost | decimal2comma:2"></span></td><td><span data-ng-bind="data.hot_water_savings | decimal2comma"></span></td><td></td></tr></tfoot></table><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_WATER_THERMO\' | translate)"></span></div></div><table class="ilabel"><thead><tr><th><span data-ng-bind="\'SSC_ABSTRACT_TYPE\' | translate"></span></th><th><span data-ng-bind="\'SSC_ASSTRACT_COST\' | translate"></span></th></tr></thead><tbody><tr ng-repeat="thermometer in data.thermometer"><td><span data-ng-bind="thermometer.name"></span></td><td><span data-ng-bind="thermometer.cost | decimal2comma:2"></span></td></tr></tbody><tfoot><tr><td></td><td><span data-ng-bind="data.thermometer_cost | decimal2comma:2"></span></td></tr></tfoot></table><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_SHOWER\' | translate)"></span></div></div><table class="ilabel"><thead><tr><th><span data-ng-bind="\'SSC_ABSTRACT_SHOWER_HEAD\' | translate"></span></th><th><span data-ng-bind="\'SSC_ASSTRACT_COST\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_WATER_SAVING_POTENTIAL\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_WARMWATER_SAVING_POTENTIAL\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_AMORTISATION_TIME\' | translate"></span></th></tr></thead><tbody><tr ng-repeat="light in data.shower"><td><span data-ng-bind="light.name"></span></td><td><span data-ng-bind="light.cost | decimal2comma:2"></span></td><td><span data-ng-bind="light.savings | decimal2comma:3"></span></td><td><span data-ng-bind="light.savings_hw | decimal2comma"></span></td><td><span data-ng-bind="light.payback_time | decimal2comma: 1"></span></td></tr></tbody><tfoot><tr><td></td><td><span data-ng-bind="data.shower_cost | decimal2comma:2"></span></td><td><span data-ng-bind="data.shower_savings | decimal2comma:3"></span></td><td><span data-ng-bind="data.shower_savings_hw | decimal2comma"></span></td><td></td></tr></tfoot></table><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_TAP\' | translate)"></span></div></div><table class="ilabel"><thead><tr><th><span data-ng-bind="\'SSC_ABSTRACT_TAP_AERATOR\' | translate"></span></th><th><span data-ng-bind="\'SSC_ASSTRACT_COST\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_WATER_SAVING_POTENTIAL\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_WARMWATER_SAVING_POTENTIAL\' | translate"></span></th><th><span data-ng-bind="\'SSC_ABSTRACT_AMORTISATION_TIME\' | translate"></span></th></tr></thead><tbody><tr ng-repeat="light in data.tap"><td><span data-ng-bind="light.name"></span></td><td><span data-ng-bind="light.cost | decimal2comma:2"></span></td><td><span data-ng-bind="light.savings | decimal2comma:3"></span></td><td><span data-ng-bind="light.savings_hw | decimal2comma"></span></td><td><span data-ng-bind="light.payback_time | decimal2comma: 1"></span></td></tr></tbody><tfoot><tr><td></td><td><span data-ng-bind="data.tap_cost | decimal2comma:2"></span></td><td><span data-ng-bind="data.tap_savings | decimal2comma:3"></span></td><td><span data-ng-bind="data.tap_savings_hw | decimal2comma"></span></td><td></td></tr></tfoot></table><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_HEAT\' | translate)"></span></div></div><table class="ilabel"><thead><tr><th><span data-ng-bind="\'SSC_ABSTRACT_TYPE\' | translate"></span></th><th><span data-ng-bind="\'SSC_ASSTRACT_COUNT\' | translate"></span></th><th><span data-ng-bind="\'SSC_ASSTRACT_COST\' | translate"></span></th></tr></thead><tbody><tr ng-repeat="heat in data.heat"><td><span data-ng-bind="heat.name"></span></td><td><span data-ng-bind="heat.count | decimal2comma:2"></span></td><td><span data-ng-bind="heat.cost | decimal2comma:2"></span></td></tr></tbody><tfoot><tr><td></td><td></td><td><span data-ng-bind="data.heat_cost | decimal2comma:2"></span></td></tr></tfoot></table><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_TOTAL_CONSUMPTION\' | translate)"></span></div></div><table class="ilabel full-border"><tbody><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_POWER\' | translate)"></span></td><td></td><td><span data-ng-bind="data.total_electric | decimal2comma"></span> kWh/a</td></tr><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_CONSUMPTION_REFRIGERATOR\' | translate)"></span></td><td><span ng-show="data.total_refrigeration_pct != \'\'"><span data-ng-bind="data.total_refrigeration_pct | decimal2comma:2"></span>%</span></td><td><span data-ng-bind="data.total_refrigeration | decimal2comma"></span> kWh/a</td></tr><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_CONSUMPTION_ELECTRIC_WARMWATER\' | translate)"></span></td><td><span data-ng-bind="(\'SSC_ABSTRACT_ESTIMATED_VALUE\' | translate)"></span>: <span data-ng-bind="data.total_electric_warmwater_estimate | decimal2comma"></span> kWh/a</td><td><span data-ng-bind="(data.total_electric_warmwater | decimal2comma) + \' kWh/a\'" ng-if="data.total_electric_warmwater != null"></span> <span ng-if="data.total_electric_warmwater == null">unbekannt</span></td></tr><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_CONSUMPTION_WATER\' | translate)"></span></td><td><span ng-show="data.total_water_estimate != \'\'"><span data-ng-bind="(\'SSC_ABSTRACT_ESTIMATED_VALUE_FROM_INPUT\' | translate)"></span>: <span data-ng-bind="data.total_water_estimate | decimal2comma:3"></span> m\xB3/a</span></td><td><span data-ng-bind="data.total_water | decimal2comma:3"></span> m\xB3/a</td></tr><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_CONSUMPTION_HEATING_ENERGY\' | translate)"></span></td><td></td><td><span data-ng-bind="(data.total_heating | decimal2comma) + \' kWh/a\'" ng-if="data.total_heating != null"></span> <span ng-if="data.total_heating == null">unbekannt</span></td></tr><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_CONSUMPTION_WARMWATER_ENERGY\' | translate)"></span></td><td><span data-ng-bind="(\'SSC_ABSTRACT_ESTIMATED_VALUE\' | translate)"></span>: <span data-ng-bind="data.total_hw_estimate | decimal2comma"></span> kWh/a</td><td><span data-ng-bind="(data.total_hw | decimal2comma) + \' kWh/a\'" ng-if="data.total_hw != null"></span> <span ng-if="data.total_hw == null">unbekannt</span></td></tr></tbody></table><div class="col-xs-12" ng-if="data.total_refrigeration_pct>=20"><div class="nlabel ssc-form-hint"><i class="fa fa-bell"></i> <span data-ng-bind="(\'SSC_ABSTRACT_WARNING_CONSUMPTION_REFRIGERATOR\' | translate)"></span></div></div><div class="clearfix"></div><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_TOTAL_SAVING_POTENTIAL\' | translate)"></span></div></div><table class="ilabel full-border"><tbody><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_POWER\' | translate)"></span></td><td><span data-ng-bind="data.savings_electric | decimal2comma:2"></span> kWh/a</td><td><span data-ng-bind="data.savings_electric_pct | decimal2comma:2"></span> %</td></tr><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_SAVINGS_ELECTRIC_WARMWATER\' | translate)"></span></td><td><span data-ng-bind="data.savings_electric_warmwater | decimal2comma:2"></span> kWh/a</td><td></td></tr><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_CONSUMPTION_WATER\' | translate)"></span></td><td><span data-ng-bind="data.savings_water | decimal2comma:2"></span> m\xB3/a</td><td><span data-ng-bind="data.savings_water_pct | decimal2comma:2"></span> %</td></tr><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_CONSUMPTION_WARMWATER_ENERGY_NOT_ELECTRIC\' | translate)"></span></td><td><span data-ng-bind="data.savings_hw | decimal2comma:2"></span> kWh/a</td><td><span data-ng-bind="data.savings_hw_pct | decimal2comma:2"></span> %</td></tr></tbody></table><div class="col-xs-12" ng-if="data.savings_electric_pct > 50"><div class="nlabel ssc-form-hint"><i class="fa fa-bell"></i> <span data-ng-bind="(\'SSC_ABSTRACT_WARNING_CONSUMPTION_SAVING\' | translate)"></span></div></div><div class="clearfix"></div><div class="row flabel clearfix margcreatebot"><div class="col-sm-12"><span data-ng-bind="(\'SSC_ABSTRACT_TOTAL_COST\' | translate)"></span></div></div><div class="col-sm-12 margcreatebot" ng-if="errors.summary.messages"><ssc-errorbox data-messages="errors.summary.messages" ssc-errorbox-title="\'FORM_WARNING_GENERIC\' | translate"></ssc-errorbox></div><table class="ilabel full-border"><tbody><tr><td><span data-ng-bind="(\'SSC_ABSTRACT_DIRECTHELPS\' | translate)"></span></td><td><span data-ng-bind="data.total_cost_directhelp | decimal2comma:2"></span> \u20AC</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('templates/static/ssc/device/device.html','<div data-ng-controller="deviceController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4><span data-ng-bind="(\'SSC_TILE_DEVICE_SH\' | translate) +\' - \'+ (\'SSC_TILE_DEVICE\' | translate)"></span><help-pop-over help="TIP_DEVICE_TAB"></help-pop-over></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div ng-repeat="(deviceIndex,ssc_device) in content.ssc_device track by ssc_device.id" on-finish-render="initjquery(); broadcastErrorUpdate()"><div id="accordion{{$index}}" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" fastaddclass="accordions[$index][0] ? \'\' : \'collapsed\'" data-parent="#accordion{{$index}}" href="#collapse{{$index}}"><span data-ng-bind="(\'SSC_DEVICE_MORE_CONSUMING_DEVICES\' | translate) + \' \' + ($index + 1) + \' \\\'\' + ssc_device.ssc_device_type.name + \'\\\'\'" ng-class="{\'error\': errors.device[deviceIndex].hasError, \'warning\': !errors.device[deviceIndex].hasError && errors.device[deviceIndex].hasWarning}"></span> <span class="ssc-form-hint" ng-if="ssc_device.ssc_refrigerator_id || ssc_device.ssc_refrigerator_id === 0" title="{{\'SSC_DEVICE_FRIDGE_LINK\' | translate}} {{ssc_device.FRIDGE_NUMBER}}"><i class="fa fa-files-o" aria-hidden="true"></i></span><ssc-delete-button delete-enabled="tableProperties.ssc_device.canDelete" delete-onclick="delete(\'sscdevice\', deviceIndex, ssc_device.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div id="collapse{{$index}}" class="collapse" fastaddclass="accordions[$index][0] ? \'in\' : \'\'"><ssc-errorbox data-messages="errors.device[deviceIndex].messages"></ssc-errorbox><div class="row margcreatetop" ng-if="ssc_device.ssc_refrigerator_id || ssc_device.ssc_refrigerator_id === 0"><div class="col-sm-12"><div class="nlabel ssc-form-hint"><i class="fa fa-files-o marg-right-small" aria-hidden="true"></i>{{\'SSC_DEVICE_FRIDGE_LINK\' | translate}}&nbsp;{{ssc_device.FRIDGE_NUMBER}}</div></div></div><div class="row margcreatetop"><div errorlabel="ssc_device.{{deviceIndex}}.ssc_room_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_STANDBY_ROOM\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].ssc_room_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_device.{{deviceIndex}}.ssc_room_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="ssc_device.ssc_room_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'ssc_room_type_id\', ssc_device.ssc_room_type_id, ssc_device.id)"><option value=""></option><option ng-repeat="item in content.ssc_room_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-1" errorlabel="ssc_device.{{deviceIndex}}.ssc_room_type_id" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.ssc_device_category_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_CATEGORY\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].ssc_device_category_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_device.{{deviceIndex}}.ssc_device_category_id" dataobj="required"><select class="createdropper leftdropper" ng-model="ssc_device.ssc_device_category_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'ssc_device_category_id\', ssc_device.ssc_device_category_id, ssc_device.id)"><option value=""></option><option ng-repeat="item in content.ssc_device_category" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-1" errorlabel="ssc_device.{{deviceIndex}}.ssc_device_category_id" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.ssc_device_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].ssc_device_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_device.{{deviceIndex}}.ssc_device_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="ssc_device.ssc_device_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'ssc_device_type_id\', ssc_device.ssc_device_type_id, ssc_device.id)"><option value=""></option><option ng-repeat="item in ssc_device.ssc_device_type_list" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-1" errorlabel="ssc_device.{{deviceIndex}}.ssc_device_type_id" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.ssc_alternative_device_type" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_ALTERNATIVE\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].ssc_alternative_device_type.required">*</span></div><div class="col-sm-7" errorlabel="ssc_device.{{deviceIndex}}.ssc_alternative_device_type" dataobj="required"><input class="createinputter" ng-model="ssc_device.ssc_alternative_device_type" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'ssc_alternative_device_type\', ssc_device.ssc_alternative_device_type, ssc_device.id)"></div><div errorlabel="ssc_device.{{deviceIndex}}.ssc_alternative_device_type" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.has_fridge_thermometer" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_FRIDGE_THERMOMETER\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].has_fridge_thermometer.required">*</span></div><div class="col-sm-7" errorlabel="ssc_device.{{deviceIndex}}.has_fridge_thermometer" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="ssc_device.has_fridge_thermometer" id="has_fridge_thermometer_{{deviceIndex}}" ng-checked="ssc_device.has_fridge_thermometer === 1" ng-change="save(\'sscdevice\', \'has_fridge_thermometer\', ssc_device.has_fridge_thermometer, ssc_device.id)"> <label class="checklabel" for="has_fridge_thermometer_{{deviceIndex}}"></label> <span data-ng-bind="ssc_device.has_fridge_thermometer === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.ssc_device_is_should_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_TARGET_VALUES\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].ssc_device_is_should_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_device.{{deviceIndex}}.ssc_device_is_should_id" dataobj="required"><select class="createdropper leftdropper" ng-model="ssc_device.ssc_device_is_should_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'ssc_device_is_should_id\', ssc_device.ssc_device_is_should_id, ssc_device.id)"><option value=""></option><option ng-repeat="item in content.ssc_device_is_should" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-1" errorlabel="ssc_device.{{deviceIndex}}.ssc_device_is_should_id" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.is_standby" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_IS_STANDBY\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].is_standby.required">*</span></div><div class="col-sm-7" errorlabel="ssc_device.{{deviceIndex}}.is_standby" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="ssc_device.is_standby" value="properties.is_standby" id="is_standby{{deviceIndex}}" ng-checked="ssc_device.is_standby === 1" ng-change="save(\'sscdevice\', \'is_standby\', ssc_device.is_standby, ssc_device.id)"> <label class="checklabel" for="is_standby{{deviceIndex}}"></label> <span data-ng-bind="ssc_device.is_standby === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row" ng-if="ssc_device.ssc_device_is_should_id !== undefined && ssc_device.ssc_device_is_should_id !== null"><div class="col-xs-offset-4 col-xs-3"><label class="ssc-filterlabel labelsmall" for="power_consumption_is" data-ng-bind="\'SSC_DEVICE_IS_VALUE\' | translate"></label></div><div class="col-xs-3"><label class="ssc-filterlabel labelsmall" for="power_consumption_should" data-ng-bind="\'SSC_DEVICE_TARGET_VALUE\' | translate"></label></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.power_consumption_is" dataobj="required" class="col-xs-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_POWER_CONSUMPTION\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].power_consumption_is.required">*</span></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.power_consumption_is" dataobj="required"><input class="createinputter" id="power_consumption_is" ng-model="ssc_device.power_consumption_is" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'power_consumption_is\', ssc_device.power_consumption_is, ssc_device.id)" decimal-separator-german="" precision="1"></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.power_consumption_should" dataobj="required"><input class="createinputter" id="power_consumption_should" ng-model="ssc_device.power_consumption_should" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'power_consumption_should\', ssc_device.power_consumption_should, ssc_device.id)" decimal-separator-german="" precision="2"></div><div class="col-xs-2 ilabel"><span data-ng-bind="\'SSC_DEVICE_WATT\' | translate"></span></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.standby_is" dataobj="required" class="col-xs-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_STANDBY_TIME\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].standby_is.required || properties.ssc_device[deviceIndex].standby_should.required">*</span></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.standby_is" dataobj="required"><input class="createinputter" id="standby_is" ng-model="ssc_device.standby_is" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'standby_is\', ssc_device.standby_is, ssc_device.id)" decimal-separator-german="" precision="2"></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.standby_should" dataobj="required"><input class="createinputter" id="standby_should" ng-model="ssc_device.standby_should" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'standby_should\', ssc_device.standby_should, ssc_device.id)" decimal-separator-german="" precision="2"></div><div class="col-xs-2 ilabel"><span data-ng-bind="\'SSC_DEVICE_HOURS\' | translate"></span></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.use_duration_is" dataobj="required" class="col-xs-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_USE_DURATION\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].use_duration_is.required || properties.ssc_device[deviceIndex].use_duration_should.required">*</span></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.use_duration_is" dataobj="required"><input class="createinputter" id="use_duration_is" ng-model="ssc_device.use_duration_is" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'use_duration_is\', ssc_device.use_duration_is, ssc_device.id)" decimal-separator-german="" precision="2"></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.use_duration_should" dataobj="required"><input class="createinputter" id="use_duration_should" ng-model="ssc_device.use_duration_should" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'use_duration_should\', ssc_device.use_duration_should, ssc_device.id)" decimal-separator-german="" precision="2"></div><div class="col-xs-2 ilabel"><span data-ng-bind="\'SSC_DEVICE_HOURS\' | translate"></span></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.consume_per_use_is" dataobj="required" class="col-xs-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_CONSUME_PER_USE\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].consume_per_use_is.required">*</span></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.consume_per_use_is" dataobj="required"><input class="createinputter" id="consume_per_use_is" ng-model="ssc_device.consume_per_use_is" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'consume_per_use_is\', ssc_device.consume_per_use_is, ssc_device.id)" decimal-separator-german="" precision="2"></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.consume_per_use_should" dataobj="required"><input class="createinputter" id="consume_per_use_should" ng-model="ssc_device.consume_per_use_should" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'consume_per_use_should\', ssc_device.consume_per_use_should, ssc_device.id)" decimal-separator-german="" precision="2"></div><div class="col-xs-2 ilabel"><span data-ng-bind="\'SSC_DEVICE_KWHPERN\' | translate"></span></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.use_count_is" dataobj="required" class="col-xs-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_COUNT_USAGE\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].use_count_is.required || properties.ssc_device[deviceIndex].use_count_should.required">*</span></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.use_count_is" dataobj="required"><input class="createinputter" id="use_count_is" ng-model="ssc_device.use_count_is" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'use_count_is\', ssc_device.use_count_is, ssc_device.id)"></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.use_count_should" dataobj="required"><input class="createinputter" id="use_count_should" ng-model="ssc_device.use_count_should" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'use_count_should\', ssc_device.use_count_should, ssc_device.id)"></div><div class="col-xs-2 ilabel"></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.yearly_consumption_is" dataobj="required" class="col-xs-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_YEARLY_CONSUMPTION\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].yearly_consumption_is.required || properties.ssc_device[deviceIndex].yearly_consumption_should.required">*</span></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.yearly_consumption_is" dataobj="required"><input class="createinputter" id="yearly_consumption_is" ng-model="ssc_device.yearly_consumption_is" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'yearly_consumption_is\', ssc_device.yearly_consumption_is, ssc_device.id)" decimal-separator-german=""></div><div class="col-xs-3" errorlabel="ssc_device.{{deviceIndex}}.yearly_consumption_should" dataobj="required"><input class="createinputter" id="yearly_consumption_should" ng-model="ssc_device.yearly_consumption_should" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'yearly_consumption_should\', ssc_device.yearly_consumption_should, ssc_device.id)" decimal-separator-german=""></div><div class="col-xs-2 ilabel">kWh/a</div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.ssc_device_period_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_PERIOD\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].ssc_device_period_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_device.{{$index}}.ssc_device_period_id" dataobj="required"><select class="createdropper leftdropper" ng-model="ssc_device.ssc_device_period_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'ssc_device_period_id\', ssc_device.ssc_device_period_id, ssc_device.id)"><option value=""></option><option ng-repeat="item in content.ssc_device_period" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-1" errorlabel="ssc_device.{{deviceIndex}}.ssc_device_period_id" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_device.{{deviceIndex}}.ssc_tip_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_DEVICE_TIP\' | translate"></span> <span data-ng-if="properties.ssc_device[deviceIndex].ssc_tip_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_device.{{deviceIndex}}.ssc_tip_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="ssc_device.ssc_tip_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscdevice\', \'ssc_tip_type_id\', ssc_device.ssc_tip_type_id, ssc_device.id)"><option value=""></option><option ng-repeat="item in content.ssc_tip_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-1" errorlabel="ssc_device.{{deviceIndex}}.ssc_tip_type_id" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatebot margcreatetop"><div class="row"><div class="col-xs-12"><hr></div></div><ssc-advice advices="ssc_device.ssc_advices" type="advice" tile-slug="tileSlug" options="ssc_device.ssc_device_type.advices_mapped" reference-id="ssc_device.id" use-default-texts="true" free-text-hide-title="true" table-properties="{canCreate: tableProperties.ssc_device.canCreate && ssc_device.ssc_advices.length < 1, canDelete: tableProperties.ssc_device.canDelete}"></ssc-advice></div><div class="margcreatebot margcreatetop" ng-if="ssc_device.explanations.length > 0"><div class="row"><div class="col-xs-12"><hr></div></div><ssc-advice advices="ssc_device.explanations" type="explanation" tile-slug="tileSlug" reference-id="ssc_device.id" table-properties="{canCreate: false, canDelete: false}"></ssc-advice></div><div class="row flabel"><div class="col-xs-11"><div class="row"><div class="col-sm-4"><span data-ng-bind="\'SSC_DEVICE_ENERGY_CONSUMPTION_YEAR\' | translate"></span></div><div class="col-sm-8 col-md-2"><span data-ng-bind="content.ssc_device[deviceIndex].calculated_yearly_consumption | decimal2comma"></span> kWh/a</div><div class="col-sm-4"><span data-ng-bind="\'SSC_DEVICE_ENERGY_SAVING_POTENTIAL\' | translate"></span></div><div class="col-sm-8 col-md-2"><span data-ng-bind="content.ssc_device[deviceIndex].power_savings | decimal2comma"></span> kWh/a</div></div></div><div class="col-xs-1 text-center"><div class="redbutton-mini icon"><i class="fa fa-cog toggle" ng-click="toggleDeviceSettings(ssc_device)" ng-class="{\'open\': isDeviceSettingsOpen(ssc_device)}"></i></div></div></div><div class="row table-row-gray" ng-show="isDeviceSettingsOpen(ssc_device)"><div class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_DEVICE_FOR_PLAUSI\' | translate"></span></div><div class="col-sm-4"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="ssc_device.for_household_consumption_prediction" value="required.status" id="for_household_consumption_prediction-{{deviceIndex}}" ng-checked="ssc_device.for_household_consumption_prediction === 1" ng-change="save(\'sscdevice\', \'for_household_consumption_prediction\', ssc_device.for_household_consumption_prediction, ssc_device.id)"> <label class="checklabel" for="for_household_consumption_prediction-{{deviceIndex}}"></label> <span data-ng-bind="ssc_device.for_household_consumption_prediction === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div></div></div></div><div class="row"><div class="col-sm-5"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_device_button\']" add-onclick="addRow(\'ssc_device\', saveData.ssc_id, \'add_ssc_device_button\')" add-enabled="tableProperties.ssc_device.canCreate" add-label="SSC_DEVICE_ADD_DEVICE"></ssc-add-button></div><div class="col-sm-offset-1 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/download/download.html','<div class="row"><div class="col-sm-9"><h4 data-ng-bind="\'SSC_DOWNLOAD_TITLE\' | translate"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><download></download>');
$templateCache.put('templates/static/ssc/electricBoiler/electricBoiler.html','<div data-ng-controller="electricBoilerController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'SSC_TILE_ELECTRICBOILER_SH\' | translate) +\' - \'+ (\'SSC_TILE_ELECTRICBOILER\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordeon{{$index}}" class="accordeon" ng-repeat="eboiler in content.ssc_electric_boiler track by eboiler.id" on-finish-render="initjquery(); broadcastErrorUpdate()"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" fastaddclass="accordions[$index][0] ? \'\' : \'collapsed\'" data-parent="#accordeon{{$index}}" href="#collapse{{$index}}"><span data-ng-bind="(\'SSC_EBOILER_DIRECTHELP_EBOILER\' | translate)" ng-class="{\'error\': errors.boiler[$index].hasError, \'warning\': !errors.boiler[$index].hasError && errors.boiler[$index].hasWarning}"></span><ssc-delete-button delete-enabled="tableProperties.ssc_electric_boiler.canDelete" delete-onclick="delete(\'sscelectricboiler\', $index, eboiler.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div id="collapse{{$index}}" class="collapse" fastaddclass="accordions[$index][0] ? \'in\' : \'\'"><ssc-errorbox data-messages="errors.boiler[$index].messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_electric_boiler.{{$index}}.ssc_room_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_ROOM_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_electric_boiler[$index].ssc_room_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_electric_boiler.{{$index}}.ssc_room_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="eboiler.ssc_room_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscelectricboiler\', \'ssc_room_type_id\', eboiler.ssc_room_type_id, eboiler.id)"><option value=""></option><option ng-repeat="item in content.ssc_room_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-1"><div errorlabel="ssc_electric_boiler.{{$index}}.ssc_room_type_id" dataobj="required" class="exclamation"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div errorlabel="ssc_electric_boiler.{{$index}}.directhelp_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_EBOILER_BUILTIN_DIRECTHELP\' | translate"></span> <span data-ng-if="properties.ssc_electric_boiler[$index].directhelp_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_electric_boiler.{{$index}}.directhelp_id" dataobj="required"><select class="createdropper leftdropper" ng-model="eboiler.directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscelectricboiler\', \'directhelp_id\', eboiler.directhelp_id, eboiler.id)"><option value=""></option><option ng-repeat="item in content.electric_boiler_directhelp" ng-value="item.id" ng-disabled="item.status === 0" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc_electric_boiler.{{$index}}.directhelp_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_electric_boiler.{{$index}}.off_per_day" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_EBOILER_OFF_PER_DAY\' | translate"></span> <span data-ng-if="properties.ssc_electric_boiler[$index].off_per_day.required">*</span><help-pop-over help="TIP_EBOILER_OFF_PER_DAY"></help-pop-over></div><div class="col-sm-6" errorlabel="ssc_electric_boiler.{{$index}}.off_per_day" dataobj="required"><input class="createinputter" ng-model="eboiler.off_per_day" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscelectricboiler\', \'off_per_day\', eboiler.off_per_day, eboiler.id)" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_EBOILER_HOURS_PER_DAY\' | translate"></span></div><div errorlabel="ssc_electric_boiler.{{$index}}.off_per_day" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="flabel clearfix"><div data-ng-class="{\'input-required\': (((eboiler.count + \'\').length === 0) || (model.name === null)) && properties.count && saved}" class="col-sm-4"><span data-ng-bind="\'SSC_LIGHTING_AMORTISATION_TIME\' | translate"></span></div><div class="col-sm-7"><span data-ng-bind="eboiler.payback_time | decimal2comma : 1"></span> Jahre</div></div><div class="flabel clearfix"><div data-ng-class="{\'input-required\': (((eboiler.count + \'\').length === 0) || (model.name === null)) && properties.count && saved}" class="col-sm-4"><span data-ng-bind="\'SSC_LIGHTING_SAVING_POTENTIAL\' | translate"></span></div><div class="col-sm-7"><span data-ng-bind="eboiler.savings | decimal2comma"></span> kWh/a</div></div></div></div></div><div class="col-sm-12 field-noinsides" ng-if="content.ssc_electric_boiler && content.ssc_electric_boiler.length > 0"><div class="col-sm-4 ilabel"><i class="fa fa-calculator marg-right-small" aria-hidden="true"></i>{{\'SSC_EBOILER_TOTAL_SAVINGS\'| translate}}</div><div class="col-sm-8 nlabel">{{content.ssc_summary.hot_water_savings | decimal2comma}} kWh/a</div></div><div class="row"><div class="col-sm-5"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_electric_boiler_button\']" add-onclick="addRow(\'ssc_electric_boiler\', saveData.ssc_id, \'add_ssc_electric_boiler_button\')" add-enabled="tableProperties.ssc_electric_boiler.canCreate" add-label="SSC_EBOILER_ADD_HELP"></ssc-add-button></div><div class="col-sm-offset-1 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/energy/energy.html','<div data-ng-controller="energyController" field-attribute-manager=""><div class="row"><div class="col-sm-8"><h4 data-ng-bind="(\'SSC_TILE_ENERGY_SH\' | translate) +\' - \'+ (\'SSC_TILE_ENERGY\' | translate)"></h4></div><div class="col-sm-1"><help-pop-over style="float: right; margin-top: 25px;" help="TIP_HEAT_TOOL_CAPTION"></help-pop-over></div><div class="col-sm-3"><a class="navbar-backlink" ui-sref="ssc.check.overview.heattool"><button type="button" class="redbutton"><span data-ng-bind="\'SSC_HEATTOOL_TITLE\' | translate"></span></button></a></div><div class="col-sm-offset-9 col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div class="row" ng-if="data.ssc.is_telephone"><div class="col-sm-12"><div class="field margcreatetop margcreatebot"><div class="hlabel"><span ng-bind="\'SSC_ENERGY_TELEPHONE_NOTICE_TITLE\' | translate"></span></div><div class="margcreatetop margcreatebot"><div class="form-fill-text-regular"><span ng-bind="\'SSC_ENERGY_TELEPHONE_NOTICE\' | translate"></span></div></div></div></div></div><div><div id="accordeon1" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion1" href="#collapse1"><span data-ng-bind="\'SSC_ENERGY_BILLS_AVAILABLE\' | translate" ng-class="{\'error\': errors.bills.hasError, \'warning\': !errors.bills.hasError && errors.bills.hasWarning}"></span><help-pop-over help="TIP_ENERGY_BILLS_AVAILABLE"></help-pop-over></div><div id="collapse1" class="collapse in"><ssc-errorbox data-messages="errors.bills.messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_energy.power_bill_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_POWER_BILL\' | translate"></span> <span data-ng-if="properties.ssc_energy.power_bill_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.power_bill_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.power_bill_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'power_bill_type_id\', content.ssc_energy.power_bill_type_id)"><option value=""></option><option ng-repeat="item in content.ssc_bill_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.power_bill_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.water_bill_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_BILL\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_bill_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.water_bill_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.water_bill_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_bill_type_id\', content.ssc_energy.water_bill_type_id)"><option value=""></option><option ng-repeat="item in content.ssc_bill_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.water_bill_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.warmwater_bill_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WARMWATER_BILL\' | translate"></span> <span data-ng-if="properties.ssc_energy.warmwater_bill_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.warmwater_bill_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.warmwater_bill_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'warmwater_bill_type_id\', content.ssc_energy.warmwater_bill_type_id)"><option value=""></option><option ng-repeat="item in content.ssc_bill_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.warmwater_bill_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="ssc_energy.heating_bill_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_HEATING_BILL\' | translate"></span> <span data-ng-if="properties.ssc_energy.heating_bill_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.heating_bill_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.heating_bill_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'heating_bill_type_id\', content.ssc_energy.heating_bill_type_id)"><option value=""></option><option ng-repeat="item in content.ssc_bill_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.heating_bill_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse2"><span data-ng-bind="\'SSC_ENERGY_POWER\' | translate" ng-class="{\'error\': errors.power.hasError, \'warning\': !errors.power.hasError && errors.power.hasWarning}"></span></div><div id="collapse2" class="collapse"><ssc-errorbox data-messages="errors.power.messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_energy.power_bill_period_from" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_POWER_BILL_PERIOD\' | translate"></span> <span data-ng-if="properties.ssc_energy.power_bill_period_from.required">*</span></div><div class="col-md-3" errorlabel="ssc_energy.power_bill_period_from" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="content.ssc_energy.power_bill_period_from" datepicker-change="save(\'sscenergy\', \'power_bill_period_from\', content.ssc_energy.power_bill_period_from)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div class="col-md-1 ilabel"><span class="">bis</span></div><div class="col-md-3" errorlabel="ssc_energy.power_bill_period_to" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="content.ssc_energy.power_bill_period_to" datepicker-change="save(\'sscenergy\', \'power_bill_period_to\', content.ssc_energy.power_bill_period_to)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div errorlabel="ssc_energy.power_bill_period_to" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.power_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_POWER_PRICE\' | translate"></span> <span data-ng-if="properties.ssc_energy.power_price.required">*</span><help-pop-over help="TIP_ENERGY_POWER_PRICE"></help-pop-over></div><div class="col-md-6" errorlabel="ssc_energy.power_price" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.power_price" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'power_price\', content.ssc_energy.power_price)" decimal-separator-german="" precision="4"></div><div class="col-md-1 ilabel">\u20AC/kWh</div><div errorlabel="ssc_energy.power_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_energy.power_heating_was_deducted" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_POWER_HEATING_WAS_DEDUCTED\' | translate"></span> <span data-ng-if="properties.ssc_energy.power_heating_was_deducted.required">*</span><help-pop-over help="TIP_ENERGY_HEATING_WAS_DEDUCTED"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_energy.power_heating_was_deducted" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="content.ssc_energy.power_heating_was_deducted" id="power_heating_was_deducted" ng-checked="content.ssc_energy.power_heating_was_deducted === 1" ng-change="save(\'sscenergy\', \'power_heating_was_deducted\', content.ssc_energy.power_heating_was_deducted)"> <label class="checklabel" for="power_heating_was_deducted"></label> <span data-ng-bind="content.ssc_energy.power_heating_was_deducted === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div><div class="row"><div errorlabel="ssc_energy.power_consumption" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_POWER_CONSUMPTION\' | translate" ng-if="content.ssc_energy.power_consumption_from_analysis === 0"></span> <span data-ng-bind="\'SSC_ENERGY_POWER_CONSUMPTION_BILL\' | translate" ng-if="content.ssc_energy.power_consumption_from_analysis === 1"></span> <span data-ng-if="properties.ssc_energy.power_consumption.required">*</span><help-pop-over help="TIP_ENERGY_POWER_CONSUMPTION" ng-if="content.ssc_energy.power_consumption_from_analysis === 0"></help-pop-over></div><div class="col-md-6" errorlabel="ssc_energy.power_consumption" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.power_consumption" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'power_consumption\', content.ssc_energy.power_consumption)" decimal-separator-german="" precision="0"></div><div class="col-md-1 ilabel">kWh</div><div errorlabel="ssc_energy.power_consumption" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.power_consumption_analysis" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_POWER_CONSUMPTION\' | translate"></span> <span data-ng-if="properties.ssc_energy.power_consumption_analysis.required">*</span><help-pop-over help="TIP_ENERGY_POWER_CONSUMPTION"></help-pop-over></div><div class="col-md-6" errorlabel="ssc_energy.power_consumption_analysis" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.power_consumption_analysis" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'power_consumption_analysis\', content.ssc_energy.power_consumption_analysis)" decimal-separator-german="" precision="0"></div><div class="col-md-1 ilabel">kWh</div><div errorlabel="ssc_energy.power_consumption_analysis" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.power_consumption_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_POWER_CONSUMPTION_YEAR\' | translate"></span> <span data-ng-if="properties.ssc_energy.power_consumption_year.required">*</span><help-pop-over help="TIP_ENERGY_POWER_CONSUMPTION_YEAR"></help-pop-over></div><div class="col-md-6" errorlabel="ssc_energy.power_consumption_year" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.power_consumption_year" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'power_consumption_year\', content.ssc_energy.power_consumption_year)" decimal-separator-german="" precision="0" forcedisabled="true"></div><div class="col-md-1 ilabel">kWh/a</div><div errorlabel="ssc_energy.power_consumption_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_energy.power_consumption_from_analysis" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_POWER_CONSUMPTION_FROM_ANALYSIS\' | translate"></span> <span data-ng-if="properties.ssc_energy.power_consumption_from_analysis.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.power_consumption_from_analysis" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="content.ssc_energy.power_consumption_from_analysis" id="power_consumption_from_analysis" ng-checked="content.ssc_energy.power_consumption_from_analysis === 1" ng-change="save(\'sscenergy\', \'power_consumption_from_analysis\', content.ssc_energy.power_consumption_from_analysis)"> <label class="checklabel" for="power_consumption_from_analysis"></label> <span data-ng-bind="content.ssc_energy.power_consumption_from_analysis === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_energy.power_has_gas_stove" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_POWER_HAS_GAS_STOVE\' | translate"></span> <span data-ng-if="properties.ssc_energy.power_has_gas_stove.required">*</span><help-pop-over help="TIP_ENERGY_POWER_HAS_GAS_STOVE"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_energy.power_has_gas_stove" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="content.ssc_energy.power_has_gas_stove" id="power_has_gas_stove" ng-checked="content.ssc_energy.power_has_gas_stove === 1" ng-change="save(\'sscenergy\', \'power_has_gas_stove\', content.ssc_energy.power_has_gas_stove)"> <label class="checklabel" for="power_has_gas_stove"></label> <span data-ng-bind="content.ssc_energy.power_has_gas_stove === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_energy.power_is_pump_included" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_POWER_IS_PUMP_INCLUDED\' | translate"></span> <span data-ng-if="properties.ssc_energy.power_is_pump_included.required">*</span><help-pop-over help="TIP_ENERGY_POWER_IS_PUMP_INCLUDED"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_energy.power_is_pump_included" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="content.ssc_energy.power_is_pump_included" id="power_is_pump_included" ng-checked="content.ssc_energy.power_is_pump_included === 1" ng-change="save(\'sscenergy\', \'power_is_pump_included\', content.ssc_energy.power_is_pump_included)"> <label class="checklabel" for="power_is_pump_included"></label> <span data-ng-bind="content.ssc_energy.power_is_pump_included === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div><div class="row"><div class="col-sm-4 ilabel" errorlabel="ssc_energy.power_index" dataobj="required"><span data-ng-bind="\'SSC_ENERGY_INDEX_POWER\' | translate"></span><help-pop-over help="TIP_ENERGY_POWER_INDEX"></help-pop-over></div><div class="col-md-5" errorlabel="ssc_energy.power_index" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.power_index" forcedisabled="true" decimal-separator-german=""></div><div class="col-md-2 ilabel">kWh/(Pers*a)</div><div errorlabel="ssc_energy.power_index" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div><div ng-if="tachoData[1].kennzGeb > 0" class="row margcreatebot"><div class="col-sm-12"><ssc-tacho ssc-tacho-top="tachoData[1].top" ssc-tacho-label="tachoData[1].label"></ssc-tacho></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse3"><span data-ng-bind="\'SSC_ENERGY_ACQUISITION_POWER_COUNTER\' | translate" ng-class="{\'error\': errors.electric_meter.hasError, \'warning\': !errors.electric_meter.hasError && errors.electric_meter.hasWarning}"></span></div><div id="collapse3" class="collapse"><ssc-errorbox data-messages="errors.electric_meter.messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_energy.electric_meter_date" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_ELECTRIC_METER_DATE\' | translate"></span> <span data-ng-if="properties.ssc_energy.electric_meter_date.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.electric_meter_date" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="content.ssc_energy.electric_meter_date" datepicker-change="save(\'sscenergy\', \'electric_meter_date\', content.ssc_energy.electric_meter_date)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div errorlabel="ssc_energy.electric_meter_date" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.electric_meter_number" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_ELECTRIC_METER_NUMBER\' | translate"></span> <span data-ng-if="properties.ssc_energy.electric_meter_number.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.electric_meter_number" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.electric_meter_number" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'electric_meter_number\', content.ssc_energy.electric_meter_number)"></div><div errorlabel="ssc_energy.electric_meter_number" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="ssc_energy.electric_meter_count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_ELECTRIC_METER_COUNT\' | translate"></span> <span data-ng-if="properties.ssc_energy.electric_meter_count.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.electric_meter_count" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.electric_meter_count" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'electric_meter_count\', content.ssc_energy.electric_meter_count)" decimal-separator-german="" precision="1"></div><div errorlabel="ssc_energy.electric_meter_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_energy.electric_meter_type_name" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_ELECTRIC_METER_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_energy.electric_meter_type_name.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.electric_meter_type_name" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.electric_meter_type_name" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'electric_meter_type_name\', content.ssc_energy.electric_meter_type_name)"><option value=""></option><option ng-repeat="item in content.electric_meter_type" ng-value="item.id" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc_energy.electric_meter_type_name" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row margcreatebot"><div errorlabel="ssc_energy.electric_base_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_ELECTRIC_BASE_PRICE\' | translate"></span> <span data-ng-if="properties.ssc_energy.electric_base_price.required">*</span><help-pop-over help="TIP_ENERGY_ELECTRIC_BASE_PRICE"></help-pop-over></div><div class="col-sm-6" errorlabel="ssc_energy.electric_base_price" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.electric_base_price" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'electric_base_price\', content.ssc_energy.electric_base_price)" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel">\u20AC</div><div errorlabel="ssc_energy.electric_base_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse4"><span data-ng-bind="\'SSC_ENERGY_WATER_CONSUMPTION\' | translate" ng-class="{\'error\': errors.water.hasError, \'warning\': !errors.water.hasError && errors.water.hasWarning}"></span></div><div id="collapse4" class="collapse"><ssc-errorbox data-messages="errors.water.messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_energy.water_bill_period_from" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_BILL_PERIOD\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_bill_period_from.required">*</span></div><div class="col-md-3" errorlabel="ssc_energy.water_bill_period_from" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="content.ssc_energy.water_bill_period_from" datepicker-change="save(\'sscenergy\', \'water_bill_period_from\', content.ssc_energy.water_bill_period_from)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div class="col-md-1 ilabel"><span class="">bis</span></div><div class="col-md-3" errorlabel="ssc_energy.water_bill_period_to" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="content.ssc_energy.water_bill_period_to" datepicker-change="save(\'sscenergy\', \'water_bill_period_to\', content.ssc_energy.water_bill_period_to)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div errorlabel="ssc_energy.water_bill_period_to" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.water_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_PRICE\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_price.required">*</span><help-pop-over help="TIP_ENERGY_WATER_PRICE"></help-pop-over></div><div class="col-md-6" errorlabel="ssc_energy.water_price" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.water_price" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_price\', content.ssc_energy.water_price)" decimal-separator-german="" precision="2"></div><div class="col-md-1 ilabel">\u20AC/m\xB3</div><div errorlabel="ssc_energy.water_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_energy.water_total_counter_available_yn_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_TOTAL_COUNTER_AVAILABLE\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_total_counter_available_yn_id.required">*</span><help-pop-over help="TIP_ENERGY_WATER_TOTAL_COUNTER_AVAILABLE"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_energy.water_total_counter_available_yn_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.water_total_counter_available_yn_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_total_counter_available_yn_id\', content.ssc_energy.water_total_counter_available_yn_id)"><option value=""></option><option ng-repeat="item in content.ssc_yes_no_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.water_total_counter_available_yn_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div errorlabel="ssc_energy.water_total_water_count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_TOTAL_COUNT\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_total_water_count.required">*</span></div><div class="col-md-6" errorlabel="ssc_energy.water_total_water_count" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.water_total_water_count" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_total_water_count\', content.ssc_energy.water_total_water_count)" decimal-separator-german="" precision="3"></div><div class="col-md-1 ilabel">m\xB3</div><div errorlabel="ssc_energy.water_total_water_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.water_total_water_count_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_TOTAL_COUNT_YEAR\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_total_water_count_year.required">*</span></div><div class="col-md-6" errorlabel="ssc_energy.water_total_water_count_year" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.water_total_water_count_year" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_total_water_count_year\', content.ssc_energy.water_total_water_count_year)" decimal-separator-german="" precision="3" forcedisabled="true"></div><div class="col-md-1 ilabel">m\xB3/a</div><div errorlabel="ssc_energy.water_total_water_count_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_energy.water_cold_counter_available_yn_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_COLD_COUNTER_AVAILABLE\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_cold_counter_available_yn_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.water_cold_counter_available_yn_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.water_cold_counter_available_yn_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_cold_counter_available_yn_id\', content.ssc_energy.water_cold_counter_available_yn_id)"><option value=""></option><option ng-repeat="item in content.ssc_yes_no_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.water_cold_counter_available_yn_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div errorlabel="ssc_energy.water_cold_water_count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_COLD_COUNT\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_cold_water_count.required">*</span></div><div class="col-md-6" errorlabel="ssc_energy.water_cold_water_count" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.water_cold_water_count" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_cold_water_count\', content.ssc_energy.water_cold_water_count)" decimal-separator-german="" precision="3"></div><div class="col-md-1 ilabel">m\xB3</div><div errorlabel="ssc_energy.water_cold_water_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.water_cold_water_count_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_COLD_COUNT_YEAR\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_cold_water_count_year.required">*</span></div><div class="col-md-6" errorlabel="ssc_energy.water_cold_water_count_year" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.water_cold_water_count_year" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_cold_water_count_year\', content.ssc_energy.water_cold_water_count_year)" decimal-separator-german="" precision="3" forcedisabled="true"></div><div class="col-md-1 ilabel">m\xB3/a</div><div errorlabel="ssc_energy.water_cold_water_count_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_energy.water_warm_counter_available_yn_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_WARM_COUNTER_AVAILABLE\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_warm_counter_available_yn_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.water_warm_counter_available_yn_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.water_warm_counter_available_yn_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_warm_counter_available_yn_id\', content.ssc_energy.water_warm_counter_available_yn_id)"><option value=""></option><option ng-repeat="item in content.ssc_yes_no_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.water_warm_counter_available_yn_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div errorlabel="ssc_energy.water_warm_water_count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_WARM_COUNT\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_warm_water_count.required">*</span><help-pop-over help="TIP_ENERGY_WATER_WARM_COUNT"></help-pop-over></div><div class="col-md-6" errorlabel="ssc_energy.water_warm_water_count" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.water_warm_water_count" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_warm_water_count\', content.ssc_energy.water_warm_water_count)" decimal-separator-german="" precision="3"></div><div class="col-md-1 ilabel">m\xB3</div><div errorlabel="ssc_energy.water_warm_water_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.water_warm_water_count_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_WARM_COUNT_YEAR\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_warm_water_count_year.required">*</span></div><div class="col-md-6" errorlabel="ssc_energy.water_warm_water_count_year" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.water_warm_water_count_year" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'water_warm_water_count_year\', content.ssc_energy.water_warm_water_count_year)" decimal-separator-german="" precision="3" forcedisabled="true"></div><div class="col-md-1 ilabel">m\xB3/a</div><div errorlabel="ssc_energy.water_warm_water_count_year" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_energy.water_has_dishwasher" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_HAS_DISHWASHER\' | translate"></span> <span data-ng-if="properties.ssc_energy.water_has_dishwasher.required">*</span><help-pop-over help="TIP_ENERGY_WATER_HAS_DISHWASHER"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_energy.water_has_dishwasher" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="content.ssc_energy.water_has_dishwasher" id="water_has_dishwasher" ng-checked="content.ssc_energy.water_has_dishwasher === 1" ng-change="save(\'sscenergy\', \'water_has_dishwasher\', content.ssc_energy.water_has_dishwasher)"> <label class="checklabel" for="water_has_dishwasher"></label> <span data-ng-bind="content.ssc_energy.water_has_dishwasher === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div><div class="row"><div errorlabel="ssc_energy.water_index" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_INDEX_WATER\' | translate"></span><help-pop-over help="TIP_ENERGY_WATER_INDEX"></help-pop-over></div><div class="col-md-5" errorlabel="ssc_energy.water_index" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.water_index" decimal-separator-german="" precision="3" forcedisabled="true"></div><div class="col-md-2 ilabel">m\xB3/(Pers*a)</div><div errorlabel="ssc_energy.water_index" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div><div ng-if="tachoData[3].kennzGeb > 0" class="row margcreatebot"><div class="col-sm-12"><ssc-tacho ssc-tacho-top="tachoData[3].top" ssc-tacho-label="tachoData[3].label"></ssc-tacho></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse5"><span data-ng-bind="\'SSC_ENERGY_WARMWATER_INPUT\' | translate" ng-class="{\'error\': errors.warmwater.hasError, \'warning\': !errors.warmwater.hasError && errors.warmwater.hasWarning}"></span></div><div id="collapse5" class="collapse"><ssc-errorbox data-messages="errors.warmwater.messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_energy.warmwater_bill_period_from" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WATER_BILL_PERIOD\' | translate"></span> <span data-ng-if="properties.ssc_energy.warmwater_bill_period_from.required">*</span></div><div class="col-md-3" errorlabel="ssc_energy.warmwater_bill_period_from" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="content.ssc_energy.warmwater_bill_period_from" datepicker-change="save(\'sscenergy\', \'warmwater_bill_period_from\', content.ssc_energy.warmwater_bill_period_from)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div class="col-md-1 ilabel"><span class="">bis</span></div><div class="col-md-3" errorlabel="ssc_energy.warmwater_bill_period_to" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="content.ssc_energy.warmwater_bill_period_to" datepicker-change="save(\'sscenergy\', \'warmwater_bill_period_to\', content.ssc_energy.warmwater_bill_period_to)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div errorlabel="ssc_energy.warmwater_bill_period_to" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.warmwater_preparation_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WARMWATER_PREPARATION_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_energy.warmwater_preparation_type_id.required">*</span><help-pop-over help="TIP_ENERGY_WARMWATER_PREPARATION_TYPE"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_energy.warmwater_preparation_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.warmwater_preparation_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'warmwater_preparation_type_id\', content.ssc_energy.warmwater_preparation_type_id)"><option value=""></option><option ng-repeat="item in content.ssc_energy_warmwater_preparation_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.warmwater_preparation_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.warmwater_other_heating" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WARMWATER_OTHER_DESC\' | translate"></span> <span data-ng-if="properties.ssc_energy.warmwater_other_heating.required">*</span></div><div class="col-sm-7" errorlabel="ssc_energy.warmwater_other_heating" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.warmwater_other_heating" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'warmwater_other_heating\', content.ssc_energy.warmwater_other_heating)"></div><div errorlabel="ssc_energy.warmwater_other_heating" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.warmwater_fuel_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WARMWATER_PRICE\' | translate"></span> <span data-ng-if="properties.ssc_energy.warmwater_fuel_price.required">*</span><help-pop-over help="TIP_ENERGY_WARMWATER_PRICE"></help-pop-over></div><div class="col-md-6" errorlabel="ssc_energy.warmwater_fuel_price" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.warmwater_fuel_price" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'warmwater_fuel_price\', content.ssc_energy.warmwater_fuel_price)" decimal-separator-german="" precision="4"></div><div class="col-md-1 ilabel">\u20AC/kWh</div><div errorlabel="ssc_energy.warmwater_fuel_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.warmwater_consumption_count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WARMWATER_TOTAL_WATER_COUNT\' | translate"></span> <span data-ng-if="properties.ssc_energy.warmwater_consumption_count.required">*</span><help-pop-over help="TIP_ENERGY_WARMWATER_TOTAL_WATER_COUNT"></help-pop-over></div><div class="col-md-6" errorlabel="ssc_energy.warmwater_consumption_count" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.warmwater_consumption_count" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'warmwater_consumption_count\', content.ssc_energy.warmwater_consumption_count)" decimal-separator-german=""></div><div class="col-md-1 ilabel">kWh/a</div><div errorlabel="ssc_energy.warmwater_consumption_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.warmwater_additional_system" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_WARMWATER_ADDITIONAL_SYSTEM\' | translate"></span> <span data-ng-if="properties.ssc_energy.warmwater_additional_system.required">*</span></div><div class="col-md-7" errorlabel="ssc_energy.warmwater_additional_system" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.warmwater_additional_system" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'warmwater_additional_system\', content.ssc_energy.warmwater_additional_system)"></div><div errorlabel="ssc_energy.warmwater_additional_system" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-sm-4 ilabel" errorlabel="ssc_energy.warmwater_index" dataobj="required"><span data-ng-bind="\'SSC_ENERGY_INDEX_WARMWATER\' | translate"></span></div><div class="col-md-5" errorlabel="ssc_energy.warmwater_index" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.warmwater_index" forcedisabled="true" decimal-separator-german=""></div><div class="col-md-2 ilabel">kWh/(Pers*a)</div><div errorlabel="ssc_energy.warmwater_index" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div><div ng-if="tachoData[4].kennzGeb > 0" class="row margcreatebot"><div class="col-sm-12"><ssc-tacho ssc-tacho-top="tachoData[4].top" ssc-tacho-label="tachoData[4].label"></ssc-tacho></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse6"><span data-ng-bind="\'SSC_ENERGY_HEATING_INPUT\' | translate" ng-class="{\'error\': errors.heating.hasError, \'warning\': !errors.heating.hasError && errors.heating.hasWarning}"></span></div><div id="collapse6" class="collapse"><ssc-errorbox data-messages="errors.heating.messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_energy.heating_bill_period_from" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_HEATING_BILL_PERIOD\' | translate"></span> <span data-ng-if="properties.ssc_energy.heating_bill_period_from.required">*</span></div><div class="col-md-3" errorlabel="ssc_energy.heating_bill_period_from" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="content.ssc_energy.heating_bill_period_from" datepicker-change="save(\'sscenergy\', \'heating_bill_period_from\', content.ssc_energy.heating_bill_period_from)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div class="col-md-1 ilabel"><span class="">bis</span></div><div class="col-md-3" errorlabel="ssc_energy.heating_bill_period_to" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="content.ssc_energy.heating_bill_period_to" datepicker-change="save(\'sscenergy\', \'heating_bill_period_to\', content.ssc_energy.heating_bill_period_to)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div errorlabel="ssc_energy.heating_bill_period_to" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.ssc_heating_system_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_HEATING_SYSTEM_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_energy.ssc_heating_system_type_id.required">*</span><help-pop-over help="TIP_ENERGY_HEATING_SYSTEM_TYPE"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_energy.ssc_heating_system_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.ssc_heating_system_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'ssc_heating_system_type_id\', content.ssc_energy.ssc_heating_system_type_id)"><option value=""></option><option ng-repeat="item in content.ssc_heating_system_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.ssc_heating_system_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.ssc_fuel_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_FUEL_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_energy.ssc_fuel_type_id.required">*</span><help-pop-over help="TIP_ENERGY_HEATING_FUEL_TYPE"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_energy.ssc_fuel_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.ssc_fuel_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'ssc_fuel_type_id\', content.ssc_energy.ssc_fuel_type_id)"><option value=""></option><option ng-repeat="item in content.ssc_fuel_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.ssc_fuel_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.heating_total_heating_count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_HEATING_TOTAL_COUNT\' | translate"></span> <span data-ng-if="properties.ssc_energy.heating_total_heating_count.required">*</span></div><div class="col-md-6" errorlabel="ssc_energy.heating_total_heating_count" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.heating_total_heating_count" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'heating_total_heating_count\', content.ssc_energy.heating_total_heating_count)" decimal-separator-german=""></div><div class="col-md-1 ilabel">kWh/a</div><div errorlabel="ssc_energy.heating_total_heating_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.heating_price" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_HEATING_PRICE\' | translate"></span> <span data-ng-if="properties.ssc_energy.heating_price.required">*</span></div><div class="col-md-6" errorlabel="ssc_energy.heating_price" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.heating_price" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'heating_price\', content.ssc_energy.heating_price)" decimal-separator-german="" precision="4"></div><div class="col-md-1 ilabel">\u20AC/kWh</div><div errorlabel="ssc_energy.heating_price" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_energy.heating_additional_system" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_HEATING_ADDITIONAL_SYSTEM\' | translate"></span> <span data-ng-if="properties.ssc_energy.heating_additional_system.required">*</span><help-pop-over help="TIP_ENERGY_HEATING_ADDITIONAL_SYSTEM"></help-pop-over></div><div class="col-md-7" errorlabel="ssc_energy.heating_additional_system" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.heating_additional_system" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'heating_additional_system\', content.ssc_energy.heating_additional_system)"></div><div errorlabel="ssc_energy.heating_additional_system" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatetop"><div errorlabel="ssc_energy.heating_water_heating_included_yn_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_HEATING_WATER_HEATING_INCLUDED\' | translate"></span> <span data-ng-if="properties.ssc_energy.heating_water_heating_included_yn_id.required">*</span><help-pop-over help="TIP_ENERGY_HEATING_WATER_HEATING_INCLUDED"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_energy.heating_water_heating_included_yn_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_energy.heating_water_heating_included_yn_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscenergy\', \'heating_water_heating_included_yn_id\', content.ssc_energy.heating_water_heating_included_yn_id)"><option value=""></option><option ng-repeat="item in content.ssc_yes_no_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_energy.heating_water_heating_included_yn_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="ssc_energy.has_heat_cost_allocator" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_ENERGY_HEATING_HAS_HEAT_COST_ALLOCATOR\' | translate"></span> <span data-ng-if="properties.ssc_energy.has_heat_cost_allocator.required">*</span><help-pop-over help="TIP_ENERGY_HEATING_HAS_HEAT_COST_ALLOCATOR"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_energy.has_heat_cost_allocator" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="content.ssc_energy.has_heat_cost_allocator" id="has_heat_cost_allocator" ng-checked="content.ssc_energy.has_heat_cost_allocator === 1" ng-change="save(\'sscenergy\', \'has_heat_cost_allocator\', content.ssc_energy.has_heat_cost_allocator)"> <label class="checklabel" for="has_heat_cost_allocator"></label> <span data-ng-bind="content.ssc_energy.has_heat_cost_allocator === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row"><div class="col-sm-4 ilabel" errorlabel="ssc_energy.heating_index" dataobj="required"><span data-ng-bind="\'SSC_ENERGY_INDEX_HEATING\' | translate"></span></div><div class="col-md-5" errorlabel="ssc_energy.heating_index" dataobj="required"><input class="createinputter" ng-model="content.ssc_energy.heating_index" forcedisabled="true" decimal-separator-german=""></div><div class="col-md-2 ilabel">kWh/(m\xB2a)</div><div errorlabel="ssc_energy.heating_index" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatebot"></div><div ng-if="tachoData[2].kennzGeb > 0" class="row margcreatebot"><div class="col-sm-12"><ssc-tacho ssc-tacho-top="tachoData[2].top" ssc-tacho-label="tachoData[2].label"></ssc-tacho></div></div><div class="margcreatetop"></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div></div>');
$templateCache.put('templates/static/ssc/energy/heattool.html','<ssc-heating-tool table="ssc_heating_tool" tile-slug="HEATING_TOOL" route-prefix="checks"></ssc-heating-tool>');
$templateCache.put('templates/static/ssc/generalInformation/generalInformation.html','<div data-ng-controller="generalInformationController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'SSC_TILE_GENERALINFO_SH\' | translate) +\' - \'+ (\'SSC_TILE_GENERALINFO\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordeon1" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion1" href="#collapse1"><span data-ng-bind="\'SSC_GENERAL_GENERAL_INFORMATION\' | translate"></span></div><ssc-errorbox data-messages="errorsGeneral"></ssc-errorbox><div id="collapse1" class="collapse in"><div class="row margcreatetop"><div errorlabel="ssc_general.privacy_is_signed" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_PRIVACY_IS_SIGNED\' | translate" ng-if="!data.ssc.is_telephone"></span> <span data-ng-bind="\'SSC_GENERAL_PRIVACY_IS_SIGNED_TELEPHONE\' | translate" ng-if="data.ssc.is_telephone"></span> <span data-ng-if="required.ssc_general.privacy_is_signed.required">*</span><help-pop-over help="TIP_GENERAL_PRIVACY_IS_SIGNED"></help-pop-over></div><div class="col-sm-3" errorlabel="ssc_general.privacy_is_signed" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc_general.privacy_is_signed" value="required.status" id="privacy_is_signed" ng-checked="data.ssc_general.privacy_is_signed === 1" ng-change="save(\'sscgeneral\', \'privacy_is_signed\', data.ssc_general.privacy_is_signed)"> <label class="checklabel" for="privacy_is_signed"></label> <span data-ng-bind="data.ssc_general.privacy_is_signed === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.privacy_is_signed" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.grants_later_contact" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_GRANTS_LATER_CONTACT\' | translate"></span> <span data-ng-if="required.ssc_general.grants_later_contact.required">*</span><help-pop-over help="TIP_GENERAL_GRANTS_LATER_CONTACT"></help-pop-over></div><div class="col-sm-3" errorlabel="ssc_general.grants_later_contact" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc_general.grants_later_contact" value="required.status" id="grants_later_contact" ng-checked="data.ssc_general.grants_later_contact === 1" ng-change="save(\'sscgeneral\', \'grants_later_contact\', data.ssc_general.grants_later_contact)"> <label class="checklabel" for="grants_later_contact"></label> <span data-ng-bind="data.ssc_general.grants_later_contact === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.grants_later_contact" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="ssc_general.has_received_voucher" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_HAS_RECEIVED_VOUCHER\' | translate"></span> <span data-ng-if="required.ssc_general.has_received_voucher.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.has_received_voucher" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc_general.has_received_voucher" value="required.has_received_voucher" id="has_received_voucher" ng-checked="data.ssc_general.has_received_voucher === 1" ng-change="save(\'sscgeneral\', \'has_received_voucher\', data.ssc_general.has_received_voucher)"> <label class="checklabel" for="has_received_voucher"></label> <span data-ng-bind="data.ssc_general.has_received_voucher === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.has_received_voucher" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse2"><span data-ng-bind="\'SSC_GENERAL_TRANSFER_AIDS\' | translate"></span></div><div class="row" ng-show="showerrorbox2"><div class="col-sm-12"><div class="errorfield margcreatetop margcreatebot"><div class="row hlabel"><span data-ng-bind="\'FORM_ERROR_TITLE\' | translate">Bitte alle Felder korrekt ausf\xFCllen</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.ssc_general"><div ng-if="key == \'ssc_aid_money_type_id\' || key == \'ssc_aid_agency_type_id\' || key == \'ssc_audience_type_id\'"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox2 = 1;value.error;}}</div><div ng-if="value.warning != null" class="warning"><span>{{$parent.$parent.$parent.showerrorbox2 = 1;value.warning;}}</span></div></div></div></div></div></div></div></div><div id="collapse2" class="collapse"><div class="row margcreatetop"><div errorlabel="ssc_general.ssc_aid_money_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_AID_MONEY_TYPE\' | translate"></span> <span data-ng-if="required.ssc_general.ssc_aid_money_type_id.required">*</span><help-pop-over help="TIP_GENERAL_AID_MONEY_TYPE" ng-if="!data.ssc.is_telephone"></help-pop-over><help-pop-over help="TIP_GENERAL_AID_MONEY_TYPE_TELEPHONE" ng-if="data.ssc.is_telephone"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_general.ssc_aid_money_type_id" dataobj="required"><select class="createdropper" ng-model="data.ssc_general.ssc_aid_money_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'ssc_aid_money_type_id\', data.ssc_general.ssc_aid_money_type_id)"><option value=""></option><option ng-repeat="item in data.ssc_aid_money_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_general.ssc_aid_money_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="ssc_general.social_pass" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_SOCIAL_PASS\' | translate"></span> <span data-ng-if="required.ssc_general.social_pass.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.social_pass" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="null" ng-model="data.ssc_general.social_pass" value="required.social_pass" id="social_pass" ng-checked="data.ssc_general.social_pass === 1" ng-change="save(\'sscgeneral\', \'social_pass\', data.ssc_general.social_pass)"> <label class="checklabel" for="social_pass"></label> <span data-ng-bind="data.ssc_general.social_pass === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.social_pass" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="ssc_general.low_income" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_LOW_INCOME\' | translate"></span> <span data-ng-if="required.ssc_general.low_income.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.low_income" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="null" ng-model="data.ssc_general.low_income" value="required.low_income" id="low_income" ng-checked="data.ssc_general.low_income === 1" ng-change="save(\'sscgeneral\', \'low_income\', data.ssc_general.low_income)"> <label class="checklabel" for="low_income"></label> <span data-ng-bind="data.ssc_general.low_income === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.low_income" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="ssc_general.low_income_self_disclosure" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_LOW_INCOME_SELF_DISCLOSURE\' | translate"></span> <span data-ng-if="required.ssc_general.low_income_self_disclosure.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.low_income_self_disclosure" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="null" ng-model="data.ssc_general.low_income_self_disclosure" value="required.low_income_self_disclosure" id="low_income_self_disclosure" ng-checked="data.ssc_general.low_income_self_disclosure === 1" ng-change="save(\'sscgeneral\', \'low_income_self_disclosure\', data.ssc_general.low_income_self_disclosure)"> <label class="checklabel" for="low_income_self_disclosure"></label> <span data-ng-bind="data.ssc_general.low_income_self_disclosure === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.low_income_self_disclosure" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatetop"><div errorlabel="ssc_general.ssc_aid_agency_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_AID_AGENCY_TYPE\' | translate"></span> <span data-ng-if="required.ssc_general.ssc_aid_agency_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.ssc_aid_agency_type_id" dataobj="required"><select class="createdropper" ng-model="data.ssc_general.ssc_aid_agency_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'ssc_aid_agency_type_id\', data.ssc_general.ssc_aid_agency_type_id)"><option value=""></option><option ng-repeat="item in data.ssc_aid_agency_types" ng-value="item.id" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc_general.ssc_aid_agency_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.ssc_aid_agency" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_AID_AGENCY\' | translate"></span> <span data-ng-if="required.ssc_general.ssc_aid_agency.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.ssc_aid_agency" dataobj="required"><input class="createinputter" ng-model="data.ssc_general.ssc_aid_agency" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'ssc_aid_agency\', data.ssc_general.ssc_aid_agency)"></div><div errorlabel="ssc_general.ssc_aid_agency" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatetop"><div errorlabel="ssc_general.audience_not_specified" dataobj="required" class="col-sm-12"><h5><span data-ng-bind="\'SSC_GENERAL_AUDIENCE_TYPE\' | translate"></span></h5></div></div><div class="row"><div errorlabel="ssc_general.audience_not_specified" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_AUDIENCE_NOT_SPECIFIED\' | translate"></span> <span data-ng-if="required.ssc_general.audience_not_specified.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.audience_not_specified" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="null" ng-model="data.ssc_general.audience_not_specified" value="required.audience_not_specified" id="audience_not_specified" ng-checked="data.ssc_general.audience_not_specified === 1" ng-change="save(\'sscgeneral\', \'audience_not_specified\', data.ssc_general.audience_not_specified)"> <label class="checklabel" for="audience_not_specified"></label> <span data-ng-bind="data.ssc_general.audience_not_specified === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.audience_not_specified" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.audience_single_parent" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_AUDIENCE_SINGLE_PARENT\' | translate"></span> <span data-ng-if="required.ssc_general.audience_single_parent.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.audience_single_parent" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="null" ng-model="data.ssc_general.audience_single_parent" value="required.audience_single_parent" id="audience_single_parent" ng-checked="data.ssc_general.audience_single_parent === 1" ng-change="save(\'sscgeneral\', \'audience_single_parent\', data.ssc_general.audience_single_parent)"> <label class="checklabel" for="audience_single_parent"></label> <span data-ng-bind="data.ssc_general.audience_single_parent === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.audience_single_parent" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.audience_pensioner" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_AUDIENCE_PENSIONER\' | translate"></span> <span data-ng-if="required.ssc_general.audience_pensioner.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.audience_pensioner" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="null" ng-model="data.ssc_general.audience_pensioner" value="required.audience_pensioner" id="audience_pensioner" ng-checked="data.ssc_general.audience_pensioner === 1" ng-change="save(\'sscgeneral\', \'audience_pensioner\', data.ssc_general.audience_pensioner)"> <label class="checklabel" for="audience_pensioner"></label> <span data-ng-bind="data.ssc_general.audience_pensioner === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.audience_pensioner" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.audience_migration_background" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_AUDIENCE_MIGRATION_BACKGROUND\' | translate"></span> <span data-ng-if="required.ssc_general.audience_migration_background.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.audience_migration_background" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="null" ng-model="data.ssc_general.audience_migration_background" value="required.audience_migration_background" id="audience_migration_background" ng-checked="data.ssc_general.audience_migration_background === 1" ng-change="save(\'sscgeneral\', \'audience_migration_background\', data.ssc_general.audience_migration_background)"> <label class="checklabel" for="audience_migration_background"></label> <span data-ng-bind="data.ssc_general.audience_migration_background === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.audience_migration_background" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.audience_other" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_AUDIENCE_OTHER\' | translate"></span> <span data-ng-if="required.ssc_general.audience_other.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.audience_other" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="null" ng-model="data.ssc_general.audience_other" value="required.audience_other" id="audience_other" ng-checked="data.ssc_general.audience_other === 1" ng-change="save(\'sscgeneral\', \'audience_other\', data.ssc_general.audience_other)"> <label class="checklabel" for="audience_other"></label> <span data-ng-bind="data.ssc_general.audience_other === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_general.audience_other" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div class="col-sm-3 col-sm-offset-8"><span data-ng-bind="\'SSC_GENERAL_MULTIPLE_OPTIONS\' |translate"></span></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse3"><span data-ng-bind="\'SSC_GENERAL_HOUSEHOLD_SPECS\' | translate"></span></div><div class="row" ng-show="showerrorbox3"><div class="col-sm-12"><div class="errorfield margcreatetop margcreatebot"><div class="row hlabel"><span data-ng-bind="\'FORM_ERROR_TITLE\' | translate">Bitte alle Felder korrekt ausf\xFCllen</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.ssc_general"><div ng-if="key == \'persons\' || key == \'persons_under_6\' || key == \'persons_6_to_13\' || key == \'persons_14_to_17\' || key == \'persons_18_to_64\' || key == \'persons_from_65\'"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox3 = 1;value.error;}}</div><div ng-if="value.warning != null" class="warning"><span>{{$parent.$parent.$parent.showerrorbox3 = 1;value.warning;}}</span></div></div></div></div></div></div></div></div><div id="collapse3" class="collapse"><div class="row margcreatetop"><div errorlabel="ssc_general.persons" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_PERSONS\' | translate"></span> <span data-ng-if="required.ssc_general.persons.required">*</span><help-pop-over help="TIP_GENERAL_PERSONS"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_general.persons" dataobj="required"><input class="createinputter" ng-model="data.ssc_general.persons" forcedisabled="true"></div><div errorlabel="ssc.persons" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-sm-12 ilabel"><span data-ng-bind="\'SSC_GENERAL_RESPECTIVE\' | translate"></span></div></div><div class="row"><div errorlabel="ssc_general.persons_under_6" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_PERSONS_UNDER_6\' | translate"></span> <span data-ng-if="required.ssc_general.persons_under_6.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.persons_under_6" dataobj="required"><select class="createdropper" ng-model="data.ssc_general.persons_under_6" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'persons_under_6\', data.ssc_general.persons_under_6)"><option ng-value="n" ng-repeat="n in [0, 1, 2, 3, 4, 5]">{{n}}</option></select></div><div errorlabel="ssc_general.persons_under_6" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.persons_6_to_13" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_PERSONS_6_TO_13\' | translate"></span> <span data-ng-if="required.ssc_general.persons_6_to_13.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.persons_6_to_13" dataobj="required"><select class="createdropper" ng-model="data.ssc_general.persons_6_to_13" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'persons_6_to_13\', data.ssc_general.persons_6_to_13)"><option ng-value="n" ng-repeat="n in [0, 1, 2, 3, 4, 5]">{{n}}</option></select></div><div errorlabel="ssc_general.persons_6_to_13" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.persons_14_to_17" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_PERSONS_14_TO_17\' | translate"></span> <span data-ng-if="required.ssc_general.persons_14_to_17.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.persons_14_to_17" dataobj="required"><select class="createdropper" ng-model="data.ssc_general.persons_14_to_17" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'persons_14_to_17\', data.ssc_general.persons_14_to_17)"><option ng-value="n" ng-repeat="n in [0, 1, 2, 3, 4, 5]">{{n}}</option></select></div><div errorlabel="ssc_general.persons_14_to_17" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.persons_18_to_64" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_PERSONS_18_TO_64\' | translate"></span> <span data-ng-if="required.ssc_general.persons_18_to_64.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.persons_18_to_64" dataobj="required"><select class="createdropper" ng-model="data.ssc_general.persons_18_to_64" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'persons_18_to_64\', data.ssc_general.persons_18_to_64)"><option ng-value="n" ng-repeat="n in [0, 1, 2, 3, 4, 5]">{{n}}</option></select></div><div errorlabel="ssc_general.persons_18_to_64" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="ssc_general.persons_from_65" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_PERSONS_OVER_65\' | translate"></span> <span data-ng-if="required.ssc_general.persons_from_65.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.persons_from_65" dataobj="required"><select class="createdropper" ng-model="data.ssc_general.persons_from_65" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'persons_from_65\', data.ssc_general.persons_from_65)"><option ng-value="n" ng-repeat="n in [0, 1, 2, 3, 4, 5]">{{n}}</option></select></div><div errorlabel="ssc_general.persons_from_65" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse4"><span data-ng-bind="\'SSC_GENERAL_BUILDING_SPECS\' | translate"></span><help-pop-over help="TIP_GENERAL_BUILDING_SPECS"></help-pop-over></div><div class="row" ng-show="showerrorbox4"><div class="col-sm-12"><div class="errorfield margcreatetop margcreatebot"><div class="row hlabel"><span data-ng-bind="\'FORM_ERROR_TITLE\' | translate">Bitte alle Felder korrekt ausf\xFCllen</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.ssc_general"><div ng-if="key == \'count_flats_in_building\' || key == \'ssc_object_type_id\' || key == \'heated_area\' || key == \'use_time_per_year\' || key == \'total_consumption_heat\' || key == \'share_energy_warmwater\'"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox4 = 1;value.error;}}</div><div ng-if="value.warning != null" class="warning"><span>{{$parent.$parent.$parent.showerrorbox4 = 1;value.warning;}}</span></div></div></div></div></div></div></div></div><div id="collapse4" class="collapse"><div class="row margcreatetop"><div errorlabel="ssc_general.ssc_object_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_OBJECT_TYPE\' | translate"></span> <span data-ng-if="required.ssc_general.ssc_object_type_id.required">*</span><help-pop-over help="TIP_GENERAL_OBJECT_TYPE"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_general.ssc_object_type_id" dataobj="required"><select class="createdropper" ng-model="data.ssc_general.ssc_object_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'ssc_object_type_id\', data.ssc_general.ssc_object_type_id)"><option value=""></option><option ng-repeat="item in data.ssc_object_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_general.ssc_object_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.heated_area" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_HEATED_AREA\' | translate"></span> <span data-ng-if="required.ssc_general.heated_area.required">*</span><help-pop-over help="TIP_GENERAL_HEATED_AREA"></help-pop-over></div><div class="col-sm-6" errorlabel="ssc_general.heated_area" dataobj="required"><input class="createinputter" ng-model="data.ssc_general.heated_area" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'heated_area\', data.ssc_general.heated_area)" decimal-separator-german="" precision="2"></div><div class="col-xs-6 col-sm-1 ilabel">m\xB2</div><div errorlabel="ssc_general.heated_area" dataobj="required" class="col-xs-6 col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.use_time_per_year" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_USE_TIME_PER_YEAR\' | translate"></span> <span data-ng-if="required.ssc_general.use_time_per_year.required">*</span><help-pop-over help="TIP_GENERAL_USE_TIME_PER_YEAR"></help-pop-over></div><div class="col-sm-6" errorlabel="ssc_general.use_time_per_year" dataobj="required"><input class="createinputter" ng-model="data.ssc_general.use_time_per_year" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'use_time_per_year\', data.ssc_general.use_time_per_year)"></div><div class="col-xs-6 col-sm-1 ilabel">Tage</div><div errorlabel="ssc_general.use_time_per_year" dataobj="required" class="col-xs-6 col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.count_flats_in_building" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_FLATS_IN_BUILDING\' | translate"></span> <span data-ng-if="required.ssc_general.count_flats_in_building.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.count_flats_in_building" dataobj="required"><input class="createinputter" ng-model="data.ssc_general.count_flats_in_building" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'count_flats_in_building\', data.ssc_general.count_flats_in_building)"></div><div errorlabel="ssc_general.count_flats_in_building" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatebot"></div></div></div><div class="field" ng-show="!required.ssc_general.position_flat_house_comment.hidden"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse5"><span data-ng-bind="\'SSC_GENERAL_FLAT_LOCATION\' | translate"></span></div><div class="row" ng-show="showerrorbox5"><div class="col-sm-12"><div class="errorfield margcreatetop margcreatebot"><div class="row hlabel"><span data-ng-bind="\'FORM_ERROR_TITLE\' | translate">Bitte alle Felder korrekt ausf\xFCllen</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.ssc_general"><div ng-if="key == \'count_cold_outer_walls\' || key == \'cold_attic_yes_no_id\' || key == \'cold_basement_yes_no_id\' || key == \'position_flat_house_comment\' || key == \'position_flat_house_matrix\'"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox5 = 1;value.error;}}</div><div ng-if="value.warning != null" class="warning"><span>{{$parent.$parent.$parent.showerrorbox5 = 1;value.warning;}}</span></div></div></div></div></div></div></div></div><div id="collapse5" class="collapse"><div class="row margcreatetop"><div errorlabel="ssc_general.count_cold_outer_walls" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_COLD_OUTER_WALLS\' | translate"></span> <span data-ng-if="required.ssc_general.count_cold_outer_walls.required">*</span><help-pop-over help="TIP_GENERAL_COLD_OUTER_WALLS"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_general.count_cold_outer_walls" dataobj="required"><input class="createinputter" ng-model="data.ssc_general.count_cold_outer_walls" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'count_cold_outer_walls\', data.ssc_general.count_cold_outer_walls)"></div><div errorlabel="ssc_general.count_cold_outer_walls" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.cold_attic_yes_no_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_COLD_ATTIC\' | translate"></span> <span data-ng-if="required.ssc_general.cold_attic_yes_no_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.cold_attic_yes_no_id" dataobj="required"><select class="createdropper" ng-model="data.ssc_general.cold_attic_yes_no_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'cold_attic_yes_no_id\', data.ssc_general.cold_attic_yes_no_id)"><option value=""></option><option ng-repeat="item in data.ssc_yes_no_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_general.cold_attic_yes_no_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.cold_basement_yes_no_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_COLD_BASEMENT\' | translate"></span> <span data-ng-if="required.ssc_general.cold_basement_yes_no_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.cold_basement_yes_no_id" dataobj="required"><select class="createdropper" ng-model="data.ssc_general.cold_basement_yes_no_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'cold_basement_yes_no_id\', data.ssc_general.cold_basement_yes_no_id)"><option value=""></option><option ng-repeat="item in data.ssc_yes_no_answer_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_general.cold_basement_yes_no_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-sm-12 ilabel"><span data-ng-bind="\'SSC_GENERAL_POSITION_MARKS\' | translate"></span></div></div><div class="row margcreatebot"><div class="col-sm-7 ilabel" errorlabel="ssc_general.position_flat_house_comment" dataobj="required"><span data-ng-bind="\'SSC_GENERAL_POSITION_COMMENT\' | translate"></span> <textarea class="createinputter" ng-model="data.ssc_general.position_flat_house_comment" style="height:12em;" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'position_flat_house_comment\', data.ssc_general.position_flat_house_comment)"></textarea></div><div class="col-sm-5" errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input type="hidden" name="position_flat_house_matrix" ng-model="data.ssc_general.position_flat_house_matrix"><div class="house_wrapper"><div class="house_roof"><div class="house_roof_inner" errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h1" id="fw_lwh_h1" ng-click="update_flat_position()" ng-true-value="1" ng-false-value="0"></div></div><table class="house_body"><tbody><tr><td errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h2" id="fw_lwh_h2" ng-true-value="1" ng-false-value="0" ng-click="update_flat_position()" ng-checked="position_flat_house_matrix.fw_lwh_h2 == 1"></td><td errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h3" id="fw_lwh_h3" ng-true-value="1" ng-false-value="0" ng-change="update_flat_position()" ng-checked="position_flat_house_matrix.fw_lwh_h3 == 1"></td><td errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h4" id="fw_lwh_h4" ng-true-value="1" ng-false-value="0" ng-change="update_flat_position()" ng-checked="position_flat_house_matrix.fw_lwh_h4 == 1"></td></tr><tr><td errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h5" id="fw_lwh_h5" ng-true-value="1" ng-false-value="0" ng-change="update_flat_position()" ng-checked="position_flat_house_matrix.fw_lwh_h5 == 1"></td><td errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h6" id="fw_lwh_h6" ng-true-value="1" ng-false-value="0" ng-change="update_flat_position()" ng-checked="position_flat_house_matrix.fw_lwh_h6 == 1"></td><td errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h7" id="fw_lwh_h7" ng-true-value="1" ng-false-value="0" ng-change="update_flat_position()" ng-checked="position_flat_house_matrix.fw_lwh_h7 == 1"></td></tr><tr><td errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h8" id="fw_lwh_h8" ng-true-value="1" ng-false-value="0" ng-change="update_flat_position()" ng-checked="position_flat_house_matrix.fw_lwh_h8 == 1"></td><td errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h9" id="fw_lwh_h9" ng-true-value="1" ng-false-value="0" ng-change="update_flat_position()" ng-checked="position_flat_house_matrix.fw_lwh_h9 == 1"></td><td errorlabel="ssc_general.position_flat_house_matrix" dataobj="required"><input style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h10" id="fw_lwh_h10" ng-true-value="1" ng-false-value="0" ng-change="update_flat_position()" ng-checked="position_flat_house_matrix.fw_lwh_h10 == 1"></td></tr><tr><td errorlabel="ssc_general.position_flat_house_matrix" dataobj="required" colspan="3"><input class="basement" style="width:auto;" type="checkbox" ng-model="position_flat_house_matrix.fw_lwh_h11" id="fw_lwh_h11" ng-change="update_flat_position()" ng-true-value="1" ng-false-value="0" ng-checked="position_flat_house_matrix.fw_lwh_h11 == 1"></td></tr></tbody></table></div></div></div></div></div><div class="field" ng-hide="required.ssc_general.has_windowed_bath.hidden == true"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse6"><span data-ng-bind="\'SSC_GENERAL_WINDOWS_AND_DOORS\' | translate"></span><help-pop-over help="TIP_GENERAL_WINDOWS_AND_DOORS"></help-pop-over></div><div class="row" ng-show="showerrorbox6"><div class="col-sm-12"><div class="errorfield margcreatetop margcreatebot"><div class="row hlabel"><span data-ng-bind="\'FORM_ERROR_TITLE\' | translate">Bitte alle Felder korrekt ausf\xFCllen</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.ssc_general"><div ng-if="key == \'has_windowed_bath\' || key == \'has_ventilated_bath\' || key == \'count_windows\' || key == \'count_leaky_windows\' || key == \'count_doors\' || key == \'count_leaky_doors\' || key == \'cross_ventilation\'"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox6 = 1; value.error;}}</div><div ng-if="value.warning != null" class="warning"><span>{{$parent.$parent.$parent.showerrorbox6 = 1; value.warning;}}</span></div></div></div></div></div></div></div></div><div id="collapse6" class="collapse"><div class="row margcreatetop"><div errorlabel="ssc_general.has_windowed_bath" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_HAS_WINDOWED_BATH\' | translate"></span> <span data-ng-if="required.ssc_general.has_windowed_bath.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.has_windowed_bath" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc_general.has_windowed_bath" value="required.has_windowed_bath" id="has_windowed_bath" ng-checked="data.ssc_general.has_windowed_bath === 1" ng-change="save(\'sscgeneral\', \'has_windowed_bath\', data.ssc_general.has_windowed_bath)"> <label class="checklabel" for="has_windowed_bath"></label> <span data-ng-bind="data.ssc_general.has_windowed_bath === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row"><div errorlabel="ssc_general.has_ventilated_bath" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_HAS_VENTILATED_BATH\' | translate"></span> <span data-ng-if="required.ssc_general.has_ventilated_bath.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.has_ventilated_bath" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc_general.has_ventilated_bath" value="required.has_ventilated_bath" id="has_ventilated_bath" ng-checked="data.ssc_general.has_ventilated_bath === 1" ng-change="save(\'sscgeneral\', \'has_ventilated_bath\', data.ssc_general.has_ventilated_bath)"> <label class="checklabel" for="has_ventilated_bath"></label> <span data-ng-bind="data.ssc_general.has_ventilated_bath === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row"><div errorlabel="ssc_general.count_windows" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_COUNT_WINDOWS\' | translate"></span> <span data-ng-if="required.ssc_general.count_windows.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.count_windows" dataobj="required"><input class="createinputter" ng-model="data.ssc_general.count_windows" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'count_windows\', data.ssc_general.count_windows)"></div><div errorlabel="ssc_general.count_windows" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.count_leaky_windows" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_COUNT_LEAKY_WINDOWS\' | translate"></span> <span data-ng-if="required.ssc_general.count_leaky_windows.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.count_leaky_windows" dataobj="required"><input class="createinputter" ng-model="data.ssc_general.count_leaky_windows" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'count_leaky_windows\', data.ssc_general.count_leaky_windows)"></div><div errorlabel="ssc_general.count_leaky_windows" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.count_doors" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_COUNT_DOORS\' | translate"></span> <span data-ng-if="required.ssc_general.count_doors.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.count_doors" dataobj="required"><input class="createinputter" ng-model="data.ssc_general.count_doors" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'count_doors\', data.ssc_general.count_doors)"></div><div errorlabel="ssc_general.count_doors" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_general.count_leaky_doors" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_COUNT_LEAKY_DOORS\' | translate"></span> <span data-ng-if="required.ssc_general.count_leaky_doors.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.count_leaky_doors" dataobj="required"><input class="createinputter" ng-model="data.ssc_general.count_leaky_doors" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscgeneral\', \'count_leaky_doors\', data.ssc_general.count_leaky_doors)"></div><div errorlabel="ssc_general.count_leaky_doors" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatebot"><div errorlabel="ssc_general.cross_ventilation" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_GENERAL_CROSS_VENTILATION\' | translate"></span> <span data-ng-if="required.ssc_general.cross_ventilation.required">*</span></div><div class="col-sm-3" errorlabel="ssc_general.cross_ventilation" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc_general.cross_ventilation" value="required.cross_ventilation" id="cross_ventilation" ng-checked="data.ssc_general.cross_ventilation === 1" ng-change="save(\'sscgeneral\', \'cross_ventilation\', data.ssc_general.cross_ventilation)"> <label class="checklabel" for="cross_ventilation"></label> <span data-ng-bind="data.ssc_general.cross_ventilation === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse8"><span data-ng-bind="\'SSC_GENERAL_KNOWN_FAULTS\' | translate"></span><help-pop-over help="TIP_GENERAL_KNOWN_FAULTS"></help-pop-over></div><div class="row" ng-show="showerrorbox6"><div class="col-sm-12"><div class="errorfield margcreatetop margcreatebot"><div class="row hlabel"><span data-ng-bind="\'FORM_ERROR_TITLE\' | translate">Bitte alle Felder korrekt ausf\xFCllen</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.ssc_general"><div ng-if="key == \'has_no_thermostatventiles\' || key == \'has_mould_formation\' || key == \'has_single_glazed_windows\' || key == \'has_untight_windows\'"><div ng-if="value.error != null">{{$parent.$parent.$parent.showerrorbox8 = 1;value.error;}}</div><div ng-if="value.warning != null" class="warning"><span>{{$parent.$parent.$parent.showerrorbox8 = 1; value.warning;}}</span></div></div></div></div></div></div></div></div><div id="collapse8" class="collapse"><div class="row margcreatetop"><div errorlabel="ssc_general.has_no_thermostatventiles" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_NO_THERMOSTATVENTILES\' | translate"></span> <span data-ng-if="required.ssc_general.has_no_thermostatventiles.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.has_no_thermostatventiles" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc_general.has_no_thermostatventiles" value="required.has_no_thermostatventiles" id="has_no_thermostatventiles" ng-checked="data.ssc_general.has_no_thermostatventiles === 1" ng-change="save(\'sscgeneral\', \'has_no_thermostatventiles\', data.ssc_general.has_no_thermostatventiles)"> <label class="checklabel" for="has_no_thermostatventiles"></label> <span data-ng-bind="data.ssc_general.has_no_thermostatventiles === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row"><div errorlabel="ssc_general.has_mould_formation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_MOULD_FORMATION\' | translate"></span> <span data-ng-if="required.ssc_general.has_mould_formation.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.has_mould_formation" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc_general.has_mould_formation" value="required.has_mould_formation" id="has_mould_formation" ng-checked="data.ssc_general.has_mould_formation === 1" ng-change="save(\'sscgeneral\', \'has_mould_formation\', data.ssc_general.has_mould_formation)"> <label class="checklabel" for="has_mould_formation"></label> <span data-ng-bind="data.ssc_general.has_mould_formation === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row"><div errorlabel="ssc_general.has_single_glazed_windows" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_SINGLE_GLAZED_WINDOWS\' | translate"></span> <span data-ng-if="required.ssc_general.has_single_glazed_windows.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.has_single_glazed_windows" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc_general.has_single_glazed_windows" value="required.has_single_glazed_windows" id="has_single_glazed_windows" ng-checked="data.ssc_general.has_single_glazed_windows === 1" ng-change="save(\'sscgeneral\', \'has_single_glazed_windows\', data.ssc_general.has_single_glazed_windows)"> <label class="checklabel" for="has_single_glazed_windows"></label> <span data-ng-bind="data.ssc_general.has_single_glazed_windows === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row margcreatebot"><div errorlabel="ssc_general.has_untight_windows" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_GENERAL_UNTIGHT_WINDOWS\' | translate"></span> <span data-ng-if="required.ssc_general.has_untight_windows.required">*</span></div><div class="col-sm-7" errorlabel="ssc_general.has_untight_windows" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc_general.has_untight_windows" value="required.has_untight_windows" id="has_untight_windows" ng-checked="data.ssc_general.has_untight_windows === 1" ng-change="save(\'sscgeneral\', \'has_untight_windows\', data.ssc_general.has_untight_windows)"> <label class="checklabel" for="has_untight_windows"></label> <span data-ng-bind="data.ssc_general.has_untight_windows === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/heat/heat.html','<div data-ng-controller="heatController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'SSC_TILE_HEAT_SH\' | translate) +\' - \'+ (\'SSC_TILE_HEAT\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordeon1" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse-room-prediction"><span data-ng-bind="\'SSC_HEAT_ROOM_PREDICTION_TITLE\' | translate" ng-class="{\'error\': errors.clip.hasError, \'warning\': !errors.clip.hasError && errors.clip.hasWarning}"></span><help-pop-over help="TIP_HEAT_SAVINGS"></help-pop-over></div><div id="collapse-room-prediction" class="collapse in"><ssc-errorbox data-messages="errors.prediction.messages"></ssc-errorbox><ssc-errorbox data-messages="errors.prediction_total.messages"></ssc-errorbox><div class="margcreatetop"></div><div class="row hidden-xs" ng-if="properties.ssc_heat.room_savings_percent.hidden"><div class="col-sm-3 ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_ROOM\' | translate"></span></div><div class="col-sm-3 ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_CONSUMPTION\' | translate"></span></div><div class="col-sm-6 ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_SAVINGS\' | translate"></span></div></div><div class="row" ng-repeat="(roomIndex, room) in content.ssc_heat_room_prediction track by room.id" ng-if="properties.ssc_heat.room_savings_percent.hidden"><div class="visible-xs flabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_ROOM\' | translate"></span> <span>{{ roomIndex + 1}}</span></div><div class="col-xs-12 visible-xs ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_ROOM\' | translate"></span></div><div class="col-sm-3" errorlabel="ssc_heat_room_prediction[roomIndex].room_id" dataobj="properties"><input class="createinputter" ng-model="room.room_name" forcedisabled="true"></div><div class="col-xs-12 visible-xs ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_CONSUMPTION\' | translate"></span></div><div class="col-sm-2 col-xs-11" errorlabel="ssc_heat_room_prediction[roomIndex].consumption_kwh" dataobj="properties"><input class="createinputter" ng-model="room.consumption_kwh" data-precision="0" forcedisabled="true" decimal-separator-german=""></div><div class="col-xs-1 ilabel no-padd" errorlabel="ssc_heat_room_prediction[roomIndex].consumption_kwh" dataobj="properties">kWh</div><div class="col-xs-12 visible-xs ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_SAVINGS\' | translate"></span></div><div class="col-sm-2 col-xs-11" errorlabel="ssc_heat_room_prediction[roomIndex].savings_prediction_percent" dataobj="properties"><input class="createinputter" ng-model="room.savings_prediction_percent" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheatroomprediction\', \'savings_prediction_percent\', room.savings_prediction_percent, room.id)" data-precision="0" decimal-separator-german=""></div><div class="col-xs-1 ilabel no-padd" errorlabel="ssc_heat_room_prediction[roomIndex].savings_prediction_percent" dataobj="properties">%</div><div class="col-sm-2 col-xs-11" errorlabel="ssc_heat_room_prediction[roomIndex].savings_prediction_kwh" dataobj="properties"><input class="createinputter" ng-model="room.savings_prediction_kwh" data-precision="0" forcedisabled="true" decimal-separator-german=""></div><div class="col-xs-1 ilabel no-padd" errorlabel="ssc_heat_room_prediction[roomIndex].savings_prediction_kwh" dataobj="properties">kWh</div></div><div class="row hidden-xs" ng-if="!properties.ssc_heat.room_savings_percent.hidden"><div class="col-sm-3 ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_CONSUMPTION_VB\' | translate"></span></div><div class="col-sm-3 ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_PROPORTION_ADVICE\' | translate"></span></div><div class="col-sm-6 ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_SAVINGS_VB\' | translate"></span></div></div><div class="row" ng-if="!properties.ssc_heat.room_savings_percent.hidden"><div class="col-xs-12 visible-xs ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_CONSUMPTION_VB\' | translate"></span></div><div class="col-xs-11 col-sm-2" errorlabel="ssc_heat.room_consumption_total" dataobj="properties"><input class="createinputter" ng-model="content.ssc_heat.room_consumption_total" data-precision="0" forcedisabled="true" decimal-separator-german=""></div><div class="col-xs-1 ilabel no-padd">kWh</div><div class="col-xs-12 visible-xs ilabel" errorlabel="ssc_heat.room_proportion_advice" dataobj="properties"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_PROPORTION_ADVICE\' | translate"></span></div><div class="col-xs-11 col-sm-2" errorlabel="ssc_heat.room_proportion_advice" dataobj="properties"><input class="createinputter" ng-model="content.ssc_heat.room_proportion_advice" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'room_proportion_advice\', content.ssc_heat.room_proportion_advice, content.ssc_heat.id)" data-precision="0" decimal-separator-german=""></div><div class="col-xs-1 ilabel no-padd">%</div><div class="col-xs-12 visible-xs ilabel" errorlabel="ssc_heat.room_savings_percent" dataobj="properties"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_SAVINGS_VB\' | translate"></span></div><div class="col-xs-11 col-sm-2" errorlabel="ssc_heat.room_savings_percent" dataobj="properties"><input class="createinputter" ng-model="content.ssc_heat.room_savings_percent" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'room_savings_percent\', content.ssc_heat.room_savings_percent, content.ssc_heat.id)" data-precision="0" decimal-separator-german=""></div><div class="col-xs-1 ilabel no-padd">%</div><div class="col-xs-11 col-sm-2" errorlabel="ssc_heat.room_savings_total" dataobj="properties"><input class="createinputter" ng-model="content.ssc_heat.room_savings_total" data-precision="0" forcedisabled="true" decimal-separator-german=""></div><div class="col-xs-1 ilabel no-padd">kWh</div></div><div class="row" ng-if="properties.ssc_heat.room_savings_percent.hidden"><div class="col-sm-3 ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_CONSUMPTION_TOTAL\' | translate"></span></div><div class="col-xs-11 col-sm-2" errorlabel="ssc_heat.room_consumption_total" dataobj="properties"><input class="createinputter" ng-model="content.ssc_heat.room_consumption_total" data-precision="0" forcedisabled="true" decimal-separator-german=""></div><div class="col-xs-1 ilabel no-padd">kWh</div><div class="col-sm-3 ilabel"><span ng-bind="\'SSC_HEAT_ROOM_PREDICTION_SAVINGS_TOTAL\' | translate"></span></div><div class="col-xs-11 col-sm-2" errorlabel="ssc_heat.room_savings_total" dataobj="properties"><input class="createinputter" ng-model="content.ssc_heat.room_savings_total" data-precision="0" forcedisabled="true" decimal-separator-german=""></div><div class="col-xs-1 ilabel no-padd">kWh</div></div><div class="margcreatebot"></div></div></div><div class="field" ng-if="content.ssc_heat.ssc_installed_clip.length > 0"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion1" href="#collapse1"><span data-ng-bind="\'SSC_HEAT_DIRECTHELP_INFO\' | translate" ng-class="{\'error\': errors.clip.hasError, \'warning\': !errors.clip.hasError && errors.clip.hasWarning}"></span><help-pop-over help="TIP_HEAT_DIRECTHELP_INFO"></help-pop-over></div><div id="collapse1" class="collapse"><ssc-errorbox data-messages="errors.clip.messages"></ssc-errorbox><div class="row" ng-repeat="item in content.ssc_heat.ssc_installed_clip track by $index" on-finish-render="broadcastErrorUpdate()"><div class="col-sm-2" errorlabel="ssc_heat.ssc_installed_clip.{{$index}}.ssc_room_type_id" dataobj="required"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_ROOM_TYPE\' | translate"></span></div><select class="createdropper" ng-model="content.ssc_heat.ssc_installed_clip[$index].ssc_room_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscinstalledclip\', \'ssc_room_type_id\', content.ssc_heat.ssc_installed_clip[$index].ssc_room_type_id, item.id)"><option value=""></option><option ng-repeat="item_room in content.ssc_room_type" ng-value="item_room.id" data-ng-bind="item_room.name"></option></select></div><div class="col-sm-2" errorlabel="ssc_heat.ssc_installed_clip.{{$index}}.heating_directhelp_id" dataobj="required"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_DIRECTHELP_TYPE\' | translate"></span></div><select class="createdropper" ng-model="content.ssc_heat.ssc_installed_clip[$index].heating_directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscinstalledclip\', \'heating_directhelp_id\', content.ssc_heat.ssc_installed_clip[$index].heating_directhelp_id, item.id)"><option value=""></option><option ng-repeat="item_type in content.clip_directhelp" ng-value="item_type.id" ng-disabled="item_type.status == 0" data-ng-bind="item_type.description"></option></select></div><div class="col-sm-4" errorlabel="ssc_heat.ssc_installed_clip.{{$index}}.thermostat_before" dataobj="required"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_THERMOSTAT_BEFORE_CHANGE\' | translate"></span></div><input class="createinputter" ng-model="content.ssc_heat.ssc_installed_clip[$index].thermostat_before" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscinstalledclip\', \'thermostat_before\', content.ssc_heat.ssc_installed_clip[$index].thermostat_before, item.id)" decimal-separator-german="" data-precision="2"></div><div class="col-sm-4"><div class="row no-pad"><div class="col-xs-10" errorlabel="ssc_heat.ssc_installed_clip.{{$index}}.thermostat_after" dataobj="required"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_THERMOSTAT_AFTER_CHANGE\' | translate"></span></div><input class="createinputter" ng-model="content.ssc_heat.ssc_installed_clip[$index].thermostat_after" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscinstalledclip\', \'thermostat_after\', content.ssc_heat.ssc_installed_clip[$index].thermostat_after, item.id)" decimal-separator-german="" data-precision="2"></div><div class="col-xs-2 delete-heat-button-xs" ng-class="$index === 0 ? \'delete-heat-button-lg\': \'\'"><ssc-delete-button delete-enabled="tableProperties.ssc_installed_clip.canDelete" delete-onclick="delete(\'sscinstalledclip\', $index, item.id)" delete-class="sscDeleteVertAlign"></ssc-delete-button></div></div></div><hr class="hidden-sm hidden-lg hidden-md"></div><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_installed_clip_button\']" add-onclick="addRow(\'ssc_installed_clip\', content.ssc_heat.id, \'add_ssc_installed_clip_button\')" add-enabled="tableProperties.ssc_installed_clip.canCreate" add-label="SSC_HEAT_ADD_ROOM"></ssc-add-button></div></div></div></div><div class="field" ng-if="content.ssc_heat.ssc_installed_shutter_strap_seal.length > 0"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse2"><span data-ng-bind="\'SSC_HEAT_SHUTTER_STRAP_SEALS\' | translate" ng-class="{\'error\': errors.shutterStrapSeal.hasError, \'warning\': !errors.shutterStrapSeal.hasError && errors.shutterStrapSeal.hasWarning}"></span></div><div id="collapse2" class="collapse"><ssc-errorbox data-messages="errors.shutterStrapSeal.messages"></ssc-errorbox><div class="row" ng-repeat="item in content.ssc_heat.ssc_installed_shutter_strap_seal track by $index" on-finish-render="broadcastErrorUpdate()"><div class="col-sm-4" errorlabel="ssc_heat.ssc_installed_shutter_strap_seal.{{$index}}.directhelp_id" dataobj="required"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_SEAL_TAPE_TYPE\' | translate"></span></div><select class="createdropper" ng-model="content.ssc_heat.ssc_installed_shutter_strap_seal[$index].directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscinstalledshutterstrapseal\', \'directhelp_id\', content.ssc_heat.ssc_installed_shutter_strap_seal[$index].directhelp_id, item.id)"><option value=""></option><option ng-repeat="item_type in content.strap_seal_directhelp" ng-value="item_type.id" ng-disabled="item_type.status == 0" data-ng-bind="item_type.description"></option></select></div><div class="col-sm-4" errorlabel="ssc_heat.ssc_installed_shutter_strap_seal.{{$index}}.ssc_room_type_id" dataobj="required"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_SEAL_TAPE_ROOM\' | translate"></span></div><select class="createdropper" ng-model="content.ssc_heat.ssc_installed_shutter_strap_seal[$index].ssc_room_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscinstalledshutterstrapseal\', \'ssc_room_type_id\', content.ssc_heat.ssc_installed_shutter_strap_seal[$index].ssc_room_type_id, item.id)"><option value=""></option><option ng-repeat="item_room in content.ssc_room_type" ng-value="item_room.id" data-ng-bind="item_room.name"></option></select></div><div class="col-sm-4"><div class="row no-pad"><div class="col-xs-10" errorlabel="ssc_heat.ssc_installed_shutter_strap_seal.{{$index}}.count_strap"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_SEAL_TAPE_COUNT\' | translate"></span></div><input dataobj="required" class="createinputter" ng-model="content.ssc_heat.ssc_installed_shutter_strap_seal[$index].count_strap" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscinstalledshutterstrapseal\', \'count_strap\', content.ssc_heat.ssc_installed_shutter_strap_seal[$index].count_strap, item.id)"></div><div class="col-xs-2 delete-heat-button-xs" ng-class="$index === 0 ? \'delete-heat-button-lg\' : \'\'"><ssc-delete-button delete-enabled="tableProperties.ssc_installed_shutter_strap_seal.canDelete" delete-onclick="delete(\'sscinstalledshutterstrapseal\', $index, item.id)" delete-class="sscDeleteVertAlign"></ssc-delete-button></div></div></div><hr class="hidden-sm hidden-lg hidden-md"></div><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_installed_shutter_strap_seal_button\']" add-onclick="addRow(\'ssc_installed_shutter_strap_seal\', content.ssc_heat.id, \'add_ssc_installed_shutter_strap_seal_button\')" add-enabled="tableProperties.ssc_installed_shutter_strap_seal.canCreate" add-label="SSC_HEAT_ADD_ROOM"></ssc-add-button></div></div></div></div><div class="field"><div class="panel-heading hlabel ng-binding ng-scope accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse3"><span data-ng-bind="\'SSC_HEAT_SEAL_TAPE\' | translate" ng-class="{\'error\': errors.sealTape.hasError, \'warning\': !errors.sealTape.hasError && errors.sealTape.hasWarning}"></span><help-pop-over help="TIP_HEAT_SEAL_TAPE"></help-pop-over></div><div id="collapse3" class="collapse"><ssc-errorbox data-messages="errors.sealTape.messages"></ssc-errorbox><div class="margcreatetop"></div><div class="row"><div class="row"><div errorlabel="ssc_heat.seal_tape_install_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_SEAL_TAPE_AFFECTED_DOORS\' | translate"></span> <span data-ng-if="properties.ssc_heat.seal_tape_install_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_heat.seal_tape_install_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_heat.seal_tape_install_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'seal_tape_install_type_id\', content.ssc_heat.seal_tape_install_type_id, content.ssc_heat.id)"><option value=""></option><option ng-repeat="item in content.ssc_seal_tape_install_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_heat.seal_tape_room_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_SEAL_TAPE_ROOM\' | translate"></span> <span data-ng-if="properties.ssc_heat.seal_tape_room_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_heat.seal_tape_room_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_heat.seal_tape_room_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'seal_tape_room_type_id\', content.ssc_heat.seal_tape_room_type_id, content.ssc_heat.id)"><option value=""></option><option ng-repeat="item in content.ssc_room_type_seal_tape" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_heat.seal_tape_room_other" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_SEAL_TAPE_ROOM_OTHER\' | translate"></span> <span data-ng-if="properties.ssc_heat.seal_tape_room_other.required">*</span></div><div class="col-sm-7" errorlabel="ssc_heat.seal_tape_room_other" dataobj="required"><input class="createinputter" ng-model="content.ssc_heat.seal_tape_room_other" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'seal_tape_room_other\', content.ssc_heat.seal_tape_room_other, content.ssc_heat.id)"></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_heat.seal_tape_length" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_SEAL_TAPE_LENGTH\' | translate"></span> <span data-ng-if="properties.ssc_heat.seal_tape_length.required">*</span></div><div class="col-sm-6" errorlabel="ssc_heat.seal_tape_length" dataobj="required"><input class="createinputter" ng-model="content.ssc_heat.seal_tape_length" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'seal_tape_length\', content.ssc_heat.seal_tape_length, content.ssc_heat.id)" decimal-separator-german="" data-precision="2"></div><div class="col-md-2 ilabel">m</div></div></div><div class="row"><div class="row"><div errorlabel="ssc_heat.seal_tape_packages" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_SEAL_TAPE_PACKAGES\' | translate"></span> <span data-ng-if="properties.ssc_heat.seal_tape_packages.required">*</span></div><div class="col-sm-7" errorlabel="ssc_heat.seal_tape_packages" dataobj="required"><input class="createinputter" ng-model="content.ssc_heat.seal_tape_packages" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'seal_tape_packages\', content.ssc_heat.seal_tape_packages, content.ssc_heat.id)" data-precision="0"></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_heat.seal_tape_directhelp_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_SEAL_TAPE_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_heat.seal_tape_directhelp_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_heat.seal_tape_directhelp_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_heat.seal_tape_directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'seal_tape_directhelp_id\', content.ssc_heat.seal_tape_directhelp_id, content.ssc_heat.id)"><option value=""></option><option ng-repeat="item in content.sealing_tape_directhelp" ng-value="item.id" ng-disabled="item.status == 0" data-ng-bind="item.description"></option></select></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_heat.seal_tape_gap_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_SEAL_TAPE_GAP_WIDTH_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_heat.seal_tape_gap_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_heat.seal_tape_gap_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_heat.seal_tape_gap_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'seal_tape_gap_type_id\', content.ssc_heat.seal_tape_gap_type_id, content.ssc_heat.id)"><option value=""></option><option ng-repeat="item in content.ssc_sealing_tape_gap_width_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div></div><div class="margcreatetop"></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse4"><span data-ng-bind="\'SSC_HEAT_THERMOHYGROMETER\' | translate" ng-class="{\'error\': errors.thermo.hasError, \'warning\': !errors.thermo.hasError && errors.thermo.hasWarning}"></span><help-pop-over help="TIP_HEAT_THERMOHYGROMETER"></help-pop-over></div><div id="collapse4" class="collapse"><ssc-errorbox data-messages="errors.thermo.messages"></ssc-errorbox><div class="margcreatetop"></div><div class="row"><div class="row"><div errorlabel="ssc_heat.thermohygro_analog_directhelp_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_HAS_THERMOHYGROMETER_ANALOG\' | translate"></span> <span data-ng-if="properties.ssc_heat.thermohygro_analog_directhelp_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_heat.thermohygro_analog_directhelp_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_heat.thermohygro_analog_directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'thermohygro_analog_directhelp_id\', content.ssc_heat.thermohygro_analog_directhelp_id, content.ssc_heat.id)"><option value=""></option><option ng-repeat="item in content.thermo_analog_directhelp" ng-value="item.id" ng-disabled="item.status == 0" data-ng-bind="item.description"></option></select></div></div></div><div class="row"><div class="row"><div errorlabel="ssc_heat.thermohygro_digital_directhelp_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_HAS_THERMOHYGROMETER_DIGITAL\' | translate"></span> <span data-ng-if="properties.ssc_heat.thermohygro_digital_directhelp_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_heat.thermohygro_digital_directhelp_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_heat.thermohygro_digital_directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'thermohygro_digital_directhelp_id\', content.ssc_heat.thermohygro_digital_directhelp_id, content.ssc_heat.id)"><option value=""></option><option ng-repeat="item in content.thermo_digital_directhelp" ng-value="item.id" ng-disabled="item.status == 0" data-ng-bind="item.description"></option></select></div></div></div><div class="row" ng-repeat="item in content.ssc_heat.ssc_thermohygrometer track by $index" on-finish-render="broadcastErrorUpdate()"><div class="col-sm-2" errorlabel="ssc_heat.ssc_thermohygrometer.{{$index}}.ssc_room_type_id" dataobj="required"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_ROOM_TYPE\' | translate"></span></div><select class="createdropper" ng-model="content.ssc_heat.ssc_thermohygrometer[$index].ssc_room_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscthermohygrometer\', \'ssc_room_type_id\', content.ssc_heat.ssc_thermohygrometer[$index].ssc_room_type_id, item.id)"><option value=""></option><option ng-repeat="item_room in content.ssc_room_type" ng-value="item_room.id" data-ng-bind="item_room.name"></option></select></div><div class="col-sm-2" errorlabel="ssc_heat.ssc_thermohygrometer.{{$index}}.temperature" dataobj="required"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_TEMPERATURE\' | translate"></span></div><input class="createinputter" ng-model="content.ssc_heat.ssc_thermohygrometer[$index].temperature" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscthermohygrometer\', \'temperature\', content.ssc_heat.ssc_thermohygrometer[$index].temperature, item.id)" decimal-separator-german="" precision="1"></div><div class="col-sm-2" errorlabel="ssc_heat.ssc_thermohygrometer.{{$index}}.humidity" dataobj="required"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_HUMIDITY\' | translate"></span></div><input class="createinputter" ng-model="content.ssc_heat.ssc_thermohygrometer[$index].humidity" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscthermohygrometer\', \'humidity\', content.ssc_heat.ssc_thermohygrometer[$index].humidity, item.id)" decimal-separator-german="" precision="1"></div><div class="col-sm-6"><div class="row no-pad"><div class="col-xs-10" errorlabel="ssc_heat.ssc_thermohygrometer.{{$index}}.climatic_situation_type_id" dataobj="required"><div class="grid-label" ng-class="$index === 0 ? \'\' : \'hidden-sm hidden-lg hidden-md\'"><span class="ilabel" data-ng-bind="\'SSC_HEAT_CLIMATIC_SITUATION_TYPE\' | translate"></span></div><select class="createdropper" ng-model="content.ssc_heat.ssc_thermohygrometer[$index].climatic_situation_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscthermohygrometer\', \'climatic_situation_type_id\', content.ssc_heat.ssc_thermohygrometer[$index].climatic_situation_type_id, item.id)"><option value=""></option><option ng-repeat="item_room in content.ssc_thermohygrometer_climatic_situation_type" ng-value="item_room.id" data-ng-bind="item_room.name"></option></select></div><div class="col-xs-2 delete-heat-button-xs" ng-class="$index === 0 ? \'delete-heat-button-lg\': \'\'"><ssc-delete-button delete-enabled="tableProperties.ssc_thermohygrometer.canDelete" delete-onclick="delete(\'sscthermohygrometer\', $index, item.id)" delete-class="sscDeleteVertAlign"></ssc-delete-button></div></div></div><hr class="hidden-sm hidden-lg hidden-md"></div><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_thermohygrometer_button\']" add-onclick="addRow(\'ssc_thermohygrometer\', content.ssc_heat.id, \'add_ssc_thermohygrometer_button\')" add-enabled="tableProperties.ssc_thermohygrometer.canCreate" add-label="SSC_HEAT_ADD_ROOM"></ssc-add-button></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse5"><span data-ng-bind="\'SSC_HEAT_DOOR_BRUSHES\' | translate" ng-class="{\'error\': errors.doorBrush.hasError, \'warning\': !errors.doorBrush.hasError && errors.doorBrush.hasWarning}"></span><help-pop-over help="TIP_HEAT_DOOR_BRUSHES"></help-pop-over></div><div id="collapse5" class="collapse"><ssc-errorbox data-messages="errors.doorBrush.messages"></ssc-errorbox><div class="margcreatetop" ng-if="content.ssc_heat.ssc_installed_door_brush.length > 0"></div><div class="row" ng-repeat="item in content.ssc_heat.ssc_installed_door_brush track by $index" on-finish-render="broadcastErrorUpdate()"><div errorlabel="ssc_heat.ssc_installed_door_brush.{{$index}}.directhelp_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HEAT_DOOR_BRUSHES_N\' | translate:{nr: $index + 1}"></span> <span data-ng-if="properties.ssc_heat.ssc_installed_door_brush[$index].directhelp_id.required">*</span></div><div class="col-sm-5" errorlabel="ssc_heat.ssc_installed_door_brush.{{$index}}.directhelp_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_heat.ssc_installed_door_brush[$index].directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscinstalleddoorbrush\', \'directhelp_id\', content.ssc_heat.ssc_installed_door_brush[$index].directhelp_id, content.ssc_heat.ssc_installed_door_brush[$index].id,content.ssc_heat.id)"><option value=""></option><option ng-repeat="doorbrush in content.door_brush_directhelp" ng-value="doorbrush.id" ng-disabled="doorbrush.status == 0" data-ng-bind="doorbrush.description"></option></select></div><div class="col-xs-10 col-sm-2" errorlabel="ssc_heat.ssc_installed_door_brush.{{$index}}.temperature_difference"><input dataobj="required" class="createinputter" ng-model="content.ssc_heat.ssc_installed_door_brush[$index].temperature_difference" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscinstalleddoorbrush\', \'temperature_difference\', content.ssc_heat.ssc_installed_door_brush[$index].temperature_difference, content.ssc_heat.ssc_installed_door_brush[$index].id)" decimal-separator-german="" precision="1"></div><div class="col-xs-2 col-sm-1 ilabel">Grad</div><div class="col-xs-10 col-sm-7" errorlabel="ssc_heat.ssc_installed_door_brush.{{$index}}.ssc_room_type_id" dataobj="required"><select class="createdropper" ng-model="content.ssc_heat.ssc_installed_door_brush[$index].ssc_room_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscinstalleddoorbrush\', \'ssc_room_type_id\', content.ssc_heat.ssc_installed_door_brush[$index].ssc_room_type_id, content.ssc_heat.ssc_installed_door_brush[$index].id,content.ssc_heat.id)"><option value=""></option><option ng-repeat="roomtype in content.ssc_room_type_heat" ng-value="roomtype.id" data-ng-bind="roomtype.name"></option></select></div><div class="col-xs-2 col-sm-1"><ssc-delete-button delete-enabled="tableProperties.ssc_installed_door_brush.canDelete" delete-onclick="delete(\'sscinstalleddoorbrush\', $index, item.id)" delete-class="sscDeleteVertAlign"></ssc-delete-button></div></div><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_installed_door_brush_button\']" add-onclick="addRow(\'ssc_installed_door_brush\', content.ssc_heat.id, \'add_ssc_installed_door_brush_button\')" add-enabled="tableProperties.ssc_installed_door_brush.canCreate" add-label="SSC_HEAT_ADD_BRUSH"></ssc-add-button></div></div></div></div><div class="field"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse6"><span data-ng-bind="\'SSC_HEAT_ADVICE\' | translate" ng-class="{\'error\': errors.advice.hasError, \'warning\': !errors.advice.hasError && errors.advice.hasWarning}"></span></div><div id="collapse6" class="collapse"><ssc-errorbox data-messages="errors.advice.messages"></ssc-errorbox><div class="flabel"><span data-ng-bind="\'SSC_HEAT_ADVICE_KEY_ASPECTS\' | translate"></span><help-pop-over help="TIP_HEAT_ADVICE_KEY_ASPECTS"></help-pop-over></div><div class="margcreatetop margcreatebot"><div class="row"><div class="col-xs-12"><hr></div></div><ssc-advice type="advice" tile-slug="tileSlug" advices="content.ssc_advice" table-properties="tableProperties.ssc_advice" options="content.advice" reference-id="content.ssc_heat.id"></ssc-advice></div><div class="margcreatetop margcreatebot"><div class="row"><div class="col-xs-12"><hr></div></div><ssc-advice type="praise" tile-slug="tileSlug" advices="content.ssc_advice_praise" table-properties="tableProperties.ssc_advice" options="content.advice_praise" reference-id="content.ssc_heat.id"></ssc-advice></div><div class="flabel"><span data-ng-bind="\'SSC_HEAT_INFOMATERIAL_HEADER\' | translate"></span></div><ssc-errorbox data-messages="errors.infomaterial.messages"></ssc-errorbox><div class="row margcreatetop" ng-repeat="(index, infomaterial) in content.ssc_heat_infomaterial track by infomaterial.id"><div errorlabel="ssc_heat_infomaterial.{{index}}.directhelp_id" dataobj="required" class="col-sm-4 ilabel"><span ng-bind="\'SSC_HEAT_INFOMATERIAL\' | translate:{nr: $index + 1}"></span></div><div class="col-sm-6" errorlabel="ssc_heat_infomaterial.{{index}}.directhelp_id" dataobj="required"><select class="createdropper" ng-model="infomaterial.directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheatinfomaterial\', \'directhelp_id\', infomaterial.directhelp_id, infomaterial.id)"><option value=""></option><option ng-repeat="directhelp in content.infomaterials" ng-value="directhelp.id" data-ng-bind="directhelp.description"></option></select></div><div errorlabel="ssc_heat_infomaterial.{{index}}.directhelp_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div><div class="col-xs-1 delete-heat-button-xs"><ssc-delete-button delete-enabled="tableProperties.ssc_heat_infomaterial.canDelete" delete-onclick="delete(\'sscheatinfomaterial\', $index, infomaterial.id)" delete-class="sscDeleteVertAlign"></ssc-delete-button></div></div><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_heat_infomaterial_button\']" add-onclick="addRow(\'ssc_heat_infomaterial\', content.ssc_heat.id, \'add_ssc_heat_infomaterial_button\')" add-enabled="tableProperties.ssc_heat_infomaterial.canCreate" add-label="SSC_HEAT_ADD_INFOMATERIAL"></ssc-add-button></div></div><div class="row margcreatebot"><div class="row"><div errorlabel="ssc_heat.internal_comment" dataobj="required" class="col-sm-12 ilabel"><span data-ng-bind="\'SSC_HEAT_INTERNAL_COMMENT\' | translate"></span> <span data-ng-if="properties.ssc_heat.internal_comment.required">*</span></div><div class="col-sm-12" errorlabel="ssc_heat.internal_comment" dataobj="required"><textarea ng-model="content.ssc_heat.internal_comment" class="createinputter" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscheat\', \'internal_comment\', content.ssc_heat.internal_comment, content.ssc_heat.id)"></textarea></div></div></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/household/household.html','<div ng-controller="overviewController" field-attribute-manager=""><h4 data-ng-bind="(\'SSC_TILE_OVERVIEW_SH\'| translate) +\' - \'+ (\'SSC_TILE_OVERVIEW\' | translate)"></h4><div data-ng-if="errorAlert" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span data-ng-bind="\'FORM_ERROR_SAVING_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="errorAlert.message"></div></div></div><div data-ng-if="saved && !check()" class="col-sm-12 errorfield margcreatebot"><div class="row hlabel"><span data-ng-bind="\'FORM_ERROR_TITLE\' | translate"></span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text" data-ng-bind="\'FORM_ERROR_TEXT\' | translate"></div></div></div><div class="row"><div class="col-md-7"><div class="col-sm-12 field"><div class="row hlabel" data-ng-bind="\'SSC_HH_OVERVIEW\'| translate"></div><div class="row" ng-show="showerrorbox"><div class="col-sm-12"><div class="col-sm-12 errorfield margcreatetop"><div class="row hlabel"><span data-ng-bind="\'FORM_ERROR_TITLE\' | translate">Bitte alle Felder korrekt ausf\xFCllen</span></div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.ssc"><div ng-if="value.error != null">{{$parent.$parent.showerrorbox=1;value.error;}}</div><div class="warning" ng-if="value.warning != null"><span>{{$parent.$parent.showerrorbox=1;value.warning;}}</span></div></div></div></div></div></div></div><div class="margcreatetop"></div><div class="row" permission-only="[ADMIN]"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_LOCATION\' | translate"></span></div><div class="col-sm-7 nlabel">{{data.ssc.location.id + ": " + data.ssc.location.name}}</div></div><div class="row"><div errorlabel="ssc.ssc_consultation_type_name" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_CONSULTATION_TYPE\' | translate"></span> <span data-ng-if="required.ssc.ssc_consultation_type_name.required">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_consultation_type_name" dataobj="required"><select class="createdropper" ng-model="data.ssc.ssc_consultation_type_name" ng-change="save(\'ssc\', \'ssc_consultation_type_name\', data.ssc.ssc_consultation_type_name)"><option ng-repeat="item in data.ssc_consultation_type" ng-value="item.name" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc.ssc_consultation_type_name" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-sm-4 ilabel" errorlabel="ssc.customernumber" dataobj="required"><span data-ng-bind="\'SSC_HH_CUSTOMERNUMBER\' | translate"></span> <span data-ng-if="required.ssc.customernumber.required">*</span></div><div class="col-sm-7" errorlabel="ssc.customernumber" dataobj="required"><input class="createinputter" ng-model="data.ssc.customernumber" ng-change="save(\'ssc\', \'customernumber\', data.ssc.customernumber)" ng-model-options="{updateOn: \'blur\'}"></div><div errorlabel="ssc.customernumber" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.salutation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_SALUTION\' | translate"></span> <span data-ng-if="required.ssc.salutation.required">*</span></div><div class="col-sm-7" errorlabel="ssc.salutation" dataobj="required"><select class="createdropper leftdropper" ng-model="data.ssc.salutation" ng-change="save(\'ssc\', \'salutation\', data.ssc.salutation)"><option value=""></option><option ng-repeat="option in data.salutation" value="{{option}}">{{option}}</option></select></div><div errorlabel="ssc.salutation" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.firstname" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_FIRSTNAME\' | translate"></span> <span data-ng-if="required.ssc.firstname.required">*</span></div><div class="col-sm-7" errorlabel="ssc.firstname" dataobj="required"><input class="createinputter" ng-model="data.ssc.firstname" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssc\', \'firstname\', data.ssc.firstname)"></div><div errorlabel="ssc.firstname" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.lastname" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_LASTNAME\' | translate"></span> <span data-ng-if="required.ssc.lastname.required">*</span></div><div class="col-sm-7" errorlabel="ssc.lastname" dataobj="required"><input class="createinputter" ng-model="data.ssc.lastname" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssc\', \'lastname\', data.ssc.lastname)"></div><div errorlabel="ssc.lastname" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.street" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_STREET\' | translate"></span> <span data-ng-if="required.ssc.street.required">*</span></div><div class="col-sm-7" errorlabel="ssc.street" dataobj="required"><input class="createinputter" ng-model="data.ssc.street" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssc\', \'street\', data.ssc.street)"></div><div errorlabel="ssc.street" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.postalcode" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_POSTALCODE\' | translate"></span> <span data-ng-if="required.ssc.postalcode.required">*</span></div><div class="col-sm-7" errorlabel="ssc.postalcode" dataobj="required"><input class="createinputter" ng-model="data.ssc.postalcode" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssc\', \'postalcode\', data.ssc.postalcode)"></div><div errorlabel="ssc.postalcode" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.city" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_CITY\' | translate"></span> <span data-ng-if="required.ssc.city.required">*</span></div><div class="col-sm-7" errorlabel="ssc.city" dataobj="required"><input class="createinputter" ng-model="data.ssc.city" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssc\',\'city\',data.ssc.city)"></div><div errorlabel="ssc.city" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.telephone" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_TELEPHONE\' | translate"></span> <span data-ng-if="required.ssc.telephone.required">*</span></div><div class="col-sm-7" errorlabel="ssc.telephone" dataobj="required"><input class="createinputter" ng-model="data.ssc.telephone" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssc\', \'telephone\', data.ssc.telephone)"></div><div errorlabel="ssc.telephone" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.mobilephone" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_MOBILEPHONE\' | translate"></span> <span data-ng-if="required.ssc.mobilephone.required">*</span></div><div class="col-sm-7" errorlabel="ssc.mobilephone" dataobj="required"><input class="createinputter" ng-model="data.ssc.mobilephone" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssc\', \'mobilephone\', data.ssc.mobilephone)"></div><div errorlabel="ssc.mobilephone" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.email" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_EMAIL\' | translate"></span> <span data-ng-if="required.ssc.email.required">*</span></div><div class="col-sm-7" errorlabel="ssc.email" dataobj="required"><input class="createinputter" ng-model="data.ssc.email" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssc\', \'email\', data.ssc.email)"></div><div errorlabel="ssc.email" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.registration_type_name" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_REGISTRATION_TYPE\' | translate"></span> <span data-ng-if="required.ssc.registration_type_name.required">*</span></div><div class="col-sm-7" errorlabel="ssc.registration_type_name" dataobj="required"><select class="createdropper" ng-model="data.ssc.registration_type_name" ng-change="save(\'ssc\', \'registration_type_name\', data.ssc.registration_type_name)"><option value="" data-ng-bind="\'SSC_CHOOSE\' | translate" disabled=""></option><option ng-repeat="item in data.registration_types" ng-value="item.id" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc.registration_type_name" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.ssc_akquise_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_AKQUISE_CATEGORY\' | translate"></span> <span data-ng-if="required.ssc.ssc_akquise_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_akquise_id" dataobj="required"><select class="createdropper" ng-model="data.ssc.ssc_akquise_category_id" ng-change="unsetAkquiseId()"><option ng-repeat="item in data.ssc_akquise_category" ng-value="item.id" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc.ssc_akquise_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" ng-show="data.ssc.ssc_akquise_category_id"><div errorlabel="ssc.ssc_akquise_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_AKQUISE\' | translate"></span> <span data-ng-if="required.ssc.ssc_akquise_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_akquise_id" dataobj="required"><select class="createdropper" ng-model="data.ssc.ssc_akquise_id" ng-change="save(\'ssc\', \'ssc_akquise_id\', data.ssc.ssc_akquise_id)"><option value=""></option><option ng-repeat="item in data.ssc_akquise | filter: {ssc_akquise_category_id: data.ssc.ssc_akquise_category_id}" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc.ssc_akquise_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.ssc_previous_consultation_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_PREVIOUS_CONSULTATION\' | translate"></span> <span data-ng-if="required.ssc.ssc_previous_consultation_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_previous_consultation_type_id" dataobj="required"><select class="createdropper" ng-model="data.ssc.ssc_previous_consultation_type_id" ng-change="save(\'ssc\', \'ssc_previous_consultation_type_id\', data.ssc.ssc_previous_consultation_type_id)"><option value=""></option><option ng-repeat="item in data.ssc_previous_consultation_type" ng-value="item.id" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc.ssc_previous_consultation_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.ssc_user_1_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_USER_1\' | translate"></span> <span data-ng-if="required.ssc.ssc_user_1_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_user_1_id" dataobj="required"><ui-select on-select="save(\'ssc\',\'ssc_user_1_id\',$select.selected.id)" theme="selectize" ng-model="data.ssc.user_1" class="ssc-ui-select" ng-disabled="required.ssc.ssc_user_1_id.disabled"><ui-select-match placeholder="Bitte Suchen Sie einen Stromsparhelfer">{{$select.selected.id + \' - \' + $select.selected.name}}</ui-select-match><ui-select-choices repeat="res in getDropUserSsh() | filter:$select.search"><span data-ng-bind-html="(res.id + \' - \' + res.name) | highlight: $select.search"></span></ui-select-choices></ui-select></div><div errorlabel="ssc.ssc_user_1_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.ssc_user_2_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_USER_2\' | translate"></span> <span data-ng-if="required.name">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_user_2_id" dataobj="required"><ui-select on-select="save(\'ssc\',\'ssc_user_2_id\',$select.selected.id)" theme="selectize" ng-model="data.ssc.user_2" class="ssc-ui-select" ng-disabled="required.ssc.ssc_user_2_id.disabled"><ui-select-match placeholder="Bitte Suchen Sie einen Stromsparhelfer">{{$select.selected.id + \' - \' + $select.selected.name}}</ui-select-match><ui-select-choices repeat="res in getDropUserSsh() | filter:$select.search"><span data-ng-bind-html="(res.id + \' - \' + res.name) | highlight: $select.search"></span></ui-select-choices></ui-select></div><div errorlabel="ssc.ssc_user_2_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.trainer_user_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_TRAINER_USER\' | translate"></span> <span data-ng-if="required.name">*</span></div><div class="col-sm-7" errorlabel="ssc.trainer_user_id" dataobj="required"><ui-select on-select="save(\'ssc\',\'trainer_user_id\',$select.selected.id)" theme="selectize" ng-model="data.ssc.trainer_user" class="ssc-ui-select" ng-disabled="required.ssc.trainer_user_id.disabled"><ui-select-match placeholder="Bitte Suchen Sie einen Trainer">{{$select.selected.id + \' - \' + $select.selected.name}}</ui-select-match><ui-select-choices repeat="res in dropUsersTrainer | filter:$select.search"><span data-ng-bind-html="(res.id + \' - \' + res.name) | highlight: $select.search"></span></ui-select-choices></ui-select></div><div errorlabel="ssc.trainer_user_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" ng-hide="required.ssc.ssc_user_mon_1_id.hidden === true"><div errorlabel="ssc.ssc_user_mon_1_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_USER_MON_1\' | translate"></span> <span data-ng-if="required.ssc.ssc_user_mon_1_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_user_mon_1_id" dataobj="required"><ui-select on-select="save(\'ssc\',\'ssc_user_mon_1_id\',$select.selected.id)" theme="selectize" ng-model="data.ssc.user_mon_1" class="ssc-ui-select" ng-disabled="required.ssc.ssc_user_mon_1_id.disabled"><ui-select-match placeholder="Bitte Suchen Sie einen Stromsparhelfer">{{$select.selected.id + \' - \' + $select.selected.name}}</ui-select-match><ui-select-choices repeat="res in getDropUserSshMonitoring() | filter:$select.search"><span data-ng-bind-html="(res.id + \' - \' + res.name) | highlight: $select.search"></span></ui-select-choices></ui-select></div><div errorlabel="ssc.ssc_user_mon_1_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" ng-hide="required.ssc.ssc_user_mon_2_id.hidden === true"><div errorlabel="ssc.ssc_user_mon_2_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_USER_MON_2\' | translate"></span> <span data-ng-if="required.name">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_user_mon_2_id" dataobj="required"><ui-select on-select="save(\'ssc\',\'ssc_user_mon_2_id\',$select.selected.id)" theme="selectize" ng-model="data.ssc.user_mon_2" class="ssc-ui-select" ng-disabled="required.ssc.ssc_user_mon_2_id.disabled"><ui-select-match placeholder="Bitte Suchen Sie einen Stromsparhelfer">{{$select.selected.id + \' - \' + $select.selected.name}}</ui-select-match><ui-select-choices repeat="res in getDropUserSshMonitoring() | filter:$select.search"><span data-ng-bind-html="(res.id + \' - \' + res.name) | highlight: $select.search"></span></ui-select-choices></ui-select></div><div errorlabel="ssc.ssc_user_mon_2_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.first_visit_at" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_FIRST_VISIT\' | translate"></span> <span data-ng-if="required.ssc.first_visit_at.required">*</span></div><div class="col-sm-7" errorlabel="ssc.first_visit_at" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="data.ssc.first_visit_at" datepicker-change="save(\'ssc\', \'first_visit_at\', data.ssc.first_visit_at)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div errorlabel="ssc.first_visit_at" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.second_visit_at" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_SECOND_VISIT\' | translate"></span> <span data-ng-if="required.ssc.second_visit_at.required">*</span></div><div class="col-sm-7" errorlabel="ssc.second_visit_at" dataobj="required"><input class="createinputter" ssc-datepicker="" data-ng-model="data.ssc.second_visit_at" datepicker-change="save(\'ssc\', \'second_visit_at\', data.ssc.second_visit_at)" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_MINUTE"></div><div errorlabel="ssc.second_visit_at" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.is_monitored" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_IS_MONITORED\' | translate"></span> <span data-ng-if="required.ssc.is_monitored.required">*</span><help-pop-over help="TIP_HH_IS_MONITORED"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc.is_monitored" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc.is_monitored" id="isMonitored" ng-checked="data.ssc.is_monitored === 1" ng-change="save(\'ssc\', \'is_monitored\', data.ssc.is_monitored)"> <label class="checklabel" for="isMonitored"></label> <span data-ng-bind="data.ssc.is_monitored === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc.is_monitored" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.is_monitoring_rejected" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_COL_REJECT_MONITORING\' | translate"></span> <span data-ng-if="required.ssc.is_monitoring_rejected.required">*</span><help-pop-over help="TIP_HH_MONITORING_REJECTED"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc.is_monitoring_rejected" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc.is_monitoring_rejected" id="is_monitoring_rejected" ng-checked="data.ssc.is_monitoring_rejected === 1" ng-change="save(\'ssc\', \'is_monitoring_rejected\', data.ssc.is_monitoring_rejected)"> <label class="checklabel" for="is_monitoring_rejected"></label> <span data-ng-bind="data.ssc.is_monitoring_rejected === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc.is_monitoring_rejected" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatetop"></div></div></div><div class="col-md-5"><div class="col-sm-12 field"><div class="row margcreatetop margcreatebot"><div errorlabel="ssc.was_checked_before" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_HH_WAS_CHECKED_BEFORE\' | translate"></span> <span data-ng-if="required.ssc.was_checked_before.required">*</span></div><div class="col-sm-4" errorlabel="ssc.was_checked_before" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc.was_checked_before" id="wasCheckedBefore" ng-checked="data.ssc.was_checked_before === 1" ng-change="save(\'ssc\', \'was_checked_before\', data.ssc.was_checked_before)"> <label class="checklabel" for="wasCheckedBefore"></label> <span data-ng-bind="data.ssc.was_checked_before === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row" ng-if="data.ssc.is_telephone"><div class="col-sm-10 col-sm-offset-1"><ssc-copy-button disabled="!data.ssc.copy_allowed"></ssc-copy-button></div><div class="col-sm-10 col-sm-offset-1 margcreatebot" ng-if="data.ssc.copies && data.ssc.copies.length"><div class="ilabel"><span>Die Beratung wurde bereits kopiert:</span> <span ng-repeat="copyId in data.ssc.copies"><a ui-sref="ssc.check({id: copyId})" class="label label-default">ID {{copyId}}</a>&nbsp;</span></div></div></div></div><div class="col-sm-12 field"><div class="row margcreatetop margcreatebot" errorlabel="ssc.location_quarter_id" dataobj="required"><div class="col-sm-4 col-md-12 col-lg-4 ilabel" dataobj="required"><span data-ng-bind="\'SSC_HH_QUARTER\' | translate"></span> <span data-ng-if="required.ssc.location_quarter_id.required">*</span></div><div class="col-sm-8 col-md-12 col-lg-8" errorlabel="ssc.location_quarter_id" dataobj="required"><select ng-change="save(\'ssc\', \'location_quarter_id\', data.ssc.location_quarter_id)" class="createdropper" ng-model="data.ssc.location_quarter_id"><option data-ng-bind="\'SSC_HH_QUARTER_EMPTY\' | translate"></option><option ng-repeat="item in data.location_quarters" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div><div class="row margcreatetop margcreatebot"><div errorlabel="ssc.heat_check_type" dataobj="required" class="col-sm-12 heat-type-indicator ilabel"><ul><li data-ng-class="{active: data.ssc.heat_check_type === \'basic\'}"><span data-ng-bind="\'SSC_HH_HEAT_CHECK_BASIC\' | translate"></span><help-pop-over help="TIP_HH_HEAT_CHECK_TYPE"></help-pop-over></li><li data-ng-class="{active: data.ssc.heat_check_type === \'standard\'}" data-ng-bind="\'SSC_HH_HEAT_CHECK_STANDARD\' | translate"></li><li data-ng-class="{active: data.ssc.heat_check_type === \'extended\'}" data-ng-bind="\'SSC_HH_HEAT_CHECK_EXTENDED\' | translate"></li><li data-ng-if="data.ssc.heat_check_type === \'none\'" class="active" data-ng-bind="\'SSC_HH_HEAT_CHECK_NONE\' | translate"></li></ul></div></div><div class="row margcreatebot"><div errorlabel="ssc.has_photovoltaic" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_HH_HAS_PHOTOVOLTAIC\' | translate"></span> <span data-ng-if="required.ssc.has_photovoltaic.required">*</span></div><div class="col-sm-4" errorlabel="ssc.has_photovoltaic" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc.has_photovoltaic" id="has-photovoltaic" ng-checked="data.ssc.has_photovoltaic === 1" ng-change="save(\'ssc\', \'has_photovoltaic\', data.ssc.has_photovoltaic)"> <label class="checklabel" for="has-photovoltaic"></label> <span data-ng-bind="data.ssc.has_photovoltaic === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row margcreatebot"><div errorlabel="ssc.has_climate_protection" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_HH_HAS_CLIMATE_PROTECTION\' | translate"></span> <span data-ng-if="required.ssc.has_climate_protection.required">*</span></div><div class="col-sm-4" errorlabel="ssc.has_climate_protection" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc.has_climate_protection" id="hasClimateProtection" ng-checked="data.ssc.has_climate_protection === 1" ng-change="save(\'ssc\', \'has_climate_protection\', data.ssc.has_climate_protection)"> <label class="checklabel" for="hasClimateProtection"></label> <span data-ng-bind="data.ssc.has_climate_protection === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div></div><div class="col-sm-12 field"><div class="row hlabel" data-ng-bind="\'SSC_HH_STATUS_TITLE\' | translate"></div><div class="row margcreatetop margcreatebot" errorlabel="ssc.status" dataobj="required"><div class="col-sm-3 ilabel" errorlabel="ssc.status" dataobj="required"><span data-ng-bind="\'SSC_HH_STATUS\' | translate"></span> <span data-ng-if="required.ssc.status.required">*</span></div><div class="col-sm-9" errorlabel="ssc.status" dataobj="required"><select ng-change="statusDialog()" class="createdropper" ng-model="data.ssc.status" title="{{getStatusName(data.ssc.status)}}"><option ng-repeat="item in data.ssc_status" ng-value="item.id" data-ng-bind="item.name"></option></select></div></div></div><div class="col-sm-12 field" ng-if="showCanceledEvaluation"><div class="row hlabel" data-ng-bind="\'SSC_HH_EVALUATION_TITLE\' | translate"></div><div class="row margcreatetop"><div class="col-sm-7 ilabel"><span data-ng-bind="\'SSC_HH_EVALUATION_TITLE\' | translate"></span> <span data-ng-if="required.ssc.canceled_evaluation.required">*</span></div><div class="col-sm-5" errorlabel="ssc.canceled_evaluation" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="data.ssc.canceled_evaluation" id="evaluationCheck" ng-checked="data.ssc.canceled_evaluation === 1" ng-change="save(\'ssc\', \'canceled_evaluation\', data.ssc.canceled_evaluation)"> <label class="checklabel" for="evaluationCheck"></label> <span data-ng-bind="data.ssc.canceled_evaluation === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div></div><div class="row margcreatetop"><div errorlabel="ssc.canceled_evaluation_efb" dataobj="required" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HH_EVALUATION_USER\' | translate"></span> <span data-ng-if="required.ssc.canceled_evaluation_efb.required">*</span></div><div class="col-sm-9" errorlabel="ssc.canceled_evaluation_efb" dataobj="required"><ui-select on-select="save(\'ssc\',\'canceled_evaluation_efb\',$select.selected.id)" theme="selectize" ng-model="data.ssc.efb_user" class="ssc-ui-select" ng-disabled="required.ssc.canceled_evaluation_efb.disabled"><ui-select-match placeholder="Bitte Suchen Sie einen EFB">{{$select.selected.id + \' - \' + $select.selected.name}}</ui-select-match><ui-select-choices refresh="search($select, \'EFB\', data.ssc.id)" refresh-delay="0" repeat="res in searchRes track by $index"><span data-ng-bind-html="(res.id + \' - \' + res.name) | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="row margcreatetop"><div errorlabel="ssc.canceled_evaluation_comment" dataobj="required" class="col-sm-3 ilabel"><span data-ng-bind="\'SSC_HH_EVALUATION_COMMENT\' | translate"></span> <span data-ng-if="required.ssc.canceled_evaluation_comment.required">*</span></div><div class="col-sm-9" errorlabel="ssc.canceled_evaluation_comment" dataobj="required"><textarea ng-model="data.ssc.canceled_evaluation_comment" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssc\', \'canceled_evaluation_comment\', data.ssc.canceled_evaluation_comment)" data-ng-class="{\'input-required-border\': (((model.text + \'\').length === 0) || (model.text === null)) &amp;&amp; required.text &amp;&amp; saved}" class="createinputter ng-pristine ng-valid ng-empty ng-touched" id="comment"></textarea></div></div><div class="row" ng-if="(data.ssc.canceled_evaluation === 1 && data.ssc.canceled_evaluation_efb && data.ssc.canceled_evaluation_comment)"><div class="col-sm-offset-3 col-sm-9"><button data-ng-if="1" ng-click="canceledEvaluationDialog()" class="redbutton disableduringload" id="roleplace" type="submit"><span data-ng-bind="\'SSC_HH_EVALUATION_SEND\' | translate"></span></button></div></div></div></div></div><div class="row"><div class="col-sm-5"><button data-ng-disabled="!data.ssc || data.ssc.is_anonymised" ng-click="anonymizeDialog()" class="redbutton disableduringload" type="submit" permission="" permission-only=\'["ADMIN"]\'><i class="fa fa-eraser marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_HH_BTN_ANONYMIZE\' | translate"></span></button></div><div class="col-sm-offset-1 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/kia/kia.html','<div ng-controller="kiaController"><div class="row"><div class="col-sm-9"><h4 ng-bind="(\'SSC_TILE_KIA_SH\' | translate) + \' - \' + (\'SSC_TILE_KIA\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordion-1" class="accordeon"><div class="field"><div class="panel-hiding hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion-1" href="#collapse-1"><span ng-bind="\'SSC_KIA_DIRECTHELP_TITLE\' | translate"></span></div><div id="collapse-1" class="collapse in"><div ng-repeat="directhelp in content.ssc_kia_directhelp"><ssc-errorbox data-messages="errors.ssc_kia_directhelp[$index]"></ssc-errorbox><div class="row"><div class="col-sm-12"><h4>{{"SSC_KIA_DIRECTHELP" | translate}} {{$index + 1}}</h4></div></div><ssc-delete-button delete-enabled="tableProperties.ssc_kia_directhelp.canDelete" delete-onclick="delete(\'ssckiadirecthelp\', directhelp.id)" delete-class="sscDeleteAccordion"></ssc-delete-button><ssc-input type="select" field="ssc_kia_directhelp.{{$index}}.directhelp_id" page="formPageScope" options="directhelp.directhelps" optionfield="description" label="SSC_KIA_DIRECTHELP"></ssc-input><div errorlabel="ssc_kia_directhelp.{{$index}}.count"><ssc-input type="input" field="ssc_kia_directhelp.{{$index}}.count" page="formPageScope" label="SSC_KIA_COUNT"></ssc-input></div><ssc-input type="toggle" field="ssc_kia_directhelp.{{$index}}.tip_given" page="formPageScope" label="SSC_KIA_TIP_GIVEN"></ssc-input><div errorlabel="ssc_kia_directhelp.{{$index}}.weekly_bought_water_liter"><ssc-input type="input" field="ssc_kia_directhelp.{{$index}}.weekly_bought_water_liter" page="formPageScope" precision="2" unit="Liter/Woche" label="SSC_KIA_WEEKLY_BOUGHT_WATER"></ssc-input></div><div errorlabel="ssc_kia_directhelp.{{$index}}.emission_savings"><ssc-input type="input" field="ssc_kia_directhelp.{{$index}}.emission_savings" page="formPageScope" disabled="true" unit-html="{{\'SSC_KIA_EMISSION_UNIT\' | translate}}" label-html="SSC_KIA_EMISSION_SAVINGS"></ssc-input></div><div errorlabel="ssc_kia_directhelp.{{$index}}.cost_savings"><ssc-input type="input" field="ssc_kia_directhelp.{{$index}}.cost_savings" page="formPageScope" label="SSC_KIA_COST_SAVINGS" unit="{{\'SSC_KIA_COSTS_UNIT\' | translate}}" disabled="true"></ssc-input></div><div class="margcreatetop"></div><hr ng-if="!$last"></div><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="isSaving" add-onclick="addDirecthelp()" add-enabled="tableProperties.ssc_kia_directhelp.canCreate" add-label="SSC_KIA_ADD_DIRECTHELP"></ssc-add-button></div></div></div></div></div><div id="accordion-2" class="accordeon"><div class="field"><div class="panel-hiding hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion-2" href="#collapse-2"><span ng-bind="\'SSC_KIA_INFOMATERIAL_TITLE\' | translate"></span></div><div id="collapse-2" class="collapse in"><div ng-repeat="infomaterial in content.ssc_kia_infomaterial"><ssc-errorbox data-messages="errors.ssc_kia_infomaterial[$index]"></ssc-errorbox><div class="margcreatetop"></div><ssc-delete-button delete-enabled="tableProperties.ssc_kia_directhelp.canDelete" delete-onclick="delete(\'ssckiainfomaterial\', infomaterial.id)" delete-class="sscDeleteAccordion"></ssc-delete-button><div class="row"><div class="col-sm-12"><h4>{{"SSC_KIA_INFOMATERIAL" | translate}} {{$index + 1}}</h4></div></div><ssc-input type="select" field="ssc_kia_infomaterial.{{$index}}.directhelp_id" page="formPageScope" options="infomaterial.directhelps" optionfield="description" label="SSC_KIA_INFOMATERIAL"></ssc-input><ssc-input type="toggle" field="ssc_kia_infomaterial.{{$index}}.tip_given" page="formPageScope" label="SSC_KIA_TIP_GIVEN"></ssc-input><div errorlabel="ssc_kia_infomaterial.{{$index}}.emission_savings"><ssc-input type="input" field="ssc_kia_infomaterial.{{$index}}.emission_savings" page="formPageScope" label-html="SSC_KIA_EMISSION_SAVINGS" unit-html="{{\'SSC_KIA_EMISSION_UNIT\' | translate}}" disabled="true"></ssc-input></div><div class="margcreatetop"></div><hr ng-if="!$last"></div><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="isSaving" add-onclick="addInfomaterial()" add-enabled="tableProperties.ssc_kia_infomaterial.canCreate" add-label="SSC_KIA_ADD_INFOMATERIAL"></ssc-add-button></div></div></div></div></div><div id="accordion-3" class="accordeon"><div class="field"><div class="panel-hiding hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion-3" href="#collapse-3"><span ng-bind="\'SSC_KIA_TIPS_TITLE\' | translate"></span></div><div id="collapse-3" class="collapse in"><div class="margcreatetop"></div><ssc-advice tile-slug="tileSlug" type="advice" advices="content.ssc_advice" table-properties="tableProperties.ssc_advice" options="content.advice" reference-id="content.ssc_kia.id"></ssc-advice><div class="margcreatetop"></div></div></div></div><div class="col-sm-12 field-noinsides" ng-if="content.ssc_kia_directhelp && content.ssc_kia_directhelp.length > 0"><div class="col-sm-4 ilabel"><i class="fa fa-calculator marg-right-small" aria-hidden="true"></i> <span ng-bind-html="\'SSC_KIA_EMISSION_SAVINGS_TOTAL\' | translate"></span></div><div class="col-sm-8 nlabel">{{content.ssc_kia.emission_savings | decimal2comma}} <span ng-bind-html="\'SSC_KIA_EMISSION_UNIT\' | translate"></span></div><div class="col-sm-4 ilabel"><i class="fa fa-calculator marg-right-small" aria-hidden="true"></i>{{\'SSC_KIA_COST_SAVINGS_TOTAL\' | translate}}</div><div class="col-sm-8 nlabel">{{content.ssc_kia.cost_savings | decimal2comma}} <span ng-bind-html="\'SSC_KIA_COSTS_UNIT\' | translate"></span></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/lighting/lighting.html','<div data-ng-controller="lightingController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'SSC_TILE_LIGHTING_SH\' | translate) +\' - \'+ (\'SSC_TILE_LIGHTING\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div ng-repeat="(lightIndex,light) in content.ssc_lighting track by light.id" on-finish-render="initjquery(); broadcastErrorUpdate()"><div id="accordion{{$index}}" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" fastaddclass="accordions[$index][0] ? \'\' : \'collapsed\'" data-parent="#accordion{{$index}}" href="#collapse{{$index}}"><span data-ng-bind="(\'SSC_LIGHTING_DIRECTHELP\' | translate) + \' \' + ($index + 1)" ng-class="{\'error\': errors.light[$index].hasError, \'warning\': !errors.light[$index].hasError && errors.light[$index].hasWarning}"></span><ssc-delete-button delete-enabled="tableProperties.ssc_lighting.canDelete" delete-onclick="delete(\'ssclighting\', lightIndex, light.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div id="collapse{{$index}}" class="collapse" fastaddclass="accordions[$index][0] ? \'in\' : \'\'"><ssc-errorbox data-messages="errors.light[$index].messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_lighting.{{$index}}.ssc_room_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_ROOM_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].ssc_room_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_lighting.{{$index}}.ssc_room_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="content.ssc_lighting[$index].ssc_room_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'ssc_room_type_id\', content.ssc_lighting[$index].ssc_room_type_id, light.id)"><option value=""></option><option ng-repeat="item in content.ssc_room_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-1" errorlabel="ssc_lighting.{{$index}}.ssc_room_type_id" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.ssc_light_socket_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_LIGHT_SOCKET_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].ssc_light_socket_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_lighting.{{$index}}.ssc_light_socket_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="content.ssc_lighting[$index].ssc_light_socket_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'ssc_light_socket_type_id\', content.ssc_lighting[$index].ssc_light_socket_type_id, light.id)"><option value=""></option><option ng-repeat="item in content.ssc_light_socket_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_lighting.{{$index}}.ssc_light_socket_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.count" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_COUNT\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].count.required">*</span></div><div class="col-sm-6" errorlabel="ssc_lighting.{{$index}}.count" dataobj="required"><input class="createinputter" ng-model="light.count" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'count\', light.count, light.id)"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_LIGHTING_COUNT\' | translate"></span></div><div errorlabel="ssc_lighting.{{$index}}.count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.wattage" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_WATTAGE\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].wattage.required">*</span><help-pop-over help="TIP_LIGHTING_WATTAGE"></help-pop-over></div><div class="col-sm-6" errorlabel="ssc_lighting.{{$index}}.wattage" dataobj="required"><input class="createinputter" ng-model="light.wattage" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'wattage\', light.wattage, light.id)" decimal-separator-german="" precision="1"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_LIGHTING_WATT\' | translate"></span></div><div errorlabel="ssc_lighting.{{$index}}.wattage" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.light_old_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_LIGHT_OLD_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].light_old_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_lighting.{{$index}}.light_old_id" dataobj="required"><select class="createdropper leftdropper" ng-model="content.ssc_lighting[$index].light_old_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'light_old_id\', content.ssc_lighting[$index].light_old_id, light.id)"><option value=""></option><option ng-repeat="item in content.ssc_light_old_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_lighting.{{$index}}.light_old_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.light_directhelp_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_LIGHT_DIRECTHELP\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].light_directhelp_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_lighting.{{$index}}.light_directhelp_id" dataobj="required"><select class="createdropper leftdropper" ng-model="content.ssc_lighting[$index].light_directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'light_directhelp_id\', content.ssc_lighting[$index].light_directhelp_id, light.id)"><option value=""></option><option ng-repeat="item in content.lighting_directhelp" ng-value="item.id" data-ng-bind="item.description" ng-disabled="item.status===0" ng-if="(content.ssc_lighting[$parent.$index].ssc_light_socket_type_id === item.sockel || !item.sockel) && (content.ssc_lighting[lightIndex].light_directhelp_id == item.id || item.directhelp_type.slug != \'ARCHIVE\')"></option></select></div><div errorlabel="ssc_lighting.{{$index}}.light_directhelp_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div><div class="row" ng-show="content.ssc_lighting[$index].light_directhelp_id == 67"><div class="col-sm-11 ilabel"><span data-ng-bind="\'SSC_LIGHTING_NO_ESHOP\' | translate"></span></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.custom_wattage" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_CUSTOM_WATTAGE\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].custom_wattage.required">*</span></div><div class="col-sm-6" errorlabel="ssc_lighting.{{$index}}.custom_wattage" dataobj="required"><input class="createinputter" ng-model="light.custom_wattage" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'custom_wattage\', light.custom_wattage, light.id)" decimal-separator-german="" precision="1"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_LIGHTING_WATT\' | translate"></span></div><div errorlabel="ssc_lighting.{{$index}}.custom_wattage" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.custom_price_netto" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_CUSTOM_PRICE_NETTO\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].custom_price_netto.required">*</span></div><div class="col-sm-6" errorlabel="ssc_lighting.{{$index}}.custom_price_netto" dataobj="required"><input class="createinputter" ng-model="light.custom_price_netto" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'custom_price_netto\', light.custom_price_netto, light.id)" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_LIGHTING_EURO\' | translate"></span></div><div errorlabel="ssc_lighting.{{$index}}.custom_price_netto" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.custom_price_brutto" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_CUSTOM_PRICE_BRUTTO\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].custom_price_brutto.required">*</span></div><div class="col-sm-6" errorlabel="ssc_lighting.{{$index}}.custom_price_brutto" dataobj="required"><input class="createinputter" ng-model="light.custom_price_brutto" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'custom_price_brutto\', light.custom_price_brutto, light.id)" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_LIGHTING_EURO\' | translate"></span></div><div errorlabel="ssc_lighting.{{$index}}.custom_price_brutto" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.burning_per_day" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_BURNING_PER_DAY\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].burning_per_day.required">*</span><help-pop-over help="TIP_LIGHTING_BURNING_PER_DAY"></help-pop-over></div><div class="col-sm-6" errorlabel="ssc_lighting.{{$index}}.burning_per_day" dataobj="required"><input class="createinputter" ng-model="light.burning_per_day" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'burning_per_day\', light.burning_per_day, light.id)" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_LIGHTING_HOURS_PER_DAY\' | translate"></span></div><div errorlabel="ssc_lighting.{{$index}}.burning_per_day" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.ssc_lamp_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_LIGHTING_LAMP_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_lighting[$index].ssc_lamp_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_lighting.{{$index}}.ssc_lamp_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="content.ssc_lighting[$index].ssc_lamp_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'ssc_lamp_type_id\', content.ssc_lighting[$index].ssc_lamp_type_id, light.id)"><option value=""></option><option ng-repeat="item in content.ssc_lamp_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_lighting.{{$index}}.ssc_lamp_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_lighting.{{$index}}.light_description" dataobj="required" class="col-sm-4 ilabel"></div><div class="col-sm-6" errorlabel="ssc_lighting.{{$index}}.light_description" dataobj="required"><textarea class="createinputter" ng-model="content.ssc_lighting[$index].light_description" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssclighting\', \'light_description\', content.ssc_lighting[$index].light_description, light.id)"></textarea></div><div errorlabel="ssc_lighting.{{$index}}.light_description" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row flabel"><div class="col-sm-4"><span data-ng-bind="\'SSC_LIGHTING_AMORTISATION_TIME\' | translate"></span><help-pop-over help="TIP_LIGHTING_AMORTISATION_TIME"></help-pop-over></div><div class="col-sm-8"><span data-ng-bind="content.ssc_lighting[$index].payback_time | decimal2comma: 1"></span> Jahre</div></div><div class="row flabel"><div class="col-sm-4"><span data-ng-bind="\'SSC_LIGHTING_SAVING_POTENTIAL\' | translate"></span><help-pop-over help="TIP_LIGHTING_SAVING_POTENTIAL"></help-pop-over></div><div class="col-sm-8"><span data-ng-bind="content.ssc_lighting[$index].savings | decimal2comma"></span> kWh/a</div></div></div></div></div></div><div class="col-sm-12 field-noinsides" ng-if="content.ssc_lighting && content.ssc_lighting.length > 0"><div class="col-sm-4 ilabel"><i class="fa fa-calculator marg-right-small" aria-hidden="true"></i>{{\'SSC_LIGHTING_TOTAL_SAVINGS\' | translate}}</div><div class="col-sm-8 nlabel">{{content.ssc_summary.lighting_savings | decimal2comma}} kWh/a</div></div><div class="row"><div class="col-sm-5"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_lighting_button\']" add-onclick="addRow(\'ssc_lighting\', saveData.ssc_id, \'add_ssc_lighting_button\')" add-enabled="tableProperties.ssc_lighting.canCreate" add-label="SSC_LIGHTING_ADD_ROOM"></ssc-add-button></div><div class="col-sm-offset-1 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/log/log.html','<tabmenulog></tabmenulog>');
$templateCache.put('templates/static/ssc/photovoltaic/photovoltaic.html','<div ng-controller="photovoltaicController"><div class="row"><div class="col-sm-9"><h4 ng-bind="(\'SSC_TILE_PHOTOVOLTAIC_SH\' | translate) + \' - \' + (\'SSC_TILE_PHOTOVOLTAIC\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordion-1" class="accordeon"><div class="field" data-ng-repeat="(moduleIndex, module) in content.ssc_pv_module track by module.id"><div class="panel-hiding hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion-1" href="#collapse-module-{{moduleIndex}}"><span ng-bind="(\'SSC_PHOTOVOLTAIC_MODULE_TITLE\' | translate) + \' \' + (moduleIndex + 1)" ng-class="{error: errors.ssc_pv_module[moduleIndex].length > 0}"></span><ssc-delete-button delete-enabled="tableProperties.ssc_pv_module.canDelete" delete-onclick="delete(\'sscpvmodule\', moduleIndex, module.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div id="collapse-module-{{moduleIndex}}" class="collapse in"><ssc-errorbox data-messages="errors.ssc_pv_module[moduleIndex]"></ssc-errorbox><div class="margcreatetop"></div><ssc-input type="select" options="moduleCountOptions" optionfield="description" field="ssc_pv_module.{{moduleIndex}}.module_count" page="formPageScope" label="SSC_PHOTOVOLTAIC_MODULE_COUNT"></ssc-input><ssc-input type="input" field="ssc_pv_module.{{moduleIndex}}.module_length" page="formPageScope" label="SSC_PHOTOVOLTAIC_MODULE_LENGTH" unit="mm"></ssc-input><ssc-input type="input" field="ssc_pv_module.{{moduleIndex}}.module_width" page="formPageScope" label="SSC_PHOTOVOLTAIC_MODULE_WIDTH" unit="mm"></ssc-input><ssc-input type="input" field="ssc_pv_module.{{moduleIndex}}.module_power" page="formPageScope" label="SSC_PHOTOVOLTAIC_MODULE_POWER" unit-html="W<sub>peak</sub>"></ssc-input><div class="flabel" data-ng-bind="\'SSC_PHOTOVOLTAIC_BALCONY_TITLE\' | translate"></div><div class="margcreatetop"></div><ssc-input type="select" field="ssc_pv_module.{{moduleIndex}}.balcony_type_id" page="formPageScope" options="content.ssc_pv_balcony_type" optionfield="description" label="SSC_PHOTOVOLTAIC_BALCONY_TYPE" help="TIP_PV_BALCONY_TYPE"></ssc-input><ssc-input type="input" field="ssc_pv_module.{{moduleIndex}}.floor" page="formPageScope" label="SSC_PHOTOVOLTAIC_FLOOR" precision="0"></ssc-input><ssc-input type="input" field="ssc_pv_module.{{moduleIndex}}.balcony_width" page="formPageScope" label="SSC_PHOTOVOLTAIC_BALCONY_WIDTH" precision="2" unit="m"></ssc-input><ssc-input type="input" field="ssc_pv_module.{{moduleIndex}}.balcony_length" page="formPageScope" label="SSC_PHOTOVOLTAIC_BALCONY_LENGTH" precision="2" unit="m"></ssc-input><ssc-input type="input" field="ssc_pv_module.{{moduleIndex}}.balcony_height" page="formPageScope" label="SSC_PHOTOVOLTAIC_BALCONY_HEIGHT" precision="2" unit="m"></ssc-input><div class="margcreatetop"></div><hr><ssc-input type="select" field="ssc_pv_module.{{moduleIndex}}.alignment_id" page="formPageScope" options="content.ssc_pv_alignment" optionfield="description" label="SSC_PHOTOVOLTAIC_ALIGNMENT"></ssc-input><ssc-input type="select" field="ssc_pv_module.{{moduleIndex}}.shading_duration_id" page="formPageScope" options="content.ssc_pv_shading_duration" optionfield="description" label="SSC_PHOTOVOLTAIC_SHADING_DURATION"></ssc-input><ssc-input type="input" disabled="true" field="ssc_pv_module.{{moduleIndex}}.total_module_power" page="formPageScope" label="SSC_PHOTOVOLTAIC_TOTAL_MODULE_POWER" unit="W"></ssc-input><div class="margcreatebot"></div></div></div></div><div class="row"><div class="col-sm-5"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_pv_module\']" add-onclick="addPvModule(content.ssc_photovoltaic.id, \'add_ssc_pv_module\')" add-enabled="tableProperties.ssc_pv_module.canCreate" add-label="SSC_PHOTOVOLTAIC_ADD_MODULE"></ssc-add-button></div></div><div id="accordion-2" class="accordeon"><div class="field"><div class="panel-hiding hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion-2" href="#collapse-summary"><span ng-bind="\'SSC_PHOTOVOLTAIC_TITLE\' | translate" ng-class="{error: errors.ssc_photovoltaic.length > 0}"></span></div><div id="collapse-summary" class="collapse in"><ssc-errorbox data-messages="errors.ssc_photovoltaic"></ssc-errorbox><div class="margcreatetop"></div><ssc-input type="input" disabled="true" field="ssc_photovoltaic.system_power" page="formPageScope" label="SSC_PHOTOVOLTAIC_SYSTEM_POWER" unit="W"></ssc-input><ssc-input type="input" field="ssc_photovoltaic.inverter_power" page="formPageScope" label="SSC_PHOTOVOLTAIC_INVERTER_POWER" unit="W"></ssc-input><ssc-input type="input" field="ssc_photovoltaic.total_costs" page="formPageScope" label="SSC_PHOTOVOLTAIC_TOTAL_COSTS" precision="2" unit="Euro"></ssc-input><div class="flabel" data-ng-bind="\'SSC_PHOTOVOLTAIC_MONTAGE_TITLE\' | translate"></div><div class="margcreatetop"></div><ssc-input type="date" dateformattype="days" datemodeltype="days" field="ssc_photovoltaic.installed_at" help="TIP_PHOTOVOLTAIC_INSTALLED_AT" page="formPageScope" label="SSC_PHOTOVOLTAIC_INSTALLED_AT"></ssc-input><ssc-input type="input" field="ssc_photovoltaic.agency" page="formPageScope" is-text="true" label="SSC_PHOTOVOLTAIC_AGENCY"></ssc-input><ssc-input type="select" field="ssc_photovoltaic.socket_type_id" page="formPageScope" options="content.ssc_pv_socket_type" optionfield="description" label="SSC_PHOTOVOLTAIC_SOCKET_TYPE"></ssc-input><ssc-input type="input" field="ssc_photovoltaic.socket_type_other" page="formPageScope" is-text="true" label="SSC_PHOTOVOLTAIC_SOCKET_TYPE_OTHER"></ssc-input><ssc-input type="input" field="ssc_photovoltaic.installer_name" page="formPageScope" is-text="true" label="SSC_PHOTOVOLTAIC_INSTALLER_NAME"></ssc-input><ssc-input type="toggle" field="ssc_photovoltaic.ownership_declaration" page="formPageScope" label="SSC_PHOTOVOLTAIC_OWNERSHIP_DECLARATION"></ssc-input><div class="flabel" data-ng-bind="\'SSC_PHOTOVOLTAIC_SUMMARY_TITLE\' | translate"></div><div class="margcreatetop"></div><ssc-input type="input" field="ssc_photovoltaic.annual_production" page="formPageScope" label="SSC_PHOTOVOLTAIC_ANNUAL_PRODUCTION" unit="kWh/a"></ssc-input><ssc-input type="input" field="ssc_photovoltaic.avoided_electricity_consumption" page="formPageScope" label="SSC_PHOTOVOLTAIC_AVOIDED_ELECTRICITY_CONSUMPTION" unit="kWh/a"></ssc-input><ssc-input type="input" disabled="true" field="ssc_photovoltaic.utilisation_rate" page="formPageScope" label="SSC_PHOTOVOLTAIC_UTILISATION_RATE" unit="%"></ssc-input><ssc-input type="input" disabled="true" field="ssc_photovoltaic.self_sufficiency_level" page="formPageScope" label="SSC_PHOTOVOLTAIC_SELF_SUFFICIENCY_LEVEL" unit="%"></ssc-input><ssc-input type="input" disabled="true" field="ssc_photovoltaic.savings_euro" page="formPageScope" label="SSC_PHOTOVOLTAIC_SAVINGS_EURO" unit="Euro"></ssc-input><ssc-input type="input" disabled="true" field="ssc_photovoltaic.savings_emission" page="formPageScope" label="SSC_PHOTOVOLTAIC_SAVINGS_EMISSION" unit="kg"></ssc-input><div class="margcreatebot"></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/refrigerator/refrigerator.html','<div data-ng-controller="refrigeratorController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'SSC_TILE_REFRIGERATOR_SH\' | translate) +\' - \'+ (\'SSC_TILE_REFRIGERATOR\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><h4 ng-if="formVars.isCorrupted" style="border:solid 2px red; color: red; padding-left:5px"><i class="fa fa-exclamation-triangle marg-right-small" aria-hidden="true"></i>Veralteter / Besch\xE4digter Check</h4><div class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" href="#collapse1"><span data-ng-bind="(\'SSC_REFRIGERATOR_EXCHANGE\' | translate)" ng-class="{\'error\': errors.exchange.hasError, \'warning\': !errors.exchange.hasError && errors.exchange.hasWarning}"></span></div><div id="collapse1" class="collapse in"><ssc-errorbox data-messages="errors.exchange.messages"></ssc-errorbox><div class="margcreatetop"></div><ssc-input data-type="select" data-field="ssc_refrigerator_exchange.ssc_refrigerator_partner_id" data-options="formPageScope.content.ssc_refrigerator_partner" data-optionfield="name" data-label="SSC_REFRIGERATOR_PARTNER" data-unit="" data-page="formPageScope" data-help=""></ssc-input><div class="margcreatetop"></div></div></div></div><h4 data-ng-bind="(\'SSC_REFRIGERATOR_INPUT\' | translate)"></h4><div ng-repeat="(refrigeratorIndex,refrigerator) in content.ssc_refrigerator track by refrigerator.id"><div class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle" fastaddclass="formVars.fridgeAccordeon[$index] ? \'\' : \'collapsed\'" data-toggle="collapse" ng-click="domChangedAccordeon()" href="#fridgeAccordeon{{refrigeratorIndex}}"><span data-ng-bind="(\'SSC_REFRIGERATOR_DEVICE\' | translate) + \' \' + (refrigeratorIndex + 1)" ng-class="{\'error\': errors.fridge[refrigeratorIndex].hasError, \'warning\': !errors.fridge[refrigeratorIndex].hasError && errors.fridge[refrigeratorIndex].hasWarning}"></span><ssc-delete-button delete-enabled="tableProperties.ssc_refrigerator.canDelete" delete-onclick="delete(\'sscrefrigerator\', refrigeratorIndex, refrigerator.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div id="fridgeAccordeon{{refrigeratorIndex}}" class="collapse" fastaddclass="formVars.fridgeAccordeon[$index] ? \'in\' : \'\'"><ssc-errorbox data-messages="errors.fridge[refrigeratorIndex].messages"></ssc-errorbox><div class="margcreatetop"></div><ssc-input data-type="select" data-field="ssc_refrigerator.{{$index}}.household_is_owner" data-options="formPageScope.formVars.isOwnerOptions" data-optionfield="name" data-label="SSC_REFRIGERATOR_HOUSEHOLD_IS_OWNER" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="toggle" data-field="ssc_refrigerator.{{$index}}.is_built_in_device" data-label="SSC_REFRIGERATOR_IS_BUILT_IN_DEVICE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="toggle" data-field="ssc_refrigerator.{{$index}}.has_fridge_thermometer" data-label="SSC_REFRIGERATOR_FRIDGE_THERMOMETER" data-unit="" data-page="formPageScope" data-help="TIP_REFRIGERATOR_THERMOMETER" data-ng-disabled="true"></ssc-input><ssc-input data-type="select" data-field="ssc_refrigerator.{{$index}}.ssc_refrigerator_producer_id" data-options="formPageScope.content.ssc_refrigerator_producer" data-optionfield="name" data-label="SSC_REFRIGERATOR_PRODUCER" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="ssc_refrigerator.{{$index}}.ssc_refrigerator_model_group_id" data-options="refrigerator.ssc_refrigerator_model_group_list" data-optionfield="name" data-label="SSC_REFRIGERATOR_MODEL_GROUP" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="ssc_refrigerator.{{$index}}.ssc_refrigerator_model_id" data-options="refrigerator.ssc_refrigerator_model_list" data-optionfield="name" data-label="SSC_REFRIGERATOR_MODEL_ID" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="ssc_refrigerator.{{$index}}.build_type_id" data-options="formPageScope.content.ssc_refrigerator_build_type" data-optionfield="name" data-label="SSC_REFRIGERATOR_BUILD_TYPE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><hr class="margcreatetop-sm margcreatebot-sm"><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.cooling_space" data-label="SSC_REFRIGERATOR_COOLING_SPACE" data-unit="Liter" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.freezing_space_only" data-label="SSC_REFRIGERATOR_FREEZING_SPACE_ONLY" data-unit="Liter" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.cooling_space_only" data-label="SSC_REFRIGERATOR_COOLING_SPACE_ONLY" data-unit="Liter" data-page="formPageScope" data-help="" data-disabled="true"></ssc-input><hr class="margcreatetop-sm margcreatebot-sm"><ssc-input data-type="select" data-field="ssc_refrigerator.{{$index}}.age" data-options="content.age_options" data-optionfield="id" data-label="SSC_REFRIGERATOR_AGE" data-unit="Jahre" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="ssc_refrigerator.{{$index}}.built_at" data-options="content.construction_year_options" data-optionfield="id" data-label="SSC_REFRIGERATOR_BUILT_AT" data-unit="Jahr" data-page="formPageScope" data-help=""></ssc-input><hr class="margcreatetop-sm margcreatebot-sm"><ssc-input data-type="select" data-field="ssc_refrigerator.{{$index}}.cooling_level_count" data-options="formPageScope.formVars.coolingStepsOptions" data-optionfield="id" data-label="SSC_REFRIGERATOR_COOLING_LEVEL_COUNT" data-unit="" data-page="formPageScope" data-help="TIP_REFRIGERATOR_COOLING_LEVEL_COUNT"></ssc-input><ssc-input data-type="select" data-field="ssc_refrigerator.{{$index}}.cooling_level_used" data-options="refrigerator.COOLING_STEP_OPTIONS" data-optionfield="id" data-label="SSC_REFRIGERATOR_COOLING_LEVEL_USED" data-unit="" data-page="formPageScope" data-help="TIP_REFRIGERATOR_COOLING_LEVEL_USED"></ssc-input><hr class="margcreatetop-sm margcreatebot-sm"><ssc-input data-type="select" data-field="ssc_refrigerator.{{$index}}.energy_label_id" data-options="refrigerator.energy_labels" data-optionfield="description" data-label="SSC_REFRIGERATOR_ENERGY_LABEL" data-unit="" data-page="formPageScope"></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.energy_label_consumption" data-label="SSC_REFRIGERATOR_ENERGY_LABEL_CONSUMPTION" data-unit="kWh/a" data-page="formPageScope" data-help=""></ssc-input><div class="margcreatetop"></div><div class="flabel clearfix"><div class="col-sm-12"><span data-ng-bind="\'SSC_REFRIGERATOR_METERING\' | translate"></span> - <span data-ng-bind="\'SSC_STANDBY_DEVICE\' | translate"></span> {{$index + 1}}</div></div><div class="margcreatetop"></div><ssc-input data-type="toggle" data-field="ssc_refrigerator.{{$index}}.metering_was_not_possible" data-label="SSC_REFRIGERATOR_METERING_NOT_POSSIBLE" data-unit="" data-inverted="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="textarea" data-field="ssc_refrigerator.{{$index}}.metering_not_possible_reason" data-label="SSC_REFRIGERATOR_METERING_NOT_POSSIBLE_REASON" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="date" data-field="ssc_refrigerator.{{$index}}.metering_begin" data-datemodeltype="minutes" data-dateformattype="minutes" data-label="SSC_REFRIGERATOR_METERING_BEGIN" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="date" data-field="ssc_refrigerator.{{$index}}.metering_end" data-datemodeltype="minutes" data-dateformattype="minutes" data-label="SSC_REFRIGERATOR_METERING_END" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.metering_consumption" data-label="SSC_REFRIGERATOR_METERING_CONSUMPTION" data-unit="kWh" data-precision="3" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.metering_consumption_year" data-label="SSC_REFRIGERATOR_METERING_YEAR" data-unit="kWh/a" data-disabled="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.metering_consumption_similar" data-label="SSC_REFRIGERATOR_METERING_ANNUAL_CONSUMPTION" data-unit="kWh/a" data-disabled="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.standard_annual_consumption" data-label="SSC_REFRIGERATOR_STANDARD_ANNUAL_CONSUMPTION" data-unit="kWh/a" data-disabled="true" data-page="formPageScope" data-help=""></ssc-input><div class="row margcreatetop" ng-if="!refrigerator.metering_was_not_possible && refrigerator.metering_consumption_year > refrigerator.metering_consumption_similar * 1.25"><div class="col-sm-12"><div class="nlabel ssc-form-hint">{{\'SSC_REFRIGERATOR_HIGH_CONSUMPTION\' | translate}}</div></div></div><div class="margcreatetop"></div><div class="flabel clearfix"><div class="col-sm-12"></div></div><div class="row margcreatetop" ng-if="content.ssc_refrigerator_exchange.MISSING_INFORMATION"><div class="col-sm-12"><div class="nlabel ssc-form-hint">{{\'SSC_REFRIGERATOR_MISSING_INFORMATION\' | translate}}:<div ng-repeat="el in content.ssc_refrigerator_exchange.MISSING_INFORMATION">- {{el}}</div></div></div></div><div class="margcreatetop"></div><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.annual_consumption_new" data-label="SSC_REFRIGERATOR_ANNUAL_CONSUMPTION" data-unit="kWh/a" data-disabled="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.annual_consumption_new_bigger" data-label="SSC_REFRIGERATOR_ANNUAL_CONSUMPTION_NEW_BIGGER" data-unit="kWh/a" data-disabled="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.savings_potential" data-label="SSC_REFRIGERATOR_SAVING_POTENTIAL" data-unit="kWh/a" data-disabled="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="toggle" data-field="ssc_refrigerator.{{$index}}.is_to_swap" data-label="SSC_REFRIGERATOR_IS_TO_SWAP" data-unit="" data-page="formPageScope" data-help=""></ssc-input><div class="margcreatetop"></div><ssc-input data-type="input" data-field="ssc_refrigerator.{{$index}}.metering_seal_number" data-label="SSC_REFRIGERATOR_METERING_SEAL_NUMBER" data-unit="" data-page="formPageScope" data-help=""></ssc-input><div class="margcreatetop"></div></div></div></div></div><div class="accordeon" ng-if="properties.ssc_refrigerator_exchange && !properties.ssc_refrigerator_exchange.test_new_fridge_consumption.hidden"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" href="#collapseExchange"><span data-ng-bind="(\'K\xFChlger\xE4tetauschprogramm\' | translate)"></span></div><div id="collapseExchange" class="collapse in"><div class="margcreatetop"></div><ssc-input data-type="label" data-field="ssc_refrigerator_exchange.test_new_fridge_consumption" data-label="SSC_REFRIGERATOR_CONSUMPTION_COMPARE" data-unit="kWh/a" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="label" data-field="ssc_refrigerator_exchange.voucher_savings_potential" data-label="SSC_REFRIGERATOR_SAVINGS" data-unit="kWh/a" data-page="formPageScope" data-help=""></ssc-input><div class="clearfix row"><div class="col-sm-12" ng-if="content.ssc_refrigerator_exchange.voucher_binding_consumption_type === \'eligible_with_warning\'"><div class="ssc-form-hint"><span class="nlabel" data-ng-bind="(\'SSC_REFRIGERATOR_STEP1_INFO_TEXT_ATTENTION\' | translate)"></span></div></div><div class="col-sm-12" ng-if="content.ssc_refrigerator_exchange.voucher_binding_consumption_type === \'eligible\'"><span class="nlabel" data-ng-bind="(\'SSC_REFRIGERATOR_STEP1_INFO_TEXT\' | translate)"></span></div><div class="col-sm-12" ng-if="content.ssc_refrigerator_exchange.voucher_binding_consumption_type === \'not_eligible\'"><span class="nlabel" data-ng-bind="(\'SSC_REFRIGERATOR_STEP1_INFO_TEXT_NO\' | translate)"></span></div></div><div class="margcreatetop"></div></div></div></div><div class="row"><div class="col-sm-5"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_refrigerator_button\']" add-onclick="addRow(\'ssc_refrigerator\', content.ssc_refrigerator_exchange.id, \'add_ssc_refrigerator_button\')" add-enabled="tableProperties.ssc_refrigerator.canCreate" add-label="SSC_REFRIGERATOR_ADD_REFRIGERATOR"></ssc-add-button></div><div class="col-sm-5 col-sm-offset-2" permission="" permission-only="[\'LOKO\', \'ADMIN\']"><button class="redbutton" ng-disabled="btnIsSaving[\'refresh_age_button\'] > 0" ng-click="refreshAge(\'refresh_age_button\')"><i class="fa fa-circle-o-notch loader fa-spin fa-fw marg-right-small" ng-if="btnIsSaving[\'refresh_age_button\'] > 0"></i> <span ng-bind="\'SSC_REFRIGERATOR_REFRESH_AGE\' | translate"></span></button></div></div><div class="margcreatetop"></div><div class="accordeon"><div class="field" ng-if="properties.ssc_refrigerator_exchange && !properties.ssc_refrigerator_exchange.info_is_eligible.hidden"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse4"><span data-ng-bind="(\'SSC_REFRIGERATOR_STEP1\' | translate)"></span></div><div id="collapse4" class="collapse"><div class="margcreatetop"></div><div class="clearfix row" ng-if="properties.ssc_refrigerator_exchange.info_dl_lang_id.hidden"><div class="col-sm-12"><span class="nlabel" data-ng-bind="(\'Ab Freigabe 2.HH-Besuch kann das Infoschreiben geladen werden.\' | translate)"></span></div></div><ssc-input data-type="select" data-field="ssc_refrigerator_exchange.info_dl_lang_id" data-options="formPageScope.content.ssc_refrigerator_info_lang" data-optionfield="name" data-label="SSC_REFRIGERATOR_INFO_LANG" data-unit="" data-page="formPageScope" data-help=""></ssc-input><div class="row" ng-if="!properties.ssc_refrigerator_exchange.info_dl_lang_id.hidden"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_REFRIGERATOR_INFO_DL\' | translate"></span></div><div class="col-sm-1 col-xs-2"><a target="_blank" ng-href="{{formVars.info_dl_route}}?ssc_id={{content.ssc_refrigerator_exchange.ssc_id}}&token={{formVars.token}}&lang={{content.ssc_refrigerator_exchange.info_dl_lang_id}}"><i class="fa fa-download in-form-icon" aria-hidden="true"></i></a></div><div class="col-sm-6 col-xs-10 nlabel" ng-if="content.ssc_refrigerator_exchange && !content.ssc_refrigerator_exchange.info_dl_count" data-ng-bind="(\'SSC_REFRIGERATOR_DOWNLOAD_RELOAD\' | translate)"></div></div><div ng-if="!content.ssc_refrigerator_exchange.has_sealnumber" class="margcreatebot"><ssc-errorbox data-messages="[{type:\'error\',text:(\'SSC_REFRIGERATOR_EXCHANGE_DOWNLOAD_ERROR_MSG\' | translate)}]" data-ssc-errorbox-title="\'SSC_REFRIGERATOR_EXCHANGE_DOWNLOAD_ERROR\' | translate"></ssc-errorbox></div><div class="margcreatetop"></div></div></div></div><div class="accordeon"><div class="field" ng-if="content.ssc_refrigerator_exchange && content.ssc_refrigerator_exchange.info_is_eligible && !properties.ssc_refrigerator_exchange.info_is_eligible.hidden"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse5"><span data-ng-bind="(\'SSC_REFRIGERATOR_STEP2\' | translate)"></span></div><div id="collapse5" class="collapse"><div class="row margcreatetop" ng-if="!content.ssc_refrigerator_exchange.info_dl_count"><div class="col-sm-12"><div class="nlabel ssc-form-hint">{{\'Das Infoschreiben muss mindestens einmal heruntergeladen werden bevor ein Gutschein erstellt werden kann.\' | translate}}</div></div></div><div class="row clearfix margcreatetop"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_REFRIGERATOR_VALID_TILL\' | translate"></span></div><div class="col-sm-8 nlabel">{{formVars.voucherExpiredBy | date: \'dd.MM.yyyy\'}}</div></div><div class="row clearfix"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_REFRIGERATOR_VOUCHER_VALUE\' | translate"></span></div><div class="col-sm-8 nlabel"><span ng-show="formVars.newVoucherValue > 0">{{formVars.newVoucherValue}} \u20AC</span> <span ng-show="formVars.newVoucherValue === null && content.ssc_refrigerator_exchange.ssc_refrigerator_partner_id === 3" ng-bind="\'SSC_REFRIGERATOR_VOUCHER_VALUE_COMPLETE\' | translate"></span></div></div><div class="row clearfix"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_REFRIGERATOR_BINDING_MAX_CONSUMPTION\' | translate"></span></div><div class="col-sm-8 nlabel"><span data-ng-bind="content.ssc_refrigerator_exchange.voucher_binding_max_consumption | decimal2comma: 0"></span> kWh/a</div></div><div ng-repeat="refrigerator in content.ssc_refrigerator track by $index"><div class="row clearfix" ng-if="refrigerator.is_to_swap"><div class="col-sm-4 ilabel"><span data-ng-bind="(\'SSC_REFRIGERATOR_SEAL_NUMBER\' | translate) + \' \' + ($index + 1)"></span></div><div class="col-sm-8 nlabel"><span data-ng-bind="refrigerator.metering_seal_number"></span></div></div></div><ssc-errorbox data-messages="voucherErrors" data-ssc-errorbox-title="\'SSC_REFRIGERATOR_EXCHANGE_VOUCHER_ERROR\' | translate"></ssc-errorbox><div class="row"><div class="col-md-offset-8 col-md-4"><button ng-disabled="!tableProperties.ssc_refrigerator_voucher.canCreate" class="redbutton" type="submit" data-ng-bind="\'SSC_REFRIGERATOR_CREATE_VOUCHER\' | translate" ng-click="addRow(\'ssc_refrigerator_voucher\', content.ssc_refrigerator_exchange.id, \'add_ssc_refrigerator_voucher_button\')"></button></div></div><div class="row"><div class="col-md-offset-8 col-md-4"><button ng-disabled="properties.ssc_refrigerator_exchange.voucher_is_extendable.disabled === true" ng-click="extendVoucher()" class="redbutton" type="submit" data-ng-bind="\'SSC_REFRIGERATOR_EXTEND_VOUCHER\' | translate"></button></div></div></div></div></div><div class="accordeon"><div class="field" ng-repeat="voucher in content.ssc_refrigerator_voucher track by $index"><div class="panel-heading hlabel accordion-toggle" fastaddclass="formVars.voucherAccordeon[$index] ? \'\' : \'collapsed\'" data-parent="#accordion1" ng-click="domChangedAccordeon()" data-toggle="collapse" href="#voucherAccordeon{{$index}}"><span data-ng-bind="(\'SSC_REFRIGERATOR_STEP_VOUCHER\' | translate) + \' (ID \' + content.ssc_refrigerator_voucher[$index].id + \')\'" data-ng-class="{\'strikethrough\': $index < content.ssc_refrigerator_voucher.length - 1}"></span></div><div id="voucherAccordeon{{$index}}" class="collapse" fastaddclass="formVars.voucherAccordeon[$index] ? \'in\' : \'\'"><div class="row clearfix margcreatetop"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_REFRIGERATOR_VOUCHER_ID\' | translate"></span></div><div class="col-sm-8 nlabel"><span data-ng-bind="content.ssc_refrigerator_voucher[$index].id"></span></div></div><div class="row clearfix"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_REFRIGERATOR_VOUCHER_STATE\' | translate"></span></div><div class="col-sm-8 nlabel"><span class="font-weight-bold" data-ng-bind="\'\u2713 \' + (\'SSC_REFRIGERATOR_VOUCHER_STATE_REDEEMED\' | translate) + \', \' + (toDate(content.ssc_refrigerator_voucher[$index].redeemed_date) | date: \'dd.MM.yyyy\')" ng-if="content.ssc_refrigerator_voucher[$index].redeemed_date"></span> <span class="font-weight-bold" data-ng-bind="(\'SSC_REFRIGERATOR_VOUCHER_STATE_NOT_REDEEMED\' | translate)" ng-if="!content.ssc_refrigerator_voucher[$index].redeemed_date"></span> <span class="font-italic" ng-if="content.ssc_refrigerator_voucher[$index].is_edited_by_admin" data-ng-bind="\'SSC_REFRIGERATOR_REDEEMED_CHANGED_BY_ADMIN\' | translate"></span></div></div><div class="row clearfix"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_REFRIGERATOR_VALID_TILL\' | translate"></span></div><div class="col-sm-8 nlabel">{{toDate(content.ssc_refrigerator_voucher[$index].expires_after) | date: \'dd.MM.yyyy\'}}</div></div><div class="row clearfix"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_REFRIGERATOR_VOUCHER_VALUE\' | translate"></span></div><div class="col-sm-8 nlabel"><span>{{content.ssc_refrigerator_voucher[$index].value | number:0}} \u20AC</span></div></div><div class="row clearfix margcreatebot"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_REFRIGERATOR_VOUCHER_CREATED_BY\' | translate"></span></div><div class="col-sm-8 nlabel"><span data-ng-bind="content.ssc_refrigerator_voucher[$index].created_by_user.firstname"></span> <span data-ng-bind="content.ssc_refrigerator_voucher[$index].created_by_user.lastname"></span>, {{content.ssc_refrigerator_voucher[$index].created_at | amUtc | amLocal | amDateFormat:\'D.M.YYYY\'}}</div></div><div ng-if="!content.ssc_refrigerator_exchange.has_sealnumber"><ssc-errorbox data-messages="[{type:\'error\',text:(\'SSC_REFRIGERATOR_EXCHANGE_DOWNLOAD_ERROR_MSG\' | translate)}]" data-ssc-errorbox-title="\'SSC_REFRIGERATOR_EXCHANGE_DOWNLOAD_ERROR\' | translate"></ssc-errorbox></div><div class="row" ng-if="$index === content.ssc_refrigerator_voucher.length - 1 && content.ssc_refrigerator_exchange.has_sealnumber"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_REFRIGERATOR_VOUCHER_DOWNLOAD\' | translate"></span></div><div class="col-sm-1 col-xs-2"><a target="_blank" ng-href="{{formVars.voucher_dl_route}}?id={{content.ssc_refrigerator_voucher[$index].id}}"><i class="fa fa-download in-form-icon" aria-hidden="true"></i></a></div></div><div class="margcreatebot"></div></div></div></div><div class="accordeon"><div class="field" data-ng-if="properties.ssc_refrigerator_exchange && (!properties.ssc_refrigerator_exchange.new_date_hand_over_old.hidden || !properties.ssc_refrigerator_exchange.billing_status_type_id.hidden)"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse7"><span data-ng-bind="(\'SSC_REFRIGERATOR_NEW_INPUT\' | translate)" ng-class="{\'error\': errors.newFridge.hasError, \'warning\': !errors.newFridge.hasError && errors.newFridge.hasWarning}"></span></div><div id="collapse7" class="collapse" data-ng-init="createExchangeDTPickers()"><ssc-errorbox data-messages="errors.newFridge.messages"></ssc-errorbox><div class="margcreatetop"></div><ssc-input data-type="date" data-field="ssc_refrigerator_exchange.new_date_hand_over_old" data-datemodeltype="minutes" data-dateformattype="days" data-label="SSC_REFRIGERATOR_NEW_DATE_HAND_OVER_OLD" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator_exchange.new_producer_name" data-options="formPageScope.content.new_producer" data-optionfield="name" data-is-text="true" data-label="SSC_REFRIGERATOR_NEW_PRODUCER" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator_exchange.new_model" data-options="formPageScope.content.new_model" data-optionfield="name" data-label="SSC_REFRIGERATOR_NEW_MODEL" data-unit="" data-is-text="true" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="ssc_refrigerator_exchange.new_build_type_id" data-options="formPageScope.content.ssc_refrigerator_build_type" data-optionfield="name" data-label="SSC_REFRIGERATOR_NEW_BUILD_TYPE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="toggle" data-field="ssc_refrigerator_exchange.new_is_built_in_device" data-label="SSC_REFRIGERATOR_NEW_IS_BUILT_IN_DEVICE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator_exchange.new_cooling_space" data-label="SSC_REFRIGERATOR_NEW_COOLING_SPACE" data-unit="Liter" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator_exchange.new_freezing_space_only" data-label="SSC_REFRIGERATOR_NEW_FREEZING_SPACE_ONLY" data-unit="Liter" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator_exchange.new_cooling_space_only" data-label="SSC_REFRIGERATOR_NEW_COOLING_SPACE_ONLY" data-unit="Liter" data-page="formPageScope" data-help="" data-disabled="true"></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator_exchange.new_consumption" data-label="SSC_REFRIGERATOR_NEW_CONSUMPTION" data-unit="kWh/a" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="select" data-field="ssc_refrigerator_exchange.new_energy_label_id" data-options="formPageScope.content.energy_labels" data-optionfield="description" data-label="SSC_REFRIGERATOR_NEW_ENERGY_LABEL" data-unit="" data-page="formPageScope"></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator_exchange.new_price" data-label="SSC_REFRIGERATOR_NEW_PRICE" data-unit="\u20AC" data-page="formPageScope" data-help="" data-precision="2"></ssc-input><ssc-input data-type="date" data-field="ssc_refrigerator_exchange.new_voucher_used_date" data-datemodeltype="minutes" data-dateformattype="days" data-label="SSC_REFRIGERATOR_NEW_VOUCHER_USED_DATE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><div class="margcreatetop"></div><hr ng-if="properties.ssc_refrigerator_exchange && !properties.ssc_refrigerator_exchange.new_date_hand_over_old.hidden && !properties.ssc_refrigerator_exchange.billing_status_type_id.hidden"><ssc-input data-type="select" data-field="ssc_refrigerator_exchange.billing_status_type_id" data-options="formPageScope.content.ssc_billing_status_type" data-optionfield="name" data-label="SSC_REFRIGERATOR_EXCHANGE_BILLING_STATUS_TYPE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="input" data-field="ssc_refrigerator_exchange.billing_nr_intern" data-label="SSC_REFRIGERATOR_EXCHANGE_BILLING_NR_INTERN" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="date" data-field="ssc_refrigerator_exchange.inspection_date" data-datemodeltype="minutes" data-dateformattype="minutes" data-label="SSC_REFRIGERATOR_EXCHANGE_INSPECTION_DATE" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="textarea" data-field="ssc_refrigerator_exchange.comment" data-label="SSC_REFRIGERATOR_EXCHANGE_COMMENT" data-unit="" data-page="formPageScope" data-help=""></ssc-input><div class="margcreatetop"></div></div></div></div><div class="accordeon"><div class="field" ng-if="properties.ssc_refrigerator_exchange && !properties.ssc_refrigerator_exchange.is_local_subsidy.hidden"><div class="panel-heading hlabel accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapse6"><span data-ng-bind="(\'SSC_REFRIGERATOR_LOCAL_SUBSIDY\' | translate)" ng-class="{\'error\': errors.localSubsidy.hasError, \'warning\': !errors.localSubsidy.hasError && errors.localSubsidy.hasWarning}"></span></div><div id="collapse6" class="collapse"><ssc-errorbox data-messages="errors.localSubsidy.messages"></ssc-errorbox><div class="margcreatetop"></div><ssc-input data-type="toggle" data-field="ssc_refrigerator_exchange.is_local_subsidy" data-label="SSC_REFRIGERATOR_LOCAL_SUBSIDY" data-unit="" data-page="formPageScope" data-help="" data-precision="2"></ssc-input><hr><div ng-repeat="subsidy in content.ssc_local_subsidy track by subsidy.id"><ssc-delete-button delete-enabled="tableProperties.ssc_local_subsidy.canDelete" delete-onclick="delete(\'ssclocalsubsidy\', $index, subsidy.id)" delete-class="sscDeleteAccordion"></ssc-delete-button><ssc-input data-type="input" data-field="ssc_local_subsidy.{{$index}}.subsidy_amount" data-label="SSC_REFRIGERATOR_SUBSIDY" data-unit="" data-page="formPageScope" data-help="" data-precision="2"></ssc-input><ssc-input data-type="select" data-field="ssc_local_subsidy.{{$index}}.local_subsidy_partner_id" data-options="formPageScope.content.ssc_local_subsidy_partner" data-optionfield="name" data-label="SSC_REFRIGERATOR_SUBSIDY_PROVIDER" data-unit="" data-page="formPageScope" data-help=""></ssc-input><ssc-input data-type="toggle" data-field="ssc_local_subsidy.{{$index}}.is_payback" data-label="SSC_REFRIGERATOR_SUBSIDY_IS_PAYBACK" data-unit="" data-page="formPageScope" data-help=""></ssc-input><hr></div><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_local_subsidy_button\']" add-onclick="addRow(\'ssc_local_subsidy\', content.ssc_refrigerator_exchange.id, \'add_ssc_local_subsidy_button\')" add-enabled="tableProperties.ssc_local_subsidy.canCreate" add-label="SSC_REFRIGERATOR_SUBSIDY_ADD"></ssc-add-button></div></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/shower/shower.html','<div data-ng-controller="showerController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'SSC_TILE_SHOWER_SH\' | translate) +\' - \'+ (\'SSC_TILE_SHOWER\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div ng-repeat="(showerIndex,shower) in content.ssc_shower track by shower.id"><div id="accordion{{showerIndex}}" class="accordeon"><div class="field margin-bottom-2"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" fastaddclass="accordions[$index][0] ? \'\' : \'collapsed\'" data-parent="#accordion{{showerIndex}}" href="#collapse{{showerIndex + 1}}"><span data-ng-bind="(\'SSC_SHOWER_DIRECTHELP\' | translate) + \' \' + (showerIndex + 1)" ng-class="{\'error\': errors.shower[showerIndex].hasError, \'warning\': !errors.shower[showerIndex].hasError && errors.shower[showerIndex].hasWarning}"></span><ssc-delete-button delete-enabled="tableProperties.ssc_shower.canDelete" delete-onclick="delete(\'sscshower\', showerIndex, shower.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div id="collapse{{showerIndex + 1}}" class="collapse" fastaddclass="accordions[$index][0] ? \'in\' : \'\'"><ssc-errorbox data-messages="errors.shower[showerIndex].messages"></ssc-errorbox><div class="margcreatetop"></div><div class="row"><div errorlabel="ssc_shower.{{showerIndex}}.flow_rate_before" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_SHOWER_FLOW_RATE\' | translate"></span> <span data-ng-if="properties.ssc_shower[showerIndex].flow_rate_before.required">*</span></div><div class="col-sm-6" errorlabel="ssc_shower.{{showerIndex}}.flow_rate_before" dataobj="required"><input class="createinputter" ng-model="shower.flow_rate_before" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshower\', \'flow_rate_before\', shower.flow_rate_before, shower.id)" decimal-separator-german="" precision="1"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_TAP_LITRE_PER_MIN\' | translate"></span></div><div class="col-sm-1" errorlabel="ssc_shower.{{showerIndex}}.flow_rate_before" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatetop"><div errorlabel="ssc_shower.{{showerIndex}}.directhelp_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_SHOWER_USE_DIRECTHELP\' | translate"></span> <span data-ng-if="properties.ssc_shower[showerIndex].directhelp_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_shower.{{showerIndex}}.directhelp_id" dataobj="required"><select class="createdropper leftdropper" ng-model="shower.directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshower\', \'directhelp_id\', shower.directhelp_id, shower.id)"><option value=""></option><option ng-repeat="item in content.shower_directhelp" ng-value="item.id" ng-disabled="item.status===0" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc_shower.{{showerIndex}}.directhelp_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_shower.{{showerIndex}}.flow_rate_directhelp" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_SHOWER_MEASURED_FLOW_RATE\' | translate"></span> <span data-ng-if="properties.ssc_shower[showerIndex].flow_rate_directhelp.required">*</span></div><div class="col-sm-6" errorlabel="ssc_shower.{{showerIndex}}.flow_rate_directhelp" dataobj="required"><input class="createinputter" ng-model="shower.flow_rate_directhelp" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshower\', \'flow_rate_directhelp\', shower.flow_rate_directhelp, shower.id)" decimal-separator-german="" precision="1"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_TAP_LITRE_PER_MIN\' | translate"></span></div><div class="col-sm-1" errorlabel="ssc_shower.{{showerIndex}}.flow_rate_directhelp" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatetop"><div errorlabel="ssc_shower.{{showerIndex}}.has_shower_timer" dataobj="required" class="col-sm-8 ilabel"><span data-ng-bind="\'SSC_SHOWER_HAS_SHOWER_TIMER\' | translate"></span> <span data-ng-if="required.ssc_shower.has_shower_timer.required">*</span></div><div class="col-sm-3" errorlabel="ssc_shower.{{showerIndex}}.has_shower_timer" dataobj="required"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="shower.has_shower_timer" value="required.status" id="has_shower_timer-{{showerIndex}}" ng-checked="shower.has_shower_timer === 1" ng-change="save(\'sscshower\', \'has_shower_timer\', shower.has_shower_timer, shower.id)"> <label class="checklabel" for="has_shower_timer-{{showerIndex}}"></label> <span data-ng-bind="shower.has_shower_timer === 1 ? (\'YES\' | translate) : (\'NO\' | translate)" class="checklabelText"></span></div><div errorlabel="ssc_shower.{{showerIndex}}.has_shower_timer" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_shower.{{showerIndex}}.ssc_shower_count_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_SHOWER_COUNT_TYPE\' | translate"></span> <span data-ng-if="properties.ssc_shower[showerIndex].ssc_shower_count_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_shower.{{showerIndex}}.ssc_shower_count_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="shower.ssc_shower_count_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshower\', \'ssc_shower_count_type_id\', shower.ssc_shower_count_type_id, shower.id)"><option value=""></option><option ng-repeat="item in content.ssc_shower_count_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_shower.{{showerIndex}}.ssc_shower_count_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div ng-show="shower.ssc_shower_count_type_id === 1 || shower.ssc_shower_count_type_id === \'1\'"><div class="flabel clearfix"><div class="col-sm-12"><span data-ng-bind="\'SSC_SHOWER_SHOWER_PERSONS\' | translate"></span></div></div><div class="row margcreatetop" ng-if="shower.has_shower_timer === 1"><div class="col-sm-12"><div class="row row-eq-height ilabel hidden-xs hidden-sm"><div class="col-md-2"><span data-ng-bind="\'SSC_SHOWER_SHOWER_PERSON_HOUSEHOLD\' | translate"></span></div><div class="col-md-2"><span data-ng-bind="\'SSC_SHOWER_COUNT_PER_WEEK\' | translate"></span></div><div class="col-md-2"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_SHOWER\' | translate"></span></div><div class="col-md-2"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_WEEK\' | translate"></span></div><div class="col-md-2"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_SHOWER_AFTER\' | translate"></span></div><div class="col-md-2"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_WEEK_AFTER\' | translate"></span></div></div><div ng-repeat="(personIndex, person) in shower.ssc_shower_person" class="tablebordercenter"><div class="row"><div class="col-md-2 ilabel"><span data-ng-bind="(\'SSC_SHOWER_SHOWER_PERSON\' | translate) + \' \' + (personIndex + 1)"></span></div><div class="col-sm-12 visible-xs visible-sm ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_COUNT_PER_WEEK\' | translate"></span></div><div class="col-md-2" errorlabel="ssc_shower.{{showerIndex}}.ssc_shower_person.{{personIndex}}.shower_count_per_week" dataobj="required"><input class="createinputter" ng-model="person.shower_count_per_week" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshowerperson\', \'shower_count_per_week\', person.shower_count_per_week, person.id)"></div><div class="col-sm-12 visible-xs visible-sm ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_SHOWER\' | translate"></span></div><div class="col-md-2" errorlabel="ssc_shower.{{showerIndex}}.ssc_shower_person.{{personIndex}}.shower_duration_per_shower" dataobj="required"><input class="createinputter" ng-model="person.shower_duration_per_shower" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshowerperson\', \'shower_duration_per_shower\', person.shower_duration_per_shower, person.id)"></div><div class="col-sm-12 visible-xs visible-sm ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_WEEK\' | translate"></span></div><div class="col-md-2 ilabel"><span ng-if="person.shower_duration_per_week" data-ng-bind="person.shower_duration_per_week"></span> <span ng-if="!person.shower_duration_per_week">0</span></div><div class="col-sm-12 visible-xs visible-sm ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_SHOWER_AFTER\' | translate"></span></div><div class="col-md-2" errorlabel="ssc_shower.{{showerIndex}}.ssc_shower_person.{{personIndex}}.shower_duration_per_shower_after" dataobj="required"><input class="createinputter" ng-model="person.shower_duration_per_shower_after" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshowerperson\', \'shower_duration_per_shower_after\', person.shower_duration_per_shower_after, person.id)"></div><div class="col-sm-12 visible-xs visible-sm ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_WEEK_AFTER\' | translate"></span></div><div class="col-md-2 ilabel" errorlabel="ssc_shower.{{showerIndex}}.ssc_shower_person.{{personIndex}}.shower_duration_per_week_after" dataobj="required"><span ng-if="person.shower_duration_per_week_after" data-ng-bind="person.shower_duration_per_week_after"></span> <span ng-if="!person.shower_duration_per_week_after">0</span><ssc-delete-button delete-enabled="tableProperties.ssc_shower_person.canDelete" delete-onclick="delete(\'sscshowerperson\', personIndex, person.id, showerIndex)" delete-class="sscDeleteAccordion"></ssc-delete-button></div></div></div><div class="row tablebordercenter"><div class="col-md-6 ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_TOTAL_WEEKLY_SHOWER_MINUTES\' | translate"></span></div><div class="col-md-2 ilabel nomargin"><span data-ng-bind="shower.shower_total_duration_week | decimal2comma"></span></div><div class="col-md-2 ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_TOTAL_WEEKLY_SHOWER_MINUTES_AFTER\' | translate"></span></div><div class="col-md-2 ilabel nomargin"><span data-ng-bind="shower.shower_total_duration_week_after | decimal2comma"></span></div></div><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_shower_person_button\' + showerIndex]" add-onclick="addRow(\'ssc_shower_person\', shower.id, \'add_ssc_shower_person_button\' + showerIndex)" add-enabled="tableProperties.ssc_shower_person.canCreate" add-label="SSC_SHOWER_ADD_PERSON"></ssc-add-button></div></div></div></div><div class="row margcreatetop" ng-if="shower.has_shower_timer !== 1"><div class="col-sm-12"><div class="row row-eq-height ilabel hidden-xs hidden-sm"><div class="col-md-3"><span data-ng-bind="\'SSC_SHOWER_SHOWER_PERSON_HOUSEHOLD\' | translate"></span></div><div class="col-md-3"><span data-ng-bind="\'SSC_SHOWER_COUNT_PER_WEEK\' | translate"></span></div><div class="col-md-3"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_SHOWER\' | translate"></span></div><div class="col-md-3"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_WEEK\' | translate"></span></div></div><div ng-repeat="(personIndex, person) in shower.ssc_shower_person" class="tablebordercenter"><div class="row"><div class="col-md-3 ilabel"><span data-ng-bind="(\'SSC_SHOWER_SHOWER_PERSON\' | translate) + \' \' + (personIndex + 1)"></span></div><div class="col-sm-12 visible-xs visible-sm ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_COUNT_PER_WEEK\' | translate"></span></div><div class="col-md-3" errorlabel="ssc_shower.{{showerIndex}}.ssc_shower_person.{{personIndex}}.shower_count_per_week" dataobj="required"><input class="createinputter" ng-model="person.shower_count_per_week" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshowerperson\', \'shower_count_per_week\', person.shower_count_per_week, person.id)"></div><div class="col-sm-12 visible-xs visible-sm ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_SHOWER\' | translate"></span></div><div class="col-md-3" errorlabel="ssc_shower.{{showerIndex}}.ssc_shower_person.{{personIndex}}.shower_duration_per_shower" dataobj="required"><input class="createinputter" ng-model="person.shower_duration_per_shower" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshowerperson\', \'shower_duration_per_shower\', person.shower_duration_per_shower, person.id)"></div><div class="col-sm-12 visible-xs visible-sm ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_DURATION_PER_WEEK\' | translate"></span></div><div class="col-md-3 ilabel"><span ng-if="person.shower_duration_per_week" data-ng-bind="person.shower_duration_per_week"></span> <span ng-if="!person.shower_duration_per_week">0</span><ssc-delete-button delete-enabled="tableProperties.ssc_shower_person.canDelete" delete-onclick="delete(\'sscshowerperson\', personIndex, person.id, showerIndex)" delete-class="sscDeleteAccordion"></ssc-delete-button></div></div></div><div class="row tablebordercenter"><div class="col-md-9 ilabel nomargin"><span data-ng-bind="\'SSC_SHOWER_TOTAL_WEEKLY_SHOWER_MINUTES\' | translate"></span></div><div class="col-md-3 ilabel nomargin"><span data-ng-bind="shower.shower_total_duration_week | decimal2comma"></span></div></div><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_shower_person_button\' + showerIndex]" add-onclick="addRow(\'ssc_shower_person\', shower.id, \'add_ssc_shower_person_button\' + showerIndex)" add-enabled="tableProperties.ssc_shower_person.canCreate" add-label="SSC_SHOWER_ADD_PERSON"></ssc-add-button></div></div></div></div></div><div ng-show="shower.ssc_shower_count_type_id === 2 || shower.ssc_shower_count_type_id === \'2\'"><div class="flabel"><span data-ng-bind="\'SSC_SHOWER_AFTER_TOTAL_USE\' | translate"></span></div><div class="row margcreatetop"><div errorlabel="ssc_shower.{{showerIndex}}.showers_per_week" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_SHOWER_COUNT_PER_WEEK_TOTAL\' | translate"></span> <span data-ng-if="properties.ssc_shower[showerIndex].showers_per_week.required">*</span><help-pop-over help="TIP_SHOWER_COUNT_PER_WEEK_TOTAL"></help-pop-over></div><div class="col-sm-6" errorlabel="ssc_shower.{{showerIndex}}.showers_per_week" dataobj="required"><input class="createinputter" ng-model="shower.showers_per_week" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshower\', \'showers_per_week\', shower.showers_per_week, shower.id)"></div><div class="col-sm-1" errorlabel="ssc_shower.{{showerIndex}}.showers_per_week" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_shower.{{showerIndex}}.duration_per_shower" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_SHOWER_TIME_PER_SHOWER_TOTAL\' | translate"></span> <span data-ng-if="properties.ssc_shower[showerIndex].duration_per_shower.required">*</span><help-pop-over help="TIP_SHOWER_TIME_PER_SHOWER_TOTAL"></help-pop-over></div><div class="col-sm-6" errorlabel="ssc_shower.{{showerIndex}}.duration_per_shower" dataobj="required"><input class="createinputter" ng-model="shower.duration_per_shower" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshower\', \'duration_per_shower\', shower.duration_per_shower, shower.id)"></div><div class="col-sm-1" errorlabel="ssc_shower.{{showerIndex}}.duration_per_shower" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatetop"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_SHOWER_TOTAL_WEEKLY_SHOWER_MINUTES\' | translate"></span></div><div class="col-sm-8 nlabel"><span data-ng-bind="shower.shower_total_duration_week | decimal2comma"></span> Min</div></div><div class="row"><div errorlabel="ssc_shower.{{showerIndex}}.duration_per_shower_after" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_SHOWER_TIME_PER_SHOWER_TOTAL_AFTER\' | translate"></span> <span data-ng-if="properties.ssc_shower[showerIndex].duration_per_shower_after.required">*</span><help-pop-over help="TIP_SHOWER_TIME_PER_SHOWER_TOTAL"></help-pop-over></div><div class="col-sm-6" errorlabel="ssc_shower.{{showerIndex}}.duration_per_shower_after" dataobj="required"><input class="createinputter" ng-model="shower.duration_per_shower_after" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscshower\', \'duration_per_shower_after\', shower.duration_per_shower_after, shower.id)"></div><div class="col-sm-1" errorlabel="ssc_shower.{{showerIndex}}.duration_per_shower_after" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row margcreatetop" ng-show="shower.has_shower_timer === 1"><div class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_SHOWER_TOTAL_WEEKLY_SHOWER_MINUTES_AFTER\' | translate"></span></div><div class="col-sm-8 nlabel"><span data-ng-bind="shower.shower_total_duration_week_after | decimal2comma"></span> Min</div></div></div><div class="flabel"><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_CONSUMPTION_WATER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_water_consumption | decimal2comma: 3"></span> m\xB3</div></div><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_CONSUMPTION_ENERGY_FOR_WARMWATER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_hw_energy_consumption | decimal2comma"></span> kWh/a</div></div></div><div class="flabel"><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_WATER_SHOWERHEAD_AFTER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_water_showerhead_after | decimal2comma: 3"></span> m\xB3</div></div><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_ENERGY_FOR_WARMWATER_SHOWERHEAD_AFTER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_hw_energy_showerhead_after | decimal2comma"></span> kWh/a</div></div><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_SAVED_WATER_SHOWERHEAD\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_water_savings_showerhead | decimal2comma: 3"></span> m\xB3</div></div><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_SAVED_ENERGY_FOR_WARMWATER_SHOWERHEAD\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_hw_energy_savings_showerhead | decimal2comma"></span> kWh/a</div></div></div><div class="flabel" ng-show="shower.has_shower_timer === 1"><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_WATER_TIMER_AFTER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_water_timer_after | decimal2comma: 3"></span> m\xB3</div></div><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_ENERGY_FOR_WARMWATER_TIMER_AFTER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_hw_energy_timer_after | decimal2comma"></span> kWh/a</div></div><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_SAVED_WATER_TIMER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_water_savings_timer | decimal2comma: 3"></span> m\xB3</div></div><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_SAVED_ENERGY_FOR_WARMWATER_TIMER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_hw_energy_savings_timer | decimal2comma"></span> kWh/a</div></div></div><div class="flabel"><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_SAVED_WATER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_water_savings | decimal2comma: 3"></span> m\xB3</div></div><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_SHOWER_YEARLY_SAVED_ENERGY_FOR_WARMWATER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.yearly_hw_energy_savings | decimal2comma"></span> kWh/a</div></div><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_AMORTISATION_TIME\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="shower.payback_time | decimal2comma: 3"></span> Jahre</div></div></div></div></div></div></div><div class="row"><div class="col-sm-5"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_shower_button\']" add-onclick="addRow(\'ssc_shower\', saveData.ssc_id, \'add_ssc_shower_button\')" add-enabled="tableProperties.ssc_shower.canCreate" add-label="SSC_SHOWER_ADD_HELP"></ssc-add-button></div></div><div ng-if="content.ssc_bathtub.length > 0"><div ng-repeat="(bathtubIndex,bathtub) in content.ssc_bathtub track by bathtub.id"><div id="accordion-bathtub{{bathtubIndex}}" class="accordeon"><div class="field margin-bottom-2"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion-bathtub{{bathtubIndex}}" href="#collapse-bathtub{{bathtubIndex + 1}}" fastaddclass="accordionsBathtub[$index][0] ? \'in\' : \'\'"><span data-ng-bind="(\'SSC_BATHTUB_DIRECTHELP\' | translate) + \' \' + (bathtubIndex + 1)" ng-class="{\'error\': errors.bathtub[bathtubIndex].hasError, \'warning\': !errors.bathtub[bathtubIndex].hasError && errors.bathtub[bathtubIndex].hasWarning}"></span><ssc-delete-button delete-enabled="tableProperties.ssc_bathtub.canDelete" delete-onclick="delete(\'sscbathtub\', bathtubIndex, bathtub.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div id="collapse-bathtub{{bathtubIndex + 1}}" class="collapse" fastaddclass="accordionsBathtub[$index][0] ? \'in\' : \'\'"><ssc-errorbox data-messages="errors.bathtub[bathtubIndex].messages"></ssc-errorbox><div class="margcreatetop"></div><div class="row margcreatetop"><div errorlabel="ssc_bathtub.{{bathtubIndex}}.fill_level" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_BATHTUB_FILL_LEVEL\' | translate"></span> <span data-ng-if="properties.ssc_bathtub[bathtubIndex].fill_level.required">*</span></div><div class="col-xs-11 col-sm-7" errorlabel="ssc_bathtub.{{bathtubIndex}}.fill_level" dataobj="required"><select class="createdropper leftdropper" ng-model="bathtub.fill_level" ng-model-options="{updateOn: \'blur\'}" ng-options="item.id as item.name for item in content.fill_levels" ng-change="save(\'sscbathtub\', \'fill_level\', bathtub.fill_level, bathtub.id)"><option value=""></option></select></div><div errorlabel="ssc_bathtub.{{bathtubIndex}}.fill_level" dataobj="required" class="col-xs-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_bathtub.{{bathtubIndex}}.usages_before" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_BATHTUB_USAGES_BEFORE\' | translate"></span> <span data-ng-if="properties.ssc_bathtub[bathtubIndex].usages_before.required">*</span></div><div class="col-xs-8 col-sm-4 col-lg-5" errorlabel="ssc_bathtub.{{bathtubIndex}}.usages_before" dataobj="required"><input class="createinputter" ng-model="bathtub.usages_before" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscbathtub\', \'usages_before\', bathtub.usages_before, bathtub.id)" decimal-separator-german="" precision="0"></div><div class="col-xs-3 col-lg-2 ilabel"><span data-ng-bind="\'SSC_BATHTUB_USAGES_YEAR\' | translate"></span></div><div class="col-xs-1" errorlabel="ssc_bathtub.{{bathtubIndex}}.usages_before" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_bathtub.{{bathtubIndex}}.usages_after" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_BATHTUB_USAGES_AFTER\' | translate"></span> <span data-ng-if="properties.ssc_bathtub[bathtubIndex].usages_after.required">*</span></div><div class="col-xs-8 col-sm-4 col-lg-5" errorlabel="ssc_bathtub.{{bathtubIndex}}.usages_after" dataobj="required"><input class="createinputter" ng-model="bathtub.usages_after" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscbathtub\', \'usages_after\', bathtub.usages_after, bathtub.id)" decimal-separator-german="" precision="0"></div><div class="col-xs-3 col-lg-2 ilabel"><span data-ng-bind="\'SSC_BATHTUB_USAGES_YEAR\' | translate"></span></div><div class="col-xs-1" errorlabel="ssc_bathtub.{{bathtubIndex}}.usages_after" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="flabel"><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_BATHTUB_YEARLY_SAVED_WATER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="bathtub.water_savings | decimal2comma: 3"></span> m\xB3</div></div><div class="row"><div class="col-lg-6 col-sm-8"><span data-ng-bind="\'SSC_BATHTUB_YEARLY_SAVED_ENERGY_FOR_WARMWATER\' | translate"></span></div><div class="col-lg-6 col-sm-4"><span data-ng-bind="bathtub.energy_savings | decimal2comma"></span> kWh/a</div></div></div></div></div></div></div></div><div ng-if="false"><div class="row"><div class="col-sm-5"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_bathtub_button\']" add-onclick="addRow(\'ssc_bathtub\', saveData.ssc_id, \'add_ssc_bathtub_button\')" add-enabled="tableProperties.ssc_bathtub.canCreate" add-label="SSC_BATHTUB_ADD_HELP"></ssc-add-button></div></div></div><div id="accordion-advices" class="accordeon"><div class="field margin-bottom-2"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion-advices" href="#collapse-advices"><span data-ng-bind="(\'SSC_SHOWER_ADVICES\' | translate)"></span></div><div id="collapse-advices" class="collapse"><ssc-advice advices="content.ssc_advice" type="advice" tile-slug="tileSlug" options="content.shower_advices" free-text-hide-title="true" table-properties="tableProperties.ssc_shower"></ssc-advice></div></div></div><div class="col-sm-12 field-noinsides" ng-if="content.ssc_shower && content.ssc_shower.length > 0 || content.ssc_bathtub && content.ssc_bathtub.length > 0"><div class="col-lg-6 col-sm-8 ilabel"><i class="fa fa-calculator marg-right-small" aria-hidden="true"></i>{{\'SSC_SHOWER-TAP_SAVED_WATER\' | translate}}</div><div class="col-lg-6 col-sm-4 nlabel">{{content.ssc_summary.shower_savings | decimal2comma: 3}} m\xB3</div></div><div class="col-sm-12 field-noinsides" ng-if="content.ssc_shower && content.ssc_shower.length > 0 || content.ssc_bathtub && content.ssc_bathtub.length > 0"><div class="col-lg-6 col-sm-8 ilabel"><i class="fa fa-calculator marg-right-small" aria-hidden="true"></i>{{\'SSC_SHOWER-TAP_SAVED_ENERGY_FOR_WARMWATER\' | translate}}</div><div class="col-lg-6 col-sm-4 nlabel">{{content.ssc_summary.shower_savings_hw | decimal2comma}} kWh/a</div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/sscoverview/sscoverview.html','<div class="container"><div class="row"><div class="col-md-8"><tile-large></tile-large><div permission="" permission-only=\'["SSH","TRAINER","LOKO","EFB","ADMIN"]\'><comment-create></comment-create><comment-overview></comment-overview></div></div><div class="col-md-4"><plausi-large></plausi-large><legend></legend></div></div></div>');
$templateCache.put('templates/static/ssc/standby/standby.html','<div data-ng-controller="standbyController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'SSC_TILE_STANDBY_SH\' | translate) +\' - \'+ (\'SSC_TILE_STANDBY\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordion{{$index}}" class="accordeon" ng-repeat="(standbyIndex,standby) in content.ssc_standby track by standby.id" on-finish-render="initjquery(); broadcastErrorUpdate()"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" fastaddclass="accordions[$index][0] ? \'\' : \'collapsed\'" data-parent="#accordion{{$index}}" href="#collapse{{$index}}"><span data-ng-bind="\'SSC_STANDBY_DIRECTHELP_STANDBY\' | translate" ng-class="{\'error\': errors.standby[standbyIndex].hasError, \'warning\': !errors.standby[standbyIndex].hasError && errors.standby[standbyIndex].hasWarning}"></span><ssc-delete-button delete-enabled="tableProperties.ssc_standby.canDelete" delete-onclick="delete(\'sscstandby\', standbyIndex, standby.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div id="collapse{{$index}}" class="collapse" fastaddclass="accordions[$index][0] ? \'in\' : \'\'"><ssc-errorbox data-messages="errors.standby[standbyIndex].messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_standby.{{$index}}.directhelp_id" dataobj="required" class="col-sm-2 ilabel"><span data-ng-bind="\'SSC_STANDBY_DIRECTHELP\' | translate"></span> <span data-ng-if="properties.ssc_standby[$index].directhelp_id.required">*</span></div><div class="col-sm-3" errorlabel="ssc_standby.{{$index}}.directhelp_id" dataobj="required"><select class="createdropper leftdropper" ng-model="standby.directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscstandby\', \'directhelp_id\', standby.directhelp_id, standby.id)"><option value=""></option><option ng-repeat="item in content.standby_directhelp" ng-value="item.id" ng-disabled="item.status===0" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc_standby.{{$index}}.directhelp_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div><div errorlabel="ssc_standby.{{$index}}.daily_standby_time" dataobj="required" class="col-sm-2 ilabel"><span data-ng-bind="\'SSC_STANDBY_DAILY_STANDBY_TIME\' | translate"></span> <span data-ng-if="properties.ssc_standby[$index].daily_standby_time.required">*</span><help-pop-over help="TIP_STANDBY_DAILY_STANDBY_TIME"></help-pop-over></div><div class="col-sm-2" errorlabel="ssc_standby.{{$index}}.daily_standby_time" dataobj="required"><input class="createinputter" ng-model="standby.daily_standby_time" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscstandby\', \'daily_standby_time\', standby.daily_standby_time, standby.id)" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_LIGHTING_HOURS_PER_DAY\' | translate"></span></div><div errorlabel="ssc_standby.{{$index}}.daily_standby_time" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_standby.{{$index}}.standby_wattage" dataobj="required" class="col-sm-2 ilabel"><span data-ng-bind="\'SSC_STANDBY_STANDBY_WATTAGE\' | translate"></span> <span data-ng-if="properties.ssc_standby[$index].standby_wattage.required">*</span><help-pop-over help="TIP_STANDBY_WATTAGE"></help-pop-over></div><div class="col-sm-2" errorlabel="ssc_standby.{{$index}}.standby_wattage" dataobj="required"><input class="createinputter" ng-model="standby.standby_wattage" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscstandby\', \'standby_wattage\', standby.standby_wattage, standby.id)" decimal-separator-german="" precision="1"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_LIGHTING_WATT\' | translate"></span></div><div errorlabel="ssc_standby.{{$index}}.standby_wattage" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_standby.{{$index}}.ssc_room_type_id" dataobj="required" class="col-sm-2 ilabel"><span data-ng-bind="\'SSC_STANDBY_ROOM\' | translate"></span> <span data-ng-if="properties.ssc_standby[$index].ssc_room_type_id.required">*</span></div><div class="col-sm-3" errorlabel="ssc_standby.{{$index}}.ssc_room_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="standby.ssc_room_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscstandby\', \'ssc_room_type_id\', standby.ssc_room_type_id, standby.id)"><option value=""></option><option ng-repeat="item in content.ssc_room_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc_standby.{{standbyIndex}}.ssc_room_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div><div ng-hide="properties.ssc_standby[standbyIndex].off_per_day.hidden"><div errorlabel="ssc_standby.{{standbyIndex}}.off_per_day" dataobj="required" class="col-sm-2 ilabel"><span data-ng-bind="\'SSC_STANDBY_OFF_PER_DAY\' | translate"></span> <span data-ng-if="properties.ssc_standby[$index].off_per_day.required">*</span></div><div class="col-sm-2" errorlabel="ssc_standby.{{standbyIndex}}.off_per_day" dataobj="required"><input class="createinputter" ng-model="standby.off_per_day" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscstandby\', \'off_per_day\', standby.off_per_day, standby.id)" decimal-separator-german="" precision="2"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_LIGHTING_HOURS_PER_DAY\' | translate"></span></div><div errorlabel="ssc_standby.{{standbyIndex}}.off_per_day" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><div ng-repeat="dev in standby.ssc_standby_device track by dev.id"><hr class="small-hr"><div class="row"><div errorlabel="ssc_standby.{{$parent.$index}}.ssc_standby_device.{{$index}}.device_type_id" dataobj="required" class="col-sm-2 ilabel"><span data-ng-bind="(\'SSC_STANDBY_DEVICE\' | translate) + \' \' + ($index + 1)"></span> <span data-ng-if="properties.ssc_standby[$parent.$index].ssc_standby_device[$index].device_type_id.required">*</span></div><div class="col-sm-3" errorlabel="ssc_standby.{{$parent.$index}}.ssc_standby_device.{{$index}}.device_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="dev.device_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscstandbydevice\', \'device_type_id\', content.ssc_standby[standbyIndex].ssc_standby_device[$index].device_type_id, dev.id)"><option value=""></option><option ng-repeat="item in content.ssc_standby_device_type" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div class="col-sm-1"><div class="row no-pad"><div errorlabel="ssc_standby.{{$parent.$index}}.ssc_standby_device.{{$index}}.device_type_id" dataobj="required" class="col-xs-6"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div><div class="col-xs-6"><ssc-delete-button delete-enabled="tableProperties.ssc_standby_device.canDelete" delete-onclick="delete(\'sscstandbydevice\', $index, dev.id, standbyIndex)" delete-class="sscDeleteVertAlign"></ssc-delete-button></div></div></div></div><div class="row"><div errorlabel="ssc_standby.{{standbyIndex}}.ssc_standby_device.{{$index}}.comment" dataobj="required" class="col-sm-2 ilabel"><span data-ng-bind="\'SSC_STANDBY_DEVICE_COMMENT\' | translate"></span> <span data-ng-if="properties.ssc_standby[standbyIndex].ssc_standby_device[$index].comment.required">*</span></div><div class="col-sm-3" errorlabel="ssc_standby.{{standbyIndex}}.ssc_standby_device.{{$index}}.comment" dataobj="required"><textarea class="createinputter" ng-model="content.ssc_standby[standbyIndex].ssc_standby_device[$index].comment" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'sscstandbydevice\', \'comment\', content.ssc_standby[standbyIndex].ssc_standby_device[$index].comment, dev.id)"></textarea></div><div errorlabel="ssc_standby.{{standbyIndex}}.ssc_standby_device.{{$index}}.comment" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div></div><hr class="small-hr"><div class="row"><div class="col-sm-4"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_standby_device_button\' + standbyIndex]" add-onclick="addRow(\'ssc_standby_device\', standby.id, \'add_ssc_standby_device_button\' + standbyIndex)" add-enabled="tableProperties.ssc_standby_device.canCreate" add-label="SSC_STANDBY_ADD_DEVICE"></ssc-add-button></div></div><div class="row"><div class="flabel clearfix"><div class="col-sm-4"><span data-ng-bind="\'SSC_LIGHTING_AMORTISATION_TIME\' | translate"></span></div><div class="col-sm-8"><span ng-bind="standby.payback_time| decimal2comma: 1"></span> Jahre</div></div></div><div class="row"><div class="flabel clearfix"><div class="col-sm-4"><span data-ng-bind="\'SSC_LIGHTING_SAVING_POTENTIAL\' | translate"></span></div><div class="col-sm-8"><span ng-bind="standby.savings| decimal2comma"></span> kWh/a</div></div></div></div></div></div><div class="col-sm-12 field-noinsides" ng-if="content.ssc_standby && content.ssc_standby.length > 0"><div class="col-sm-4 ilabel"><i class="fa fa-calculator marg-right-small" aria-hidden="true"></i>{{\'SSC_STANDBY_TOTAL_SAVINGS\' | translate}}</div><div class="col-sm-8 nlabel">{{content.ssc_summary.standby_savings | decimal2comma}} kWh/a</div></div><div class="row"><div class="col-sm-5"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_standby_button\']" add-onclick="addRow(\'ssc_standby\', saveData.ssc_id, \'add_ssc_standby_button\')" add-enabled="tableProperties.ssc_standby.canCreate" add-label="SSC_STANDBY_ADD_HELP"></ssc-add-button></div><div class="col-sm-offset-1 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/tap/tap.html','<div data-ng-controller="tapController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'SSC_TILE_TAP_SH\' | translate) +\' - \'+ (\'SSC_TILE_TAP\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div ng-repeat="(tapIndex,tap) in content.ssc_tap track by tap.id" on-finish-render="initjquery(); broadcastErrorUpdate()"><div id="accordion{{tapIndex}}" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion{{tapIndex}}" fastaddclass="accordions[$index][0] ? \'\' : \'collapsed\'" href="#collapse{{tapIndex}}"><span data-ng-bind="(\'SSC_TAP_DIRECTHELP\' | translate) + \' \' + (tapIndex + 1)" ng-class="{\'error\': errors.tap[tapIndex].hasError, \'warning\': !errors.tap[tapIndex].hasError && errors.tap[tapIndex].hasWarning}"></span><ssc-delete-button delete-enabled="tableProperties.ssc_tap.canDelete" delete-onclick="delete(\'ssctap\', tapIndex, tap.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div id="collapse{{tapIndex}}" class="collapse" fastaddclass="accordions[$index][0] ? \'in\' : \'\'"><ssc-errorbox data-messages="errors.tap[tapIndex].messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_tap.{{tapIndex}}.ssc_room_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_STANDBY_ROOM\' | translate"></span> <span data-ng-if="properties.ssc_tap[tapIndex].ssc_room_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc_tap.{{tapIndex}}.ssc_room_type_id" dataobj="required"><select class="createdropper leftdropper" ng-model="tap.ssc_room_type_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssctap\',\'ssc_room_type_id\', tap.ssc_room_type_id, tap.id)"><option value=""></option><option ng-repeat="item in content.ssc_room_type" ng-value="item.id" data-ng-bind="item.name" ng-if="item.id == 4 || item.id == 3 || item.id == 5"></option></select></div><div class="col-sm-1" errorlabel="ssc_tap.{{tapIndex}}.ssc_room_type_id" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_tap.{{tapIndex}}.flow_rate" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_TAP_FLOW_RATE\' | translate"></span> <span data-ng-if="properties.ssc_tap[tapIndex].flow_rate.required">*</span></div><div class="col-sm-6" errorlabel="ssc_tap.{{tapIndex}}.flow_rate" dataobj="required"><input class="createinputter" ng-model="tap.flow_rate" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssctap\',\'flow_rate\', tap.flow_rate, tap.id)" decimal-separator-german="" precision="1"></div><div class="col-sm-1 ilabel"><span data-ng-bind="\'SSC_TAP_LITRE_PER_MIN\' | translate"></span></div><div errorlabel="ssc_tap.{{tapIndex}}.flow_rate" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_tap.{{tapIndex}}.directhelp_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_TAP_FLOW_AERATOR\' | translate"></span> <span data-ng-if="properties.ssc_tap[tapIndex].directhelp_id.required">*</span><help-pop-over help="TIP_TAP_DIRECTHELP"></help-pop-over></div><div class="col-sm-7" errorlabel="ssc_tap.{{tapIndex}}.directhelp_id" dataobj="required"><select class="createdropper leftdroppegur" ng-model="tap.directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssctap\',\'directhelp_id\', tap.directhelp_id, tap.id)"><option value=""></option><option ng-repeat="item in content.tap_directhelp" ng-value="item.id" data-ng-bind="item.description" ng-disabled="item.status===0"></option></select></div><div class="col-sm-1" errorlabel="ssc_tap.{{tapIndex}}.directhelp_id" dataobj="required"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="flabel clearfix"><div class="col-sm-4"><span data-ng-bind="\'SSC_TAP_SAVED_WATER\' | translate"></span><help-pop-over help="TIP_TAP_SAVED_WATER"></help-pop-over></div><div class="col-sm-7"><span data-ng-bind="content.ssc_tap[$index].water_savings | decimal2comma: 3"></span> m\xB3</div></div><div class="flabel clearfix"><div class="col-sm-4"><span data-ng-bind="\'SSC_TAP_SAVED_ENERGY_FOR_WARMWATER\' | translate"></span></div><div class="col-sm-7"><span data-ng-bind="tap.hw_energy_savings | decimal2comma"></span> kWh/a</div></div><div class="flabel clearfix"><div class="col-sm-4"><span data-ng-bind="\'SSC_LIGHTING_AMORTISATION_TIME\' | translate"></span></div><div class="col-sm-7"><span data-ng-bind="tap.payback_time | decimal2comma: 1"></span> Jahre</div></div></div></div></div></div><div class="col-sm-12 field-noinsides" ng-if="content.ssc_tap && content.ssc_tap.length > 0"><div class="col-sm-4 ilabel"><i class="fa fa-calculator marg-right-small" aria-hidden="true"></i>{{\'SSC_SHOWER-TAP_SAVED_WATER\' | translate}}</div><div class="col-sm-8 nlabel">{{content.ssc_summary.tap_savings | decimal2comma: 3}} m\xB3/a</div></div><div class="col-sm-12 field-noinsides" ng-if="content.ssc_tap && content.ssc_tap.length > 0"><div class="col-sm-4 ilabel"><i class="fa fa-calculator marg-right-small" aria-hidden="true"></i>{{\'SSC_SHOWER-TAP_SAVED_ENERGY_FOR_WARMWATER\' | translate}}</div><div class="col-sm-8 nlabel">{{content.ssc_summary.tap_savings_hw | decimal2comma}} kWh/a</div></div><div class="row"><div class="col-sm-5"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_tap_button\']" add-onclick="addRow(\'ssc_tap\', saveData.ssc_id, \'add_ssc_tap_button\')" add-enabled="tableProperties.ssc_tap.canCreate" add-label="SSC_TAP_ADD_ROOM"></ssc-add-button></div><div class="col-sm-offset-1 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/telephone/general.html','<div ng-controller="telephoneController"><div class="row"><div class="col-sm-9"><h4 ng-bind="(\'SSC_TILE_TELEPHONE_SH\' | translate) + \' - \' + (\'SSC_TILE_TELEPHONE\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordion-1" class="accordeon"><div class="field"><div class="panel-hiding hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion-1" href="#collapse-1"><span ng-bind="\'SSC_TELEPHONE_TITLE\' | translate"></span></div><div id="collapse-1" class="collapse in"><ssc-errorbox data-messages="errors"></ssc-errorbox><div class="margcreatetop"></div><ssc-input type="select" field="ssc_telephone_consultation.customer_reason" page="formPageScope" options="content.ssc_customer_reason" optionfield="description" label="SSC_TELEPHONE_CUSTOMER_REASON"></ssc-input><div errorlabel="ssc_telephone_consultation.customer_reason_other"><ssc-input type="input" field="ssc_telephone_consultation.customer_reason_other" page="formPageScope" is-text="true" label="SSC_TELEPHONE_CUSTOMER_REASON_OTHER"></ssc-input></div><ssc-input type="select" field="ssc_telephone_consultation.customer_interest" page="formPageScope" options="content.ssc_customer_interest" optionfield="description" label="SSC_TELEPHONE_CUSTOMER_INTEREST"></ssc-input><div errorlabel="ssc_telephone_consultation.customer_interest_other"><ssc-input type="input" field="ssc_telephone_consultation.customer_interest_other" page="formPageScope" is-text="true" label="SSC_TELEPHONE_CUSTOMER_INTEREST_OTHER"></ssc-input></div><ssc-input type="select" field="ssc_telephone_consultation.warmwater_preparation_type" page="formPageScope" options="content.ssc_warmwater_preparation_simple" optionfield="description" label="SSC_TELEPHONE_WARMWATER_PREPARATION"></ssc-input><ssc-input type="select" field="ssc_telephone_consultation.has_old_fridge" page="formPageScope" options="content.ssc_yes_no_answer_type" optionfield="name" label="SSC_TELEPHONE_OLD_FRIDGE"></ssc-input><ssc-input type="select" field="ssc_telephone_consultation.has_frequently_used_devices" page="formPageScope" options="content.ssc_yes_no_answer_type" optionfield="name" label="SSC_TELEPHONE_HAS_FREQUENTLY_USED_DEVICES"></ssc-input><div errorlabel="ssc_telephone_consultation.frequently_used_devices"><ssc-input type="textarea" field="ssc_telephone_consultation.frequently_used_devices" page="formPageScope" label="SSC_TELEPHONE_FREQUENTLY_USED_DEVICES"></ssc-input></div><ssc-input type="select" field="ssc_telephone_consultation.has_continuous_operation_devices" page="formPageScope" options="content.ssc_yes_no_answer_type" optionfield="name" label="SSC_TELEPHONE_HAS_CONTINUOUS_OPERATION_DEVICES"></ssc-input><div errorlabel="ssc_telephone_consultation.continuous_operation_devices"><ssc-input type="textarea" field="ssc_telephone_consultation.continuous_operation_devices" page="formPageScope" label="SSC_TELEPHONE_CONTINUOUS_OPERATION_DEVICES"></ssc-input></div><ssc-input type="select" field="ssc_telephone_consultation.has_led_lights" page="formPageScope" options="content.ssc_yes_no_answer_type" optionfield="name" label="SSC_TELEPHONE_LED_LIGHTS"></ssc-input><ssc-input type="select" field="ssc_telephone_consultation.has_switchable_power_strips" page="formPageScope" options="content.ssc_yes_no_answer_type" optionfield="name" label="SSC_TELEPHONE_SWITCHABLE_POWER_STRIPS"></ssc-input><div class="margcreatetop"></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/telephone/info.html','<div ng-controller="telephoneInfoController"><div class="row"><div class="col-sm-9"><h4 ng-bind="(\'SSC_TILE_TELEPHONE_INFO_SH\' | translate) + \' - \' + (\'SSC_TILE_TELEPHONE_INFO\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordion-1" class="accordeon"><div class="field"><div class="panel-hiding hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion-1" href="#collapse-1"><span ng-bind="\'SSC_TELEPHONE_INFO_TITLE\' | translate"></span></div><div id="collapse-1" class="collapse in"><ssc-errorbox data-messages="errors"></ssc-errorbox><div class="margcreatetop"></div><ssc-input type="select" field="ssc_telephone_consultation_info.ventilation_type" page="formPageScope" options="content.ssc_ventilation_type" optionfield="description" label="SSC_TELEPHONE_INFO_VENTILATION_TYPE"></ssc-input><div errorlabel="ssc_telephone_consultation_info.ventilation_count_daily"><ssc-input type="input" field="ssc_telephone_consultation_info.ventilation_count_daily" is-text="false" precision="0" page="formPageScope" unit="{{\'SSC_TELEPHONE_INFO_VENTILATION_COUNT_DAILY_UNIT\' | translate}}" label="SSC_TELEPHONE_INFO_VENTILATION_COUNT_DAILY"></ssc-input></div><ssc-input type="toggle" field="ssc_telephone_consultation_info.mould_problems" page="formPageScope" label="SSC_TELEPHONE_INFO_MOULD_PROBLEMS"></ssc-input><ssc-input type="input" field="ssc_telephone_consultation_info.consultation_duration" is-text="false" precision="0" page="formPageScope" unit="{{\'SSC_TELEPHONE_INFO_CONSULTATION_DURATION_UNIT\' | translate}}" label="SSC_TELEPHONE_INFO_CONSULTATION_DURATION"></ssc-input><ssc-input type="toggle" field="ssc_telephone_consultation_info.fridge_thermometer_given" page="formPageScope" label="SSC_TELEPHONE_INFO_FRIDGE_THERMO_GIVEN"></ssc-input><ssc-input type="toggle" field="ssc_telephone_consultation_info.power_strip_given" page="formPageScope" label="SSC_TELEPHONE_INFO_POWER_STRIP_GIVEN"></ssc-input><div errorlabel="ssc_telephone_consultation_info.directhelp_electric_id"><ssc-input type="select" field="ssc_telephone_consultation_info.directhelp_electric_id" page="formPageScope" options="content.directhelp" optionfield="description" label="SSC_TELEPHONE_INFO_DIRECTHELP_ELECTRIC"></ssc-input></div><ssc-input type="toggle" field="ssc_telephone_consultation_info.thermometer_given" page="formPageScope" label="SSC_TELEPHONE_INFO_THERMOMETER_GIVEN"></ssc-input><ssc-input type="toggle" field="ssc_telephone_consultation_info.interest_info_material" page="formPageScope" label="SSC_TELEPHONE_INFO_INTEREST_INFO_MATERIAL"></ssc-input><ssc-input type="toggle" field="ssc_telephone_consultation_info.interest_visit_online" page="formPageScope" label="SSC_TELEPHONE_INFO_INTEREST_VISIT"></ssc-input><ssc-input type="toggle" field="ssc_telephone_consultation_info.interest_heat_check" page="formPageScope" label="SSC_TELEPHONE_INFO_INTEREST_HEAT_CHECK"></ssc-input><ssc-input type="toggle" field="ssc_telephone_consultation_info.interest_climate_protection" page="formPageScope" label="SSC_TELEPHONE_INFO_INTEREST_CLIMATE_PROTECTION"></ssc-input><ssc-input type="textarea" field="ssc_telephone_consultation_info.comment" page="formPageScope" label="SSC_TELEPHONE_INFO_COMMENT"></ssc-input><div class="margcreatetop"></div></div></div></div><div class="row"><div class="col-sm-offset-9 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div></div></div>');
$templateCache.put('templates/static/ssc/tips/tips.html','<div data-ng-controller="tipsController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'SSC_TILE_TIPS_SH\' | translate) +\' - \'+ (\'SSC_TILE_TIPS\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordeon1" class="accordeon"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" data-parent="#accordion1" href="#collapse1"><span data-ng-bind="\'SSC_TILE_TIPS\' | translate"></span></div><div id="collapse1" class="collapse in"><ssc-errorbox messages="messages.tips.messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_tips.internal_comment" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_TIPS_INTERNAL_NOTES\' | translate"></span> <span data-ng-if="required.ssc_tips.internal_comment.required">*</span><help-pop-over help="TIP_TIPS_INTERNAL_NOTES"></help-pop-over></div><div class="col-sm-8" errorlabel="ssc_tips.internal_comment" dataobj="required"><textarea ng-model="data.ssc_tips.internal_comment" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssctips\', \'internal_comment\', data.ssc_tips.internal_comment)" ui-tinymce="" class="createinputter">\n                        </textarea></div></div><div class="row margcreatetop margcreatebot"><div class="col-xs-12"><hr></div><div errorlabel="ssc_tips.budget_report_3" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_TIPS_COMMENT_ON_REPORT_PAGE_3\' | translate"></span> <span data-ng-if="required.ssc_tips.budget_report_3.required">*</span><help-pop-over help="TIP_TIPS_COMMENT_ON_REPORT_PAGE_3"></help-pop-over></div><div class="col-sm-8" errorlabel="ssc_tips.budget_report_3" dataobj="required"><textarea ng-model="data.ssc_tips.budget_report_3" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssctips\', \'budget_report_3\', data.ssc_tips.budget_report_3)" class="createinputter" ui-tinymce="editorConfig">\n                        </textarea></div></div><div class="margcreatetop margcreatebot"><div class="row"><div class="col-xs-12"><hr></div></div><ssc-advice type="advice" tile-slug="tileSlug" advices="data.ssc_advice" table-properties="tableProperties.ssc_advice" show-top-tips="true" show-source="true"></ssc-advice></div></div></div></div><div class="row"><div class="col-sm-offset-6 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/ssc/toiletFlush/toiletFlush.html','<div data-ng-controller="toiletflushController" field-attribute-manager=""><div class="row"><div class="col-sm-9"><h4 data-ng-bind="(\'SSC_TILE_TOILETFLUSH_SH\' | translate) +\' - \'+ (\'SSC_TILE_TOILETFLUSH\' | translate)"></h4></div><div class="col-sm-3"><ssc-expand-all-btn></ssc-expand-all-btn></div></div><div id="accordion{{$index}}" class="accordeon" ng-repeat="flush in content.ssc_toilet_flush track by flush.id" on-finish-render="initjquery(); broadcastErrorUpdate()"><div class="field"><div class="panel-heading hlabel accordion-toggle" data-toggle="collapse" fastaddclass="accordions[$index][0] ? \'\' : \'collapsed\'" data-parent="#accordion{{$index}}" href="#collapse{{$index}}"><span data-ng-bind="(\'SSC_TOILETFLUSH_DIRECTHELP_FLUSH\' | translate)" ng-class="{\'error\': errors.toilet[$index].hasError, \'warning\': !errors.toilet[$index].hasError && errors.toilet[$index].hasWarning}"></span><ssc-delete-button delete-enabled="tableProperties.ssc_toilet_flush.canDelete" delete-onclick="delete(\'ssctoiletflush\', $index, flush.id)" delete-class="sscDeleteAccordion"></ssc-delete-button></div><div id="collapse{{$index}}" class="collapse" fastaddclass="accordions[$index][0] ? \'in\' : \'\'"><ssc-errorbox data-messages="errors.toilet[$index].messages"></ssc-errorbox><div class="row margcreatetop"><div errorlabel="ssc_toilet_flush.{{$index}}.directhelp_id" dataobj="required" class="col-sm-5 ilabel"><span data-ng-bind="\'SSC_STANDBY_DIRECTHELP\' | translate"></span> <span data-ng-if="properties.ssc_toilet_flush[$index].directhelp_id.required">*</span></div><div class="col-sm-6" errorlabel="ssc_toilet_flush.{{$index}}.directhelp_id" dataobj="required"><select class="createdropper leftdropper" ng-model="flush.directhelp_id" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssctoiletflush\', \'directhelp_id\', flush.directhelp_id, flush.id)"><option value=""></option><option ng-repeat="item in content.toilet_flush_directhelp" ng-value="item.id" ng-disabled="item.status===0" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc_toilet_flush.{{$index}}.directhelp_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc_toilet_flush.{{$index}}.daily_flush_count" dataobj="required" class="col-sm-5 ilabel"><span data-ng-bind="\'SSC_TOILETFLUSH_DAILY_FLUSH_COUNT\' | translate"></span> <span data-ng-if="properties.ssc_toilet_flush[$index].daily_flush_count.required">*</span><help-pop-over help="TIP_TOILETFLUSH_FLUSHS"></help-pop-over></div><div class="col-sm-4" errorlabel="ssc_toilet_flush.{{$index}}.daily_flush_count" dataobj="required"><input class="createinputter" ng-model="flush.daily_flush_count" ng-model-options="{updateOn: \'blur\'}" ng-change="save(\'ssctoiletflush\', \'daily_flush_count\', flush.daily_flush_count, flush.id)" decimal-separator-german="" precision="0"></div><div class="col-sm-2 ilabel"><span data-ng-bind="\'SSC_TOILETFLUSH_FLUSHS\' | translate"></span></div><div errorlabel="ssc_toilet_flush.{{$index}}.daily_flush_count" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="flabel clearfix"><div class="col-sm-4"><span data-ng-bind="\'SSC_LIGHTING_AMORTISATION_TIME\' | translate"></span></div><div class="col-sm-7"><span data-ng-bind="flush.payback_time| decimal2comma: 1"></span> Jahre</div></div><div class="flabel clearfix"><div class="col-sm-4"><span data-ng-bind="\'SSC_LIGHTING_SAVING_POTENTIAL\' | translate"></span><help-pop-over help="TIP_TOILETFLUSH_SAVING_POTENTIAL"></help-pop-over></div><div class="col-sm-7"><span data-ng-bind="flush.savings| decimal2comma: 3"></span> m\xB3/a</div></div></div></div></div><div class="col-sm-12 field-noinsides" ng-if="content.ssc_toilet_flush && content.ssc_toilet_flush.length > 0"><div class="col-sm-4 ilabel"><i class="fa fa-calculator marg-right-small" aria-hidden="true"></i>{{\'SSC_TOILETFLUSH_TOTAL_SAVINGS\' | translate}}</div><div class="col-sm-8 nlabel">{{content.ssc_summary.toilet_flush_savings | decimal2comma: 3}} m\xB3/a</div></div><div class="row"><div class="col-sm-5"><ssc-add-button add-is-saving="btnIsSaving[\'add_ssc_toilet_flush_button\']" add-onclick="addRow(\'ssc_toilet_flush\', saveData.ssc_id, \'add_ssc_toilet_flush_button\')" add-enabled="tableProperties.ssc_toilet_flush.canCreate" add-label="SSC_TOILETFLUSH_ADD_HELP"></ssc-add-button></div><div class="col-sm-offset-1 col-sm-3"><button ng-click="ready()" class="redbutton" type="submit"><i class="fa fa-check marg-right-small" aria-hidden="true"></i><span data-ng-bind="\'SSC_READY\' | translate"></span></button></div><div class="col-sm-3"><button ng-click="continue()" class="redbutton" type="submit"><span data-ng-bind="\'SSC_CONTINUE\' | translate"></span><i class="fa fa-arrow-right marg-left-small"></i></button></div></div></div>');
$templateCache.put('templates/static/user/employmenttyp/userEmploymenttyp.html','<div ng-show="isNotFound" style="text-align:center"><h4>Nicht gefunden</h4></div><div ng-show="!isNotFound"><div class="container" data-ng-controller="submenuController" permission="" permission-only="[\'LOKO\', \'ADMIN\']"><div class="row"><div class="col-sm-4"><a class="navbar-backlink" ui-sref="user.update.employmenttyp.create"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'USER_EMPLOYMENTTYP_CREATE\' | translate}}</button></a></div></div></div><tabmenuuseremplyomenttyp is-not-found="isNotFound"></tabmenuuseremplyomenttyp></div>');
$templateCache.put('templates/static/user/employmenttyp/userEmploymenttypCreate.html','<user-emplyomenttyp-create></user-emplyomenttyp-create>');
$templateCache.put('templates/static/user/substitute/userSubstitute.html','<div ng-show="isNotFound" style="text-align:center"><h4>Nicht gefunden</h4></div><div ng-show="!isNotFound"><div class="container" data-ng-controller="submenuController"><div class="row"><div class="col-sm-4"><a class="navbar-backlink" ui-sref="user.update.substitute.create"><button type="button" class="redbutton"><i class="fa fa-plus marg-right-small" aria-hidden="true"></i>{{\'USER_SUBSTITUTE_CREATE\' | translate}}</button></a></div></div></div><tabmenuusersubstitute is-not-found="isNotFound"></tabmenuusersubstitute></div>');
$templateCache.put('templates/static/user/substitute/userSubstituteCreate.html','<user-substitute-create></user-substitute-create>');
$templateCache.put('templates/static/ssc/household/create/create.html','<div data-ng-controller="householdcreateController"><div class="container"><div class="row"><div class="col-md-7"><div class="col-sm-12 field"><div class="row hlabel" data-ng-bind="\'SSC_HH_CREATE\' | translate"></div><div class="col-sm-12 errorfield margcreatetop margcreatebot" ng-show="showerrorbox || responseHasServerError"><div class="row hlabel">{{responseHasServerError ? (\'FORM_ERROR_SAVING_TITLE\' | translate) : (\'FORM_ERROR_TITLE\' | translate)}}</div><div class="row margcreatetop margcreatebot"><div class="col-sm-12 form-fill-text"><div ng-repeat="(key, value) in required.ssc"><div ng-if="value.error != null">{{$parent.$parent.showerrorbox = 1;value.error;}}</div><div ng-if="value.warning != null" class="warning"><span>{{$parent.$parent.showerrorbox = 1;value.warning;}}</span></div></div><div ng-if="responseHasServerError">{{\'FORM_ERROR_SAVING\' | translate}}</div></div></div></div><div class="margcreatetop"></div><div class="row" ng-show="locationlist.length > 0"><div class="col-sm-4 ilabel" errorlabel="ssc.location_id" dataobj="required"><span data-ng-bind="\'SSC_HH_LOCATION\' | translate"></span> <span data-ng-if="required.ssc.location_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc.location_id" dataobj="required"><select class="createdropper leftdropper" ng-model="data.ssc.location_id" ng-change="print(); loadUserList(data.ssc.location_id)" convert-to-number=""><option ng-repeat="item in locationlist" value="{{item.id}}" ng-attr-selected="{{locationlist.length == 1 ? \'selected\' : \'\'}}">{{item.name}}</option></select></div><div errorlabel="ssc.location_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.ssc_consultation_type_name" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_CONSULTATION_TYPE\' | translate"></span> <span data-ng-if="required.ssc.ssc_consultation_type_name.required">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_consultation_type_name" dataobj="required"><select class="createdropper" ng-model="data.ssc.ssc_consultation_type_name"><option value="" data-ng-bind="\'SSC_CHOOSE\' | translate" disabled=""></option><option ng-repeat="item in data.ssc_consultation_type" ng-value="item.name" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc.ssc_consultation_type_name" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-sm-4 ilabel" errorlabel="ssc.customernumber" dataobj="required"><span data-ng-bind="\'SSC_HH_CUSTOMERNUMBER\' | translate"></span> <span data-ng-if="required.ssc.customernumber.required">*</span></div><div class="col-sm-7"><input errorlabel="ssc_general.ssc.customernumber" dataobj="required" class="createinputter" ng-model="data.ssc.customernumber"></div><div errorlabel="ssc_general.ssc.customernumber" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.salutation" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_SALUTION\' | translate"></span> <span data-ng-if="required.ssc.salutation.required">*</span></div><div class="col-sm-7" errorlabel="ssc.salutation" dataobj="required"><select class="createdropper leftdropper" ng-model="data.ssc.salutation"><option value=""></option><option ng-repeat="option in data.salutation" value="{{option}}">{{option}}</option></select></div><div errorlabel="ssc.salutation" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.firstname" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_FIRSTNAME\' | translate"></span> <span data-ng-if="required.ssc.firstname.required">*</span></div><div class="col-sm-7"><input errorlabel="ssc.firstname" dataobj="required" class="createinputter" ng-model="data.ssc.firstname"></div><div errorlabel="ssc.firstname" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.lastname" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_LASTNAME\' | translate"></span> <span data-ng-if="required.ssc.lastname.required">*</span></div><div class="col-sm-7"><input errorlabel="ssc.lastname" dataobj="required" class="createinputter" ng-model="data.ssc.lastname"></div><div errorlabel="ssc.lastname" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.street" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_STREET\' | translate"></span> <span data-ng-if="required.ssc.street.required">*</span></div><div class="col-sm-7"><input errorlabel="ssc.street" dataobj="required" class="createinputter" ng-model="data.ssc.street"></div><div errorlabel="ssc.street" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.postalcode" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_POSTALCODE\' | translate"></span> <span data-ng-if="required.ssc.postalcode.required">*</span></div><div class="col-sm-7"><input errorlabel="ssc.postalcode" dataobj="required" class="createinputter" ng-model="data.ssc.postalcode"></div><div errorlabel="ssc.postalcode" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.city" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_CITY\' | translate"></span> <span data-ng-if="required.ssc.city.required">*</span></div><div class="col-sm-7"><input errorlabel="ssc.city" dataobj="required" class="createinputter" ng-model="data.ssc.city"></div><div errorlabel="ssc.city" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.telephone" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_TELEPHONE\' | translate"></span> <span data-ng-if="required.ssc.telephone.required">*</span></div><div class="col-sm-7"><input errorlabel="ssc.telephone" dataobj="required" class="createinputter" ng-model="data.ssc.telephone"></div><div errorlabel="ssc.telephone" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.mobilephone" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_MOBILEPHONE\' | translate"></span> <span data-ng-if="required.ssc.mobilephone.required">*</span></div><div class="col-sm-7"><input errorlabel="ssc.mobilephone" dataobj="required" class="createinputter" ng-model="data.ssc.mobilephone"></div><div errorlabel="ssc.mobilephone" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.email" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_EMAIL\' | translate"></span> <span data-ng-if="required.ssc.email.required">*</span></div><div class="col-sm-7" errorlabel="ssc.email" dataobj="required"><input class="createinputter" ng-model="data.ssc.email"></div><div errorlabel="ssc.email" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.registration_type_name" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_REGISTRATION_TYPE\' | translate"></span> <span data-ng-if="required.ssc.registration_type_name.required">*</span></div><div class="col-sm-7" errorlabel="ssc.registration_type_name" dataobj="required"><select class="createdropper" ng-model="data.ssc.registration_type_name"><option value="" data-ng-bind="\'SSC_CHOOSE\' | translate" disabled=""></option><option ng-repeat="item in data.registration_types" ng-value="item.id" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc.registration_type_name" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.ssc_akquise_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_AKQUISE_CATEGORY\' | translate"></span> <span data-ng-if="required.ssc.ssc_akquise_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_akquise_id" dataobj="required"><select class="createdropper" ng-model="data.ssc.ssc_akquise_category_id" ng-change="unsetAkquiseId()"><option ng-repeat="item in data.ssc_akquise_category" ng-value="item.id" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc.ssc_akquise_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" ng-show="data.ssc.ssc_akquise_category_id"><div errorlabel="ssc.ssc_akquise_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_AKQUISE\' | translate"></span> <span data-ng-if="required.ssc.ssc_akquise_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_akquise_id" dataobj="required"><select class="createdropper" ng-model="data.ssc.ssc_akquise_id"><option value=""></option><option ng-repeat="item in data.ssc_akquise | filter: {ssc_akquise_category_id: data.ssc.ssc_akquise_category_id}" ng-value="item.id" data-ng-bind="item.name"></option></select></div><div errorlabel="ssc.ssc_akquise_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.ssc_previous_consultation_type_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_PREVIOUS_CONSULTATION\' | translate"></span> <span data-ng-if="required.ssc.ssc_previous_consultation_type_id.required">*</span></div><div class="col-sm-7" errorlabel="ssc.ssc_previous_consultation_type_id" dataobj="required"><select class="createdropper" ng-model="data.ssc.ssc_previous_consultation_type_id"><option ng-repeat="item in data.ssc_previous_consultation_type" ng-value="item.id" data-ng-bind="item.description"></option></select></div><div errorlabel="ssc.ssc_previous_consultation_type_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.ssc_user_1_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_USER_1\' | translate"></span> <span data-ng-if="data.ssc.user_1.required">*</span></div><div class="col-sm-7"><ui-select class="ssc-ui-select" theme="selectize" ng-disabled="!data.ssc.location_id && data.ssc.location_id !== 0" ng-model="data.ssc.user_1"><ui-select-match placeholder="Bitte Suchen Sie einen Stromsparhelfer"><span class="selected-value" ng-bind="$select.selected.id + \' - \' + $select.selected.name"></span> <span class="fa fa-times clear-button" ng-click="$select.clear($event);"></span></ui-select-match><ui-select-choices repeat="res in dropUsersSSH | filter:$select.search"><span data-ng-bind-html="(res.id + \' - \' + res.name) | highlight: $select.search"></span></ui-select-choices></ui-select></div><div errorlabel="ssc.ssc_user_1_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.ssc_user_2_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_USER_2\' | translate"></span> <span data-ng-if="data.ssc.user_2.required">*</span></div><div class="col-sm-7"><ui-select theme="selectize" ng-model="data.ssc.user_2" ng-disabled="!data.ssc.location_id && data.ssc.location_id !== 0" class="ssc-ui-select"><ui-select-match placeholder="Bitte Suchen Sie einen Stromsparhelfer"><span class="selected-value" ng-bind="$select.selected.id + \' - \' + $select.selected.name"></span> <span class="fa fa-times clear-button" ng-click="$select.clear($event);"></span></ui-select-match><ui-select-choices repeat="res in dropUsersSSH | filter:$select.search"><span data-ng-bind-html="(res.id + \' - \' + res.name) | highlight: $select.search"></span></ui-select-choices></ui-select></div><div errorlabel="ssc.ssc_user_2_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.trainer_user_id" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_TRAINER_USER\' | translate"></span> <span data-ng-if="required.ssc.trainer_user.required">*</span></div><div class="col-sm-7" errorlabel="ssc.trainer_user_id"><ui-select theme="selectize" ng-model="data.ssc.trainer_user" ng-disabled="!data.ssc.location_id && data.ssc.location_id !== 0" class="ssc-ui-select"><ui-select-match placeholder="Bitte Suchen Sie einen Trainer"><span class="selected-value" ng-bind="$select.selected.id + \' - \' + $select.selected.name"></span> <span class="fa fa-times clear-button" ng-click="$select.clear($event);"></span></ui-select-match><ui-select-choices repeat="res in dropUsersTrainer | filter:$select.search"><span data-ng-bind-html="(res.id + \' - \' + res.name) | highlight: $select.search"></span></ui-select-choices></ui-select></div><div errorlabel="ssc.trainer_user_id" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.first_visit_at" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_FIRST_VISIT\' | translate"></span> <span data-ng-if="required.ssc.first_visit_at.required">*</span></div><div class="col-sm-7" errorlabel="ssc.first_visit_at" dataobj="required"><input class="createinputter" id="firstvisit" ssc-datepicker="" data-ng-model="data.ssc.first_visit_at" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-end-id="secondvisit"></div><div errorlabel="ssc.first_visit_at" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row" ng-if="data.ssc.ssc_consultation_type_name !== \'consultation_hour\' && data.ssc.ssc_consultation_type_name !== \'telephone\'"><div errorlabel="ssc.second_visit_at" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_SECOND_VISIT\' | translate"></span> <span data-ng-if="required.ssc.second_visit_at.required">*</span></div><div class="col-sm-7" errorlabel="ssc.second_visit_at" dataobj="required"><input class="createinputter" id="secondvisit" ssc-datepicker="" data-ng-model="data.ssc.second_visit_at" datepicker-format="DATEPICKER_DAY" datepicker-model-format="API_DAY" datepicker-type="fromto" datepicker-start-id="firstvisit"></div><div errorlabel="ssc.second_visit_at" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="row"><div errorlabel="ssc.comment" dataobj="required" class="col-sm-4 ilabel"><span data-ng-bind="\'SSC_HH_COMMENT\' | translate"></span> <span data-ng-if="required.ssc.comment.required">*</span></div><div class="col-sm-7"><textarea errorlabel="ssc.comment" dataobj="required" class="createinputter" ng-model="data.ssc.comment"></textarea></div><div errorlabel="ssc.comment" dataobj="required" class="col-sm-1"><div class="exclamation"><i class="fa fa-exclamation" aria-hidden="true"></i></div></div></div><div class="margcreatebot"></div></div></div><div class="row"><div class="col-sm-3 col-sm-offset-9"><button data-ng-if="1" ng-click="save()" class="redbutton disableduringload" type="submit"><span data-ng-bind="\'SSC_SAVE\' | translate"></span></button></div></div></div></div></div>');}]);